import { Link, useLocation, useNavigate } from "react-router-dom";
import React, { useContext, useEffect, useRef, useState } from "react";
import axios from "axios";
import { useTranslation } from "react-i18next";
import { Accordion, AccordionContext, Card, useAccordionButton } from "react-bootstrap";
import OverlayContainer from "../Components/OverlayContainer";
import Modal from "react-bootstrap/Modal";
import Dropdown from "react-bootstrap/Dropdown";
import Button from "react-bootstrap/Button";
import Select from "react-dropdown-select";
import ReactImageMagnify from "@blacklab/react-image-magnify";
import * as qs from "qs";
import PopoverStickOnHover from "../Components/PopoverStickOnHover";
import CustomControl from "../Components/CustomControl";
import CustomDropdownWithSearch from "../Components/CustomDropdownWithSearch";
import NumberToPersianWord from "number_to_persian_word";
import UserProjects from "../Static Files/UserProjects.json";
import GetPrice from "../Functions/GetPrice";
import { useDispatch, useSelector } from "react-redux";
import { CartUpdatedTrue, ShowLogin2Modal } from "../Actions/types";
import authHeader from "../Services/auth-header";
import SaveUserProject from "../Functions/SaveUserProject";
import { refreshToken } from "../Services/auth.service";
import GetUserProjectData from "../Functions/GetUserProjectData";
import setGetDeps from "../Functions/setGetDeps";
import ModalLogin from "../Components/ModalLogin";
import AddProjectToCart from "../Functions/AddProjectToCart";
import GetMeasurementArray from "../Functions/GetMeasurementArray";
import GetSewingFilters from "../Functions/GetSewingFilters";
import Step5ATrackPleated from "../Components/Accordion/Step5ATrackPleated";
import Step6Pleated from "../Components/Accordion/Step6Pleated";
import Step7Pleated from "../Components/Accordion/Step7Pleated";
import Step5BTrackPleated from "../Components/Accordion/Step5BTrackPleated";
import Step5CTrackPleated from "../Components/Accordion/Step5CTrackPleated";
import Step5CTrackFloorPleated from "../Components/Accordion/Step5CTrackFloorPleated";
import Step5DTrackPleated from "../Components/Accordion/Step5DTrackPleated";
import Step4Pleated from "../Components/Accordion/Step4Pleated";
import Step3APleated from "../Components/Accordion/Step3APleated";
import Step2APleated from "../Components/Accordion/Step2APleated";
import Step8PleatedComponent from "../Components/Accordion/Step8PleatedComponent";
import Step11AccessoriesPleatedDraperyAndSheer from "../Components/Accordion/Step11AccessoriesPleatedDraperyAndSheer";
import Step9PleatedOne from "../Components/Accordion/Step9PleatedOne";
import Step9AcomponentPleated from "../Components/Accordion/Step9AcomponentPleated";
import Step9BcomponentPleated from "../Components/Accordion/Step9BcomponentPleated";
import Step12componentPleated from "../Components/Accordion/Step12componentPleated";
import StepRoomLablePleated from "../Components/Accordion/StepRoomLablePleated";
import Step9CcomponentPleated from "../Components/Accordion/Step9CcomponentPleated";
import {
  Capitalize,
  CapitalizeAllWords,
  convertToPersian,
  NumToFa,
  Uppercase,
  capitalizeWordsText,
} from "../Functions/TextTransform";
import { DebounceInput } from "react-debounce-input";
import { createGetCart, createGetHasZipcode } from "../Functions/FunctionsGrommet/cartAndZipcode";
import { rooms, motorChannels } from "../Static Files/Static_Labels";
import ShowMoreLineLimited from "../Components/ShowMoreLineLimited";
import RenderSideCart from "../Components/RenderSideCart";
import { useMediaQuery } from "react-responsive";
import AddSwatch from "../Functions/AddSwatch";
import { findFabricPhotoById } from "../Functions/GrommetUtils";
import ElectricHandModalGrommet from "../Components/Modal/ElectricHandModalGrommet";
import CompleteStep4Grommet from "../Components/Modal/CompleteStep4Grommet";
import FabricSelectionModalGrommet from "../Components/Modal/FabricSelectionModalGrommet";
import HelpMeasureModalPleated from "../Components/Modal/HelpMeasureModalPleated";
import SelectMountGrommetStep4 from "../Components/Modal/SelectMountGrommetStep4";

import {
  baseURLModel,
  baseURLFabrics,
  baseURLGetRail,
  baseURLPrice,
  baseURLZipCode,
  baseURLFreeShipping,
  baseURGetProject,
  baseURLGetCart,
  baseURLUploadImg,
  baseURLUploadPdf,
  baseURLDeleteFile,
  baseURLDeleteBasketProject,
} from "../Services/client";
import { imgUrl } from "../config/api";
import MultipleFileUpload from "../Components/MultipleFileUpload";
import UploadedFilesList from "../Components/UploadedFilesList";

function PleatedOne({
  CatID,
  ModelID,
  PageType,
  ProjectId,
  EditIndex,
  PageItem,
  QueryString,
  Parameters,
  PageId,
}) {
  const { t, i18n } = useTranslation();
  const location = useLocation();
  const [pageLanguage, setPageLanguage] = useState(
    location.pathname
      .split("")
      .slice(1, 3)
      .join("")
  );
  const isTabletOrMobile = useMediaQuery({ query: "(max-width: 923px)" });
  const firstRender = useRef(true);
  const modalTopRef = useRef(null);
  const fabricsContainerRef = useRef(null);
  const fabricsContainerRef2 = useRef(null);
  const fabricsContainerRef3 = useRef(null);
  const fabricsContainerRef4 = useRef(null);
  const [catID, setCatID] = useState(CatID);
  const [modelID, setModelID] = useState(ModelID);
  const [pageType, setPageType] = useState(PageType);
  const [projectId, setProjectId] = useState(ProjectId);
  const [editIndex, setEditIndex] = useState(EditIndex);
  const [pageItem, setPageItem] = useState(PageItem);
  const [queryString, setQueryString] = useState(QueryString);
  const [parameters, setParameters] = useState(Parameters);
  const [pageId, setPageId] = useState(PageId);
  const { isLoggedIn, cartUpdated, mainCart, sideCartPrice } = useSelector((state) => state.auth);
  let navigate = useNavigate();
  const dispatch = useDispatch();
  const multipleFileUploadRef = useRef();
  const [uploadingFiles, setUploadingFiles] = useState([]);
  const [uploadedImages, setUploadedImages] = useState([]);
  const [uploadedPDFs, setUploadedPDFs] = useState([]);
  const formatFileSize = (bytes) => {
    if (!bytes && bytes !== 0) return "";
    const mb = bytes / (1024 * 1024);
    if (mb >= 1) return `${mb.toFixed(2)} MB`;
    return `${(bytes / 1024).toFixed(2)} KB`;
  };
  const [shouldScroll, setShouldScroll] = useState(false);
  const [nameEnDraperyTrack, setNameEnDraperyTrack] = useState(null);
  const [nameFaDraperyTrack, setNameFaDraperyTrack] = useState(null);
  const [nameColorEnDraperyTrack, setNameColorEnDraperyTrack] = useState(null);
  const [nameColorFaDraperyTrack, setNameColorFaDraperyTrack] = useState(null);
  const [nameColorEnDraperyTrack9a, setNameColorEnDraperyTrack9a] = useState(null);
  const [nameColorFaDraperyTrack9a, setNameColorFaDraperyTrack9a] = useState(null);
  const [nameBattonEnDraperyTrack, setNameBattonEnDraperyTrack] = useState(null);
  const [nameBattonEnDraperyTrack9a, setNameBattonEnDraperyTrack9a] = useState(null);
  const [pageLoad, setPageLoad] = useState(undefined);
  const [boardLoad, setBoardLoad] = useState(undefined);
  const [rodsLoad, setRodsLoad] = useState(undefined);
  const [rodsLoad2, setRodsLoad2] = useState(undefined);
  const [motorLoad, setMotorLoad] = useState(false);
  const [mesLoad, setMesLoad] = useState(false);
  const [projectData, setProjectData] = useState({});
  const [model, setModel] = useState({});
  const [modelAccessories, setModelAccessories] = useState({});
  const [stepAccessories, setStepAccessories] = useState({});
  const [stepAccessoriesList, setStepAccessoriesList] = useState([]);
  const [trimAccessories, setTrimAccessories] = useState({});
  const [fabrics, setFabrics] = useState({});
  const [fabrics2, setFabrics2] = useState({});
  const [fabricsList, setFabricsList] = useState([]);
  const [fabricsList2, setFabricsList2] = useState([]);
  const [fabricsList22, setFabricsList22] = useState([]);
  const [sheers, setSheers] = useState({});
  const [sheers2, setSheers2] = useState({});
  const [sheersModelId, setSheersModelId] = useState("");
  const [sheersModelId2, setSheersModelId2] = useState("");
  const [rails, setRails] = useState([]);
  const [rails2, setRails2] = useState([]);
  const [rails3, setRails3] = useState([]);
  const [rods, setRods] = useState({});
  const [tracks, setTracks] = useState({});
  const [rods2, setRods2] = useState({});
  const [tracks2, setTracks2] = useState({});
  const [rods3, setRods3] = useState({});
  const [tracks3, setTracks3] = useState({});
  const [rodsList, setRodsList] = useState([]);
  const [rodsList2, setRodsList2] = useState([]);
  const [rodsList3, setRodsList3] = useState([]);
  const [rodsList4, setRodsList4] = useState([]);
  const [tracksList, setTracksList] = useState([]);
  const [tracksList2, setTracksList2] = useState([]);
  const [tracksList3, setTracksList3] = useState([]);
  const [tracksList4, setTracksList4] = useState([]);
  const [rodsColorList, setRodsColorList] = useState([]);
  const [rodsColorList2, setRodsColorList2] = useState([]);
  const [rodsColorList3, setRodsColorList3] = useState([]);
  const [rodsColorList4, setRodsColorList4] = useState([]);
  const [rodsColorList5, setRodsColorList5] = useState([]);
  const [rodsColorList6, setRodsColorList6] = useState([]);
  const [step6CHead9, setStep6CHead9] = useState("Rod");
  const [sheersList, setSheersList] = useState([]);
  const [sheersList2, setSheersList2] = useState([]);
  const [defaultFabricPhoto, setDefaultFabricPhoto] = useState(null);
  const [defaultModelName, setDefaultModelName] = useState("");
  const [defaultModelNameFa, setDefaultModelNameFa] = useState("");
  const [defaultModelDesc, setDefaultModelDesc] = useState("");
  const [defaultModelDescFa, setDefaultModelDescFa] = useState("");
  const [price, setPrice] = useState(0);
  const [priceBtn, setPriceBtn] = useState(null);
  const [liningPrice, setLiningPrice] = useState(undefined);
  const [handCurtainPricDrapery, setHandCurtainPricDrapery] = useState(undefined);
  const [handCurtainPricSheer, setHandCurtainPricSheer] = useState(undefined);
  const [freeShipPrice, setFreeShipPrice] = useState(0);
  const [show, setShow] = useState(false);
  const [searchText, setSearchText] = useState("");
  const [searchShow, setSearchShow] = useState(false);
  const [searchText2, setSearchText2] = useState("");
  const [searchShow2, setSearchShow2] = useState(false);
  const [measurementsNextStep, setMeasurementsNextStep] = useState("4");
  const [hardwareNextStep, setHardwareNextStep] = useState("9");
  const [projectModalState, setProjectModalState] = useState(0);
  const [zoomModalHeader, setZoomModalHeader] = useState([]);
  const [zoomModalBody, setZoomModalBody] = useState([]);
  const [swatchId, setSwatchId] = useState(0);
  const [swatchDetailId, setSwatchDetailId] = useState(0);
  const [swatchPhotoPath, setSwatchPhotoPath] = useState("");
  const [hasSwatchId, setHasSwatchId] = useState(false);
  const [addCartErr, setAddCartErr] = useState([]);
  const [sideCartObjects, setSideCartObjects] = useState({});
  const [sideCartProductTotal, setSideCartProductTotal] = useState(0);
  const [sideCartInstallPrice, setSideCartInstallPrice] = useState(0);
  const [sideCartTransportPrice, setSideCartTransportPrice] = useState(0);
  const [sideCartHasSwatches, setSideCartHasSwatches] = useState(false);
  const [cartAgree, setCartAgree] = useState([]);
  const [cartChanged, setCartChanged] = useState(0);
  const [bagUpdate, setBagUpdate] = useState(false);
  const [bag, setBag] = useState({});
  const [remoteNames, setRemoteNames] = useState([]);
  const [showRemoteName, setShowRemoteName] = useState(false);
  const [accordionActiveKey, setAccordionActiveKey] = useState("");
  const accordionActiveKeyRef = useRef(accordionActiveKey);
  const [accordionActiveKey2, setAccordionActiveKey2] = useState("");
  const [roomLabelText, setRoomLabelText] = useState("");
  const [selectedColor, setSelectedColor] = useState(null);
  const [fabricSelected, setFabricSelected] = useState({
    selectedFabricId: 0,
    selectedTextEn: "",
    selectedTextFa: "",
    selectedDesignCode: "",
    selectedColorEn: "",
    selectedColorFa: "",
    selectedHasTrim: false,
    selectedPhoto: "",
    selectedPhoto2: "",
    FabricWidth: 0,
    SewingDirection: undefined,
  });
  const [fabricSelected2, setFabricSelected2] = useState({
    selectedFabricId: 0,
    selectedTextEn: "",
    selectedTextFa: "",
    selectedDesignCode: "",
    selectedColorEn: "",
    selectedColorFa: "",
    selectedLeadRequired: false,
    selectedPhoto: "",
    selectedPhoto2: "",
    FabricWidth: 0,
    SewingDirection: undefined,
  });
  const [borderSelected, setBorderSelected] = useState({
    selectedFabricId: 0,
    selectedTextEn: "",
    selectedTextFa: "",
    selectedDesignCode: "",
    selectedColorEn: "",
    selectedColorFa: "",
    selectedHasTrim: false,
    selectedPhoto: "",
    selectedPhoto2: "",
  });
  const [trimSelected, setTrimSelected] = useState({
    selectedFabricId: 0,
    selectedTextEn: "",
    selectedTextFa: "",
    selectedDesignCode: "",
    selectedColorEn: "",
    selectedColorFa: "",
    selectedHasTrim: false,
    selectedPhoto: "",
    selectedPhoto2: "",
  });
  const [borderSelected2, setBorderSelected2] = useState({
    selectedFabricId: 0,
    selectedTextEn: "",
    selectedTextFa: "",
    selectedDesignCode: "",
    selectedColorEn: "",
    selectedColorFa: "",
    selectedHasTrim: false,
    selectedPhoto: "",
    selectedPhoto2: "",
  });
  const [trimSelected2, setTrimSelected2] = useState({
    selectedFabricId: 0,
    selectedTextEn: "",
    selectedTextFa: "",
    selectedDesignCode: "",
    selectedColorEn: "",
    selectedColorFa: "",
    selectedHasTrim: false,
    selectedPhoto: "",
    selectedPhoto2: "",
  });
  const [sheersSelected, setSheersSelected] = useState({
    selectedFabricId: 0,
    selectedTextEn: "",
    selectedTextFa: "",
    selectedColorEn: "",
    selectedColorFa: "",
    selectedHasTrim: false,
    selectedPhoto: "",
    selectedPhoto2: "",
  });
  const [sheersSelected2, setSheersSelected2] = useState({
    selectedFabricId: 0,
    selectedTextEn: "",
    selectedTextFa: "",
    selectedColorEn: "",
    selectedColorFa: "",
    selectedHasTrim: false,
    selectedPhoto: "",
    selectedPhoto2: "",
  });
  const [roomLabelSelect, setRoomLabelSelect] = useState({
    label: "",
    value: "",
  });
  const [sheerHeaderStyleTemp, setSheerHeaderStyleTemp] = useState({
    stepValue: "",
    id: "",
    cartValue: "",
    event: "",
  });
  const [sheerHeaderStyleTemp2, setSheerHeaderStyleTemp2] = useState({
    stepValue: "",
    id: "",
    cartValue: "",
    event: "",
  });
  const [mountTypeTemp, setMountTypeTemp] = useState({
    stepValue: "",
    id: "",
    cartValue: "",
    event: "",
  });
  const [curtainPosTemp, setCurtainPosTemp] = useState({
    stepValue: "",
    id: "",
    cartValue: "",
    event: "",
  });
  const [finishedLengthTemp, setFinishedLengthTemp] = useState({
    stepValue: "",
    id: "",
    cartValue: "",
    event: "",
  });
  const [hardwareSheerWarningTemp, setHardwareSheerWarningTemp] = useState({
    stepValue: "",
    id: "",
    cartValue: "",
    event: "",
  });
  const [hardwarePLWarningTemp, setHardwarePLWarningTemp] = useState({
    stepValue: "",
    id: "",
    cartValue: "",
    event: "",
  });
  const [panelSheerWarningTemp, setPanelSheerWarningTemp] = useState({
    stepValue: "",
    id: "",
    cartValue: "",
    event: "",
  });
  const [panelPLWarningTemp, setPanelPLWarningTemp] = useState({
    stepValue: "",
    id: "",
    cartValue: "",
    event: "",
  });
  const [stepSelectedValue, setStepSelectedValue] = useState({});
  const [showLabels, setShowLabels] = useState(true);
  const [headerTruncated, setHeaderTruncated] = useState([]);
  const [extendedTitle, setExtendedTitle] = useState({
    1: [],
    2: [],
    6: [],
    8: [],
    "8A": [],
    "8B": [],
    "8C": [],
    9: [],
  });
  const [detailsShow, setDetailsShow] = useState(false);
  const [filtersShow, setFiltersShow] = useState(false);
  const [filtersShow2, setFiltersShow2] = useState(false);
  const [windowSize, setWindowSize] = useState("");
  const [windowSizeBool, setWindowSizeBool] = useState(false);
  const [stepSelectedLabel, setStepSelectedLabel] = useState({});
  const [modals, setModals] = useState({});
  const [showModals, setShowModals] = useState("");
  const [hideModals, setHideModals] = useState("");
  const [popoverImages, setPopoverImages] = useState([]);
  const [inputDifRef, setInputDifRef] = useState(undefined);
  const [inputDifdep, setInputDifdep] = useState("");
  const [leftRight, setLeftRight] = useState({
    left: "",
    right: "",
  });
  const [showEmptyMessage, setShowEmptyMessage] = useState(false);
  const [showEmptyMessage2, setShowEmptyMessage2] = useState(false);
  const timeoutRef = useRef(null);
  const [stepSelectedOptions, setStepSelectedOptions] = useState({
    values: {},
    labels: {},
  });
  const [selectCustomValues, setSelectCustomValues] = useState({
    width1: [],
    width2: [],
    width3: [],
    height1: [],
    height2: [],
    left: [],
    right: [],
    width: [],
    length: [],
    Depth: [],
    MouldingHeight: [],
    width3A: [],
    height3C: [],
    shadeMount: [],
    RodWidth: [],
    RodToBottom: [],
  });
  const [width, setWidth] = useState(undefined);
  const [height, setHeight] = useState(undefined);
  const [depth, setDepth] = useState(undefined);
  const [mouldingHeight, setMouldingHeight] = useState(undefined);
  const [rodToBottom, setRodToBottom] = useState(undefined);
  const [rodToFloor, setRodToFloor] = useState(undefined);
  const [windowToFloor, setWindowToFloor] = useState(undefined);
  const [ceilingToWindow1, setCeilingToWindow1] = useState(undefined);
  const [ceilingToWindow2, setCeilingToWindow2] = useState(undefined);
  const [ceilingToWindow3, setCeilingToWindow3] = useState(undefined);
  const [ceilingToFloor, setCeilingToFloor] = useState(undefined);
  const [ceilingToFloor1, setCeilingToFloor1] = useState(undefined);
  const [ceilingToFloor2, setCeilingToFloor2] = useState(undefined);
  const [ceilingToFloor3, setCeilingToFloor3] = useState(undefined);
  const [width3C, setWidth3C] = useState(undefined);
  const [rodWidth, setRodWidth] = useState(undefined);
  const [left, setLeft] = useState(undefined);
  const [right, setRight] = useState(undefined);
  const [height3E, setHeight3E] = useState(undefined);
  const [mount, setMount] = useState(undefined);
  const [hardwareDraperyStep9, setHardwareDraperyStep9] = useState(null);
  const [hardwareSheerStep9, setHardwareSheerStep9] = useState(null);
  const [hardwareLayerStep9, setHardwareLayerStep9] = useState(null);
  const [anyMeasurements, setAnyMeasurements] = useState(false);
  const [widthCart, setWidthCart] = useState(undefined);
  const [heightCart, setHeightCart] = useState(undefined);
  const [heightCart2, setHeightCart2] = useState(undefined);
  const [fabricError, setFabricError] = useState(false);
  const [errorData, setErrorData] = useState({});
  const [fabricsBoard, setFabricsBoard] = useState([]);
  const [fabricBoard, setFabricBoard] = useState(undefined);
  const [sheerBoard, setSheerBoard] = useState(undefined);
  const [fabricIsBoard, setFabricIsBoard] = useState(false);
  const [sheerIsBoard, setSheerIsBoard] = useState(false);
  const [windowWidthPanelType, setWindowWidthPanelType] = useState(null);
  const [requiredStep, setRequiredStep] = useState({});
  const [cartValues, setCartValues] = useState({});
  const [cartStateAgree, setCartStateAgree] = useState(false);
  const [cartAgreeDescription, setCartAgreeDescription] = useState(false);
  const [cartCount, setCartCount] = useState(0);
  const [cartProjectIndex, setCartProjectIndex] = useState(-1);
  const [saveProjectCount, setSaveProjectCount] = useState(0);

  const [depSet, setDepSet] = useState(
    new Set(["1", "2", "2A", "2B", "2C", "3A0", "3", "4", "5", "6", "8", "1001", "1002"])
  );

  const inputs = useRef({});
  // Skip Step9 hardware-type cart wipe while restoring Track after refresh
  const skipHardwareTypeCartWipeRef = useRef(false);
  const measureClearEpochRef = useRef(0);
  const restoredZipcodeRef = useRef("");
  const restoredTrackControlRef = useRef("");
  const restoredTrackMotorRef = useRef(null);
  const restoredStep9ATrackRef = useRef(null);
  const restoredStep9BTrackRef = useRef(null);
  const restoredStep9CTrackRef = useRef(null);
  const selectedTitle = useRef({});
  const search_input = useRef(null);
  const search_input2 = useRef(null);
  const accordion = useRef(null);
  const accordion2 = useRef(null);
  const [showMoreFilterTrigger, setShowMoreFilterTrigger] = useState(undefined);
  const filterCheckboxes = useRef({
    colors: [],
    patterns: [],
    types: [],
    prices: [],
    colors2: [],
    patterns2: [],
    types2: [],
    prices2: [],
    colorsSheer: [],
    patternsSheer: [],
    typesSheer: [],
    pricesSheer: [],
  });
  const steps = useRef({});
  const stepHeaders = useRef({});
  const pendingScrollToMeasurementsRef = useRef(false);
  useEffect(() => {
    accordionActiveKeyRef.current = accordionActiveKey;
    // After opening lining from measurements, scroll once layout has committed
    if (accordionActiveKey === "4" && pendingScrollToMeasurementsRef.current) {
      pendingScrollToMeasurementsRef.current = false;
      setTimeout(() => {
        const header = stepHeaders.current["3"];
        if (header) {
          header.scrollIntoView({ behavior: "smooth", block: "start" });
        }
      }, 800);
    }
  }, [accordionActiveKey]);
  const depDetails = useRef({
    1: {},
    2: {},
    "2B": {},
    "2C": {},
    "3A0": {},
    3: {},
    4: {},
    5: {},
    6: {},
    7: {},
    8: {},
    9: {},
    10: {},
  });

  const [filterChanged, setFilterChanged] = useState({
    filter: 0,
    filter_id: undefined,
    isDelete: false,
    step: "1",
  });
  const [filterColors, setFilterColors] = useState([...queryString["colors"]]);
  const [filterPatterns, setFilterPatterns] = useState([...queryString["patterns"]]);
  const [filterTypes, setFilterTypes] = useState([...queryString["types"]]);
  const [filterPrices, setFilterPrices] = useState([...queryString["prices"]]);
  const [filterColors2, setFilterColors2] = useState([]);
  const [filterPatterns2, setFilterPatterns2] = useState([]);
  const [filterTypes2, setFilterTypes2] = useState([]);
  const [filterPrices2, setFilterPrices2] = useState([]);
  const [filterDesigns, setFilterDesigns] = useState([...queryString["designs"]]);

  const [isClearAll, setIsClearAll] = useState(false);

  const [step1, setStep1] = useState("");
  const [step1Check, setStep1Check] = useState("");
  const [step1Border, setStep1Border] = useState("");
  const [step1BorderRadio, setStep1BorderRadio] = useState("");
  const [step1Trim, setStep1Trim] = useState("");
  const [step2Check, setStep2Check] = useState("");
  const [step2Check2, setStep2Check2] = useState("");
  const [step2Border, setStep2Border] = useState("");
  const [step2BorderRadio, setStep2BorderRadio] = useState("");
  const [step2Trim, setStep2Trim] = useState("");
  const [step2, setStep2] = useState("");
  const [step2A, setStep2A] = useState("");
  const [step2B, setStep2B] = useState("");
  const [step2B1, setStep2B1] = useState("");
  const [step2C, setStep2C] = useState("");
  const [step3, setStep3] = useState("");
  const [step31, setStep31] = useState("");
  const [step3A0, setStep3A0] = useState("");
  const [step3A, setStep3A] = useState("Standard");
  const [step3B, setStep3B] = useState("Floor");
  const [step3ARod, setStep3ARod] = useState("Floor");
  const [step3ATrack, setStep3ATrack] = useState("Floor");
  const [step3ARod1, setStep3ARod1] = useState("true");
  const [step4, setStep4] = useState("");
  const [step5, setStep5] = useState("");
  const [step6, setStep6] = useState("Customize Style Per Curtain");
  const [step61, setStep61] = useState("");
  const [step6A, setStep6A] = useState("");
  const [step6B, setStep6B] = useState("");
  const [step6C, setStep6C] = useState("");
  const [step6BHead, setStep6BHead] = useState("Rod");
  const [step6CHead, setStep6CHead] = useState("Rod");
  const [step6DHead, setStep6DHead] = useState("Rod");
  const [step7, setStep7] = useState("");
  const [remove9A, setRemove9A] = useState(false);
  const [step8, setStep8] = useState("");
  const [step81, setStep81] = useState("");
  const [step8RodCheck, setStep8RodCheck] = useState("");
  const [step82, setStep82] = useState("");
  const [step83, setStep83] = useState("");
  const [step9ADrapery, setStep9ADrapery] = useState("");
  const [step8A1, setStep8A1] = useState("");
  const [step8A2, setStep8A2] = useState("");
  const [stepHardware9A, setStepHardware9A] = useState("");
  const [stepHardwareName9A, setStepHardwareName9A] = useState("");
  const [step8A3, setStep8A3] = useState("");
  const [step8A4, setStep8A4] = useState("");
  const [step8B, setStep8B] = useState("");
  const [step8B1, setStep8B1] = useState("");
  const [step8BRilType, setStep8BRilType] = useState("");
  const [stepTrackCollections9A, setStepTrackCollections9A] = useState("");
  const [stepTCollections9A, setStepTCollections9A] = useState("");
  const [stepTrackCollectionsName9A, setStepTrackCollectionsName9A] = useState("");
  const [step8D1, setStep8D1] = useState("");
  const [step8DTrack, setStep8DTrack] = useState("");
  const [step8D2, setStep8D2] = useState("");
  const [step8B2, setStep8B2] = useState("");
  const [step8B3, setStep8B3] = useState("");
  const [step9APosition, setStep9APosition] = useState("");
  const [stepControl9A, setStepControl9A] = useState("");
  const [step8B4, setStep8B4] = useState("");
  const [step8B5, setStep8B5] = useState("");
  const [step8B6, setStep8B6] = useState("");
  const [step8C, setStep8C] = useState("");
  const [step8C1, setStep8C1] = useState("");
  const [step8CTrack, setStep8CTrack] = useState("");
  const [step8C2, setStep8C2] = useState("");
  const [step8C3, setStep8C3] = useState("");
  const [step8C5, setStep8C5] = useState("");
  const [zipcodeChecked, setZipcodeChecked] = useState("");
  const [zipcode, setZipcode] = useState("");
  const [zipcodeButton, setZipcodeButton] = useState(false);
  const [hasZipcode, setHasZipcode] = useState("");
  const [hasInstall, setHasInstall] = useState(null);
  const [installPrice, setInstallPrice] = useState(-1);
  const [transportPrice, setTransportPrice] = useState(-1);
  const [remoteNameA, setRemoteNameA] = useState("");
  const [remoteNameB, setRemoteNameB] = useState("");
  const [remoteNameC, setRemoteNameC] = useState("");
  const [moreInfoInput, setMoreInfoInput] = useState("");
  const [selectedRoomLabel, setSelectedRoomLabel] = useState([]);
  const [trackType8B, setTrackType8B] = useState(undefined);
  const [trackType8C, setTrackType8C] = useState(undefined);

  const [motorErr1, setMotorErr1] = useState(false);
  const [step3BErr1, setStep3BErr1] = useState(false);
  const [step3ARodErr1, setStep3ARodErr1] = useState(false);
  const [mountErr1, setMountErr1] = useState(false);
  const [mountErr2, setMountErr2] = useState(false);
  const [depthHelp, setDepthHelp] = useState("Triple Layer");
  const [selectedFile, setSelectedFile] = useState();
  const [selectedFileName, setSelectedFileName] = useState("");
  const [editedFileName, setEditedFileName] = useState("");
  const [uploadedImagesList, setUploadedImagesList] = useState([]);
  const [uploadedImagesNamesList, setUploadedImagesNamesList] = useState([]);
  const [uploadedPDFNameList, setUploadedPDFNameList] = useState([]);
  const [uploadedImagesFile, setUploadedImagesFile] = useState([]);
  const [uploadedPDFFile, setUploadedPDFFile] = useState([]);
  const [uploadedImagesURL, setUploadedImagesURL] = useState([]);
  const [uploadedPDFURL, setUploadedPDFURL] = useState([]);
  const [initFilterColors, setInitFilterColors] = useState({});
  const [initFilterPatterns, setInitFilterPatterns] = useState({});
  const [initFilterTypes, setInitFilterTypes] = useState({});
  const [initFilterPrices, setInitFilterPrices] = useState({});
  const [sewingColors, setSewingColors] = useState([]);
  const [sewingPatterns, setSewingPatterns] = useState([]);
  const [sewingTypes, setSewingTypes] = useState([]);
  const [sewingPrices, setSewingPrices] = useState([]);
  const [sewingColors2, setSewingColors2] = useState([]);
  const [sewingPatterns2, setSewingPatterns2] = useState([]);
  const [sewingTypes2, setSewingTypes2] = useState([]);
  const [sewingPrices2, setSewingPrices2] = useState([]);
  const [sewingColorsSheer, setSewingColorsSheer] = useState([]);
  const [sewingPatternsSheer, setSewingPatternsSheer] = useState([]);
  const [sewingTypesSheer, setSewingTypesSheer] = useState([]);
  const [sewingPricesSheer, setSewingPricesSheer] = useState([]);
  const [loading2, setLoading2] = useState(false);
  const [showMoreFilter, setShowMoreFilter] = useState({
    colors: false,
    patterns: false,
    types: false,
    prices: false,
  });
  const [deleteUploadImageUrl, setDeleteUploadImageUrl] = useState("");
  const [deleteUploadPdfUrl, setDeleteUploadPdfUrl] = useState("");
  const [deleteUploadImageIndex, setDeleteUploadImageIndex] = useState(-1);
  const [deleteUploadPdfIndex, setDeleteUploadPdfIndex] = useState(-1);
  const [addingLoading, setAddingLoading] = useState(false);
  const [backPage, setBackPage] = useState(false);
  const [cartLoading, setCartLoading] = useState(false);
  const [savingLoading, setSavingLoading] = useState(false);
  const [isUploading, setIsUploading] = useState(false);
  const [fabricLoading, setFabricLoading] = useState(false);
  const [swatchLogin, setSwatchLogin] = useState(false);
  const [loading, setLoading] = useState(false);
  const [swatchLoginSwatchId, setSwatchLoginSwatchId] = useState(null);
  const [swatchLoginSwatchDetailId, setSwatchLoginSwatchDetailId] = useState(null);
  const [helpMeasure, setHelpMeasure] = useState("hasRod");
  const [helpMeasureLengthType, setHelpMeasureLengthType] = useState("Floor");
  const [customAcc, setCustomAcc] = useState([]);
  const [customAccActive, setCustomAccActive] = useState({});
  const [selectedMotorChannelsA, setSelectedMotorChannelsA] = useState([
    motorChannels[pageLanguage].find((opt) => opt.value === "0"),
  ]);
  const [selectedMotorChannelsB, setSelectedMotorChannelsB] = useState([
    motorChannels[pageLanguage].find((opt) => opt.value === "0"),
  ]);
  const [selectedMotorChannelsC, setSelectedMotorChannelsC] = useState([
    motorChannels[pageLanguage].find((opt) => opt.value === "0"),
  ]);
  const [selectedMotorPositionA, setSelectedMotorPositionA] = useState([]);
  const [selectedMotorPositionB, setSelectedMotorPositionB] = useState([]);
  const [selectedMotorPositionC, setSelectedMotorPositionC] = useState([]);
  const [selectedRemoteNameA, setSelectedRemoteNameA] = useState([]);
  const [selectedRemoteName, setSelectedRemoteName] = useState([]);
  const [selectedDrapery, setSelectedDrapery] = useState([]);
  const [selectedSheer, setSelectedSheer] = useState([]);
  const [selectedPrivacyLayer, setSelectedPrivacyLayer] = useState([]);
  const [nameStep, setNameStep] = useState("5A");
  const [accessoriesDesign, setAccessoriesDesign] = useState({
    isPlus: undefined,
    SewingAccessoryValue: "",
    SewingAccessoryId: undefined,
    SewingModelAccessoryId: undefined,
    DesignCode: undefined,
    DesignNameEn: undefined,
    DesignNameFa: undefined,
    ColorNameEn: undefined,
    ColorNameFa: undefined,
    qty: undefined,
  });
  const [tiebackDrapery, setTiebackDrapery] = useState({
    isPlus: undefined,
    HandCurtainId: undefined,
    HandCurtainNum: 0,
  });
  const [tiebackDraperyQty, setTiebackDraperyQty] = useState(0);
  const [tiebackSheer, setTiebackSheer] = useState({
    isPlus: undefined,
    HandCurtainId: undefined,
    HandCurtainNum: 0,
  });
  const [tiebackSheerQty, setTiebackSheerQty] = useState(0);
  const getFabrics = () => {
    let paramObj = {
      modelId: modelID,
    };
    let promise5 = new Promise((resolve, reject) => {
      if (filterDesigns.length > 0) {
        paramObj["designs"] = [];
        filterDesigns?.forEach((filter_id, index) => {
          paramObj["designs"] = [...paramObj["designs"], filter_id];
          if (index === filterDesigns.length - 1) {
            resolve();
          }
        });
      } else {
        resolve();
      }
    });

    let promise6 = new Promise((resolve, reject) => {
      if (heightCart2) {
        paramObj["windowheight"] = [heightCart2];
        resolve();
      } else {
        resolve();
      }
    });

    Promise.all([promise5, promise6]).then(() => {
      setLoading(true);
      axios
        .get(baseURLFabrics, {
          params: paramObj,
          paramsSerializer: (params) => {
            return qs.stringify(params, { arrayFormat: "repeat" });
          },
        })
        .then((response) => {
          getSheersFabrics("10010301,10010302");
          let tempFabrics = {};
          let tempFabrics2 = {};
          response.data.forEach((obj) => {
            obj["ShowMore"] = false;
            if (
              obj["FabricGroupId"] === "10010301" ||
              obj["FabricGroupId"] === "10010302" ||
              obj["FabricGroupId"] === "100101"
            ) {
              if (
                tempFabrics[obj["DesignEnName"]] === "" ||
                tempFabrics[obj["DesignEnName"]] === undefined ||
                tempFabrics[obj["DesignEnName"]] === null ||
                tempFabrics[obj["DesignEnName"]] === []
              )
                tempFabrics[obj["DesignEnName"]] = [];
              tempFabrics[obj["DesignEnName"]].push(obj);
            } else if (obj["FabricGroupId"] === "100102") {
              if (
                tempFabrics2[obj["DesignEnName"]] === "" ||
                tempFabrics2[obj["DesignEnName"]] === undefined ||
                tempFabrics2[obj["DesignEnName"]] === null ||
                tempFabrics2[obj["DesignEnName"]] === []
              )
                tempFabrics2[obj["DesignEnName"]] = [];
              tempFabrics2[obj["DesignEnName"]].push(obj);
            }
          });
          if (Object.keys(tempFabrics).length) {
            setFabrics(tempFabrics);
          } else {
            let pageLanguage1 = pageLanguage;
            // setFabrics(tempFabrics);
            setFabricsList([
              <div
                className={`material_detail ${pageLanguage1 === "fa" ? "font_farsi" : "font_en"}`}
                key={"fabric" + "empty"}
              >
                <div
                  className={`material_traits ${pageLanguage1 === "fa" ? "font_farsi" : "font_en"}`}
                >
                  <h5 className="empty_fabrics">
                    {pageLanguage1 === "en"
                      ? "Sorry, no matching fabrics.\nTo view more results, try clearing your filters."
                      : "متاسفانه این محصول را موجود نداریم.\nبرای دیدن نتایج بهتر، فیلترها را تغییر دهید."}
                  </h5>
                  <button
                    className="empty_fabrics_btn white_btn btn"
                    onClick={() => {
                      setFabricsList([
                        <div
                          className={`material_detail ${
                            pageLanguage1 === "fa" ? "font_farsi" : "font_en"
                          }`}
                          key={"fabric" + "empty"}
                        >
                          <div
                            className={`material_traits ${
                              pageLanguage1 === "fa" ? "font_farsi" : "font_en"
                            }`}
                          >
                            <h5 className="empty_fabrics">
                              {pageLanguage1 === "en"
                                ? "Sorry, no matching fabrics.\nTo view more results, try clearing your filters."
                                : "متاسفانه این محصول را موجود نداریم.\nبرای دیدن نتایج بهتر، فیلترها را تغییر دهید."}
                            </h5>
                            <button className="empty_fabrics_btn white_btn btn">
                              {pageLanguage1 === "fa" ? "در حال پاک کردن" : "CLEARING"}
                            </button>
                          </div>
                        </div>,
                      ]);
                      setTimeout(() => {
                        setIsClearAll(true);
                      }, 300);
                    }}
                  >
                    {pageLanguage1 === "fa" ? "همه فیلترها را پاک کنید" : "CLEAR ALL FILTERS"}
                  </button>
                </div>
              </div>,
            ]);
          }
          setFabrics(tempFabrics);
          setFabrics2(tempFabrics2);
          setTimeout(() => {
            setIsClearAll(false);
          }, 1000);
        })
        .catch((err) => {
          console.log(err);
          setTimeout(() => {
            setIsClearAll(false);
          }, 1000);
        })
        .finally(() => {
          setLoading(false);
        });
    });
  };
  function getSheersFabrics(groupId) {
    let paramObj = {
      modelId: modelID,
    };
    setLoading(true);
    axios
      .get(baseURLFabrics, {
        params: paramObj,
        paramsSerializer: (params) => {
          return qs.stringify(params, { arrayFormat: "repeat" });
        },
      })
      .then((response) => {
        let tempFabrics = {};
        let tempFabrics2 = {};
        response.data.forEach((obj) => {
          obj["ShowMore"] = false;
          if (obj["FabricGroupId"] === "10010301") {
            if (
              tempFabrics[obj["DesignEnName"]] === "" ||
              tempFabrics[obj["DesignEnName"]] === undefined ||
              tempFabrics[obj["DesignEnName"]] === null ||
              tempFabrics[obj["DesignEnName"]] === []
            )
              tempFabrics[obj["DesignEnName"]] = [];
            tempFabrics[obj["DesignEnName"]].push(obj);
          } else if (obj["FabricGroupId"] === "10010302") {
            if (
              tempFabrics2[obj["DesignEnName"]] === "" ||
              tempFabrics2[obj["DesignEnName"]] === undefined ||
              tempFabrics2[obj["DesignEnName"]] === null ||
              tempFabrics2[obj["DesignEnName"]] === []
            )
              tempFabrics2[obj["DesignEnName"]] = [];
            tempFabrics2[obj["DesignEnName"]].push(obj);
          }
        });
        setSheers(tempFabrics);
        setSheers2(tempFabrics2);
        setTimeout(() => {
          setIsClearAll(false);
        }, 1000);
      })
      .catch((err) => {
        console.log(err);
        setTimeout(() => {
          setIsClearAll(false);
        }, 1000);
      })
      .finally(() => {
        setLoading(false);
      });
  }

  function getRails(width) {
    let params = {};
    params["modelId"] = modelID;
    if (width) {
      params["width"] = width;
    }
    axios
      .get(baseURLGetRail, {
        params: params,
      })
      .then((response) => {
        let temp = {};
        let temp2 = {};
        let temp3 = {};
        response.data.forEach((obj) => {
          if (obj["RailCategoryId"] === 5303) {
            if (
              temp[obj["DesignCode"]] === "" ||
              temp[obj["DesignCode"]] === undefined ||
              temp[obj["DesignCode"]] === null ||
              temp[obj["DesignCode"]] === []
            )
              temp[obj["DesignCode"]] = [];
            temp[obj["DesignCode"]].push(obj);
          } else if (obj["RailCategoryId"] === 5301) {
            if (
              temp2[obj["DesignCode"]] === "" ||
              temp2[obj["DesignCode"]] === undefined ||
              temp2[obj["DesignCode"]] === null ||
              temp2[obj["DesignCode"]] === []
            )
              temp2[obj["DesignCode"]] = [];
            temp2[obj["DesignCode"]].push(obj);
          }
        });
        setRods(temp);
        setTracks(temp2);
        setRails(response.data || []);
      })
      .catch((err) => {
        console.log(err);
        setRails([]);
        if (rodsLoad) {
          setRodsLoad(false);
        }
      });
  }
  function getSheersRails(modelID, width, isPrivacy) {
    let params = {};
    params["modelId"] = modelID;
    if (width) {
      params["width"] = width;
    }
    axios
      .get(baseURLGetRail, {
        params: params,
      })
      .then((response) => {
        let temp = {};
        let temp2 = {};
        let temp3 = {};
        response.data.forEach((obj) => {
          if (obj["RailCategoryId"] === 5303) {
            if (
              temp[obj["DesignCode"]] === "" ||
              temp[obj["DesignCode"]] === undefined ||
              temp[obj["DesignCode"]] === null ||
              temp[obj["DesignCode"]] === []
            )
              temp[obj["DesignCode"]] = [];
            temp[obj["DesignCode"]].push(obj);
          } else if (obj["RailCategoryId"] === 5301) {
            if (
              temp2[obj["DesignCode"]] === "" ||
              temp2[obj["DesignCode"]] === undefined ||
              temp2[obj["DesignCode"]] === null ||
              temp2[obj["DesignCode"]] === []
            )
              temp2[obj["DesignCode"]] = [];
            temp2[obj["DesignCode"]].push(obj);
          }
        });

        if (isPrivacy) {
          setRods3(temp);
          setTracks3(temp2);
          setRails3(response.data || []);
        } else {
          setRods2(temp);
          setTracks2(temp2);
          setRails2(response.data || []);
        }
      })
      .catch((err) => {
        console.log(err);
        if (isPrivacy) {
          setRails3([]);
        } else {
          setRails2([]);
        }
        if (rodsLoad2) {
          setRodsLoad2(false);
        }
      });
  }
  function getFabricsWithFilter(clearAll, step = "1") {
    if (clearAll) {
      getFabrics();
    } else {
      const isStep2 = step === "2";
      const currentSearchText = isStep2 ? searchText2 : searchText;
      const currentFilterColors = isStep2 ? filterColors2 : filterColors;
      const currentFilterPatterns = isStep2 ? filterPatterns2 : filterPatterns;
      const currentFilterTypes = isStep2 ? filterTypes2 : filterTypes;
      const currentFilterPrices = isStep2 ? filterPrices2 : filterPrices;

      if (isStep2) {
        setShowEmptyMessage2(false);
        setLoading2(true);
      } else {
        setShowEmptyMessage(false);
        setLoading(true);
      }

      let paramObj = { modelId: modelID, searchString: currentSearchText };

      let promise1 = new Promise((resolve, reject) => {
        if (currentFilterColors.length > 0) {
          paramObj["colorIds"] = [];
          currentFilterColors.forEach((filter_id, index) => {
            paramObj["colorIds"] = [...paramObj["colorIds"], filter_id];
            if (index === currentFilterColors.length - 1) {
              resolve();
            }
          });
        } else {
          resolve();
        }
      });
      let promise2 = new Promise((resolve, reject) => {
        if (currentFilterPatterns.length > 0) {
          paramObj["patternTypeIds"] = [];
          currentFilterPatterns.forEach((filter_id, index) => {
            paramObj["patternTypeIds"] = [...paramObj["patternTypeIds"], filter_id];
            if (index === currentFilterPatterns.length - 1) {
              resolve();
            }
          });
        } else {
          resolve();
        }
      });
      let promise3 = new Promise((resolve, reject) => {
        if (currentFilterTypes.length > 0) {
          paramObj["typeIds"] = [];
          currentFilterTypes.forEach((filter_id, index) => {
            paramObj["typeIds"] = [...paramObj["typeIds"], filter_id];
            if (index === currentFilterTypes.length - 1) {
              resolve();
            }
          });
        } else {
          resolve();
        }
      });
      let promise4 = new Promise((resolve, reject) => {
        if (currentFilterPrices.length > 0) {
          paramObj["priceLevelIds"] = [];
          currentFilterPrices.forEach((filter_id, index) => {
            paramObj["priceLevelIds"] = [...paramObj["priceLevelIds"], filter_id];
            if (index === currentFilterPrices.length - 1) {
              resolve();
            }
          });
        } else {
          resolve();
        }
      });
      let promise5 = new Promise((resolve, reject) => {
        if (filterDesigns.length > 0) {
          paramObj["designs"] = [];
          filterDesigns.forEach((filter_id, index) => {
            paramObj["designs"] = [...paramObj["designs"], filter_id];
            if (index === filterDesigns.length - 1) {
              resolve();
            }
          });
        } else {
          resolve();
        }
      });

      let promise6 = new Promise((resolve, reject) => {
        if (heightCart2) {
          paramObj["windowheight"] = [heightCart2];
          resolve();
        } else {
          resolve();
        }
      });

      Promise.all([promise1, promise2, promise3, promise4, promise5, promise6]).then(() => {
        axios
          .get(baseURLFabrics, {
            params: paramObj,
            paramsSerializer: (params) => {
              return qs.stringify(params, { arrayFormat: "repeat" });
            },
          })
          .then((response) => {
            const data = Array.isArray(response.data) ? response.data : [];
            if (!isStep2) {
              getSheersFabrics("10010301,10010302");
            }

            let tempFabrics = {};
            let tempFabrics2 = {};
            data.forEach((obj) => {
              obj["ShowMore"] = false;
              if (
                obj["FabricGroupId"] === "10010301" ||
                obj["FabricGroupId"] === "10010302" ||
                obj["FabricGroupId"] === "100101"
              ) {
                if (
                  tempFabrics[obj["DesignEnName"]] === "" ||
                  tempFabrics[obj["DesignEnName"]] === undefined ||
                  tempFabrics[obj["DesignEnName"]] === null ||
                  tempFabrics[obj["DesignEnName"]] === []
                )
                  tempFabrics[obj["DesignEnName"]] = [];
                tempFabrics[obj["DesignEnName"]].push(obj);
              } else if (obj["FabricGroupId"] === "100102") {
                if (
                  tempFabrics2[obj["DesignEnName"]] === "" ||
                  tempFabrics2[obj["DesignEnName"]] === undefined ||
                  tempFabrics2[obj["DesignEnName"]] === null ||
                  tempFabrics2[obj["DesignEnName"]] === []
                )
                  tempFabrics2[obj["DesignEnName"]] = [];
                tempFabrics2[obj["DesignEnName"]].push(obj);
              }
            });

            if (isStep2) {
              if (data.length === 0 || !Object.keys(tempFabrics2).length) {
                setShowEmptyMessage2(true);
                setFabrics2({});
                setFabricsList2([]);
              } else {
                setShowEmptyMessage2(false);
                setFabrics2(tempFabrics2);
              }
            } else {
              if (data.length === 0 || !Object.keys(tempFabrics).length) {
                setShowEmptyMessage(true);
                setFabrics({});
                setFabricsList([]);
              } else {
                setShowEmptyMessage(false);
                setFabrics(tempFabrics);
              }
            }
          })
          .catch((err) => {
            console.log(err);
          })
          .finally(() => {
            if (isStep2) {
              setLoading2(false);
            } else {
              setLoading(false);
            }
          });
      });
    }
  }
  const getModel = () => {
    axios
      .get(baseURLModel, {
        params: {
          id: modelID,
        },
      })
      .then((response) => {
        setModel(response.data);
      })
      .catch((err) => {
        console.log(err);
      });
  };
  function renderFabrics(bag, limitedFabrics, isBoard) {
    const fabricList = [];
    let cartObj = {};
    let temp = [];

    let pageLanguage1 = location.pathname
      .split("")
      .slice(1, 3)
      .join("");
    let params =
      parameters === undefined ||
      parameters === null ||
      parameters === "undefined" ||
      parameters === "null" ||
      parameters === ""
        ? "{}"
        : JSON.parse(JSON.stringify(parameters));

    if (Object.keys(bag).length > 0) {
      if (isLoggedIn) {
      } else {
        cartObj = JSON.parse(localStorage.getItem("cart"));
        temp = cartObj["swatches"];
      }
    }

    let tempFabrics = JSON.parse(JSON.stringify(fabrics));
    if (limitedFabrics !== undefined) {
      tempFabrics = limitedFabrics;
    }

    let promiseArr = [];
    Object.keys(tempFabrics).forEach((key, index) => {
      let fabrics = tempFabrics;
      promiseArr[index] = new Promise((resolve, reject) => {
        let DesignName = convertToPersian(fabrics[key][0]["DesignName"]);
        let DesignEnName = fabrics[key][0]["DesignEnName"];

        let HasTrim = fabrics[key][0]["CanHasTrim"];
        let HasBorder = fabrics[key][0]["CanHasBorder"];
        let DesignCode = fabrics[key][0]["DesignCode"];
        let designSelected = false;
        let designSelectedIndex = 0;
        let SamplePrice = fabrics[key][0]["SamplePrice"];
        let designOrderSelected =
          params["Designs"] &&
          params["Designs"][DesignCode] &&
          params["Designs"][DesignCode]["order"] &&
          params["Designs"][DesignCode]["order"] >= 0
            ? params["Designs"][DesignCode]["order"]
            : -1;

        const fabric = [];
        const fabric1 = [];

        let promiseArr2 = [];
        for (let j = 0; j < fabrics[key].length; j++) {
          promiseArr2[j] = new Promise((resolve, reject) => {
            let FabricId = fabrics[key][j].FabricId;
            let fabricOrderSelected =
              params["Fabrics"] &&
              params["Fabrics"][FabricId] &&
              (params["Fabrics"][FabricId]["order"] || params["Fabrics"][FabricId]["order"] === 0)
                ? params["Fabrics"][FabricId]["order"]
                : -1;
            let PhotoPath = "";
            let PhotoPath2 = "";
            fabrics[key][j].FabricPhotos.forEach((obj) => {
              if (obj.PhotoTypeId === 4702) PhotoPath = obj.PhotoUrl;
              if (obj.PhotoTypeId === 4709) PhotoPath2 = obj.PhotoUrl;
            });

            let FabricOnModelPhotoUrl = fabrics[key][j].FabricOnModelPhotoUrl;
            let DesignRaportLength = fabrics[key][j].DesignRaportLength;
            let DesignRaportWidth = fabrics[key][j].DesignRaportWidth;
            let PolyesterPercent = fabrics[key][j].PolyesterPercent;
            let ViscosePercent = fabrics[key][j].ViscosePercent;
            let NylonPercent = fabrics[key][j].NylonPercent;
            let ColorName = convertToPersian(fabrics[key][j].ColorName);
            let ColorEnName = fabrics[key][j].ColorEnName;
            let FabricWidth = fabrics[key][j].FabricWidth;
            let SewingDirection = fabrics[key][j].SewingDirection;
            let SwatchId = fabrics[key][j].SwatchId ? fabrics[key][j].SwatchId : -1;
            let HasSwatchId = false;
            let swatchDetailId = undefined;
            let index = -1;
            if (isLoggedIn) {
              if (bag["CartDetails"]) {
                let index = bag["CartDetails"].findIndex((object) => {
                  return object["ProductId"] === SwatchId;
                });
                if (index !== -1) {
                  HasSwatchId = true;
                  swatchDetailId = bag["CartDetails"][index]["CartDetailId"];
                }
              }
            } else {
              if (temp?.length > 0) {
                index = temp.findIndex((object) => {
                  return object["SwatchId"] === SwatchId;
                });
                if (index !== -1) {
                  HasSwatchId = true;
                }
              }
            }
            let pushIndex = 0;
            if (fabricOrderSelected !== -1 && !fabric[fabricOrderSelected]) {
              pushIndex = fabricOrderSelected;
            } else if (fabricOrderSelected !== -1 && fabric[fabricOrderSelected]) {
              fabric[fabric.length] = fabric[fabricOrderSelected];
              pushIndex = fabricOrderSelected;
            } else {
              pushIndex = fabric.length;
            }
            if (`${FabricId}` === step1) {
              designSelected = true;
              designSelectedIndex = pushIndex;
            }
            fabric[pushIndex] = (
              <div
                className={`radio_group ${pageLanguage1 === "fa" ? "font_farsi" : "font_en"}`}
                key={"fabric" + key + j}
              >
                <label
                  data-tip={`${pageLanguage1 === "en" ? DesignEnName : DesignName}: ${
                    pageLanguage1 === "en" ? ColorEnName : ColorName
                  }`}
                  data-for={"fabric" + key + j}
                  className={`radio_container ${pageLanguage1 === "fa" ? "font_farsi" : "font_en"}`}
                  data-img={`https://www.doopsalta.com/upload/${PhotoPath}`}
                >
                  <input
                    className="radio"
                    type="radio"
                    ref-num="1"
                    default-fabric-photo={FabricOnModelPhotoUrl}
                    onChange={(e) => {
                      let temp = JSON.parse(JSON.stringify(fabricSelected));
                      temp.selectedFabricId = FabricId;
                      temp.selectedTextEn = DesignEnName;
                      temp.selectedTextFa = DesignName;
                      temp.selectedDesignCode = DesignCode;
                      temp.selectedColorEn = ColorEnName;
                      temp.selectedColorFa = ColorName;
                      temp.selectedHasTrim = HasTrim;
                      temp.selectedPhoto = FabricOnModelPhotoUrl;
                      temp.selectedPhoto2 = PhotoPath2;
                      temp.FabricWidth = FabricWidth;
                      temp.SewingDirection = SewingDirection;
                      setFabricSelected(temp);
                    }}
                    name="fabric"
                    model-id={modelID}
                    value={FabricId}
                    text-en={DesignEnName}
                    text-fa={DesignName}
                    checked={`${FabricId}` === step1}
                    ref={(ref) => (inputs.current[`1${FabricId}`] = ref)}
                  />
                  <div className="frame_img">
                    <img
                      className={`img-fluid ${FabricId === step1 ? "img-fluid_checked" : ""}`}
                      src={imgUrl(PhotoPath2)}
                      alt={FabricId}
                    />
                  </div>
                </label>
                <div
                  className={`fabric_name_container ${
                    pageLanguage1 === "fa" ? "font_farsi" : "font_en"
                  }`}
                >
                  <h1>{pageLanguage1 === "en" ? CapitalizeAllWords(ColorEnName) : ColorName}</h1>
                  <span
                    onClick={() => {
                      handleShow(fabrics[key][j], swatchDetailId);
                      setHasSwatchId(HasSwatchId);
                    }}
                  >
                    <i className="fa fa-search" aria-hidden="true" />
                  </span>
                </div>
                <button
                  className={`swatchButton ${HasSwatchId ? "activeSwatch" : ""} ${
                    pageLanguage1 === "fa" ? "font_farsi" : "font_en"
                  }`}
                  current-state={HasSwatchId ? "1" : "0"}
                  onClick={(e) => {
                    fabricSwatch(e, SwatchId, swatchDetailId, PhotoPath);
                  }}
                  disabled={SwatchId === -1}
                >
                  {HasSwatchId
                    ? pageLanguage1 === "en"
                      ? "SWATCH IN BAG"
                      : "نمونه در سبد"
                    : pageLanguage1 === "en"
                    ? "ORDER" + " SWATCH"
                    : "سفارش نمونه"}
                </button>
              </div>
            );

            pushIndex = fabric.length;
            fabric1.push(
              <li className="fabric_design_border_list_item" key={"border" + key + j}>
                <OverlayContainer
                  classNames="Accessories_List_item_color"
                  placement="middle"
                  children={
                    <div
                      className={`radio_group ${pageLanguage1 === "fa" ? "font_farsi" : "font_en"}`}
                    >
                      <label>
                        <input
                          className="radio"
                          type="radio"
                          outline="true"
                          onChange={(e) => {
                            let temp = JSON.parse(JSON.stringify(borderSelected));
                            temp.selectedFabricId = FabricId;
                            temp.selectedTextEn = DesignEnName;
                            temp.selectedTextFa = DesignName;
                            temp.selectedDesignCode = DesignCode;
                            temp.selectedColorEn = ColorEnName;
                            temp.selectedColorFa = ColorName;
                            setBorderSelected(temp);
                          }}
                          name="border-trim"
                          model-id={modelID}
                          value={FabricId}
                          checked={`${FabricId}` === step1Border}
                          ref={(ref) => (inputs.current[`border-trim${FabricId}`] = ref)}
                        />
                        <div className="frame_img">
                          <img
                            className={`img-fluid ${
                              `${FabricId}` === step1Border ? "img-fluid_checked" : ""
                            }`}
                            src={imgUrl(PhotoPath)}
                            alt=""
                          />
                        </div>
                      </label>
                    </div>
                  }
                  component={
                    <div className="Accessories_List_item_color_container">
                      <p className="Accessories_List_item_color_text 1">
                        {pageLanguage1 === "en" ? ColorEnName : ColorName}
                      </p>
                    </div>
                  }
                />
              </li>
            );
            resolve();
          });
        }

        Promise.all(promiseArr2).then(() => {
          if (designSelected) {
            if (isBoard) {
              let newPushIndex = Math.ceil((designSelectedIndex + 1) / 4) * 4;
              fabric.splice(
                newPushIndex,
                0,
                <div key={"board"} className="grommet_fabric_board_container">
                  <div className="card-body-display-flex">
                    <span className="checkbox_text">{t("fabricHasLine")}</span>
                  </div>
                </div>
              );
            }
          }
          let pushIndex = 0;
          if (designOrderSelected !== -1 && !fabricList[designOrderSelected]) {
            pushIndex = designOrderSelected;
          } else if (designOrderSelected !== -1 && fabricList[designOrderSelected]) {
            fabricList[fabricList.length] = fabricList[designOrderSelected];
            pushIndex = designOrderSelected;
          } else {
            let index = fabricList.findIndex(Object.is.bind(null, undefined));
            pushIndex = index === -1 ? fabricList.length : index;
          }

          fabricList[pushIndex] = (
            <React.Fragment key={"fabric" + key}>
              <div
                className={`material_detail ${pageLanguage1 === "fa" ? "font_farsi" : "font_en"}`}
              >
                <div
                  className={`material_traits ${pageLanguage1 === "fa" ? "font_farsi" : "font_en"}`}
                >
                  <hr />
                  <span>
                    <p>
                      {pageLanguage1 === "en" ? "DESIGN NAME" : "نام طرح"}:{" "}
                      {pageLanguage1 === "en" ? DesignEnName : DesignName}
                    </p>
                    <span className="fabric_seperator">&nbsp;|&nbsp;</span>
                    <p>
                      {pageLanguage1 === "en" ? "FROM" : "قیمت از"}:{" "}
                      {GetPrice(
                        SamplePrice,
                        pageLanguage1,
                        pageLanguage1 === "en" ? "Tomans" : "تومان",
                        isTabletOrMobile
                      )}
                    </p>
                  </span>
                </div>
                {fabric}
              </div>
              {(HasTrim || HasBorder) && (
                <div
                  className={
                    step1Check === `${DesignCode}`
                      ? "fabric_design_checkbox_container fabric_design_checkbox_container_pleated width_max checkbox_style checkbox_style_inline active"
                      : "fabric_design_checkbox_container fabric_design_checkbox_container_pleated width_max checkbox_style checkbox_style_inline"
                  }
                >
                  <input
                    type="checkbox"
                    name="step1Check"
                    checked={step1Check === `${DesignCode}`}
                    onChange={(e) => {
                      if (
                        step1 !== "" &&
                        fabrics[DesignEnName].some((obj) => obj["FabricId"] === step1)
                      ) {
                        if (e.target.checked) {
                          setStep1Check(`${DesignCode}`);
                          setShouldScroll(true);
                          setTimeout(() => {
                            if (fabricsContainerRef3.current) {
                              fabricsContainerRef3.current.scrollBy({
                                top: 200,
                                behavior: "smooth",
                              });
                            }
                          }, 200);
                        } else {
                          setStep1Check("");
                        }
                      } else {
                        setStep1Check("");
                        modalHandleShow("FabricDesignNotSelected");
                      }
                    }}
                    id={`${DesignCode + 4}`}
                    ref={(ref) => (inputs.current[`trim-${DesignCode}`] = ref)}
                  />
                  <label htmlFor={`${DesignCode + 4}`} className="checkbox_label">
                    <img
                      className="checkbox_label_img checkmark1 img-fluid"
                      src={require("../Images/public/checkmark1_checkbox.png")}
                      alt=""
                    />
                    <span className="checkbox_text">
                      {HasTrim && HasBorder
                        ? pageLanguage1 === "en"
                          ? "Add A Decorative Border / Trim"
                          : "اضافه کردن نواردوزی/ حاشیه تزئینی  "
                        : HasTrim
                        ? pageLanguage1 === "en"
                          ? "Add A Trim"
                          : "یک نوار اضافه کنید"
                        : HasBorder
                        ? pageLanguage1 === "en"
                          ? "Add A Decorative Border"
                          : "اضافه کردن حاشیه/ نوار تزئینی"
                        : ""}
                    </span>
                  </label>
                </div>
              )}
              <div
                className={
                  step1Check === `${DesignCode}`
                    ? "fabric_design_trim_border_container active"
                    : "fabric_design_trim_border_container"
                }
              >
                <div>
                  <h1 className="fabric_design_trim_border_title">
                    {HasTrim && HasBorder
                      ? pageLanguage1 === "en"
                        ? "Select Your Decorative Border / Trim Material"
                        : "نواردوزی/حاشیه تزئینی مورد نظرتان را انتخاب کنید."
                      : HasTrim
                      ? pageLanguage1 === "en"
                        ? "Select Your Trim Material"
                        : ""
                      : HasBorder
                      ? pageLanguage1 === "en"
                        ? "Select Your Decorative Border"
                        : ""
                      : ""}
                  </h1>
                  {HasBorder && (
                    <div className="fabric_design_border_container">
                      <h2 className="fabric_design_trim_border_title2">
                        {pageLanguage1 === "en" ? "DECORATIVE BORDER" : "حاشیه تزئینی"}:{" "}
                        {pageLanguage1 === "en" ? DesignEnName : DesignName}
                      </h2>
                      <ul className="fabric_design_border_list">{fabric1}</ul>
                      {step1Border !== "" && (
                        <div className="fabric_design_border_checkbox_container">
                          <h3 className="fabric_design_trim_border_title3">
                            {pageLanguage1 === "en"
                              ? "Select A Border Position:"
                              : "حاشیه تزیینی کجای پرده دوخته شود؟"}
                          </h3>
                          <div className="box100 radio_style">
                            <input
                              className={
                                step1BorderRadio === "10cm Leading Edge"
                                  ? "radio radio_checked"
                                  : "radio"
                              }
                              type="radio"
                              text={t("10cm Leading Edge")}
                              value="1"
                              name="step1bordercheck"
                              id="border1"
                              checked={step1BorderRadio === "10cm Leading Edge"}
                              onChange={(e) => {
                                setStep1BorderRadio("10cm Leading Edge");
                              }}
                              ref={(ref) => (inputs.current["border1"] = ref)}
                            />
                            <label htmlFor="border1">
                              {/* {t("10cm Leading Edge")} */}
                              {i18n.language === "fa"
                                ? "حاشیه ۱۰ س\u200Cم در کناره\u200Cها"
                                : "10cm Leading Edge"}
                            </label>
                          </div>
                          <div className="box100 radio_style">
                            <input
                              className={
                                step1BorderRadio === "60cm Bottom Border"
                                  ? "radio radio_checked"
                                  : "radio"
                              }
                              type="radio"
                              text={t("60cm Bottom Border")}
                              value="2"
                              name="step1bordercheck"
                              id="border2"
                              checked={step1BorderRadio === "60cm Bottom Border"}
                              onChange={(e) => {
                                setStep1BorderRadio("60cm Bottom Border");
                                // setCart("borderPosition", "60cm Bottom Border");
                              }}
                              ref={(ref) => (inputs.current["border2"] = ref)}
                            />
                            <label htmlFor="border2">
                              {/* {t("60cm Bottom Border")} */}
                              {i18n.language === "fa"
                                ? "حاشیه ۶۰ س\u200Cم پایین"
                                : "60cm Bottom Border"}
                            </label>
                          </div>
                          <div className="box100 radio_style">
                            <input
                              className={
                                step1BorderRadio === "10cm Leading Edge & 60cm Bottom Border"
                                  ? "radio radio_checked"
                                  : "radio"
                              }
                              type="radio"
                              text={t("10cm Leading Edge & 60cm Bottom Border")}
                              value="3"
                              name="step1bordercheck"
                              id="border3"
                              checked={
                                step1BorderRadio === "10cm Leading Edge & 60cm Bottom Border"
                              }
                              onChange={(e) => {
                                setStep1BorderRadio("10cm Leading Edge & 60cm Bottom Border");
                                // setCart("borderPosition", "10cm Leading Edge & 60cm Bottom Border");
                              }}
                              ref={(ref) => (inputs.current["border3"] = ref)}
                            />
                            <label htmlFor="border3">
                              {t("10cm Leading Edge & 60cm Bottom Border")}
                            </label>
                          </div>
                        </div>
                      )}
                    </div>
                  )}
                  {HasTrim && (
                    <>
                      {Object.keys(trimAccessories).map((key, index) => {
                        return (
                          <div className="fabric_design_border_container" key={"trim" + key}>
                            <h2 className="fabric_design_trim_border_title2">
                              {pageLanguage1 === "en" ? "DECORATIVE TRIM" : "نوار تزئینی"}:{" "}
                              {pageLanguage1 === "en"
                                ? Uppercase(trimAccessories[key][0]["DesignENName"])
                                : convertToPersian(trimAccessories[key][0]["DesignName"])}
                            </h2>
                            <ul className="fabric_design_border_list">
                              {trimAccessories[key].map((el, i) => {
                                let FabricId = el["DetailId"];
                                let DesignName = convertToPersian(el["DesignName"]);
                                let DesignEnName = el["DesignENName"];
                                let ColorName = convertToPersian(el["ColorName"]);
                                let ColorEnName = el["ColorENName"];
                                let PhotoPath = "";
                                el["Photos"].forEach((obj) => {
                                  if (obj.PhotoTypeId === 4702) PhotoPath = obj.PhotoUrl;
                                });
                                return (
                                  <li
                                    className="fabric_design_border_list_item"
                                    key={"trim" + key + i}
                                  >
                                    <OverlayContainer
                                      classNames="Accessories_List_item_color"
                                      placement="middle"
                                      children={
                                        <div
                                          className={`radio_group ${
                                            pageLanguage1 === "fa" ? "font_farsi" : "font_en"
                                          }`}
                                        >
                                          <label>
                                            <input
                                              className="radio"
                                              type="radio"
                                              outline="true"
                                              onChange={(e) => {
                                                let temp = JSON.parse(JSON.stringify(trimSelected));
                                                temp.selectedFabricId = FabricId;
                                                temp.selectedTextEn = DesignEnName;
                                                temp.selectedTextFa = DesignName;
                                                temp.selectedDesignCode = DesignCode;
                                                temp.selectedColorEn = ColorEnName;
                                                temp.selectedColorFa = ColorName;
                                                setTrimSelected(temp);
                                              }}
                                              name="border-trim"
                                              model-id={modelID}
                                              value={FabricId}
                                              checked={`${FabricId}` === step1Trim}
                                              ref={(ref) =>
                                                (inputs.current[`border-trim${FabricId}`] = ref)
                                              }
                                            />
                                            <div className="frame_img">
                                              <img
                                                className={`img-fluid ${
                                                  `${FabricId}` === step1Trim
                                                    ? "img-fluid_checked"
                                                    : ""
                                                }`}
                                                src={imgUrl(PhotoPath)}
                                                alt=""
                                              />
                                            </div>
                                          </label>
                                        </div>
                                      }
                                      component={
                                        <div className="Accessories_List_item_color_container">
                                          <p className="Accessories_List_item_color_text 2">
                                            {pageLanguage1 === "en" ? ColorEnName : ColorName}
                                          </p>
                                        </div>
                                      }
                                    />
                                  </li>
                                );
                              })}
                            </ul>
                          </div>
                        );
                      })}
                    </>
                  )}
                </div>
              </div>
            </React.Fragment>
          );

          resolve();
        });
      });
    });

    Promise.all(promiseArr).then(() => {
      if (limitedFabrics !== undefined) {
      } else {
        setFabricsList(fabricList);
      }
    });
  }
  function renderFabrics2(bag, limitedFabrics, isBoard) {
    const fabricList = [];
    let cartObj = {};
    let temp = [];
    let pageLanguage1 = location.pathname
      .split("")
      .slice(1, 3)
      .join("");
    let params =
      parameters === undefined ||
      parameters === null ||
      parameters === "undefined" ||
      parameters === "null" ||
      parameters === ""
        ? "{}"
        : JSON.parse(JSON.stringify(parameters));

    if (Object.keys(bag).length > 0) {
      if (isLoggedIn) {
      } else {
        cartObj = JSON.parse(localStorage.getItem("cart"));
        temp = cartObj["swatches"];
      }
    }

    let tempFabrics = JSON.parse(JSON.stringify(fabrics2));
    if (limitedFabrics !== undefined) {
      tempFabrics = limitedFabrics;
    }

    let promiseArr = [];
    Object.keys(tempFabrics).forEach((key, index) => {
      let fabrics = tempFabrics;
      promiseArr[index] = new Promise((resolve) => {
        let DesignName = convertToPersian(fabrics[key][0]["DesignName"]);
        let DesignEnName = fabrics[key][0]["DesignEnName"];
        let HasTrim = fabrics[key][0]["CanHasTrim"];
        let HasBorder = fabrics[key][0]["CanHasBorder"];
        let LeadRequired = fabrics[key][0]["LeadRequired"];
        let DesignCode = fabrics[key][0]["DesignCode"];
        let designSelected = false;
        let designSelectedIndex = 0;
        let SamplePrice = fabrics[key][0]["SamplePrice"];
        let designOrderSelected =
          params["Designs"] &&
          params["Designs"][DesignCode] &&
          params["Designs"][DesignCode]["order"] &&
          params["Designs"][DesignCode]["order"] >= 0
            ? params["Designs"][DesignCode]["order"]
            : -1;

        const fabric = [];
        const fabric1 = [];
        let promiseArr2 = [];
        for (let j = 0; j < fabrics[key].length; j++) {
          promiseArr2[j] = new Promise((resolve) => {
            let FabricId = fabrics[key][j].FabricId;
            let fabricOrderSelected =
              params["Fabrics"] &&
              params["Fabrics"][FabricId] &&
              (params["Fabrics"][FabricId]["order"] || params["Fabrics"][FabricId]["order"] === 0)
                ? params["Fabrics"][FabricId]["order"]
                : -1;

            let PhotoPath = "";
            let PhotoPath2 = "";
            fabrics[key][j].FabricPhotos.forEach((obj) => {
              if (obj.PhotoTypeId === 4702) PhotoPath = obj.PhotoUrl;
              if (obj.PhotoTypeId === 4709) PhotoPath2 = obj.PhotoUrl;
            });

            let FabricOnModelPhotoUrl = fabrics[key][j].FabricOnModelPhotoUrl;
            let ColorName = convertToPersian(fabrics[key][j].ColorName);
            let ColorEnName = fabrics[key][j].ColorEnName;
            let FabricWidth = fabrics[key][j].FabricWidth;
            let SewingDirection = fabrics[key][j].SewingDirection;
            let SwatchId = fabrics[key][j].SwatchId ? fabrics[key][j].SwatchId : -1;
            let HasSwatchId = false;
            let swatchDetailId = undefined;
            let index = -1;
            if (isLoggedIn) {
              if (bag["CartDetails"]) {
                let index = bag["CartDetails"].findIndex((object) => {
                  return object["ProductId"] === SwatchId;
                });
                if (index !== -1) {
                  HasSwatchId = true;
                  swatchDetailId = bag["CartDetails"][index]["CartDetailId"];
                }
              }
            } else {
              if (temp?.length > 0) {
                index = temp.findIndex((object) => {
                  return object["SwatchId"] === SwatchId;
                });
                if (index !== -1) {
                  HasSwatchId = true;
                }
              }
            }

            let pushIndex = 0;
            if (fabricOrderSelected !== -1 && !fabric[fabricOrderSelected]) {
              pushIndex = fabricOrderSelected;
            } else if (fabricOrderSelected !== -1 && fabric[fabricOrderSelected]) {
              fabric[fabric.length] = fabric[fabricOrderSelected];
              pushIndex = fabricOrderSelected;
            } else {
              pushIndex = fabric.length;
            }
            if (`${FabricId}` === step2) {
              designSelected = true;
              designSelectedIndex = pushIndex;
            }

            fabric[pushIndex] = (
              <div
                className={`radio_group ${pageLanguage1 === "fa" ? "font_farsi" : "font_en"}`}
                key={"fabric" + key + j}
              >
                <label
                  data-tip={`${pageLanguage1 === "en" ? DesignEnName : DesignName}: ${
                    pageLanguage1 === "en" ? ColorEnName : ColorName
                  }`}
                  data-for={"fabric" + key + j}
                  className={`radio_container ${pageLanguage1 === "fa" ? "font_farsi" : "font_en"}`}
                  data-img={`https://www.doopsalta.com/upload/${PhotoPath}`}
                >
                  <input
                    className="radio"
                    type="radio"
                    ref-num="3"
                    default-fabric-photo={FabricOnModelPhotoUrl}
                    onChange={(e) => {
                      let temp = JSON.parse(JSON.stringify(fabricSelected2));
                      temp.selectedFabricId = FabricId;
                      temp.selectedTextEn = DesignEnName;
                      temp.selectedTextFa = DesignName;
                      temp.selectedDesignCode = DesignCode;
                      temp.selectedColorEn = ColorEnName;
                      temp.selectedColorFa = ColorName;
                      temp.selectedLeadRequired = LeadRequired;
                      temp.selectedPhoto = FabricOnModelPhotoUrl;
                      temp.selectedPhoto2 = PhotoPath2;
                      temp.FabricWidth = FabricWidth;
                      temp.SewingDirection = SewingDirection;
                      setFabricSelected2(temp);
                    }}
                    name="fabric2"
                    model-id={modelID}
                    value={FabricId}
                    text-en={DesignEnName}
                    text-fa={DesignName}
                    checked={`${FabricId}` === step2}
                    ref={(ref) => (inputs.current[`15${FabricId}`] = ref)}
                  />
                  <div className="frame_img">
                    <img
                      className={`img-fluid  ${`${FabricId}` === step2 ? "img-fluid_checked" : ""}`}
                      src={imgUrl(PhotoPath2)}
                      alt=""
                    />
                  </div>
                </label>
                <div
                  className={`fabric_name_container ${
                    pageLanguage1 === "fa" ? "font_farsi" : "font_en"
                  }`}
                >
                  <h1>{pageLanguage1 === "en" ? CapitalizeAllWords(ColorEnName) : ColorName}</h1>
                  <span
                    onClick={() => {
                      handleShow(fabrics[key][j], swatchDetailId);
                      setHasSwatchId(HasSwatchId);
                    }}
                  >
                    <i className="fa fa-search" aria-hidden="true" />
                  </span>
                </div>
                <button
                  className={`swatchButton ${HasSwatchId ? "activeSwatch" : ""} ${
                    pageLanguage1 === "fa" ? "font_farsi" : "font_en"
                  }`}
                  current-state={HasSwatchId ? "1" : "0"}
                  onClick={(e) => {
                    fabricSwatch(e, SwatchId, swatchDetailId, PhotoPath);
                  }}
                  disabled={SwatchId === -1}
                >
                  {HasSwatchId
                    ? pageLanguage1 === "en"
                      ? "SWATCH IN BAG"
                      : "نمونه در سبد"
                    : pageLanguage1 === "en"
                    ? "ORDER" + " SWATCH"
                    : "سفارش نمونه"}
                </button>
              </div>
            );
            pushIndex = fabric.length;
            fabric1.push(
              <li className="fabric_design_border_list_item" key={"border" + key + j}>
                <OverlayContainer
                  classNames="Accessories_List_item_color"
                  placement="middle"
                  children={
                    <div
                      className={`radio_group ${pageLanguage1 === "fa" ? "font_farsi" : "font_en"}`}
                    >
                      <label>
                        <input
                          className="radio"
                          type="radio"
                          outline="true"
                          onChange={(e) => {
                            let temp = JSON.parse(JSON.stringify(borderSelected2));
                            temp.selectedFabricId = FabricId;
                            temp.selectedTextEn = DesignEnName;
                            temp.selectedTextFa = DesignName;
                            temp.selectedDesignCode = DesignCode;
                            temp.selectedColorEn = ColorEnName;
                            temp.selectedColorFa = ColorName;
                            setBorderSelected2(temp);
                          }}
                          name="border-trim"
                          model-id={modelID}
                          value={FabricId}
                          checked={`${FabricId}` === step2Border}
                          ref={(ref) => (inputs.current[`border-trim${FabricId}`] = ref)}
                        />
                        <div className="frame_img">
                          <img
                            className={`img-fluid ${
                              `${FabricId}` === step2Border ? "img-fluid_checked" : ""
                            }`}
                            src={imgUrl(PhotoPath)}
                            alt=""
                          />
                        </div>
                      </label>
                    </div>
                  }
                  component={
                    <div className="Accessories_List_item_color_container">
                      <p className="Accessories_List_item_color_text 3">
                        {pageLanguage1 === "en" ? ColorEnName : ColorName}
                      </p>
                    </div>
                  }
                />
              </li>
            );
            resolve();
          });
        }
        Promise.all(promiseArr2).then(() => {
          if (designSelected) {
            if (isBoard) {
              let newPushIndex = Math.ceil((designSelectedIndex + 1) / 4) * 4;
              fabric.splice(
                newPushIndex,
                0,
                <div key={"board"} className="grommet_fabric_board_container">
                  <div className="card-body-display-flex">
                    <span className="checkbox_text">{t("fabricHasLine2")}</span>
                  </div>
                </div>
              );
            }
          }
          let pushIndex = 0;
          if (designOrderSelected !== -1 && !fabricList[designOrderSelected]) {
            pushIndex = designOrderSelected;
          } else if (designOrderSelected !== -1 && fabricList[designOrderSelected]) {
            fabricList[fabricList.length] = fabricList[designOrderSelected];
            pushIndex = designOrderSelected;
          } else {
            let index = fabricList.findIndex(Object.is.bind(null, undefined));
            pushIndex = index === -1 ? fabricList.length : index;
          }

          fabricList[pushIndex] = (
            <React.Fragment key={"fabric" + key}>
              <div
                className={`material_detail ${pageLanguage1 === "fa" ? "font_farsi" : "font_en"}`}
              >
                <div
                  className={`material_traits ${pageLanguage1 === "fa" ? "font_farsi" : "font_en"}`}
                >
                  <hr />
                  <span>
                    <p>
                      {pageLanguage1 === "en" ? "DESIGN NAME" : "نام طرح"}:{" "}
                      {pageLanguage1 === "en" ? DesignEnName : DesignName}
                    </p>
                    <span className="fabric_seperator">&nbsp;|&nbsp;</span>
                    <p>
                      {pageLanguage1 === "en" ? "FROM" : "قیمت از"}:{" "}
                      {GetPrice(
                        SamplePrice,
                        pageLanguage1,
                        pageLanguage1 === "en" ? "Tomans" : "تومان",
                        isTabletOrMobile
                      )}
                    </p>
                  </span>
                </div>
                {fabric}
              </div>
              {LeadRequired && (
                <div className="fabric_design_checkbox_container width_max checkbox_style checkbox_style_inline 1">
                  <span className="checkbox_text">
                    {pageLanguage1 === "en"
                      ? "Lead weight comes standard with this design."
                      : "این مدل تور به طور پیش فرض با وزنه سربی ارسال می شود."}
                  </span>
                </div>
              )}
              {LeadRequired === null && (
                <div
                  className={
                    step2Check2 === `${DesignCode}`
                      ? "fabric_design_checkbox_container width_max checkbox_style checkbox_style_inline 2 active"
                      : "fabric_design_checkbox_container width_max checkbox_style checkbox_style_inline 3"
                  }
                >
                  <input
                    type="checkbox"
                    name="step1Check"
                    checked={step2Check2 === `${DesignCode}`}
                    onChange={(e) => {
                      if (
                        step2 !== "" &&
                        fabrics[DesignEnName].some((obj) => obj["FabricId"] === step2)
                      ) {
                        if (e.target.checked) {
                          setStep2Check2(`${DesignCode}`);
                        } else {
                          setStep2Check2("");
                        }
                      } else {
                        setStep2Check2("");
                        modalHandleShow("FabricDesignNotSelected");
                      }
                    }}
                    id={`${DesignCode + 2}`}
                    ref={(ref) => (inputs.current[`trim-${DesignCode}`] = ref)}
                  />
                  <label htmlFor={`${DesignCode + 2}`} className="checkbox_label">
                    <img
                      className="checkbox_label_img checkmark1 img-fluid"
                      src={require("../Images/public/checkmark1_checkbox.png")}
                      alt=""
                    />
                    <span className="checkbox_text">
                      {pageLanguage1 === "en" ? "Add A Lead Weight" : "وزنه سربی اضافه کنید."}
                    </span>
                  </label>
                </div>
              )}
              {(HasTrim || HasBorder) && (
                <div
                  className={
                    step2Check === `${DesignCode}`
                      ? "fabric_design_checkbox_container width_max checkbox_style checkbox_style_inline 4 active"
                      : "fabric_design_checkbox_container width_max checkbox_style checkbox_style_inline 5"
                  }
                >
                  <input
                    type="checkbox"
                    name="step1Check"
                    checked={step2Check === `${DesignCode}`}
                    onChange={(e) => {
                      if (
                        step2 !== "" &&
                        fabrics[DesignEnName].some((obj) => obj["FabricId"] === step2)
                      ) {
                        if (e.target.checked) {
                          setStep2Check(`${DesignCode}`);
                          setTimeout(() => {
                            if (fabricsContainerRef2.current) {
                              fabricsContainerRef2.current.scrollBy({
                                top: 300,
                                behavior: "smooth",
                              });
                            }
                          }, 400);
                        } else {
                          setStep2Check("");
                        }
                      } else {
                        setStep2Check("");
                        modalHandleShow("FabricDesignNotSelected");
                      }
                    }}
                    id={`${DesignCode + 3}`}
                    ref={(ref) => (inputs.current[`trim-${DesignCode}`] = ref)}
                  />
                  <label htmlFor={`${DesignCode + 3}`} className="checkbox_label">
                    <img
                      className="checkbox_label_img checkmark1 img-fluid"
                      src={require("../Images/public/checkmark1_checkbox.png")}
                      alt=""
                    />
                    <span className="checkbox_text">
                      {HasTrim && HasBorder
                        ? pageLanguage1 === "en"
                          ? "Add A Decorative Border / Trim"
                          : "یک حاشیه / نوار تزئینی اضافه کنید"
                        : HasTrim
                        ? pageLanguage1 === "en"
                          ? "Add A Trim"
                          : "یک نوار اضافه کنید"
                        : HasBorder
                        ? pageLanguage1 === "en"
                          ? "Add A Decorative Border"
                          : "اضافه کردن حاشیه/ نوار تزئینی"
                        : ""}
                    </span>
                  </label>
                </div>
              )}
              <div
                className={
                  step2Check === `${DesignCode}`
                    ? "fabric_design_trim_border_container active"
                    : "fabric_design_trim_border_container"
                }
              >
                <div>
                  <h1 className="fabric_design_trim_border_title">
                    {HasTrim && HasBorder
                      ? pageLanguage1 === "en"
                        ? "Select Your Decorative Border / Trim Material"
                        : ""
                      : HasTrim
                      ? pageLanguage1 === "en"
                        ? "Select Your Trim Material"
                        : ""
                      : HasBorder
                      ? pageLanguage1 === "en"
                        ? "Select Your Decorative Border"
                        : ""
                      : ""}
                  </h1>
                  {HasBorder && (
                    <div className="fabric_design_border_container">
                      <h2 className="fabric_design_trim_border_title2">
                        {pageLanguage1 === "en" ? "DECORATIVE BORDER" : "حاشیه تزئینی"}:{" "}
                        {pageLanguage1 === "en" ? DesignEnName : DesignName}
                      </h2>
                      <ul className="fabric_design_border_list">{fabric1}</ul>
                      {step2Border !== "" && (
                        <div className="fabric_design_border_checkbox_container">
                          <h3 className="fabric_design_trim_border_title3">
                            {pageLanguage1 === "en"
                              ? "Select A Border Position:"
                              : "حاشیه کجای پرده دوخته شود؟"}
                          </h3>
                          <div className="box100 radio_style">
                            <input
                              className={
                                step2BorderRadio === "10cm Leading Edge"
                                  ? "radio radio_checked"
                                  : "radio"
                              }
                              type="radio"
                              text={t("10cm Leading Edge")}
                              value="1"
                              name="step2bordercheck"
                              id="border4"
                              checked={step2BorderRadio === "10cm Leading Edge"}
                              onChange={(e) => {
                                setStep2BorderRadio("10cm Leading Edge");
                              }}
                              ref={(ref) => (inputs.current["border4"] = ref)}
                            />
                            <label htmlFor="border4">
                              {i18n.language === "fa"
                                ? "حاشیه ۱۰ س\u200Cم در کناره ها"
                                : "10cm Leading Edge"}
                            </label>
                          </div>
                          <div className="box100 radio_style">
                            <input
                              className={
                                step2BorderRadio === "60cm Bottom Border"
                                  ? "radio radio_checked"
                                  : "radio"
                              }
                              type="radio"
                              text={t("60cm Bottom Border")}
                              value="2"
                              name="step2bordercheck"
                              id="border5"
                              checked={step2BorderRadio === "60cm Bottom Border"}
                              onChange={(e) => {
                                setStep2BorderRadio("60cm Bottom Border");
                              }}
                              ref={(ref) => (inputs.current["border5"] = ref)}
                            />
                            <label htmlFor="border5">
                              {i18n.language === "fa" ? "حاشیه ۶۰ س‌م پایین" : "60cm Bottom Border"}
                            </label>
                          </div>
                          <div className="box100 radio_style">
                            <input
                              className={
                                step2BorderRadio === "10cm Leading Edge & 60cm Bottom Border"
                                  ? "radio radio_checked"
                                  : "radio"
                              }
                              type="radio"
                              text={t("10cm Leading Edge & 60cm Bottom Border")}
                              value="3"
                              name="step2bordercheck"
                              id="border6"
                              checked={
                                step2BorderRadio === "10cm Leading Edge & 60cm Bottom Border"
                              }
                              onChange={(e) => {
                                setStep2BorderRadio("10cm Leading Edge & 60cm Bottom Border");
                              }}
                              ref={(ref) => (inputs.current["border6"] = ref)}
                            />
                            <label htmlFor="border6">
                              {t("10cm Leading Edge & 60cm Bottom Border")}
                            </label>
                          </div>
                        </div>
                      )}
                    </div>
                  )}
                  {HasTrim && (
                    <>
                      {Object.keys(trimAccessories).map((key, index) => {
                        return (
                          <div className="fabric_design_border_container" key={"trim" + key}>
                            <h2 className="fabric_design_trim_border_title2">
                              {pageLanguage1 === "en" ? "DECORATIVE TRIM" : "نوار تزئینی"}:{" "}
                              {pageLanguage1 === "en"
                                ? Uppercase(trimAccessories[key][0]["DesignENName"])
                                : convertToPersian(trimAccessories[key][0]["DesignName"])}
                            </h2>
                            <ul className="fabric_design_border_list">
                              {trimAccessories[key].map((el, i) => {
                                let FabricId = el["DetailId"];
                                let DesignName = convertToPersian(el["DesignName"]);
                                let DesignEnName = el["DesignENName"];
                                let ColorName = convertToPersian(el["ColorName"]);
                                let ColorEnName = el["ColorENName"];
                                let PhotoPath = "";
                                el["Photos"].forEach((obj) => {
                                  if (obj.PhotoTypeId === 4702) PhotoPath = obj.PhotoUrl;
                                });
                                return (
                                  <li
                                    className="fabric_design_border_list_item"
                                    key={"trim" + key + i}
                                  >
                                    <OverlayContainer
                                      classNames="Accessories_List_item_color"
                                      placement="middle"
                                      children={
                                        <div
                                          className={`radio_group ${
                                            pageLanguage1 === "fa" ? "font_farsi" : "font_en"
                                          }`}
                                        >
                                          <label>
                                            <input
                                              className="radio"
                                              type="radio"
                                              outline="true"
                                              onChange={(e) => {
                                                let temp = JSON.parse(
                                                  JSON.stringify(trimSelected2)
                                                );
                                                temp.selectedFabricId = FabricId;
                                                temp.selectedTextEn = DesignEnName;
                                                temp.selectedTextFa = DesignName;
                                                temp.selectedDesignCode = DesignCode;
                                                temp.selectedColorEn = ColorEnName;
                                                temp.selectedColorFa = ColorName;
                                                setTrimSelected2(temp);
                                              }}
                                              name="border-trim"
                                              model-id={modelID}
                                              value={FabricId}
                                              checked={`${FabricId}` === step2Trim}
                                              ref={(ref) =>
                                                (inputs.current[`border-trim${FabricId}`] = ref)
                                              }
                                            />
                                            <div className="frame_img">
                                              <img
                                                className={`img-fluid ${
                                                  `${FabricId}` === step2Trim
                                                    ? "img-fluid_checked"
                                                    : ""
                                                }`}
                                                src={imgUrl(PhotoPath)}
                                                alt=""
                                              />
                                            </div>
                                          </label>
                                        </div>
                                      }
                                      component={
                                        <div className="Accessories_List_item_color_container">
                                          <p className="Accessories_List_item_color_text 4">
                                            {pageLanguage1 === "en" ? ColorEnName : ColorName}
                                          </p>
                                        </div>
                                      }
                                    />
                                  </li>
                                );
                              })}
                            </ul>
                          </div>
                        );
                      })}
                    </>
                  )}
                </div>
              </div>
            </React.Fragment>
          );
          resolve();
        });
      });
    });
    Promise.all(promiseArr).then(() => {
      if (limitedFabrics !== undefined) {
      } else {
        if (fabricList?.length) {
          setFabricsList2(fabricList);
        }
      }
    });
  }

  function renderFabrics22(bag, limitedFabrics, isBoard) {
    const fabricList = [];
    let cartObj = {};
    let temp = [];
    let pageLanguage1 = location.pathname
      .split("")
      .slice(1, 3)
      .join("");
    let params =
      parameters === undefined ||
      parameters === null ||
      parameters === "undefined" ||
      parameters === "null" ||
      parameters === ""
        ? "{}"
        : JSON.parse(JSON.stringify(parameters));

    if (Object.keys(bag).length > 0) {
      if (isLoggedIn) {
      } else {
        cartObj = JSON.parse(localStorage.getItem("cart"));
        temp = cartObj["swatches"];
      }
    }

    let tempFabrics = JSON.parse(JSON.stringify(fabrics2));
    if (limitedFabrics !== undefined) {
      tempFabrics = limitedFabrics;
    }

    let promiseArr = [];
    Object.keys(tempFabrics).forEach((key, index) => {
      let fabrics = tempFabrics;
      promiseArr[index] = new Promise((resolve) => {
        let DesignName = convertToPersian(fabrics[key][0]["DesignName"]);
        let DesignEnName = fabrics[key][0]["DesignEnName"];
        let HasTrim = fabrics[key][0]["CanHasTrim"];
        let HasBorder = fabrics[key][0]["CanHasBorder"];
        let LeadRequired = fabrics[key][0]["LeadRequired"];
        let DesignCode = fabrics[key][0]["DesignCode"];
        let designSelected = false;
        let designSelectedIndex = 0;
        let SamplePrice = fabrics[key][0]["SamplePrice"];
        let designOrderSelected =
          params["Designs"] &&
          params["Designs"][DesignCode] &&
          params["Designs"][DesignCode]["order"] &&
          params["Designs"][DesignCode]["order"] >= 0
            ? params["Designs"][DesignCode]["order"]
            : -1;

        const fabric = [];
        const fabric1 = [];
        let promiseArr2 = [];
        for (let j = 0; j < fabrics[key].length; j++) {
          promiseArr2[j] = new Promise((resolve) => {
            let FabricId = fabrics[key][j].FabricId;
            let fabricOrderSelected =
              params["Fabrics"] &&
              params["Fabrics"][FabricId] &&
              (params["Fabrics"][FabricId]["order"] || params["Fabrics"][FabricId]["order"] === 0)
                ? params["Fabrics"][FabricId]["order"]
                : -1;

            let PhotoPath = "";
            let PhotoPath2 = "";
            fabrics[key][j].FabricPhotos.forEach((obj) => {
              if (obj.PhotoTypeId === 4702) PhotoPath = obj.PhotoUrl;
              if (obj.PhotoTypeId === 4709) PhotoPath2 = obj.PhotoUrl;
            });

            let FabricOnModelPhotoUrl = fabrics[key][j].FabricOnModelPhotoUrl;
            let ColorName = convertToPersian(fabrics[key][j].ColorName);
            let ColorEnName = fabrics[key][j].ColorEnName;
            let FabricWidth = fabrics[key][j].FabricWidth;
            let SewingDirection = fabrics[key][j].SewingDirection;
            let SwatchId = fabrics[key][j].SwatchId ? fabrics[key][j].SwatchId : -1;
            let HasSwatchId = false;
            let swatchDetailId = undefined;
            let index = -1;
            if (isLoggedIn) {
              if (bag["CartDetails"]) {
                let index = bag["CartDetails"].findIndex((object) => {
                  return object["ProductId"] === SwatchId;
                });
                if (index !== -1) {
                  HasSwatchId = true;
                  swatchDetailId = bag["CartDetails"][index]["CartDetailId"];
                }
              }
            } else {
              if (temp?.length > 0) {
                index = temp.findIndex((object) => {
                  return object["SwatchId"] === SwatchId;
                });
                if (index !== -1) {
                  HasSwatchId = true;
                }
              }
            }

            let pushIndex = 0;
            if (fabricOrderSelected !== -1 && !fabric[fabricOrderSelected]) {
              pushIndex = fabricOrderSelected;
            } else if (fabricOrderSelected !== -1 && fabric[fabricOrderSelected]) {
              fabric[fabric.length] = fabric[fabricOrderSelected];
              pushIndex = fabricOrderSelected;
            } else {
              pushIndex = fabric.length;
            }
            if (`${FabricId}` === step2) {
              designSelected = true;
              designSelectedIndex = pushIndex;
            }

            fabric[pushIndex] = (
              <div
                className={`radio_group ${pageLanguage1 === "fa" ? "font_farsi" : "font_en"}`}
                key={"fabric" + key + j}
              >
                <label
                  data-tip={`${pageLanguage1 === "en" ? DesignEnName : DesignName}: ${
                    pageLanguage1 === "en" ? ColorEnName : ColorName
                  }`}
                  data-for={"fabric" + key + j}
                  className={`radio_container ${pageLanguage1 === "fa" ? "font_farsi" : "font_en"}`}
                  data-img={`https://www.doopsalta.com/upload/${PhotoPath}`}
                >
                  <input
                    className="radio"
                    type="radio"
                    ref-num="3"
                    default-fabric-photo={FabricOnModelPhotoUrl}
                    onChange={(e) => {
                      let temp = JSON.parse(JSON.stringify(fabricSelected2));
                      temp.selectedFabricId = FabricId;
                      temp.selectedTextEn = DesignEnName;
                      temp.selectedTextFa = DesignName;
                      temp.selectedDesignCode = DesignCode;
                      temp.selectedColorEn = ColorEnName;
                      temp.selectedColorFa = ColorName;
                      temp.selectedLeadRequired = LeadRequired;
                      temp.selectedPhoto = FabricOnModelPhotoUrl;
                      temp.selectedPhoto2 = PhotoPath2;
                      temp.FabricWidth = FabricWidth;
                      temp.SewingDirection = SewingDirection;
                      setFabricSelected2(temp);
                    }}
                    name="fabric2"
                    model-id={modelID}
                    value={FabricId}
                    text-en={DesignEnName}
                    text-fa={DesignName}
                    checked={`${FabricId}` === step2}
                    ref={(ref) => (inputs.current[`15${FabricId}`] = ref)}
                  />
                  <div className="frame_img">
                    <img
                      className={`img-fluid  ${`${FabricId}` === step2 ? "img-fluid_checked" : ""}`}
                      src={imgUrl(PhotoPath2)}
                      alt=""
                    />
                  </div>
                </label>
                <div
                  className={`fabric_name_container ${
                    pageLanguage1 === "fa" ? "font_farsi" : "font_en"
                  }`}
                >
                  <h1>{pageLanguage1 === "en" ? CapitalizeAllWords(ColorEnName) : ColorName}</h1>
                  <span
                    onClick={() => {
                      handleShow(fabrics[key][j], swatchDetailId);
                      setHasSwatchId(HasSwatchId);
                    }}
                  >
                    <i className="fa fa-search" aria-hidden="true" />
                  </span>
                </div>
                <button
                  className={`swatchButton ${HasSwatchId ? "activeSwatch" : ""} ${
                    pageLanguage1 === "fa" ? "font_farsi" : "font_en"
                  }`}
                  current-state={HasSwatchId ? "1" : "0"}
                  onClick={(e) => {
                    fabricSwatch(e, SwatchId, swatchDetailId, PhotoPath);
                  }}
                  disabled={SwatchId === -1}
                >
                  {HasSwatchId
                    ? pageLanguage1 === "en"
                      ? "SWATCH IN BAG"
                      : "نمونه در سبد"
                    : pageLanguage1 === "en"
                    ? "ORDER" + " SWATCH"
                    : "سفارش نمونه"}
                </button>
              </div>
            );
            pushIndex = fabric.length;
            fabric1.push(
              <li className="fabric_design_border_list_item" key={"border" + key + j}>
                <OverlayContainer
                  classNames="Accessories_List_item_color"
                  placement="middle"
                  children={
                    <div
                      className={`radio_group ${pageLanguage1 === "fa" ? "font_farsi" : "font_en"}`}
                    >
                      <label>
                        <input
                          className="radio"
                          type="radio"
                          outline="true"
                          onChange={(e) => {
                            let temp = JSON.parse(JSON.stringify(borderSelected2));
                            temp.selectedFabricId = FabricId;
                            temp.selectedTextEn = DesignEnName;
                            temp.selectedTextFa = DesignName;
                            temp.selectedDesignCode = DesignCode;
                            temp.selectedColorEn = ColorEnName;
                            temp.selectedColorFa = ColorName;
                            setBorderSelected2(temp);
                          }}
                          name="border-trim"
                          model-id={modelID}
                          value={FabricId}
                          checked={`${FabricId}` === step2Border}
                          ref={(ref) => (inputs.current[`border-trim${FabricId}`] = ref)}
                        />
                        <div className="frame_img">
                          <img
                            className={`img-fluid ${
                              `${FabricId}` === step2Border ? "img-fluid_checked" : ""
                            }`}
                            src={imgUrl(PhotoPath)}
                            alt=""
                          />
                        </div>
                      </label>
                    </div>
                  }
                  component={
                    <div className="Accessories_List_item_color_container">
                      <p className="Accessories_List_item_color_text 5">
                        {pageLanguage1 === "en" ? ColorEnName : ColorName}
                      </p>
                    </div>
                  }
                />
              </li>
            );
            resolve();
          });
        }
        Promise.all(promiseArr2).then(() => {
          if (designSelected) {
            if (isBoard) {
              let newPushIndex = Math.ceil((designSelectedIndex + 1) / 4) * 4;
              fabric.splice(
                newPushIndex,
                0,
                <div key={"board"} className="grommet_fabric_board_container">
                  <div className="card-body-display-flex">
                    <span className="checkbox_text">{t("fabricHasLine2")}</span>
                  </div>
                </div>
              );
            }
          }
          let pushIndex = 0;
          if (designOrderSelected !== -1 && !fabricList[designOrderSelected]) {
            pushIndex = designOrderSelected;
          } else if (designOrderSelected !== -1 && fabricList[designOrderSelected]) {
            fabricList[fabricList.length] = fabricList[designOrderSelected];
            pushIndex = designOrderSelected;
          } else {
            let index = fabricList.findIndex(Object.is.bind(null, undefined));
            pushIndex = index === -1 ? fabricList.length : index;
          }

          fabricList[pushIndex] = (
            <React.Fragment key={"fabric" + key}>
              <div
                className={`material_detail ${pageLanguage1 === "fa" ? "font_farsi" : "font_en"}`}
              >
                <div
                  className={`material_traits ${pageLanguage1 === "fa" ? "font_farsi" : "font_en"}`}
                >
                  <hr />
                  <span>
                    <p>
                      {pageLanguage1 === "en" ? "DESIGN NAME" : "نام طرح"}:{" "}
                      {pageLanguage1 === "en" ? DesignEnName : DesignName}
                    </p>
                    <span className="fabric_seperator">&nbsp;|&nbsp;</span>
                    <p>
                      {pageLanguage1 === "en" ? "FROM" : "قیمت از"}:{" "}
                      {GetPrice(
                        SamplePrice,
                        pageLanguage1,
                        pageLanguage1 === "en" ? "Tomans" : "تومان",
                        isTabletOrMobile
                      )}
                    </p>
                  </span>
                </div>
                {fabric}
              </div>
              {LeadRequired && (
                <div className="fabric_design_checkbox_container width_max checkbox_style checkbox_style_inline 1">
                  <span className="checkbox_text">
                    {pageLanguage1 === "en"
                      ? "Lead weight comes standard with this design."
                      : "این مدل تور به طور پیش فرض با وزنه سربی ارسال می شود."}
                  </span>
                </div>
              )}
              {LeadRequired === null && (
                <div
                  className={
                    step2Check2 === `${DesignCode}`
                      ? "fabric_design_checkbox_container width_max checkbox_style checkbox_style_inline 2 active"
                      : "fabric_design_checkbox_container width_max checkbox_style checkbox_style_inline 3"
                  }
                >
                  <input
                    type="checkbox"
                    name="step1Check"
                    checked={step2Check2 === `${DesignCode}`}
                    onChange={(e) => {
                      if (
                        step2 !== "" &&
                        fabrics[DesignEnName].some((obj) => obj["FabricId"] === step2)
                      ) {
                        if (e.target.checked) {
                          setStep2Check2(`${DesignCode}`);
                        } else {
                          setStep2Check2("");
                        }
                      } else {
                        setStep2Check2("");
                        modalHandleShow("FabricDesignNotSelected");
                      }
                    }}
                    id={`${DesignCode + 21}`}
                    ref={(ref) => (inputs.current[`trim-${DesignCode}`] = ref)}
                  />
                  <label htmlFor={`${DesignCode + 21}`} className="checkbox_label">
                    <img
                      className="checkbox_label_img checkmark1 img-fluid"
                      src={require("../Images/public/checkmark1_checkbox.png")}
                      alt=""
                    />
                    <span className="checkbox_text">
                      {pageLanguage1 === "en" ? "Add A Lead Weight" : "وزنه سربی اضافه کنید."}
                    </span>
                  </label>
                </div>
              )}
              {(HasTrim || HasBorder) && (
                <div
                  className={
                    step2Check === `${DesignCode}`
                      ? "fabric_design_checkbox_container width_max checkbox_style checkbox_style_inline 4 active"
                      : "fabric_design_checkbox_container width_max checkbox_style checkbox_style_inline 5"
                  }
                >
                  <input
                    type="checkbox"
                    name="step1Check"
                    checked={step2Check === `${DesignCode}`}
                    onChange={(e) => {
                      if (
                        step2 !== "" &&
                        fabrics[DesignEnName].some((obj) => obj["FabricId"] === step2)
                      ) {
                        if (e.target.checked) {
                          setStep2Check(`${DesignCode}`);
                          setTimeout(() => {
                            if (fabricsContainerRef4.current) {
                              fabricsContainerRef4.current.scrollBy({
                                top: 300,
                                behavior: "smooth",
                              });
                            }
                          }, 400);
                        } else {
                          setStep2Check("");
                        }
                      } else {
                        setStep2Check("");
                        modalHandleShow("FabricDesignNotSelected");
                      }
                    }}
                    id={`${DesignCode + 31}`}
                    ref={(ref) => (inputs.current[`trim-${DesignCode}`] = ref)}
                  />
                  <label htmlFor={`${DesignCode + 31}`} className="checkbox_label">
                    <img
                      className="checkbox_label_img checkmark1 img-fluid"
                      src={require("../Images/public/checkmark1_checkbox.png")}
                      alt=""
                    />
                    <span className="checkbox_text">
                      {HasTrim && HasBorder
                        ? pageLanguage1 === "en"
                          ? "Add A Decorative Border / Trim"
                          : "یک حاشیه / نوار تزئینی اضافه کنید"
                        : HasTrim
                        ? pageLanguage1 === "en"
                          ? "Add A Trim"
                          : "یک نوار اضافه کنید"
                        : HasBorder
                        ? pageLanguage1 === "en"
                          ? "Add A Decorative Border"
                          : "اضافه کردن حاشیه/ نوار تزئینی"
                        : ""}
                    </span>
                  </label>
                </div>
              )}
              <div
                className={
                  step2Check === `${DesignCode}`
                    ? "fabric_design_trim_border_container active"
                    : "fabric_design_trim_border_container"
                }
              >
                <div>
                  <h1 className="fabric_design_trim_border_title">
                    {HasTrim && HasBorder
                      ? pageLanguage1 === "en"
                        ? "Select Your Decorative Border / Trim Material"
                        : ""
                      : HasTrim
                      ? pageLanguage1 === "en"
                        ? "Select Your Trim Material"
                        : ""
                      : HasBorder
                      ? pageLanguage1 === "en"
                        ? "Select Your Decorative Border"
                        : ""
                      : ""}
                  </h1>
                  {HasBorder && (
                    <div className="fabric_design_border_container">
                      <h2 className="fabric_design_trim_border_title2">
                        {pageLanguage1 === "en" ? "DECORATIVE BORDER" : "حاشیه تزئینی"}:{" "}
                        {pageLanguage1 === "en" ? DesignEnName : DesignName}
                      </h2>
                      <ul className="fabric_design_border_list">{fabric1}</ul>
                      {step2Border !== "" && (
                        <div className="fabric_design_border_checkbox_container">
                          <h3 className="fabric_design_trim_border_title3">
                            {pageLanguage1 === "en"
                              ? "Select A Border Position:"
                              : "حاشیه کجای پرده دوخته شود؟"}
                          </h3>
                          <div className="box100 radio_style">
                            <input
                              className={
                                step2BorderRadio === "10cm Leading Edge"
                                  ? "radio radio_checked"
                                  : "radio"
                              }
                              type="radio"
                              text={t("10cm Leading Edge")}
                              value="1"
                              name="step2bordercheck"
                              id="border41"
                              checked={step2BorderRadio === "10cm Leading Edge"}
                              onChange={(e) => {
                                setStep2BorderRadio("10cm Leading Edge");
                              }}
                              ref={(ref) => (inputs.current["border4"] = ref)}
                            />
                            <label htmlFor="border41">
                              {i18n.language === "fa"
                                ? "حاشیه ۱۰ س\u200Cم در کناره ها"
                                : "10cm Leading Edge"}
                            </label>
                          </div>
                          <div className="box100 radio_style">
                            <input
                              className={
                                step2BorderRadio === "60cm Bottom Border"
                                  ? "radio radio_checked"
                                  : "radio"
                              }
                              type="radio"
                              text={t("60cm bottom border")}
                              value="2"
                              name="step2bordercheck"
                              id="border51"
                              checked={step2BorderRadio === "60cm Bottom Border"}
                              onChange={(e) => {
                                setStep2BorderRadio("60cm Bottom Border");
                              }}
                              ref={(ref) => (inputs.current["border5"] = ref)}
                            />
                            <label htmlFor="border51">
                              {i18n.language === "fa" ? "حاشیه ۶۰ س‌م پایین" : "60cm Bottom Border"}
                            </label>
                          </div>
                          <div className="box100 radio_style">
                            <input
                              className={
                                step2BorderRadio === "10cm Leading Edge & 60cm Bottom Border"
                                  ? "radio radio_checked"
                                  : "radio"
                              }
                              type="radio"
                              text={t("10cm Leading Edge & 60cm Bottom Border")}
                              value="3"
                              name="step2bordercheck"
                              id="border61"
                              checked={
                                step2BorderRadio === "10cm Leading Edge & 60cm Bottom Border"
                              }
                              onChange={(e) => {
                                setStep2BorderRadio("10cm Leading Edge & 60cm Bottom Border");
                              }}
                              ref={(ref) => (inputs.current["border6"] = ref)}
                            />
                            <label htmlFor="border61">
                              {t("10cm Leading Edge & 60cm Bottom Border")}
                            </label>
                          </div>
                        </div>
                      )}
                    </div>
                  )}
                  {HasTrim && (
                    <>
                      {Object.keys(trimAccessories).map((key, index) => {
                        return (
                          <div className="fabric_design_border_container" key={"trim" + key}>
                            <h2 className="fabric_design_trim_border_title2">
                              {pageLanguage1 === "en" ? "DECORATIVE TRIM" : "نوار تزئینی"}:{" "}
                              {pageLanguage1 === "en"
                                ? Uppercase(trimAccessories[key][0]["DesignENName"])
                                : convertToPersian(trimAccessories[key][0]["DesignName"])}
                            </h2>
                            <ul className="fabric_design_border_list">
                              {trimAccessories[key].map((el, i) => {
                                let FabricId = el["DetailId"];
                                let DesignName = convertToPersian(el["DesignName"]);
                                let DesignEnName = el["DesignENName"];
                                let ColorName = convertToPersian(el["ColorName"]);
                                let ColorEnName = el["ColorENName"];
                                let PhotoPath = "";
                                el["Photos"].forEach((obj) => {
                                  if (obj.PhotoTypeId === 4702) PhotoPath = obj.PhotoUrl;
                                });
                                return (
                                  <li
                                    className="fabric_design_border_list_item"
                                    key={"trim" + key + i}
                                  >
                                    <OverlayContainer
                                      classNames="Accessories_List_item_color"
                                      placement="middle"
                                      children={
                                        <div
                                          className={`radio_group ${
                                            pageLanguage1 === "fa" ? "font_farsi" : "font_en"
                                          }`}
                                        >
                                          <label>
                                            <input
                                              className="radio"
                                              type="radio"
                                              outline="true"
                                              onChange={(e) => {
                                                let temp = JSON.parse(
                                                  JSON.stringify(trimSelected2)
                                                );
                                                temp.selectedFabricId = FabricId;
                                                temp.selectedTextEn = DesignEnName;
                                                temp.selectedTextFa = DesignName;
                                                temp.selectedDesignCode = DesignCode;
                                                temp.selectedColorEn = ColorEnName;
                                                temp.selectedColorFa = ColorName;
                                                setTrimSelected2(temp);
                                              }}
                                              name="border-trim"
                                              model-id={modelID}
                                              value={FabricId}
                                              checked={`${FabricId}` === step2Trim}
                                              ref={(ref) =>
                                                (inputs.current[`border-trim${FabricId}`] = ref)
                                              }
                                            />
                                            <div className="frame_img">
                                              <img
                                                className={`img-fluid ${
                                                  `${FabricId}` === step2Trim
                                                    ? "img-fluid_checked"
                                                    : ""
                                                }`}
                                                src={imgUrl(PhotoPath)}
                                                alt=""
                                              />
                                            </div>
                                          </label>
                                        </div>
                                      }
                                      component={
                                        <div className="Accessories_List_item_color_container">
                                          <p className="Accessories_List_item_color_text 6">
                                            {pageLanguage1 === "en" ? ColorEnName : ColorName}
                                          </p>
                                        </div>
                                      }
                                    />
                                  </li>
                                );
                              })}
                            </ul>
                          </div>
                        );
                      })}
                    </>
                  )}
                </div>
              </div>
            </React.Fragment>
          );
          resolve();
        });
      });
    });
    Promise.all(promiseArr).then(() => {
      if (limitedFabrics !== undefined) {
      } else {
        setFabricsList22(fabricList);
      }
    });
  }

  function renderSheers(bag) {
    const fabricList = [];
    let cartObj = {};
    let temp = [];

    let pageLanguage1 = location.pathname
      .split("")
      .slice(1, 3)
      .join("");
    if (Object.keys(bag).length > 0) {
      if (isLoggedIn) {
      } else {
        cartObj = JSON.parse(localStorage.getItem("cart"));
        temp = cartObj["swatches"];
      }
    }

    Object.keys(sheers).forEach((key, index) => {
      let fabrics = sheers;
      let DesignName = convertToPersian(fabrics[key][0]["DesignName"]);
      let DesignEnName = fabrics[key][0]["DesignEnName"];
      let SamplePrice = fabrics[key][0]["SamplePrice"];

      const fabric = [];
      for (let j = 0; j < fabrics[key].length; j++) {
        let FabricId = fabrics[key][j].FabricId;
        let PhotoPath = "";
        let PhotoPath2 = "";
        fabrics[key][j].FabricPhotos.forEach((obj) => {
          if (obj.PhotoTypeId === 4702) PhotoPath = obj.PhotoUrl;
          if (obj.PhotoTypeId === 4709) PhotoPath2 = obj.PhotoUrl;
        });

        let FabricOnModelPhotoUrl = fabrics[key][j].FabricOnModelPhotoUrl;
        let HasTrim = fabrics[key][j].HasTrim;
        let ColorName = convertToPersian(fabrics[key][j].ColorName);
        let ColorEnName = fabrics[key][j].ColorEnName;
        let SwatchId = fabrics[key][j].SwatchId ? fabrics[key][j].SwatchId : -1;
        let HasSwatchId = false;
        let swatchDetailId = undefined;
        let index = -1;
        if (isLoggedIn) {
          if (bag["CartDetails"]) {
            let index = bag["CartDetails"].findIndex((object) => {
              return object["ProductId"] === SwatchId;
            });
            if (index !== -1) {
              HasSwatchId = true;
              swatchDetailId = bag["CartDetails"][index]["CartDetailId"];
            }
          }
        } else {
          if (temp?.length > 0) {
            index = temp.findIndex((object) => {
              return object["SwatchId"] === SwatchId;
            });
            if (index !== -1) {
              HasSwatchId = true;
            }
          }
        }
        fabric.push(
          <div
            className={`radio_group ${pageLanguage1 === "fa" ? "font_farsi" : "font_en"}`}
            key={"fabric" + key + j}
          >
            <label
              data-tip={`${pageLanguage1 === "en" ? DesignEnName : DesignName}: ${
                pageLanguage1 === "en" ? ColorEnName : ColorName
              }`}
              data-for={"fabric" + key + j}
              className={`radio_container ${pageLanguage1 === "fa" ? "font_farsi" : "font_en"}`}
              data-img={`https://www.doopsalta.com/upload/${PhotoPath}`}
            >
              {/*<ReactTooltip id={"fabric" + key + j} place="top" type="light" effect="float"/>*/}
              <input
                className="radio"
                type="radio"
                ref-num="2"
                default-fabric-photo={FabricOnModelPhotoUrl}
                onChange={(e) => {
                  let temp = JSON.parse(JSON.stringify(sheersSelected));
                  temp.selectedFabricId = FabricId;
                  temp.selectedTextEn = DesignEnName;
                  temp.selectedTextFa = DesignName;
                  temp.selectedColorEn = ColorEnName;
                  temp.selectedColorFa = ColorName;
                  temp.selectedHasTrim = HasTrim;
                  temp.selectedPhoto = FabricOnModelPhotoUrl;
                  setSheersSelected(temp);
                }}
                name="fabric"
                model-id={modelID}
                value={FabricId}
                text-en={DesignEnName}
                text-fa={DesignName}
                checked={`${FabricId}` === step2B1}
                ref={(ref) => (inputs.current[`1${FabricId}`] = ref)}
              />
              <div className="frame_img">
                <img
                  className={`img-fluid ${`${FabricId}` === step2B1 ? "img-fluid_checked" : ""}`}
                  src={imgUrl(PhotoPath2)}
                  alt=""
                />
              </div>
            </label>
            <div
              className={`fabric_name_container ${
                pageLanguage1 === "fa" ? "font_farsi" : "font_en"
              }`}
            >
              <h1>{pageLanguage1 === "en" ? CapitalizeAllWords(ColorEnName) : ColorName}</h1>
              <span
                onClick={() => {
                  handleShow(fabrics[key][j], swatchDetailId);
                  setHasSwatchId(HasSwatchId);
                }}
              >
                <i className="fa fa-search" aria-hidden="true" />
              </span>
            </div>
            <button
              className={`swatchButton ${HasSwatchId ? "activeSwatch" : ""} ${
                pageLanguage1 === "fa" ? "font_farsi" : "font_en"
              }`}
              current-state={HasSwatchId ? "1" : "0"}
              onClick={(e) => {
                fabricSwatch(e, SwatchId, swatchDetailId, PhotoPath);
              }}
              disabled={SwatchId === -1}
            >
              {HasSwatchId
                ? pageLanguage1 === "en"
                  ? "SWATCH IN BAG"
                  : "نمونه در سبد"
                : pageLanguage1 === "en"
                ? "ORDER" + " SWATCH"
                : "سفارش نمونه"}
            </button>
          </div>
        );
      }

      fabricList.push(
        <div
          className={`material_detail  ${pageLanguage1 === "fa" ? "font_farsi" : "font_en"}`}
          key={"fabric" + key}
        >
          <div className={`material_traits ${pageLanguage1 === "fa" ? "font_farsi" : "font_en"}`}>
            <hr />
            <span>
              <p>
                {pageLanguage1 === "en" ? "DESIGN NAME" : "نام طرح"}:{" "}
                {pageLanguage1 === "en" ? DesignEnName : DesignName}
              </p>
              <span className="fabric_seperator">&nbsp;|&nbsp;</span>
              <p>
                {pageLanguage1 === "en" ? "FROM" : "قیمت از"}:{" "}
                {GetPrice(
                  SamplePrice,
                  pageLanguage1,
                  pageLanguage1 === "en" ? "Tomans" : "تومان",
                  isTabletOrMobile
                )}
              </p>
            </span>
          </div>
          {fabric}
        </div>
      );
    });
    setSheersList(fabricList);
  }
  function renderSheers2(bag) {
    const fabricList = [];
    let cartObj = {};
    let temp = [];
    let pageLanguage1 = location.pathname
      .split("")
      .slice(1, 3)
      .join("");
    if (Object.keys(bag).length > 0) {
      if (isLoggedIn) {
      } else {
        cartObj = JSON.parse(localStorage.getItem("cart"));
        temp = cartObj["swatches"];
      }
    }

    Object.keys(sheers2).forEach((key, index) => {
      let fabrics = sheers2;
      let DesignName = convertToPersian(fabrics[key][0]["DesignName"]);
      let DesignEnName = fabrics[key][0]["DesignEnName"];
      let SamplePrice = fabrics[key][0]["SamplePrice"];

      const fabric = [];
      for (let j = 0; j < fabrics[key].length; j++) {
        let FabricId = fabrics[key][j].FabricId;
        let PhotoPath = "";
        let PhotoPath2 = "";
        fabrics[key][j].FabricPhotos.forEach((obj) => {
          if (obj.PhotoTypeId === 4702) PhotoPath = obj.PhotoUrl;
          if (obj.PhotoTypeId === 4709) PhotoPath2 = obj.PhotoUrl;
        });

        let FabricOnModelPhotoUrl = fabrics[key][j].FabricOnModelPhotoUrl;
        let HasTrim = fabrics[key][j].HasTrim;
        let ColorName = convertToPersian(fabrics[key][j].ColorName);
        let ColorEnName = fabrics[key][j].ColorEnName;
        let SwatchId = fabrics[key][j].SwatchId ? fabrics[key][j].SwatchId : -1;
        let HasSwatchId = false;
        let swatchDetailId = undefined;
        let index = -1;
        if (isLoggedIn) {
          if (bag["CartDetails"]) {
            let index = bag["CartDetails"].findIndex((object) => {
              return object["ProductId"] === SwatchId;
            });
            if (index !== -1) {
              HasSwatchId = true;
              swatchDetailId = bag["CartDetails"][index]["CartDetailId"];
            }
          }
        } else {
          if (temp?.length > 0) {
            index = temp.findIndex((object) => {
              return object["SwatchId"] === SwatchId;
            });
            if (index !== -1) {
              HasSwatchId = true;
            }
          }
        }

        fabric.push(
          <div
            className={`radio_group ${pageLanguage1 === "fa" ? "font_farsi" : "font_en"}`}
            key={"fabric" + key + j}
          >
            <label
              data-tip={`${pageLanguage1 === "en" ? DesignEnName : DesignName}: ${
                pageLanguage1 === "en" ? ColorEnName : ColorName
              }`}
              data-for={"fabric" + key + j}
              className={`radio_container ${pageLanguage1 === "fa" ? "font_farsi" : "font_en"}`}
              data-img={`https://www.doopsalta.com/upload/${PhotoPath}`}
            >
              <input
                className="radio"
                type="radio"
                ref-num="3"
                default-fabric-photo={FabricOnModelPhotoUrl}
                onChange={(e) => {
                  let temp = JSON.parse(JSON.stringify(sheersSelected2));
                  temp.selectedFabricId = FabricId;
                  temp.selectedTextEn = DesignEnName;
                  temp.selectedTextFa = DesignName;
                  temp.selectedColorEn = ColorEnName;
                  temp.selectedColorFa = ColorName;
                  temp.selectedHasTrim = HasTrim;
                  temp.selectedPhoto = FabricOnModelPhotoUrl;
                  setSheersSelected2(temp);
                }}
                name="fabric2"
                model-id={modelID}
                value={FabricId}
                text-en={DesignEnName}
                text-fa={DesignName}
                checked={`${FabricId}` === step2B1}
                ref={(ref) => (inputs.current[`15${FabricId}`] = ref)}
              />
              <div className="frame_img">
                <img
                  className={`img-fluid ${`${FabricId}` === step2B1 ? "img-fluid_checked" : ""}`}
                  src={imgUrl(PhotoPath2)}
                  alt=""
                />
              </div>
            </label>
            <div
              className={`fabric_name_container ${
                pageLanguage1 === "fa" ? "font_farsi" : "font_en"
              }`}
            >
              <h1>{pageLanguage1 === "en" ? CapitalizeAllWords(ColorEnName) : ColorName}</h1>
              <span
                onClick={() => {
                  handleShow(fabrics[key][j], swatchDetailId);
                  setHasSwatchId(HasSwatchId);
                }}
              >
                <i className="fa fa-search" aria-hidden="true" />
              </span>
            </div>
            <button
              className={`swatchButton ${HasSwatchId ? "activeSwatch" : ""} ${
                pageLanguage1 === "fa" ? "font_farsi" : "font_en"
              }`}
              current-state={HasSwatchId ? "1" : "0"}
              onClick={(e) => {
                fabricSwatch(e, SwatchId, swatchDetailId, PhotoPath);
              }}
              disabled={SwatchId === -1}
            >
              {HasSwatchId
                ? pageLanguage1 === "en"
                  ? "SWATCH IN BAG"
                  : "نمونه در سبد"
                : pageLanguage1 === "en"
                ? "ORDER" + " SWATCH"
                : "سفارش نمونه"}
            </button>
          </div>
        );
      }

      fabricList.push(
        <div
          className={`material_detail  ${pageLanguage1 === "fa" ? "font_farsi" : "font_en"}`}
          key={"fabric" + key}
        >
          <div className={`material_traits ${pageLanguage1 === "fa" ? "font_farsi" : "font_en"}`}>
            <hr />
            <span>
              <p>
                {pageLanguage1 === "en" ? "DESIGN NAME" : "نام طرح"}:{" "}
                {pageLanguage1 === "en" ? DesignEnName : DesignName}
              </p>
              <span className="fabric_seperator">&nbsp;|&nbsp;</span>
              <p>
                {pageLanguage1 === "en" ? "FROM" : "قیمت از"}:{" "}
                {GetPrice(
                  SamplePrice,
                  pageLanguage1,
                  pageLanguage1 === "en" ? "Tomans" : "تومان",
                  isTabletOrMobile
                )}
              </p>
            </span>
          </div>
          {fabric}
        </div>
      );
    });
    setSheersList2(fabricList);
  }

  const [activeAccessoryColors, setActiveAccessoryColors] = useState({});

  const handleSelectAccessoryColor = (designKey, detailId) => {
    setActiveAccessoryColors((prev) => ({
      ...prev,
      [designKey]: detailId,
    }));
  };

  // Match saved accessory value against API color fields (DetailId or SewingAccessoryDetailId)
  const accessoryValueMatches = (el, savedValue) =>
    `${el?.DetailId}` === `${savedValue}` || `${el?.SewingAccessoryDetailId}` === `${savedValue}`;

  const findAccessoryColor = (colors, acc) => {
    if (!colors?.length || !acc) return undefined;
    const savedValue =
      acc["SewingAccessoryValue"] || acc["SewingAccessoryDetailId"] || acc["DetailId"];
    const byId = colors.find((el) => accessoryValueMatches(el, savedValue));
    if (byId) return byId;
    return colors.find(
      (el) =>
        (acc["DesignNameFa"] &&
          el["DesignName"] === acc["DesignNameFa"] &&
          el["ColorName"] === (acc["ColorNameFa"] || acc["ColorName"])) ||
        (acc["DesignNameEn"] &&
          el["DesignENName"] === acc["DesignNameEn"] &&
          el["ColorENName"] === (acc["ColorNameEn"] || acc["ColorENName"])) ||
        (acc["DesignName"] &&
          el["DesignName"] === acc["DesignName"] &&
          el["ColorName"] === acc["ColorName"])
    );
  };

  function normalizeSavedAccessory(obj) {
    if (!obj) return obj;
    return {
      ...obj,
      SewingAccessoryValue:
        obj["SewingAccessoryValue"] || obj["SewingAccessoryDetailId"] || obj["DetailId"],
      Qty: obj["Qty"] || obj["Quantity"] || obj["qty"],
      DesignNameFa: obj["DesignNameFa"] || obj["DesignName"],
      DesignNameEn: obj["DesignNameEn"] || obj["DesignENName"],
      ColorNameFa: obj["ColorNameFa"] || obj["ColorName"],
      ColorNameEn: obj["ColorNameEn"] || obj["ColorENName"],
    };
  }

  function getSavedAccessoriesList(source) {
    if (!source) return [];
    const candidates = [
      source["Accessories"],
      source["SewingOrderDetails"] && source["SewingOrderDetails"][0]
        ? source["SewingOrderDetails"][0]["Accessories"]
        : undefined,
      source["PreorderText"] && source["PreorderText"]["Accessories"],
    ];
    const list = candidates.find((arr) => Array.isArray(arr) && arr.length) || [];
    return list
      .filter(Boolean)
      .map(normalizeSavedAccessory)
      .filter((obj) => obj && obj["Qty"]);
  }

  function buildAccessoriesHeaderText(source) {
    const tempText = [];
    if (!source) return tempText;
    const draperyQty = Array.isArray(source["HandCurtainNum"])
      ? +source["HandCurtainNum"][0]
      : +source["HandCurtainNum"] || 0;
    if (draperyQty > 0) {
      tempText.push(
        `${pageLanguage === "en" ? "Matching Drapery Tieback" : "کمرپرده پارچه ای"} ${NumToFa(
          draperyQty,
          pageLanguage
        )}`
      );
    }
    const sheerQty = Array.isArray(source["HandCurtainNum2"])
      ? +source["HandCurtainNum2"][0]
      : +source["HandCurtainNum2"] || 0;
    if (sheerQty > 0) {
      tempText.push(
        `${pageLanguage === "en" ? "Matching Sheer Tieback" : "کمرپرده توری"} ${NumToFa(
          sheerQty,
          pageLanguage
        )}`
      );
    }
    getSavedAccessoriesList(source).forEach((obj) => {
      const name = pageLanguage === "en" ? obj["DesignNameEn"] : obj["DesignNameFa"];
      const color = pageLanguage === "en" ? obj["ColorNameEn"] : obj["ColorNameFa"];
      const qty = obj["Qty"];
      if (!name || !qty) return;
      const colorText = color ? (pageLanguage === "en" ? capitalizeWordsText(color) : color) : "";
      tempText.push(
        `${name}${colorText ? " / " + colorText : ""} ${
          pageLanguage === "en" ? `x${qty}` : NumberToPersianWord.convertEnToPe(`${qty}x`)
        }`
      );
    });
    return tempText;
  }

  function renderStepAccessories() {
    const tempList = [];
    let pageLanguage1 = location.pathname
      .split("")
      .slice(1, 3)
      .join("");
    let temp2 = JSON.parse(JSON.stringify(customAccActive));
    let params =
      parameters === undefined ||
      parameters === null ||
      parameters === "undefined" ||
      parameters === "null" ||
      parameters === ""
        ? "{}"
        : JSON.parse(JSON.stringify(parameters));

    let promiseArr = [];
    Object.keys(stepAccessories).forEach((key, index) => {
      promiseArr[index] = new Promise((resolve, reject) => {
        let temp = [];
        let PhotoPath = "";
        let DesignENName = stepAccessories[key][0]["DesignENName"];
        let DesignName = stepAccessories[key][0]["DesignName"];
        let promiseArr2 = [];
        stepAccessories[key].forEach((obj, index) => {
          const detailId = obj["DetailId"];
          if (
            obj["DetailId"] &&
            obj["DetailId"] !== "" &&
            obj["SewingAccessoryDetailId"] &&
            obj["SewingAccessoryId"] &&
            obj["ColorHtmlCode"]
          ) {
            promiseArr2[index] = new Promise((resolve, reject) => {
              let tempColor = obj["ColorHtmlCode"] !== "" ? obj["ColorHtmlCode"] : "#e2e2e2";
              let ColorENName = obj["ColorENName"];
              let ColorName = obj["ColorName"];
              let DetailId = obj["DetailId"];
              let SewingModelAccessoryId = obj["SewingModelAccessoryId"];
              let SewingAccessoryId = obj["SewingAccessoryId"];
              let colorSelected = !!(
                temp2[key] && `${temp2[key]["SewingAccessoryValue"]}` === `${DetailId}`
              );
              if (colorSelected) {
                if (obj["Photos"] && obj["Photos"].length)
                  obj["Photos"].forEach((obj) => {
                    if (obj["PhotoTypeId"] === 4702) PhotoPath = obj["PhotoUrl"];
                  });
              }
              let fabricOrderSelected =
                params["AccColors"] &&
                params["AccColors"][DetailId] &&
                (params["AccColors"][DetailId]["order"] ||
                  params["AccColors"][DetailId]["order"] === 0)
                  ? params["AccColors"][DetailId]["order"]
                  : -1;

              let pushIndex = 0;
              if (fabricOrderSelected !== -1 && !temp[fabricOrderSelected]) {
                pushIndex = fabricOrderSelected;
              } else if (fabricOrderSelected !== -1 && temp[fabricOrderSelected]) {
                temp[temp.length] = JSON.parse(JSON.stringify(temp[fabricOrderSelected]));
                pushIndex = fabricOrderSelected;
              } else {
                pushIndex = temp.length;
              }

              temp[pushIndex] = (
                <li
                  className={
                    `${activeAccessoryColors[key]}` === `${detailId}`
                      ? "Accessories_List_item_colors_list_item_overlay_active"
                      : colorSelected
                      ? "Accessories_List_item_colors_list_item colorSelected"
                      : "Accessories_List_item_colors_list_item"
                  }
                  key={index}
                  onClick={() => {
                    handleSelectAccessoryColor(key, detailId);
                    setAccessoriesDesign({
                      isPlus: undefined,
                      SewingAccessoryValue: DetailId,
                      SewingAccessoryId: SewingAccessoryId,
                      SewingModelAccessoryId: SewingModelAccessoryId,
                      DesignCode: key,
                      DesignNameEn: DesignENName,
                      DesignNameFa: DesignName,
                      ColorNameEn: ColorENName,
                      ColorNameFa: ColorName,
                      qty: undefined,
                    });
                  }}
                >
                  <OverlayContainer
                    classNames="Accessories_List_item_color"
                    placement="middle"
                    children={
                      <div
                        className="Accessories_List_item_colors_list_item_overlay"
                        style={{ backgroundColor: tempColor }}
                        onClick={() => {
                          setSelectedColor(DetailId);
                        }}
                      />
                    }
                    component={
                      <div className="Accessories_List_item_color_container">
                        <p className="Accessories_List_item_color_text 7">
                          {pageLanguage1 === "en" ? capitalizeWordsText(ColorENName) : ColorName}
                        </p>
                      </div>
                    }
                  />
                </li>
              );
              resolve();
            });
          } else if (obj["Photos"] && obj["Photos"].length) {
            obj["Photos"].forEach((obj) => {
              if (obj["PhotoTypeId"] === 4702) PhotoPath = obj["PhotoUrl"];
            });
          }
        });

        Promise.all(promiseArr2).then(() => {
          let obj = stepAccessories[key][0];
          let DesignCode = key;
          let DetailId = temp2[key] ? temp2[key]["SewingAccessoryValue"] : obj["DetailId"];
          let Price = obj["Price"];

          let designOrderSelected =
            params["Designs"] &&
            params["Designs"][DesignCode] &&
            params["Designs"][DesignCode]["order"] &&
            params["Designs"][DesignCode]["order"] >= 0
              ? params["Designs"][DesignCode]["order"]
              : -1;

          let pushIndex = 0;
          if (designOrderSelected !== -1 && !tempList[designOrderSelected]) {
            pushIndex = designOrderSelected;
          } else if (designOrderSelected !== -1 && tempList[designOrderSelected]) {
            tempList[tempList.length] = JSON.parse(JSON.stringify(tempList[designOrderSelected]));
            pushIndex = designOrderSelected;
          } else {
            let index = tempList.findIndex(Object.is.bind(null, undefined));
            pushIndex = index === -1 ? tempList.length : index;
          }

          tempList[pushIndex] = (
            <li className="Accessories_List_item" key={index}>
              <div className="Accessories_List_item_image">
                <img src={imgUrl(PhotoPath)} className="img-fluid" alt="" />
              </div>
              <div className="Accessories_List_item_desc">
                <h1
                  style={{
                    textAlign: pageLanguage === "fa" ? "right" : "left",
                  }}
                  className="Accessories_List_item_title Accessories_List_title_new"
                >
                  {pageLanguage1 === "en" ? DesignENName : DesignName}
                </h1>
                <h2 className="Accessories_List_item_price">
                  {GetPrice(Price, pageLanguage1, t("TOMANS"), isTabletOrMobile)}
                </h2>
                <div className="Accessories_List_item_colors">
                  <ul className="Accessories_List_item_colors_list">{temp}</ul>
                </div>
              </div>
              <div className="Accessories_List_item_qty">
                <div className="qty_numbers">
                  <button
                    type="text"
                    className="qty_minus"
                    onClick={() =>
                      setAccessoriesDesign({
                        isPlus: false,
                        SewingAccessoryValue: undefined,
                        SewingAccessoryId: undefined,
                        SewingModelAccessoryId: undefined,
                        DesignCode: key,
                        DesignNameEn: undefined,
                        DesignNameFa: undefined,
                        ColorNameEn: undefined,
                        ColorNameFa: undefined,
                        qty: undefined,
                      })
                    }
                  >
                    <img
                      src={require("../Images/public/minus.svg").default}
                      alt=""
                      className="qty_math_icon"
                    />
                  </button>
                  <input
                    type="text"
                    className="qty_num"
                    name="qty_num_g11"
                    value={getAccValue(customAcc, "SewingAccessoryValue", DetailId, pageLanguage)}
                    onChange={(e) =>
                      setAccessoriesDesign({
                        isPlus: undefined,
                        SewingAccessoryValue: undefined,
                        SewingAccessoryId: undefined,
                        SewingModelAccessoryId: undefined,
                        DesignCode: key,
                        DesignNameEn: undefined,
                        DesignNameFa: undefined,
                        ColorNameEn: undefined,
                        ColorNameFa: undefined,
                        qty: e.target.value,
                      })
                    }
                    readOnly
                  />
                  <button
                    type="text"
                    className="qty_plus"
                    onClick={() =>
                      setAccessoriesDesign({
                        isPlus: true,
                        SewingAccessoryValue: undefined,
                        SewingAccessoryId: undefined,
                        SewingModelAccessoryId: undefined,
                        DesignCode: key,
                        DesignNameEn: undefined,
                        DesignNameFa: undefined,
                        ColorNameEn: undefined,
                        ColorNameFa: undefined,
                        qty: undefined,
                      })
                    }
                  >
                    <img
                      src={require("../Images/public/plus.svg").default}
                      alt=""
                      className="qty_math_icon"
                    />
                  </button>
                </div>
              </div>
            </li>
          );
          resolve();
        });
      });
    });

    Promise.all(promiseArr).then(() => {
      setStepAccessoriesList(tempList);
    });
  }

  useEffect(() => {
    if (stepAccessories && Object.keys(stepAccessories).length > 0) {
      // Sync active color from restored Accessories; keep click selection when qty is 0
      setActiveAccessoryColors((prev) => {
        const nextActive = { ...prev };
        Object.keys(stepAccessories).forEach((designKey) => {
          const colors = stepAccessories[designKey] || [];
          const savedAcc = (customAcc || []).find((acc) => findAccessoryColor(colors, acc));
          if (savedAcc) {
            const colorObj = findAccessoryColor(colors, savedAcc);
            if (colorObj) {
              nextActive[designKey] = colorObj.DetailId;
            }
          } else if (nextActive[designKey] === undefined) {
            const firstColorObj = colors.find(
              (obj) =>
                obj["DetailId"] &&
                obj["DetailId"] !== "" &&
                obj["SewingAccessoryDetailId"] &&
                obj["SewingAccessoryId"] &&
                obj["ColorHtmlCode"]
            );
            if (firstColorObj) {
              nextActive[designKey] = firstColorObj.DetailId;
            }
          }
        });
        return nextActive;
      });
    }
  }, [stepAccessories, customAcc]);

  function getAccValue(array, searchRef, id, lang) {
    let qty = 0;

    let tempObj =
      array.filter((obj) => {
        return `${obj[searchRef]}` === `${id}`;
      })[0] || {};

    // After refresh, saved SewingAccessoryValue may be DetailId or SewingAccessoryDetailId
    if (!Object.keys(tempObj).length && Array.isArray(array) && id !== undefined) {
      tempObj =
        array.find((acc) => {
          return Object.keys(stepAccessories || {}).some((designKey) => {
            const colorObj = findAccessoryColor(stepAccessories[designKey], acc);
            return colorObj && `${colorObj["DetailId"]}` === `${id}`;
          });
        }) || {};
    }

    if (Object.keys(tempObj).length > 0) {
      qty = tempObj["Qty"] ? tempObj["Qty"] : 0;
    }

    if (lang === "fa") {
      return NumberToPersianWord.convertEnToPe(`${qty}`);
    } else {
      return qty;
    }
  }
  function renderRods() {
    const rodList = [];
    const rodList2 = [];
    const rodList3 = [];
    const rodList4 = [];
    let pageLanguage1 = location.pathname
      .split("")
      .slice(1, 3)
      .join("");

    let promiseArr = [];
    let promiseArr2 = [];
    let promiseArr3 = [];
    Object.keys(rods).forEach((key, index) => {
      promiseArr[index] = new Promise((resolve, reject) => {
        let obj = rods[key][0] || {};
        let DesignName = convertToPersian(obj["DesignName"]);
        let DesignEnName = obj["DesignENName"];
        let RailId = obj["RailId"];
        let RailTypeId = obj["RailTypeId"];
        let Price = obj["Price"];
        let PhotoObj = {};
        PhotoObj =
          obj["Photos"].filter((obj) => {
            return obj["PhotoTypeId"] === 4701;
          })[0] || PhotoObj;
        let PhotoPath = PhotoObj["PhotoUrl"] || "";

        rodList.push(
          <div className="box33 radio_style" key={index}>
            <img src={imgUrl(PhotoPath)} className="img-fluid height_auto" alt="" />
            <input
              className="radio"
              type="radio"
              text={pageLanguage1 === "fa" ? DesignName : DesignEnName}
              value={index}
              name="step81"
              ref-num={"81"}
              id={"81" + index}
              checked={step81 === `${RailId}`}
              onChange={(e) => {
                setStep81(`${RailId}`);
                setStep8RodCheck(`${RailTypeId}`);
              }}
              ref={(ref) => (inputs.current["81" + index] = ref)}
            />
            <label htmlFor={"81" + index}>
              {pageLanguage1 === "fa" ? DesignName : DesignEnName}
              <br />
              <p className="surcharge_price">
                {Price > 0
                  ? (pageLanguage1 === "en" ? "Add " : "+ ") +
                    GetPrice(
                      Price,
                      pageLanguage1,
                      pageLanguage1 === "en" ? "Tomans" : "تومان",
                      isTabletOrMobile
                    )
                  : pageLanguage1 === "en"
                  ? "Surcharge Applies"
                  : "+ شامل هزینه"}
              </p>
            </label>
          </div>
        );

        rodList2.push(
          <div className="box33 radio_style" key={index}>
            <img src={imgUrl(PhotoPath)} className="img-fluid height_auto" alt="" />
            <input
              className="radio"
              type="radio"
              text={pageLanguage1 === "fa" ? DesignName : DesignEnName}
              value={index}
              name="step8A1"
              ref-num={"8A1"}
              id={"8A1" + index}
              checked={step8A1 === `${RailId}`}
              onChange={(e) => {
                setStep8A1(`${RailId}`);
              }}
              ref={(ref) => (inputs.current["8A1" + index] = ref)}
            />
            <label htmlFor={"8A1" + index}>
              {pageLanguage1 === "fa" ? DesignName : DesignEnName}
              <br />
              <p className="surcharge_price">
                {Price > 0
                  ? (pageLanguage1 === "en" ? "Add " : "+ ") +
                    GetPrice(
                      Price,
                      pageLanguage1,
                      pageLanguage1 === "en" ? "Tomans" : "تومان",
                      isTabletOrMobile
                    )
                  : pageLanguage1 === "en"
                  ? "Surcharge Applies"
                  : "+ شامل هزینه"}
              </p>
            </label>
          </div>
        );

        resolve();
      });
    });

    Object.keys(rods2).forEach((key, index) => {
      promiseArr2[index] = new Promise((resolve, reject) => {
        let obj = rods2[key][0] || {};
        let DesignName = convertToPersian(obj["DesignName"]);
        let DesignEnName = obj["DesignENName"];
        let RailId = obj["RailId"];
        let Price = obj["Price"];
        let RailTypeId = obj["RailTypeId"];
        let PhotoObj = {};
        PhotoObj =
          obj["Photos"].filter((obj) => {
            return obj["PhotoTypeId"] === 4701;
          })[0] || PhotoObj;
        let PhotoPath = PhotoObj["PhotoUrl"] || "";

        rodList3.push(
          <div className="box33 radio_style" key={index}>
            <img src={imgUrl(PhotoPath)} className="img-fluid height_auto" alt="" />
            <input
              className="radio"
              type="radio"
              text={pageLanguage1 === "fa" ? DesignName : DesignEnName}
              value={index}
              name="step8B1"
              ref-num={"8B1"}
              id={"8B1" + index}
              checked={step8B1 === `${RailId}`}
              onChange={(e) => {
                setStep8B1(`${RailId}`);
                setStep8BRilType(`${RailTypeId}`);
              }}
              ref={(ref) => (inputs.current["8B1" + index] = ref)}
            />
            <label htmlFor={"8B1" + index}>
              {pageLanguage1 === "fa" ? DesignName : DesignEnName}
              <br />
              <p className="surcharge_price">
                {Price > 0
                  ? (pageLanguage1 === "en" ? "Add " : "+ ") +
                    GetPrice(
                      Price,
                      pageLanguage1,
                      pageLanguage1 === "en" ? "Tomans" : "تومان",
                      isTabletOrMobile
                    )
                  : pageLanguage1 === "en"
                  ? "Surcharge Applies"
                  : "+ شامل هزینه"}
              </p>
            </label>
          </div>
        );

        resolve();
      });
    });

    Object.keys(rods3).forEach((key, index) => {
      promiseArr3[index] = new Promise((resolve, reject) => {
        let obj = rods3[key][0] || {};
        let DesignName = convertToPersian(obj["DesignName"]);
        let DesignEnName = obj["DesignENName"];
        let RailId = obj["RailId"];
        let Price = obj["Price"];
        let RailTypeId = obj["RailTypeId"];
        let PhotoObj = {};
        PhotoObj =
          obj["Photos"].filter((obj) => {
            return obj["PhotoTypeId"] === 4701;
          })[0] || PhotoObj;
        let PhotoPath = PhotoObj["PhotoUrl"] || "";

        rodList4.push(
          <div className="box33 radio_style" key={index}>
            <img src={imgUrl(PhotoPath)} className="img-fluid height_auto" alt="" />
            <input
              className="radio"
              type="radio"
              text={pageLanguage1 === "fa" ? DesignName : DesignEnName}
              value={index}
              name="step8C1"
              ref-num={"8C1"}
              id={"8C1" + index}
              checked={step8C1 === `${RailId}`}
              onChange={(e) => {
                setStep8C1(`${RailId}`);
                setStep8CTrack(`${RailTypeId}`);
              }}
              ref={(ref) => (inputs.current["8C1" + index] = ref)}
            />
            <label htmlFor={"8C1" + index}>
              {pageLanguage1 === "fa" ? DesignName : DesignEnName}
              <br />
              <p className="surcharge_price">
                {Price > 0
                  ? (pageLanguage1 === "en" ? "Add " : "+ ") +
                    GetPrice(
                      Price,
                      pageLanguage1,
                      pageLanguage1 === "en" ? "Tomans" : "تومان",
                      isTabletOrMobile
                    )
                  : pageLanguage1 === "en"
                  ? "Surcharge Applies"
                  : "+ شامل هزینه"}
              </p>
            </label>
          </div>
        );

        resolve();
      });
    });

    Promise.all(promiseArr).then(() => {
      setRodsList(rodList);
      setRodsList2(rodList2);
    });
    Promise.all(promiseArr2).then(() => {
      setRodsList3(rodList3);
    });
    Promise.all(promiseArr3).then(() => {
      setRodsList4(rodList4);
    });
  }
  function renderTracks() {
    const order = [2201, 2207, 2208];
    const rodList = [];
    const rodList2 = [];
    const rodList3 = [];
    const trackList4 = [];
    let pageLanguage1 = location.pathname
      .split("")
      .slice(1, 3)
      .join("");

    let result_arr = [];
    let result_arr2 = [];

    let promiseArr = [];
    let promiseArr2 = [];
    let promiseArr3 = [];
    let promiseArr4 = [];
    let promiseArr5 = [];
    let promiseArr6 = [];

    promiseArr3[0] = new Promise((resolve, reject) => {
      result_arr = []
        .concat(...Object.values(tracks2))
        .sort((a, b) => order.indexOf(a.RailTypeId) - order.indexOf(b.RailTypeId))
        .filter((item, index, self) => {
          return index === self.findIndex((t) => t.RailTypeId === item.RailTypeId);
        });
      setTimeout(() => {
        resolve();
      }, 200);
    });

    Promise.all(promiseArr3).then(() => {
      result_arr.forEach((el, index) => {
        promiseArr[index] = new Promise((resolve, reject) => {
          let obj = el;

          let DesignName = convertToPersian(obj["DesignName"]);
          let DesignEnName = obj["DesignENName"];
          let RailId = obj["RailId"];
          let Price = obj["Price"];
          let RailTypeId = obj["RailTypeId"];
          let PhotoObj = {};
          PhotoObj =
            obj["Photos"].filter((obj) => {
              return obj["PhotoTypeId"] === 4701;
            })[0] || PhotoObj;
          let PhotoPath = PhotoObj["PhotoUrl"] || "";

          rodList.push(
            <div className="box33 radio_style" key={index}>
              <img src={imgUrl(PhotoPath)} className="img-fluid height_auto" alt="" />
              <input
                className="radio"
                type="radio"
                text={pageLanguage1 === "fa" ? DesignName : DesignEnName}
                value={index}
                name="step8B1"
                ref-num={"8B1"}
                id={"8B1" + index}
                checked={step8B1 === `${RailId}`}
                onChange={(e) => {
                  setStep8B1(`${RailId}`);
                  setStep8BRilType(`${RailTypeId}`);
                }}
                ref={(ref) => (inputs.current["8B1" + index] = ref)}
              />
              <label htmlFor={"8B1" + index}>
                {pageLanguage1 === "fa" ? DesignName : DesignEnName}
                <br />
                <p className="surcharge_price">
                  {Price > 0
                    ? (pageLanguage1 === "en" ? "Add " : "+ ") +
                      GetPrice(Price, pageLanguage1, t("TOMANS"), isTabletOrMobile)
                    : pageLanguage1 === "en"
                    ? "Surcharge Applies"
                    : "+ شامل هزینه"}
                </p>
              </label>
            </div>
          );

          resolve();
        });
      });

      Promise.all(promiseArr).then(() => {
        setTracksList(rodList);
      });
    });

    promiseArr4[0] = new Promise((resolve, reject) => {
      result_arr2 = []
        .concat(...Object.values(tracks3))
        .sort((a, b) => order.indexOf(a.RailTypeId) - order.indexOf(b.RailTypeId))
        .filter((item, index, self) => {
          return index === self.findIndex((t) => t.RailTypeId === item.RailTypeId);
        });
      setTimeout(() => {
        resolve();
      }, 200);
    });

    Promise.all(promiseArr4).then(() => {
      result_arr2.forEach((el, index) => {
        promiseArr2[index] = new Promise((resolve, reject) => {
          let obj = el;
          let DesignName = convertToPersian(obj["DesignName"]);
          let DesignEnName = obj["DesignENName"];
          let RailId = obj["RailId"];
          let Price = obj["Price"];
          let RailTypeId = obj["RailTypeId"];
          let PhotoObj = {};
          PhotoObj =
            obj["Photos"].filter((obj) => {
              return obj["PhotoTypeId"] === 4701;
            })[0] || PhotoObj;
          let PhotoPath = PhotoObj["PhotoUrl"] || "";

          rodList2.push(
            <div className="box33 radio_style" key={index}>
              <img src={imgUrl(PhotoPath)} className="img-fluid height_auto" alt="" />
              <input
                className="radio"
                type="radio"
                text={pageLanguage1 === "fa" ? DesignName : DesignEnName}
                value={index}
                name="step8C1"
                ref-num={"8C1"}
                id={"8C1" + index}
                checked={step8C1 === `${RailId}`}
                onChange={(e) => {
                  setStep8C1(`${RailId}`);
                  setStep8CTrack(`${RailTypeId}`);
                }}
                ref={(ref) => (inputs.current["8C1" + index] = ref)}
              />
              <label htmlFor={"8C1" + index}>
                {pageLanguage1 === "fa" ? DesignName : DesignEnName}
                <br />
                <p className="surcharge_price">
                  {Price > 0
                    ? (pageLanguage1 === "en" ? "Add " : "+ ") +
                      GetPrice(
                        Price,
                        pageLanguage1,
                        pageLanguage1 === "en" ? "Tomans" : "تومان",
                        isTabletOrMobile
                      )
                    : pageLanguage1 === "en"
                    ? "Surcharge Applies"
                    : "+ شامل هزینه"}
                </p>
              </label>
            </div>
          );

          resolve();
        });
      });

      Promise.all(promiseArr2).then(() => {
        setTracksList2(rodList2);
      });
    });

    promiseArr5[0] = new Promise((resolve, reject) => {
      result_arr = []
        .concat(...Object.values(tracks2))
        .sort((a, b) => order.indexOf(a.RailTypeId) - order.indexOf(b.RailTypeId))
        .filter((item, index, self) => {
          return index === self.findIndex((t) => t.RailTypeId === item.RailTypeId);
        });
      setTimeout(() => {
        resolve();
      }, 200);
    });

    Promise.all(promiseArr5).then(() => {
      result_arr.forEach((el, index) => {
        promiseArr5[index] = new Promise((resolve, reject) => {
          let obj = el;
          let DesignName = convertToPersian(obj["DesignName"]);
          let DesignEnName = obj["DesignENName"];
          let RailId = obj["RailId"];
          let RailTypeId = obj["RailTypeId"];
          //   console.log("RailTypeId:", RailTypeId, "DesignENName:", DesignEnName);
          let Price = obj["Price"];
          let PhotoObj = {};
          PhotoObj =
            obj["Photos"].filter((obj) => {
              return obj["PhotoTypeId"] === 4701;
            })[0] || PhotoObj;
          let PhotoPath = PhotoObj["PhotoUrl"] || "";

          rodList3.push(
            <div className="box33 radio_style" key={index}>
              <img src={imgUrl(PhotoPath)} className="img-fluid height_auto" alt="" />
              <input
                className="radio"
                type="radio"
                text={pageLanguage1 === "fa" ? DesignName : DesignEnName}
                value={index}
                name="stepTrackCollections9A"
                ref-num={"851"}
                id={"851" + index}
                checked={
                  stepTrackCollections9A === `${RailId}` ||
                  (stepTCollections9A !== "" && `${stepTCollections9A}` === `${RailTypeId}`)
                }
                onChange={(e) => {
                  setStepTrackCollectionsName9A(pageLanguage1 === "fa" ? DesignName : DesignEnName);
                  setRemoteNameA("");
                  setStepHardware9A("");
                  setStep8B3("");
                  setStep8B6("");
                  setStep9APosition("");
                  setStepControl9A("");
                  setStepTCollections9A(`${RailTypeId}`);
                  setStepTrackCollections9A(`${RailId}`);
                }}
                ref={(ref) => (inputs.current["851" + index] = ref)}
              />
              <label htmlFor={"851" + index}>
                {pageLanguage1 === "fa" ? DesignName : DesignEnName}
                <br />
                <p className="surcharge_price">
                  {Price > 0
                    ? (pageLanguage1 === "en" ? "Add " : "+ ") +
                      GetPrice(Price, pageLanguage1, t("TOMANS"), isTabletOrMobile)
                    : pageLanguage1 === "en"
                    ? "Surcharge Applies"
                    : "+ شامل هزینه"}
                </p>
              </label>
            </div>
          );

          resolve();
        });
      });

      Promise.all(promiseArr5).then(() => {
        setTracksList3(rodList3);
      });
    });

    promiseArr6[0] = new Promise((resolve, reject) => {
      result_arr = []
        .concat(...Object.values(tracks2))
        .sort((a, b) => order.indexOf(a.RailTypeId) - order.indexOf(b.RailTypeId))
        .filter((item, index, self) => {
          return index === self.findIndex((t) => t.RailTypeId === item.RailTypeId);
        });
      setTimeout(() => {
        resolve();
      }, 200);
    });

    Promise.all(promiseArr6).then(() => {
      result_arr.forEach((el, index) => {
        promiseArr6[index] = new Promise((resolve, reject) => {
          let obj = el;
          let DesignName = convertToPersian(obj["DesignName"]);
          let DesignEnName = obj["DesignENName"];
          let RailId = obj["RailId"];
          let RailTypeId = obj["RailTypeId"];
          let Price = obj["Price"];
          let PhotoObj = {};
          PhotoObj =
            obj["Photos"].filter((obj) => {
              return obj["PhotoTypeId"] === 4701;
            })[0] || PhotoObj;
          let PhotoPath = PhotoObj["PhotoUrl"] || "";

          trackList4.push(
            <div className="box33 radio_style" key={index}>
              <img src={imgUrl(PhotoPath)} className="img-fluid height_auto" alt="" />
              <input
                className="radio"
                type="radio"
                text={pageLanguage1 === "fa" ? DesignName : DesignEnName}
                value={index}
                name="step8D1"
                ref-num={"8d1"}
                id={"8d1" + index}
                checked={step8D1 === `${RailId}`}
                onChange={(e) => {
                  setNameEnDraperyTrack(DesignEnName);
                  setNameFaDraperyTrack(DesignName);
                  setStep8D1(`${RailId}`);
                  setStep8DTrack(`${RailTypeId}`);
                }}
                ref={(ref) => (inputs.current["8d1" + index] = ref)}
              />
              <label htmlFor={"8d1" + index}>
                {pageLanguage1 === "fa" ? DesignName : DesignEnName}
                <br />
                <p className="surcharge_price">
                  {Price > 0
                    ? (pageLanguage1 === "en" ? "Add " : "+ ") +
                      GetPrice(Price, pageLanguage1, t("TOMANS"), isTabletOrMobile)
                    : pageLanguage1 === "en"
                    ? "Surcharge Applies"
                    : "+ شامل هزینه"}
                </p>
              </label>
            </div>
          );

          resolve();
        });
      });

      Promise.all(promiseArr6).then(() => {
        setTracksList4(trackList4);
      });
    });
  }
  function handleClose() {
    setShow(false);
  }
  function handleShow(fabricObj, SwatchDetailId) {
    let pageLanguage = location.pathname
      .split("")
      .slice(1, 3)
      .join("");

    let DesignName = convertToPersian(fabricObj["DesignName"]);
    let DesignEnName = fabricObj["DesignEnName"];
    let PhotoPath = "";
    fabricObj["FabricPhotos"].forEach((obj) => {
      if (obj["PhotoTypeId"] === 4702) PhotoPath = obj["PhotoUrl"];
    });
    let PriceLevelEnTitle = fabricObj["PriceLevelEnTitle"];
    let PriceLevelTitle = fabricObj["PriceLevelTitle"];
    let PolyesterPercent = fabricObj["PolyesterPercent"] || 0;
    let ViscosePercent = fabricObj["ViscosePercent"] || 0;
    let NylonPercent = fabricObj["NylonPercent"] || 0;
    let ConttonPercent = fabricObj["ConttonPercent"] || 0;
    let LinenPercent = fabricObj["LinenPercent"] || 0;
    let FabricWidth = fabricObj["FabricWidth"] || 0;
    let ColorName = convertToPersian(fabricObj["ColorName"]);
    let ColorEnName = fabricObj["ColorEnName"];
    let SwatchId = fabricObj["SwatchId"] ? fabricObj["SwatchId"] : -1;

    const tempDiv = [];
    const tempDiv1 = [];
    tempDiv.push(
      <div key={PhotoPath} className="zoomImg">
        <div className="imageContainer">
          <ReactImageMagnify
            imageProps={{
              alt: "", // isFluidWidth: true,
              src: imgUrl(PhotoPath),
            }}
            magnifiedImageProps={{
              src: imgUrl(PhotoPath),
              width: 800,
              height: 800,
            }}
            portalProps={{ placement: "over" }}
          />
        </div>
      </div>
    );
    tempDiv1.push(
      <div key={1} className="zoom_modal_header_container">
        <h1 className="zoom_modal_header_design">
          {pageLanguage === "en" ? DesignEnName : DesignName} /{" "}
          {pageLanguage === "en" ? ColorEnName : ColorName}
        </h1>
        <h1 className="zoom_modal_header_Price">
          {t("PRICE GROUP: ")}
          {pageLanguage === "en" ? capitalizeWordsText(PriceLevelEnTitle) : PriceLevelTitle}
        </h1>
        <div className="zoom_modal_header_Contents_container">
          <h1 className="zoom_modal_header_Contents">{t("Contents")}</h1>
          {PolyesterPercent > 0 && (
            <p className="zoom_modal_header_Contents_item">
              {pageLanguage === "en" ? PolyesterPercent + "%" : NumToFa(PolyesterPercent) + "%"}{" "}
              {t("Polyester")}
            </p>
          )}
          {ViscosePercent > 0 && (
            <p className="zoom_modal_header_Contents_item">
              {pageLanguage === "en" ? ViscosePercent + "%" : NumToFa(ViscosePercent) + "%"}{" "}
              {t("Viscose")}
            </p>
          )}
          {NylonPercent > 0 && (
            <p className="zoom_modal_header_Contents_item">
              {NumToFa(NylonPercent) + "%"} {t("Nylon")}
            </p>
          )}
          {ConttonPercent > 0 && (
            <p className="zoom_modal_header_Contents_item">
              {pageLanguage === "en" ? ConttonPercent + "%" : NumToFa(ConttonPercent) + "%"}{" "}
              {t("Contton")}
            </p>
          )}
          {LinenPercent > 0 && (
            <p className="zoom_modal_header_Contents_item">
              {pageLanguage === "en" ? LinenPercent + "%" : NumToFa(LinenPercent) + "%"}{" "}
              {t("Linen")}
            </p>
          )}
        </div>
        <div className="zoom_modal_header_Contents_container">
          <h1 className="zoom_modal_header_Contents">{t("Fabric Width")}</h1>
          {FabricWidth > 0 && (
            <p className="zoom_modal_header_Contents_item">
              {pageLanguage === "en" ? FabricWidth + "cm" : NumToFa(FabricWidth) + "س\u200Cم"}
            </p>
          )}
        </div>
      </div>
    );

    setZoomModalBody(tempDiv);
    setZoomModalHeader(tempDiv1);
    setSwatchId(SwatchId);
    setSwatchDetailId(SwatchDetailId);
    setSwatchPhotoPath(PhotoPath);
    setShow(true);
  }
  function modalHandleClose(modalName) {
    setHideModals(modalName);
  }
  function modalHandleShow(modalName) {
    setShowModals(modalName);
  }
  useEffect(() => {
    if (!pageLoad && showModals !== "") {
      let tempModals = JSON.parse(JSON.stringify(modals));
      tempModals[showModals] = true;
      setModals(tempModals);
      setShowModals("");
    }
  }, [showModals]);

  useEffect(() => {
    if (!pageLoad && hideModals !== "") {
      let tempModals = JSON.parse(JSON.stringify(modals));
      tempModals[hideModals] = false;
      setModals(tempModals);
      setHideModals("");
    }
  }, [hideModals]);

  useEffect(() => {
    if (shouldScroll && fabricsContainerRef.current) {
      setTimeout(() => {
        fabricsContainerRef.current.scrollBy({
          top: 300,
          behavior: "smooth",
        });
        setShouldScroll(false);
      }, 400);
    }
  }, [shouldScroll, step1Check]);

  function ContextAwareToggle({
    stepNum,
    stepTitle,
    stepTitle2,
    stepSelected,
    eventKey,
    callback,
    stepRef,
    type,
    required,
    cartCustomText,
  }) {
    const { activeEventKey } = useContext(AccordionContext);
    const decoratedOnClick = useAccordionButton(eventKey, () => {
      callback && callback(eventKey);
      activeEventKey === eventKey ? setAccordionActiveKey("") : setAccordionActiveKey(eventKey);
      setTimeout(() => {
        if (stepHeaders.current[stepRef] !== undefined && stepHeaders.current[stepRef] !== null)
          stepHeaders.current[stepRef].scrollIntoView();
      }, 500);
    });
    const isCurrentEventKey = activeEventKey === eventKey;
    const excludedStepSelectedValues = [
      "I Have My Own Hardware",
      "Same Hardware For All Curtains",
      "Customize Hardware Per Curtain",
    ];
    const shouldHideText = excludedStepSelectedValues.includes(stepSelected) && !step8;
    return (
      <div
        className={`w-100 h-100 steps_header ${isCurrentEventKey ? "steps_header_active" : ""}`}
        onClick={decoratedOnClick}
        ref={(ref) => (stepHeaders.current[stepRef] = ref)}
      >
        <div className="steps_header_num_container">
          <div className="steps_header_num">{stepNum}</div>
        </div>
        <div className="steps_header_title_container">
          <div
            className={"steps_header_title " + stepTitle2 ? "steps_header_title_max_content" : ""}
            type-of-step={type}
            cart-custom-text={cartCustomText === undefined ? stepTitle : cartCustomText}
            ref={(ref) => (steps.current[stepRef] = ref)}
          >
            {stepTitle}
            <h5>{stepTitle2}</h5>
          </div>
        </div>

        <div className="steps_header_selected_container">
          <div className="steps_header_selected_title_container 1">
            <div
              className={
                "steps_header_selected" +
                (stepSelected === t("Invalid Measurements") ? " steps_header_selected_red" : "")
              }
              ref={(ref) => (selectedTitle.current[stepNum] = ref)}
            >
              <span
             
              >
                {showLabels && !shouldHideText
                  ? stepRef in extendedTitle && extendedTitle[stepRef].length > 0
                    ? extendedTitle[stepRef][0]
                    : stepSelected
                  : null}
              </span>

              {showLabels && stepRef in extendedTitle && extendedTitle[stepRef].length > 1 ? (
                <h5
                  onMouseEnter={() => {
                    if (stepRef in extendedTitle && extendedTitle[stepRef].length > 1) {
                      let temp = JSON.parse(JSON.stringify(headerTruncated));
                      temp[stepNum] = true;
                      setHeaderTruncated(temp);
                    }
                  }}
                  onMouseLeave={() => {
                    let temp = JSON.parse(JSON.stringify(headerTruncated));
                    temp[stepNum] = false;
                    setHeaderTruncated(temp);
                  }}
                >
                  ...
                </h5>
              ) : (
                ""
              )}
            </div>

            {headerTruncated[stepNum] && (
              <div className="header_tooltip">
                {stepRef in extendedTitle
                  ? stepRef === "1" ||
                    stepRef === "2" ||
                    stepRef === "3A0" ||
                    stepRef === "6" ||
                    stepRef === "8" ||
                    stepRef === "8A" ||
                    stepRef === "8B" ||
                    stepRef === "8C"
                    ? extendedTitle[stepRef].slice(1).filter((n) => n)
                    : extendedTitle[stepRef]
                        .slice(1)
                        .filter((n) => n)
                        .join(", \n")
                        .replace(/,/g, "")
                  : stepSelected}
              </div>
            )}
          </div>

          {required && <div className="stepRequired" />}
        </div>
      </div>
    );
  }

  function ContextAwareToggle2({
    stepNum,
    stepTitle,
    stepTitle2,
    stepSelected,
    eventKey,
    callback,
    stepRef,
    type,
    required,
    cartCustomText,
  }) {
    const { activeEventKey } = useContext(AccordionContext);

    const decoratedOnClick = useAccordionButton(eventKey, () => {
      callback && callback(eventKey);
      activeEventKey === eventKey ? setAccordionActiveKey2("") : setAccordionActiveKey2(eventKey);

      setTimeout(() => {
        if (stepHeaders.current[stepRef] !== undefined && stepHeaders.current[stepRef] !== null)
          stepHeaders.current[stepRef].scrollIntoView();
      }, 500);
    });

    const isCurrentEventKey = activeEventKey === eventKey;

    return (
      <div
        className={`w-100 h-100 steps_header ${isCurrentEventKey ? "steps_header_active" : ""}`}
        onClick={decoratedOnClick}
        ref={(ref) => (stepHeaders.current[stepRef + "2"] = ref)}
      >
        <div className="steps_header_num_container">
          <div className="steps_header_num">{stepNum}</div>
        </div>
        <div className="steps_header_title_container 2">
          <div
            className={"steps_header_title " + stepTitle2 ? "steps_header_title_max_content" : ""}
            type-of-step={type}
            cart-custom-text={cartCustomText === undefined ? stepTitle : cartCustomText}
            ref={(ref) => (steps.current[stepRef] = ref)}
          >
            {stepTitle}
            <h5>{stepTitle2}</h5>
          </div>
        </div>
        <div className="steps_header_selected_container">
          <div className="steps_header_selected_title_container 2">
            <div
              className={
                "steps_header_selected" +
                (stepSelected === t("Invalid Measurements") ? " steps_header_selected_red" : "")
              }
              onMouseEnter={() => {
                if (stepRef in extendedTitle && extendedTitle[stepRef].length > 1) {
                  let temp = JSON.parse(JSON.stringify(headerTruncated));
                  temp[stepNum] = true;
                  setHeaderTruncated(temp);
                }
              }}
              onMouseLeave={() => {
                let temp = JSON.parse(JSON.stringify(headerTruncated));
                temp[stepNum] = false;
                setHeaderTruncated(temp);
              }}
              ref={(ref) => (selectedTitle.current[stepNum] = ref)}
            >
              {showLabels
                ? stepRef in extendedTitle && extendedTitle[stepRef].length > 0
                  ? extendedTitle[stepRef][0]
                  : stepSelected
                : null}
              {showLabels && stepRef in extendedTitle && extendedTitle[stepRef].length > 1 ? (
                <h5> ...</h5>
              ) : (
                ""
              )}
            </div>
            {headerTruncated[stepNum] && (
              <div className="header_tooltip 2">
                {stepRef in extendedTitle
                  ? stepRef === "1" ||
                    stepRef === "2" ||
                    stepRef === "3A0" ||
                    stepRef === "6" ||
                    stepRef === "8" ||
                    stepRef === "8A" ||
                    stepRef === "8B" ||
                    stepRef === "8C"
                    ? extendedTitle[stepRef].slice(1).filter((n) => n)
                    : extendedTitle[stepRef]
                        .slice(1)
                        .filter((n) => n)
                        .join(", \n")
                  : stepSelected}
              </div>
            )}
          </div>
          <div
            className={isCurrentEventKey ? "steps_header_arrow_up" : "steps_header_arrow_down"}
          />
        </div>
      </div>
    );
  }

  function ContextAwareToggle3({
    stepNum,
    stepTitle,
    stepTitle2,
    stepSelected,
    eventKey,
    callback,
    stepRef,
    type,
    required,
    cartCustomText,
  }) {
    const { activeEventKey } = useContext(AccordionContext);

    const decoratedOnClick = useAccordionButton(eventKey, () => {
      callback && callback(eventKey);
      activeEventKey === eventKey ? setAccordionActiveKey2("") : setAccordionActiveKey2(eventKey);

      setTimeout(() => {
        if (stepHeaders.current[stepRef] !== undefined && stepHeaders.current[stepRef] !== null)
          stepHeaders.current[stepRef].scrollIntoView();
      }, 500);
    });

    const isCurrentEventKey = activeEventKey === eventKey;

    return (
      <div
        className={`w-100 h-100 steps_header ${isCurrentEventKey ? "steps_header_active" : ""}`}
        onClick={decoratedOnClick}
        ref={(ref) => (stepHeaders.current[stepRef + "2"] = ref)}
      >
        <div className="steps_header_title_container 3">
          <div
            className={"steps_header_title " + stepTitle2 ? "steps_header_title_max_content" : ""}
            type-of-step={type}
            cart-custom-text={cartCustomText === undefined ? stepTitle : cartCustomText}
            ref={(ref) => (steps.current[stepRef] = ref)}
          >
            {stepTitle}
            <h5>{stepTitle2}</h5>
          </div>
        </div>
        <div className="steps_header_selected_container steps_header_selected_container2">
          <div className="steps_header_selected_title_container 3">
            <div
              className={
                "steps_header_selected" +
                (stepSelected === t("Invalid Measurements") ? " steps_header_selected_red" : "")
              }
              onMouseEnter={() => {
                if (stepRef in extendedTitle && extendedTitle[stepRef].length > 1) {
                  let temp = JSON.parse(JSON.stringify(headerTruncated));
                  temp[stepNum] = true;
                  setHeaderTruncated(temp);
                }
              }}
              onMouseLeave={() => {
                let temp = JSON.parse(JSON.stringify(headerTruncated));
                temp[stepNum] = false;
                setHeaderTruncated(temp);
              }}
              ref={(ref) => (selectedTitle.current[stepNum] = ref)}
            >
              {showLabels
                ? stepRef in extendedTitle && extendedTitle[stepRef].length > 0
                  ? extendedTitle[stepRef][0]
                  : stepSelected
                : null}
              {showLabels && stepRef in extendedTitle && extendedTitle[stepRef].length > 1 ? (
                <h5> ...</h5>
              ) : (
                ""
              )}
            </div>

            {headerTruncated[stepNum] && (
              <div className="header_tooltip 3">
                {stepRef in extendedTitle
                  ? stepRef === "1" ||
                    stepRef === "2" ||
                    stepRef === "3A0" ||
                    stepRef === "6" ||
                    stepRef === "8" ||
                    stepRef === "8A" ||
                    stepRef === "8B" ||
                    stepRef === "8C"
                    ? extendedTitle[stepRef].slice(1).filter((n) => n)
                    : extendedTitle[stepRef]
                        .slice(1)
                        .filter((n) => n)
                        .join(", \n")
                  : stepSelected}
              </div>
            )}
          </div>
        </div>
      </div>
    );
  }

  function ContextAwareToggleViewDetails({
    eventKey,
    callback,
    textOnHide,
    textOnShow,
    customClass,
    customClass2,
  }) {
    const { activeEventKey } = useContext(AccordionContext);

    const decoratedOnClick = useAccordionButton(eventKey, () => callback && callback(eventKey));

    const isCurrentEventKey = activeEventKey === eventKey;

    return (
      <button
        className={
          (customClass ? customClass : "basket_item_title_dropdown_btn") +
          " accordion_toggle_button"
        }
        aria-expanded={`${isCurrentEventKey}`}
        type="button"
        onClick={decoratedOnClick}
      >
        <h4 className={customClass2 ? customClass2 : "dk_curtain_preview_item_details"}>
          {isCurrentEventKey ? textOnShow : textOnHide}
        </h4>
      </button>
    );
  }

  function ContextAwareToggleFilters({ eventKey, callback, textOnHide, textOnShow }) {
    const { activeEventKey } = useContext(AccordionContext);

    const decoratedOnClick = useAccordionButton(eventKey, () => callback && callback(eventKey));

    const isCurrentEventKey = activeEventKey === eventKey;

    return (
      <>
        <button
          className="product_filter_accordion_btn"
          aria-expanded={`${isCurrentEventKey}`}
          type="button"
          onClick={decoratedOnClick}
        >
          <p className="product_filter_accordion_btn_title">
            {isCurrentEventKey ? textOnShow : textOnHide}
          </p>
          <div
            className={
              isCurrentEventKey
                ? "product_filter_accordion_btn_img_minus img-fluid"
                : "product_filter_accordion_btn_img_plus img-fluid"
            }
          ></div>
        </button>
      </>
    );
  }
  const [isShowStep5, setIsShowStep5] = useState(false);
  function NextStep({ children, eventKey, callback, onClick, currentStep, clickBtn }) {
    const decoratedOnClick = useAccordionButton(eventKey, () => {
      callback && callback(eventKey);
      onClick && onClick(eventKey);
      setAccordionActiveKey(eventKey);
      setTimeout(() => {
        if (
          currentStep &&
          stepHeaders.current[currentStep] !== undefined &&
          stepHeaders.current[currentStep] !== null
        )
          stepHeaders.current[currentStep].scrollIntoView();
      }, 800);
    });

    const decoratedOnClick2 = useAccordionButton(eventKey, () => {
      //   setIsShowStep5(true);
      callback && callback(eventKey);
      onClick && onClick(eventKey);
      // Lining step: pin Measurements (step 5) at top so 1–4 scroll away
      pendingScrollToMeasurementsRef.current = true;
      setAccordionActiveKey(eventKey);
    });

    // اگر eventKey برابر "4" بود، هیچ چیزی نمایش نده
    if (eventKey === "4") {
      return (
        <div className="nextStep_area">
          <div className="nextStep" onClick={decoratedOnClick2}>
            {children}
          </div>
        </div>
      );
    }

    return (
      <div className="nextStep_area">
        <div className="nextStep" onClick={decoratedOnClick}>
          {children}
        </div>
      </div>
    );
  }

  function clearAllFilters() {
    filterCheckboxes.current["colors"].forEach((obj) => {
      if (obj !== null) obj.checked = false;
    });
    filterCheckboxes.current["patterns"].forEach((obj) => {
      if (obj !== null) obj.checked = false;
    });
    filterCheckboxes.current["types"].forEach((obj) => {
      if (obj !== null) obj.checked = false;
    });
    filterCheckboxes.current["prices"].forEach((obj) => {
      if (obj !== null) obj.checked = false;
    });
    filterCheckboxes.current["colors2"].forEach((obj) => {
      if (obj !== null) obj.checked = false;
    });
    filterCheckboxes.current["patterns2"].forEach((obj) => {
      if (obj !== null) obj.checked = false;
    });
    filterCheckboxes.current["types2"].forEach((obj) => {
      if (obj !== null) obj.checked = false;
    });
    filterCheckboxes.current["prices2"].forEach((obj) => {
      if (obj !== null) obj.checked = false;
    });
    filterCheckboxes.current["colorsSheer"].forEach((obj) => {
      if (obj !== null) obj.checked = false;
    });
    filterCheckboxes.current["patternsSheer"].forEach((obj) => {
      if (obj !== null) obj.checked = false;
    });
    filterCheckboxes.current["typesSheer"].forEach((obj) => {
      if (obj !== null) obj.checked = false;
    });
    filterCheckboxes.current["pricesSheer"].forEach((obj) => {
      if (obj !== null) obj.checked = false;
    });
    if (search_input.current) search_input.current.value = "";
    if (search_input2.current) search_input2.current.value = "";
    setSearchText("");
    setSearchText2("");
    setSearchShow(false);
    setSearchShow2(false);

    setFilterColors([]);
    setFilterPatterns([]);
    setFilterTypes([]);
    setFilterPrices([]);
    setFilterColors2([]);
    setFilterPatterns2([]);
    setFilterTypes2([]);
    setFilterPrices2([]);
  }

  useEffect(() => {
    if (isClearAll) {
      clearAllFilters();
      getFabricsWithFilter(true, "1");
      getFabricsWithFilter(true, "2");
    }
  }, [isClearAll]);

  function clearFilters(e) {
    const refIndex = e.currentTarget.getAttribute("text") || e.target.getAttribute("text");
    const refStep =
      e.currentTarget.getAttribute("data-step") || e.target.getAttribute("data-step") || "1";
    const refKey =
      refStep === "2"
        ? refIndex === "colors"
          ? "colorsSheer"
          : refIndex === "patterns"
            ? "patternsSheer"
            : refIndex === "types"
              ? "typesSheer"
              : "pricesSheer"
        : refIndex;

    const items = filterCheckboxes.current[refKey] || [];
    items.forEach((obj) => {
      if (obj) obj.checked = false;
    });

    if (refStep === "2") {
      if (refIndex === "colors") {
        setFilterColors2([]);
      } else if (refIndex === "patterns") {
        setFilterPatterns2([]);
      } else if (refIndex === "types") {
        setFilterTypes2([]);
      } else {
        setFilterPrices2([]);
      }
    } else {
      if (refIndex === "colors") {
        setFilterColors([]);
      } else if (refIndex === "patterns") {
        setFilterPatterns([]);
      } else if (refIndex === "types") {
        setFilterTypes([]);
      } else {
        setFilterPrices([]);
      }
    }
  }

  function popoverThumbnailHover(e) {
    let refIndex = e.target.getAttribute("text");
    let tempImages = [...popoverImages];
    tempImages[refIndex] = e.target.src;
    setPopoverImages(tempImages);
  }

  function optionSelectChanged_three(
    obj,
    refIndex,
    position,
    isMin,
    modalRef,
    postfixEn,
    postfixFa,
    pageLang,
    eventKey
  ) {
    if (obj !== undefined && typeof obj === "object") {
      let temp = JSON.parse(JSON.stringify(stepSelectedOptions));
      if (temp.labels[refIndex] === undefined) temp.labels[refIndex] = [];
      if (temp.values[refIndex] === undefined) temp.values[refIndex] = [];
      temp.labels[refIndex][position] = obj.label;
      temp.values[refIndex][position] = parseFloat(obj.value);
      setStepSelectedOptions(temp);

      if (
        temp.values[refIndex].filter(function(e) {
          return e;
        }).length === 3
      ) {
        let tempLabels = JSON.parse(JSON.stringify(stepSelectedLabel));
        if (isMin) {
          let tempMin =
            temp.values[refIndex][
              temp.values[refIndex].indexOf(Math.min(...temp.values[refIndex]))
            ];
          tempLabels[refIndex] =
            pageLang === "fa"
              ? NumberToPersianWord.convertEnToPe(`${tempMin}`) + postfixFa
              : tempMin + postfixEn;
        } else {
          let tempMax =
            temp.values[refIndex][
              temp.values[refIndex].indexOf(Math.min(...temp.values[refIndex]))
            ];
          tempLabels[refIndex] =
            pageLang === "fa"
              ? NumberToPersianWord.convertEnToPe(`${tempMax}`) + postfixFa
              : tempMax + postfixEn;
        }
        setStepSelectedLabel(tempLabels);
        let minValue = Math.min(...temp.values[refIndex]);
        let maxValue = Math.max(...temp.values[refIndex]);
        if (maxValue - minValue >= 2) {
          if (refIndex === "3EStandardCeiling") {
            setInputDifdep("3EStandardCeiling1,3EStandardCeiling2,3EStandardCeiling3");
          } else if (refIndex === "3EStandardCeilingFloor") {
            setInputDifdep(
              "3EStandardCeilingFloor1,3EStandardCeilingFloor2,3EStandardCeilingFloor3"
            );
          }
          setInputDifRef(refIndex);
          setAccordionActiveKey(eventKey);
          modalHandleShow(modalRef);
        }
      }
    } else if (obj !== undefined) {
      let temp = JSON.parse(JSON.stringify(stepSelectedOptions));
      if (temp.labels[refIndex] === undefined) temp.labels[refIndex] = [];
      if (temp.values[refIndex] === undefined) temp.values[refIndex] = [];
      temp.labels[refIndex][position] = obj;
      temp.values[refIndex][position] = parseFloat(obj);
      setStepSelectedOptions(temp);

      if (
        temp.values[refIndex].filter(function(e) {
          return e;
        }).length === 3
      ) {
        let tempLabels = JSON.parse(JSON.stringify(stepSelectedLabel));
        if (isMin) {
          let tempMin =
            temp.values[refIndex][
              temp.values[refIndex].indexOf(Math.min(...temp.values[refIndex]))
            ];
          tempLabels[refIndex] =
            pageLang === "fa"
              ? NumberToPersianWord.convertEnToPe(`${tempMin}`) + postfixFa
              : tempMin + postfixEn;
        } else {
          let tempMax =
            temp.values[refIndex][
              temp.values[refIndex].indexOf(Math.min(...temp.values[refIndex]))
            ];
          tempLabels[refIndex] =
            pageLang === "fa"
              ? NumberToPersianWord.convertEnToPe(`${tempMax}`) + postfixFa
              : tempMax + postfixEn;
        }
        setStepSelectedLabel(tempLabels);
        let minValue = Math.min(...temp.values[refIndex]);
        let maxValue = Math.max(...temp.values[refIndex]);
        if (maxValue - minValue >= 2) {
          if (refIndex === "3EStandardCeiling") {
            setInputDifdep("3EStandardCeiling1,3EStandardCeiling2,3EStandardCeiling3");
          } else if (refIndex === "3EStandardCeilingFloor") {
            setInputDifdep(
              "3EStandardCeilingFloor1,3EStandardCeilingFloor2,3EStandardCeilingFloor3"
            );
          }
          setInputDifRef(refIndex);
          setAccordionActiveKey(eventKey);
          modalHandleShow(modalRef);
        }
      }
    }
    let temp = JSON.parse(JSON.stringify(requiredStep));
    if (requiredStep[refIndex]) {
      temp[refIndex] = false;
    }

    setRequiredStep(temp);
  }

  function optionSelectChanged_LeftRight(
    obj,
    refIndex,
    isLeft,
    postfixEn,
    postfixFa,
    pageLang,
    secondVal
  ) {
    if (obj !== undefined && typeof obj === "object") {
      if (isLeft) {
        let temp = JSON.parse(JSON.stringify(leftRight));
        temp.left = obj.value;
        if (secondVal !== undefined) {
          temp.right = secondVal;
        }
        setLeftRight(temp);

        if (temp.right !== "" && temp.left !== "") {
          let tempLabels = JSON.parse(JSON.stringify(stepSelectedLabel));
          tempLabels[refIndex] =
            pageLang === "fa"
              ? `راست:  ${NumberToPersianWord.convertEnToPe(`${temp.right}`) +
                  postfixFa}\u00A0\u00A0\u00A0چپ: ${NumberToPersianWord.convertEnToPe(
                  `${temp.left}`
                ) + postfixFa}`
              : `Left: ${temp.left + postfixEn}\u00A0\u00A0\u00A0Right: ${temp.right + postfixEn}`;
          setStepSelectedLabel(tempLabels);
        }
      } else {
        let temp = JSON.parse(JSON.stringify(leftRight));
        temp.right = obj.value;
        if (secondVal !== undefined) {
          temp.left = secondVal;
        }
        setLeftRight(temp);

        if (temp.right !== "" && temp.left !== "") {
          let tempLabels = JSON.parse(JSON.stringify(stepSelectedLabel));
          tempLabels[refIndex] =
            pageLang === "fa"
              ? `راست:  ${NumberToPersianWord.convertEnToPe(`${temp.right}`) +
                  postfixFa}\u00A0\u00A0\u00A0چپ: ${NumberToPersianWord.convertEnToPe(
                  `${temp.left}`
                ) + postfixFa}`
              : `Left: ${temp.left + postfixEn}\u00A0\u00A0\u00A0Right: ${temp.right + postfixEn}`;
          setStepSelectedLabel(tempLabels);
        }
      }
    } else if (obj !== undefined) {
      if (isLeft) {
        let temp = JSON.parse(JSON.stringify(leftRight));
        temp.left = obj;
        if (secondVal !== undefined) {
          temp.right = secondVal;
        }
        setLeftRight(temp);

        if (temp.right !== "" && temp.left !== "") {
          let tempLabels = JSON.parse(JSON.stringify(stepSelectedLabel));
          tempLabels[refIndex] =
            pageLang === "fa"
              ? `راست:  ${NumberToPersianWord.convertEnToPe(`${temp.right}`) +
                  postfixFa}\u00A0\u00A0\u00A0چپ: ${NumberToPersianWord.convertEnToPe(
                  `${temp.left}`
                ) + postfixFa}`
              : `Left: ${temp.left + postfixEn}\u00A0\u00A0\u00A0Right: ${temp.right + postfixEn}`;
          setStepSelectedLabel(tempLabels);
        }
      } else {
        let temp = JSON.parse(JSON.stringify(leftRight));
        temp.right = obj;
        if (secondVal !== undefined) {
          temp.left = secondVal;
        }
        setLeftRight(temp);

        if (temp.right !== "" && temp.left !== "") {
          let tempLabels = JSON.parse(JSON.stringify(stepSelectedLabel));
          tempLabels[refIndex] =
            pageLang === "fa"
              ? `راست:  ${NumberToPersianWord.convertEnToPe(`${temp.right}`) +
                  postfixFa}\u00A0\u00A0\u00A0چپ: ${NumberToPersianWord.convertEnToPe(
                  `${temp.left}`
                ) + postfixFa}`
              : `Left: ${temp.left + postfixEn}\u00A0\u00A0\u00A0Right: ${temp.right + postfixEn}`;
          setStepSelectedLabel(tempLabels);
        }
      }
    }
    let temp = JSON.parse(JSON.stringify(requiredStep));
    if (requiredStep[refIndex]) {
      temp[refIndex] = false;
    }

    setRequiredStep(temp);
  }

  function optionSelectChanged(refIndex, selected, postfixEn, postfixFa, pageLang) {
    if (selected !== undefined && typeof selected === "object") {
      let tempLabels = JSON.parse(JSON.stringify(stepSelectedLabel));
      tempLabels[refIndex] =
        pageLang === "fa"
          ? `${NumberToPersianWord.convertEnToPe(`${selected.value}`) + postfixFa}`
          : `${selected.value + postfixEn}`;
      setStepSelectedLabel(tempLabels);

      let tempValue = JSON.parse(JSON.stringify(stepSelectedValue));
      tempValue[refIndex] = selected.value;
      setStepSelectedValue(tempValue);
    } else if (selected !== undefined) {
      let tempLabels = JSON.parse(JSON.stringify(stepSelectedLabel));
      tempLabels[refIndex] =
        pageLang === "fa"
          ? `${NumberToPersianWord.convertEnToPe(`${selected}`) + postfixFa}`
          : `${selected + postfixEn}`;
      setStepSelectedLabel(tempLabels);

      let tempValue = JSON.parse(JSON.stringify(stepSelectedValue));
      tempValue[refIndex] = selected;
      setStepSelectedValue(tempValue);
    }
    let temp = JSON.parse(JSON.stringify(requiredStep));

    if (requiredStep[refIndex]) {
      temp[refIndex] = false;
    }

    if (refIndex === "3DRod" || refIndex === "3G") {
      temp["3"] = false;
    }

    setRequiredStep(temp);
  }

  function selectChanged(e, nums, customText, secondRefIndex, secText) {
    let tempValue = JSON.parse(JSON.stringify(stepSelectedValue));
    let tempLabels = JSON.parse(JSON.stringify(stepSelectedLabel));
    let temp = JSON.parse(JSON.stringify(requiredStep));

    if (e && customText) {
      tempLabels[e] = customText;

      if (secondRefIndex !== undefined) {
        let tempArr1 = secondRefIndex.split(",");
        tempArr1.forEach((ref, index) => {
          if (ref !== undefined) {
            tempLabels[ref] = secText[index];
          }
        });
      }

      if (tempLabels[e] !== "" && requiredStep[e]) {
        temp[e] = false;
      }
    } else if (e) {
      let refIndex = e.target.getAttribute("ref-num");
      tempLabels[refIndex] = e.target.getAttribute("text");
      tempValue[refIndex] = e.target.value;

      if (requiredStep[refIndex]) {
        temp[refIndex] = false;
      }
    }

    if (nums !== undefined) {
      let tempArr = nums.split(",");
      tempArr.forEach((num) => {
        if (num !== undefined) {
          if (tempValue[num] !== undefined) delete tempValue[num];
          if (tempLabels[num] !== undefined) delete tempLabels[num];
          if (tempLabels[num] !== "" && requiredStep[num]) {
            temp[num] = false;
          }
        }
      });
    }

    setStepSelectedLabel(tempLabels);
    setStepSelectedValue(tempValue);

    setRequiredStep((prev) => {
      if (prev["8"] === false) {
        return { ...temp, 8: false };
      } else if (prev["3"] === true) {
        return { ...temp, 3: true };
      } else if (prev["311"]) {
        return { ...temp, 3: false };
      }
      return temp;
    });
  }
  let effectless = [
    "PhotoUrl",
    "PageType",
    "PageId",
    "SheerHeaderStyle",
    "SheerHeaderStyleID",
    "PrivacyLayer",
    "Depth",
    "MouldingHeight",
    "PanelCoverage",
    "hardwareDrapery",
    "hardwareSheer",
    "hardwarePrivacyLayer",
    "hasPowerB",
    "MotorPositionA",
    "MotorPositionB",
    "RemoteNameA",
    "RemoteNameB",
    "MotorChannelsB",
    "hasPowerC",
    "MotorPositionC",
    "RemoteNameC",
    "MotorChannelsC",
    "RoomNameFa",
    "RoomNameEn",
    "WindowName",
    "moreInfoInput",
  ];

  function setCart(refIndex, cartValue, delRefs, secondRefIndex, secondCartValue, customAccCart) {
    let temp = JSON.parse(JSON.stringify(cartValues));
    let changingRefs = [];

    if (refIndex !== undefined) {
      temp[refIndex] = cartValue;
      changingRefs.push(refIndex);
    }
    if (delRefs !== undefined) {
      let tempArr = delRefs.split(",");
      changingRefs.push(...tempArr);
      tempArr.forEach((ref) => {
        if (ref !== undefined) {
          if (temp[ref] !== undefined) delete temp[ref];
        }
      });
    }
    if (secondRefIndex !== undefined) {
      let tempArr1 = secondRefIndex.split(",");
      changingRefs.push(...tempArr1);
      tempArr1.forEach((ref, index) => {
        if (ref !== undefined) {
          temp[ref] = secondCartValue[index];
        }
      });
    }

    let scenario = 0;
    if (!temp["hasRod"]) {
      if (temp["FinishedLengthType"] === "Sill" || temp["FinishedLengthType"] === "Apron") {
        if (
          (temp["Mount"] === "Ceiling" || temp["Mount"] === "Moulding") &&
          (temp["CurtainPosition"] === "Standard" ||
            temp["CurtainPosition"] === "Left Corner Window" ||
            temp["CurtainPosition"] === "Right Corner Window")
        ) {
          scenario = 1;
        } else if (temp["Mount"] === "Wall" && temp["CurtainPosition"] === "Wall to Wall") {
          scenario = 2;
        } else if (
          (temp["Mount"] === "Ceiling" || temp["Mount"] === "Moulding") &&
          temp["CurtainPosition"] === "Wall to Wall"
        ) {
          scenario = 3;
        } else {
          scenario = 4;
        }
      } else {
        if (
          (temp["Mount"] === "Ceiling" || temp["Mount"] === "Moulding") &&
          (temp["CurtainPosition"] === "Standard" ||
            temp["CurtainPosition"] === "Left Corner Window" ||
            temp["CurtainPosition"] === "Right Corner Window")
        ) {
          scenario = 5;
        } else if (temp["Mount"] === "Wall" && temp["CurtainPosition"] === "Wall to Wall") {
          scenario = 6;
        } else if (
          (temp["Mount"] === "Ceiling" || temp["Mount"] === "Moulding") &&
          temp["CurtainPosition"] === "Wall to Wall"
        ) {
          scenario = 7;
        } else {
          scenario = 8;
        }
      }
    } else {
      if (temp["FinishedLengthType"] === "Sill" || temp["FinishedLengthType"] === "Apron") {
        scenario = 9;
      } else {
        scenario = 10;
      }
    }

    let MesSce = ["Mount", "calcMeasurements"];
    if (temp["calcMeasurements"]) {
      MesSce.push(...["hasRod", "FinishedLengthType"]);
      if (scenario === 1) {
        MesSce.push(
          ...[
            "Width3C",
            "ExtensionLeft",
            "ExtensionRight",
            "CeilingToWindow1",
            "CeilingToWindow2",
            "CeilingToWindow3",
            "CeilingToFloor",
          ]
        );
      } else if (scenario === 2) {
        MesSce.push(...["Width3C", "Height3E", "ShadeMount", "CeilingToFloor"]);
      } else if (scenario === 3) {
        MesSce.push(
          ...[
            "Width3C",
            "CeilingToWindow1",
            "CeilingToWindow2",
            "CeilingToWindow3",
            "CeilingToFloor",
          ]
        );
      } else if (scenario === 4) {
        MesSce.push(
          ...[
            "Width3C",
            "Height3E",
            "ExtensionLeft",
            "ExtensionRight",
            "ShadeMount",
            "CeilingToFloor",
          ]
        );
      } else if (scenario === 5) {
        MesSce.push(
          ...[
            "Width3C",
            "ExtensionLeft",
            "ExtensionRight",
            "CeilingToFloor1",
            "CeilingToFloor2",
            "CeilingToFloor3",
          ]
        );
      } else if (scenario === 6) {
        MesSce.push(...["Width3C", "WindowToFloor", "ShadeMount", "CeilingToFloor"]);
      } else if (scenario === 7) {
        MesSce.push(...["Width3C", "CeilingToFloor1", "CeilingToFloor2", "CeilingToFloor3"]);
      } else if (scenario === 8) {
        MesSce.push(
          ...[
            "Width3C",
            "WindowToFloor",
            "ExtensionLeft",
            "ExtensionRight",
            "ShadeMount",
            "CeilingToFloor",
          ]
        );
      } else if (scenario === 9) {
        MesSce.push(...["RodWidth", "RodToBottom", "CeilingToFloor"]);
      } else if (scenario === 10) {
        MesSce.push(...["RodWidth", "RodToFloor", "CeilingToFloor"]);
      }
    } else {
      MesSce.push(...["Width", "Height"]);
    }
    const isMesCompleted = MesSce.every(
      (ref) => Object.keys(temp).includes(ref) && temp[ref] !== undefined
    );
    const isMesCleared =
      delRefs !== undefined &&
      delRefs.split(",").includes("calcMeasurements") &&
      temp["calcMeasurements"] === undefined;
    const isPageLoadEnd =
      refIndex === undefined &&
      cartValue === undefined &&
      delRefs === undefined &&
      secondRefIndex === undefined &&
      secondCartValue === undefined &&
      customAccCart === undefined;
    const isEffectless = changingRefs.every((ref) => effectless.includes(ref));

    // Always persist accessories into cartValues (short path used to skip this)
    if (customAccCart !== undefined) {
      temp["Accessories"] = customAccCart;
    } else if (customAcc.length > 0) {
      temp["Accessories"] = customAcc;
    }

    // Measurement fields were cleared (e.g. mount type change). Persist wipe, clear step-5
    // title, and invalidate in-flight price responses so getWindowSize cannot restore it.
    if (isMesCleared) {
      measureClearEpochRef.current += 1;
      if (temp["WindowWidth"] !== undefined) delete temp["WindowWidth"];
      if (temp["WindowHeight"] !== undefined) delete temp["WindowHeight"];
      if (temp["WidthCart"] !== undefined) delete temp["WidthCart"];
      if (temp["HeightCart"] !== undefined) delete temp["HeightCart"];
      if (
        !pageLoad &&
        !rodsLoad &&
        !rodsLoad2 &&
        !(
          refIndex === undefined &&
          delRefs === undefined &&
          secondRefIndex === undefined &&
          customAccCart === undefined
        )
      ) {
        setCartValues(temp);
      }
      setWindowSize("");
      setWindowSizeBool(false);
      setWidthCart(undefined);
      setWindowWidthPanelType(undefined);
      setHeightCart(undefined);
      setHeightCart2(undefined);
      setPrice(0);
      setPriceBtn(null);
      setCartLoading(false);
      return;
    }

    if (!isPageLoadEnd && (isEffectless || (!isMesCompleted && !widthCart))) {
      if (
        !pageLoad &&
        !rodsLoad &&
        !rodsLoad2 &&
        !(
          refIndex === undefined &&
          delRefs === undefined &&
          secondRefIndex === undefined &&
          customAccCart === undefined
        )
      ) {
        setCartValues(temp);
      }
      setCartLoading(false);
    } else {
      let tempPostObj = {};
      tempPostObj["WindowCount"] = 1;
      tempPostObj["SewingModelId"] = `${modelID}`;
      let userProjects = JSON.parse(JSON.stringify(UserProjects))[`${modelID}`]["data"];
      Object.keys(temp).forEach((key) => {
        if (temp[key] !== undefined && temp[key] !== null && temp[key] !== "") {
          let tempObj = userProjects.find((obj) => obj["cart"] === key);
          if (tempObj === undefined) {
          } else {
            if (tempObj && tempObj["apiLabel"] !== "") {
              if (tempObj["apiValue"] === null) {
                tempPostObj[tempObj["apiLabel"]] = temp[key];
              } else {
                tempPostObj[tempObj["apiLabel"]] = tempObj["apiValue"][temp[key]];
              }
            }
          }
        }
      });

      tempPostObj["SewingOrderDetails"] = [];
      for (let i = 0; i < 3; i++) {
        tempPostObj["SewingOrderDetails"][i] = {};
        tempPostObj["SewingOrderDetails"][i]["IsLowWrinkle"] = true;
        tempPostObj["SewingOrderDetails"][i]["IsCoverAll"] =
          i === 0 ? step5 !== "Decorative" : true;
        tempPostObj["SewingOrderDetails"][i]["IsAltogether"] = true;
      }

      tempPostObj["SewingOrderDetails"][0]["CurtainPartId"] = 2303;
      tempPostObj["SewingOrderDetails"][0]["SewingModelId"] = `${modelID}`;

      tempPostObj["SewingOrderDetails"][1]["CurtainPartId"] = 2302;
      tempPostObj["SewingOrderDetails"][1]["SewingModelId"] = tempPostObj["SewingModelId"];

      tempPostObj["SewingOrderDetails"][2]["CurtainPartId"] = 2301;
      tempPostObj["SewingOrderDetails"][2]["SewingModelId"] = tempPostObj["SewingModelId"];

      Object.keys(temp).forEach((key) => {
        if (temp[key] !== undefined && temp[key] !== null && temp[key] !== "") {
          let tempObj = userProjects.find((obj) => obj["cart"] === key);
          if (tempObj) {
            for (let i = 0; i < 3; i++) {
              let j = +i + +2;
              if (tempObj["apiLabel" + j] !== undefined) {
                if (tempObj["apiValue" + j] === null) {
                  tempPostObj["SewingOrderDetails"][i][tempObj["apiLabel" + j]] = temp[key];
                } else {
                  tempPostObj["SewingOrderDetails"][i][tempObj["apiLabel" + j]] =
                    tempObj["apiValue" + j][temp[key]];
                }
              }
            }
          }
        }
      });
      tempPostObj["SewingOrderDetails"][0]["Accessories"] = [];
      tempPostObj["SewingOrderDetails"][1]["Accessories"] = [];
      tempPostObj["SewingOrderDetails"][2]["Accessories"] = [];
      Object.keys(temp).forEach((key) => {
        if (temp[key] !== undefined && temp[key] !== null && temp[key] !== "") {
          let tempObj = userProjects.find((obj) => obj["cart"] === key);
          if (tempObj) {
            if (tempObj["apiAcc"] !== undefined) {
              if (tempObj["apiAcc"] === true && tempObj["apiAccValue"][temp[key]]) {
                tempPostObj["SewingOrderDetails"][0]["Accessories"].push(
                  tempObj["apiAccValue"][temp[key]]
                );
              } else if (tempObj["apiAcc"] === "value") {
                let pushObj = tempObj["apiAccValue"] || {};
                pushObj["SewingAccessoryValue"] = temp[key].toString();
                tempPostObj["SewingOrderDetails"][0]["Accessories"].push(pushObj);
              }
            }
            if (tempObj["apiAcc2"] !== undefined) {
              if (tempObj["apiAcc2"] === true && tempObj["apiAccValue2"][temp[key]]) {
                tempPostObj["SewingOrderDetails"][1]["Accessories"].push(
                  tempObj["apiAccValue2"][temp[key]]
                );
              } else if (tempObj["apiAcc"] === "value") {
                let pushObj = tempObj["apiAccValue2"] || {};
                pushObj["SewingAccessoryValue"] = temp[key].toString();
                tempPostObj["SewingOrderDetails"][1]["Accessories"].push(pushObj);
              }
            }
            if (tempObj["apiAcc3"] !== undefined) {
              if (tempObj["apiAcc3"] === true && tempObj["apiAccValue3"][temp[key]]) {
                tempPostObj["SewingOrderDetails"][2]["Accessories"].push(
                  tempObj["apiAccValue3"][temp[key]]
                );
              } else if (tempObj["apiAcc"] === "value") {
                let pushObj = tempObj["apiAccValue3"] || {};
                pushObj["SewingAccessoryValue"] = temp[key].toString();
                tempPostObj["SewingOrderDetails"][2]["Accessories"].push(pushObj);
              }
            }
          }
        }
      });
      if (customAccCart && customAccCart.length > 0) {
        tempPostObj["SewingOrderDetails"][0]["Accessories"].push(...customAccCart);
        temp["Accessories"] = customAccCart;
      } else if (customAcc.length > 0) {
        tempPostObj["SewingOrderDetails"][0]["Accessories"].push(...customAcc);
        temp["Accessories"] = customAcc;
      }
      tempPostObj["SewingOrderDetails"][0]["Accessories"] = tempPostObj["SewingOrderDetails"][0][
        "Accessories"
      ].filter(function(el) {
        return el != null;
      });

      if (
        !pageLoad &&
        !rodsLoad &&
        !rodsLoad2 &&
        !(
          refIndex === undefined &&
          delRefs === undefined &&
          secondRefIndex === undefined &&
          customAccCart === undefined
        )
      ) {
        setCartValues(temp);
      }

      let promise2 = new Promise((resolve, reject) => {
        if (step3 !== "" && !pageLoad && !rodsLoad && !rodsLoad2) {
          for (let i = tempPostObj["SewingOrderDetails"].length - 1; i >= 0; i--) {
            if (
              tempPostObj["SewingOrderDetails"] &&
              tempPostObj["SewingOrderDetails"][i] &&
              tempPostObj["SewingOrderDetails"][i]["FabricId"] === undefined
            ) {
              tempPostObj["SewingOrderDetails"].splice(i, 1);
            }
          }
          if (zipcode && zipcode !== "") {
            tempPostObj["ZipCode"] = zipcode;
          }
          if (hasZipcode && hasZipcode !== "") {
            tempPostObj["ZipCode"] = hasZipcode;
            delete tempPostObj["InstallAmount"];
            delete tempPostObj["TransportationAmount"];
          }

          if (!tempPostObj.hasOwnProperty("Height1")) {
            tempPostObj.Height1 = tempPostObj.WindowHeight;
          }
          if (!tempPostObj.hasOwnProperty("Width1")) {
            tempPostObj.Width1 = tempPostObj.WindowWidth;
          }
          const liningTypeIdMap = {
            "Standard Lining": 6002,
            "Privacy Lining": 6003,
          };
          tempPostObj["SewingOrderDetails"].forEach((detail) => {
            if (detail && detail["LiningId"] !== undefined) {
              delete detail["LiningId"];
            }
          });
          const liningTypeId = liningTypeIdMap[tempPostObj["Lining"]];
          if (liningTypeId !== undefined && tempPostObj["SewingOrderDetails"][0]) {
            tempPostObj["SewingOrderDetails"][0]["LiningTypeId"] = liningTypeId;
          }
          const measureEpochAtRequest = measureClearEpochRef.current;
          axios
            .post(baseURLPrice, tempPostObj)
            .then((response) => {
              // Ignore stale price responses after measurement wipe (mount change, etc.)
              if (measureEpochAtRequest !== measureClearEpochRef.current) {
                resolve();
                return;
              }
              setPrice(response.data["Price"]);
              setPriceBtn(response.data["Price"]);
              setWindowWidthPanelType(response.data["WindowWidth"]);
              setWidthCart(response.data["Width"]);
              setLiningPrice(response.data["LiningPrice"]);
              response?.data?.SewingOrderDetails.forEach((detail) => {
                if (detail.CurtainPartId === 2303) {
                  setHandCurtainPricDrapery(detail.HandCurtainPrice);
                } else if (detail.CurtainPartId === 2302) {
                  setHandCurtainPricSheer(detail.HandCurtainPrice);
                }
              });
              if (response.data["Price"]) {
                setInstallPrice(
                  response.data["InstallAmount"] ? response.data["InstallAmount"] : 0
                );
                setTransportPrice(
                  response.data["TransportationAmount"] ? response.data["TransportationAmount"] : 0
                );
                setHasInstall(!!response.data["TransportationAmount"]);
              }

              if (
                response.data["SewingOrderDetails"] &&
                response.data["SewingOrderDetails"].length &&
                (!response.data["ErrorCode"] || response.data["ErrorCode"] === "")
              ) {
                setFabricsBoard(
                  response.data["SewingOrderDetails"]
                    .filter((obj) => ["2302", "2303"].includes(obj["CurtainPartId"].toString()))
                    .map(({ CurtainPartId, FabricId, IsBoard, BoardNum }) => ({
                      CurtainPartId,
                      FabricId,
                      IsBoard,
                      BoardNum,
                    }))
                );
              } else if (
                boardLoad &&
                refIndex === undefined &&
                delRefs === undefined &&
                secondRefIndex === undefined &&
                customAccCart === undefined
              ) {
                setBoardLoad(false);
              } else if (
                response.data["SewingOrderDetails"] &&
                response.data["SewingOrderDetails"].length &&
                response.data["ErrorCode"] &&
                response.data["ErrorCode"] !== ""
              ) {
                setBoardLoad(true);
              }

              getWindowSize(response.data["WindowWidth"], response.data["WindowHeight"]);
              temp["WindowWidth"] = response.data["WindowWidth"];
              temp["WindowHeight"] = response.data["WindowHeight"];
              temp["WidthCart"] = response.data["Width"];
              temp["HeightCart"] = response.data["Height"];
              setWidthCart(response.data["Width"] ? response.data["Width"] : undefined);
              setWindowWidthPanelType(response.data["WindowWidth"] ? response.data["WindowWidth"] : undefined);
              setHeightCart(response.data["Height"] ? response.data["Height"] : undefined);
              setHeightCart2(
                response.data["WindowHeight"] ? response.data["WindowHeight"] : undefined
              );

              if (response.data["ErrorCode"] && response.data["ErrorCode"] === 230) {
                setFabricError(true);
                setErrorData(response.data);
              }
              resolve();
            })
            .catch((err) => {
              if (measureEpochAtRequest !== measureClearEpochRef.current) {
                resolve();
                return;
              }
              setPrice(0);
              setPriceBtn(null);
              setWindowSize("");
              setLiningPrice(0);
              setHandCurtainPricDrapery(0);
              setHandCurtainPricSheer(0);
              setWidthCart(undefined);
              setWindowWidthPanelType(undefined);
              setHeightCart(undefined);
              setHeightCart2(undefined);
              setWindowSizeBool(false);
              resolve(1);
            });
        } else {
          resolve();
        }
      });
      promise2.then((res) => {
        setCartLoading(false);
        setFabricLoading(false);
      });
    }
  }

  function measureWindowSize(zipcode) {
    let promise2 = new Promise((resolve, reject) => {
      let temp = JSON.parse(JSON.stringify(cartValues));
      let tempPostObj = {};
      tempPostObj["WindowCount"] = 1;
      tempPostObj["SewingModelId"] = `${modelID}`;

      let userProjects = JSON.parse(JSON.stringify(UserProjects))[`${modelID}`]["data"];

      Object.keys(temp).forEach((key) => {
        if (temp[key] !== undefined && temp[key] !== null && temp[key] !== "") {
          let tempObj = userProjects.find((obj) => obj["cart"] === key);
          if (tempObj === undefined) {
          } else {
            if (tempObj && tempObj["apiLabel"] !== "") {
              if (tempObj["apiValue"] === null) {
                tempPostObj[tempObj["apiLabel"]] = temp[key];
              } else {
                tempPostObj[tempObj["apiLabel"]] = tempObj["apiValue"][temp[key]];
              }
            }
          }
        }
      });

      tempPostObj["SewingOrderDetails"] = [];
      for (let i = 0; i < 3; i++) {
        tempPostObj["SewingOrderDetails"][i] = {};
        tempPostObj["SewingOrderDetails"][i]["IsLowWrinkle"] = true;
        tempPostObj["SewingOrderDetails"][i]["IsCoverAll"] =
          i === 0 ? step5 !== "Decorative" : true;
        tempPostObj["SewingOrderDetails"][i]["IsAltogether"] = true;
      }

      tempPostObj["SewingOrderDetails"][0]["CurtainPartId"] = 2303;
      tempPostObj["SewingOrderDetails"][0]["SewingModelId"] = `${modelID}`;

      tempPostObj["SewingOrderDetails"][1]["CurtainPartId"] = 2302;
      tempPostObj["SewingOrderDetails"][1]["SewingModelId"] = tempPostObj["SewingModelId"];

      tempPostObj["SewingOrderDetails"][2]["CurtainPartId"] = 2301;
      tempPostObj["SewingOrderDetails"][2]["SewingModelId"] = tempPostObj["SewingModelId"];

      Object.keys(temp).forEach((key) => {
        if (temp[key] !== undefined && temp[key] !== null && temp[key] !== "") {
          let tempObj = userProjects.find((obj) => obj["cart"] === key);
          if (tempObj) {
            for (let i = 0; i < 3; i++) {
              let j = +i + +2;
              if (tempObj["apiLabel" + j] !== undefined) {
                if (tempObj["apiValue" + j] === null) {
                  tempPostObj["SewingOrderDetails"][i][tempObj["apiLabel" + j]] = temp[key];
                } else {
                  tempPostObj["SewingOrderDetails"][i][tempObj["apiLabel" + j]] =
                    tempObj["apiValue" + j][temp[key]];
                }
              }
            }
          }
        }
      });
      tempPostObj["SewingOrderDetails"][0]["Accessories"] = [];
      tempPostObj["SewingOrderDetails"][1]["Accessories"] = [];
      tempPostObj["SewingOrderDetails"][2]["Accessories"] = [];
      Object.keys(temp).forEach((key) => {
        if (temp[key] !== undefined && temp[key] !== null && temp[key] !== "") {
          let tempObj = userProjects.find((obj) => obj["cart"] === key);
          if (tempObj) {
            if (tempObj["apiAcc"] !== undefined) {
              if (tempObj["apiAcc"] === true && tempObj["apiAccValue"][temp[key]]) {
                tempPostObj["SewingOrderDetails"][0]["Accessories"].push(
                  tempObj["apiAccValue"][temp[key]]
                );
              } else {
              }
            }
            if (tempObj["apiAcc2"] !== undefined) {
              if (tempObj["apiAcc2"] === true && tempObj["apiAccValue2"][temp[key]]) {
                tempPostObj["SewingOrderDetails"][1]["Accessories"].push(
                  tempObj["apiAccValue2"][temp[key]]
                );
              } else {
              }
            }
            if (tempObj["apiAcc3"] !== undefined) {
              if (tempObj["apiAcc3"] === true && tempObj["apiAccValue3"][temp[key]]) {
                tempPostObj["SewingOrderDetails"][2]["Accessories"].push(
                  tempObj["apiAccValue3"][temp[key]]
                );
              } else {
              }
            }
          }
        }
      });
      if (customAcc.length > 0) {
        tempPostObj["SewingOrderDetails"][0]["Accessories"].push(...customAcc);
      }
      tempPostObj["SewingOrderDetails"][0]["Accessories"] = tempPostObj["SewingOrderDetails"][0][
        "Accessories"
      ].filter(function(el) {
        return el != null;
      });

      if (step3 !== "") {
        for (let i = tempPostObj["SewingOrderDetails"].length - 1; i >= 0; i--) {
          if (
            tempPostObj["SewingOrderDetails"] &&
            tempPostObj["SewingOrderDetails"][i] &&
            tempPostObj["SewingOrderDetails"][i]["FabricId"] === undefined
          ) {
            tempPostObj["SewingOrderDetails"].splice(i, 1);
          }
        }

        if (zipcode && zipcode !== "") {
          tempPostObj["ZipCode"] = zipcode;
        }
        const liningTypeIdMap = {
          "Standard Lining": 6002,
          "Privacy Lining": 6003,
        };
        tempPostObj["SewingOrderDetails"].forEach((detail) => {
          if (detail && detail["LiningId"] !== undefined) {
            delete detail["LiningId"];
          }
        });
        const liningTypeId = liningTypeIdMap[tempPostObj["Lining"]];
        if (liningTypeId !== undefined && tempPostObj["SewingOrderDetails"][0]) {
          tempPostObj["SewingOrderDetails"][0]["LiningTypeId"] = liningTypeId;
        }
        axios
          .post(baseURLPrice, tempPostObj)
          .then((response) => {
            if (zipcode && zipcode !== "") {
              if (response.data["Price"]) {
                setInstallPrice(
                  response.data["InstallAmount"] ? response.data["InstallAmount"] : 0
                );
                setTransportPrice(
                  response.data["TransportationAmount"] ? response.data["TransportationAmount"] : 0
                );
                setHasInstall(!!response.data["TransportationAmount"]);
                setZipcodeButton(true);
              } else {
                HasInstall(zipcode);
              }
            } else {
              setPrice(response.data["Price"]);
              setPriceBtn(response.data["Price"]);
              setLiningPrice(response.data["LiningPrice"]);
              response?.data?.SewingOrderDetails.forEach((detail) => {
                if (detail.CurtainPartId === 2303) {
                  setHandCurtainPricDrapery(detail.HandCurtainPrice);
                } else if (detail.CurtainPartId === 2302) {
                  setHandCurtainPricSheer(detail.HandCurtainPrice);
                }
              });
              getWindowSize(response.data["WindowWidth"], response.data["WindowHeight"]);
              temp["WindowWidth"] = response.data["WindowWidth"];
              temp["WindowHeight"] = response.data["WindowHeight"];
              temp["WidthCart"] = response.data["Width"];
              temp["HeightCart"] = response.data["Height"];
              setWidthCart(response.data["Width"] ? response.data["Width"] : undefined);
              setWindowWidthPanelType(response.data["WindowWidth"] ? response.data["WindowWidth"] : undefined);
              setHeightCart(response.data["Height"] ? response.data["Height"] : undefined);
              setHeightCart2(
                response.data["WindowHeight"] ? response.data["WindowHeight"] : undefined
              );
              setCartValues(temp);
              setTimeout(() => {
                resolve();
              }, 1000);
            }
          })
          .catch((err) => {
            if (zipcode && zipcode !== "") {
              setInstallPrice(-1);
              setTransportPrice(-1);
              HasInstall(zipcode);
              setTimeout(() => {
                reject();
              }, 1000);
            } else {
              setWidthCart(undefined);
              setWindowWidthPanelType(undefined);
              setHeightCart(undefined);
              setHeightCart2(undefined);
              setPrice(0);
              setPriceBtn(null);
              if (temp["HeightCart"] !== undefined) delete temp["HeightCart"];
              if (temp["WidthCart"] !== undefined) delete temp["WidthCart"];

              if (temp["WindowHeight"] !== undefined) delete temp["WindowHeight"];
              if (temp["WindowWidth"] !== undefined) delete temp["WindowWidth"];
              setWindowSizeBool(false);
              setCartValues(temp);
              setTimeout(() => {
                reject();
              }, 1000);
            }
          });
      } else {
        HasInstall(zipcode);
        reject();
      }
    });
    promise2
      .then(() => {
        return true;
      })
      .catch(() => {
        return false;
      });
  }

  function HasInstall(zipcode) {
    axios
      .post(
        baseURLZipCode,
        {},
        {
          params: {
            zipCode: zipcode,
          },
        }
      )
      .then((response) => {
        setHasInstall(response.data);
        setZipcodeButton(true);
      })
      .catch((err) => {
        setHasInstall(false);
        setZipcodeChecked("false");
        setCart("", "", "ZipCode");
        setZipcodeButton(true);
      });
  }
  function clearInputs(e, nums, addNums, Scenario) {
    if (Scenario === undefined) {
      setWidth(undefined);
      setHeight(undefined);
      setRodToBottom(undefined);
      setRodToFloor(undefined);
      setWindowToFloor(undefined);
      setCeilingToWindow1(undefined);
      setCeilingToWindow2(undefined);
      setCeilingToWindow3(undefined);
      setCeilingToFloor(undefined);
      setCeilingToFloor1(undefined);
      setCeilingToFloor2(undefined);
      setCeilingToFloor3(undefined);
      setWidth3C(undefined);
      setRodWidth(undefined);
      setLeft(undefined);
      setRight(undefined);
      setHeight3E(undefined);
      setMount(undefined);
      setStepSelectedOptions({ values: {}, labels: {} });
    } else if (Scenario === "HeightDif") {
      setCeilingToWindow1(undefined);
      setCeilingToWindow2(undefined);
      setCeilingToWindow3(undefined);
      setCeilingToFloor1(undefined);
      setCeilingToFloor2(undefined);
      setCeilingToFloor3(undefined);
    }

    setTimeout(() => {
      setWindowSizeBool(false);
      selectChanged(
        e,
        nums
          ? nums
          : "3C,3D,3E,3EFloor,3EStandardCeiling,3EStandardCeilingFloor,3F,3G,3BRod,3CRod,3CRodFloor,3DRod" +
              (addNums ? "," + addNums : "")
      );
    }, 100);
  }

  function selectUncheck(e) {
    let refIndex = e.target.getAttribute("ref-num");
    let tempLabels = JSON.parse(JSON.stringify(stepSelectedLabel));
    delete tempLabels[refIndex];
    setStepSelectedLabel(tempLabels);

    let tempValue = JSON.parse(JSON.stringify(stepSelectedValue));
    if (tempValue[refIndex] !== undefined) delete tempValue[refIndex];
    setStepSelectedValue(tempValue);
    e.target.checked = false;
  }

  function fabricClicked(photo, hasTrim) {
    if(photo !== undefined && photo !== null && photo !== "") {
      setDefaultFabricPhoto(photo);
    }
  }
  const [isClickStep4, setIsClickStep4] = useState(true);
  function setDeps(addDeps, removeDeps, notMainStep) {
    console.log({
      "Added Dependencies": addDeps,
      "Removed Dependencies": removeDeps,
    });

    let temp = JSON.parse(JSON.stringify(requiredStep));
    let depSetTempArr = new Set([...depSet]);
    if (addDeps !== undefined && addDeps !== "") {
      let tempArr = addDeps.split(",");
      tempArr.forEach((dep) => {
        if (dep !== undefined && dep !== "") {
          depSetTempArr.add(dep);
        }
      });
    }
    if (removeDeps !== undefined && removeDeps !== "") {
      let tempArr = removeDeps.split(",");
      tempArr.forEach((dep) => {
        if (dep !== undefined && dep !== "") {
          depSetTempArr = new Set([...depSetTempArr].filter((x) => x !== dep));

          let tempDep = "";
          if (notMainStep) {
            tempDep = dep.slice(0, Math.abs(notMainStep) * -1);
          } else {
            tempDep = dep;
          }

          if (
            requiredStep[tempDep] &&
            [...depSetTempArr].findIndex((el) => el.startsWith(tempDep) && el.charAt(1) !== "0") ===
              -1
          ) {
            temp[tempDep] = false;
          }
        }
      });
    }

    setDepSet(depSetTempArr);

    setRequiredStep((prev) => {
      if (prev["2"] === false && isClickStep4) {
        setIsClickStep4(false);
        return { ...temp, 2: false };
      } else if (prev["3"] && removeDeps === "312") {
        return { ...temp, 3: false };
      }
      if (removeDeps === "211" || removeDeps === "21,211") {
        return { ...temp, 2: false };
      }
      if (removeDeps === "6B,6C" && step2B === "None") {
        return { ...temp, 6: false };
      }
      if (removeDeps === "8P6,888") {
        return { ...temp, 8: false };
      }
      if (removeDeps === "8P6,888") {
        return { ...temp, 8: false };
      } else if (removeDeps === "8C,8C1,8C2,8C3,8C5,888") {
        return { ...temp, 8: false };
      } else if (removeDeps === "8,8A,8A1,8A2,8B,8B1,8B2,8C,8C1,8C2,8C3,8P5,888") {
        return { ...temp, 8: false };
      }
      return temp;
    });
  }
  const [allBags, setAllBags] = useState({});
  function addToCart() {
    let shouldRemove9A = remove9A;

    if (allBags["DraperyHardware"] === "Rod" && cartValues["DraperyHardware"] === "Track") {
      shouldRemove9A = true;
      setRemove9A(true);
    }
    let temp = JSON.parse(JSON.stringify(requiredStep));
    let tempErr = {};
    let promiseArr = [];
    if (step8 === "Same Hardware For All Curtains") {
      const excludedValues = new Set([
        "81",
        "82",
        "8B2",
        "8B3",
        "83",
        "3BRod",
        "3CRodFloor",
        "3DRod",
        "8B61",
      ]);
      for (let val of excludedValues) {
        depSet.delete(val);
      }
    } else if (step8 === "I Want To Customize Hardware Per Curtain" || step3 === "false") {
      const excludedValues = new Set([
        "8A1",
        "8A2",
        "8B2",
        "8B3",
        "3BRod",
        "3CRodFloor",
        "3DRod",
        "8A3",
        "8B61",
      ]);
      for (let val of excludedValues) {
        depSet.delete(val);
      }
    } else if (step8 === "I Have My Own Hardware") {
      const excludedValues = new Set(["3BRod", "3CRodFloor", "3DRod"]);
      for (let val of excludedValues) {
        depSet.delete(val);
      }
    }
    if (step5 === "Full") {
      depSet.delete("5");
    }
    
    if (step2B === "None") {
      depSet.delete("6");
    }
    let tempDepSet = [...depSet];
    console.log(`tempDepSet`, tempDepSet);
    tempDepSet.forEach((dependency, index) => {
      promiseArr[index] = new Promise((resolve, reject) => {
        if (steps.current[dependency] !== undefined && steps.current[dependency] !== null) {
          temp[dependency] = true;

          let type =
            steps.current[dependency].getAttribute("type-of-step") === "1"
              ? pageLanguage === "fa"
                ? ""
                : ""
              : pageLanguage === "fa"
              ? ""
              : "";
          tempErr[dependency] = {
            order: dependency,
            el: (
              <li key={index}>
                {pageLanguage === "fa"
                  ? "" + steps.current[dependency].getAttribute("cart-custom-text") + type
                  : "" + type + steps.current[dependency].getAttribute("cart-custom-text")}
              </li>
            ),
          };
        }
        resolve();
      });
    });

    Promise.all(promiseArr).then(() => {
      if (depSet.size > 0) {
        let promiseArr2 = [];
        Object.keys(depDetails.current).forEach((key, index) => {
          promiseArr2[index] = new Promise((resolve, reject) => {
            let promiseArr3 = [];
            Object.keys(depDetails.current[key]).forEach((key2, index2) => {
              promiseArr3[index2] = new Promise((resolve, reject) => {
                if (
                  depDetails.current[key][key2] !== undefined &&
                  depDetails.current[key][key2] !== null &&
                  tempDepSet.includes(key2)
                ) {
                  let depGroup =
                    depDetails.current[key][key2].getAttribute("dep-group") === ""
                      ? key2
                      : depDetails.current[key][key2].getAttribute("dep-group");
                  // let depType=depDetails.current[key][key2].getAttribute("dep-type")||"";
                  let depText = depDetails.current[key][key2].getAttribute("text") || "";
                  if (steps.current[depGroup] !== undefined && steps.current[depGroup] !== null) {
                    temp[depGroup] = true;
                    if (tempErr[depGroup] === undefined) {
                      let type =
                        steps.current[depGroup].getAttribute("type-of-step") === "1"
                          ? pageLanguage === "fa"
                            ? ""
                            : ""
                          : pageLanguage === "fa"
                          ? ""
                          : "";
                      tempErr[depGroup] = {
                        order: depGroup,
                        el: (
                          <li key={index}>
                            {pageLanguage === "fa"
                              ? "" + steps.current[depGroup].getAttribute("cart-custom-text") + type
                              : "" +
                                type +
                                steps.current[depGroup].getAttribute("cart-custom-text")}
                          </li>
                        ),
                      };
                    }
                    resolve();
                  } else {
                    temp[key] = true;
                    if (tempErr[depGroup] === undefined) {
                      tempErr[depGroup] = {
                        order: depGroup,
                        el: <li key={index + "_" + index2}>{depText}</li>,
                      };
                    }
                    resolve();
                  }
                } else {
                  resolve();
                }
              });
            });

            Promise.all(promiseArr3)
              .then(() => {
                resolve();
              })
              .catch((err) => {
                console.log(err);
                resolve();
              });
          });
        });

        Promise.all(promiseArr2)
          .then(() => {
            const special = ["جانمایی پرده", "Room Label"];

            // ترتیب دلخواه
            // const customOrder = [
            //   "1","11","111", "2","21","211", "2A", "2B","2B1", "2C", "3A0", "3", "4", "5", "6","6A","6B","6C", "8", "10"
            // ];

            // const customOrder = [
            //   "1",
            //   "11",
            //   "111",
            //   "2",
            //   "21",
            //   "211",
            //   "2A",
            //   "2B",
            //   "2B1",
            //   "2C",
            //   "3A0",
            //   "3",
            //   "4",
            //   "5",
            //   "6",
            //   "6A",
            //   "6B",
            //   "6C",
            //   "8",
            //   "8A",
            //   "85",
            //   "84",
            //   "809",
            //   "810",
            //   "811",
            //   "812",
            //   "813",
            //   "8A1",
            //   "8A2",
            //   "8A3",
            //   "8C3",
            //   "8A4",
            //   "8C5",
            //   "8P5",
            //   "8P6",
            //   "814",
            //   "842",
            //   "843",
            //   "844",
            //   "845",
            //   "846",
            //   "847",
            //   "848",
            //   "86",
            //   "8B",
            //   "8B1",
            //   "8B2",
            //   "8B3",
            //   "8B5",
            //   "8B51",
            //   "8B6",
            //   "849",
            //   "850",
            //   "852",
            //   "853",
            //   "854",
            //   "855",
            //   "856",
            //   "857",
            //   "87",
            //   "8C",
            //   "8C1",
            //   "8C2",
            //   "8C51",
            //   "8C52",
            //   "8C6",
            //   "858",
            //   "859",
            //   "860",
            //   "861",
            //   "862",
            //   "863",
            //   "864",
            //   "865",
            //   "10",
            // ];
            const customOrder = [
              "1",
              "11",
              "111",
              "2",
              "21",
              "211",
              "2A",
              "2B",
              "2B1",
              "2C",
              "3A0",
              "3",
              "3C",
              "3D",
              "3EFloor",
              "3F",
              "3G",
              "3BRod",
              "3BRodHaveRod",
              "3CRodIHave",
              "3CRodFloorHaveRod",
              "3CRod",
              "3CRodFloor",
              "3DRod",
              "3EStandardCeilingFloor",
              "4",
              "5",
              "6",
              "6A",
              "6B",
              "6C",
              "8",
              "8A",
              "85",
              "84",
              "809",
              "810",
              "811",
              "812",
              "813",
              "8A1",
              "8A2",
              "8A3",
              "8C3",
              "8A4",
              "8C5",
              "8P5",
              "8P6",
              "814",
              "842",
              "843",
              "844",
              "845",
              "846",
              "847",
              "848",
              "86",
              "8B",
              "8B1",
              "8B2",
              "8B3",
              "8B5",
              "8B51",
              "8B6",
              "849",
              "850",
              "852",
              "853",
              "854",
              "855",
              "856",
              "857",
              "87",
              "8C",
              "8C1",
              "8C2",
              "8C51",
              "8C52",
              "8C6",
              "858",
              "859",
              "860",
              "861",
              "862",
              "863",
              "864",
              "865",
              "10",
            ];

            function getOrderIndex(order) {
              const idx = customOrder.indexOf(order);
              return idx === -1 ? Number.MAX_SAFE_INTEGER : idx;
            }

            console.log(`tempErr`, tempErr);

            const sortedArray = Object.entries(tempErr)
              .sort((a, b) => {
                const aText = a[1].el.props.children;
                const bText = b[1].el.props.children;

                return (
                  special.includes(aText) - special.includes(bText) ||
                  getOrderIndex(a[1].order) - getOrderIndex(b[1].order)
                );
              })
              .map(([, value]) => {
                const originalEl = value.el;
                const className = pageLanguage === "fa" ? "farsi" : "";
                return <li className={className}>{originalEl.props.children}</li>;
              });

            setAddCartErr(sortedArray);
            setRequiredStep(temp);
            modalHandleShow("addToCartErr");
            setAddingLoading(false);
          })

          .catch((err) => {
            console.log(err);
            setAddingLoading(false);
          });
      } else if (heightCart === undefined || widthCart === undefined) {
        if (measureWindowSize()) {
          addToCart();
        } else {
          setAddingLoading(false);
        }
      } else {
        if (price) {
          let userProjects = JSON.parse(JSON.stringify(UserProjects))[`${modelID}`]["data"];
          let tempArr = [];
          let temp1 = [];
          let temp2 = [];
          let temp3 = [];
          let temp4 = [];
          let temp5 = [];
          let temp = JSON.parse(JSON.stringify(cartValues));
          let tempPostObj = {};
          let tempBagPrice = 0;
          tempPostObj["WindowCount"] = 1;
          tempPostObj["SewingModelId"] = `${modelID}`;
          Object.keys(temp).forEach((key) => {
            if (temp[key] !== undefined && temp[key] !== null && temp[key] !== "") {
              let tempObj = userProjects.find((obj) => obj["cart"] === key);
              if (tempObj && tempObj["apiLabel"] !== "") {
                if (tempObj["apiValue"] === null) {
                  tempPostObj[tempObj["apiLabel"]] = temp[key];
                } else {
                  tempPostObj[tempObj["apiLabel"]] = tempObj["apiValue"][temp[key]];
                }
              }
            }
          });

          tempPostObj["SewingOrderDetails"] = [];
          for (let i = 0; i < 3; i++) {
            tempPostObj["SewingOrderDetails"][i] = {};
            tempPostObj["SewingOrderDetails"][i]["IsLowWrinkle"] = true;
            tempPostObj["SewingOrderDetails"][i]["IsCoverAll"] =
              i === 0 ? step5 !== "Decorative" : true;
            tempPostObj["SewingOrderDetails"][i]["IsAltogether"] = true;
          }

          tempPostObj["SewingOrderDetails"][0]["CurtainPartId"] = 2303;
          tempPostObj["SewingOrderDetails"][0]["SewingModelId"] = `${modelID}`;

          tempPostObj["SewingOrderDetails"][1]["CurtainPartId"] = 2302;
          tempPostObj["SewingOrderDetails"][1]["SewingModelId"] = tempPostObj["SewingModelId"];

          tempPostObj["SewingOrderDetails"][2]["CurtainPartId"] = 2301;
          tempPostObj["SewingOrderDetails"][2]["SewingModelId"] = tempPostObj["SewingModelId"];

          Object.keys(temp).forEach((key) => {
            if (temp[key] !== undefined && temp[key] !== null && temp[key] !== "") {
              let tempObj = userProjects.find((obj) => obj["cart"] === key);
              if (tempObj) {
                for (let i = 0; i < 3; i++) {
                  let j = +i + +2;
                  if (tempObj["apiLabel" + j] !== undefined) {
                    if (tempObj["apiValue" + j] === null) {
                      tempPostObj["SewingOrderDetails"][i][tempObj["apiLabel" + j]] = temp[key];
                    } else {
                      tempPostObj["SewingOrderDetails"][i][tempObj["apiLabel" + j]] =
                        tempObj["apiValue" + j][temp[key]];
                    }
                  }
                }
              }
            }
          });
          tempPostObj["SewingOrderDetails"][0]["Accessories"] = [];
          tempPostObj["SewingOrderDetails"][1]["Accessories"] = [];
          tempPostObj["SewingOrderDetails"][2]["Accessories"] = [];
          Object.keys(temp).forEach((key) => {
            if (temp[key] !== undefined && temp[key] !== null && temp[key] !== "") {
              let tempObj = userProjects.find((obj) => obj["cart"] === key);
              if (tempObj) {
                if (tempObj["apiAcc"] !== undefined) {
                  if (tempObj["apiAcc"] === true && tempObj["apiAccValue"][temp[key]]) {
                    tempPostObj["SewingOrderDetails"][0]["Accessories"].push(
                      tempObj["apiAccValue"][temp[key]]
                    );
                  } else {
                  }
                }
                if (tempObj["apiAcc2"] !== undefined) {
                  if (tempObj["apiAcc2"] === true && tempObj["apiAccValue2"][temp[key]]) {
                    tempPostObj["SewingOrderDetails"][1]["Accessories"].push(
                      tempObj["apiAccValue2"][temp[key]]
                    );
                  } else {
                  }
                }
                if (tempObj["apiAcc3"] !== undefined) {
                  if (tempObj["apiAcc3"] === true && tempObj["apiAccValue3"][temp[key]]) {
                    tempPostObj["SewingOrderDetails"][2]["Accessories"].push(
                      tempObj["apiAccValue3"][temp[key]]
                    );
                  } else {
                  }
                }
              }
            }
          });
          if (customAcc.length > 0) {
            tempPostObj["SewingOrderDetails"][0]["Accessories"].push(...customAcc);
          }
          tempPostObj["SewingOrderDetails"][0]["Accessories"] = tempPostObj[
            "SewingOrderDetails"
          ][0]["Accessories"].filter(function(el) {
            return el != null;
          });
          tempPostObj["SewingModelId"] = tempPostObj["SewingOrderDetails"][0]["SewingModelId"];
          for (let i = tempPostObj["SewingOrderDetails"].length - 1; i >= 0; i--) {
            if (
              tempPostObj["SewingOrderDetails"] &&
              tempPostObj["SewingOrderDetails"][i] &&
              tempPostObj["SewingOrderDetails"][i]["FabricId"] === undefined
            ) {
              tempPostObj["SewingOrderDetails"].splice(i, 1);
            }
          }
          if (tempPostObj["SewingOrderDetails"][0]["FabricId"] !== undefined) {
            const liningTypeIdMap = {
              "Standard Lining": 6002,
              "Privacy Lining": 6003,
            };
            tempPostObj["SewingOrderDetails"].forEach((detail) => {
              if (detail && detail["LiningId"] !== undefined) {
                delete detail["LiningId"];
              }
            });
            const liningTypeId = liningTypeIdMap[tempPostObj["Lining"]];
            if (liningTypeId !== undefined && tempPostObj["SewingOrderDetails"][0]) {
              tempPostObj["SewingOrderDetails"][0]["LiningTypeId"] = liningTypeId;
            }
            axios
              .post(baseURLPrice, tempPostObj)
              .then((response) => {
                tempBagPrice = response.data["Price"];
                temp["Price"] = response.data["Price"];
                if (zipcode && zipcode !== "") {
                  temp["ZipCode"] = zipcode;
                }
                if (zipcodeChecked && response.data["InstallAmount"]) {
                  temp["InstallAmount"] = response.data["InstallAmount"];
                  temp["TransportationAmount"] = response.data["TransportationAmount"];
                }
                setInstallPrice(
                  response.data["InstallAmount"] ? response.data["InstallAmount"] : 0
                );
                let roomNameFa = cartValues["RoomNameFa"];
                let roomName = cartValues["RoomNameEn"];
                let WindowName =
                  cartValues["WindowName"] === undefined ? "" : cartValues["WindowName"];
                let moreInfoInput =
                  cartValues["moreInfoInput"] === undefined ? "" : cartValues["moreInfoInput"];

                let promiseArr = [];
                customAcc.forEach((obj, index) => {
                  if (obj["DesignNameFa"] !== undefined && obj["DesignNameEn"] !== undefined) {
                    promiseArr[index] = new Promise((resolve, reject) => {
                      temp4[index] = (
                        <li className="cart_agree_item" key={"acc" + index}>
                          <h1 className="cart_agree_item_title 1">
                            {pageLanguage === "fa" ? obj["DesignNameFa"] : obj["DesignNameEn"]} /{" "}
                            {pageLanguage === "fa"
                              ? obj["ColorNameFa"]
                              : capitalizeWordsText(obj["ColorNameEn"])}
                          </h1>
                          <h2 className="cart_agree_item_desc 1">
                            {t("agree_Qty")}
                            {NumToFa(obj["Qty"], pageLanguage)}
                          </h2>
                        </li>
                      );
                      resolve();
                    });
                  }
                });

                let promiseArr2 = [];
                Object.keys(cartValues).forEach((key, index) => {
                  if ((shouldRemove9A !== undefined ? shouldRemove9A : remove9A) === false) {
                    if (!cartValues.hasOwnProperty("RailDesignEnA")) {
                      cartValues["RailDesignEnA"] = nameEnDraperyTrack;
                      cartValues["RailDesignFaA"] = nameFaDraperyTrack;
                    }
                    if (remoteNameA !== "" && stepTCollections9A === "2208") {
                      cartValues["MotorChannelsA"] = selectedMotorChannelsA.map(
                        (item) => item.value
                      );
                      cartValues["MotorPositionA"] = selectedMotorPositionA[0]?.["label"];
                    }
                    if (!cartValues.hasOwnProperty("RailDesignEnC")) {
                      cartValues["RailDesignEnC"] = nameEnDraperyTrack;
                      cartValues["RailDesignFaC"] = nameFaDraperyTrack;
                    }

                    if (!cartValues.hasOwnProperty("RailColorEnA")) {
                      cartValues["RailColorEnA"] = nameColorEnDraperyTrack;
                      cartValues["RailColorFaA"] = nameColorFaDraperyTrack;
                    }

                    if (!cartValues.hasOwnProperty("RailColorEnB")) {
                      cartValues["RailColorEnB"] = nameColorEnDraperyTrack;
                      cartValues["RailColorFaB"] = nameColorFaDraperyTrack;
                    }

                    if (!cartValues.hasOwnProperty("BatonOptionA")) {
                      cartValues["BatonOptionA"] = nameBattonEnDraperyTrack;
                    }

                    if (step8 === "Same Hardware For All Curtains" && step8DTrack === "2207") {
                      cartValues["ControlPositionA"] = cartValues["ControlPositionB"];
                      cartValues["ControlPositionC"] = cartValues["ControlPositionB"];
                    }

                    if (step8 === "Same Hardware For All Curtains" && step8DTrack === "2208") {
                      cartValues["MotorPositionA"] = cartValues["MotorPositionB"];
                      cartValues["MotorPositionC"] = cartValues["MotorPositionB"];
                      cartValues["RemoteNameA"] = cartValues["RemoteNameB"];
                      cartValues["RemoteNameC"] = cartValues["RemoteNameB"];
                      cartValues["MotorChannelsA"] = cartValues["MotorChannelsB"];
                      cartValues["MotorChannelsC"] = cartValues["MotorChannelsB"];
                    }

                    if (
                      (step8 === "I Want To Customize Hardware Per Curtain" ||
                        step8 === "Same Hardware For All Curtains") &&
                      (step8BRilType === "2207" || step8BRilType === "2201")
                    ) {
                      delete cartValues.MotorPositionB;
                      delete cartValues.RemoteNameB;
                      delete cartValues.MotorChannelsB;
                    }

                    if (
                      step8 === "Same Hardware For All Curtains" &&
                      (step8DTrack === "2207" || step8DTrack === "2201")
                    ) {
                      delete cartValues.MotorPositionB;
                      delete cartValues.RemoteNameB;
                      delete cartValues.MotorChannelsB;
                    }

                    // if (
                    //   (cartValues["RailColorEnB"] === null ||
                    //     step8B === "None" ||
                    //     step8B === "Rod") &&
                    //   step8 !== "Same Hardware For All Curtains"
                    // ) {
                    //   console.log("من حذف کردم");
                    // این قسمت وقتی همه تراک هستند حذف می کنه
                    //   delete cartValues.MotorChannelsB;
                    //   delete cartValues.MotorPositionB;
                    // }

                    if (
                      step8 === "I Want To Customize Hardware Per Curtain" &&
                      cartValues["BatonOptionA"] === null &&
                      cartValues["RailColorEnA"] === undefined
                    ) {
                      cartValues["RailColorEnA"] = nameColorEnDraperyTrack9a;
                      cartValues["RailColorFaA"] = nameColorFaDraperyTrack9a;
                      cartValues["BatonOptionA"] = nameBattonEnDraperyTrack9a;
                    }

                    if (
                      cartValues["RailDesignEnA"] === "Cord Draw Track" &&
                      step8 !== "Same Hardware For All Curtains"
                    ) {
                      cartValues["ControlPositionA"] = "Control" + " " + step9APosition;
                    }
                  } else {
                    if (
                      cartValues["DraperyHardware"] === "Track" &&
                      step8 === "I Want To Customize Hardware Per Curtain" &&
                      (shouldRemove9A !== undefined ? shouldRemove9A : remove9A)
                    ) {
                      cartValues["RailDesignEnA"] = stepTrackCollectionsName9A;
                      cartValues["RailDesignFaA"] = stepTrackCollectionsName9A;
                      cartValues["RailColorEnA"] = nameColorEnDraperyTrack;
                      cartValues["RailColorFaA"] = nameColorFaDraperyTrack;
                      if (step9APosition && stepTrackCollectionsName9A === "Cord Draw Track") {
                        delete cartValues.BatonOptionA;
                        cartValues["ControlPositionA"] = "Control" + " " + step9APosition;
                      }
                    }
                  }

                  if (
                    step8 === "I Want To Customize Hardware Per Curtain" &&
                    step9ADrapery === "Track" &&
                    stepTCollections9A === "2201"
                  ) {
                    cartValues["BatonOptionA"] = stepControl9A;
                  }

                  if (
                    step8 === "I Want To Customize Hardware Per Curtain" &&
                    step9ADrapery === "Track" &&
                    stepTCollections9A === "2208" &&
                    Object.keys(allBags).length > 0
                  ) {
                    cartValues["MotorPositionA"] = selectedMotorPositionA[0]?.["label"];
                    cartValues["RemoteNameA"] = remoteNameA;
                    cartValues["MotorChannelsA"] = selectedMotorChannelsA?.map(
                      (item) => item?.value
                    );
                    if (step8B !== "Track" && step8BRilType !== "2208") {
                      delete cartValues.MotorPositionB;
                      delete cartValues.RemoteNameB;
                      delete cartValues.MotorChannelsB;
                    }
                  }

                  if (step8 === "I Want To Customize Hardware Per Curtain") {
                    if (stepTCollections9A === "2207") {
                      delete cartValues.BatonOptionA;
                    }
                    if (step8BRilType === "2207") {
                      delete cartValues.BatonOptionB;
                    }
                    if (step8CTrack === "2207") {
                      delete cartValues.BatonOptionC;
                    }
                  }
                  console.log(`cartValues`, cartValues);
                  setAllBags(cartValues);

                  promiseArr2[index] = new Promise((resolve, reject) => {
                    let filteredProjects = userProjects.filter(
                      (obj) => obj.title !== "Matching Tieback" && obj.title !== "کمرپرده توری"
                    );
                    if (step3 === "false") {
                      filteredProjects = filteredProjects.filter(
                        (obj) => obj.title !== "Finished Length Type"
                      );
                    } else {
                      if (step3B === "Slight Puddle" && step31 === "false") {
                        filteredProjects = filteredProjects.filter(
                          (obj) => obj.title !== "Finished Length Type"
                        );
                      } else if (step3ARod === "Slight Puddle" && step31 === "true") {
                        filteredProjects = filteredProjects.filter(
                          (obj) => obj.title !== "Finished Length Type"
                        );
                      } else if (step3ATrack === "Slight Puddle" && step31 === "Track") {
                        filteredProjects = filteredProjects.filter(
                          (obj) => obj.title !== "Finished Length Type"
                        );
                      }
                    }
                    if (!(shouldRemove9A !== undefined ? shouldRemove9A : remove9A)) {
                      if (
                        cartValues["DraperyHardware"] === "Rod" &&
                        cartValues["Hardware"] === "Same Hardware For All Curtains"
                      ) {
                        cartValues["BatonOptionB"] = cartValues["BatonOptionA"];
                        cartValues["BatonOptionC"] = cartValues["BatonOptionA"];
                      }
                    }

                    let tempObj = filteredProjects.find((obj) => obj.cart === key);

                    if (tempObj === undefined || cartValues[key] === undefined) {
                      resolve();
                    } else {
                      if (key === "WindowHeight" || key === "WindowWidth") {
                        resolve();
                      } else if (
                        (key === "PanelTypeOption" &&
                          cartValues["PanelTypeOption"] === "Customize Style Per Curtain") ||
                        (key === "Hardware" &&
                          cartValues["Hardware"] === "I Want To Customize Hardware Per Curtain")
                      ) {
                        resolve();
                      } else if (
                        tempObj["title"] !== "" &&
                        tempObj["lang"].indexOf(pageLanguage) > -1
                      ) {
                        let objLabel = "";
                        if (key === "ControlType" && cartValues["ControlType"] === "Motorized") {
                          objLabel =
                            pageLanguage === "fa"
                              ? NumberToPersianWord.convertEnToPe(
                                  `${t(cartValues[key].toString())} / ${t(
                                    cartValues["MotorType"].toString()
                                  )}`
                                ).toString()
                              : `${t(cartValues[key].toString())} /
                               ${t(cartValues["MotorType"].toString())}`;
                        } else if (
                          key === "DraperyHardware" &&
                          cartValues["RailDesignEnA"] === "Motorized Track"
                        ) {
                          objLabel =
                            // t(cartValues[key].toString()) +
                            // " / " +
                            pageLanguage === "fa"
                              ? cartValues["RailDesignFaA"]
                              : cartValues["RailDesignEnA"];
                        } else if (
                          key === "DraperyHardware" &&
                          cartValues["DraperyHardware"] !== "None"
                        ) {
                          objLabel =
                            // t(cartValues[key].toString()) +
                            // " / " +
                            (pageLanguage === "fa"
                              ? cartValues["RailDesignFaA"]
                              : cartValues["RailDesignEnA"]) +
                            " \n " +
                            (pageLanguage === "fa"
                              ? cartValues["RailColorFaA"]
                              : cartValues["RailColorEnA"]) +
                            (cartValues["BatonOptionA"]
                              ? cartValues["BatonOptionA"] !== "None"
                                ? " / " + t(cartValues["BatonOptionA"])
                                : ""
                              : " / " + t(cartValues["ControlPositionA"]));
                        } else if (
                          key === "SheerHardware" &&
                          cartValues["SheerHardware"] !== "None"
                        ) {
                          if (cartValues["RailDesignEnB"] === "Motorized Track") {
                            objLabel =
                              // t(cartValues[key].toString()) +
                              // " / " +
                              pageLanguage === "fa"
                                ? cartValues["RailDesignFaB"]
                                : cartValues["RailDesignEnB"];
                          } else {
                            objLabel =
                              // t(cartValues[key].toString()) +
                              // " / " +
                              (pageLanguage === "fa"
                                ? cartValues["RailDesignFaB"]
                                : cartValues["RailDesignEnB"]) +
                              " \n " +
                              (pageLanguage === "fa"
                                ? cartValues["RailColorFaB"]
                                : cartValues["RailColorEnB"]) +
                              (cartValues["BatonOptionB"]
                                ? cartValues["BatonOptionB"] !== "None"
                                  ? " / " + t(cartValues["BatonOptionB"])
                                  : ""
                                : " / " + t(cartValues["ControlPositionB"]));
                          }
                        } else if (
                          key === "PrivacyLayerHardware" &&
                          cartValues["PrivacyLayerHardware"] !== "None"
                        ) {
                          if (cartValues["RailDesignEnC"] === "Motorized Track") {
                            objLabel =
                              // t(cartValues[key].toString()) +
                              // " / " +
                              pageLanguage === "fa"
                                ? cartValues["RailDesignFaC"]
                                : cartValues["RailDesignEnC"];
                          } else {
                            objLabel =
                              // t(cartValues[key].toString()) +
                              // " / " +
                              (pageLanguage === "fa"
                                ? cartValues["RailDesignFaC"]
                                : cartValues["RailDesignEnC"]) +
                              " \n " +
                              (pageLanguage === "fa"
                                ? cartValues["RailColorFaC"]
                                : cartValues["RailColorEnC"]) +
                              (cartValues["BatonOptionC"]
                                ? cartValues["BatonOptionC"] !== "None"
                                  ? " / " + t(cartValues["BatonOptionC"])
                                  : ""
                                : " / " + t(cartValues["ControlPositionC"]));
                          }
                        } else if (tempObj["titleValue"] === null || true) {
                          if (tempObj["titlePostfix"] === "") {
                            let rawValue = t(cartValues[key]?.toString());
                            if (/^[\d,]+$/.test(rawValue)) {
                              rawValue = rawValue.split(",").join(", ");
                            }
                            objLabel =
                              pageLanguage === "fa"
                                ? NumberToPersianWord.convertEnToPe(
                                    `${t(cartValues[key]?.toString())}`
                                  ).toString()
                                : rawValue;
                          } else {
                            objLabel =
                              pageLanguage === "fa"
                                ? NumberToPersianWord.convertEnToPe(
                                    `${cartValues[key]}`
                                  )?.toString() + t(tempObj["titlePostfix"])
                                : cartValues[key].toString() + t(tempObj["titlePostfix"]);
                          }
                        } else {
                          if (tempObj["titleValue"][cartValues[key].toString()] === null) {
                            if (tempObj["titlePostfix"] === "") {
                              objLabel = t(cartValues[key].toString());
                            } else {
                              objLabel =
                                pageLanguage === "fa"
                                  ? NumberToPersianWord.convertEnToPe(
                                      `${cartValues[key]}`
                                    ).toString() + t(tempObj["titlePostfix"])
                                  : cartValues[key].toString() + t(tempObj["titlePostfix"]);
                            }
                          } else {
                            objLabel = t(tempObj["titleValue"][cartValues[key].toString()]);
                          }
                        }

                        if (tempObj["fabric"] === undefined) {
                          temp5[tempObj["order"]] = (
                            <li className="cart_agree_item" key={key}>
                              <h1 className="cart_agree_item_title 2">
                                {t(tempObj["title"])}&nbsp;
                              </h1>
                              <h2 className="cart_agree_item_desc 2">{objLabel}</h2>
                            </li>
                          );
                          resolve();
                        } else if (tempObj["fabric"] === 1) {
                          temp1[tempObj["order"]] = (
                            <li className="cart_agree_item" key={key}>
                              <h1 className="cart_agree_item_title 3">
                                {t(tempObj["title"])}&nbsp;
                              </h1>
                              <h2 className="cart_agree_item_desc 3">{objLabel}</h2>
                            </li>
                          );
                          resolve();
                        } else if (tempObj["fabric"] === 2) {
                          temp2[tempObj["order"]] = (
                            <li className="cart_agree_item" key={key}>
                              <h1 className="cart_agree_item_title 4">
                                {t(tempObj["title"])}&nbsp;
                              </h1>
                              <h2 className="cart_agree_item_desc 4">{objLabel}</h2>
                            </li>
                          );
                          resolve();
                        } else if (tempObj["fabric"] === 3) {
                          temp3[tempObj["order"]] = (
                            <li className="cart_agree_item" key={key}>
                              <h1 className="cart_agree_item_title 5">
                                {t(tempObj["title"])}&nbsp;
                              </h1>
                              <h2 className="cart_agree_item_desc 5">{objLabel}</h2>
                            </li>
                          );
                          resolve();
                        } else {
                          resolve();
                        }
                      } else {
                        resolve();
                      }
                    }
                  });
                });

                Promise.all([...promiseArr, ...promiseArr2]).then(() => {
                  const measurementCartValues = {
                    ...cartValues,
                    step31: step31,
                  };

                  tempArr.push(
                    <div key={defaultModelName}>
                      <h2 className="cart_agree_title">
                        {pageLanguage === "fa"
                          ? convertToPersian(defaultModelNameFa) + " سفارشی "
                          : "Custom " + defaultModelName}
                      </h2>
                      <ul className="cart_agree_items_container">
                        <GetMeasurementArray
                          modelId={`${modelID}`}
                          cartValues={measurementCartValues}
                        />
                        <li className="cart_agree_item cart_agree_item_fabrics_sorted cart_agree_item_general">
                          <h1 className="cart_agree_item_fabrics_sorted_title">
                            {t("General Details")}
                          </h1>
                          <ul>{temp5}</ul>
                        </li>
                        <li className="cart_agree_item cart_agree_item_fabrics_sorted cart_agree_item_drapery">
                          <h1 className="cart_agree_item_fabrics_sorted_title">{t("Drapery")}</h1>
                          <ul>
                            <li className="cart_agree_item">
                              <h1 className="cart_agree_item_title">
                                {t("Material & Color")}&nbsp;
                              </h1>
                              <h2 className="cart_agree_item_desc 6">
                                {pageLanguage === "fa"
                                  ? cartValues["FabricDesignFa"] +
                                    " / " +
                                    t(cartValues["FabricColorFa"] || "")
                                  : CapitalizeAllWords(
                                      cartValues["FabricDesignEn"] +
                                        " / " +
                                        cartValues["FabricColorEn"]
                                    )}
                              </h2>
                            </li>
                            {cartValues["BorderOrTrimId"] && cartValues["borderPosition"] && (
                              <li className="cart_agree_item">
                                <h1 className="cart_agree_item_title">
                                  {t("Decorative Border")}&nbsp;
                                </h1>
                                <h2 className="cart_agree_item_desc 7">
                                  {pageLanguage === "fa"
                                    ? cartValues["BorderOrTrimDesignFa"] +
                                      " / " +
                                      cartValues["BorderOrTrimColorFa"] +
                                      " \n " +
                                      t(cartValues["borderPosition"])
                                    : CapitalizeAllWords(
                                        cartValues["BorderOrTrimDesignEn"] +
                                          " / " +
                                          cartValues["BorderOrTrimColorEn"] +
                                          " \n " +
                                          t(cartValues["borderPosition"])
                                      )}
                                </h2>
                              </li>
                            )}
                            {cartValues["BorderOrTrimId"] && !cartValues["borderPosition"] && (
                              <li className="cart_agree_item">
                                <h1 className="cart_agree_item_title">
                                  {t("Decorative Trim")}&nbsp;
                                </h1>
                                <h2 className="cart_agree_item_desc 8">
                                  {pageLanguage === "fa"
                                    ? cartValues["BorderOrTrimDesignFa"] +
                                      " / " +
                                      cartValues["BorderOrTrimColorFa"]
                                    : CapitalizeAllWords(
                                        cartValues["BorderOrTrimDesignEn"] +
                                          " / " +
                                          cartValues["BorderOrTrimColorEn"]
                                      )}
                                </h2>
                              </li>
                            )}

                            {temp1}

                            {((remoteNameA !== "" && stepTCollections9A === "2208") ||
                              (step8 === "Same Hardware For All Curtains" &&
                                step8DTrack === "2208")) && (
                              <>
                                <li className="cart_agree_item">
                                  <h1 className="cart_agree_item_title">
                                    {t("Motor Position")}&nbsp;
                                  </h1>
                                  <h2 className="cart_agree_item_desc 6">
                                    {cartValues["MotorPositionA"]}
                                  </h2>
                                </li>
                                <li className="cart_agree_item">
                                  <h1 className="cart_agree_item_title">
                                    {t("Remote Name")}&nbsp;
                                  </h1>
                                  <h2 className="cart_agree_item_desc 6">
                                    {cartValues["RemoteNameA"]}
                                  </h2>
                                </li>
                                <li className="cart_agree_item">
                                  <h1 className="cart_agree_item_title">
                                    {t("Motor Channels")}&nbsp;
                                  </h1>
                                  <h2 className="cart_agree_item_desc 61">
                                    {cartValues["MotorChannelsA"]?.join(", ")}
                                  </h2>
                                </li>
                              </>
                            )}
                            {cartValues["FinishedLengthType"] === "Slight Puddle" &&
                              step3 === "true" && (
                                <li className="cart_agree_item">
                                  <h1 className="cart_agree_item_title 2">
                                    {t("dk_step2A")}&nbsp;
                                  </h1>
                                  <h2 className="cart_agree_item_desc 2">
                                    {t(cartValues["FinishedLengthType"])}
                                  </h2>
                                </li>
                              )}
                            {cartValues["HandCurtainNum"] > 0 && (
                              <li className="cart_agree_item">
                                <h1 className="cart_agree_item_title">
                                  {t("Matching Tieback")}&nbsp;
                                </h1>
                                <h2 className="cart_agree_item_desc 6">
                                  {t("agree_Qty") +
                                    NumToFa(cartValues["HandCurtainNum"], pageLanguage)}
                                </h2>
                              </li>
                            )}
                          </ul>
                        </li>
                        <li className="cart_agree_item cart_agree_item_fabrics_sorted cart_agree_item_sheer">
                          <h1 className="cart_agree_item_fabrics_sorted_title">{t("Sheer")}</h1>
                          <ul>
                            <li className="cart_agree_item">
                              <h1 className="cart_agree_item_title">
                                {t("Material & Color")}&nbsp;
                              </h1>
                              <h2 className="cart_agree_item_desc 9">
                                {pageLanguage === "fa"
                                  ? cartValues["FabricDesignFa2"] +
                                    " / " +
                                    t(cartValues["FabricColorFa2"] || "")
                                  : CapitalizeAllWords(
                                      cartValues["FabricDesignEn2"] +
                                        " / " +
                                        cartValues["FabricColorEn2"]
                                    )}
                              </h2>
                            </li>
                            {cartValues["BorderOrTrimId2"] && cartValues["borderPosition2"] && (
                              <li className="cart_agree_item">
                                <h1 className="cart_agree_item_title">
                                  {t("Decorative Border")}&nbsp;
                                </h1>
                                <h2 className="cart_agree_item_desc 10">
                                  {pageLanguage === "fa"
                                    ? cartValues["BorderOrTrimDesignFa2"] +
                                      " / " +
                                      cartValues["BorderOrTrimColorFa2"] +
                                      " \n " +
                                      t(cartValues["borderPosition2"])
                                    : CapitalizeAllWords(
                                        cartValues["BorderOrTrimDesignEn2"] +
                                          " / " +
                                          cartValues["BorderOrTrimColorEn2"] +
                                          " \n " +
                                          t(cartValues["borderPosition2"])
                                      )}
                                </h2>
                              </li>
                            )}
                            {cartValues["BorderOrTrimId2"] && !cartValues["borderPosition2"] && (
                              <li className="cart_agree_item">
                                <h1 className="cart_agree_item_title">
                                  {t("Decorative Trim")}&nbsp;
                                </h1>
                                <h2 className="cart_agree_item_desc 11">
                                  {pageLanguage === "fa"
                                    ? cartValues["BorderOrTrimDesignFa2"] +
                                      " / " +
                                      cartValues["BorderOrTrimColorFa2"]
                                    : CapitalizeAllWords(
                                        cartValues["BorderOrTrimDesignEn2"] +
                                          " / " +
                                          cartValues["BorderOrTrimColorEn2"]
                                      )}
                                </h2>
                              </li>
                            )}
                            {temp2}
                            {cartValues["FinishedLengthType"] === "Slight Puddle" &&
                              step3 === "true" && (
                                <li className="cart_agree_item">
                                  <h1 className="cart_agree_item_title 2">
                                    {t("dk_step2A")}&nbsp;
                                  </h1>
                                  <h2 className="cart_agree_item_desc 2">
                                    {cartValues["FinishedLengthType"] === "Slight Puddle"
                                      ? t("Floor")
                                      : t(cartValues["FinishedLengthType"])}
                                  </h2>
                                </li>
                              )}
                            {cartValues["HandCurtainNum2"] > 0 && (
                              <li className="cart_agree_item">
                                <h1 className="cart_agree_item_title">
                                  {t("Matching Tieback")}&nbsp;
                                </h1>
                                <h2 className="cart_agree_item_desc 6">
                                  {t("agree_Qty") +
                                    NumToFa(cartValues["HandCurtainNum2"], pageLanguage)}
                                </h2>
                              </li>
                            )}
                          </ul>
                        </li>
                        {cartValues["PrivacyLayer"] !== "none" &&
                          cartValues["SheersDesignEn"] &&
                          cartValues["SheersColorEn"] && (
                            <li className="cart_agree_item cart_agree_item_fabrics_sorted cart_agree_item_pl">
                              <h1 className="cart_agree_item_fabrics_sorted_title">
                                {t("Privacy Layer")}
                              </h1>
                              <ul>
                                <li className="cart_agree_item">
                                  <h1 className="cart_agree_item_title">
                                    {t("Material & Color")}&nbsp;
                                  </h1>
                                  <h2 className="cart_agree_item_desc 12">
                                    {pageLanguage === "fa"
                                      ? cartValues["SheersDesignFa"] +
                                        " / " +
                                        cartValues["SheersColorFa"]
                                      : CapitalizeAllWords(
                                          cartValues["SheersDesignEn"] +
                                            " / " +
                                            cartValues["SheersColorEn"]
                                        )}
                                  </h2>
                                </li>
                                {temp3}

                                {step8 === "Same Hardware For All Curtains" &&
                                  step8DTrack === "2208" && (
                                    <>
                                      <li className="cart_agree_item">
                                        <h1 className="cart_agree_item_title">
                                          {t("Motor Position")}&nbsp;
                                        </h1>
                                        <h2 className="cart_agree_item_desc 6">
                                          {cartValues["MotorPositionA"]}
                                        </h2>
                                      </li>
                                      <li className="cart_agree_item">
                                        <h1 className="cart_agree_item_title">
                                          {t("Remote Name")}&nbsp;
                                        </h1>
                                        <h2 className="cart_agree_item_desc 6">
                                          {cartValues["RemoteNameA"]}
                                        </h2>
                                      </li>
                                      <li className="cart_agree_item">
                                        <h1 className="cart_agree_item_title">
                                          {t("Motor Channels")}&nbsp;
                                        </h1>
                                        <h2 className="cart_agree_item_desc 61">
                                          {cartValues["MotorChannelsA"]?.join(" ,")}
                                        </h2>
                                      </li>
                                    </>
                                  )}
                                {cartValues["FinishedLengthType"] === "Slight Puddle" &&
                                  step3 === "true" && (
                                    <li className="cart_agree_item">
                                      <h1 className="cart_agree_item_title 2">
                                        {t("dk_step2A")}&nbsp;
                                      </h1>
                                      <h2 className="cart_agree_item_desc 2">
                                        {cartValues["FinishedLengthType"] === "Slight Puddle"
                                          ? t("Floor")
                                          : t(cartValues["FinishedLengthType"])}
                                      </h2>
                                    </li>
                                  )}
                              </ul>
                            </li>
                          )}
                        {!!temp4.length && (
                          <li className="cart_agree_item cart_agree_item_fabrics_sorted cart_agree_item_acc">
                            <h1 className="cart_agree_item_fabrics_sorted_title">
                              {t("Accessories")}
                            </h1>
                            <ul>{temp4}</ul>
                          </li>
                        )}
                        <li className="cart_agree_item">
                          <h1 className="cart_agree_item_title">
                            {pageLanguage === "fa" ? "نام اتاق" : "Room Label"}&nbsp;
                          </h1>
                          <h2 className="cart_agree_item_desc 13">
                            {pageLanguage === "fa"
                              ? roomNameFa + (WindowName === "" ? "" : " / " + t(WindowName))
                              : roomName + (WindowName === "" ? "" : " / " + WindowName)}
                          </h2>
                        </li>
                        {moreInfoInput !== "" && (
                          <li className="cart_agree_item">
                            <h1 className="cart_agree_item_title">{t("Order Notes")}&nbsp;</h1>
                            <ShowMoreLineLimited moreInfoInput={moreInfoInput} lines={3} />
                          </li>
                        )}
                        <li className="cart_agree_item">
                          <h1 className="cart_agree_item_title">{t("Price")}&nbsp;</h1>
                          <h2 className="cart_agree_item_desc 14">
                            {GetPrice(tempBagPrice, pageLanguage, t("TOMANS"), isTabletOrMobile)}
                          </h2>
                        </li>
                      </ul>
                    </div>
                  );
                  setCartAgree(tempArr);
                  modalHandleShow("cart_modal");
                  setCartValues(temp);
                  setAllBags(temp);
                  setAddingLoading(false);
                });
              })
              .catch((err) => {
                console.log(err);
                if (err.response && err.response.status === 401) {
                  refreshToken().then((response2) => {
                    if (response2 !== false) {
                      addToCart();
                    } else {
                      setPrice(0);
                      setPriceBtn(null);
                      temp["Price"] = 0;
                      setCartValues(temp);
                      setAddingLoading(false);
                      navigate("/" + pageLanguage + "/User");
                    }
                  });
                } else {
                  setPrice(0);
                  setPriceBtn(null);
                  temp["Price"] = 0;
                  setCartValues(temp);
                  setAddingLoading(false);
                  modalHandleClose("cart_modal");
                }
              });
          } else {
            setAddingLoading(false);
          }
        }
      }
    });
  }

  function addToCart_agreed() {
    if (!cartValues.hasOwnProperty("RailDesignEnA")) {
      cartValues["RailDesignEnA"] = nameEnDraperyTrack;
      cartValues["RailDesignFaA"] = nameFaDraperyTrack;
    }

    if (!cartValues.hasOwnProperty("RailColorEnA")) {
      cartValues["RailColorEnA"] = nameColorEnDraperyTrack;
      cartValues["RailColorFaA"] = nameColorFaDraperyTrack;
    }

    if (!cartValues.hasOwnProperty("BatonOptionA")) {
      cartValues["BatonOptionA"] = nameBattonEnDraperyTrack;
    }

    // Ensure the drapery (panel A / index 0) always carries its selected RailId.
    // The drapery rail id lives in different state depending on the chosen hardware,
    // and was sometimes missing from cartValues, leaving index 0 without a RailId.
    if (!cartValues["RailIdA"]) {
      let draperyRailId = "";
      if (step8 === "Same Hardware For All Curtains") {
        // shared rod/track finish applied to all curtains
        draperyRailId = step82 || step8D2;
      } else if (step9ADrapery === "Rod") {
        // individual drapery rod finish
        draperyRailId = step8A2;
      } else if (step9ADrapery === "Track") {
        // individual drapery track finish
        draperyRailId = stepHardware9A;
      }
      if (draperyRailId) {
        cartValues["RailIdA"] = draperyRailId;
        if (allBags && typeof allBags === "object") {
          allBags["RailIdA"] = draperyRailId;
        }
      }
    }

    if (cartValues["InstallAmount"]) {
      allBags["InstallAmount"] = cartValues["InstallAmount"];
    }
    if (cartValues["TransportationAmount"]) {
      allBags["TransportationAmount"] = cartValues["TransportationAmount"];
    }
    if (cartValues["ZipCode"]) {
      allBags["ZipCode"] = cartValues["ZipCode"];
    } else if (zipcode && zipcode !== "") {
      allBags["ZipCode"] = zipcode;
    }
    if (
      cartValues["DraperyHardware"] === "Track" &&
      step8 === "I Want To Customize Hardware Per Curtain"
    ) {
      console.log("7072");
    }

    setRemove9A(false);

    const successImages = uploadedImages.filter((img) => img.status === "success");
    const imageFiles = successImages.map((img) => img.name);
    const imageUrls = successImages.map((img) => {
      if (img.url && img.url.startsWith("http")) {
        try {
          const urlObj = new URL(img.url);
          return urlObj.pathname;
        } catch (e) {
          return img.url;
        }
      }
      return img.url || "";
    });

    const successPdfs = uploadedPDFs.filter((pdf) => pdf.status === "success");
    const pdfFiles = successPdfs.map((pdf) => pdf.name);
    const pdfUrls = successPdfs.map((pdf) => {
      if (pdf.url && pdf.url.startsWith("http")) {
        try {
          const urlObj = new URL(pdf.url);
          return urlObj.pathname;
        } catch (e) {
          return pdf.url;
        }
      }
      return pdf.url || "";
    });

    const filesForCart = [imageFiles, imageUrls, pdfFiles, pdfUrls];

    AddProjectToCart(
      allBags,
      `${modelID}`,
      price,
      defaultModelName,
      defaultModelNameFa,
      filesForCart,
      projectId && projectId !== "" ? projectId : cartProjectIndex,
      editIndex,
      navigate,
      isLoggedIn,
      customAcc
    )
      .then((temp) => {
        if (temp && temp !== 401) {
          const processedTemp = { ...temp };

          if (processedTemp.drapery) {
            const updateItems = (items) =>
              items.map((item) => {
                const motorChannelsValues = selectedMotorChannelsA?.length
                  ? Array.isArray(selectedMotorChannelsA)
                    ? selectedMotorChannelsA.map((ch) => ch?.value || ch).filter(Boolean)
                    : Object.values(selectedMotorChannelsA).filter(Boolean)
                  : null;

                const updatedItem = {
                  ...item,
                  ...(selectedMotorPositionA && {
                    MotorPositionA: selectedMotorPositionA[0]?.["label"],
                  }),
                  ...(remoteNameA && { RemoteNameA: remoteNameA }),
                  ...(motorChannelsValues && { MotorChannelsA: motorChannelsValues }),
                  ...(step9APosition && { ControlPositionA: "Control" + " " + step9APosition }),
                };

                if (item.PreorderText) {
                  updatedItem.PreorderText = {
                    ...item.PreorderText,
                    ...(selectedMotorPositionA && { MotorPositionA: selectedMotorPositionA }),
                    ...(remoteNameA && { RemoteNameA: remoteNameA }),
                    ...(motorChannelsValues && { MotorChannelsA: motorChannelsValues }),
                  };

                  if (item.PreorderText && cartValues["RailDesignEnA"] === "Cord Draw Track") {
                    updatedItem.PreorderText = {
                      ...item.PreorderText,
                      ...(step9APosition && { ControlPositionA: "Control" + " " + step9APosition }),
                    };
                  }
                }

                return updatedItem;
              });

            // به‌روزرسانی drapery
            processedTemp.drapery = updateItems(processedTemp.drapery);

            if (processedTemp[""]) {
              processedTemp[""] = updateItems(processedTemp[""]);
            }
          }

          setCartAgreeDescription(false);

          renderCart(processedTemp);
          setBag(processedTemp);
          setTimeout(() => {
            setCartStateAgree(true);
          }, 500);
          setAddingLoading(false);
        } else if (temp === 401) {
          addToCart_agreed();
        } else {
          setAddingLoading(false);
          setCartAgreeDescription(false);
        }
      })
      .catch((err) => {
        console.log(err);
        setAddingLoading(false);
        setCartAgreeDescription(false);
      });
  }

  function updateSideCartSummary(cartObjects) {
    if (!cartObjects || !Object.keys(cartObjects).length) {
      setSideCartProductTotal(0);
      setSideCartInstallPrice(0);
      setSideCartTransportPrice(0);
      setSideCartHasSwatches(false);
      return;
    }

    if (isLoggedIn && cartObjects["CartDetails"]) {
      setSideCartProductTotal(cartObjects["TotalAmount"] || 0);
      setSideCartInstallPrice(cartObjects["InstallAmount"] || 0);
      setSideCartTransportPrice(cartObjects["TransportationAmount"] || 0);
      setSideCartHasSwatches(cartObjects["CartDetails"].some((item) => item["TypeId"] === 6402));
      return;
    }

    const draperies = cartObjects["drapery"] || [];
    const products = cartObjects["product"] || [];
    const swatches = cartObjects["swatches"] || [];
    let productTotal = 0;
    let installTotal = 0;

    [...draperies, ...products].forEach((item) => {
      const priceToUse =
        item["DiscountedPrice"] !== undefined && item["DiscountedPrice"] !== null
          ? item["DiscountedPrice"]
          : item["Price"];
      productTotal += (priceToUse || 0) * (item["Count"] || 1);
    });

    draperies.forEach((item) => {
      const installAmount = item["InstallAmount"] || 0;
      const windowCount = item["WindowCount"] || item["Count"] || 1;
      installTotal += installAmount * windowCount;
    });

    const transportItem = draperies.find((item) => item["TransportationAmount"] > 0);
    setSideCartProductTotal(productTotal);
    setSideCartInstallPrice(installTotal);
    setSideCartTransportPrice(transportItem ? transportItem["TransportationAmount"] : 0);
    setSideCartHasSwatches(swatches.length > 0);
  }

  function renderCart(customPageCart) {
    let cartObjects = {};
    let promise2 = new Promise((resolve, reject) => {
      if (customPageCart !== undefined) {
        cartObjects = customPageCart;

        resolve();
      } else {
        if (isLoggedIn) {
          axios
            .get(baseURLGetCart, {
              headers: authHeader(),
            })
            .then((response) => {
              cartObjects = response.data ? response.data : {};
              resolve();
            })
            .catch((err) => {
              console.log(err);
              if (err.response && err.response.status === 401) {
                refreshToken().then((response2) => {
                  if (response2 !== false) {
                    renderCart(customPageCart);
                  } else {
                    navigate("/" + pageLanguage + "/User");
                  }
                });
              } else {
                modalHandleClose("cart_modal");
                reject();
              }
            });
        } else {
          if (localStorage.getItem("cart") === null) {
            modalHandleClose("cart_modal");
            reject();
          } else {
            cartObjects = JSON.parse(localStorage.getItem("cart"));
            resolve();
          }
        }
      }
    });
    promise2.then(() => {
      let cartCount = 0;
      let totalPrice = 0;
      setSideCartObjects(cartObjects);
      updateSideCartSummary(cartObjects);
      if (isLoggedIn) {
        if (cartObjects["CartDetails"].length === 0) {
          modalHandleClose("cart_modal");
          setCartStateAgree(false);
        }
        cartCount += cartObjects["CartDetails"].length;
      } else {
        if (
          cartObjects["drapery"]?.length +
            cartObjects["product"]?.length +
            cartObjects["swatches"]?.length ===
          0
        ) {
          setCartCount(0);
          modalHandleClose("cart_modal");
          setCartStateAgree(false);
        }
        cartCount += cartObjects["drapery"].length;
      }
      setCartCount(cartCount);
    });
    axios
      .get(baseURLFreeShipping)
      .then((response) => {
        setFreeShipPrice(response.data);
      })
      .catch((err) => {
        console.log(err);
      });
  }

  function fabricSwatch(e, SwatchId, SwatchDetailId, PhotoPath) {
    let currentState = e.target ? e.target.getAttribute("current-state") : e;
    if (isLoggedIn) {
      if (currentState === "0") {
        AddSwatch(SwatchId)
          .then((response) => {
            setBag(response.data ? response.data : {});
            renderFabrics(response.data ? response.data : {});
            renderFabrics2(response.data ? response.data : {});
            renderFabrics22(response.data ? response.data : {});
            if (show) {
              if (response.data["CartDetails"]) {
                let index = response.data["CartDetails"].findIndex((object) => {
                  return object["ProductId"] === SwatchId;
                });
                if (index !== -1) {
                  setSwatchDetailId(response.data["CartDetails"][index]["CartDetailId"]);
                }
              }
            }
          })
          .catch((err) => {
            fabricSwatch(e, SwatchId, SwatchDetailId);
          });
      } else {
        if (SwatchDetailId) {
          axios
            .post(
              baseURLDeleteBasketProject + "/" + SwatchDetailId,
              {},
              {
                headers: authHeader(),
              }
            )
            .then((response) => {
              setCartChanged(cartChanged + 1);
            })
            .catch((err) => {
              console.log(err);
              if (err.response && err.response.status === 401) {
                refreshToken().then((response2) => {
                  if (response2 !== false) {
                    fabricSwatch(e, SwatchId, SwatchDetailId);
                  } else {
                    fabricSwatch(e, SwatchId, SwatchDetailId);
                  }
                });
              } else {
              }
            });
        }
      }
      if (show) {
        if (currentState === "0") {
          setHasSwatchId(true);
        } else {
          setHasSwatchId(false);
        }
      }
    } else {
      setSwatchLogin(true);
      setSwatchLoginSwatchId(SwatchId);
      setSwatchLoginSwatchDetailId(SwatchDetailId);
      modalHandleShow("side_login_modal");
    }
  }

  // After first successful measure calc: open lining (6); scroll runs via pending flag + useEffect
  function openLiningAfterMeasurements() {
    const prev = accordionActiveKeyRef.current;
    if (!prev || prev === "3A0") return;
    if (!String(prev).startsWith("3")) return;
    pendingScrollToMeasurementsRef.current = true;
    setAccordionActiveKey("4");
  }

  function getWindowSize(totalWidth, totalHeight) {
    if (totalWidth > 0 && totalHeight > 0) {
      let pageLanguage = location.pathname
        .split("")
        .slice(1, 3)
        .join("");
      let tempWindowSize =
        pageLanguage === "fa"
          ? `عرض: ${NumberToPersianWord.convertEnToPe(
              totalWidth.toString()
            )}س\u200Cم\u00A0\u00A0\u00A0ارتفاع: ${NumberToPersianWord.convertEnToPe(
              totalHeight.toString()
            )}س\u200Cم`
          : `Width: ${totalWidth}cm\u00A0\u00A0\u00A0Height: ${totalHeight}cm`;
      setWindowSize(tempWindowSize);
      setWindowSizeBool(true);
      openLiningAfterMeasurements();
    } else {
      setWindowSizeBool(false);
    }
  }

  function roomLabelChanged(changedValue, refIndex, isText) {
    let tempLabels = JSON.parse(JSON.stringify(stepSelectedLabel));
    let tempValue = JSON.parse(JSON.stringify(stepSelectedValue));
    let tempSelect = JSON.parse(JSON.stringify(roomLabelSelect));
    let temp = JSON.parse(JSON.stringify(requiredStep));
    if (isText) {
      if (roomLabelSelect.label !== "") {
        if (changedValue === "") {
          tempLabels[refIndex] = roomLabelSelect.label;
        } else {
          tempLabels[refIndex] = roomLabelSelect.label + " - " + changedValue;
        }
      }
    } else {
      tempSelect.label = changedValue.label;
      tempSelect.value = changedValue.value;

      tempValue[refIndex] = changedValue.value;

      if (changedValue.label !== "") {
        if (roomLabelText === "") {
          tempLabels[refIndex] = changedValue.label;
        } else {
          tempLabels[refIndex] = changedValue.label + " - " + roomLabelText;
        }
      }
    }
    if (tempLabels[refIndex] !== "" && requiredStep[refIndex]) {
      temp[refIndex] = false;
    }

    setStepSelectedLabel(tempLabels);
    setStepSelectedValue(tempValue);
    setRoomLabelSelect(tempSelect);
    setRequiredStep(temp);
  }

  function uploadImg(file) {
    setSelectedFile(file);
    setSelectedFileName(file.name);
  }

  function retryAxiosPost(url, formData, config, onSuccess, onFail, retries = 1, delay = 30000) {
    axios
      .post(url, formData, config)
      .then(onSuccess)
      .catch((err) => {
        if (err.response && err.response.status === 401) {
          refreshToken().then((response2) => {
            if (response2 !== false) {
              retryAxiosPost(url, formData, config, onSuccess, onFail, retries, delay);
            } else {
              onFail(err);
            }
          });
        } else if (retries > 0) {
          setTimeout(() => {
            retryAxiosPost(url, formData, config, onSuccess, onFail, retries - 1, delay);
          }, delay);
        } else {
          onFail(err);
        }
      });
  }

  function submitUploadedFile(PDFOrImg, file) {
    setIsUploading(true);

    let extensionSearch = /(?:\.([^.]+))?$/;
    let extension;
    let newFile;
    if (selectedFile === undefined) {
      extension = extensionSearch.exec(file.name)[1];
      newFile = new File(
        [file],
        editedFileName === "" ? file.name : editedFileName + "." + extension,
        { type: `${file.type}` }
      );
    } else {
      extension = extensionSearch.exec(selectedFile.name)[1];
      newFile = new File(
        [selectedFile],
        editedFileName === "" ? selectedFile.name : editedFileName + "." + extension,
        { type: `${selectedFile.type}` }
      );
    }

    const formData = new FormData();
    formData.append("File", newFile);
    formData.append("UserFileName", newFile.name);

    const config = {
      headers: {
        "content-type": "multipart/form-data",
        ...authHeader(),
      },
    };

    const url = PDFOrImg === 1 ? baseURLUploadPdf : baseURLUploadImg;

    const onSuccess = (response) => {
      setIsUploading(false);
      addUploadFileUrl(response.data, newFile.name, PDFOrImg, newFile);
      setSelectedFile(undefined);
      setSelectedFileName("");
      setEditedFileName("");
      modalHandleClose(PDFOrImg === 1 ? "uploadPdf" : "uploadImg");
    };

    const onFail = (err) => {
      setIsUploading(false);
      setSelectedFile(undefined);
      setSelectedFileName("");
      setEditedFileName("");
      modalHandleClose(PDFOrImg === 1 ? "uploadPdf" : "uploadImg");

      dispatch({
        type: ShowLogin2Modal,
      });
    };

    retryAxiosPost(url, formData, config, onSuccess, onFail, 1, 30000); // یکبار بعد از ۳۰ ثانیه تلاش مجدد
  }

  function addUploadFileUrl(fileUrl, imageName, PDFOrImg, newFile) {
    if (!fileUrl) return;

    const newFileObj = {
      id: Date.now() + Math.random() + imageName,
      name: imageName,
      url: fileUrl,
      size: newFile.size,
      type: PDFOrImg === 1 ? "application/pdf" : newFile.type,
      status: "success",
      uploadedAt: new Date(),
    };

    if (PDFOrImg === 1) {
      setUploadedPDFs((prev) => {
        const updated = [...prev, newFileObj];
        sessionStorage.setItem("backup_uploadedPDFs", JSON.stringify(updated));
        return updated;
      });
    } else {
      setUploadedImages((prev) => {
        const updated = [...prev, newFileObj];
        sessionStorage.setItem("backup_uploadedImages", JSON.stringify(updated));
        return updated;
      });
    }
  }

  function setDeleteUploaded(fileUrl, freeIndex, PDFOrImg) {
    if (PDFOrImg === 1) {
      setDeleteUploadPdfUrl(fileUrl);
      setDeleteUploadPdfIndex(freeIndex);
    } else {
      setDeleteUploadImageUrl(fileUrl);
      setDeleteUploadImageIndex(freeIndex);
    }
  }

  function deleteUploadedImg(uploadedImagesList1, uploadedImagesNamesList1, fileUrl, index) {
    let promise2 = new Promise((resolve, reject) => {
      if (fileUrl !== "") {
        axios
          .delete(baseURLDeleteFile, {
            params: {
              url: fileUrl,
            },
            headers: authHeader(),
          })
          .then((response) => {
            resolve();
          })
          .catch((err) => {
            console.log(err);
            if (err.response && err.response.status === 401) {
              refreshToken().then((response2) => {
                if (response2 !== false) {
                  deleteUploadedImg(uploadedImagesList1, uploadedImagesNamesList1, fileUrl, index);
                  reject();
                } else {
                  resolve();
                }
              });
            } else {
              resolve();
            }
          });
      } else {
        resolve();
      }
    });
    promise2.then(() => {
      let tempArray = [...uploadedImagesList1];
      let tempArrayNames = [...uploadedImagesNamesList1];
      let tempArrayFiles = [...uploadedImagesFile];
      let tempArrayURLs = [...uploadedImagesURL];

      delete tempArray[index];
      delete tempArrayNames[index];
      delete tempArrayFiles[index];
      delete tempArrayURLs[index];

      setUploadedImagesURL(tempArrayURLs);
      setUploadedImagesFile(tempArrayFiles);
      setUploadedImagesList(tempArray);
      setUploadedImagesNamesList(tempArrayNames);
      setDeleteUploadImageUrl("");
      setDeleteUploadImageIndex(-1);
    });
  }

  const handleDeleteFile2 = async (fileId) => {
    let file = uploadingFiles.find((f) => f.id === fileId);
    let isUploading = !!file;
    if (!file) file = uploadedImages.find((f) => f.id === fileId);
    if (!file) file = uploadedPDFs.find((f) => f.id === fileId);
    if (!file) return;

    if (isUploading || file.status === "pending" || file.status === "uploading") {
      if (multipleFileUploadRef.current) {
        multipleFileUploadRef.current.cancelUpload(fileId);
      } else {
        console.error("multipleFileUploadRef is null! Check ref assignment.");
      }
      return;
    }

    const isPdf = file.type === "application/pdf";
    const hasError = file.status === "error" || !file.url;

    if (hasError) {
      if (isPdf) {
        setUploadedPDFs((prev) => {
          const newList = prev.filter((f) => f.id !== fileId);
          sessionStorage.setItem("backup_uploadedPDFs", JSON.stringify(newList));
          return newList;
        });
      } else {
        setUploadedImages((prev) => {
          const newList = prev.filter((f) => f.id !== fileId);
          sessionStorage.setItem("backup_uploadedImages", JSON.stringify(newList));
          return newList;
        });
      }
      return;
    }

    let relativeUrl = file.url;
    if (relativeUrl?.startsWith("http")) {
      try {
        const urlObj = new URL(relativeUrl);
        relativeUrl = urlObj.pathname;
      } catch (e) {}
    }

    try {
      const encodedUrl = encodeURIComponent(relativeUrl);
      await axios.delete(`${baseURLDeleteFile}?url=${encodedUrl}`);
      if (isPdf) {
        setUploadedPDFs((prev) => {
          const newList = prev.filter((f) => f.id !== fileId);
          sessionStorage.setItem("backup_uploadedPDFs", JSON.stringify(newList));
          return newList;
        });
      } else {
        setUploadedImages((prev) => {
          const newList = prev.filter((f) => f.id !== fileId);
          sessionStorage.setItem("backup_uploadedImages", JSON.stringify(newList));
          return newList;
        });
      }
    } catch (err) {
      console.error("Delete from server failed", err);
    }
  };

  function deleteUploadedPdf(uploadedPdfsNamesList1, fileUrl, index) {
    let promise2 = new Promise((resolve, reject) => {
      if (fileUrl !== "") {
        axios
          .delete(baseURLDeleteFile, {
            params: {
              url: fileUrl,
            },
            headers: authHeader(),
          })
          .then((response) => {
            resolve();
          })
          .catch((err) => {
            console.log(err);
            if (err.response && err.response.status === 401) {
              refreshToken().then((response2) => {
                if (response2 !== false) {
                  deleteUploadedPdf(uploadedPdfsNamesList1, fileUrl, index);
                  reject();
                } else {
                  resolve();
                }
              });
            } else {
              resolve();
            }
          });
      } else {
        resolve();
      }
    });
    promise2.then(() => {
      let tempArrayNames = [...uploadedPdfsNamesList1];
      let tempArrayFiles = [...uploadedPDFFile];
      let tempArrayURLs = [...uploadedPDFURL];

      delete tempArrayNames[index];
      delete tempArrayFiles[index];
      delete tempArrayURLs[index];

      setUploadedPDFURL(tempArrayURLs);
      setUploadedPDFFile(tempArrayFiles);
      setUploadedPDFNameList(tempArrayNames);
      setDeleteUploadImageUrl("");
      setDeleteUploadImageIndex(-1);
    });
  }

  function getProjectDetail(basketId) {
    axios
      .get(baseURGetProject, {
        params: {
          id: basketId ? basketId : projectId,
        },
        headers: authHeader(),
      })
      .then((response) => {
        setProjectDetails(response.data, basketId);
      })
      .catch((err) => {
        console.log(err);
        if (err.response && err.response.status === 401) {
          refreshToken().then((response2) => {
            if (response2 !== false) {
              getProjectDetail();
            } else {
              navigate("/" + pageLanguage + "/Curtain/" + catID + "/" + modelID);
            }
          });
        } else {
          navigate("/" + pageLanguage + "/Curtain/" + catID + "/" + modelID);
        }
      });
  }

  const convertTempToFiles = (temp) => {
    const images =
      temp.uploadedImagesURL?.map((url, idx) => ({
        id: `restored-img-${Date.now()}-${idx}-${temp.uploadedImagesFile?.[idx] || ""}`,
        name: temp.uploadedImagesFile?.[idx] || "unknown",
        url: imgUrl(url),
        size: 0,
        type: "image/" + url.split(".").pop(),
        status: "success",
        uploadedAt: new Date(0),
      })) || [];
    const pdfs =
      temp.uploadedPDFURL?.map((url, idx) => ({
        id: `restored-pdf-${Date.now()}-${idx}-${temp.uploadedPDFFile?.[idx] || ""}`,
        name: temp.uploadedPDFFile?.[idx] || "unknown",
        url: imgUrl(url),
        size: 0,
        type: "application/pdf",
        status: "success",
        uploadedAt: new Date(0),
      })) || [];
    return { images, pdfs };
  };

  function setProjectDetails(data, editIndex, changeLang) {
    let storedImages = [];
    let storedPDFs = [];
    try {
      const imagesRaw = sessionStorage.getItem("backup_uploadedImages");
      const pdfsRaw = sessionStorage.getItem("backup_uploadedPDFs");
      if (imagesRaw) storedImages = JSON.parse(imagesRaw);
      if (pdfsRaw) storedPDFs = JSON.parse(pdfsRaw);
    } catch (e) {
      console.error("sessionStorage read error", e);
    }
    if (storedImages.length) setUploadedImages(storedImages);
    if (storedPDFs.length) setUploadedPDFs(storedPDFs);

    setPageLoad(true);
    setBoardLoad(true);
    setRodsLoad(true);
    setRodsLoad2(true);
    setMesLoad(true);

    setExtendedTitle({
      1: [],
      2: [],
      6: [],
      8: [],
      "8A": [],
      "8B": [],
      "8C": [],
      9: [],
    });
    if (data && Object.keys(data).length !== 0) {
      setProjectData(data);
    }

    let pageLanguage = location.pathname
      .split("")
      .slice(1, 3)
      .join("");
    let tempLabels = {};
    let tempValue = {};
    let selectValues = JSON.parse(JSON.stringify(selectCustomValues));
    let tempSelect = JSON.parse(JSON.stringify(roomLabelSelect));
    let depSetTempArr = new Set([...depSet]);
    let tempExtended = extendedTitle;

    let postfixFa = "س\u200Cم";
    let postfixEn = "cm";

    GetUserProjectData(data, isLoggedIn, editIndex, changeLang).then((temp) => {
      if (editIndex !== undefined && Object.keys(temp).length !== 0) {
        setCartProjectIndex(editIndex);
      }
      setCartValues(temp);

      let tempFabric = {};
      let tempFabric2 = {};
      let tempSheers = {};
      let tempSheers2 = {};
      let promise2 = new Promise((resolve, reject) => {
        if (temp["FabricId"] || temp["FabricId2"] || temp["SheersId1"] || temp["SheersId2"]) {
          let paramObj = {
            modelId: modelID,
          };
          setLoading(true);
          axios
            .get(baseURLFabrics, {
              params: paramObj,
            })
            .then((response) => {
              let promiseArr = [];
              response.data.forEach((obj, index) => {
                promiseArr[index] = new Promise((resolve, reject) => {
                  if (obj["FabricId"] === temp["FabricId"]) {
                    setStep1(obj["FabricId"]);
                    tempFabric = obj;
                  }
                  if (obj["FabricId"] === temp["FabricId2"]) {
                    setStep2(obj["FabricId"]);
                    tempFabric2 = obj;
                  }
                  if (obj["FabricId"] === temp["SheersId1"]) {
                    tempSheers = obj;
                  }
                  if (obj["FabricId"] === temp["SheersId2"]) {
                    tempSheers2 = obj;
                  }
                  resolve();
                });
              });
              Promise.all(promiseArr).then(() => {
                resolve();
              });
            })
            .catch((err) => {
              console.log(err);
              reject();
            })
            .finally(() => {
              setLoading(false);
            });
        } else {
          reject();
        }
      });
      promise2
        .then(() => {
          if (Object.keys(tempFabric).length > 0 || Object.keys(tempFabric2).length > 0) {
            if (Object.keys(tempFabric).length > 0) {
              const photoUrl4709 = findFabricPhotoById(tempFabric.FabricPhotos, 4709);
              let temp1 = JSON.parse(JSON.stringify(fabricSelected));
              temp1.selectedFabricId = tempFabric.FabricId;
              temp1.selectedTextEn = tempFabric.DesignEnName;
              temp1.selectedTextFa = tempFabric.DesignName;
              temp1.selectedDesignCode = tempFabric.DesignCode;
              temp1.selectedColorEn = tempFabric.ColorEnName;
              temp1.selectedColorFa = tempFabric.ColorName;
              temp1.selectedHasTrim = tempFabric.HasTrim;
              temp1.selectedPhoto = tempFabric.FabricOnModelPhotoUrl;
              temp1.selectedPhoto2 = photoUrl4709;
              temp1.FabricWidth = tempFabric.FabricWidth;
              temp1.SewingDirection = tempFabric.SewingDirection;
              setFabricSelected(temp1);
              tempLabels["1"] =
                location.pathname
                  .split("")
                  .slice(1, 3)
                  .join("") === "fa"
                  ? tempFabric["DesignName"] + " / " + tempFabric["ColorName"]
                  : tempFabric["DesignEnName"] + " / " + tempFabric["ColorEnName"];
              tempValue["1"] = temp["FabricId"];

              tempExtended["1"][0] = tempLabels["1"];
              depSetTempArr = new Set([...setGetDeps("", "1", depSetTempArr)]);
            }
            if (Object.keys(tempFabric2).length > 0) {
              const photoUrl4709 = findFabricPhotoById(tempFabric2.FabricPhotos, 4709);

              let temp1 = JSON.parse(JSON.stringify(fabricSelected2));
              temp1.selectedFabricId = tempFabric2.FabricId;
              temp1.selectedTextEn = tempFabric2.DesignEnName;
              temp1.selectedTextFa = tempFabric2.DesignName;
              temp1.selectedDesignCode = tempFabric.DesignCode;
              temp1.selectedColorEn = tempFabric2.ColorEnName;
              temp1.selectedColorFa = tempFabric2.ColorName;
              temp1.selectedHasTrim = tempFabric2.HasTrim;
              temp1.selectedPhoto = tempFabric2.FabricOnModelPhotoUrl;
              temp1.selectedPhoto2 = photoUrl4709;
              temp1.FabricWidth = tempFabric2.FabricWidth;
              temp1.SewingDirection = tempFabric2.SewingDirection;
              setFabricSelected2(temp1);
              tempLabels["2"] =
                location.pathname
                  .split("")
                  .slice(1, 3)
                  .join("") === "fa"
                  ? tempFabric2["DesignName"] + " / " + tempFabric2["ColorName"]
                  : tempFabric2["DesignEnName"] + " / " + tempFabric2["ColorEnName"];
              tempValue["2"] = temp["FabricId2"];
              tempExtended["2"][0] = tempLabels["2"];
              depSetTempArr = new Set([...setGetDeps("", "2", depSetTempArr)]);
            }
            if (Object.keys(tempSheers).length > 0) {
              let temp1 = JSON.parse(JSON.stringify(sheersSelected));
              temp1.selectedFabricId = tempSheers.FabricId;
              temp1.selectedTextEn = tempSheers.DesignEnName;
              temp1.selectedTextFa = tempSheers.DesignName;
              temp1.selectedColorEn = tempSheers.ColorEnName;
              temp1.selectedColorFa = tempSheers.ColorName;
              temp1.selectedHasTrim = tempSheers.HasTrim;
              temp1.selectedPhoto = tempSheers.FabricOnModelPhotoUrl;
              setSheersSelected(temp1);
              depSetTempArr = new Set([...setGetDeps("", "2B1", depSetTempArr)]);
            } else if (Object.keys(tempSheers2).length > 0) {
              let temp1 = JSON.parse(JSON.stringify(sheersSelected2));
              temp1.selectedFabricId = tempSheers2.FabricId;
              temp1.selectedTextEn = tempSheers2.DesignEnName;
              temp1.selectedTextFa = tempSheers2.DesignName;
              temp1.selectedColorEn = tempSheers2.ColorEnName;
              temp1.selectedColorFa = tempSheers2.ColorName;
              temp1.selectedHasTrim = tempSheers2.HasTrim;
              temp1.selectedPhoto = tempSheers2.FabricOnModelPhotoUrl;
              setSheersSelected2(temp1);
              depSetTempArr = new Set([...setGetDeps("", "2B1", depSetTempArr)]);
            }

            setStepSelectedLabel(tempLabels);
            setStepSelectedValue(tempValue);
            promise2.reject();
          }
        })
        .catch(() => {
          setTimeout(() => {
            if (temp["BorderOrTrimId"]) {
              setStep1Check(`${tempFabric.DesignCode}`);
              if (temp["borderPosition"]) {
                setStep1Border(temp["BorderOrTrimId"]);
                setStep1BorderRadio(temp["borderPosition"]);
                tempExtended["1"][1] = (
                  <li key="1" className="step_title_extended_list_item">
                    <span className="step_title_extended_list_item_title">
                      {t("Decorative Border")}
                    </span>
                    <span className="step_title_extended_list_item_text">
                      {location.pathname
                        .split("")
                        .slice(1, 3)
                        .join("") === "fa"
                        ? temp["BorderOrTrimDesignFa"] + " / " + temp["BorderOrTrimColorFa"]
                        : CapitalizeAllWords(
                            temp["BorderOrTrimDesignEn"] + " / " + temp["BorderOrTrimColorEn"]
                          )}
                    </span>
                  </li>
                );
                tempExtended["1"][2] = (
                  <li key="2" className="step_title_extended_list_item">
                    <span className="step_title_extended_list_item_title">
                      {t("Border Position")}
                    </span>
                    <span className="step_title_extended_list_item_text">
                      {pageLanguage === "en"
                        ? CapitalizeAllWords(t(temp["borderPosition"]))
                        : t(temp["borderPosition"])}
                    </span>
                  </li>
                );
              } else {
                setStep1Trim(temp["BorderOrTrimId"]);
                tempExtended["1"][1] = (
                  <li key="1" className="step_title_extended_list_item">
                    <span className="step_title_extended_list_item_title">
                      {t("Decorative Trim")}
                    </span>
                    <span className="step_title_extended_list_item_text">
                      {location.pathname
                        .split("")
                        .slice(1, 3)
                        .join("") === "fa"
                        ? temp["BorderOrTrimDesignFa"] + " / " + temp["BorderOrTrimColorFa"]
                        : CapitalizeAllWords(
                            temp["BorderOrTrimDesignEn"] + " / " + temp["BorderOrTrimColorEn"]
                          )}
                    </span>
                  </li>
                );
              }
            }

            if (temp["BorderOrTrimId2"]) {
              setStep2Check(`${tempFabric2.DesignCode}`);
              if (temp["borderPosition2"]) {
                setStep2Border(temp["BorderOrTrimId2"]);
                setStep2BorderRadio(temp["borderPosition2"]);
                tempExtended["2"][1] = (
                  <li key="1" className="step_title_extended_list_item">
                    <span className="step_title_extended_list_item_title">
                      {t("Decorative Border")}
                    </span>
                    <span className="step_title_extended_list_item_text">
                      {location.pathname
                        .split("")
                        .slice(1, 3)
                        .join("") === "fa"
                        ? temp["BorderOrTrimDesignFa2"] + " / " + temp["BorderOrTrimColorFa2"]
                        : CapitalizeAllWords(
                            temp["BorderOrTrimDesignEn2"] + " / " + temp["BorderOrTrimColorEn2"]
                          )}
                    </span>
                  </li>
                );
                tempExtended["2"][2] = (
                  <li key="2" className="step_title_extended_list_item">
                    <span className="step_title_extended_list_item_title">
                      {t("Border Position")}
                    </span>
                    <span className="step_title_extended_list_item_text">
                      {pageLanguage === "en"
                        ? CapitalizeAllWords(t(temp["borderPosition2"]))
                        : t(temp["borderPosition2"])}
                    </span>
                  </li>
                );
              } else {
                setStep2Trim(temp["BorderOrTrimId2"]);
                tempExtended["2"][1] = (
                  <li key="1" className="step_title_extended_list_item">
                    <span className="step_title_extended_list_item_title">
                      {t("Decorative Trim")}
                    </span>
                    <span className="step_title_extended_list_item_text">
                      {location.pathname
                        .split("")
                        .slice(1, 3)
                        .join("") === "fa"
                        ? temp["BorderOrTrimDesignFa2"] + " / " + temp["BorderOrTrimColorFa2"]
                        : CapitalizeAllWords(
                            temp["BorderOrTrimDesignEn2"] + " / " + temp["BorderOrTrimColorEn2"]
                          )}
                    </span>
                  </li>
                );
              }
            }

            if (temp["SheerHeaderStyle"]) {
              setStep2A(temp["SheerHeaderStyle"]);
              if (temp["SheerHeaderStyle"] === "Grommet") {
                let refIndex = inputs?.current["2A1"]?.getAttribute("ref-num");
                tempLabels[refIndex] = inputs?.current["2A1"]?.getAttribute("text");
                tempValue[refIndex] = inputs?.current["2A1"]?.value;
                depSetTempArr = new Set([...setGetDeps("", "2A", depSetTempArr)]);
                setSheersModelId("0099");
              } else if (temp["SheerHeaderStyle"] === "Inverted Box Pleat") {
                let refIndex = inputs?.current["2A2"]?.getAttribute("ref-num");
                tempLabels[refIndex] = inputs?.current["2A2"]?.getAttribute("text");
                tempValue[refIndex] = inputs?.current["2A2"]?.value;
                depSetTempArr = new Set([...setGetDeps("", "2A", depSetTempArr)]);
                setSheersModelId("0036");
              } else if (temp["SheerHeaderStyle"] === "Pencil Pleat") {
                let refIndex = inputs?.current["2A3"]?.getAttribute("ref-num");
                tempLabels[refIndex] = inputs?.current["2A3"]?.getAttribute("text");
                tempValue[refIndex] = inputs?.current["2A3"]?.value;
                depSetTempArr = new Set([...setGetDeps("", "2A", depSetTempArr)]);
                setSheersModelId("0001");
              } else {
                let refIndex = inputs?.current["2A4"]?.getAttribute("ref-num");
                tempLabels[refIndex] = inputs?.current["2A4"]?.getAttribute("text");
                tempValue[refIndex] = inputs?.current["2A4"]?.value;
                depSetTempArr = new Set([...setGetDeps("", "2A", depSetTempArr)]);
              }
              setStepSelectedLabel(tempLabels);
              setStepSelectedValue(tempValue);
            }

            if (temp["PrivacyLayer"]) {
              setStep2B(temp["PrivacyLayer"]);
              if (temp["PrivacyLayer"] === "None") {
                let refIndex = inputs?.current["2B1"]?.getAttribute("ref-num");
                tempLabels[refIndex] = inputs?.current["2B1"]?.getAttribute("text");
                tempValue[refIndex] = inputs?.current["2B1"]?.value;
                depSetTempArr = new Set([...setGetDeps("", "2B,2B1", depSetTempArr)]);
              } else if (temp["PrivacyLayer"] === "Semi Sheer") {
                let refIndex = inputs?.current["2B2"]?.getAttribute("ref-num");
                tempLabels[refIndex] = inputs?.current["2B2"]?.getAttribute("text");
                tempValue[refIndex] = inputs?.current["2B2"]?.value;
                if (temp["SheersId1"]) {
                  setStep2B1(temp["SheersId1"]);
                  tempLabels["2B"] =
                    location.pathname
                      .split("")
                      .slice(1, 3)
                      .join("") === "fa"
                      ? tempSheers["DesignName"] + " / " + tempSheers["ColorName"]
                      : tempSheers["DesignEnName"] + " / " + tempSheers["ColorEnName"];
                }
                depSetTempArr = new Set([
                  ...setGetDeps(temp["SheersId1"] !== undefined ? "" : "2B1,", "2B", depSetTempArr),
                ]);
              } else {
                let refIndex = inputs.current["2B3"].getAttribute("ref-num");
                tempLabels[refIndex] = inputs.current["2B3"].getAttribute("text");
                tempValue[refIndex] = inputs.current["2B3"].value;
                if (temp["SheersId2"]) {
                  setStep2B1(temp["SheersId2"]);
                  tempLabels["2B"] =
                    location.pathname
                      .split("")
                      .slice(1, 3)
                      .join("") === "fa"
                      ? tempSheers2["DesignName"] + " / " + tempSheers2["ColorName"]
                      : tempSheers2["DesignEnName"] + " / " + tempSheers2["ColorEnName"];
                }
                depSetTempArr = new Set([
                  ...setGetDeps(temp["SheersId2"] !== undefined ? "" : "2B1,", "2B", depSetTempArr),
                ]);
              }

              if (temp["PrivacyLayer"] !== "None") {
                if (temp["PrivacyLayerHeaderStyle"]) {
                  setStep2C(temp["PrivacyLayerHeaderStyle"]);
                  if (temp["PrivacyLayerHeaderStyle"] === "Grommet") {
                    let refIndex = inputs.current["2C1"].getAttribute("ref-num");
                    tempLabels[refIndex] = inputs.current["2C1"].getAttribute("text");
                    tempValue[refIndex] = inputs.current["2C1"].value;
                    depSetTempArr = new Set([...setGetDeps("", "2C", depSetTempArr)]);
                    setSheersModelId2("0099");
                  } else if (temp["PrivacyLayerHeaderStyle"] === "Inverted Box Pleat") {
                    let refIndex = inputs?.current["2C2"]?.getAttribute("ref-num");
                    tempLabels[refIndex] = inputs?.current["2C2"]?.getAttribute("text");
                    tempValue[refIndex] = inputs?.current["2C2"]?.value;
                    depSetTempArr = new Set([...setGetDeps("", "2C", depSetTempArr)]);
                    setSheersModelId2("0036");
                  } else if (temp["PrivacyLayerHeaderStyle"] === "Pencil Pleat") {
                    let refIndex = inputs.current["2C3"].getAttribute("ref-num");
                    tempLabels[refIndex] = inputs.current["2C3"].getAttribute("text");
                    tempValue[refIndex] = inputs.current["2C3"].value;
                    depSetTempArr = new Set([...setGetDeps("", "2C", depSetTempArr)]);
                    setSheersModelId2("0001");
                  } else {
                    let refIndex = inputs.current["2C4"]?.getAttribute("ref-num");
                    tempLabels[refIndex] = inputs.current["2C4"]?.getAttribute("text");
                    tempValue[refIndex] = inputs.current["2C4"]?.value;
                    depSetTempArr = new Set([...setGetDeps("", "2C", depSetTempArr)]);
                  }
                }
              }
              setStepSelectedLabel(tempLabels);
              setStepSelectedValue(tempValue);
            }

            if (temp["Mount"]) {
              setStep3A0(temp["Mount"].toString());
              if (temp["Mount"] === "Wall") {
                let refIndex = inputs?.current["3A01"]?.getAttribute("ref-num");
                tempLabels[refIndex] = inputs?.current["3A01"]?.getAttribute("text");
                tempValue[refIndex] = inputs?.current["3A01"]?.value;
                depSetTempArr = new Set([...setGetDeps("", "3A0", depSetTempArr)]);
              } else if (temp["Mount"] === "Ceiling") {
                let refIndex = inputs?.current["3A02"]?.getAttribute("ref-num");
                tempLabels[refIndex] = inputs?.current["3A02"]?.getAttribute("text");
                tempValue[refIndex] = inputs?.current["3A02"]?.value;
                depSetTempArr = new Set([...setGetDeps("", "3A0", depSetTempArr)]);
              } else {
                let refIndex = inputs?.current["3A03"]?.getAttribute("ref-num");
                tempLabels[refIndex] = inputs?.current["3A03"]?.getAttribute("text");
                tempValue[refIndex] = inputs?.current["3A03"]?.value;
                setDepth(temp["Depth"] ? temp["Depth"] : undefined);
                setMouldingHeight(temp["MouldingHeight"] ? temp["MouldingHeight"] : undefined);
                depSetTempArr = new Set([
                  ...setGetDeps(
                    (temp["Depth"] !== undefined ? "" : "3A11,") +
                      (temp["MouldingHeight"] !== undefined ? "" : "3A12,"),
                    "3A0",
                    depSetTempArr
                  ),
                ]);
              }
              setStepSelectedLabel(tempLabels);
              setStepSelectedValue(tempValue);
            }

            const calcRaw = Array.isArray(temp["calcMeasurements"])
              ? temp["calcMeasurements"][0]
              : temp["calcMeasurements"];
            const hasOwnMeasurements = calcRaw === false || `${calcRaw}` === "false";

            if (temp["calcMeasurements"] !== undefined) {
              setStep3(temp["calcMeasurements"].toString());
              if (hasOwnMeasurements) {
                // Same as live "I have my own measurements": default Full and hide step 7
                setStep5("Full");
                let refIndex = inputs?.current["31"]?.getAttribute("ref-num");
                tempLabels[refIndex] = inputs?.current["31"]?.getAttribute("text");
                tempValue[refIndex] = inputs?.current["31"]?.value;
                setStepSelectedLabel(tempLabels);
                setStepSelectedValue(tempValue);

                setWidth(temp["Width"] ? temp["Width"] : undefined);
                setHeight(temp["Height"] ? temp["Height"] : undefined);
                depSetTempArr = new Set([
                  ...setGetDeps(
                    (temp["Width"] ? "" : "311,") + (temp["Height"] ? "" : "312,"),
                    "3",
                    depSetTempArr
                  ),
                ]);
                setSelectCustomValues(selectValues);
              } else {
                let refIndex = inputs.current["32"].getAttribute("ref-num");
                tempLabels[refIndex] = inputs?.current["32"]?.getAttribute("text");
                tempValue[refIndex] = inputs?.current["32"]?.value;
                setStepSelectedLabel(tempLabels);
                setStepSelectedValue(tempValue);
                depSetTempArr = new Set([...setGetDeps("", "3", depSetTempArr)]);

                if (temp["hasRod"] !== undefined) {
                  setStep31(temp["hasRod"].toString());
                  depSetTempArr = new Set([...setGetDeps("", "3,31", depSetTempArr)]);
                  if (!temp["hasRod"]) {
                    let scenario = 0;
                    if (temp["CurtainPosition"]) {
                      setStep3A(temp["CurtainPosition"].toString());
                      if (temp["CurtainPosition"] === "Standard") {
                        let refIndex = inputs.current["3A1"].getAttribute("ref-num");
                        tempLabels[refIndex] = inputs.current["3A1"].getAttribute("text");
                        tempValue[refIndex] = inputs.current["3A1"].value;

                        depSetTempArr = new Set([...setGetDeps("", "3A", depSetTempArr)]);
                      } else if (temp["CurtainPosition"] === "Wall to Wall") {
                        let refIndex = inputs.current["3A2"].getAttribute("ref-num");
                        tempLabels[refIndex] = inputs.current["3A2"].getAttribute("text");
                        tempValue[refIndex] = inputs.current["3A2"].value;

                        depSetTempArr = new Set([...setGetDeps("", "3A", depSetTempArr)]);
                      } else if (temp["CurtainPosition"] === "Left Corner Window") {
                        let refIndex = inputs.current["3A3"].getAttribute("ref-num");
                        tempLabels[refIndex] = inputs.current["3A3"].getAttribute("text");
                        tempValue[refIndex] = inputs.current["3A3"].value;

                        depSetTempArr = new Set([...setGetDeps("", "3A", depSetTempArr)]);
                      } else {
                        let refIndex = inputs.current["3A4"].getAttribute("ref-num");
                        tempLabels[refIndex] = inputs.current["3A4"].getAttribute("text");
                        tempValue[refIndex] = inputs.current["3A4"].value;

                        depSetTempArr = new Set([...setGetDeps("", "3A", depSetTempArr)]);
                      }
                      if (temp["Mount"]) {
                        if (temp["FinishedLengthType"]) {
                          setStep3B(temp["FinishedLengthType"].toString());
                          if (
                            temp["FinishedLengthType"] === "Sill" ||
                            temp["FinishedLengthType"] === "Apron"
                          ) {
                            if (
                              (temp["Mount"] === "Ceiling" || temp["Mount"] === "Moulding") &&
                              (temp["CurtainPosition"] === "Standard" ||
                                temp["CurtainPosition"] === "Left Corner Window" ||
                                temp["CurtainPosition"] === "Right Corner Window")
                            ) {
                              scenario = 1;
                            } else if (
                              temp["Mount"] === "Wall" &&
                              temp["CurtainPosition"] === "Wall to Wall"
                            ) {
                              scenario = 2;
                            } else if (
                              (temp["Mount"] === "Ceiling" || temp["Mount"] === "Moulding") &&
                              temp["CurtainPosition"] === "Wall to Wall"
                            ) {
                              scenario = 3;
                            } else {
                              scenario = 4;
                            }

                            if (temp["FinishedLengthType"] === "Sill") {
                              let refIndex = inputs.current["3B1"].getAttribute("ref-num");
                              tempLabels[refIndex] = inputs.current["3B1"].getAttribute("text");
                              tempValue[refIndex] = inputs.current["3B1"].value;
                            } else {
                              let refIndex = inputs.current["3B2"].getAttribute("ref-num");
                              tempLabels[refIndex] = inputs.current["3B2"].getAttribute("text");
                              tempValue[refIndex] = inputs.current["3B2"].value;
                              // setStep3B1("true");
                            }
                          } else {
                            if (
                              (temp["Mount"] === "Ceiling" || temp["Mount"] === "Moulding") &&
                              (temp["CurtainPosition"] === "Standard" ||
                                temp["CurtainPosition"] === "Left Corner Window" ||
                                temp["CurtainPosition"] === "Right Corner Window")
                            ) {
                              scenario = 5;
                            } else if (
                              temp["Mount"] === "Wall" &&
                              temp["CurtainPosition"] === "Wall to Wall"
                            ) {
                              scenario = 6;
                            } else if (
                              (temp["Mount"] === "Ceiling" || temp["Mount"] === "Moulding") &&
                              temp["CurtainPosition"] === "Wall to Wall"
                            ) {
                              scenario = 7;
                            } else {
                              scenario = 8;
                            }

                            if (temp["FinishedLengthType"] === "Floor") {
                              let refIndex = inputs.current["3B3"].getAttribute("ref-num");
                              tempLabels[refIndex] = inputs.current["3B3"].getAttribute("text");
                              tempValue[refIndex] = inputs.current["3B3"].value;
                            } else {
                              let refIndex = inputs.current["3B4"].getAttribute("ref-num");
                              tempLabels[refIndex] = inputs.current["3B4"].getAttribute("text");
                              tempValue[refIndex] = inputs.current["3B4"].value;
                            }
                          }
                        }
                      }
                    }
                    setTimeout(() => {
                      if (scenario > 0) {
                        if (scenario === 1) {
                          let tempWidth = changeLang ? temp["Width3C"] : temp["Width"];

                          // selectValues["Width3C"] = tempWidth ? [{value: tempWidth}] : [];
                          setWidth3C(tempWidth ? tempWidth : undefined);
                          if (tempWidth) {
                            tempLabels["3C"] =
                              pageLanguage === "fa"
                                ? NumberToPersianWord.convertEnToPe(`${tempWidth}`) + postfixFa
                                : tempWidth + postfixEn;
                          }

                          setLeft(temp["ExtensionLeft"] ? temp["ExtensionLeft"] : undefined);
                          setRight(temp["ExtensionRight"] ? temp["ExtensionRight"] : undefined);
                          if (
                            temp["ExtensionLeft"] !== undefined &&
                            temp["ExtensionRight"] !== undefined
                          ) {
                            tempLabels["3D"] =
                              pageLanguage === "fa"
                                ? `راست:  ${NumberToPersianWord.convertEnToPe(
                                    `${temp["ExtensionRight"]}`
                                  ) +
                                    postfixFa}\u00A0\u00A0\u00A0چپ: ${NumberToPersianWord.convertEnToPe(
                                    `${temp["ExtensionLeft"]}`
                                  ) + postfixFa}`
                                : `Left: ${temp["ExtensionLeft"] +
                                    postfixEn}\u00A0\u00A0\u00A0Right: ${temp["ExtensionRight"] +
                                    postfixEn}`;
                          }

                          let tempHeight = changeLang ? temp["CeilingToWindow1"] : temp["Height"];
                          let tempHeight2 = changeLang ? temp["CeilingToWindow2"] : temp["Height2"];
                          let tempHeight3 = changeLang ? temp["CeilingToWindow3"] : temp["Height3"];

                          setCeilingToWindow1(tempHeight ? tempHeight : undefined);
                          setCeilingToWindow2(tempHeight2 ? tempHeight2 : undefined);
                          setCeilingToWindow3(tempHeight3 ? tempHeight3 : undefined);
                          if (tempHeight && tempHeight2 && tempHeight3) {
                            let tempMax = Math.min(tempHeight, tempHeight2, tempHeight3);
                            tempLabels["3EStandardCeiling"] =
                              pageLanguage === "fa"
                                ? NumberToPersianWord.convertEnToPe(`${tempMax}`) + postfixFa
                                : tempMax + postfixEn;
                          }

                          // selectValues["CeilingToFloor"] = temp["CeilingToFloor"] ? [{value: temp["CeilingToFloor"]}] : [];
                          setCeilingToFloor(
                            temp["CeilingToFloor"] ? temp["CeilingToFloor"] : undefined
                          );
                          if (temp["CeilingToFloor"] !== undefined) {
                            tempLabels["3G"] =
                              pageLanguage === "fa"
                                ? NumberToPersianWord.convertEnToPe(`${temp["CeilingToFloor"]}`) +
                                  postfixFa
                                : temp["CeilingToFloor"] + postfixEn;
                          }

                          depSetTempArr = new Set([
                            ...setGetDeps(
                              (tempWidth ? "" : "3C,") +
                                (temp["ExtensionLeft"] !== undefined ? "" : "3D1,") +
                                (temp["ExtensionRight"] !== undefined ? "" : "3D2,") +
                                (tempHeight !== undefined ? "" : "3EStandardCeiling1,") +
                                (tempHeight2 !== undefined ? "" : "3EStandardCeiling2,") +
                                (tempHeight3 !== undefined ? "" : "3EStandardCeiling3,") +
                                (temp["CeilingToFloor"] !== undefined ? "" : "3G,"),
                              "31,3A,3B,3B1",
                              depSetTempArr
                            ),
                          ]);
                        } else if (scenario === 2) {
                          let tempWidth = changeLang ? temp["Width3C"] : temp["Width"];
                          let tempHeight = changeLang ? temp["Height3E"] : temp["Height"];

                          // selectValues["Width3C"] = tempWidth ? [{value: tempWidth}] : [];
                          setWidth3C(tempWidth ? tempWidth : undefined);
                          if (tempWidth) {
                            tempLabels["3C"] =
                              pageLanguage === "fa"
                                ? NumberToPersianWord.convertEnToPe(`${tempWidth}`) + postfixFa
                                : tempWidth + postfixEn;
                          }

                          // selectValues["Height3E"] = tempHeight ? [{value: tempHeight}] : [];
                          setHeight3E(tempHeight ? tempHeight : undefined);
                          if (tempHeight) {
                            tempLabels["3E"] =
                              pageLanguage === "fa"
                                ? NumberToPersianWord.convertEnToPe(`${tempHeight}`) + postfixFa
                                : tempHeight + postfixEn;
                          }

                          // selectValues["ShadeMount"] = temp["ShadeMount"] ? [{value: temp["ShadeMount"]}] : [];
                          setMount(temp["ShadeMount"] ? temp["ShadeMount"] : undefined);
                          if (temp["ShadeMount"] !== undefined) {
                            tempLabels["3F"] =
                              pageLanguage === "fa"
                                ? NumberToPersianWord.convertEnToPe(`${temp["ShadeMount"]}`) +
                                  postfixFa
                                : temp["ShadeMount"] + postfixEn;
                          }

                          // selectValues["CeilingToFloor"] = temp["CeilingToFloor"] ? [{value: temp["CeilingToFloor"]}] : [];
                          setCeilingToFloor(
                            temp["CeilingToFloor"] ? temp["CeilingToFloor"] : undefined
                          );
                          if (temp["CeilingToFloor"] !== undefined) {
                            tempLabels["3G"] =
                              pageLanguage === "fa"
                                ? NumberToPersianWord.convertEnToPe(`${temp["CeilingToFloor"]}`) +
                                  postfixFa
                                : temp["CeilingToFloor"] + postfixEn;
                          }

                          depSetTempArr = new Set([
                            ...setGetDeps(
                              (tempWidth ? "" : "3C,") +
                                (tempHeight !== undefined ? "" : "3E,") +
                                (temp["ShadeMount"] !== undefined ? "" : "3F,") +
                                (temp["CeilingToFloor"] !== undefined ? "" : "3G,"),
                              "31,3A,3B,3B1",
                              depSetTempArr
                            ),
                          ]);
                        } else if (scenario === 3) {
                          let tempWidth = changeLang ? temp["Width3C"] : temp["Width"];

                          // selectValues["Width3C"] = tempWidth ? [{value: tempWidth}] : [];
                          setWidth3C(tempWidth ? tempWidth : undefined);
                          if (tempWidth) {
                            tempLabels["3C"] =
                              pageLanguage === "fa"
                                ? NumberToPersianWord.convertEnToPe(`${tempWidth}`) + postfixFa
                                : tempWidth + postfixEn;
                          }

                          let tempHeight = changeLang ? temp["CeilingToWindow1"] : temp["Height"];
                          let tempHeight2 = changeLang ? temp["CeilingToWindow2"] : temp["Height2"];
                          let tempHeight3 = changeLang ? temp["CeilingToWindow3"] : temp["Height3"];

                          setCeilingToWindow1(tempHeight ? tempHeight : undefined);
                          setCeilingToWindow2(tempHeight2 ? tempHeight2 : undefined);
                          setCeilingToWindow3(tempHeight3 ? tempHeight3 : undefined);
                          if (tempHeight && tempHeight2 && tempHeight3) {
                            let tempMax = Math.min(tempHeight, tempHeight2, tempHeight3);
                            tempLabels["3EStandardCeiling"] =
                              pageLanguage === "fa"
                                ? NumberToPersianWord.convertEnToPe(`${tempMax}`) + postfixFa
                                : tempMax + postfixEn;
                          }

                          // selectValues["CeilingToFloor"] = temp["CeilingToFloor"] ? [{value: temp["CeilingToFloor"]}] : [];
                          setCeilingToFloor(
                            temp["CeilingToFloor"] ? temp["CeilingToFloor"] : undefined
                          );
                          if (temp["CeilingToFloor"] !== undefined) {
                            tempLabels["3G"] =
                              pageLanguage === "fa"
                                ? NumberToPersianWord.convertEnToPe(`${temp["CeilingToFloor"]}`) +
                                  postfixFa
                                : temp["CeilingToFloor"] + postfixEn;
                          }

                          depSetTempArr = new Set([
                            ...setGetDeps(
                              (tempWidth ? "" : "3C,") +
                                (tempHeight !== undefined ? "" : "3EStandardCeiling1,") +
                                (tempHeight2 !== undefined ? "" : "3EStandardCeiling2,") +
                                (tempHeight3 !== undefined ? "" : "3EStandardCeiling3,") +
                                (temp["CeilingToFloor"] !== undefined ? "" : "3G,"),
                              "31,3A,3B,3B1",
                              depSetTempArr
                            ),
                          ]);
                        } else if (scenario === 4) {
                          let tempWidth = changeLang ? temp["Width3C"] : temp["Width"];
                          let tempHeight = changeLang ? temp["Height3E"] : temp["Height"];

                          // selectValues["Width3C"] = tempWidth ? [{value: tempWidth}] : [];
                          setWidth3C(tempWidth ? tempWidth : undefined);
                          if (tempWidth) {
                            tempLabels["3C"] =
                              pageLanguage === "fa"
                                ? NumberToPersianWord.convertEnToPe(`${tempWidth}`) + postfixFa
                                : tempWidth + postfixEn;
                          }

                          setLeft(temp["ExtensionLeft"] ? temp["ExtensionLeft"] : undefined);
                          setRight(temp["ExtensionRight"] ? temp["ExtensionRight"] : undefined);
                          if (
                            temp["ExtensionLeft"] !== undefined &&
                            temp["ExtensionRight"] !== undefined
                          ) {
                            tempLabels["3D"] =
                              pageLanguage === "fa"
                                ? `راست:  ${NumberToPersianWord.convertEnToPe(
                                    `${temp["ExtensionRight"]}`
                                  ) +
                                    postfixFa}\u00A0\u00A0\u00A0چپ: ${NumberToPersianWord.convertEnToPe(
                                    `${temp["ExtensionLeft"]}`
                                  ) + postfixFa}`
                                : `Left: ${temp["ExtensionLeft"] +
                                    postfixEn}\u00A0\u00A0\u00A0Right: ${temp["ExtensionRight"] +
                                    postfixEn}`;
                          }

                          setHeight3E(tempHeight ? tempHeight : undefined);
                          if (tempHeight) {
                            tempLabels["3E"] =
                              pageLanguage === "fa"
                                ? NumberToPersianWord.convertEnToPe(`${tempHeight}`) + postfixFa
                                : tempHeight + postfixEn;
                          }

                          // selectValues["ShadeMount"] = temp["ShadeMount"] ? [{value: temp["ShadeMount"]}] : [];
                          setMount(temp["ShadeMount"] ? temp["ShadeMount"] : undefined);
                          if (temp["ShadeMount"] !== undefined) {
                            tempLabels["3F"] =
                              pageLanguage === "fa"
                                ? NumberToPersianWord.convertEnToPe(`${temp["ShadeMount"]}`) +
                                  postfixFa
                                : temp["ShadeMount"] + postfixEn;
                          }

                          // selectValues["CeilingToFloor"] = temp["CeilingToFloor"] ? [{value: temp["CeilingToFloor"]}] : [];
                          setCeilingToFloor(
                            temp["CeilingToFloor"] ? temp["CeilingToFloor"] : undefined
                          );
                          if (temp["CeilingToFloor"] !== undefined) {
                            tempLabels["3G"] =
                              pageLanguage === "fa"
                                ? NumberToPersianWord.convertEnToPe(`${temp["CeilingToFloor"]}`) +
                                  postfixFa
                                : temp["CeilingToFloor"] + postfixEn;
                          }

                          depSetTempArr = new Set([
                            ...setGetDeps(
                              (tempWidth ? "" : "3C,") +
                                (temp["ExtensionLeft"] !== undefined ? "" : "3D1,") +
                                (temp["ExtensionRight"] !== undefined ? "" : "3D2,") +
                                (tempHeight !== undefined ? "" : "3E,") +
                                (temp["ShadeMount"] !== undefined ? "" : "3F,") +
                                (temp["CeilingToFloor"] !== undefined ? "" : "3G,"),
                              "31,3A,3B,3B1",
                              depSetTempArr
                            ),
                          ]);
                        } else if (scenario === 5) {
                          let tempWidth = changeLang ? temp["Width3C"] : temp["Width"];

                          // selectValues["Width3C"] = tempWidth ? [{value: tempWidth}] : [];
                          setWidth3C(tempWidth ? tempWidth : undefined);
                          if (tempWidth) {
                            tempLabels["3C"] =
                              pageLanguage === "fa"
                                ? NumberToPersianWord.convertEnToPe(`${tempWidth}`) + postfixFa
                                : tempWidth + postfixEn;
                          }

                          setLeft(temp["ExtensionLeft"] ? temp["ExtensionLeft"] : undefined);
                          setRight(temp["ExtensionRight"] ? temp["ExtensionRight"] : undefined);
                          if (
                            temp["ExtensionLeft"] !== undefined &&
                            temp["ExtensionRight"] !== undefined
                          ) {
                            tempLabels["3D"] =
                              pageLanguage === "fa"
                                ? `راست:  ${NumberToPersianWord.convertEnToPe(
                                    `${temp["ExtensionRight"]}`
                                  ) +
                                    postfixFa}\u00A0\u00A0\u00A0چپ: ${NumberToPersianWord.convertEnToPe(
                                    `${temp["ExtensionLeft"]}`
                                  ) + postfixFa}`
                                : `Left: ${temp["ExtensionLeft"] +
                                    postfixEn}\u00A0\u00A0\u00A0Right: ${temp["ExtensionRight"] +
                                    postfixEn}`;
                          }

                          let tempHeight = changeLang ? temp["CeilingToFloor1"] : temp["Height"];
                          let tempHeight2 = changeLang ? temp["CeilingToFloor2"] : temp["Height2"];
                          let tempHeight3 = changeLang ? temp["CeilingToFloor3"] : temp["Height3"];

                          setCeilingToFloor1(tempHeight ? tempHeight : undefined);
                          setCeilingToFloor2(tempHeight2 ? tempHeight2 : undefined);
                          setCeilingToFloor3(tempHeight3 ? tempHeight3 : undefined);
                          if (tempHeight && tempHeight2 && tempHeight3) {
                            let tempMax = Math.min(tempHeight, tempHeight2, tempHeight3);
                            tempLabels["3EStandardCeilingFloor"] =
                              pageLanguage === "fa"
                                ? NumberToPersianWord.convertEnToPe(`${tempMax}`) + postfixFa
                                : tempMax + postfixEn;
                          }

                          depSetTempArr = new Set([
                            ...setGetDeps(
                              (tempWidth ? "" : "3C,") +
                                (temp["ExtensionLeft"] !== undefined ? "" : "3D1,") +
                                (temp["ExtensionRight"] !== undefined ? "" : "3D2,") +
                                (tempHeight !== undefined ? "" : "3EStandardCeilingFloor1,") +
                                (tempHeight2 !== undefined ? "" : "3EStandardCeilingFloor2,") +
                                (tempHeight3 !== undefined ? "" : "3EStandardCeilingFloor3,"),
                              "31,3A,3B,3B1",
                              depSetTempArr
                            ),
                          ]);
                        } else if (scenario === 6) {
                          let tempWidth = changeLang ? temp["Width3C"] : temp["Width"];
                          let tempHeight = changeLang ? temp["WindowToFloor"] : temp["Height"];

                          // selectValues["Width3C"] = tempWidth ? [{value: tempWidth}] : [];
                          setWidth3C(tempWidth ? tempWidth : undefined);
                          if (tempWidth) {
                            tempLabels["3C"] =
                              pageLanguage === "fa"
                                ? NumberToPersianWord.convertEnToPe(`${tempWidth}`) + postfixFa
                                : tempWidth + postfixEn;
                          }

                          // selectValues["WindowToFloor"] = tempHeight ? [{value: tempHeight}] : [];
                          setWindowToFloor(tempHeight ? tempHeight : undefined);
                          if (tempHeight) {
                            tempLabels["3EFloor"] =
                              pageLanguage === "fa"
                                ? NumberToPersianWord.convertEnToPe(`${tempHeight}`) + postfixFa
                                : tempHeight + postfixEn;
                          }

                          // selectValues["ShadeMount"] = temp["ShadeMount"] ? [{value: temp["ShadeMount"]}] : [];
                          setMount(temp["ShadeMount"] ? temp["ShadeMount"] : undefined);
                          if (temp["ShadeMount"] !== undefined) {
                            tempLabels["3F"] =
                              pageLanguage === "fa"
                                ? NumberToPersianWord.convertEnToPe(`${temp["ShadeMount"]}`) +
                                  postfixFa
                                : temp["ShadeMount"] + postfixEn;
                          }

                          // selectValues["CeilingToFloor"] = temp["CeilingToFloor"] ? [{value: temp["CeilingToFloor"]}] : [];
                          setCeilingToFloor(
                            temp["CeilingToFloor"] ? temp["CeilingToFloor"] : undefined
                          );
                          if (temp["CeilingToFloor"] !== undefined) {
                            tempLabels["3G"] =
                              pageLanguage === "fa"
                                ? NumberToPersianWord.convertEnToPe(`${temp["CeilingToFloor"]}`) +
                                  postfixFa
                                : temp["CeilingToFloor"] + postfixEn;
                          }

                          depSetTempArr = new Set([
                            ...setGetDeps(
                              (tempWidth ? "" : "3C,") +
                                (tempHeight !== undefined ? "" : "3EFloor,") +
                                (temp["ShadeMount"] !== undefined ? "" : "3F,") +
                                (temp["CeilingToFloor"] !== undefined ? "" : "3G,"),
                              "31,3A,3B,3B1",
                              depSetTempArr
                            ),
                          ]);
                        } else if (scenario === 7) {
                          let tempWidth = changeLang ? temp["Width3C"] : temp["Width"];

                          // selectValues["Width3C"] = tempWidth ? [{value: tempWidth}] : [];
                          setWidth3C(tempWidth ? tempWidth : undefined);
                          if (tempWidth) {
                            tempLabels["3C"] =
                              pageLanguage === "fa"
                                ? NumberToPersianWord.convertEnToPe(`${tempWidth}`) + postfixFa
                                : tempWidth + postfixEn;
                          }
                          let tempHeight = changeLang ? temp["CeilingToFloor1"] : temp["Height"];
                          let tempHeight2 = changeLang ? temp["CeilingToFloor2"] : temp["Height2"];
                          let tempHeight3 = changeLang ? temp["CeilingToFloor3"] : temp["Height3"];

                          setCeilingToFloor1(tempHeight ? tempHeight : undefined);
                          setCeilingToFloor2(tempHeight2 ? tempHeight2 : undefined);
                          setCeilingToFloor3(tempHeight3 ? tempHeight3 : undefined);
                          if (tempHeight && tempHeight2 && tempHeight3) {
                            let tempMax = Math.min(tempHeight, tempHeight2, tempHeight3);
                            tempLabels["3EStandardCeilingFloor"] =
                              pageLanguage === "fa"
                                ? NumberToPersianWord.convertEnToPe(`${tempMax}`) + postfixFa
                                : tempMax + postfixEn;
                          }

                          depSetTempArr = new Set([
                            ...setGetDeps(
                              (tempWidth ? "" : "3C,") +
                                (tempHeight !== undefined ? "" : "3EStandardCeilingFloor1,") +
                                (tempHeight2 !== undefined ? "" : "3EStandardCeilingFloor2,") +
                                (tempHeight3 !== undefined ? "" : "3EStandardCeilingFloor3,"),
                              "31,3A,3B,3B1",
                              depSetTempArr
                            ),
                          ]);
                        } else {
                          let tempWidth = changeLang ? temp["Width3C"] : temp["Width"];
                          let tempHeight = changeLang ? temp["WindowToFloor"] : temp["Height"];

                          // selectValues["Width3C"] = tempWidth ? [{value: tempWidth}] : [];
                          setWidth3C(tempWidth ? tempWidth : undefined);
                          if (tempWidth) {
                            tempLabels["3C"] =
                              pageLanguage === "fa"
                                ? NumberToPersianWord.convertEnToPe(`${tempWidth}`) + postfixFa
                                : tempWidth + postfixEn;
                          }
                          setLeft(temp["ExtensionLeft"] ? temp["ExtensionLeft"] : undefined);
                          setRight(temp["ExtensionRight"] ? temp["ExtensionRight"] : undefined);
                          if (
                            temp["ExtensionLeft"] !== undefined &&
                            temp["ExtensionRight"] !== undefined
                          ) {
                            tempLabels["3D"] =
                              pageLanguage === "fa"
                                ? `راست:  ${NumberToPersianWord.convertEnToPe(
                                    `${temp["ExtensionRight"]}`
                                  ) +
                                    postfixFa}\u00A0\u00A0\u00A0چپ: ${NumberToPersianWord.convertEnToPe(
                                    `${temp["ExtensionLeft"]}`
                                  ) + postfixFa}`
                                : `Left: ${temp["ExtensionLeft"] +
                                    postfixEn}\u00A0\u00A0\u00A0Right: ${temp["ExtensionRight"] +
                                    postfixEn}`;
                          }
                          setWindowToFloor(tempHeight ? tempHeight : undefined);
                          if (tempHeight) {
                            tempLabels["3EFloor"] =
                              pageLanguage === "fa"
                                ? NumberToPersianWord.convertEnToPe(`${tempHeight}`) + postfixFa
                                : tempHeight + postfixEn;
                          }
                          setMount(temp["ShadeMount"] ? temp["ShadeMount"] : undefined);
                          if (temp["ShadeMount"] !== undefined) {
                            tempLabels["3F"] =
                              pageLanguage === "fa"
                                ? NumberToPersianWord.convertEnToPe(`${temp["ShadeMount"]}`) +
                                  postfixFa
                                : temp["ShadeMount"] + postfixEn;
                          }
                          setCeilingToFloor(
                            temp["CeilingToFloor"] ? temp["CeilingToFloor"] : undefined
                          );
                          if (temp["CeilingToFloor"] !== undefined) {
                            tempLabels["3G"] =
                              pageLanguage === "fa"
                                ? NumberToPersianWord.convertEnToPe(`${temp["CeilingToFloor"]}`) +
                                  postfixFa
                                : temp["CeilingToFloor"] + postfixEn;
                          }

                          depSetTempArr = new Set([
                            ...setGetDeps(
                              (tempWidth ? "" : "3C,") +
                                (temp["ExtensionLeft"] !== undefined ? "" : "3D1,") +
                                (temp["ExtensionRight"] !== undefined ? "" : "3D2,") +
                                (tempHeight !== undefined ? "" : "3EFloor,") +
                                (temp["ShadeMount"] !== undefined ? "" : "3F,") +
                                (temp["CeilingToFloor"] !== undefined ? "" : "3G,"),
                              "31,3A,3B,3B1",
                              depSetTempArr
                            ),
                          ]);
                        }
                        setSelectCustomValues(selectValues);
                        setStepSelectedLabel(tempLabels);
                        setStepSelectedValue(tempValue);
                      } else {
                        depSetTempArr = new Set([
                          ...setGetDeps(
                            (temp["FinishedLengthType"] ? "" : "3B,") + "3A",
                            "3,31",
                            depSetTempArr
                          ),
                        ]);
                      }
                    }, 100);
                  } else {
                    if (temp["FinishedLengthType"]) {
                      setStep3ARod(temp["FinishedLengthType"].toString());
                      setStep3ATrack(temp["FinishedLengthType"].toString());
                      if (
                        temp["FinishedLengthType"] === "Sill" ||
                        temp["FinishedLengthType"] === "Apron"
                      ) {
                        if (temp["FinishedLengthType"] === "Sill") {
                          let refIndex = inputs.current["3ARod1"].getAttribute("ref-num");
                          tempLabels[refIndex] = inputs.current["3ARod1"].getAttribute("text");
                          tempValue[refIndex] = inputs.current["3ARod1"].value;
                        } else {
                          let refIndex = inputs.current["3ARod2"].getAttribute("ref-num");
                          tempLabels[refIndex] = inputs.current["3ARod2"].getAttribute("text");
                          tempValue[refIndex] = inputs.current["3ARod2"].value;
                          // setStep3ARod1("true");
                        }

                        let tempWidth = changeLang ? temp["RodWidth"] : temp["Width"];
                        let tempHeight = changeLang ? temp["RodToBottom"] : temp["Height"];
                        setRodWidth(tempWidth ? tempWidth : undefined);
                        if (tempWidth) {
                          tempLabels["3BRod"] =
                            pageLanguage === "fa"
                              ? NumberToPersianWord.convertEnToPe(`${tempWidth}`) + postfixFa
                              : tempWidth + postfixEn;
                        }
                        setRodToBottom(tempHeight ? tempHeight : undefined);
                        if (tempHeight) {
                          tempLabels["3CRod"] =
                            pageLanguage === "fa"
                              ? NumberToPersianWord.convertEnToPe(`${tempHeight}`) + postfixFa
                              : tempHeight + postfixEn;
                        }
                        setCeilingToFloor(
                          temp["CeilingToFloor"] ? temp["CeilingToFloor"] : undefined
                        );
                        if (temp["CeilingToFloor"] !== undefined) {
                          tempLabels["3DRod"] =
                            pageLanguage === "fa"
                              ? NumberToPersianWord.convertEnToPe(`${temp["CeilingToFloor"]}`) +
                                postfixFa
                              : temp["CeilingToFloor"] + postfixEn;
                        }

                        depSetTempArr = new Set([
                          ...setGetDeps(
                            (tempWidth !== undefined ? "" : "3BRod,") +
                              (tempHeight !== undefined ? "" : "3CRod,") +
                              (temp["CeilingToFloor"] !== undefined ? "" : "3DRod,"),
                            "31,3ARod,3ARod1",
                            depSetTempArr
                          ),
                        ]);
                        setSelectCustomValues(selectValues);
                        setStepSelectedLabel(tempLabels);
                        setStepSelectedValue(tempValue);
                      } else {
                        if (temp["FinishedLengthType"] === "Floor") {
                          let refIndex = inputs.current["3ARod3"].getAttribute("ref-num");
                          tempLabels[refIndex] = inputs.current["3ARod3"].getAttribute("text");
                          tempValue[refIndex] = inputs.current["3ARod3"].value;
                        } else {
                          let refIndex = inputs.current["3ARod4"].getAttribute("ref-num");
                          tempLabels[refIndex] = inputs.current["3ARod4"].getAttribute("text");
                          tempValue[refIndex] = inputs.current["3ARod4"].value;
                        }

                        let tempWidth = changeLang ? temp["RodWidth"] : temp["Width"];
                        let tempHeight = changeLang ? temp["RodToFloor"] : temp["Height"];
                        setRodWidth(tempWidth ? tempWidth : undefined);
                        if (tempWidth) {
                          tempLabels["3BRod"] =
                            pageLanguage === "fa"
                              ? NumberToPersianWord.convertEnToPe(`${tempWidth}`) + postfixFa
                              : tempWidth + postfixEn;
                        }
                        setRodToFloor(tempHeight ? tempHeight : undefined);
                        if (tempHeight) {
                          tempLabels["3CRodFloor"] =
                            pageLanguage === "fa"
                              ? NumberToPersianWord.convertEnToPe(`${tempHeight}`) + postfixFa
                              : tempHeight + postfixEn;
                        }
                        setCeilingToFloor(
                          temp["CeilingToFloor"] ? temp["CeilingToFloor"] : undefined
                        );
                        if (temp["CeilingToFloor"] !== undefined) {
                          tempLabels["3DRod"] =
                            pageLanguage === "fa"
                              ? NumberToPersianWord.convertEnToPe(`${temp["CeilingToFloor"]}`) +
                                postfixFa
                              : temp["CeilingToFloor"] + postfixEn;
                        }

                        depSetTempArr = new Set([
                          ...setGetDeps(
                            (tempWidth !== undefined ? "" : "3BRod,") +
                              (tempHeight !== undefined ? "" : "3CRodFloor,") +
                              (temp["CeilingToFloor"] !== undefined ? "" : "3DRod,"),
                            "31,3ARod",
                            depSetTempArr
                          ),
                        ]);
                        setSelectCustomValues(selectValues);
                        setStepSelectedLabel(tempLabels);
                        setStepSelectedValue(tempValue);
                      }
                    } else {
                      depSetTempArr = new Set([...setGetDeps("3ARod", "", depSetTempArr)]);
                    }
                  }
                } else {
                  depSetTempArr = new Set([...setGetDeps("31", "3", depSetTempArr)]);
                }
              }
            }
            if (temp["WindowWidth"] && temp["WindowHeight"]) {
              getWindowSize(temp["WindowWidth"], temp["WindowHeight"]);
            }

            if (temp["Lining"]) {
              setStep4(temp["Lining"]);
              if (temp["Lining"] === "Standard Lining") {
                let refIndex = inputs.current["41"].getAttribute("ref-num");
                tempLabels[refIndex] = inputs.current["41"].getAttribute("text");
                tempValue[refIndex] = inputs.current["41"].value;
              } else {
                let refIndex = inputs.current["42"].getAttribute("ref-num");
                tempLabels[refIndex] = inputs.current["42"].getAttribute("text");
                tempValue[refIndex] = inputs.current["42"].value;
              }
              depSetTempArr = new Set([...setGetDeps("", "4", depSetTempArr)]);
              setStepSelectedLabel(tempLabels);
              setStepSelectedValue(tempValue);
            }

            if (temp["PanelCoverage"] && !hasOwnMeasurements) {
              setStep5(temp["PanelCoverage"]);
              if (temp["PanelCoverage"] === "Full") {
                let refIndex = inputs.current["51"]?.getAttribute("ref-num");
                if (refIndex) {
                  tempLabels[refIndex] = inputs.current["51"].getAttribute("text");
                  tempValue[refIndex] = inputs.current["51"].value;
                }
              } else {
                let refIndex = inputs.current["52"]?.getAttribute("ref-num");
                if (refIndex) {
                  tempLabels[refIndex] = inputs.current["52"].getAttribute("text");
                  tempValue[refIndex] = inputs.current["52"].value;
                }
              }
              depSetTempArr = new Set([...setGetDeps("", "5", depSetTempArr)]);
              setStepSelectedLabel(tempLabels);
              setStepSelectedValue(tempValue);
            }

            if (temp["PanelTypeA"] || temp["PanelTypeB"] || temp["PanelTypeC"]) {
              setStep6("Customize Style Per Curtain");
              const panelHeader = buildLivePanelTypeHeader(temp);
              if (!tempExtended["6"]) tempExtended["6"] = [];

              if (temp["step6CHead"]) setStep6CHead(temp["step6CHead"]);
              if (temp["step6BHead"]) setStep6BHead(temp["step6BHead"]);
              if (temp["step6DHead"]) setStep6DHead(temp["step6DHead"]);

              if (temp["PanelTypeA"]) {
                setStep6A(temp["PanelTypeA"]);
                tempExtended["6"][0] = panelHeader.drapery;
                tempLabels["6"] = panelHeader.drapery;
              }
              if (temp["PanelTypeB"]) {
                setStep6B(temp["PanelTypeB"]);
                tempExtended["6"][1] = (
                  <li key="1" className="step_title_extended_list_item">
                    <span className="step_title_extended_list_item_title">{t("Sheer Panel")}</span>
                    <span className="step_title_extended_list_item_text">{panelHeader.sheer}</span>
                  </li>
                );
              }
              if (temp["PanelTypeC"]) {
                setStep6C(temp["PanelTypeC"]);
                tempExtended["6"][2] = (
                  <li key="2" className="step_title_extended_list_item">
                    <span className="step_title_extended_list_item_title">
                      {t("Privacy Layer Panel")}
                    </span>
                    <span className="step_title_extended_list_item_text">{panelHeader.lining}</span>
                  </li>
                );
              }

              depSetTempArr = new Set([
                ...setGetDeps(
                  (temp["PanelTypeA"] !== undefined ? "" : "6A,") +
                    (temp["PanelTypeB"] !== undefined ? "" : "6B,") +
                    (temp["PanelTypeC"] !== undefined ? "" : "6C,"),
                  "6",
                  depSetTempArr
                ),
              ]);
            }

            if (temp["GrommetFinish"]) {
              setStep7(temp["GrommetFinish"]);
              if (temp["GrommetFinish"] === "Satin Brass") {
                let refIndex = inputs.current["71"].getAttribute("ref-num");
                tempLabels[refIndex] = inputs.current["71"].getAttribute("text");
                tempValue[refIndex] = inputs.current["71"].value;
              } else if (temp["GrommetFinish"] === "Satin Nickel") {
                let refIndex = inputs.current["72"].getAttribute("ref-num");
                tempLabels[refIndex] = inputs.current["72"].getAttribute("text");
                tempValue[refIndex] = inputs.current["72"].value;
              } else {
                let refIndex = inputs.current["73"].getAttribute("ref-num");
                tempLabels[refIndex] = inputs.current["73"].getAttribute("text");
                tempValue[refIndex] = inputs.current["73"].value;
              }
              depSetTempArr = new Set([...setGetDeps("", "7", depSetTempArr)]);
              setStepSelectedLabel(tempLabels);
              setStepSelectedValue(tempValue);
            }

            if (temp["Hardware"]) {
              setStep8(temp["Hardware"]);
              if (temp["Hardware"] === "I Have My Own Hardware") {
                let refIndex = inputs.current["81"].getAttribute("ref-num");
                tempLabels[refIndex] = t("None");
                tempValue[refIndex] = inputs.current["81"].value;
                setHardwareDraperyStep9(temp["hardwareDrapery"]);
                setHardwareSheerStep9(temp["hardwareSheer"]);
                setHardwareLayerStep9(temp["hardwarePrivacyLayer"]);
                // Match live radio label: "نیاز ندارم." (not cart English value)
                tempExtended["8"] = [t("None")];

                const ownHardwareLabel = (rawValue) => {
                  const value = Array.isArray(rawValue) ? rawValue[0] : rawValue;
                  if (!value) return "";
                  const pools = [
                    ...(draperiesSelect[pageLanguage] || []),
                    ...(draperiesSelect2[pageLanguage] || []),
                    ...(draperiesSelect3[pageLanguage] || []),
                    ...(sheersSelect[pageLanguage] || []),
                    ...(sheersSelect2[pageLanguage] || []),
                    ...(sheersSelect3[pageLanguage] || []),
                    ...(privacyLayerSelect[pageLanguage] || []),
                    ...(privacyLayerSelect2[pageLanguage] || []),
                    ...(privacyLayerSelect3[pageLanguage] || []),
                  ];
                  const option = pools.find((opt) => opt.value === value);
                  if (!option) return value;
                  return pageLanguage === "fa" ? option.label : option.value;
                };

                if (temp["hardwareDrapery"]) {
                  const draperyOption = [
                    ...(privacyLayerSelect[pageLanguage] || []),
                    ...(privacyLayerSelect2[pageLanguage] || []),
                    ...(privacyLayerSelect3[pageLanguage] || []),
                    ...(draperiesSelect[pageLanguage] || []),
                    ...(draperiesSelect2[pageLanguage] || []),
                    ...(draperiesSelect3[pageLanguage] || []),
                  ].find((opt) => opt.value === temp["hardwareDrapery"]);
                  if (draperyOption) setSelectedDrapery([draperyOption]);
                  tempExtended["8"][1] = (
                    <li key="1" className="step_title_extended_list_item">
                      <span className="step_title_extended_list_item_title">
                        {t("Drapery Hardware")}
                      </span>
                      <span className="step_title_extended_list_item_text">
                        {ownHardwareLabel(temp["hardwareDrapery"])}
                      </span>
                    </li>
                  );
                }
                if (temp["hardwareSheer"]) {
                  const sheerOption = [
                    ...(sheersSelect[pageLanguage] || []),
                    ...(sheersSelect2[pageLanguage] || []),
                    ...(sheersSelect3[pageLanguage] || []),
                  ].find((opt) => opt.value === temp["hardwareSheer"]);
                  if (sheerOption) setSelectedSheer([sheerOption]);
                  tempExtended["8"][2] = (
                    <li key="2" className="step_title_extended_list_item">
                      <span className="step_title_extended_list_item_title">
                        {t("Sheer Hardware")}
                      </span>
                      <span className="step_title_extended_list_item_text">
                        {ownHardwareLabel(temp["hardwareSheer"])}
                      </span>
                    </li>
                  );
                }
                if (temp["hardwarePrivacyLayer"]) {
                  const privacyOption = [
                    ...(privacyLayerSelect[pageLanguage] || []),
                    ...(privacyLayerSelect2[pageLanguage] || []),
                    ...(privacyLayerSelect3[pageLanguage] || []),
                  ].find((opt) => opt.value === temp["hardwarePrivacyLayer"]);
                  if (privacyOption) setSelectedPrivacyLayer([privacyOption]);
                  tempExtended["8"][3] = (
                    <li key="3" className="step_title_extended_list_item">
                      <span className="step_title_extended_list_item_title">
                        {t("Privacy Layer Hardware")}
                      </span>
                      <span className="step_title_extended_list_item_text">
                        {ownHardwareLabel(temp["hardwarePrivacyLayer"])}
                      </span>
                    </li>
                  );
                }

                depSetTempArr = new Set([...setGetDeps("", "8", depSetTempArr)]);
              } else if (temp["Hardware"] === "Same Hardware For All Curtains") {
                let refIndex = inputs.current["82"].getAttribute("ref-num");
                tempLabels[refIndex] = inputs.current["82"].getAttribute("text");
                tempValue[refIndex] = inputs.current["82"].value;
                tempExtended["8"] = [inputs.current["82"].getAttribute("text")];

                const findRailById = (id) => {
                  if (id === undefined || id === null || id === "") return {};
                  const match = (arr) =>
                    (arr || []).find((obj) => `${obj["RailId"]}` === `${id}`) || {};
                  const from2 = match(rails2);
                  if (Object.keys(from2).length) return from2;
                  const from3 = match(rails3);
                  if (Object.keys(from3).length) return from3;
                  return match(rails);
                };

                const isTrackHardware =
                  (temp["DraperyHardware"] === "Track" && temp["RailDesignA"] === undefined) ||
                  (temp["RailDesignB"] !== undefined && temp["RailDesignA"] === undefined);
                const restoredTrackDesign =
                  temp["RailDesignB"] || temp["RailDesignA"] || temp["RailDesignC"];
                const restoredTrackColor = temp["RailIdC"] || temp["RailIdA"] || temp["RailIdB"];
                const restoredBaton = Array.isArray(temp["BatonOptionA"])
                  ? temp["BatonOptionA"][0]
                  : temp["BatonOptionA"];
                const restoredControlRaw =
                  temp["ControlPositionB"] || temp["ControlPositionA"] || temp["ControlPositionC"];
                const parseControlSide = (value) => {
                  if (value === undefined || value === null || value === "") return "";
                  const raw = Array.isArray(value) ? value[0] : value;
                  const text = `${raw}`.toLowerCase();
                  if (text.includes("left") || raw === "چپ") return "Left";
                  if (text.includes("right") || raw === "راست") return "Right";
                  return "";
                };
                const restoredControlSide = parseControlSide(restoredControlRaw);

                if (isTrackHardware) {
                  skipHardwareTypeCartWipeRef.current = true;
                  if (restoredControlSide) {
                    restoredTrackControlRef.current = restoredControlSide;
                    setStep8B4(restoredControlSide);
                  }
                  setStep6CHead9("Track");
                  const reapplyTrackToggle = () => {
                    skipHardwareTypeCartWipeRef.current = true;
                    setStep6CHead9("Track");
                    if (restoredTrackControlRef.current) {
                      setStep8B4(restoredTrackControlRef.current);
                    }
                    if (restoredTrackMotorRef.current) {
                      applyElectricTrackRestoreFromCart(restoredTrackMotorRef.current);
                    }
                  };
                  setTimeout(reapplyTrackToggle, 50);
                  setTimeout(reapplyTrackToggle, 400);
                  setTimeout(reapplyTrackToggle, 1300);
                  setTimeout(reapplyTrackToggle, 2000);

                  if (restoredTrackDesign) {
                    setStep8D1(`${restoredTrackDesign}`);
                  }

                  const railObject = findRailById(restoredTrackDesign);
                  const designNameHint = `${temp["RailDesignFaB"] ||
                    temp["RailDesignEnB"] ||
                    temp["RailDesignFaA"] ||
                    temp["RailDesignEnA"] ||
                    ""}`;
                  const hasElectricFields =
                    temp["hasPowerB"] === true ||
                    temp["hasPowerB"] === "true" ||
                    !!(temp["MotorPositionB"] || temp["RemoteNameB"] || temp["MotorChannelsB"]);
                  const railTypeId = railObject["RailTypeId"]
                    ? `${railObject["RailTypeId"]}`
                    : temp["RailTypeId"]
                    ? `${temp["RailTypeId"]}`
                    : designNameHint.includes("برقی") ||
                      designNameHint.toLowerCase().includes("electric")
                    ? "2208"
                    : designNameHint.includes("سوپر") ||
                      designNameHint.toLowerCase().includes("super")
                    ? "2207"
                    : hasElectricFields
                    ? "2208"
                    : restoredControlSide
                    ? "2207"
                    : restoredBaton
                    ? "2201"
                    : "";

                  if (hasElectricFields || railTypeId === "2208") {
                    restoredTrackMotorRef.current = {
                      hasPowerB: temp["hasPowerB"],
                      MotorPositionB: temp["MotorPositionB"] || temp["MotorPositionA"],
                      RemoteNameB: temp["RemoteNameB"] || temp["RemoteNameA"],
                      MotorChannelsB: temp["MotorChannelsB"] || temp["MotorChannelsA"],
                    };
                  }

                  if (railTypeId) {
                    setStep8DTrack(railTypeId);
                  }

                  if (restoredTrackColor) {
                    setStep8D2(`${restoredTrackColor}`);
                  }

                  if (restoredBaton && (railTypeId === "2201" || !railTypeId)) {
                    setStep83(restoredBaton);
                  }

                  if (restoredControlSide && railTypeId !== "2208") {
                    restoredTrackControlRef.current = restoredControlSide;
                    setStep8B4(restoredControlSide);
                  }

                  if (Object.keys(railObject).length > 0) {
                    showRodsColor(railObject, "8D2");
                  }

                  if (railTypeId === "2208") {
                    restoredTrackMotorRef.current = {
                      hasPowerB: temp["hasPowerB"],
                      MotorPositionB: temp["MotorPositionB"] || temp["MotorPositionA"],
                      RemoteNameB: temp["RemoteNameB"] || temp["RemoteNameA"],
                      MotorChannelsB: temp["MotorChannelsB"] || temp["MotorChannelsA"],
                    };
                    applyElectricTrackRestoreFromCart(temp, tempExtended);
                  } else if (railTypeId === "2207") {
                    setTrackType8B(2);
                    if (restoredControlSide) {
                      restoredTrackControlRef.current = restoredControlSide;
                      setStep8B4(restoredControlSide);
                    }
                  } else {
                    setTrackType8B(undefined);
                  }

                  const designLabel = railObject["DesignENName"]
                    ? pageLanguage === "fa"
                      ? convertToPersian(railObject["DesignName"])
                      : railObject["DesignENName"]
                    : pageLanguage === "fa"
                    ? temp["RailDesignFaB"] || temp["RailDesignFaA"] || temp["RailDesignFaC"]
                    : temp["RailDesignEnB"] || temp["RailDesignEnA"] || temp["RailDesignEnC"];

                  if (designLabel) {
                    tempExtended["8"][1] = (
                      <li key="1" className="step_title_extended_list_item">
                        <span className="step_title_extended_list_item_title">{t("Design")}</span>
                        <span className="step_title_extended_list_item_text">{designLabel}</span>
                      </li>
                    );
                  }

                  const colorRail = findRailById(restoredTrackColor);
                  const colorLabel =
                    colorRail["ColorName"] && colorRail["ColorEnName"]
                      ? pageLanguage === "fa"
                        ? convertToPersian(colorRail["ColorName"])
                        : colorRail["ColorEnName"]
                      : pageLanguage === "fa"
                      ? temp["RailColorFaC"] || temp["RailColorFaA"] || temp["RailColorFaB"]
                      : temp["RailColorEnC"] || temp["RailColorEnA"] || temp["RailColorEnB"];

                  if (colorLabel && railTypeId !== "2208") {
                    tempExtended["8"][2] = (
                      <li key="2" className="step_title_extended_list_item">
                        <span className="step_title_extended_list_item_title">{t("Finish")}</span>
                        <span className="step_title_extended_list_item_text">{colorLabel}</span>
                      </li>
                    );
                  }

                  if (
                    restoredBaton &&
                    (railTypeId === "2201" || !railTypeId) &&
                    !restoredControlSide
                  ) {
                    tempExtended["8"][3] = (
                      <li key="3" className="step_title_extended_list_item">
                        <span className="step_title_extended_list_item_title">{t("Baton")}</span>
                        <span className="step_title_extended_list_item_text">
                          {t(restoredBaton)}
                        </span>
                      </li>
                    );
                  } else if (restoredControlSide && railTypeId !== "2208") {
                    tempExtended["8"][3] = (
                      <li key="3" className="step_title_extended_list_item">
                        <span className="step_title_extended_list_item_title">
                          {t("Control Position")}
                        </span>
                        <span className="step_title_extended_list_item_text">
                          {t(restoredControlSide)}
                        </span>
                      </li>
                    );
                  }
                } else if (temp["RailDesignA"]) {
                  setStep81(`${temp["RailDesignA"]}`);
                  let railObject =
                    rails.find((obj) => `${obj["RailId"]}` === `${temp["RailDesignA"]}`) || {};

                  if (railObject["RailTypeId"]) {
                    setStep8RodCheck(`${railObject["RailTypeId"]}`);
                    if (
                      `${railObject["RailTypeId"]}` === "2207" ||
                      `${railObject["RailTypeId"]}` === "2208"
                    ) {
                      setStep6CHead9("Track");
                      setStep8DTrack(`${railObject["RailTypeId"]}`);
                    } else {
                      setStep6CHead9("Rod");
                    }
                  } else {
                    setStep6CHead9("Rod");
                  }

                  const designLabel = railObject["DesignENName"]
                    ? pageLanguage === "fa"
                      ? convertToPersian(railObject["DesignName"])
                      : railObject["DesignENName"]
                    : pageLanguage === "fa"
                    ? temp["RailDesignFaA"]
                    : temp["RailDesignEnA"];

                  if (designLabel) {
                    tempExtended["8"][1] = (
                      <li key="1" className="step_title_extended_list_item">
                        <span className="step_title_extended_list_item_title">{t("Design")}</span>
                        <span className="step_title_extended_list_item_text">{designLabel}</span>
                      </li>
                    );
                  }

                  if (temp["RailIdA"]) {
                    setStep82(`${temp["RailIdA"]}`);

                    let railObject2 =
                      rails.find((obj) => `${obj["RailId"]}` === `${temp["RailIdA"]}`) || {};

                    const colorLabel =
                      railObject2["ColorName"] && railObject2["ColorEnName"]
                        ? pageLanguage === "fa"
                          ? convertToPersian(railObject2["ColorName"])
                          : railObject2["ColorEnName"]
                        : pageLanguage === "fa"
                        ? temp["RailColorFaA"]
                        : temp["RailColorEnA"];

                    if (colorLabel) {
                      tempExtended["8"][2] = (
                        <li key="2" className="step_title_extended_list_item">
                          <span className="step_title_extended_list_item_title">{t("Finish")}</span>
                          <span className="step_title_extended_list_item_text">{colorLabel}</span>
                        </li>
                      );
                    }
                  }

                  if (Object.keys(railObject).length > 0) {
                    showRodsColor(railObject, "82");
                  }

                  if (temp["BatonOptionA"]) {
                    const batonValue = Array.isArray(temp["BatonOptionA"])
                      ? temp["BatonOptionA"][0]
                      : temp["BatonOptionA"];
                    // Rod baton radios use step8A4 (live); keep step83 for track batons
                    setStep8A4(batonValue);
                    setStep83(batonValue);
                    tempExtended["8"][3] = (
                      <li key="3" className="step_title_extended_list_item">
                        <span className="step_title_extended_list_item_title">{t("Baton")}</span>
                        <span className="step_title_extended_list_item_text">{t(batonValue)}</span>
                      </li>
                    );
                  }
                }
                depSetTempArr = new Set([
                  ...setGetDeps(
                    isTrackHardware
                      ? (restoredTrackDesign !== undefined ? "" : "81,") +
                          (restoredTrackColor !== undefined ? "" : "82,") +
                          (restoredBaton !== undefined ? "" : "83,813,")
                      : (temp["RailDesignA"] !== undefined ? "" : "81,") +
                          (temp["RailIdA"] !== undefined ? "" : "82,") +
                          (temp["BatonOptionA"] !== undefined ? "" : "83,813,"),
                    "8",
                    depSetTempArr
                  ),
                ]);
              } else {
                let refIndex = inputs.current["83"].getAttribute("ref-num");
                tempLabels[refIndex] = inputs.current["83"].getAttribute("text");
                tempValue[refIndex] = inputs.current["83"].value;
                depSetTempArr = new Set([
                  ...setGetDeps(
                    "8A,8B," + (temp["PrivacyLayer"] === "None" ? "" : "8C,"),
                    "8",
                    depSetTempArr
                  ),
                ]);
                tempExtended["8"] = [inputs.current["83"].getAttribute("text")];

                if (temp["DraperyHardware"]) {
                  setStep9ADrapery(temp["DraperyHardware"]);
                  if (temp["DraperyHardware"] === "None") {
                    let refIndex = inputs.current["8A1"].getAttribute("ref-num");
                    tempLabels[refIndex] = inputs.current["8A1"].getAttribute("text");
                    tempValue[refIndex] = inputs.current["8A1"].value;
                    tempExtended["8A"] = [t("None")];
                    if (temp["hardwareDrapery"]) {
                      const draperyPools = [
                        ...(sheersSelect[pageLanguage] || []),
                        ...(sheersSelect2[pageLanguage] || []),
                        ...(sheersSelect3[pageLanguage] || []),
                        ...(draperiesSelect[pageLanguage] || []),
                        ...(draperiesSelect2[pageLanguage] || []),
                        ...(draperiesSelect3[pageLanguage] || []),
                      ];
                      const draperyOption = draperyPools.find(
                        (opt) => opt.value === temp["hardwareDrapery"]
                      );
                      if (draperyOption) {
                        setSelectedDrapery([draperyOption]);
                      }
                      const draperyLabel = draperyOption
                        ? pageLanguage === "fa"
                          ? draperyOption.label
                          : draperyOption.value
                        : temp["hardwareDrapery"];
                      tempExtended["8A"][1] = (
                        <li key="1" className="step_title_extended_list_item">
                          <span className="step_title_extended_list_item_title">
                            {t("Drapery Hardware")}
                          </span>
                          <span className="step_title_extended_list_item_text">{draperyLabel}</span>
                        </li>
                      );
                    }
                    depSetTempArr = new Set([...setGetDeps("", "8A", depSetTempArr)]);
                  } else if (temp["DraperyHardware"] === "Track") {
                    let refIndex = inputs.current["8A3"].getAttribute("ref-num");
                    tempLabels[refIndex] = inputs.current["8A3"].getAttribute("text");
                    tempValue[refIndex] = inputs.current["8A3"].value;
                    tempExtended["8A"] = [inputs.current["8A3"].getAttribute("text")];
                    restoredStep9ATrackRef.current = temp;
                    applyStep9ATrackRestoreFromCart(temp, tempExtended);
                    const restoredRailObject = findRailByIdAny(
                      temp["RailDesignB"] || temp["RailDesignA"]
                    );
                    const restoredTypeId = inferStep9ATrackTypeId(temp, restoredRailObject);

                    if (restoredTypeId === "2208") {
                      setTrackType8B(1);
                    } else if (temp["ControlPositionA"] || temp["ControlPositionB"]) {
                      const controlRaw = temp["ControlPositionB"] || temp["ControlPositionA"];
                      const controlSide = parseStep9AControlSide(controlRaw);
                      if (controlSide) {
                        setStep9APosition(controlSide);
                        tempExtended["8A"][3] = (
                          <li key="3" className="step_title_extended_list_item">
                            <span className="step_title_extended_list_item_title">
                              {t("Control Position")}
                            </span>
                            <span className="step_title_extended_list_item_text">
                              {t(controlSide)}
                            </span>
                          </li>
                        );
                      }
                    }
                    depSetTempArr = new Set([
                      ...setGetDeps(
                        restoredTypeId === "2208"
                          ? temp["hasPowerA"]
                            ? temp["MotorPositionA"]
                              ? ""
                              : "8B51,"
                            : "8B5,"
                          : (temp["RailDesignA"] !== undefined || temp["RailDesignB"] !== undefined
                              ? ""
                              : "8B1,") +
                              (temp["RailIdA"] !== undefined || temp["RailColorEnA"] !== undefined
                                ? ""
                                : "8B2,") +
                              (temp["BatonOptionA"] !== undefined ||
                              temp["BatonOptionB"] !== undefined ||
                              temp["ControlPositionA"] !== undefined
                                ? ""
                                : "8A3,"),
                        "8A",
                        depSetTempArr
                      ),
                    ]);
                  } else {
                    let refIndex = inputs.current["8A2"].getAttribute("ref-num");
                    tempLabels[refIndex] = inputs.current["8A2"].getAttribute("text");
                    tempValue[refIndex] = inputs.current["8A2"].value;
                    tempExtended["8A"] = [inputs.current["8A2"].getAttribute("text")];

                    // let tempMount = changeLang ? temp["MountA"] : temp["Mount"];
                    if (temp["RailDesignA"]) {
                      setStep8A1(`${temp["RailDesignA"]}`);
                      let railObject =
                        rails.find((obj) => `${obj["RailId"]}` === `${temp["RailDesignA"]}`) || {};

                      const designLabel = railObject["DesignENName"]
                        ? pageLanguage === "fa"
                          ? convertToPersian(railObject["DesignName"])
                          : railObject["DesignENName"]
                        : pageLanguage === "fa"
                        ? temp["RailDesignFaA"]
                        : temp["RailDesignEnA"];

                      if (designLabel) {
                        tempExtended["8A"][1] = (
                          <li key="1" className="step_title_extended_list_item">
                            <span className="step_title_extended_list_item_title">
                              {t("Design")}
                            </span>
                            <span className="step_title_extended_list_item_text">
                              {designLabel}
                            </span>
                          </li>
                        );
                      }

                      if (temp["RailIdA"]) {
                        setStep8A2(`${temp["RailIdA"]}`);

                        let railObject2 =
                          rails.find((obj) => `${obj["RailId"]}` === `${temp["RailIdA"]}`) || {};

                        const colorLabel =
                          railObject2["ColorName"] && railObject2["ColorEnName"]
                            ? pageLanguage === "fa"
                              ? convertToPersian(railObject2["ColorName"])
                              : railObject2["ColorEnName"]
                            : pageLanguage === "fa"
                            ? temp["RailColorFaA"]
                            : temp["RailColorEnA"];

                        if (colorLabel) {
                          tempExtended["8A"][2] = (
                            <li key="2" className="step_title_extended_list_item">
                              <span className="step_title_extended_list_item_title">
                                {t("Finish")}
                              </span>
                              <span className="step_title_extended_list_item_text">
                                {colorLabel}
                              </span>
                            </li>
                          );
                        }
                      }

                      if (Object.keys(railObject).length > 0) {
                        showRodsColor(railObject, "8A2");
                      }

                      if (temp["BatonOptionA"]) {
                        const batonValue = Array.isArray(temp["BatonOptionA"])
                          ? temp["BatonOptionA"][0]
                          : temp["BatonOptionA"];
                        setStep8A3(batonValue);
                        tempExtended["8A"][3] = (
                          <li key="3" className="step_title_extended_list_item">
                            <span className="step_title_extended_list_item_title">
                              {t("Baton")}
                            </span>
                            <span className="step_title_extended_list_item_text">
                              {t(batonValue)}
                            </span>
                          </li>
                        );
                      }
                    }
                    depSetTempArr = new Set([
                      ...setGetDeps(
                        (temp["RailDesignA"] !== undefined ? "" : "8A1,") +
                          (temp["RailIdA"] !== undefined ? "" : "8A2,") +
                          (temp["BatonOptionA"] !== undefined ? "" : "8A3,"),
                        "8A",
                        depSetTempArr
                      ),
                    ]);
                  }
                }

                if (temp["SheerHardware"]) {
                  setStep8B(temp["SheerHardware"]);
                  if (temp["SheerHardware"] === "None") {
                    let refIndex = inputs.current["8B1"].getAttribute("ref-num");
                    tempLabels[refIndex] = inputs.current["8B1"].getAttribute("text");
                    tempValue[refIndex] = inputs.current["8B1"].value;
                    tempExtended["8B"] = [t("None")];
                    if (temp["hardwareSheer"]) {
                      const sheerPools = [
                        ...(sheersSelect[pageLanguage] || []),
                        ...(sheersSelect2[pageLanguage] || []),
                        ...(sheersSelect3[pageLanguage] || []),
                        ...(draperiesSelect[pageLanguage] || []),
                        ...(draperiesSelect2[pageLanguage] || []),
                        ...(draperiesSelect3[pageLanguage] || []),
                      ];
                      const sheerOption = sheerPools.find(
                        (opt) => opt.value === temp["hardwareSheer"]
                      );
                      if (sheerOption) {
                        setSelectedSheer([sheerOption]);
                      }
                      const sheerLabel = sheerOption
                        ? pageLanguage === "fa"
                          ? sheerOption.label
                          : sheerOption.value
                        : temp["hardwareSheer"];
                      tempExtended["8B"][1] = (
                        <li key="1" className="step_title_extended_list_item">
                          <span className="step_title_extended_list_item_title">
                            {t("Sheer Hardware")}
                          </span>
                          <span className="step_title_extended_list_item_text">{sheerLabel}</span>
                        </li>
                      );
                    }
                    depSetTempArr = new Set([...setGetDeps("", "8B", depSetTempArr)]);
                  } else if (temp["SheerHardware"] === "Track") {
                    restoredStep9BTrackRef.current = temp;
                    let refIndex = inputs.current["8B2"].getAttribute("ref-num");
                    tempLabels[refIndex] = inputs.current["8B2"].getAttribute("text");
                    tempValue[refIndex] = inputs.current["8B2"].value;
                    tempExtended["8B"] = [inputs.current["8B2"].getAttribute("text")];
                    let railObject = {};
                    let typeId = "";

                    if (temp["RailDesignB"]) {
                      setStep8B1(`${temp["RailDesignB"]}`);
                      railObject = findRailByIdAny(temp["RailDesignB"]);
                      if (!Object.keys(railObject).length) {
                        railObject = findTrackTypeBySavedName(
                          temp["RailDesignEnB"] || temp["RailDesignFaB"]
                        );
                      }

                      typeId = inferStep9ATrackTypeId(temp, railObject);
                      setStep8BRilType(typeId);
                      setTrackType8B(typeId === "2208" ? 1 : typeId === "2207" ? 2 : undefined);

                      const designLabel = railObject["DesignENName"]
                        ? pageLanguage === "fa"
                          ? convertToPersian(railObject["DesignName"])
                          : railObject["DesignENName"]
                        : pageLanguage === "fa"
                        ? temp["RailDesignFaB"]
                        : temp["RailDesignEnB"];

                      if (designLabel) {
                        tempExtended["8B"][1] = (
                          <li key="1" className="step_title_extended_list_item">
                            <span className="step_title_extended_list_item_title">
                              {t("Design")}
                            </span>
                            <span className="step_title_extended_list_item_text">
                              {designLabel}
                            </span>
                          </li>
                        );
                      }

                      if (typeId === "2208") {
                        applyStep9BElectricRestoreFromCart(temp, tempExtended);
                      } else {
                        if (temp["RailIdB"]) {
                          setStep8B2(`${temp["RailIdB"]}`);

                          let railObject2 =
                            rails2.find((obj) => `${obj["RailId"]}` === `${temp["RailIdB"]}`) ||
                            rails.find((obj) => `${obj["RailId"]}` === `${temp["RailIdB"]}`) ||
                            {};
                          if (!Object.keys(railObject2).length && railObject["DesignCode"]) {
                            const colorPool =
                              (tracks2 && tracks2[railObject["DesignCode"]]) ||
                              (tracks && tracks[railObject["DesignCode"]]) ||
                              [];
                            railObject2 =
                              colorPool.find(
                                (obj) => `${obj["RailId"]}` === `${temp["RailIdB"]}`
                              ) || {};
                          }

                          const colorLabel =
                            railObject2["ColorName"] && railObject2["ColorEnName"]
                              ? pageLanguage === "fa"
                                ? convertToPersian(railObject2["ColorName"])
                                : railObject2["ColorEnName"]
                              : pageLanguage === "fa"
                              ? temp["RailColorFaB"]
                              : temp["RailColorEnB"];

                          if (colorLabel) {
                            tempExtended["8B"][2] = (
                              <li key="2" className="step_title_extended_list_item">
                                <span className="step_title_extended_list_item_title">
                                  {t("Finish")}
                                </span>
                                <span className="step_title_extended_list_item_text">
                                  {colorLabel}
                                </span>
                              </li>
                            );
                          }
                        }

                        showRodsColor(railObject, "8B2");

                        if (temp["BatonOptionB"] && typeId !== "2207") {
                          const batonValue = Array.isArray(temp["BatonOptionB"])
                            ? temp["BatonOptionB"][0]
                            : temp["BatonOptionB"];
                          setStep8B3(batonValue);
                          tempExtended["8B"][3] = (
                            <li key="3" className="step_title_extended_list_item">
                              <span className="step_title_extended_list_item_title">
                                {t("Baton")}
                              </span>
                              <span className="step_title_extended_list_item_text">
                                {t(batonValue)}
                              </span>
                            </li>
                          );
                        }
                        if (temp["ControlPositionB"] && typeId === "2207") {
                          const controlRaw = Array.isArray(temp["ControlPositionB"])
                            ? temp["ControlPositionB"][0]
                            : temp["ControlPositionB"];
                          const controlSide = parseStep9AControlSide(controlRaw) || controlRaw;
                          setStep8B3(controlSide);
                          tempExtended["8B"][3] = (
                            <li key="3" className="step_title_extended_list_item">
                              <span className="step_title_extended_list_item_title">
                                {t("Control Position")}
                              </span>
                              <span className="step_title_extended_list_item_text">
                                {t(controlSide)}
                              </span>
                            </li>
                          );
                        }
                      }
                    }
                    depSetTempArr = new Set([
                      ...setGetDeps(
                        typeId === "2208"
                          ? temp["hasPowerB"]
                            ? temp["MotorPositionB"]
                              ? ""
                              : "8B51,"
                            : "8B5,"
                          : (temp["RailDesignB"] !== undefined ? "" : "8B1,") +
                              (temp["RailIdB"] !== undefined ? "" : "8B2,") +
                              (temp["BatonOptionB"] !== undefined ||
                              temp["ControlPositionB"] !== undefined
                                ? ""
                                : "8B3,"),
                        "8B",
                        depSetTempArr
                      ),
                    ]);
                  } else {
                    let refIndex = inputs.current["8B3"].getAttribute("ref-num");
                    tempLabels[refIndex] = inputs.current["8B3"].getAttribute("text");
                    tempValue[refIndex] = inputs.current["8B3"].value;
                    tempExtended["8B"] = [inputs.current["8B3"].getAttribute("text")];

                    if (temp["RailDesignB"]) {
                      setStep8B1(`${temp["RailDesignB"]}`);
                      let railObject =
                        rails2.find((obj) => `${obj["RailId"]}` === `${temp["RailDesignB"]}`) ||
                        rails.find((obj) => `${obj["RailId"]}` === `${temp["RailDesignB"]}`) ||
                        {};

                      if (railObject["RailTypeId"]) {
                        setStep8BRilType(`${railObject["RailTypeId"]}`);
                      }
                      setTrackType8B(undefined);

                      const designLabel = railObject["DesignENName"]
                        ? pageLanguage === "fa"
                          ? convertToPersian(railObject["DesignName"])
                          : railObject["DesignENName"]
                        : pageLanguage === "fa"
                        ? temp["RailDesignFaB"]
                        : temp["RailDesignEnB"];

                      if (designLabel) {
                        tempExtended["8B"][1] = (
                          <li key="1" className="step_title_extended_list_item">
                            <span className="step_title_extended_list_item_title">
                              {t("Design")}
                            </span>
                            <span className="step_title_extended_list_item_text">
                              {designLabel}
                            </span>
                          </li>
                        );
                      }

                      if (temp["RailIdB"]) {
                        setStep8B2(`${temp["RailIdB"]}`);

                        let railObject2 =
                          rails2.find((obj) => `${obj["RailId"]}` === `${temp["RailIdB"]}`) ||
                          rails.find((obj) => `${obj["RailId"]}` === `${temp["RailIdB"]}`) ||
                          {};

                        const colorLabel =
                          railObject2["ColorName"] && railObject2["ColorEnName"]
                            ? pageLanguage === "fa"
                              ? convertToPersian(railObject2["ColorName"])
                              : railObject2["ColorEnName"]
                            : pageLanguage === "fa"
                            ? temp["RailColorFaB"]
                            : temp["RailColorEnB"];

                        if (colorLabel) {
                          tempExtended["8B"][2] = (
                            <li key="2" className="step_title_extended_list_item">
                              <span className="step_title_extended_list_item_title">
                                {t("Finish")}
                              </span>
                              <span className="step_title_extended_list_item_text">
                                {colorLabel}
                              </span>
                            </li>
                          );
                        }
                      }

                      if (Object.keys(railObject).length > 0) {
                        showRodsColor(railObject, "8B2");
                      }

                      if (temp["BatonOptionB"]) {
                        const batonValue = Array.isArray(temp["BatonOptionB"])
                          ? temp["BatonOptionB"][0]
                          : temp["BatonOptionB"];
                        setStep8B3(batonValue);
                        tempExtended["8B"][3] = (
                          <li key="3" className="step_title_extended_list_item">
                            <span className="step_title_extended_list_item_title">
                              {t("Baton")}
                            </span>
                            <span className="step_title_extended_list_item_text">
                              {t(batonValue)}
                            </span>
                          </li>
                        );
                      }
                    }
                    depSetTempArr = new Set([
                      ...setGetDeps(
                        (temp["RailDesignB"] !== undefined ? "" : "8B1,") +
                          (temp["RailIdB"] !== undefined ? "" : "8B2,") +
                          (temp["BatonOptionB"] !== undefined ||
                          temp["ControlPositionB"] !== undefined
                            ? ""
                            : "8B3,"),
                        "8B",
                        depSetTempArr
                      ),
                    ]);
                  }
                }

                if (temp["PrivacyLayerHardware"]) {
                  setStep8C(temp["PrivacyLayerHardware"]);
                  if (temp["PrivacyLayerHardware"] === "None") {
                    let refIndex = inputs.current["8C1"].getAttribute("ref-num");
                    tempLabels[refIndex] = inputs.current["8C1"].getAttribute("text");
                    tempValue[refIndex] = inputs.current["8C1"].value;
                    tempExtended["8C"] = [t("None")];
                    if (temp["hardwarePrivacyLayer"]) {
                      const savedPrivacy = Array.isArray(temp["hardwarePrivacyLayer"])
                        ? temp["hardwarePrivacyLayer"][0]
                        : temp["hardwarePrivacyLayer"];
                      const privacyPools = [
                        ...(privacyLayerSelect[pageLanguage] || []),
                        ...(privacyLayerSelect2[pageLanguage] || []),
                        ...(privacyLayerSelect3[pageLanguage] || []),
                      ];
                      const privacyOption =
                        privacyPools.find((opt) => opt.value === savedPrivacy && !opt.disabled) ||
                        privacyPools.find((opt) => opt.value === savedPrivacy);
                      if (privacyOption) {
                        setSelectedPrivacyLayer([privacyOption]);
                      }
                      const privacyLabel = privacyOption
                        ? pageLanguage === "fa"
                          ? privacyOption.label
                          : privacyOption.value
                        : savedPrivacy;
                      tempExtended["8C"][1] = (
                        <li key="1" className="step_title_extended_list_item">
                          <span className="step_title_extended_list_item_title">
                            {t("Privacy Layer HW")}
                          </span>
                          <span className="step_title_extended_list_item_text">{privacyLabel}</span>
                        </li>
                      );
                    }
                    depSetTempArr = new Set([...setGetDeps("", "8C", depSetTempArr)]);
                  } else if (temp["PrivacyLayerHardware"] === "Track") {
                    restoredStep9CTrackRef.current = temp;
                    let refIndex = inputs.current["8C2"].getAttribute("ref-num");
                    tempLabels[refIndex] = inputs.current["8C2"].getAttribute("text");
                    tempValue[refIndex] = inputs.current["8C2"].value;
                    tempExtended["8C"] = [inputs.current["8C2"].getAttribute("text")];
                    let railObject = {};
                    let typeId = "";

                    if (temp["RailDesignC"]) {
                      setStep8C1(`${temp["RailDesignC"]}`);
                      railObject = findRailByIdAny(temp["RailDesignC"]);
                      if (!Object.keys(railObject).length) {
                        railObject = findTrackTypeBySavedName(
                          temp["RailDesignEnC"] || temp["RailDesignFaC"]
                        );
                      }

                      typeId = railObject["RailTypeId"] ? `${railObject["RailTypeId"]}` : "";
                      if (!typeId) {
                        const designHint = `${temp["RailDesignEnC"] ||
                          temp["RailDesignFaC"] ||
                          ""}`;
                        const lower = designHint.toLowerCase();
                        if (
                          temp["hasPowerC"] ||
                          temp["MotorPositionC"] ||
                          temp["RemoteNameC"] ||
                          designHint.includes("برقی") ||
                          lower.includes("electric")
                        ) {
                          typeId = "2208";
                        } else if (
                          temp["ControlPositionC"] ||
                          designHint.includes("سوپر") ||
                          lower.includes("super") ||
                          lower.includes("cord")
                        ) {
                          typeId = "2207";
                        } else {
                          typeId = "2201";
                        }
                      }
                      setStep8CTrack(typeId);
                      setTrackType8C(typeId === "2208" ? 1 : typeId === "2207" ? 2 : undefined);

                      const designLabel = railObject["DesignENName"]
                        ? pageLanguage === "fa"
                          ? convertToPersian(railObject["DesignName"])
                          : railObject["DesignENName"]
                        : pageLanguage === "fa"
                        ? temp["RailDesignFaC"]
                        : temp["RailDesignEnC"];

                      if (designLabel) {
                        tempExtended["8C"][1] = (
                          <li key="1" className="step_title_extended_list_item">
                            <span className="step_title_extended_list_item_title">
                              {t("Design")}
                            </span>
                            <span className="step_title_extended_list_item_text">
                              {designLabel}
                            </span>
                          </li>
                        );
                      }

                      if (typeId === "2208") {
                        applyStep9CElectricRestoreFromCart(temp, tempExtended);
                      } else {
                        if (temp["RailIdC"]) {
                          setStep8C2(`${temp["RailIdC"]}`);

                          let railObject2 =
                            rails3.find((obj) => `${obj["RailId"]}` === `${temp["RailIdC"]}`) || {};
                          if (!Object.keys(railObject2).length && railObject["DesignCode"]) {
                            const colorPool =
                              (tracks3 && tracks3[railObject["DesignCode"]]) ||
                              (tracks && tracks[railObject["DesignCode"]]) ||
                              [];
                            railObject2 =
                              colorPool.find(
                                (obj) => `${obj["RailId"]}` === `${temp["RailIdC"]}`
                              ) || {};
                          }

                          const colorLabel =
                            railObject2["ColorName"] && railObject2["ColorEnName"]
                              ? pageLanguage === "fa"
                                ? convertToPersian(railObject2["ColorName"])
                                : railObject2["ColorEnName"]
                              : pageLanguage === "fa"
                              ? temp["RailColorFaC"]
                              : temp["RailColorEnC"];

                          if (colorLabel) {
                            tempExtended["8C"][2] = (
                              <li key="2" className="step_title_extended_list_item">
                                <span className="step_title_extended_list_item_title">
                                  {t("Finish")}
                                </span>
                                <span className="step_title_extended_list_item_text">
                                  {colorLabel}
                                </span>
                              </li>
                            );
                          }
                        }

                        showRodsColor(railObject, "8C2");

                        if (temp["BatonOptionC"] && typeId !== "2207") {
                          const batonValue = Array.isArray(temp["BatonOptionC"])
                            ? temp["BatonOptionC"][0]
                            : temp["BatonOptionC"];
                          setStep8C3(batonValue);
                          tempExtended["8C"][3] = (
                            <li key="3" className="step_title_extended_list_item">
                              <span className="step_title_extended_list_item_title">
                                {t("Baton")}
                              </span>
                              <span className="step_title_extended_list_item_text">
                                {t(batonValue)}
                              </span>
                            </li>
                          );
                        }
                        if (temp["ControlPositionC"] && typeId === "2207") {
                          const controlRaw = Array.isArray(temp["ControlPositionC"])
                            ? temp["ControlPositionC"][0]
                            : temp["ControlPositionC"];
                          const controlSide = parseStep9AControlSide(controlRaw) || controlRaw;
                          setStep8C3(controlSide);
                          tempExtended["8C"][3] = (
                            <li key="3" className="step_title_extended_list_item">
                              <span className="step_title_extended_list_item_title">
                                {t("Control Position")}
                              </span>
                              <span className="step_title_extended_list_item_text">
                                {t(controlSide)}
                              </span>
                            </li>
                          );
                        }
                      }
                    }
                    depSetTempArr = new Set([
                      ...setGetDeps(
                        typeId === "2208"
                          ? temp["hasPowerC"]
                            ? (temp["MotorPositionC"] ? "" : "8C51,") +
                              (temp["RemoteName"] && temp["RemoteName"] !== "" ? "" : "8C52,")
                            : "8C5,"
                          : (temp["RailDesignC"] !== undefined ? "" : "8C1,") +
                              (temp["RailIdC"] !== undefined ? "" : "8C2,") +
                              (temp["BatonOptionC"] !== undefined ||
                              temp["ControlPositionC"] !== undefined
                                ? ""
                                : "8C3,"),
                        "8C",
                        depSetTempArr
                      ),
                    ]);
                  } else {
                    let refIndex = inputs.current["8C3"].getAttribute("ref-num");
                    tempLabels[refIndex] = inputs.current["8C3"].getAttribute("text");
                    tempValue[refIndex] = inputs.current["8C3"].value;
                    tempExtended["8C"] = [inputs.current["8C3"].getAttribute("text")];

                    if (temp["RailDesignC"]) {
                      setStep8C1(`${temp["RailDesignC"]}`);
                      let railObject =
                        rails3.find((obj) => `${obj["RailId"]}` === `${temp["RailDesignC"]}`) || {};

                      if (railObject["RailTypeId"]) {
                        setStep8CTrack(`${railObject["RailTypeId"]}`);
                      }
                      setTrackType8C(undefined);

                      const designLabel = railObject["DesignENName"]
                        ? pageLanguage === "fa"
                          ? convertToPersian(railObject["DesignName"])
                          : railObject["DesignENName"]
                        : pageLanguage === "fa"
                        ? temp["RailDesignFaC"]
                        : temp["RailDesignEnC"];

                      if (designLabel) {
                        tempExtended["8C"][1] = (
                          <li key="1" className="step_title_extended_list_item">
                            <span className="step_title_extended_list_item_title">
                              {t("Design")}
                            </span>
                            <span className="step_title_extended_list_item_text">
                              {designLabel}
                            </span>
                          </li>
                        );
                      }

                      if (temp["RailIdC"]) {
                        setStep8C2(`${temp["RailIdC"]}`);

                        let railObject2 =
                          rails3.find((obj) => `${obj["RailId"]}` === `${temp["RailIdC"]}`) || {};

                        const colorLabel =
                          railObject2["ColorName"] && railObject2["ColorEnName"]
                            ? pageLanguage === "fa"
                              ? convertToPersian(railObject2["ColorName"])
                              : railObject2["ColorEnName"]
                            : pageLanguage === "fa"
                            ? temp["RailColorFaC"]
                            : temp["RailColorEnC"];

                        if (colorLabel) {
                          tempExtended["8C"][2] = (
                            <li key="2" className="step_title_extended_list_item">
                              <span className="step_title_extended_list_item_title">
                                {t("Finish")}
                              </span>
                              <span className="step_title_extended_list_item_text">
                                {colorLabel}
                              </span>
                            </li>
                          );
                        }
                      }

                      if (Object.keys(railObject).length > 0) {
                        showRodsColor(railObject, "8C2");
                      }

                      if (temp["BatonOptionC"]) {
                        const batonValue = Array.isArray(temp["BatonOptionC"])
                          ? temp["BatonOptionC"][0]
                          : temp["BatonOptionC"];
                        setStep8C3(batonValue);
                        tempExtended["8C"][3] = (
                          <li key="3" className="step_title_extended_list_item">
                            <span className="step_title_extended_list_item_title">
                              {t("Baton")}
                            </span>
                            <span className="step_title_extended_list_item_text">
                              {t(batonValue)}
                            </span>
                          </li>
                        );
                      }
                    }
                    depSetTempArr = new Set([
                      ...setGetDeps(
                        (temp["RailDesignC"] !== undefined ? "" : "8C1,") +
                          (temp["RailIdC"] !== undefined ? "" : "8C2,") +
                          (temp["BatonOptionC"] !== undefined ||
                          temp["ControlPositionC"] !== undefined
                            ? ""
                            : "8C3,"),
                        "8C",
                        depSetTempArr
                      ),
                    ]);
                  }
                }
              }
              setStepSelectedLabel(tempLabels);
              setStepSelectedValue(tempValue);
            }

            if (temp["HandCurtainId"] && temp["HandCurtainNum"]) {
              const draperyNum = Array.isArray(temp["HandCurtainNum"])
                ? +temp["HandCurtainNum"][0]
                : +temp["HandCurtainNum"];
              setTiebackDraperyQty(draperyNum);
              setTiebackDrapery({
                isPlus: undefined,
                HandCurtainId: temp["HandCurtainId"],
                HandCurtainNum: draperyNum,
              });
            }

            if (temp["HandCurtainId2"] && temp["HandCurtainNum2"]) {
              const sheerNum = Array.isArray(temp["HandCurtainNum2"])
                ? +temp["HandCurtainNum2"][0]
                : +temp["HandCurtainNum2"];
              setTiebackSheerQty(sheerNum);
              setTiebackSheer({
                isPlus: undefined,
                HandCurtainId: temp["HandCurtainId2"],
                HandCurtainNum: sheerNum,
              });
            }

            const savedAccessories = getSavedAccessoriesList(temp);
            if (savedAccessories.length) {
              setCustomAcc(savedAccessories);
              temp["Accessories"] = savedAccessories;
              setCartValues((prev) => ({ ...prev, Accessories: savedAccessories }));
            }

            const accessoryHeader = buildAccessoriesHeaderText(temp);
            if (accessoryHeader.length) {
              tempExtended["9"] = accessoryHeader;
              tempLabels["9"] = accessoryHeader.join(", \n");
            }

            if (temp["RoomNameEn"]) {
              depSetTempArr = new Set([...setGetDeps("", "1001", depSetTempArr)]);
              setSelectedRoomLabel(
                temp["RoomNameEn"]
                  ? [
                      {
                        value: temp["RoomNameEn"],
                        label: rooms[pageLanguage].find((opt) => opt.value === temp["RoomNameEn"])
                          .label,
                      },
                    ]
                  : []
              );
              tempSelect.label = rooms[pageLanguage].find(
                (opt) => opt.value === temp["RoomNameEn"]
              ).label;
              tempSelect.value = temp["RoomNameEn"];
              setRoomLabelSelect(tempSelect);
              if (
                temp["WindowName"] === undefined ||
                (temp["WindowName"] && temp["WindowName"] === "")
              ) {
                tempLabels["10"] = tempSelect.label;
              } else if (temp["WindowName"]) {
                tempLabels["10"] = tempSelect.label + " - " + temp["WindowName"];
              }
              setStepSelectedLabel(tempLabels);
            }

            if (temp["WindowName"] && temp["WindowName"] !== "") {
              depSetTempArr = new Set([...setGetDeps("", "1002", depSetTempArr)]);
              setRoomLabelText(temp["WindowName"]);
            }

            if (temp["moreInfoInput"] && temp["moreInfoInput"] !== "") {
              setMoreInfoInput(temp["moreInfoInput"]);
            }

            const restoredZip = parseSavedZipCode(temp["ZipCode"]);
            if (restoredZip) {
              restoredZipcodeRef.current = restoredZip;
              setZipcode(restoredZip);
              setZipcodeButton(true);
              setHasInstall(true);
              setZipcodeChecked("true");
              temp["ZipCode"] = restoredZip;
              if (temp["InstallAmount"] && temp["InstallAmount"] > 0) {
                setInstallPrice(temp["InstallAmount"]);
              }
              if (temp["TransportationAmount"] && temp["TransportationAmount"] > 0) {
                setTransportPrice(temp["TransportationAmount"]);
              }
            }

            if (temp["uploadedImagesURL"] && temp["uploadedImagesURL"].length > 0) {
              const { images, pdfs } = convertTempToFiles(temp);
              setUploadedImages(images);
              setUploadedPDFs(pdfs);
              sessionStorage.setItem("backup_uploadedImages", JSON.stringify(images));
              sessionStorage.setItem("backup_uploadedPDFs", JSON.stringify(pdfs));
              let tempArrayNames = [];
              let tempArray = [];

              let promise3 = new Promise((resolve, reject) => {
                temp["uploadedImagesFile"].forEach((obj, index) => {
                  tempArrayNames[index] = (
                    <li className="uploaded_name_item" key={index}>
                      <i className="fa fa-file" />
                      <span className="uploaded_name_item_text">
                        {obj.replace(/\.[^/.]+$/, "")}
                      </span>
                      <span
                        className="uploaded_name_item_x"
                        onClick={() => {
                          setDeleteUploaded(temp["uploadedImagesURL"][index], index, 2);
                        }}
                      >
                        X
                      </span>
                    </li>
                  );

                  tempArray[index] = (
                    <li className="uploaded_image_item" key={index}>
                      <img
                        src={imgUrl(temp["uploadedImagesURL"][index])}
                        className="img-fluid"
                        alt=""
                      />
                    </li>
                  );

                  if (index === temp["uploadedImagesFile"].length - 1) {
                    resolve();
                  }
                });
              });

              promise3.then(() => {
                setUploadedImagesNamesList(tempArrayNames);
                setUploadedImagesList(tempArray);
              });
            }
            if (temp["uploadedPDFURL"] && temp["uploadedPDFURL"].length > 0) {
              setUploadedPDFURL(temp["uploadedPDFURL"]);
              setUploadedPDFFile(temp["uploadedPDFFile"]);
              let tempArrayNames = [];

              let promise3 = new Promise((resolve, reject) => {
                temp["uploadedPDFFile"].forEach((obj, index) => {
                  tempArrayNames[index] = (
                    <li className="uploaded_name_item" key={index}>
                      <i className="fa fa-file" />
                      <span className="uploaded_name_item_text">
                        {obj.replace(/\.[^/.]+$/, "")}
                      </span>
                      <span
                        className="uploaded_name_item_x"
                        onClick={() => {
                          setDeleteUploaded(temp["uploadedPDFURL"][index], index, 1);
                        }}
                      >
                        X
                      </span>
                    </li>
                  );
                  if (index === temp["uploadedPDFFile"].length - 1) {
                    resolve();
                  }
                });
              });

              promise3.then(() => {
                setUploadedPDFNameList(tempArrayNames);
              });
            }

            // setTimeout(() => {

            // }, 300);

            setDepSet(depSetTempArr);
            setSelectCustomValues(selectValues);
            setStepSelectedLabel(tempLabels);
            setStepSelectedValue(tempValue);
            setExtendedTitle(tempExtended);
            setPageLoad(false);
            const restoredStep6 = tempExtended["6"] ? tempExtended["6"].slice() : [];
            const restoredStep8 = tempExtended["8"] ? tempExtended["8"].slice() : [];
            const restoredStep8A = tempExtended["8A"] ? tempExtended["8A"].slice() : [];
            const restoredStep9 = tempExtended["9"] ? tempExtended["9"].slice() : [];
            if (
              restoredStep6.length ||
              restoredStep8.length ||
              restoredStep8A.length > 1 ||
              restoredStep9.length
            ) {
              const reapplyStepHeaders = () => {
                setExtendedTitle((prev) => {
                  const next = { ...prev };
                  if (restoredStep6.length && !(prev["6"] && prev["6"].length > 1)) {
                    next["6"] = restoredStep6;
                  }
                  const current8 = prev["8"] || [];
                  const looksUnrestoredOwnHardware =
                    !current8.length ||
                    current8[0] === "I Have My Own Hardware" ||
                    current8[0] === t("I Have My Own Hardware");
                  const missingSameHardwareDetails =
                    restoredStep8.length > current8.length && restoredStep8.length > 1;
                  if (
                    restoredStep8.length &&
                    (looksUnrestoredOwnHardware || missingSameHardwareDetails)
                  ) {
                    next["8"] = restoredStep8;
                  }
                  const current8A = prev["8A"] || [];
                  if (restoredStep8A.length > 1 && current8A.length <= 1) {
                    next["8A"] = restoredStep8A;
                  }
                  if (restoredStep9.length) {
                    next["9"] = restoredStep9;
                  }
                  return next;
                });
              };
              setTimeout(reapplyStepHeaders, 50);
              setTimeout(reapplyStepHeaders, 120);
              setTimeout(reapplyStepHeaders, 1200);
            }
            if (restoredZipcodeRef.current) {
              const reapplyZip = () => {
                const zip = restoredZipcodeRef.current;
                if (!zip) return;
                setZipcode(zip);
                setZipcodeButton(true);
                setHasInstall(true);
              };
              setTimeout(reapplyZip, 300);
              setTimeout(reapplyZip, 900);
              setTimeout(reapplyZip, 1600);
            }
          }, 300);
        });
    });
  }

  function parseSavedZipCode(value) {
    if (value === undefined || value === null || value === "") return "";
    if (Array.isArray(value)) return `${value[0] ?? ""}`.trim();
    return `${value}`.trim();
  }

  // Match live Step8PleatedComponent header strings (drapery [0], sheer/lining tooltip)
  function buildLivePanelTypeHeader(source) {
    const widthNum = parseInt(
      source["WidthCart"] || source["Width"] || source["WindowWidth"] || widthCart || 0,
      10
    );
    const step3Val =
      source["calcMeasurements"] !== undefined ? `${source["calcMeasurements"]}` : "";
    const step31Val = source["hasRod"] !== undefined ? `${source["hasRod"]}` : "";
    const step5Val = source["PanelCoverage"] || "";
    const draperyHead = source["step6CHead"] || "Rod";
    const sheerHead = source["step6BHead"] || "Rod";
    const liningHead = source["step6DHead"] || "Rod";
    const narrow = widthNum < 160;
    const wide = widthNum > 160;

    const liveDrapery = (panelType) => {
      if (panelType === "Single Panel") {
        if (step31Val === "true" && step3Val === "true" && narrow) {
          return t("Drapery Panel Rod Single Panel");
        }
        if (step3Val === "false" && narrow) return t("Drapery Panel Single Panel");
        if (step3Val === "true" && step31Val === "false" && narrow) {
          return t("Drapery Panel Single Panel");
        }
        if (
          step3Val === "false" &&
          step31Val === "" &&
          wide &&
          step5Val === "Decorative" &&
          draperyHead === "Rod"
        ) {
          return t("Drapery Panel Rod Single Panel");
        }
        if (
          step3Val === "false" &&
          step31Val === "" &&
          wide &&
          step5Val === "Decorative" &&
          draperyHead === "Track"
        ) {
          return t("Drapery Panel Track Single Panel");
        }
        if (
          step3Val === "true" &&
          step31Val === "true" &&
          wide &&
          step5Val === "Decorative" &&
          draperyHead === "Rod"
        ) {
          return t("Drapery Panel Rod Single Panel");
        }
        if (
          step3Val === "true" &&
          step31Val === "false" &&
          wide &&
          step5Val === "Decorative" &&
          draperyHead === "Rod"
        ) {
          return t("Drapery Panel Rod Single Panel");
        }
        return t("Drapery Panel Track Single Panel");
      }
      if (panelType === "Single Panel, Right") {
        if (step31Val === "true" && step3Val === "true" && narrow) {
          return t("Drapery Panel Rod Single Panel, Right");
        }
        if (step3Val === "false" && narrow) return t("Drapery Panel Single Panel, Right");
        if (step3Val === "true" && step31Val === "false" && narrow) {
          return t("Drapery Panel Single Panel, Right");
        }
        if (
          step3Val === "false" &&
          step31Val === "" &&
          wide &&
          step5Val === "Decorative" &&
          draperyHead === "Rod"
        ) {
          return t("Drapery Panel Rod Single Panel, Right");
        }
        if (
          step3Val === "false" &&
          step31Val === "" &&
          wide &&
          step5Val === "Decorative" &&
          draperyHead === "Track"
        ) {
          return t("Drapery Panel Track Single Panel, Right");
        }
        if (
          step3Val === "true" &&
          step31Val === "true" &&
          wide &&
          step5Val === "Decorative" &&
          draperyHead === "Rod"
        ) {
          return t("Drapery Panel Rod Single Panel, Right");
        }
        if (
          step3Val === "true" &&
          step31Val === "false" &&
          wide &&
          step5Val === "Decorative" &&
          draperyHead === "Rod"
        ) {
          return t("Drapery Panel Rod Single Panel, Right");
        }
        return t("Drapery Panel Track Single Panel, Right");
      }
      if (panelType === "Single, Free Hanging") return t("Drapery Panel Rod Single, Free Hanging");
      if (panelType === "Pair, Free Hanging") return t("Drapery Panel Rod Pair, Free Hanging");
      if (panelType === "Pair, Split Draw") {
        if (step3Val === "true" && step31Val === "true" && narrow) {
          return t("Drapery Panel Rod Pair, Split Draw");
        }
        if (step3Val === "false" && narrow) return t("Drapery Panel Pair, Split Draw");
        if (draperyHead === "Rod" && wide) return t("Drapery Panel Rod Pair, Split Draw");
        if (step3Val === "true" && step31Val === "false" && narrow) {
          return t("Drapery Panel Pair, Split Draw");
        }
        return t("Drapery Panel Track Pair, Split Draw");
      }
      if (panelType === "Three Panel, Split Draw") return t("Drapery Three Panel, Split Draw");
      return t(panelType);
    };

    const liveSideText = (panelType, head) => {
      if (panelType === "Single, Free Hanging") return t("Rod Single, Free Hanging");
      if (panelType === "Pair, Free Hanging") return t("Rod Pair, Free Hanging");
      if (panelType === "Three Panel, Split Draw") return t("Three Panel, Split Draw");
      if (panelType === "Single Panel") {
        if (step31Val === "true" && step3Val === "true" && narrow && head === "Rod") {
          return t("Rod Single Panel");
        }
        if (step31Val === "true" && step3Val === "true" && narrow && head === "Track") {
          return t("Track Single Panel");
        }
        if (step31Val === "true" && step3Val === "true" && narrow) return t("Rod Single Panel");
        if (step3Val === "false" && narrow) return t("Single Panel");
        if (step3Val === "true" && step31Val === "false" && narrow) return t("Single Panel");
        return t("Track Single Panel");
      }
      if (panelType === "Single Panel, Right") {
        if (step31Val === "true" && step3Val === "true" && narrow && head === "Rod") {
          return t("Rod Single Panel, Right");
        }
        if (step31Val === "true" && step3Val === "true" && narrow && head === "Track") {
          return t("Track Single Panel, Right");
        }
        if (step31Val === "true" && step3Val === "true" && narrow) {
          return t("Rod Single Panel, Right");
        }
        if (step3Val === "false" && narrow) return t("Single Panel, Right");
        if (step3Val === "true" && step31Val === "false" && narrow) return t("Single Panel, Right");
        return t("Track Single Panel, Right");
      }
      if (panelType === "Pair, Split Draw") {
        if (step31Val === "true" && step3Val === "true" && narrow && head === "Rod") {
          return t("Rod Pair, Split Draw");
        }
        if (step31Val === "true" && step3Val === "true" && narrow && head === "Track") {
          return t("Track Pair, Split Draw");
        }
        if (step3Val === "true" && step31Val === "true" && narrow) return t("Rod Pair, Split Draw");
        if (step3Val === "false" && narrow) return t("Pair, Split Draw");
        if (step3Val === "true" && step31Val === "true" && wide && head === "Track") {
          return t("Track Pair, Split Draw");
        }
        if (head === "Rod" && wide) return t("Rod Pair, Split Draw");
        if (step3Val === "true" && step31Val === "false" && narrow) return t("Pair, Split Draw");
        return t("Track Pair, Split Draw");
      }
      return t(panelType);
    };

    return {
      drapery: source["PanelTypeA"] ? liveDrapery(source["PanelTypeA"]) : "",
      sheer: source["PanelTypeB"] ? liveSideText(source["PanelTypeB"], sheerHead) : "",
      lining: source["PanelTypeC"] ? liveSideText(source["PanelTypeC"], liningHead) : "",
    };
  }

  function filterSelected(filter, filterId, isDelete, step = "1") {
    const isStep2 = step === "2";
    const colors = isStep2 ? filterColors2 : filterColors;
    const patterns = isStep2 ? filterPatterns2 : filterPatterns;
    const types = isStep2 ? filterTypes2 : filterTypes;
    const prices = isStep2 ? filterPrices2 : filterPrices;
    const setColors = isStep2 ? setFilterColors2 : setFilterColors;
    const setPatterns = isStep2 ? setFilterPatterns2 : setFilterPatterns;
    const setTypes = isStep2 ? setFilterTypes2 : setFilterTypes;
    const setPrices = isStep2 ? setFilterPrices2 : setFilterPrices;

    if (filter === "colors") {
      if (isDelete) {
        if (!colors.includes(filterId)) setColors([...colors, filterId]);
      } else {
        setColors(colors.filter((id1) => id1 !== filterId));
      }
    } else if (filter === "patterns") {
      if (isDelete) {
        if (!patterns.includes(filterId)) setPatterns([...patterns, filterId]);
      } else {
        setPatterns(patterns.filter((id1) => id1 !== filterId));
      }
    } else if (filter === "types") {
      if (isDelete) {
        if (!types.includes(filterId)) setTypes([...types, filterId]);
      } else {
        setTypes(types.filter((id1) => id1 !== filterId));
      }
    } else if (filter === "prices") {
      if (isDelete) {
        if (!prices.includes(filterId)) setPrices([...prices, filterId]);
      } else {
        setPrices(prices.filter((id1) => id1 !== filterId));
      }
    }
  }
  const MotorPosition = {
    en: [{ value: "Left", label: "Left" }, { value: "Right", label: "Right" }],
    fa: [{ value: "Left", label: "چپ" }, { value: "Right", label: "راست" }],
  };

  function parseSavedMotorChannels(source) {
    let saved = source["MotorChannelsB"] || source["MotorChannelsA"] || source["MotorChannelsC"];
    if (!saved) return [];
    if (!Array.isArray(saved)) saved = [saved];
    if (Array.isArray(saved[0])) saved = saved[0];
    return saved
      .map((item) => {
        const val = item && typeof item === "object" ? item.value : item;
        if (val === undefined || val === null || val === "") return null;
        return (
          (motorChannels[pageLanguage] || []).find(
            (opt) => opt.value === val || `${opt.value}` === `${val}`
          ) || { value: val, label: `${val}` }
        );
      })
      .filter(Boolean);
  }

  function resolveMotorPositionOption(source) {
    let motorVal = source["MotorPositionB"] || source["MotorPositionA"];
    if (Array.isArray(motorVal)) motorVal = motorVal[0];
    if (motorVal && typeof motorVal === "object") motorVal = motorVal.value;
    if (!motorVal) return null;
    return (
      (MotorPosition[pageLanguage] || []).find(
        (opt) => opt.value === motorVal || opt.label === motorVal
      ) || { value: motorVal, label: t(motorVal) }
    );
  }

  function buildElectricTrackHeaderItems(source) {
    const items = {};
    const motorPos = resolveMotorPositionOption(source);
    if (motorPos) {
      items[2] = (
        <li key="2" className="step_title_extended_list_item">
          <span className="step_title_extended_list_item_title">{t("Motor Position")}</span>
          <span className="step_title_extended_list_item_text">
            {pageLanguage === "fa" ? motorPos.label : motorPos.value}
          </span>
        </li>
      );
    }
    const remoteVal = source["RemoteNameB"] || source["RemoteNameA"];
    if (remoteVal) {
      items[3] = (
        <li key="3" className="step_title_extended_list_item">
          <span className="step_title_extended_list_item_title">{t("Remote_name")}</span>
          <span className="step_title_extended_list_item_text">{remoteVal}</span>
        </li>
      );
    }
    const channelOpts = parseSavedMotorChannels(source);
    if (channelOpts.length) {
      items[4] = (
        <li key="4" className="step_title_extended_list_item">
          <span className="step_title_extended_list_item_title">{t("Channel(s)")}</span>
          <span className="step_title_extended_list_item_text">
            {channelOpts
              .map((item) => (pageLanguage === "fa" ? item.label : item.value))
              .join(", ")}
          </span>
        </li>
      );
    }
    return items;
  }

  function applyStep9BElectricRestoreFromCart(source, tempExtended) {
    if (!source) return;
    const unwrap = (val) => (Array.isArray(val) ? val[0] : val);
    setTrackType8B(1);
    if (`${step8BRilType}` !== "2208") {
      setStep8BRilType("2208");
    }
    const hasPower =
      source["hasPowerB"] === true ||
      source["hasPowerB"] === "true" ||
      source["MotorPositionB"] ||
      source["RemoteNameB"] ||
      source["MotorChannelsB"];
    if (hasPower && step8B5 !== "true") {
      setStep8B5("true");
    }
    const motorPos = resolveMotorPositionOption(source);
    if (motorPos && selectedMotorPositionB[0]?.value !== motorPos.value) {
      setSelectedMotorPositionB([motorPos]);
    }
    const remoteVal = unwrap(source["RemoteNameB"] || source["RemoteNameA"]);
    if (remoteVal && remoteNameB !== remoteVal) {
      setRemoteNameB(remoteVal);
      setSelectedRemoteName([{ value: remoteVal, label: remoteVal }]);
    }
    const channelOpts = parseSavedMotorChannels(source);
    if (channelOpts.length) {
      const currentChannels = (selectedMotorChannelsB || []).map((item) => item.value).join(",");
      const nextChannels = channelOpts.map((item) => item.value).join(",");
      if (currentChannels !== nextChannels) {
        setSelectedMotorChannelsB(channelOpts);
      }
    }
    const headerItems = buildElectricTrackHeaderItems(source);
    if (tempExtended && tempExtended["8B"]) {
      if (headerItems[2]) tempExtended["8B"][2] = headerItems[2];
      if (headerItems[3]) tempExtended["8B"][3] = headerItems[3];
      if (headerItems[4]) tempExtended["8B"][4] = headerItems[4];
    } else if (headerItems[2] || headerItems[3] || headerItems[4]) {
      setExtendedTitle((prev) => {
        const next = { ...prev };
        const list = [...(next["8B"] || [])];
        if (headerItems[2]) list[2] = headerItems[2];
        if (headerItems[3]) list[3] = headerItems[3];
        if (headerItems[4]) list[4] = headerItems[4];
        next["8B"] = list;
        return next;
      });
    }
  }

  function applyStep9CElectricRestoreFromCart(source, tempExtended) {
    if (!source) return;
    const unwrap = (val) => (Array.isArray(val) ? val[0] : val);
    setTrackType8C(1);
    if (`${step8CTrack}` !== "2208") {
      setStep8CTrack("2208");
    }
    const hasPower =
      source["hasPowerC"] === true ||
      source["hasPowerC"] === "true" ||
      source["MotorPositionC"] ||
      source["RemoteNameC"] ||
      source["MotorChannelsC"];
    if (hasPower && step8C5 !== "true") {
      setStep8C5("true");
    }
    const motorPos = resolveMotorPositionOption({ MotorPositionB: source["MotorPositionC"] });
    if (motorPos && selectedMotorPositionC[0]?.value !== motorPos.value) {
      setSelectedMotorPositionC([motorPos]);
    }
    const remoteVal = unwrap(source["RemoteNameC"]);
    if (remoteVal && remoteNameC !== remoteVal) {
      setRemoteNameC(remoteVal);
      setSelectedRemoteName([{ value: remoteVal, label: remoteVal }]);
    }
    const channelOpts = parseSavedMotorChannels({ MotorChannelsB: source["MotorChannelsC"] });
    if (channelOpts.length) {
      const currentChannels = (selectedMotorChannelsC || []).map((item) => item.value).join(",");
      const nextChannels = channelOpts.map((item) => item.value).join(",");
      if (currentChannels !== nextChannels) {
        setSelectedMotorChannelsC(channelOpts);
      }
    }
    const headerItems = buildElectricTrackHeaderItems({
      MotorPositionB: source["MotorPositionC"],
      RemoteNameB: source["RemoteNameC"],
      MotorChannelsB: source["MotorChannelsC"],
    });
    if (tempExtended && tempExtended["8C"]) {
      if (headerItems[2]) tempExtended["8C"][2] = headerItems[2];
      if (headerItems[3]) tempExtended["8C"][3] = headerItems[3];
      if (headerItems[4]) tempExtended["8C"][4] = headerItems[4];
    } else if (headerItems[2] || headerItems[3] || headerItems[4]) {
      setExtendedTitle((prev) => {
        const next = { ...prev };
        const list = [...(next["8C"] || [])];
        if (headerItems[2]) list[2] = headerItems[2];
        if (headerItems[3]) list[3] = headerItems[3];
        if (headerItems[4]) list[4] = headerItems[4];
        next["8C"] = list;
        return next;
      });
    }
  }

  function applyElectricTrackRestoreFromCart(source, tempExtended) {
    if (!source) return;
    setTrackType8B(1);
    if (
      source["hasPowerB"] === true ||
      source["hasPowerB"] === "true" ||
      source["MotorPositionB"] ||
      source["RemoteNameB"] ||
      source["MotorChannelsB"]
    ) {
      setStep8B6("true");
    }
    const motorPos = resolveMotorPositionOption(source);
    if (motorPos) {
      setSelectedMotorPositionB([motorPos]);
    }
    const remoteVal = source["RemoteNameB"] || source["RemoteNameA"];
    if (remoteVal) {
      setRemoteNameB(remoteVal);
      setSelectedRemoteName([{ value: remoteVal, label: remoteVal }]);
    }
    const channelOpts = parseSavedMotorChannels(source);
    if (channelOpts.length) {
      setSelectedMotorChannelsB(channelOpts);
    }
    const headerItems = buildElectricTrackHeaderItems(source);
    if (tempExtended && tempExtended["8"]) {
      if (headerItems[2]) tempExtended["8"][2] = headerItems[2];
      if (headerItems[3]) tempExtended["8"][3] = headerItems[3];
      if (headerItems[4]) tempExtended["8"][4] = headerItems[4];
    } else if (headerItems[2] || headerItems[3] || headerItems[4]) {
      setExtendedTitle((prev) => {
        const next = { ...prev };
        const list = [...(next["8"] || [])];
        if (headerItems[2]) list[2] = headerItems[2];
        if (headerItems[3]) list[3] = headerItems[3];
        if (headerItems[4]) list[4] = headerItems[4];
        next["8"] = list;
        return next;
      });
    }
  }

  function findRailByIdAny(id) {
    if (id === undefined || id === null || id === "") return {};
    const match = (arr) => (arr || []).find((obj) => `${obj["RailId"]}` === `${id}`) || {};
    const from2 = match(rails2);
    if (Object.keys(from2).length) return from2;
    const fromRails = match(rails);
    if (Object.keys(fromRails).length) return fromRails;
    return match(rails3);
  }

  function findTrackTypeBySavedName(name) {
    if (!name) return {};
    const pool = []
      .concat(...Object.values(tracks2 || {}))
      .concat(...Object.values(tracks || {}))
      .concat(...Object.values(tracks3 || {}));
    const unique = pool.filter(
      (item, index, self) => index === self.findIndex((t) => t.RailTypeId === item.RailTypeId)
    );
    return (
      unique.find(
        (obj) =>
          obj["DesignENName"] === name ||
          obj["DesignName"] === name ||
          convertToPersian(obj["DesignName"] || "") === name
      ) || {}
    );
  }

  function parseStep9AControlSide(value) {
    if (value === undefined || value === null || value === "") return "";
    const raw = Array.isArray(value) ? value[0] : value;
    const text = `${raw}`.toLowerCase();
    if (text.includes("left") || raw === "چپ") return "Left";
    if (text.includes("right") || raw === "راست") return "Right";
    return "";
  }

  function inferStep9ATrackTypeId(source, railObject) {
    if (railObject && railObject["RailTypeId"]) return `${railObject["RailTypeId"]}`;
    const hint = `${source["RailDesignEnA"] ||
      source["RailDesignFaA"] ||
      source["RailDesignEnB"] ||
      source["RailDesignFaB"] ||
      source["RailDesignEnC"] ||
      source["RailDesignFaC"] ||
      ""}`;
    const lower = hint.toLowerCase();
    if (
      source["MotorPositionA"] ||
      source["MotorPositionB"] ||
      source["MotorPositionC"] ||
      source["RemoteNameA"] ||
      source["RemoteNameB"] ||
      source["RemoteNameC"] ||
      source["hasPowerA"] ||
      source["hasPowerB"] ||
      source["hasPowerC"] ||
      source["MotorChannelsA"] ||
      source["MotorChannelsB"] ||
      source["MotorChannelsC"] ||
      hint.includes("برقی") ||
      lower.includes("electric")
    ) {
      return "2208";
    }
    const controlRaw =
      source["ControlPositionB"] || source["ControlPositionA"] || source["ControlPositionC"];
    if (
      parseStep9AControlSide(controlRaw) ||
      hint.includes("سوپر") ||
      lower.includes("super") ||
      lower.includes("cord")
    ) {
      return "2207";
    }
    return "2201";
  }

  function resolveStep9ATrackColorId(source, railObject) {
    const savedId = source["RailIdA"] || source["RailIdB"];
    if (savedId) return `${savedId}`;
    const hint =
      source["RailColorEnA"] ||
      source["RailColorFaA"] ||
      source["RailColorEnB"] ||
      source["RailColorFaB"];
    if (!hint || !railObject || !railObject["DesignCode"]) return "";
    const colors =
      (tracks2 && tracks2[railObject["DesignCode"]]) ||
      (tracks && tracks[railObject["DesignCode"]]) ||
      [];
    const found = colors.find(
      (obj) =>
        obj["ColorEnName"] === hint ||
        obj["ColorName"] === hint ||
        convertToPersian(obj["ColorName"] || "") === hint
    );
    return found ? `${found["RailId"]}` : "";
  }

  function applyStep9ATrackRestoreFromCart(source, tempExtended) {
    if (!source) return;
    const unwrap = (val) => (Array.isArray(val) ? val[0] : val);
    const savedDesignId = source["RailDesignB"] || source["RailDesignA"];
    let railObject = findRailByIdAny(savedDesignId);
    if (!Object.keys(railObject).length) {
      railObject = findTrackTypeBySavedName(
        source["RailDesignEnA"] ||
          source["RailDesignFaA"] ||
          source["RailDesignEnB"] ||
          source["RailDesignFaB"]
      );
    }
    const designId = railObject["RailId"] || savedDesignId;
    if (designId && `${stepTrackCollections9A}` !== `${designId}`) {
      setStepTrackCollections9A(`${designId}`);
    }
    const typeId = inferStep9ATrackTypeId(source, railObject);
    if (typeId && `${stepTCollections9A}` !== `${typeId}`) {
      setStepTCollections9A(typeId);
    }
    if (railObject["DesignENName"] || railObject["DesignName"]) {
      setStepTrackCollectionsName9A(
        pageLanguage === "fa"
          ? convertToPersian(railObject["DesignName"])
          : railObject["DesignENName"]
      );
    }

    const batonValue = unwrap(source["BatonOptionA"]) || unwrap(source["BatonOptionB"]);
    const controlSide = parseStep9AControlSide(
      source["ControlPositionB"] ||
        source["ControlPositionA"] ||
        source["ControlPositionC"] ||
        batonValue
    );
    if (
      typeId === "2201" &&
      batonValue &&
      !parseStep9AControlSide(batonValue) &&
      stepControl9A !== batonValue
    ) {
      setStepControl9A(batonValue);
      setNameBattonEnDraperyTrack9a(batonValue);
      setNameBattonEnDraperyTrack(batonValue);
    }
    if (typeId === "2207" && controlSide && step9APosition !== controlSide) {
      setStep9APosition(controlSide);
      setNameBattonEnDraperyTrack9a(`${controlSide} Control`);
    }

    if (typeId === "2208") {
      setTrackType8B(1);
      const hasPower =
        source["hasPowerB"] === true ||
        source["hasPowerB"] === "true" ||
        source["hasPowerA"] === true ||
        source["hasPowerA"] === "true" ||
        source["MotorPositionB"] ||
        source["MotorPositionA"] ||
        source["RemoteNameA"] ||
        source["RemoteNameB"] ||
        source["MotorChannelsB"] ||
        source["MotorChannelsA"];
      if (hasPower && step8B6 !== "true") {
        setStep8B6("true");
      }
      const motorPos = resolveMotorPositionOption(source);
      if (motorPos && selectedMotorPositionA[0]?.value !== motorPos.value) {
        setSelectedMotorPositionA([motorPos]);
      }
      const remoteVal = source["RemoteNameA"] || source["RemoteNameB"];
      if (remoteVal && remoteNameA !== remoteVal) {
        setRemoteNameA(remoteVal);
        setSelectedRemoteNameA([{ value: remoteVal, label: remoteVal }]);
      }
      const channelOpts = parseSavedMotorChannels(source);
      if (channelOpts.length) {
        const currentChannels = (selectedMotorChannelsA || []).map((item) => item.value).join(",");
        const nextChannels = channelOpts.map((item) => item.value).join(",");
        if (currentChannels !== nextChannels) {
          setSelectedMotorChannelsA(channelOpts);
        }
      }
    }

    const colorId = resolveStep9ATrackColorId(source, railObject);
    if (colorId && `${stepHardware9A}` !== `${colorId}`) {
      setStepHardware9A(colorId);
    }

    const colorObj = colorId ? findRailByIdAny(colorId) : {};
    const colorLabel = colorObj["ColorName"]
      ? pageLanguage === "fa"
        ? convertToPersian(colorObj["ColorName"])
        : colorObj["ColorEnName"]
      : source["RailColorEnA"] || source["RailColorFaA"];
    if (colorLabel) {
      setStepHardwareName9A(colorLabel);
      if (colorObj["ColorEnName"]) {
        setNameColorEnDraperyTrack(colorObj["ColorEnName"]);
        setNameColorFaDraperyTrack(colorObj["ColorName"]);
        setNameColorEnDraperyTrack9a(colorObj["ColorEnName"]);
        setNameColorFaDraperyTrack9a(colorObj["ColorName"]);
      }
    }

    const writeHeader = (list) => {
      const next = [...(list || [])];
      const designLabel = railObject["DesignENName"]
        ? pageLanguage === "fa"
          ? convertToPersian(railObject["DesignName"])
          : railObject["DesignENName"]
        : source["RailDesignEnA"] || source["RailDesignFaA"];
      if (designLabel) {
        next[1] = (
          <li key="1" className="step_title_extended_list_item">
            <span className="step_title_extended_list_item_title">{t("Design")}</span>
            <span className="step_title_extended_list_item_text">{designLabel}</span>
          </li>
        );
      }
      if (typeId !== "2208" && colorLabel) {
        next[2] = (
          <li key="2" className="step_title_extended_list_item">
            <span className="step_title_extended_list_item_title">{t("Finish")}</span>
            <span className="step_title_extended_list_item_text">{colorLabel}</span>
          </li>
        );
      }
      if (typeId === "2201" && batonValue && !parseStep9AControlSide(batonValue)) {
        next[3] = (
          <li key="3" className="step_title_extended_list_item">
            <span className="step_title_extended_list_item_title">{t("Baton")}</span>
            <span className="step_title_extended_list_item_text">{t(batonValue)}</span>
          </li>
        );
      }
      if (typeId === "2207" && controlSide) {
        next[3] = (
          <li key="3" className="step_title_extended_list_item">
            <span className="step_title_extended_list_item_title">{t("Control Position")}</span>
            <span className="step_title_extended_list_item_text">{t(controlSide)}</span>
          </li>
        );
      }
      if (typeId === "2208") {
        const electricHeader = buildElectricTrackHeaderItems(source);
        if (electricHeader[2]) next[2] = electricHeader[2];
        if (electricHeader[3]) next[3] = electricHeader[3];
        if (electricHeader[4]) next[4] = electricHeader[4];
      }
      return next;
    };

    if (tempExtended && tempExtended["8A"]) {
      tempExtended["8A"] = writeHeader(tempExtended["8A"]);
    } else {
      setExtendedTitle((prev) => {
        const next = { ...prev };
        next["8A"] = writeHeader(next["8A"]);
        return next;
      });
    }

    const colorSource =
      (tracks2 && railObject["DesignCode"] && tracks2[railObject["DesignCode"]]) ||
      (tracks && railObject["DesignCode"] && tracks[railObject["DesignCode"]]);
    if (Object.keys(railObject).length > 0 && colorSource && typeId !== "2208") {
      showRodsColor(railObject, typeId === "2207" ? "8H3" : "8H1");
    }
  }
  const draperiesSelect = {
    en: [
      { num: "1", value: "I Have 25mm Rod", label: "25mm Rod" },
      { num: "2", value: "I Have 28mm Rod", label: "28mm Rod" },
      { num: "3", value: "I Have Standard Track", label: "Standard Track", disabled: true },
      {
        num: "4",
        value: "I Have Track With Cord Draw",
        label: "Track With Cord Draw",
        disabled: true,
      },
      { num: "5", value: "I Have Motorized Track", label: "Motorized Track", disabled: true },
      { num: "6", value: "I Have Others", label: "Others" },
    ],
    fa: [
      { num: "1", value: "I Have 25mm Rod", label: "میله پردهِ ۲۵ میلیمتری" },
      { num: "2", value: "I Have 28mm Rod", label: "میله پردهِ ۲۸ میلیمتری" },
      { num: "3", value: "I Have Standard Track", label: "ریل استاندارد", disabled: true },
      { num: "4", value: "I Have Track With Cord Draw", label: "ریل اتومات", disabled: true },
      { num: "5", value: "I Have Motorized Track", label: "ریل برقی", disabled: true },
      { num: "6", value: "I Have Others", label: "سایر" },
    ],
  };

  const draperiesSelect2 = {
    en: [
      { num: "1", value: "I Have 25mm Rod", label: "25mm Rod", disabled: true },
      { num: "2", value: "I Have 28mm Rod", label: "28mm Rod", disabled: true },
      { num: "3", value: "I Have Standard Track", label: "Standard Track" },
      { num: "4", value: "I Have Track With Cord Draw", label: "Track With Cord Draw" },
      { num: "5", value: "I Have Motorized Track", label: "Motorized Track" },
      { num: "6", value: "I Have Others", label: "Others" },
    ],
    fa: [
      { num: "1", value: "I Have 25mm Rod", label: "میله پردهِ ۲۵ میلیمتری", disabled: true },
      { num: "2", value: "I Have 28mm Rod", label: "میله پردهِ ۲۸ میلیمتری", disabled: true },
      { num: "3", value: "I Have Standard Track", label: "ریل استاندارد" },
      { num: "4", value: "I Have Track With Cord Draw", label: "ریل اتومات" },
      { num: "5", value: "I Have Motorized Track", label: "ریل برقی" },
      { num: "6", value: "I Have Others", label: "سایر" },
    ],
  };

  const draperiesSelect3 = {
    en: [
      { num: "1", value: "I Have 25mm Rod", label: "25mm Rod" },
      { num: "2", value: "I Have 28mm Rod", label: "28mm Rod" },
      { num: "3", value: "I Have Standard Track", label: "Standard Track" },
      { num: "4", value: "I Have Track With Cord Draw", label: "Track With Cord Draw" },
      { num: "5", value: "I Have Motorized Track", label: "Motorized Track" },
      { num: "6", value: "I Have Others", label: "Others" },
    ],
    fa: [
      { num: "1", value: "I Have 25mm Rod", label: "میله پردهِ ۲۵ میلیمتری" },
      { num: "2", value: "I Have 28mm Rod", label: "میله پردهِ ۲۸ میلیمتری" },
      { num: "3", value: "I Have Standard Track", label: "ریل استاندارد" },
      { num: "4", value: "I Have Track With Cord Draw", label: "ریل اتومات" },
      { num: "5", value: "I Have Motorized Track", label: "ریل برقی" },
      { num: "6", value: "I Have Others", label: "سایر" },
    ],
  };

  const sheersSelect = {
    en: [
      { num: "1", value: "I Have 25mm Rod", label: "25mm Rod" },
      { num: "2", value: "I Have 28mm Rod", label: "28mm Rod" },
      { num: "3", value: "I Have Standard Track", label: "Standard Track", disabled: true },
      {
        num: "4",
        value: "I Have Track With Cord Draw",
        label: "Track With Cord Draw",
        disabled: true,
      },
      { num: "5", value: "I Have Motorized Track", label: "Motorized Track", disabled: true },
      { num: "6", value: "I Have Others", label: "Others" },
    ],
    fa: [
      { num: "1", value: "I Have 25mm Rod", label: "میله پردهِ ۲۵ میلیمتری" },
      { num: "2", value: "I Have 28mm Rod", label: "میله پردهِ ۲۸ میلیمتری" },
      { num: "3", value: "I Have Standard Track", label: "ریل استاندارد", disabled: true },
      { num: "4", value: "I Have Track With Cord Draw", label: "ریل اتومات", disabled: true },
      { num: "5", value: "I Have Motorized Track", label: "ریل برقی", disabled: true },
      { num: "6", value: "I Have Others", label: "سایر" },
    ],
  };

  const sheersSelect2 = {
    en: [
      { num: "1", value: "I Have 25mm Rod", label: "25mm Rod", disabled: true },
      { num: "2", value: "I Have 28mm Rod", label: "28mm Rod", disabled: true },
      { num: "3", value: "I Have Standard Track", label: "Standard Track" },
      { num: "4", value: "I Have Track With Cord Draw", label: "Track With Cord Draw" },
      { num: "5", value: "I Have Motorized Track", label: "Motorized Track" },
      { num: "6", value: "I Have Others", label: "Others" },
    ],
    fa: [
      { num: "1", value: "I Have 25mm Rod", label: "میله پردهِ ۲۵ میلیمتری", disabled: true },
      { num: "2", value: "I Have 28mm Rod", label: "میله پردهِ ۲۸ میلیمتری", disabled: true },
      { num: "3", value: "I Have Standard Track", label: "ریل استاندارد" },
      { num: "4", value: "I Have Track With Cord Draw", label: "ریل اتومات" },
      { num: "5", value: "I Have Motorized Track", label: "ریل برقی" },
      { num: "6", value: "I Have Others", label: "سایر" },
    ],
  };
  const sheersSelect3 = {
    en: [
      { num: "1", value: "I Have 25mm Rod", label: "25mm Rod" },
      { num: "2", value: "I Have 28mm Rod", label: "28mm Rod" },
      { num: "3", value: "I Have Standard Track", label: "Standard Track" },
      { num: "4", value: "I Have Track With Cord Draw", label: "Track With Cord Draw" },
      { num: "5", value: "I Have Motorized Track", label: "Motorized Track" },
      { num: "6", value: "I Have Others", label: "Others" },
    ],
    fa: [
      { num: "1", value: "I Have 25mm Rod", label: "میله پردهِ ۲۵ میلیمتری" },
      { num: "2", value: "I Have 28mm Rod", label: "میله پردهِ ۲۸ میلیمتری" },
      { num: "3", value: "I Have Standard Track", label: "ریل استاندارد" },
      { num: "4", value: "I Have Track With Cord Draw", label: "ریل اتومات" },
      { num: "5", value: "I Have Motorized Track", label: "ریل برقی" },
      { num: "6", value: "I Have Others", label: "سایر" },
    ],
  };

  const privacyLayerSelect = {
    en: [
      { num: "1", value: "I Have 25mm Rod", label: "25mm Rod" },
      { num: "2", value: "I Have 28mm Rod", label: "28mm Rod" },
      { num: "3", value: "I Have Standard Track", label: "Standard Track", disabled: true },
      {
        num: "4",
        value: "I Have Track With Cord Draw",
        label: "Track With Cord Draw",
        disabled: true,
      },
      { num: "5", value: "I Have Motorized Track", label: "Motorized Track", disabled: true },
      { num: "6", value: "I Have Others", label: "Others" },
    ],
    fa: [
      { num: "1", value: "I Have 25mm Rod", label: "میله پردهِ ۲۵ میلیمتری" },
      { num: "2", value: "I Have 28mm Rod", label: "میله پردهِ ۲۸ میلیمتری" },
      { num: "3", value: "I Have Standard Track", label: "ریل استاندارد", disabled: true },
      { num: "4", value: "I Have Track With Cord Draw", label: "ریل اتومات", disabled: true },
      { num: "5", value: "I Have Motorized Track", label: "ریل برقی", disabled: true },
      { num: "6", value: "I Have Others", label: "سایر" },
    ],
  };

  const privacyLayerSelect2 = {
    en: [
      { num: "1", value: "I Have 25mm Rod", label: "25mm Rod", disabled: true },
      { num: "2", value: "I Have 28mm Rod", label: "28mm Rod", disabled: true },
      { num: "3", value: "I Have Standard Track", label: "Standard Track" },
      { num: "4", value: "I Have Track With Cord Draw", label: "Track With Cord Draw" },
      { num: "5", value: "I Have Motorized Track", label: "Motorized Track" },
      { num: "6", value: "I Have Others", label: "Others" },
    ],
    fa: [
      { num: "1", value: "I Have 25mm Rod", label: "میله پردهِ ۲۵ میلیمتری", disabled: true },
      { num: "2", value: "I Have 28mm Rod", label: "میله پردهِ ۲۸ میلیمتری", disabled: true },
      { num: "3", value: "I Have Standard Track", label: "ریل استاندارد" },
      { num: "4", value: "I Have Track With Cord Draw", label: "ریل اتومات" },
      { num: "5", value: "I Have Motorized Track", label: "ریل برقی" },
      { num: "6", value: "I Have Others", label: "سایر" },
    ],
  };
  const privacyLayerSelect3 = {
    en: [
      { num: "1", value: "I Have 25mm Rod", label: "25mm Rod" },
      { num: "2", value: "I Have 28mm Rod", label: "28mm Rod" },
      { num: "3", value: "I Have Standard Track", label: "Standard Track" },
      { num: "4", value: "I Have Track With Cord Draw", label: "Track With Cord Draw" },
      { num: "5", value: "I Have Motorized Track", label: "Motorized Track" },
      { num: "6", value: "I Have Others", label: "Others" },
    ],
    fa: [
      { num: "1", value: "I Have 25mm Rod", label: "میله پردهِ ۲۵ میلیمتری" },
      { num: "2", value: "I Have 28mm Rod", label: "میله پردهِ ۲۸ میلیمتری" },
      { num: "3", value: "I Have Standard Track", label: "ریل استاندارد" },
      { num: "4", value: "I Have Track With Cord Draw", label: "ریل اتومات" },
      { num: "5", value: "I Have Motorized Track", label: "ریل برقی" },
      { num: "6", value: "I Have Others", label: "سایر" },
    ],
  };

  const topScroll = () => {
    if (isLoggedIn) {
      setTimeout(() => {
        if (modalTopRef.current) {
          modalTopRef.current.scrollIntoView({ behavior: "smooth", block: "start" });
        }
      }, 12000);
    } else {
      setTimeout(() => {
        if (modalTopRef.current) {
          modalTopRef.current.scrollIntoView({ behavior: "smooth", block: "start" });
        }
      }, 2000);
    }
  };

  useEffect(() => {
    if (!pageLoad && !rodsLoad && !rodsLoad2 && !mesLoad) {
      if (step6 !== "") {
        // Do not wipe restored panel layout header after refresh
        const hasRestoredPanels =
          cartValues["PanelTypeA"] !== undefined ||
          cartValues["PanelTypeB"] !== undefined ||
          cartValues["PanelTypeC"] !== undefined;
        if (!hasRestoredPanels) {
          let tempExtended = extendedTitle;
          if (tempExtended["6"] && tempExtended["6"].length) {
            tempExtended["6"].splice(1, 3);
          }
          setExtendedTitle(tempExtended);
          setStep61("");
          setStep6A("");
          setStep6B("");
          setStep6C("");
          if (step6 === "Same Style For All Curtains") {
            setCart("", "", "PanelTypeA,PanelTypeB,PanelTypeC");
          } else {
            setCart("", "", "PanelTypeA,PanelTypeB,PanelTypeC");
          }
        }
      }
      if (widthCart && parseInt(widthCart) > 0) {
        getRails(parseInt(widthCart));

        if (sheersModelId !== "") getSheersRails(sheersModelId, parseInt(widthCart));
        if (sheersModelId2 !== "") getSheersRails(sheersModelId2, parseInt(widthCart), true);
      }
    }
    if (mesLoad) {
      setMesLoad(false);
    }
  }, [widthCart]);

  useEffect(() => {
    if (fabricSelected.selectedFabricId && fabricSelected.selectedFabricId !== 0 && !pageLoad) {
      setFabricLoading(true);
      fabricClicked(fabricSelected.selectedPhoto, fabricSelected.selectedHasTrim);
      let tempLabels = JSON.parse(JSON.stringify(stepSelectedLabel));
      tempLabels["1"] =
        location.pathname
          .split("")
          .slice(1, 3)
          .join("") === "fa"
          ? fabricSelected.selectedTextFa + " / " + fabricSelected.selectedColorFa
          : fabricSelected.selectedTextEn + " / " + fabricSelected.selectedColorEn;
      let tempValue = JSON.parse(JSON.stringify(stepSelectedValue));
      tempValue["1"] = fabricSelected.selectedFabricId;
      setStepSelectedLabel(tempLabels);
      setStepSelectedValue(tempValue);
      setCart(
        "FabricId",
        `${fabricSelected.selectedFabricId}`,
        "",
        "FabricDesignFa,FabricDesignEn,FabricColorEn,FabricColorFa,PhotoUrl",
        [
          fabricSelected.selectedTextFa,
          fabricSelected.selectedTextEn,
          fabricSelected.selectedColorEn,
          fabricSelected.selectedColorFa,
          fabricSelected.selectedPhoto,
        ]
      );
      setStep1(fabricSelected.selectedFabricId.toString());
      let tempExtended = extendedTitle;
      tempExtended["1"][0] = tempLabels["1"];
      let temp = JSON.parse(JSON.stringify(requiredStep));
      if (tempLabels["1"] !== "" && requiredStep["1"]) {
        temp["1"] = false;
      }

      setRequiredStep(temp);
      if (step1Check !== `${fabricSelected.selectedDesignCode}`) {
        setStep1Check("");
        setStep1Border("");
        setStep1BorderRadio("");
        setStep1Trim("");
        tempExtended["1"].splice(1, 1);
        setDeps("", "1");
      } else {
        setDeps("", "1");
      }
      setExtendedTitle(tempExtended);
    }
  }, [fabricSelected]);

  useEffect(() => {
    if (fabricSelected2.selectedFabricId && fabricSelected2.selectedFabricId !== 0 && !pageLoad) {
      setFabricLoading(true);
      fabricClicked(fabricSelected2.selectedPhoto, fabricSelected2.selectedHasTrim);
      let tempLabels = JSON.parse(JSON.stringify(stepSelectedLabel));
      tempLabels["2"] =
        location.pathname
          .split("")
          .slice(1, 3)
          .join("") === "fa"
          ? fabricSelected2.selectedTextFa + " / " + fabricSelected2.selectedColorFa
          : fabricSelected2.selectedTextEn + " / " + fabricSelected2.selectedColorEn;
      let tempValue = JSON.parse(JSON.stringify(stepSelectedValue));
      tempValue["2"] = fabricSelected2.selectedFabricId;
      setStepSelectedLabel(tempLabels);
      setStepSelectedValue(tempValue);
      setCart(
        "FabricId2",
        `${fabricSelected2.selectedFabricId}`,
        fabricSelected2.selectedLeadRequired ? "" : "leadId,hasLead",
        "FabricDesignFa2,FabricDesignEn2,FabricColorEn2,FabricColorFa2,PhotoUrl2" +
          (fabricSelected2.selectedLeadRequired ? ",leadId,hasLead" : ""),
        [
          fabricSelected2.selectedTextFa,
          fabricSelected2.selectedTextEn,
          fabricSelected2.selectedColorEn,
          fabricSelected2.selectedColorFa,
          fabricSelected2.selectedPhoto,
          fabricSelected2.selectedFabricId.toString(),
          "Included",
        ]
      );
      setStep2(fabricSelected2.selectedFabricId.toString());
      let tempExtended = extendedTitle;
      tempExtended["2"] = [tempLabels["2"]];
      let temp = JSON.parse(JSON.stringify(requiredStep));
      if (tempLabels["2"] !== "" && requiredStep["2"]) {
        temp["2"] = false;
      }

      setRequiredStep(temp);
      if (step2Check !== `${fabricSelected2.selectedDesignCode}`) {
        setStep2Check("");
        setStep2Check2("");
        setStep2Border("");
        setStep2BorderRadio("");
        setStep2Trim("");
        tempExtended["2"].splice(1, 1);
        setDeps("", "2");
      } else {
        setDeps("", "2");
      }
      if (fabricSelected2.selectedLeadRequired) {
        tempExtended["2"][1] = (
          <li key="1" className="step_title_extended_list_item">
            <span className="step_title_extended_list_item_title">{t("Lead Weight")}</span>
            <span className="step_title_extended_list_item_text">
              {location.pathname
                .split("")
                .slice(1, 3)
                .join("") === "fa"
                ? "دارد"
                : "Included"}
            </span>
          </li>
        );
      }
      setExtendedTitle(tempExtended);
    }
  }, [fabricSelected2]);

  useEffect(() => {
    if (borderSelected.selectedFabricId && !pageLoad) {
      setCart(
        "BorderOrTrimId",
        `${borderSelected.selectedFabricId}`,
        "",
        "BorderOrTrimDesignFa,BorderOrTrimDesignEn,BorderOrTrimColorEn,BorderOrTrimColorFa,BorderOrTrimPhotoUrl",
        [
          borderSelected.selectedTextFa,
          borderSelected.selectedTextEn,
          borderSelected.selectedColorEn,
          borderSelected.selectedColorFa,
          borderSelected.selectedPhoto,
        ]
      );

      setStep1Border(borderSelected.selectedFabricId.toString());
      setStep1Trim("");
      setDeps("111", "11", 1);

      let tempExtended = extendedTitle;
      tempExtended["1"][1] = (
        <li key="1" className="step_title_extended_list_item">
          <span className="step_title_extended_list_item_title">{t("Decorative Border")}</span>
          <span className="step_title_extended_list_item_text">
            {location.pathname
              .split("")
              .slice(1, 3)
              .join("") === "fa"
              ? borderSelected.selectedTextFa + " / " + borderSelected.selectedColorFa
              : CapitalizeAllWords(
                  borderSelected.selectedTextEn + " / " + borderSelected.selectedColorEn
                )}
          </span>
        </li>
      );
      setExtendedTitle(tempExtended);
    }
  }, [borderSelected]);

  useEffect(() => {
    if (trimSelected.selectedFabricId && !pageLoad) {
      setCart(
        "BorderOrTrimId",
        `${trimSelected.selectedFabricId}`,
        "",
        "BorderOrTrimDesignFa,BorderOrTrimDesignEn,BorderOrTrimColorEn,BorderOrTrimColorFa,BorderOrTrimPhotoUrl",
        [
          trimSelected.selectedTextFa,
          trimSelected.selectedTextEn,
          trimSelected.selectedColorEn,
          trimSelected.selectedColorFa,
          trimSelected.selectedPhoto,
        ]
      );

      setStep1Border("");
      setStep1Trim(trimSelected.selectedFabricId.toString());
      setDeps("", "11,111", 1);

      let tempExtended = extendedTitle;
      tempExtended["1"][1] = (
        <li key="1" className="step_title_extended_list_item">
          <span className="step_title_extended_list_item_title">{t("Decorative Trim")}</span>
          <span className="step_title_extended_list_item_text">
            {location.pathname
              .split("")
              .slice(1, 3)
              .join("") === "fa"
              ? trimSelected.selectedTextFa + " / " + trimSelected.selectedColorFa
              : CapitalizeAllWords(
                  trimSelected.selectedTextEn + " / " + trimSelected.selectedColorEn
                )}
          </span>
        </li>
      );
      tempExtended["1"].splice(2, 1);
      setExtendedTitle(tempExtended);
    }
  }, [trimSelected]);

  useEffect(() => {
    if (borderSelected2.selectedFabricId && !pageLoad) {
      setCart(
        "BorderOrTrimId2",
        `${borderSelected2.selectedFabricId}`,
        "",
        "BorderOrTrimDesignFa2,BorderOrTrimDesignEn2,BorderOrTrimColorEn2,BorderOrTrimColorFa2,BorderOrTrimPhotoUrl2",
        [
          borderSelected2.selectedTextFa,
          borderSelected2.selectedTextEn,
          borderSelected2.selectedColorEn,
          borderSelected2.selectedColorFa,
          borderSelected2.selectedPhoto,
        ]
      );

      setStep2Border(borderSelected2.selectedFabricId.toString());
      setStep2Trim("");
      setDeps("211", "21", 1);

      let tempExtended = extendedTitle;
      tempExtended["2"][1] = (
        <li key="1" className="step_title_extended_list_item">
          <span className="step_title_extended_list_item_title">{t("Decorative Border")}</span>
          <span className="step_title_extended_list_item_text">
            {location.pathname
              .split("")
              .slice(1, 3)
              .join("") === "fa"
              ? borderSelected2.selectedTextFa + " / " + borderSelected2.selectedColorFa
              : CapitalizeAllWords(
                  borderSelected2.selectedTextEn + " / " + borderSelected2.selectedColorEn
                )}
          </span>
        </li>
      );
      setExtendedTitle(tempExtended);
    }
  }, [borderSelected2]);

  useEffect(() => {
    if (trimSelected2.selectedFabricId && !pageLoad) {
      setCart(
        "BorderOrTrimId2",
        `${trimSelected2.selectedFabricId}`,
        "",
        "BorderOrTrimDesignFa2,BorderOrTrimDesignEn2,BorderOrTrimColorEn2,BorderOrTrimColorFa2,BorderOrTrimPhotoUrl2",
        [
          trimSelected2.selectedTextFa,
          trimSelected2.selectedTextEn,
          trimSelected2.selectedColorEn,
          trimSelected2.selectedColorFa,
          trimSelected2.selectedPhoto,
        ]
      );

      setStep2Border("");
      setStep2Trim(trimSelected2.selectedFabricId.toString());
      setDeps("", "21,211", 1);

      let tempExtended = extendedTitle;
      tempExtended["2"][1] = (
        <li key="1" className="step_title_extended_list_item">
          <span className="step_title_extended_list_item_title">{t("Decorative Trim")}</span>
          <span className="step_title_extended_list_item_text">
            {location.pathname
              .split("")
              .slice(1, 3)
              .join("") === "fa"
              ? trimSelected2.selectedTextFa + " / " + trimSelected2.selectedColorFa
              : CapitalizeAllWords(
                  trimSelected2.selectedTextEn + " / " + trimSelected2.selectedColorEn
                )}
          </span>
        </li>
      );
      tempExtended["2"].splice(2, 1);
      setExtendedTitle(tempExtended);
    }
  }, [trimSelected2]);

  useEffect(() => {
    if (sheersSelected.selectedFabricId && sheersSelected.selectedFabricId !== 0 && !pageLoad) {
      setCart(
        "SheersId1",
        `${sheersSelected.selectedFabricId}`,
        "",
        "SheersDesignFa,SheersDesignEn,SheersColorEn,SheersColorFa,SheersPhotoUrl",
        [
          sheersSelected.selectedTextFa,
          sheersSelected.selectedTextEn,
          sheersSelected.selectedColorEn,
          sheersSelected.selectedColorFa,
          sheersSelected.selectedPhoto,
        ]
      );

      setDeps("", "2B1");
      setStep2B1(sheersSelected.selectedFabricId.toString());

      let tempLabels = JSON.parse(JSON.stringify(stepSelectedLabel));

      tempLabels["2B"] =
        location.pathname
          .split("")
          .slice(1, 3)
          .join("") === "fa"
          ? sheersSelected.selectedTextFa + " / " + sheersSelected.selectedColorFa
          : sheersSelected.selectedTextEn + " / " + sheersSelected.selectedColorEn;
      setStepSelectedLabel(tempLabels);

      let temp = JSON.parse(JSON.stringify(requiredStep));
      if (tempLabels["2B"] !== "" && requiredStep["2B"]) {
        temp["2B"] = false;
      }

      setRequiredStep(temp);
    }
  }, [sheersSelected]);

  useEffect(() => {
    if (sheersSelected2.selectedFabricId && sheersSelected2.selectedFabricId !== 0 && !pageLoad) {
      setCart(
        "SheersId2",
        `${sheersSelected2.selectedFabricId}`,
        "",
        "SheersDesignFa,SheersDesignEn,SheersColorEn,SheersColorFa,SheersPhotoUrl",
        [
          sheersSelected2.selectedTextFa,
          sheersSelected2.selectedTextEn,
          sheersSelected2.selectedColorEn,
          sheersSelected2.selectedColorFa,
          sheersSelected2.selectedPhoto,
        ]
      );
      setDeps("", "2B1");
      setStep2B1(sheersSelected2.selectedFabricId.toString());

      let tempLabels = JSON.parse(JSON.stringify(stepSelectedLabel));
      tempLabels["2B"] =
        location.pathname
          .split("")
          .slice(1, 3)
          .join("") === "fa"
          ? sheersSelected2.selectedTextFa + " / " + sheersSelected2.selectedColorFa
          : sheersSelected2.selectedTextEn + " / " + sheersSelected2.selectedColorEn;
      setStepSelectedLabel(tempLabels);

      let temp = JSON.parse(JSON.stringify(requiredStep));
      if (tempLabels["2B"] !== "" && requiredStep["2B"]) {
        temp["2B"] = false;
      }

      setRequiredStep(temp);
    }
  }, [sheersSelected2]);

  useEffect(() => {
    if (!pageLoad) {
      if (step1BorderRadio !== "") {
        let tempExtended = extendedTitle;
        tempExtended["1"][2] = (
          <li key="2" className="step_title_extended_list_item">
            <span className="step_title_extended_list_item_title">{t("Border Position")}</span>
            <span className="step_title_extended_list_item_text">
              {pageLanguage === "en"
                ? CapitalizeAllWords(t(step1BorderRadio))
                : t(step1BorderRadio)}
            </span>
          </li>
        );
        setExtendedTitle(tempExtended);
        setCart("borderPosition", step1BorderRadio);
        setDeps("", "111", 2);
      } else {
        let tempExtended = extendedTitle;
        tempExtended["1"].splice(2, 1);
        setExtendedTitle(tempExtended);
      }
    }
  }, [step1BorderRadio]);

  useEffect(() => {
    if (!pageLoad) {
      if (step2BorderRadio !== "") {
        let tempExtended = extendedTitle;
        tempExtended["2"][2] = (
          <li key="2" className="step_title_extended_list_item">
            <span className="step_title_extended_list_item_title">{t("Border Position")}</span>
            <span className="step_title_extended_list_item_text">
              {pageLanguage === "en"
                ? CapitalizeAllWords(t(step2BorderRadio))
                : t(step2BorderRadio)}
            </span>
          </li>
        );
        setExtendedTitle(tempExtended);
        setCart("borderPosition2", step2BorderRadio);
        setDeps("", "211", 2);
      } else if (!fabricSelected2.selectedLeadRequired) {
        let tempExtended = extendedTitle;
        tempExtended["2"].splice(2, 1);
        setExtendedTitle(tempExtended);
      }
    }
  }, [step2BorderRadio]);

  useEffect(() => {
    if (!firstRender.current) {
      // getCart().then((temp) => {
      if (Object.keys(fabrics).length) {
        setTimeout(() => {
          renderFabrics(bag);
        }, 100);
      } else {
        setFabricsList([]);
      }
    }
  }, [step1]);

  useEffect(() => {
    if (Object.keys(fabrics).length) {
      renderFabrics(bag);
    } else {
      setFabricsList([]);
    }
  }, [step1Check, step1Border, step1BorderRadio, step1Trim]);

  useEffect(() => {
    if (!pageLoad) {
      if (fabricSelected.selectedFabricId && step1Check !== "") {
        setDeps("11", "");
      } else if (fabricSelected.selectedFabricId) {
        setTimeout(() => {
          let tempExtended = extendedTitle;
          tempExtended["1"].splice(1, 2);
          setExtendedTitle(tempExtended);
          setDeps("", "11,111", 1);
          setCart(
            "",
            "",
            "BorderOrTrimId,BorderOrTrimDesignFa,BorderOrTrimDesignEn,BorderOrTrimColorEn,BorderOrTrimColorFa,BorderOrTrimPhotoUrl,borderPosition"
          );
        }, 500);
      }
    }
  }, [step1Check]);

  useEffect(() => {
    if (!pageLoad) {
      if (fabricSelected2.selectedFabricId && step2Check !== "") {
        setDeps("21", "");
      } else if (fabricSelected2.selectedFabricId) {
        setTimeout(() => {
          let tempExtended = extendedTitle;
          tempExtended["2"].splice(1, 2);
          setExtendedTitle(tempExtended);
          setDeps("", "21,211", 1);
          setCart(
            "",
            "",
            "BorderOrTrimId2,BorderOrTrimDesignFa2,BorderOrTrimDesignEn2,BorderOrTrimColorEn2,BorderOrTrimColorFa2,BorderOrTrimPhotoUrl2,borderPosition2"
          );
        }, 500);
      }
    }
  }, [step2Check]);

  useEffect(() => {
    if (!pageLoad) {
      if (fabricSelected2.selectedFabricId && step2Check2 !== "") {
        setCart("leadId", fabricSelected2.selectedFabricId.toString(), "", "hasLead", ["Yes"]);
        let tempExtended = extendedTitle;
        tempExtended["2"][1] = (
          <li key="1" className="step_title_extended_list_item">
            <span className="step_title_extended_list_item_title">{t("Lead Weight")}</span>
            <span className="step_title_extended_list_item_text">
              {location.pathname
                .split("")
                .slice(1, 3)
                .join("") === "fa"
                ? "موجود"
                : "Yes"}
            </span>
          </li>
        );
        setExtendedTitle(tempExtended);
      } else if (fabricSelected2.selectedFabricId && !fabricSelected2.selectedLeadRequired) {
        setTimeout(() => {
          let tempExtended = extendedTitle;
          tempExtended["2"].splice(1, 2);
          setExtendedTitle(tempExtended);
          setCart("", "", "leadId,hasLead");
        }, 500);
      }
    }
  }, [step2Check2]);

  useEffect(() => {
    if (Object.keys(fabrics2).length) {
      renderFabrics2(bag);
      renderFabrics22(bag);
    } else {
      setFabricsList2([]);
      setFabricsList22([]);
    }
  }, [step2Check2, step2Check, step2Border, step2BorderRadio, step2Trim]);

  useEffect(() => {
    if (!firstRender.current) {
      if (Object.keys(fabrics2).length) {
        setTimeout(() => {
          renderFabrics2(bag);
          renderFabrics22(bag);
        }, 100);
      } else {
        setFabricsList2([]);
        setFabricsList22([]);
      }
    }
  }, [step2]);

  useEffect(() => {
    if (!firstRender.current) {
      if (Object.keys(sheers).length || Object.keys(sheers2).length) {
        setTimeout(() => {
          renderSheers(bag);
          renderSheers2(bag);
        }, 100);
      } else {
        setSheersList([]);
        setSheersList2([]);
      }
    }
  }, [step2B1]);

  useEffect(() => {
    if (fabricError && !accordionActiveKey.startsWith("3") && Object.keys(errorData).length) {
      let fabricBoard = undefined;
      let sheerBoard = undefined;
      let temp1 = {};
      let temp2 = {};
      if (errorData["SewingOrderDetails"] && errorData["SewingOrderDetails"].length) {
        setFabricsBoard(
          errorData["SewingOrderDetails"]
            .filter((obj) => ["2302", "2303"].includes(obj["CurtainPartId"].toString()))
            .map(({ CurtainPartId, FabricId, IsBoard, BoardNum }) => ({
              CurtainPartId,
              FabricId,
              IsBoard,
              BoardNum,
            }))
        );
        temp1 = errorData["SewingOrderDetails"].find(
          (obj) => obj["FabricId"] === fabricSelected.selectedFabricId
        );
        temp2 = errorData["SewingOrderDetails"].find(
          (obj) => obj["FabricId"] === fabricSelected2.selectedFabricId
        );
      }

      if (fabricSelected.selectedFabricId && Object.keys(temp1).length) {
        if (temp1["CanSewing"] === false) {
          fabricBoard = 1;
        } else if (temp1["IsBoard"] && temp1["BoardNum"] > 1) {
          fabricBoard = 0;
        }
      }
      if (fabricSelected2.selectedFabricId && Object.keys(temp2).length) {
        if (temp2["CanSewing"] === false) {
          sheerBoard = 1;
        } else if (temp2["IsBoard"] && temp2["BoardNum"] > 1) {
          sheerBoard = 0;
        }
      }

      setFabricError(false);
      setErrorData({});

      if (fabricBoard !== undefined || sheerBoard !== undefined) {
        if (fabricBoard === 1 && sheerBoard === 1) {
          setAccordionActiveKey2("");
          setFabricSelected({
            selectedFabricId: 0,
            selectedTextEn: "",
            selectedTextFa: "",
            selectedDesignCode: "",
            selectedColorEn: "",
            selectedColorFa: "",
            selectedHasTrim: false,
            selectedPhoto: "",
            selectedPhoto2: "",
            FabricWidth: 0,
            SewingDirection: undefined,
          });
          setFabricSelected2({
            selectedFabricId: 0,
            selectedTextEn: "",
            selectedTextFa: "",
            selectedDesignCode: "",
            selectedColorEn: "",
            selectedColorFa: "",
            selectedHasTrim: false,
            selectedPhoto: "",
            selectedPhoto2: "",
            FabricWidth: 0,
            SewingDirection: undefined,
          });

          let tempExtended = extendedTitle;
          setStep1Check("");
          setStep1Border("");
          setStep1BorderRadio("");
          setStep1Trim("");
          tempExtended["1"] = [];
          setDeps("1,2", "11,111,21,211");
          setCart(
            "",
            "",
            "FabricId,FabricDesignFa,FabricDesignEn,FabricColorEn,FabricColorFa,PhotoUrl,BorderOrTrimId,BorderOrTrimDesignFa,BorderOrTrimDesignEn,BorderOrTrimColorEn,BorderOrTrimColorFa,BorderOrTrimPhotoUrl,borderPosition,FabricId2,leadId,hasLead,FabricDesignFa2,FabricDesignEn2,FabricColorEn2,FabricColorFa2,PhotoUrl2,BorderOrTrimId2,BorderOrTrimDesignFa2,BorderOrTrimDesignEn2,BorderOrTrimColorEn2,BorderOrTrimColorFa2,BorderOrTrimPhotoUrl2,borderPosition2"
          );
          selectChanged(undefined, "1,2");
          setStep1("");

          setStep2Check("");
          setStep2Check2("");
          setStep2Border("");
          setStep2BorderRadio("");
          setStep2Trim("");
          tempExtended["2"] = [];
          setExtendedTitle(tempExtended);
          setStep2("");
        } else if (fabricBoard === 1) {
          setAccordionActiveKey2("1");
          setFabricSelected({
            selectedFabricId: 0,
            selectedTextEn: "",
            selectedTextFa: "",
            selectedDesignCode: "",
            selectedColorEn: "",
            selectedColorFa: "",
            selectedHasTrim: false,
            selectedPhoto: "",
            selectedPhoto2: "",
            FabricWidth: 0,
            SewingDirection: undefined,
          });
          let tempExtended = extendedTitle;
          setStep1Check("");
          setStep1Border("");
          setStep1BorderRadio("");
          setStep1Trim("");
          tempExtended["1"] = [];
          setDeps("1", "11,111");
          setCart(
            "",
            "",
            "FabricId,FabricDesignFa,FabricDesignEn,FabricColorEn,FabricColorFa,PhotoUrl,BorderOrTrimId,BorderOrTrimDesignFa,BorderOrTrimDesignEn,BorderOrTrimColorEn,BorderOrTrimColorFa,BorderOrTrimPhotoUrl,borderPosition"
          );
          selectChanged(undefined, "1");
          setExtendedTitle(tempExtended);
          setStep1("");
        } else if (sheerBoard === 1) {
          setAccordionActiveKey2("2");
          setFabricSelected2({
            selectedFabricId: 0,
            selectedTextEn: "",
            selectedTextFa: "",
            selectedDesignCode: "",
            selectedColorEn: "",
            selectedColorFa: "",
            selectedHasTrim: false,
            selectedPhoto: "",
            selectedPhoto2: "",
            FabricWidth: 0,
            SewingDirection: undefined,
          });
          let tempExtended = extendedTitle;
          setStep2Check("");
          setStep2Check2("");
          setStep2Border("");
          setStep2BorderRadio("");
          setStep2Trim("");
          tempExtended["2"] = [];
          setDeps("2", "21,211", 1);
          setCart(
            "",
            "",
            "FabricId2,leadId,hasLead,FabricDesignFa2,FabricDesignEn2,FabricColorEn2,FabricColorFa2,PhotoUrl2,BorderOrTrimId2,BorderOrTrimDesignFa2,BorderOrTrimDesignEn2,BorderOrTrimColorEn2,BorderOrTrimColorFa2,BorderOrTrimPhotoUrl2,borderPosition2"
          );
          selectChanged(undefined, "2");
          setExtendedTitle(tempExtended);
          setStep2("");
        }
        if (fabricBoard !== undefined) {
          setFabricBoard(fabricBoard);
        }
        if (sheerBoard !== undefined) {
          setSheerBoard(sheerBoard);
        }

        setTimeout(() => {
          modalHandleShow("changeFabrics");
        }, 200);
      }
    }

    const validKeys = [
      "1",
      "2",
      "2A",
      "2B",
      "2C",
      "3A0",
      "4",
      "5",
      "6",
      "8",
      "8A",
      "8B",
      "8C",
      "9",
      "10",
      "11",
    ];

    setIsShowStep5(validKeys.includes(accordionActiveKey));
  }, [fabricError, errorData, accordionActiveKey]);

  useEffect(() => {
    if (fabricsBoard && fabricsBoard.length && !pageLoad && !boardLoad) {
      let fabricRail = undefined;
      let sheerRail = undefined;
      if (fabricSelected.selectedFabricId) {
        let temp = fabricsBoard.find((obj) => obj["FabricId"] === fabricSelected.selectedFabricId);
        if (temp && Object.keys(temp).length) {
          if (temp["IsBoard"] && temp["BoardNum"] > 1) {
            fabricRail = 0;
          }
        }
      }
      if (fabricSelected2.selectedFabricId) {
        let temp = fabricsBoard.find((obj) => obj["FabricId"] === fabricSelected2.selectedFabricId);
        if (temp && Object.keys(temp).length) {
          if (temp["IsBoard"] && temp["BoardNum"] > 1) {
            sheerRail = 0;
          }
        }
      }
      if (modals["changeFabrics"] || fabricBoard || sheerBoard) {
        setFabricIsBoard(fabricRail === 0);
        setSheerIsBoard(sheerRail === 0);
      } else {
        if (fabricRail === 0 && sheerRail === 0) {
          modalHandleShow("fabricHasLine3");
        } else if (fabricRail === 0 && sheerRail === undefined) {
          modalHandleShow("fabricHasLine");
        } else if (fabricRail === undefined && sheerRail === 0) {
          modalHandleShow("fabricHasLine2");
        }
      }
    }

    if (boardLoad) {
      setBoardLoad(false);
    }
  }, [JSON.stringify(fabricsBoard)]);

  useEffect(() => {
    if (heightCart === undefined) {
      setHeightCart2(undefined);
    }
  }, [heightCart]);

  useEffect(() => {
    if (fabricIsBoard) {
      renderFabrics(bag, undefined, fabricIsBoard);
      setFabricIsBoard(false);
    }
  }, [fabricIsBoard]);

  useEffect(() => {
    if (sheerIsBoard) {
      renderFabrics2(bag, undefined, sheerIsBoard);
      renderFabrics22(bag, undefined, sheerIsBoard);
      setSheerIsBoard(false);
    }
  }, [sheerIsBoard]);

  useEffect(() => {
    let arr = [
      width3C,
      height3E,
      left,
      right,
      mount,
      rodWidth,
      ceilingToFloor,
      ceilingToFloor1,
      ceilingToFloor2,
      ceilingToFloor3,
      ceilingToWindow1,
      ceilingToWindow2,
      ceilingToWindow3,
      windowToFloor,
      rodToFloor,
      rodToBottom,
    ];
    if (arr.every((el) => el === undefined)) {
      setAnyMeasurements(false);
    } else {
      setAnyMeasurements(true);
    }
  }, [
    width3C,
    height3E,
    left,
    right,
    mount,
    rodWidth,
    ceilingToFloor,
    ceilingToFloor1,
    ceilingToFloor2,
    ceilingToFloor3,
    ceilingToWindow1,
    ceilingToWindow2,
    ceilingToWindow3,
    windowToFloor,
    rodToFloor,
    rodToBottom,
  ]);

  useEffect(() => {
    if (pageLanguage !== "") {
      if (
        Object.keys(rods).length ||
        Object.keys(rods2).length ||
        Object.keys(rods3).length ||
        Object.keys(tracks).length ||
        Object.keys(tracks2).length ||
        Object.keys(tracks3).length
      ) {
        renderRods();
        renderTracks();
      } else {
        setRodsList([]);
        setRodsList2([]);
        setRodsList3([]);
        setRodsList4([]);
        setTracksList([]);
        setTracksList2([]);
      }
    }
  }, [step81, step8A1, step8B1, step8C1, stepTrackCollections9A, stepTCollections9A, step8D1]);

  function showRodsColor(railObject, stepNum) {
    let pageLanguage = location.pathname
      .split("")
      .slice(1, 3)
      .join("");
    const rodList = [];
    let promiseArr = [];
    if (Object.keys(railObject).length > 0) {
      if (stepNum === "82") {
        rods[railObject["DesignCode"]].forEach((obj, index) => {
          promiseArr[index] = new Promise((resolve, reject) => {
            let ColorName = obj["ColorName"];
            let ColorEnName = obj["ColorEnName"];
            let RailId = obj["RailId"];
            let Price = obj["Price"];
            let PhotoObj = {};
            PhotoObj =
              obj["Photos"].filter((obj) => {
                return obj["PhotoTypeId"] === 4709;
              })[0] || PhotoObj;
            let PhotoPath = PhotoObj["PhotoUrl"] || "";

            rodList.push(
              <div className="box33" key={index}>
                <div className="radio_group">
                  <label className="radio_container">
                    <input
                      className="radio"
                      type="radio"
                      text={pageLanguage === "fa" ? ColorName : ColorEnName}
                      value={index}
                      name="step82"
                      ref-num={"8"}
                      id={"82" + index}
                      outline="true"
                      checked={step82 === `${RailId}`}
                      onChange={(e) => {
                        setStep82(`${RailId}`);
                      }}
                      ref={(ref) => (inputs.current["82" + index] = ref)}
                    />
                    <div className="frame_img">
                      <img src={imgUrl(PhotoPath)} className="img-fluid bracket_color_img" alt="" />
                    </div>
                  </label>
                  <div className="radio_group_name_container">
                    <h1>{pageLanguage === "fa" ? ColorName : ColorEnName}</h1>
                  </div>
                </div>
              </div>
            );
            resolve();
          });
        });
      } else if (stepNum === "8A2") {
        rods[railObject["DesignCode"]]?.forEach((obj, index) => {
          promiseArr[index] = new Promise((resolve, reject) => {
            let ColorName = obj["ColorName"];
            let ColorEnName = obj["ColorEnName"];
            let RailId = obj["RailId"];
            let Price = obj["Price"];
            let PhotoObj = {};
            PhotoObj =
              obj["Photos"].filter((obj) => {
                return obj["PhotoTypeId"] === 4709;
              })[0] || PhotoObj;
            let PhotoPath = PhotoObj["PhotoUrl"] || "";

            rodList.push(
              <div className="box33" key={index}>
                <div className="radio_group">
                  <label className="radio_container">
                    <input
                      className="radio"
                      type="radio"
                      text={pageLanguage === "fa" ? ColorName : ColorEnName}
                      value={index}
                      name="step8A2"
                      ref-num={"8A2"}
                      id={"8A2" + index}
                      outline="true"
                      checked={step8A2 === `${RailId}`}
                      onChange={(e) => {
                        setStep8A2(`${RailId}`);
                      }}
                      ref={(ref) => (inputs.current["8A2" + index] = ref)}
                    />
                    <div className="frame_img">
                      <img src={imgUrl(PhotoPath)} className="img-fluid bracket_color_img" alt="" />
                    </div>
                  </label>
                  <div className="radio_group_name_container">
                    <h1>{pageLanguage === "fa" ? ColorName : ColorEnName}</h1>
                  </div>
                </div>
              </div>
            );
            resolve();
          });
        });
      } else if (stepNum === "8B2") {
        let tempRails = {};
        if (railObject["RailCategoryId"] === 5303) {
          tempRails = rods2[railObject["DesignCode"]] ? rods2 : rods;
        } else {
          tempRails = tracks2[railObject["DesignCode"]] ? tracks2 : tracks;
        }
        tempRails[railObject["DesignCode"]]?.forEach((obj, index) => {
          promiseArr[index] = new Promise((resolve, reject) => {
            let ColorName = obj["ColorName"];
            let ColorEnName = obj["ColorEnName"];
            let RailId = obj["RailId"];
            let Price = obj["Price"];
            let PhotoObj = {};
            PhotoObj =
              obj["Photos"].filter((obj) => {
                return obj["PhotoTypeId"] === 4709;
              })[0] || PhotoObj;
            let PhotoPath = PhotoObj["PhotoUrl"] || "";

            rodList.push(
              <div className="box33" key={index}>
                <div className="radio_group">
                  <label className="radio_container">
                    <input
                      className="radio"
                      type="radio"
                      text={pageLanguage === "fa" ? ColorName : ColorEnName}
                      value={index}
                      name="step8B2"
                      ref-num={"8B2"}
                      id={"8B2" + index}
                      outline="true"
                      checked={step8B2 === `${RailId}`}
                      onChange={(e) => {
                        setStep8B2(`${RailId}`);
                      }}
                      ref={(ref) => (inputs.current["8B2" + index] = ref)}
                    />
                    <div className="frame_img">
                      <img
                        src={imgUrl(PhotoPath)}
                        className={
                          step8B2 === `${RailId}`
                            ? "img-fluid bracket_color_img img-fluid_checked 1"
                            : "img-fluid bracket_color_img"
                        }
                        alt=""
                      />
                    </div>
                  </label>
                  <div className="radio_group_name_container">
                    <h1>{pageLanguage === "fa" ? ColorName : ColorEnName}</h1>
                  </div>
                </div>
              </div>
            );
            resolve();
          });
        });
      } else if (stepNum === "8C2") {
        let tempRails = {};
        if (railObject["RailCategoryId"] === 5303) {
          tempRails = rods3;
        } else {
          tempRails = tracks3;
        }
        tempRails[railObject["DesignCode"]]?.forEach((obj, index) => {
          promiseArr[index] = new Promise((resolve, reject) => {
            let ColorName = obj["ColorName"];
            let ColorEnName = obj["ColorEnName"];
            let RailId = obj["RailId"];
            let PhotoObj = {};
            PhotoObj =
              obj["Photos"].filter((obj) => {
                return obj["PhotoTypeId"] === 4709;
              })[0] || PhotoObj;
            let PhotoPath = PhotoObj["PhotoUrl"] || "";

            rodList.push(
              <div className="box33" key={index}>
                <div className="radio_group">
                  <label className="radio_container">
                    <input
                      className="radio"
                      type="radio"
                      text={pageLanguage === "fa" ? ColorName : ColorEnName}
                      value={index}
                      name="step8C2"
                      ref-num={"8C2"}
                      id={"8C2" + index}
                      outline="true"
                      checked={step8C2 === `${RailId}`}
                      onChange={(e) => {
                        setStep8C2(`${RailId}`);
                      }}
                      ref={(ref) => (inputs.current["8C2" + index] = ref)}
                    />
                    <div className="frame_img">
                      <img
                        src={imgUrl(PhotoPath)}
                        className={
                          step8C2 === `${RailId}`
                            ? "img-fluid bracket_color_img img-fluid_checked 2"
                            : "img-fluid bracket_color_img"
                        }
                        alt=""
                      />
                    </div>
                  </label>
                  <div className="radio_group_name_container">
                    <h1>{pageLanguage === "fa" ? ColorName : ColorEnName}</h1>
                  </div>
                </div>
              </div>
            );
            resolve();
          });
        });
      } else if (stepNum === "8D2") {
        let tempRails = {};
        if (railObject["RailCategoryId"] === 5303) {
          tempRails = rods3;
        } else {
          tempRails = tracks3;
          if (
            !tempRails[railObject["DesignCode"]]?.length &&
            tracks2[railObject["DesignCode"]]?.length
          ) {
            tempRails = tracks2;
          }
        }

        tempRails[railObject["DesignCode"]]?.forEach((obj, index) => {
          promiseArr[index] = new Promise((resolve, reject) => {
            let ColorName = obj["ColorName"];
            let ColorEnName = obj["ColorEnName"];
            let RailId = obj["RailId"];
            let PhotoObj = {};
            PhotoObj =
              obj["Photos"].filter((obj) => {
                return obj["PhotoTypeId"] === 4709;
              })[0] || PhotoObj;
            let PhotoPath = PhotoObj["PhotoUrl"] || "";

            rodList.push(
              <div className="box33" key={index}>
                <div className="radio_group">
                  <label className="radio_container">
                    <input
                      className="radio"
                      type="radio"
                      text={pageLanguage === "fa" ? ColorName : ColorEnName}
                      value={index}
                      name="step8D2"
                      ref-num={"8"}
                      id={"8D2" + index}
                      outline="true"
                      checked={step8D2 === `${RailId}`}
                      onChange={(e) => {
                        setNameColorEnDraperyTrack(ColorEnName);
                        setNameColorFaDraperyTrack(ColorName);
                        setStep8D2(`${RailId}`);
                      }}
                      ref={(ref) => (inputs.current["8D2" + index] = ref)}
                    />
                    <div className="frame_img">
                      <img
                        src={imgUrl(PhotoPath)}
                        className={
                          step8D2 === `${RailId}`
                            ? "img-fluid bracket_color_img img-fluid_checked 3"
                            : "img-fluid bracket_color_img"
                        }
                        alt=""
                      />
                    </div>
                  </label>
                  <div className="radio_group_name_container">
                    <h1>{pageLanguage === "fa" ? ColorName : ColorEnName}</h1>
                  </div>
                </div>
              </div>
            );
            resolve();
          });
        });
      } else if (stepNum === "8H1") {
        let tempRails = {};
        if (railObject["RailCategoryId"] === 5303) {
          tempRails = rods2;
        } else {
          tempRails = tracks2[railObject["DesignCode"]] ? tracks2 : tracks;
        }
        tempRails[railObject["DesignCode"]]?.forEach((obj, index) => {
          promiseArr[index] = new Promise((resolve, reject) => {
            let ColorName = obj["ColorName"];
            let ColorEnName = obj["ColorEnName"];
            let RailId = obj["RailId"];
            let Price = obj["Price"];
            let PhotoObj = {};
            PhotoObj =
              obj["Photos"].filter((obj) => {
                return obj["PhotoTypeId"] === 4709;
              })[0] || PhotoObj;
            let PhotoPath = PhotoObj["PhotoUrl"] || "";

            rodList.push(
              <div className="box33" key={index}>
                <div className="radio_group">
                  <label className="radio_container">
                    <input
                      className="radio"
                      type="radio"
                      text={pageLanguage === "fa" ? ColorName : ColorEnName}
                      value={index}
                      name="stepHardware9A"
                      ref-num={"8H1"}
                      id={"8H1" + index}
                      outline="true"
                      checked={stepHardware9A === `${RailId}`}
                      onChange={(e) => {
                        setStepHardware9A(`${RailId}`);
                        setStepHardwareName9A(pageLanguage === "fa" ? ColorName : ColorEnName);
                      }}
                      ref={(ref) => (inputs.current["8H1" + index] = ref)}
                    />
                    <div className="frame_img">
                      <img src={imgUrl(PhotoPath)} className="img-fluid bracket_color_img" alt="" />
                    </div>
                  </label>
                  <div className="radio_group_name_container">
                    <h1>{pageLanguage === "fa" ? ColorName : ColorEnName}</h1>
                  </div>
                </div>
              </div>
            );
            resolve();
          });
        });
      } else if (stepNum === "8H3") {
        let tempRails = {};
        if (railObject["RailCategoryId"] === 5303) {
          tempRails = rods2;
        } else {
          tempRails = tracks2[railObject["DesignCode"]] ? tracks2 : tracks;
        }
        tempRails[railObject["DesignCode"]]?.forEach((obj, index) => {
          promiseArr[index] = new Promise((resolve, reject) => {
            let ColorName = obj["ColorName"];
            let ColorEnName = obj["ColorEnName"];
            let RailId = obj["RailId"];
            let Price = obj["Price"];
            let PhotoObj = {};
            PhotoObj =
              obj["Photos"].filter((obj) => {
                return obj["PhotoTypeId"] === 4709;
              })[0] || PhotoObj;
            let PhotoPath = PhotoObj["PhotoUrl"] || "";

            rodList.push(
              <div className="box33" key={index}>
                <div className="radio_group">
                  <label className="radio_container">
                    <input
                      className="radio"
                      type="radio"
                      text={pageLanguage === "fa" ? ColorName : ColorEnName}
                      value={index}
                      name="stepHardware9A"
                      ref-num={"8H1"}
                      id={"8H1" + index}
                      outline="true"
                      checked={stepHardware9A === `${RailId}`}
                      onChange={(e) => {
                        setStepHardware9A(`${RailId}`);
                      }}
                      ref={(ref) => (inputs.current["8H1" + index] = ref)}
                    />
                    <div className="frame_img">
                      <img src={imgUrl(PhotoPath)} className="img-fluid bracket_color_img" alt="" />
                    </div>
                  </label>
                  <div className="radio_group_name_container">
                    <h1>{pageLanguage === "fa" ? ColorName : ColorEnName}</h1>
                  </div>
                </div>
              </div>
            );
            resolve();
          });
        });
      }

      Promise.all(promiseArr).then(() => {
        if (Object.keys(railObject).length > 0) {
          if (stepNum === "82") {
            setRodsColorList(rodList);
          } else if (stepNum === "8A2") {
            setRodsColorList2(rodList);
          } else if (stepNum === "8B2") {
            setRodsColorList3(rodList);
          } else if (stepNum === "8C2") {
            setRodsColorList4(rodList);
          } else if (stepNum === "8D2") {
            setRodsColorList5(rodList);
          } else if (stepNum === "8H1") {
            setRodsColorList6(rodList);
          } else if (stepNum === "8H3") {
            setRodsColorList6(rodList);
          }
        }
      });
    }
  }

  useEffect(() => {
    if (step6 === "Customize Style Per Curtain") {
      setHardwareNextStep("9");
      setStep8("");
      let tempExtended = extendedTitle;
      tempExtended["8"] = [];
      tempExtended["8A"] = [];
      tempExtended["8B"] = [];
      tempExtended["8C"] = [];
      setExtendedTitle(tempExtended);
      selectChanged("", "8,8A,8B,8C");

      setCart(
        "",
        "",
        "Hardware,hardwareDrapery,hardwareSheer,hardwarePrivacyLayer,BatonOptionA,RailDesignA,RailDesignEnA,RailDesignFaA,RailColorEnA,RailColorFaA,RodColorA,MountA,RailIdB,BatonOptionB,ControlPositionB,RailDesignB,RailDesignEnB,RailDesignFaB,RailColorEnB,RailColorFaB,RodColorB,hasPowerB,MotorPositionB,RemoteNameB,MotorChannelsB,RailIdC,BatonOptionC,ControlPositionC,RailDesignC,RailDesignEnC,RailDesignFaC,RailColorEnC,RailColorFaC,RodColorC,hasPowerC,MotorPositionC,RemoteNameC,MotorChannelsC"
      );
    }
  }, [step6BHead, step6CHead]);

  useEffect(() => {
    if (step81 !== "" && !pageLoad) {
      // After refresh, design is set from cart — do not wipe color/baton or splice tooltip
      const isRestoreHydrate =
        cartValues["RailDesignA"] !== undefined && `${cartValues["RailDesignA"]}` === `${step81}`;

      if (!isRestoreHydrate) {
        setDeps("812,813", "81,8A,8B,8C,8A1,811,801,809");
        setStep82("");
        setStep83("");
        setStep8A4("");
      }

      let railObject = rails.find((obj) => `${obj["RailId"]}` === `${step81}`) || {};

      if (railObject["RailTypeId"]) {
        setStep8RodCheck(`${railObject["RailTypeId"]}`);
      }

      if (isRestoreHydrate) {
        if (cartValues["BatonOptionA"]) {
          const batonValue = Array.isArray(cartValues["BatonOptionA"])
            ? cartValues["BatonOptionA"][0]
            : cartValues["BatonOptionA"];
          if (batonValue && step8A4 !== batonValue) {
            setStep8A4(batonValue);
          }
          if (batonValue && step83 !== batonValue) {
            setStep83(batonValue);
          }
        }
        if (cartValues["RailIdA"] && `${step82}` !== `${cartValues["RailIdA"]}`) {
          setStep82(`${cartValues["RailIdA"]}`);
        }
      }

      if (railObject["DesignENName"] && !isRestoreHydrate) {
        let tempExtended = extendedTitle;
        tempExtended["8"][1] = (
          <li key="1" className="step_title_extended_list_item">
            <span className="step_title_extended_list_item_title">{t("Design")}</span>
            <span className="step_title_extended_list_item_text">
              {pageLanguage === "fa"
                ? convertToPersian(railObject["DesignName"])
                : railObject["DesignENName"]}
            </span>
          </li>
        );
        tempExtended["8"].splice(2, 3);
        setExtendedTitle(tempExtended);
      }
      if (!isRestoreHydrate) {
        setCart(
          undefined,
          undefined,
          "RailIdA,RailColorFaA,RailColorEnA,RailIdB,RailColorFaB,RailColorEnB,RailIdC,RailColorFaC,RailColorEnC",
          "RailDesignA,RailDesignFaA,RailDesignEnA,RailDesignB,RailDesignFaB,RailDesignEnB,RailDesignC,RailDesignFaC,RailDesignEnC",
          [
            step81,
            railObject["DesignName"],
            railObject["DesignENName"],
            step81,
            railObject["DesignName"],
            railObject["DesignENName"],
            step81,
            railObject["DesignName"],
            railObject["DesignENName"],
          ]
        );
      }
      if (Object.keys(railObject).length > 0 && rods[railObject["DesignCode"]]) {
        showRodsColor(railObject, "82");
      }
    }
  }, [step81, rails, rods]);

  // After refresh, rails/rods may load after design is restored — set rod type and color list then
  useEffect(() => {
    if (
      rails.length > 0 &&
      Object.keys(rods).length > 0 &&
      step81 !== "" &&
      step8 === "Same Hardware For All Curtains"
    ) {
      let railObject = rails.find((obj) => `${obj["RailId"]}` === `${step81}`) || {};
      if (railObject["RailTypeId"]) {
        setStep8RodCheck(`${railObject["RailTypeId"]}`);
      }
      if (Object.keys(railObject).length > 0 && rods[railObject["DesignCode"]]) {
        showRodsColor(railObject, "82");
      }
    }
  }, [rails, rods, step81, step8]);

  // Step 9.1 rod colors: rails/rods can load after the design is restored from cart
  useEffect(() => {
    if (rails.length > 0 && Object.keys(rods).length > 0 && step8A1 !== "") {
      let railObject = rails.find((obj) => `${obj["RailId"]}` === `${step8A1}`) || {};
      if (Object.keys(railObject).length > 0 && rods[railObject["DesignCode"]]) {
        showRodsColor(railObject, "8A2");
      }
    }
  }, [rails, rods, step8A1, step8A2]);

  // Step 9.2 rod/track colors: rails2/tracks2 can load after the design is restored from cart
  useEffect(() => {
    if ((step8B !== "Rod" && step8B !== "Track") || step8B1 === "") return;
    if (
      !(
        rails2.length > 0 ||
        Object.keys(rods2).length > 0 ||
        rails.length > 0 ||
        Object.keys(tracks2).length > 0 ||
        Object.keys(tracks).length > 0
      )
    ) {
      return;
    }
    const railObject =
      rails2.find((obj) => `${obj["RailId"]}` === `${step8B1}`) ||
      rails.find((obj) => `${obj["RailId"]}` === `${step8B1}`) ||
      {};
    if (railObject["RailTypeId"] && `${step8BRilType}` !== `${railObject["RailTypeId"]}`) {
      setStep8BRilType(`${railObject["RailTypeId"]}`);
    }
    if (step8B === "Track") {
      if (`${railObject["RailTypeId"]}` === "2207" && trackType8B !== 2) {
        setTrackType8B(2);
      } else if (`${railObject["RailTypeId"]}` === "2208" && trackType8B !== 1) {
        setTrackType8B(1);
      } else if (`${railObject["RailTypeId"]}` === "2201" && trackType8B !== undefined) {
        setTrackType8B(undefined);
      }
    }
    const hasColorSource =
      railObject["DesignCode"] &&
      ((rods2 && rods2[railObject["DesignCode"]]) ||
        (rods && rods[railObject["DesignCode"]]) ||
        (tracks2 && tracks2[railObject["DesignCode"]]) ||
        (tracks && tracks[railObject["DesignCode"]]));
    if (Object.keys(railObject).length > 0 && hasColorSource) {
      showRodsColor(railObject, "8B2");
    }

    const restoredTypeId = restoredStep9BTrackRef.current
      ? inferStep9ATrackTypeId(restoredStep9BTrackRef.current, railObject)
      : "";
    if (
      restoredStep9BTrackRef.current &&
      (`${railObject["RailTypeId"]}` === "2207" || restoredTypeId === "2207")
    ) {
      const source = restoredStep9BTrackRef.current;
      const colorId = source["RailIdB"];
      if (colorId && `${step8B2}` !== `${colorId}`) {
        setStep8B2(`${colorId}`);
      }
      const controlSide = parseStep9AControlSide(source["ControlPositionB"]);
      if (controlSide && step8B3 !== controlSide) {
        setStep8B3(controlSide);
      }
      const colorLabel = pageLanguage === "fa" ? source["RailColorFaB"] : source["RailColorEnB"];
      if (colorLabel || controlSide) {
        setExtendedTitle((prev) => {
          const next = { ...prev };
          const list = [...(next["8B"] || [])];
          if (colorLabel && !list[2]) {
            list[2] = (
              <li key="2" className="step_title_extended_list_item">
                <span className="step_title_extended_list_item_title">{t("Finish")}</span>
                <span className="step_title_extended_list_item_text">{colorLabel}</span>
              </li>
            );
          }
          if (controlSide && !list[3]) {
            list[3] = (
              <li key="3" className="step_title_extended_list_item">
                <span className="step_title_extended_list_item_title">{t("Control Position")}</span>
                <span className="step_title_extended_list_item_text">{t(controlSide)}</span>
              </li>
            );
          }
          next["8B"] = list;
          return next;
        });
      }
      if (hasColorSource) {
        const timer = setTimeout(() => {
          restoredStep9BTrackRef.current = null;
        }, 600);
        return () => clearTimeout(timer);
      }
    } else if (
      restoredStep9BTrackRef.current &&
      (`${railObject["RailTypeId"]}` === "2208" || restoredTypeId === "2208")
    ) {
      applyStep9BElectricRestoreFromCart(restoredStep9BTrackRef.current);
      const timer = setTimeout(() => {
        restoredStep9BTrackRef.current = null;
      }, 600);
      return () => clearTimeout(timer);
    }
  }, [rails2, rods2, rails, rods, tracks2, tracks, step8B, step8B1, step8B2]);

  // Step 9.3 rod/track colors: rails3/rods3 can load after the design is restored from cart
  useEffect(() => {
    if ((step8C !== "Rod" && step8C !== "Track") || step8C1 === "") return;
    if (!(rails3.length > 0 || Object.keys(rods3).length > 0 || Object.keys(tracks3).length > 0)) {
      return;
    }
    const railObject = rails3.find((obj) => `${obj["RailId"]}` === `${step8C1}`) || {};
    if (railObject["RailTypeId"] && `${step8CTrack}` !== `${railObject["RailTypeId"]}`) {
      setStep8CTrack(`${railObject["RailTypeId"]}`);
    }
    if (step8C === "Track") {
      if (`${railObject["RailTypeId"]}` === "2207" && trackType8C !== 2) {
        setTrackType8C(2);
      } else if (`${railObject["RailTypeId"]}` === "2208" && trackType8C !== 1) {
        setTrackType8C(1);
      } else if (`${railObject["RailTypeId"]}` === "2201" && trackType8C !== undefined) {
        setTrackType8C(undefined);
      }
    } else if (step8C === "Rod" && trackType8C !== undefined) {
      setTrackType8C(undefined);
    }
    const hasColorSource =
      railObject["DesignCode"] &&
      ((rods3 && rods3[railObject["DesignCode"]]) ||
        (tracks3 && tracks3[railObject["DesignCode"]]));
    if (Object.keys(railObject).length > 0 && hasColorSource) {
      showRodsColor(railObject, "8C2");
    }

    if (
      restoredStep9CTrackRef.current &&
      (`${railObject["RailTypeId"]}` === "2208" ||
        restoredStep9CTrackRef.current["hasPowerC"] ||
        restoredStep9CTrackRef.current["MotorPositionC"] ||
        restoredStep9CTrackRef.current["RemoteNameC"])
    ) {
      applyStep9CElectricRestoreFromCart(restoredStep9CTrackRef.current);
      const timer = setTimeout(() => {
        restoredStep9CTrackRef.current = null;
      }, 600);
      return () => clearTimeout(timer);
    }

    if (
      restoredStep9CTrackRef.current &&
      (`${railObject["RailTypeId"]}` === "2207" ||
        parseStep9AControlSide(restoredStep9CTrackRef.current["ControlPositionC"]))
    ) {
      const source = restoredStep9CTrackRef.current;
      const colorId = source["RailIdC"];
      if (colorId && `${step8C2}` !== `${colorId}`) {
        setStep8C2(`${colorId}`);
      }
      const controlSide = parseStep9AControlSide(source["ControlPositionC"]);
      if (controlSide && step8C3 !== controlSide) {
        setStep8C3(controlSide);
      }
      const colorLabel = pageLanguage === "fa" ? source["RailColorFaC"] : source["RailColorEnC"];
      if (colorLabel || controlSide) {
        setExtendedTitle((prev) => {
          const next = { ...prev };
          const list = [...(next["8C"] || [])];
          if (colorLabel && !list[2]) {
            list[2] = (
              <li key="2" className="step_title_extended_list_item">
                <span className="step_title_extended_list_item_title">{t("Finish")}</span>
                <span className="step_title_extended_list_item_text">{colorLabel}</span>
              </li>
            );
          }
          if (controlSide) {
            list[3] = (
              <li key="3" className="step_title_extended_list_item">
                <span className="step_title_extended_list_item_title">{t("Control Position")}</span>
                <span className="step_title_extended_list_item_text">{t(controlSide)}</span>
              </li>
            );
          }
          next["8C"] = list;
          return next;
        });
      }
      if (hasColorSource) {
        const timer = setTimeout(() => {
          restoredStep9CTrackRef.current = null;
        }, 600);
        return () => clearTimeout(timer);
      }
    }
  }, [rails3, rods3, tracks3, step8C, step8C1, step8C2]);

  // Step 9.1 track: rails2/tracks2 can load after design/color/baton are restored from cart
  useEffect(() => {
    if (!restoredStep9ATrackRef.current) return;
    if (step9ADrapery !== "Track") return;
    if (!(rails2.length > 0 || Object.keys(tracks2).length > 0 || Object.keys(tracks).length > 0)) {
      return;
    }
    applyStep9ATrackRestoreFromCart(restoredStep9ATrackRef.current);
    const savedDesignId =
      restoredStep9ATrackRef.current["RailDesignB"] ||
      restoredStep9ATrackRef.current["RailDesignA"] ||
      stepTrackCollections9A;
    const railObject = findRailByIdAny(savedDesignId);
    const typeId = inferStep9ATrackTypeId(restoredStep9ATrackRef.current, railObject);
    const hasColorSource =
      railObject["DesignCode"] &&
      ((tracks2 && tracks2[railObject["DesignCode"]]) ||
        (tracks && tracks[railObject["DesignCode"]]));
    if (hasColorSource || typeId === "2208") {
      const timer = setTimeout(() => {
        restoredStep9ATrackRef.current = null;
      }, 600);
      return () => clearTimeout(timer);
    }
  }, [rails2, tracks2, tracks, rails, step9ADrapery, stepTrackCollections9A, stepHardware9A]);

  useEffect(() => {
    if (
      rails2.length > 0 &&
      step8D1 !== "" &&
      step8 === "Same Hardware For All Curtains" &&
      step6CHead9 === "Track"
    ) {
      let railObject =
        rails2.find((obj) => `${obj["RailId"]}` === `${step8D1}`) ||
        rails3.find((obj) => `${obj["RailId"]}` === `${step8D1}`) ||
        {};
      if (railObject["RailTypeId"]) {
        setStep8DTrack(`${railObject["RailTypeId"]}`);
      }
      if (Object.keys(railObject).length > 0) {
        showRodsColor(railObject, "8D2");
      }
      if (`${railObject["RailTypeId"]}` === "2208" && restoredTrackMotorRef.current) {
        applyElectricTrackRestoreFromCart(restoredTrackMotorRef.current);
      }
      if (`${railObject["RailTypeId"]}` === "2207" && restoredTrackControlRef.current) {
        const controlSide = restoredTrackControlRef.current;
        if (step8B4 !== controlSide) {
          setStep8B4(controlSide);
        }
        setExtendedTitle((prev) => {
          const next = { ...prev };
          const list = [...(next["8"] || [])];
          list[3] = (
            <li key="3" className="step_title_extended_list_item">
              <span className="step_title_extended_list_item_title">{t("Control Position")}</span>
              <span className="step_title_extended_list_item_text">{t(controlSide)}</span>
            </li>
          );
          next["8"] = list;
          return next;
        });
      }
    }
  }, [rails2, rails3, tracks2, tracks3, step8D1, step8D2, step8, step6CHead9]);

  useEffect(() => {
    if (step8D1 !== "" && !pageLoad) {
      const restoredTrackDesign =
        cartValues["RailDesignB"] || cartValues["RailDesignA"] || cartValues["RailDesignC"];
      const isRestoreHydrate =
        skipHardwareTypeCartWipeRef.current ||
        (step8 === "Same Hardware For All Curtains" &&
          restoredTrackDesign !== undefined &&
          `${restoredTrackDesign}` === `${step8D1}` &&
          (cartValues["DraperyHardware"] === "Track" ||
            (cartValues["RailDesignB"] !== undefined && cartValues["RailDesignA"] === undefined)));

      if (!isRestoreHydrate) {
        setStep8B2("");
        setStep8B3("");
        setStep8B5("");
        setStep8B4("");
        setStep8D2("");
      }
      let railObject = {};
      railObject =
        rails2.filter((obj) => {
          return obj["RailId"] === step8D1;
        })[0] || railObject;
      if (Object.keys(railObject).length === 0) {
        railObject = rails2.find((obj) => `${obj["RailId"]}` === `${step8D1}`) || railObject;
      }
      if (railObject["DesignENName"] && !isRestoreHydrate) {
        let tempExtended = extendedTitle;
        tempExtended["8"][1] = (
          <li key="6" className="step_title_extended_list_item">
            <span className="step_title_extended_list_item_title">{t("Design")}</span>
            <span className="step_title_extended_list_item_text">
              {pageLanguage === "fa"
                ? convertToPersian(railObject["DesignName"])
                : railObject["DesignENName"]}
            </span>
          </li>
        );
        tempExtended["8"].splice(2, 3);
        setExtendedTitle(tempExtended);
      }
      if (railObject["RailTypeId"] === 2208) {
        if (parseInt(widthCart) > 600 && !isRestoreHydrate) {
          modalHandleShow("width600cm");
        }
        setTrackType8B(1);
        if (step2B === "None") {
          setDeps("8A,8B", "8A1,8A2,8A3,8C3,811,801,810,8C,86");
        } else {
          setDeps("8A,8B,8C", "8A1,8A2,8A3,8C3,811,801,810");
        }

        if (!isRestoreHydrate) {
          setCart(
            "RailDesignB",
            step8D1,
            "RailIdB,RailColorFaB,RailColorEnB",
            "RailDesignFaB,RailDesignEnB",
            [railObject["DesignName"], railObject["DesignENName"]]
          );
        } else {
          applyElectricTrackRestoreFromCart(restoredTrackMotorRef.current || cartValues);
        }
      } else if (railObject["RailTypeId"] === 2207) {
        setTrackType8B(2);
        if (!isRestoreHydrate) {
          setStep8B6("");
          setCart(
            "RailDesignB",
            step8D1,
            "RailIdB,RailColorFaB,RailColorEnB",
            "RailDesignFaB,RailDesignEnB",
            [railObject["DesignName"], railObject["DesignENName"]]
          );
          setDeps("8A2,8C3", "8A,8A1,8B,8B1,8B2,8A3,8P5,8P6,8C5,8C,811,801,810");
        }
        showRodsColor(railObject, "8D2");
        if (isRestoreHydrate) {
          const colorId = cartValues["RailIdC"] || cartValues["RailIdA"] || cartValues["RailIdB"];
          if (colorId && `${step8D2}` !== `${colorId}`) {
            setStep8D2(`${colorId}`);
          }
          const controlPos =
            restoredTrackControlRef.current ||
            cartValues["ControlPositionB"] ||
            cartValues["ControlPositionA"] ||
            cartValues["ControlPositionC"];
          if (controlPos) {
            const controlSide = restoredTrackControlRef.current
              ? restoredTrackControlRef.current
              : `${controlPos}`.toLowerCase().includes("left")
              ? "Left"
              : "Right";
            if (step8B4 !== controlSide) {
              setStep8B4(controlSide);
            }
          }
          if (railObject["RailTypeId"]) {
            setStep8DTrack(`${railObject["RailTypeId"]}`);
          }
        }
      } else {
        if (!isRestoreHydrate) {
          setStep8B6("");
          setStep83("");
          setCart(
            "RailDesignB",
            step8D1,
            "RailIdB,RailColorFaB,RailColorEnB",
            "RailDesignFaB,RailDesignEnB",
            [railObject["DesignName"], railObject["DesignENName"]]
          );
          setDeps("8A2,8A3", "85,86,87,8A,8A1,8B,8B1,8B2,8C,8P5,8P6,8C5,8C3,811,801,810");
        }
        setTrackType8B(undefined);
        showRodsColor(railObject, "8D2");
        if (isRestoreHydrate) {
          const colorId = cartValues["RailIdC"] || cartValues["RailIdA"] || cartValues["RailIdB"];
          if (colorId && `${step8D2}` !== `${colorId}`) {
            setStep8D2(`${colorId}`);
          }
          if (restoredTrackControlRef.current) {
            if (step8B4 !== restoredTrackControlRef.current) {
              setStep8B4(restoredTrackControlRef.current);
            }
            setStep8DTrack("2207");
            setTrackType8B(2);
          } else if (cartValues["BatonOptionA"]) {
            const batonValue = Array.isArray(cartValues["BatonOptionA"])
              ? cartValues["BatonOptionA"][0]
              : cartValues["BatonOptionA"];
            if (batonValue && step83 !== batonValue) {
              setStep83(batonValue);
            }
          }
          if (railObject["RailTypeId"]) {
            setStep8DTrack(`${railObject["RailTypeId"]}`);
          }
        }
      }
    }
  }, [step8D1]);

  useEffect(() => {
    if (step8D2 !== "" && !pageLoad) {
      const restoredColorId =
        cartValues["RailIdC"] || cartValues["RailIdA"] || cartValues["RailIdB"];
      const isRestoreHydrate =
        step8 === "Same Hardware For All Curtains" &&
        restoredColorId !== undefined &&
        `${restoredColorId}` === `${step8D2}`;

      if (!isRestoreHydrate) {
        if (step8 === "Same Hardware For All Curtains") {
          setDeps("", "8,8A,8A1,8A2,8B,8B1,8B2,8C,8C1,8C2");
        } else {
          setDeps("", "8D2", 1);
        }
      }

      let railObject = {};
      railObject =
        rails3.filter((obj) => {
          return obj["RailId"] === step8D1;
        })[0] || railObject;

      let railObject2 = {};
      railObject2 =
        rails3.filter((obj) => {
          return obj["RailId"] === step8D2;
        })[0] || railObject2;

      if (railObject["DesignENName"] && railObject2["ColorName"] && railObject2["ColorEnName"]) {
        let tempExtended = extendedTitle;
        tempExtended["8"][2] = (
          <li key="2" className="step_title_extended_list_item">
            <span className="step_title_extended_list_item_title">{t("Finish")}</span>
            <span className="step_title_extended_list_item_text">
              {pageLanguage === "fa"
                ? convertToPersian(railObject2["ColorName"])
                : railObject2["ColorEnName"]}
            </span>
          </li>
        );
        setExtendedTitle(tempExtended);
      }
      if (!isRestoreHydrate) {
        // "Same Hardware For All Curtains" (track): apply the selected rail/color to all
        // three panels (A/B/C) so index 0 (RailIdA) and index 1 (RailIdB) also get a RailId
        setCart(
          undefined,
          undefined,
          "",
          "RailIdA,RailColorFaA,RailColorEnA,RailIdB,RailColorFaB,RailColorEnB,RailIdC,RailColorFaC,RailColorEnC",
          [
            step8D2,
            railObject2["ColorName"],
            railObject2["ColorEnName"],
            step8D2,
            railObject2["ColorName"],
            railObject2["ColorEnName"],
            step8D2,
            railObject2["ColorName"],
            railObject2["ColorEnName"],
          ]
        );
      }
      showRodsColor(railObject, "8D2");
    }
  }, [step8D2]);

  useEffect(() => {
    if (step82 !== "" && !pageLoad) {
      if (step8 === "Same Hardware For All Curtains") {
        setDeps("", "812", 1);
      } else {
        setDeps("", "82");
      }

      let railObject = {};
      railObject =
        rails.filter((obj) => {
          return obj["RailId"] === step81;
        })[0] || railObject;

      let railObject2 = {};
      railObject2 =
        rails.filter((obj) => {
          return obj["RailId"] === step82;
        })[0] || railObject2;

      if (railObject["DesignENName"] && railObject2["ColorName"] && railObject2["ColorEnName"]) {
        let tempExtended = extendedTitle;
        tempExtended["8"][2] = (
          <li key="2" className="step_title_extended_list_item">
            <span className="step_title_extended_list_item_title">{t("Finish")}</span>
            <span className="step_title_extended_list_item_text">
              {pageLanguage === "fa"
                ? convertToPersian(railObject2["ColorName"])
                : railObject2["ColorEnName"]}
            </span>
          </li>
        );
        setExtendedTitle(tempExtended);
      }
      setCart(
        undefined,
        undefined,
        "",
        "RailIdA,RailColorFaA,RailColorEnA,RailIdB,RailColorFaB,RailColorEnB,RailIdC,RailColorFaC,RailColorEnC",
        [
          step82,
          railObject2["ColorName"],
          railObject2["ColorEnName"],
          step82,
          railObject2["ColorName"],
          railObject2["ColorEnName"],
          step82,
          railObject2["ColorName"],
          railObject2["ColorEnName"],
        ]
      );
      showRodsColor(railObject, "82");
    }
  }, [step82]);

  useEffect(() => {
    if (stepHardware9A !== "" && !pageLoad) {
      const isRestoreHydrate = !!restoredStep9ATrackRef.current;
      if (!isRestoreHydrate) {
        setStep8B2("");
        setStep8B3("");
        setStep8B5("");
      }
      let railObject = rails2.find((obj) => `${obj["RailId"]}` === `${stepHardware9A}`) || {};

      let railObject2 = rails.find((obj) => `${obj["RailId"]}` === `${stepHardware9A}`) || {};

      if (railObject["DesignENName"] && !isRestoreHydrate) {
        let tempExtended = extendedTitle;
        setNameColorEnDraperyTrack(railObject2["ColorEnName"]);
        setNameColorFaDraperyTrack(railObject2["ColorName"]);
        setNameColorEnDraperyTrack9a(railObject["ColorEnName"]);
        setNameColorFaDraperyTrack9a(railObject["ColorName"]);

        tempExtended["8A"][2] = (
          <li key="2" className="step_title_extended_list_item">
            <span className="step_title_extended_list_item_title">{t("Finish")}</span>
            <span className="step_title_extended_list_item_text">
              {pageLanguage === "fa"
                ? convertToPersian(railObject["ColorName"])
                : railObject["ColorEnName"]}
            </span>
          </li>
        );
        setExtendedTitle(tempExtended);
      }

      if (railObject["RailTypeId"] === 2208) {
        if (parseInt(widthCart) > 600) {
          modalHandleShow("width600cm");
        }
        setTrackType8B(1);

        if (!isRestoreHydrate) {
          setCart(
            "RailDesignB",
            stepTrackCollections9A,
            "RailIdB,RailColorFaB,RailColorEnB",
            "RailDesignFaB,RailDesignEnB",
            [railObject["DesignName"], railObject["DesignENName"]]
          );
        }
      } else if (railObject["RailTypeId"] === 2207) {
        setTrackType8B(undefined);
        if (!isRestoreHydrate) {
          setCart(
            "RailDesignB",
            stepTrackCollections9A,
            "RailIdB,RailColorFaB,RailColorEnB",
            "RailDesignFaB,RailDesignEnB",
            [railObject["DesignName"], railObject["DesignENName"]]
          );
          setDeps("", "8B1,842");
        }
        showRodsColor(railObject, "8H3");
      } else {
        setTrackType8B(undefined);
        if (!isRestoreHydrate) {
          setCart(
            "RailDesignB",
            stepTrackCollections9A,
            "RailIdB,RailColorFaB,RailColorEnB",
            "RailDesignFaB,RailDesignEnB",
            [railObject["DesignName"], railObject["DesignENName"]]
          );
          setDeps("", "8B1,842");
        }
        showRodsColor(railObject, "8H1");
      }
    }
  }, [stepHardware9A]);

  useEffect(() => {
    if (step8A1 !== "" && !pageLoad) {
      const isRestoreHydrate =
        cartValues["RailDesignA"] !== undefined &&
        `${cartValues["RailDesignA"]}` === `${step8A1}` &&
        (step8 === "I Want To Customize Hardware Per Curtain" ||
          cartValues["DraperyHardware"] === "Rod");

      if (!isRestoreHydrate) {
        setDeps("842,843", "8A,84");
        setStep8A2("");
        setStep8A3("");
      }
      let railObject = rails.find((obj) => `${obj["RailId"]}` === `${step8A1}`) || {};

      if (isRestoreHydrate) {
        if (cartValues["RailIdA"] && `${step8A2}` !== `${cartValues["RailIdA"]}`) {
          setStep8A2(`${cartValues["RailIdA"]}`);
        }
        if (cartValues["BatonOptionA"]) {
          const batonValue = Array.isArray(cartValues["BatonOptionA"])
            ? cartValues["BatonOptionA"][0]
            : cartValues["BatonOptionA"];
          if (batonValue && step8A3 !== batonValue) {
            setStep8A3(batonValue);
          }
        }
      }

      if (railObject["DesignENName"] && !isRestoreHydrate) {
        let tempExtended = extendedTitle;
        tempExtended["8A"][1] = (
          <li key="1" className="step_title_extended_list_item">
            <span className="step_title_extended_list_item_title">{t("Design")}</span>
            <span className="step_title_extended_list_item_text">
              {pageLanguage === "fa"
                ? convertToPersian(railObject["DesignName"])
                : railObject["DesignENName"]}
            </span>
          </li>
        );
        tempExtended["8A"].splice(2, 3);
        setExtendedTitle(tempExtended);
      }
      if (!isRestoreHydrate) {
        setCart(
          "RailDesignA",
          step8A1,
          "RailIdA,RailColorFaA,RailColorEnA",
          "RailDesignFaA,RailDesignEnA",
          [railObject["DesignName"], railObject["DesignENName"]]
        );
      }
      if (Object.keys(railObject).length > 0) {
        showRodsColor(railObject, "8A2");
      }
    }
  }, [step8A1]);

  useEffect(() => {
    if (step8A2 !== "" && !pageLoad) {
      const isRestoreHydrate =
        cartValues["RailIdA"] !== undefined && `${cartValues["RailIdA"]}` === `${step8A2}`;

      if (!isRestoreHydrate) {
        setDeps("", "8A1,842", 1);
      }
      let railObject = rails.find((obj) => `${obj["RailId"]}` === `${step8A1}`) || {};
      let railObject2 = rails.find((obj) => `${obj["RailId"]}` === `${step8A2}`) || {};

      if (railObject["DesignENName"] && railObject2["ColorName"] && railObject2["ColorEnName"]) {
        let tempExtended = extendedTitle;

        tempExtended["8A"][2] = (
          <li key="2" className="step_title_extended_list_item">
            <span className="step_title_extended_list_item_title">{t("Finish")}</span>
            <span className="step_title_extended_list_item_text">
              {pageLanguage === "fa"
                ? convertToPersian(railObject2["ColorName"])
                : railObject2["ColorEnName"]}
            </span>
          </li>
        );
        setExtendedTitle(tempExtended);
      }
      if (!isRestoreHydrate) {
        setCart("RailIdA", step8A2, "", "RailColorFaA,RailColorEnA", [
          railObject2["ColorName"],
          railObject2["ColorEnName"],
        ]);
      }
      if (Object.keys(railObject).length > 0) {
        showRodsColor(railObject, "8A2");
      }
    }
  }, [step8A2]);

  useEffect(() => {
    if (step8B1 !== "" && !pageLoad) {
      const isRestoreHydrate =
        (cartValues["SheerHardware"] === "Rod" || cartValues["SheerHardware"] === "Track") &&
        cartValues["RailDesignB"] !== undefined &&
        `${cartValues["RailDesignB"]}` === `${step8B1}`;

      if (!isRestoreHydrate) {
        setStep8B2("");
        setStep8B3("");
        setStep8B5("");
      }
      let railObject =
        rails2.find((obj) => `${obj["RailId"]}` === `${step8B1}`) ||
        rails.find((obj) => `${obj["RailId"]}` === `${step8B1}`) ||
        {};

      if (railObject["RailTypeId"] && `${step8BRilType}` !== `${railObject["RailTypeId"]}`) {
        setStep8BRilType(`${railObject["RailTypeId"]}`);
      }

      if (railObject["DesignENName"] && !isRestoreHydrate) {
        let tempExtended = extendedTitle;
        tempExtended["8B"][1] = (
          <li key="1" className="step_title_extended_list_item">
            <span className="step_title_extended_list_item_title">{t("Design")}</span>
            <span className="step_title_extended_list_item_text">
              {pageLanguage === "fa"
                ? convertToPersian(railObject["DesignName"])
                : railObject["DesignENName"]}
            </span>
          </li>
        );
        tempExtended["8B"].splice(2, 3);
        setExtendedTitle(tempExtended);
      }

      if (railObject["RailTypeId"] === 2208) {
        if (parseInt(widthCart) > 600) {
          modalHandleShow("width600cm");
        }
        setTrackType8B(1);
        if (!isRestoreHydrate) {
          setDeps("86", "849,850,852,853,854,855,856,857");
          setCart(
            "RailDesignB",
            step8B1,
            "RailIdB,RailColorFaB,RailColorEnB",
            "RailDesignFaB,RailDesignEnB",
            [railObject["DesignName"], railObject["DesignENName"]]
          );
        }
      } else if (railObject["RailTypeId"] === 2207) {
        setTrackType8B(2);
        if (!isRestoreHydrate) {
          setCart(
            "RailDesignB",
            step8B1,
            "RailIdB,RailColorFaB,RailColorEnB",
            "RailDesignFaB,RailDesignEnB",
            [railObject["DesignName"], railObject["DesignENName"]]
          );
          setDeps("854,850", "8B,8A,849,86,853,852,855,856,857");
        }
        showRodsColor(railObject, "8B2");
        showRodsColor(railObject, "8H3");
      } else if (Object.keys(railObject).length > 0) {
        setTrackType8B(undefined);
        if (!isRestoreHydrate) {
          setCart(
            "RailDesignB",
            step8B1,
            "RailIdB,RailColorFaB,RailColorEnB",
            "RailDesignFaB,RailDesignEnB",
            [railObject["DesignName"], railObject["DesignENName"]]
          );
          if (step8B === "Rod") {
            setDeps("850,852", "8B,8A,849,86,853,854,855,856,857");
          } else {
            setDeps("850,853", "8B,8A,849,86,852,854,855,856,857");
          }
        }
        showRodsColor(railObject, "8B2");
      }
    }
  }, [step8B1]);

  useEffect(() => {
    if (stepTrackCollections9A !== "" && !pageLoad) {
      const isRestoreHydrate = !!restoredStep9ATrackRef.current;
      if (!isRestoreHydrate) {
        setStep8B2("");
        setStep8B3("");
        setStep8B5("");
      }
      let railObject =
        rails2.find((obj) => `${obj["RailId"]}` === `${stepTrackCollections9A}`) || {};

      if (railObject["DesignENName"] && !isRestoreHydrate) {
        let tempExtended = extendedTitle;
        setNameEnDraperyTrack(railObject["DesignENName"]);
        setNameFaDraperyTrack(railObject["DesignName"]);
        tempExtended["8A"][1] = (
          <li key="1" className="step_title_extended_list_item">
            <span className="step_title_extended_list_item_title">{t("Design")}</span>
            <span className="step_title_extended_list_item_text">
              {pageLanguage === "fa"
                ? convertToPersian(railObject["DesignName"])
                : railObject["DesignENName"]}
            </span>
          </li>
        );
        tempExtended["8A"].splice(2, 3);
        setExtendedTitle(tempExtended);
      }

      if (railObject["RailTypeId"] === 2208) {
        setDeps("85", "8A2,8A3,842,844,8A1,8A2,8A3,8C3,86,87,84,848");
        if (parseInt(widthCart) > 600) {
          modalHandleShow("width600cm");
        }
        setTrackType8B(1);

        if (!isRestoreHydrate) {
          setCart(
            "RailDesignB",
            stepTrackCollections9A,
            "RailIdB,RailColorFaB,RailColorEnB",
            "RailDesignFaB,RailDesignEnB",
            [railObject["DesignName"], railObject["DesignENName"]]
          );
        }
      } else if (railObject["RailTypeId"] === 2207) {
        setTrackType8B(2);
        if (!isRestoreHydrate) {
          setCart(
            "RailDesignB",
            stepTrackCollections9A,
            "RailIdB,RailColorFaB,RailColorEnB",
            "RailDesignFaB,RailDesignEnB",
            [railObject["DesignName"], railObject["DesignENName"]]
          );
          setDeps("8A2,8A3,842,848", "85,8A,84,845,846,847,844");
        }
        showRodsColor(railObject, "8B2");
        showRodsColor(railObject, "8H3");
      } else {
        setTrackType8B(undefined);
        if (!isRestoreHydrate) {
          setCart(
            "RailDesignB",
            stepTrackCollections9A,
            "RailIdB,RailColorFaB,RailColorEnB",
            "RailDesignFaB,RailDesignEnB",
            [railObject["DesignName"], railObject["DesignENName"]]
          );
          setDeps("842,844", "8A,8A2,8A3,84,85,845,846,847,848");
        }
        showRodsColor(railObject, "8H1");
      }
    }
  }, [stepTrackCollections9A]);

  useEffect(() => {
    if (step8B2 !== "" && !pageLoad) {
      const isRestoreHydrate =
        (cartValues["SheerHardware"] === "Rod" || cartValues["SheerHardware"] === "Track") &&
        cartValues["RailIdB"] !== undefined &&
        `${cartValues["RailIdB"]}` === `${step8B2}`;

      if (!isRestoreHydrate) {
        setDeps("", "8B2,850", 1);
      }
      let railObject =
        rails2.find((obj) => `${obj["RailId"]}` === `${step8B1}`) ||
        rails.find((obj) => `${obj["RailId"]}` === `${step8B1}`) ||
        {};

      let railObject2 =
        rails2.find((obj) => `${obj["RailId"]}` === `${step8B2}`) ||
        rails.find((obj) => `${obj["RailId"]}` === `${step8B2}`) ||
        {};
      if (!Object.keys(railObject2).length && railObject["DesignCode"]) {
        const colorPool =
          (tracks2 && tracks2[railObject["DesignCode"]]) ||
          (tracks && tracks[railObject["DesignCode"]]) ||
          (rods2 && rods2[railObject["DesignCode"]]) ||
          (rods && rods[railObject["DesignCode"]]) ||
          [];
        railObject2 = colorPool.find((obj) => `${obj["RailId"]}` === `${step8B2}`) || {};
      }

      if (railObject["DesignENName"] && railObject2["ColorName"] && railObject2["ColorEnName"]) {
        let tempExtended = extendedTitle;
        tempExtended["8B"][2] = (
          <li key="2" className="step_title_extended_list_item">
            <span className="step_title_extended_list_item_title">{t("Finish")}</span>
            <span className="step_title_extended_list_item_text">
              {pageLanguage === "fa"
                ? convertToPersian(railObject2["ColorName"])
                : railObject2["ColorEnName"]}
            </span>
          </li>
        );
        setExtendedTitle(tempExtended);
      }
      if (!isRestoreHydrate || (railObject2["ColorName"] && railObject2["ColorEnName"])) {
        setCart("RailIdB", step8B2, "", "RailColorFaB,RailColorEnB", [
          railObject2["ColorName"],
          railObject2["ColorEnName"],
        ]);
      }
      showRodsColor(railObject, "8B2");

      showRodsColor(railObject, "8H3");
    }
  }, [step8B2]);

  useEffect(() => {
    if (step8C1 !== "" && !pageLoad) {
      const isRestoreHydrate =
        (cartValues["PrivacyLayerHardware"] === "Rod" ||
          cartValues["PrivacyLayerHardware"] === "Track") &&
        cartValues["RailDesignC"] !== undefined &&
        `${cartValues["RailDesignC"]}` === `${step8C1}`;

      if (!isRestoreHydrate) {
        setStep8C2("");
        setStep8C3("");
        setStep8C5("");
      }

      let railObject = rails3.find((obj) => `${obj["RailId"]}` === `${step8C1}`) || {};

      if (railObject["RailTypeId"] && `${step8CTrack}` !== `${railObject["RailTypeId"]}`) {
        setStep8CTrack(`${railObject["RailTypeId"]}`);
      }

      if (railObject["DesignENName"] && !isRestoreHydrate) {
        let tempExtended = extendedTitle;
        tempExtended["8C"][1] = (
          <li key="1" className="step_title_extended_list_item">
            <span className="step_title_extended_list_item_title">{t("Design")}</span>
            <span className="step_title_extended_list_item_text">
              {pageLanguage === "fa"
                ? convertToPersian(railObject["DesignName"])
                : railObject["DesignENName"]}
            </span>
          </li>
        );
        tempExtended["8C"].splice(2, 3);
        setExtendedTitle(tempExtended);
      }

      if (railObject["RailTypeId"] === 2208) {
        if (parseInt(widthCart) > 600 && !isRestoreHydrate) {
          modalHandleShow("width600cm");
        }
        setTrackType8C(1);
        if (!isRestoreHydrate) {
          setCart(
            "RailDesignC",
            step8C1,
            "RailIdC,RailColorFaC,RailColorEnC",
            "RailDesignFaC,RailDesignEnC",
            [railObject["DesignName"], railObject["DesignENName"]]
          );
          setDeps("87", "8C1,8C2,8C3,858,859,860,861,862,863,864,865");
        }
      } else if (railObject["RailTypeId"] === 2207) {
        setTrackType8C(2);
        if (!isRestoreHydrate) {
          setCart(
            "RailDesignC",
            step8C1,
            "RailIdC,RailColorFaC,RailColorEnC",
            "RailDesignFaC,RailDesignEnC,hasPowerC,MotorPositionC,RemoteNameC,MotorChannelsC",
            [railObject["DesignName"], railObject["DesignENName"]]
          );
          setDeps("859,862", "8C1,8C5,8C51,8C52,87,,858,860,861,863,864,865");
        }
        showRodsColor(railObject, "8C2");
      } else if (Object.keys(railObject).length > 0) {
        setTrackType8C(undefined);
        if (!isRestoreHydrate) {
          setCart(
            "RailDesignC",
            step8C1,
            "RailIdC,RailColorFaC,RailColorEnC",
            "RailDesignFaC,RailDesignEnC,hasPowerC,MotorPositionC,RemoteNameC,MotorChannelsC",
            [railObject["DesignName"], railObject["DesignENName"]]
          );
          if (step8C === "Rod") {
            setDeps("859,860", "8C1,8C5,8C51,8C52,858,87,,858,861,862,863,864,865");
          } else {
            setDeps("859,861", "8C1,8C5,8C51,8C52,858,87,858,860,862,863,864,865");
          }
        }
        showRodsColor(railObject, "8C2");
      }
    }
  }, [step8C1]);

  useEffect(() => {
    if (step8C2 !== "" && !pageLoad) {
      const isRestoreHydrate =
        (cartValues["PrivacyLayerHardware"] === "Rod" ||
          cartValues["PrivacyLayerHardware"] === "Track") &&
        cartValues["RailIdC"] !== undefined &&
        `${cartValues["RailIdC"]}` === `${step8C2}`;

      if (!isRestoreHydrate) {
        setDeps("", "8C2,859", 1);
      }
      let railObject = rails3.find((obj) => `${obj["RailId"]}` === `${step8C1}`) || {};

      let railObject2 = rails3.find((obj) => `${obj["RailId"]}` === `${step8C2}`) || {};
      if (!Object.keys(railObject2).length && railObject["DesignCode"]) {
        const colorPool =
          (rods3 && rods3[railObject["DesignCode"]]) ||
          (tracks3 && tracks3[railObject["DesignCode"]]) ||
          [];
        railObject2 = colorPool.find((obj) => `${obj["RailId"]}` === `${step8C2}`) || {};
      }

      if (railObject["DesignENName"] && railObject2["ColorName"] && railObject2["ColorEnName"]) {
        let tempExtended = extendedTitle;
        tempExtended["8C"][2] = (
          <li key="2" className="step_title_extended_list_item">
            <span className="step_title_extended_list_item_title">{t("Finish")}</span>
            <span className="step_title_extended_list_item_text">
              {pageLanguage === "fa"
                ? convertToPersian(railObject2["ColorName"])
                : railObject2["ColorEnName"]}
            </span>
          </li>
        );
        setExtendedTitle(tempExtended);
      }
      if (!isRestoreHydrate || (railObject2["ColorName"] && railObject2["ColorEnName"])) {
        setCart("RailIdC", step8C2, "", "RailColorFaC,RailColorEnC", [
          railObject2["ColorName"],
          railObject2["ColorEnName"],
        ]);
      }
      showRodsColor(railObject, "8C2");
    }
  }, [step8C2]);

  useEffect(() => {
    setTimeout(() => {
      let tempExtended = extendedTitle;
      if (rails.length && step81 !== "") {
        let railObject = {};
        railObject =
          rails.filter((obj) => {
            return obj["RailId"] === step81;
          })[0] || railObject;

        if (railObject["DesignENName"]) {
          tempExtended["8"][1] = (
            <li key="1" className="step_title_extended_list_item">
              <span className="step_title_extended_list_item_title">{t("Design")}</span>
              <span className="step_title_extended_list_item_text">
                {pageLanguage === "fa"
                  ? convertToPersian(railObject["DesignName"])
                  : railObject["DesignENName"]}
              </span>
            </li>
          );
          tempExtended["8"].splice(2, 3);
        }
        let railObject2 = {};
        railObject2 =
          rails.filter((obj) => {
            return obj["RailId"] === step82;
          })[0] || railObject2;

        if (railObject["DesignENName"] && railObject2["ColorName"] && railObject2["ColorEnName"]) {
          tempExtended["8"][2] = (
            <li key="2" className="step_title_extended_list_item">
              <span className="step_title_extended_list_item_title">{t("Finish")}</span>
              <span className="step_title_extended_list_item_text">
                {pageLanguage === "fa"
                  ? convertToPersian(railObject2["ColorName"])
                  : railObject2["ColorEnName"]}
              </span>
            </li>
          );
        }
        showRodsColor(railObject, "82");
      }

      if (rails.length && step8A1 !== "") {
        let railObject = rails.find((obj) => `${obj["RailId"]}` === `${step8A1}`) || {};
        const isRestoreHydrate =
          cartValues["RailDesignA"] !== undefined &&
          `${cartValues["RailDesignA"]}` === `${step8A1}`;

        if (railObject["DesignENName"] && !isRestoreHydrate) {
          tempExtended["8A"][1] = (
            <li key="1" className="step_title_extended_list_item">
              <span className="step_title_extended_list_item_title">{t("Design")}</span>
              <span className="step_title_extended_list_item_text">
                {pageLanguage === "fa"
                  ? convertToPersian(railObject["DesignName"])
                  : railObject["DesignENName"]}
              </span>
            </li>
          );
          tempExtended["8A"].splice(2, 3);
        } else if (railObject["DesignENName"] && isRestoreHydrate && !tempExtended["8A"][1]) {
          tempExtended["8A"][1] = (
            <li key="1" className="step_title_extended_list_item">
              <span className="step_title_extended_list_item_title">{t("Design")}</span>
              <span className="step_title_extended_list_item_text">
                {pageLanguage === "fa"
                  ? convertToPersian(railObject["DesignName"])
                  : railObject["DesignENName"]}
              </span>
            </li>
          );
        }
        let railObject2 = rails.find((obj) => `${obj["RailId"]}` === `${step8A2}`) || {};

        if (railObject["DesignENName"] && railObject2["ColorName"] && railObject2["ColorEnName"]) {
          tempExtended["8A"][2] = (
            <li key="2" className="step_title_extended_list_item">
              <span className="step_title_extended_list_item_title">{t("Finish")}</span>
              <span className="step_title_extended_list_item_text">
                {pageLanguage === "fa"
                  ? convertToPersian(railObject2["ColorName"])
                  : railObject2["ColorEnName"]}
              </span>
            </li>
          );
        }
        if (isRestoreHydrate && cartValues["BatonOptionA"] && !tempExtended["8A"][3]) {
          const batonValue = Array.isArray(cartValues["BatonOptionA"])
            ? cartValues["BatonOptionA"][0]
            : cartValues["BatonOptionA"];
          tempExtended["8A"][3] = (
            <li key="3" className="step_title_extended_list_item">
              <span className="step_title_extended_list_item_title">{t("Baton")}</span>
              <span className="step_title_extended_list_item_text">{t(batonValue)}</span>
            </li>
          );
        }
        if (Object.keys(railObject).length > 0) {
          showRodsColor(railObject, "8A2");
        }
      }
      setExtendedTitle(tempExtended);
    }, 1000);
  }, [rails]);

  useEffect(() => {
    setTimeout(() => {
      let tempExtended = extendedTitle;
      if (rails2.length && step8B1 !== "") {
        const isRestoreHydrate =
          (cartValues["SheerHardware"] === "Rod" || cartValues["SheerHardware"] === "Track") &&
          cartValues["RailDesignB"] !== undefined &&
          `${cartValues["RailDesignB"]}` === `${step8B1}`;

        let railObject =
          rails2.find((obj) => `${obj["RailId"]}` === `${step8B1}`) ||
          rails.find((obj) => `${obj["RailId"]}` === `${step8B1}`) ||
          {};

        if (railObject["RailTypeId"] && `${step8BRilType}` !== `${railObject["RailTypeId"]}`) {
          setStep8BRilType(`${railObject["RailTypeId"]}`);
        }

        if (railObject["DesignENName"] && !isRestoreHydrate) {
          tempExtended["8B"][1] = (
            <li key="1" className="step_title_extended_list_item">
              <span className="step_title_extended_list_item_title">{t("Design")}</span>
              <span className="step_title_extended_list_item_text">
                {pageLanguage === "fa"
                  ? convertToPersian(railObject["DesignName"])
                  : railObject["DesignENName"]}
              </span>
            </li>
          );
          tempExtended["8B"].splice(2, 3);
        } else if (railObject["DesignENName"] && isRestoreHydrate && !tempExtended["8B"][1]) {
          tempExtended["8B"][1] = (
            <li key="1" className="step_title_extended_list_item">
              <span className="step_title_extended_list_item_title">{t("Design")}</span>
              <span className="step_title_extended_list_item_text">
                {pageLanguage === "fa"
                  ? convertToPersian(railObject["DesignName"])
                  : railObject["DesignENName"]}
              </span>
            </li>
          );
        }

        if (railObject["RailTypeId"] === 2208) {
          setTrackType8B(1);
          if (isRestoreHydrate) {
            applyStep9BElectricRestoreFromCart(
              restoredStep9BTrackRef.current || cartValues,
              tempExtended
            );
          }
        } else {
          const isSuperTrack = `${railObject["RailTypeId"]}` === "2207";
          setTrackType8B(isSuperTrack ? 2 : undefined);

          const colorId = step8B2 || cartValues["RailIdB"];
          let railObject2 =
            rails2.find((obj) => `${obj["RailId"]}` === `${colorId}`) ||
            rails.find((obj) => `${obj["RailId"]}` === `${colorId}`) ||
            {};
          if (!Object.keys(railObject2).length && railObject["DesignCode"]) {
            const colorPool =
              (tracks2 && tracks2[railObject["DesignCode"]]) ||
              (tracks && tracks[railObject["DesignCode"]]) ||
              [];
            railObject2 = colorPool.find((obj) => `${obj["RailId"]}` === `${colorId}`) || {};
          }

          if (
            railObject["DesignENName"] &&
            railObject2["ColorName"] &&
            railObject2["ColorEnName"]
          ) {
            tempExtended["8B"][2] = (
              <li key="2" className="step_title_extended_list_item">
                <span className="step_title_extended_list_item_title">{t("Finish")}</span>
                <span className="step_title_extended_list_item_text">
                  {pageLanguage === "fa"
                    ? convertToPersian(railObject2["ColorName"])
                    : railObject2["ColorEnName"]}
                </span>
              </li>
            );
          } else if (isRestoreHydrate && !tempExtended["8B"][2]) {
            const colorLabel =
              pageLanguage === "fa" ? cartValues["RailColorFaB"] : cartValues["RailColorEnB"];
            if (colorLabel) {
              tempExtended["8B"][2] = (
                <li key="2" className="step_title_extended_list_item">
                  <span className="step_title_extended_list_item_title">{t("Finish")}</span>
                  <span className="step_title_extended_list_item_text">{colorLabel}</span>
                </li>
              );
            }
          }

          if (isRestoreHydrate && colorId && `${step8B2}` !== `${colorId}`) {
            setStep8B2(`${colorId}`);
          }

          if (
            isRestoreHydrate &&
            !isSuperTrack &&
            cartValues["BatonOptionB"] &&
            !tempExtended["8B"][3]
          ) {
            const batonValue = Array.isArray(cartValues["BatonOptionB"])
              ? cartValues["BatonOptionB"][0]
              : cartValues["BatonOptionB"];
            tempExtended["8B"][3] = (
              <li key="3" className="step_title_extended_list_item">
                <span className="step_title_extended_list_item_title">{t("Baton")}</span>
                <span className="step_title_extended_list_item_text">{t(batonValue)}</span>
              </li>
            );
          }
          if (isRestoreHydrate && isSuperTrack) {
            const controlRaw = Array.isArray(cartValues["ControlPositionB"])
              ? cartValues["ControlPositionB"][0]
              : cartValues["ControlPositionB"];
            const controlSide = parseStep9AControlSide(controlRaw);
            if (controlSide) {
              if (step8B3 !== controlSide) {
                setStep8B3(controlSide);
              }
              if (!tempExtended["8B"][3]) {
                tempExtended["8B"][3] = (
                  <li key="3" className="step_title_extended_list_item">
                    <span className="step_title_extended_list_item_title">
                      {t("Control Position")}
                    </span>
                    <span className="step_title_extended_list_item_text">{t(controlSide)}</span>
                  </li>
                );
              }
            }
          }
          showRodsColor(railObject, "8B2");
        }
      }
      setExtendedTitle(tempExtended);
    }, 1000);
  }, [rails2]);

  useEffect(() => {
    setTimeout(() => {
      let tempExtended = extendedTitle;
      if (rails3.length && step8C1 !== "") {
        const isRestoreHydrate =
          (cartValues["PrivacyLayerHardware"] === "Rod" ||
            cartValues["PrivacyLayerHardware"] === "Track") &&
          cartValues["RailDesignC"] !== undefined &&
          `${cartValues["RailDesignC"]}` === `${step8C1}`;

        let railObject = rails3.find((obj) => `${obj["RailId"]}` === `${step8C1}`) || {};

        if (railObject["RailTypeId"] && `${step8CTrack}` !== `${railObject["RailTypeId"]}`) {
          setStep8CTrack(`${railObject["RailTypeId"]}`);
        }

        if (railObject["DesignENName"] && !isRestoreHydrate) {
          tempExtended["8C"][1] = (
            <li key="1" className="step_title_extended_list_item">
              <span className="step_title_extended_list_item_title">{t("Design")}</span>
              <span className="step_title_extended_list_item_text">
                {pageLanguage === "fa"
                  ? convertToPersian(railObject["DesignName"])
                  : railObject["DesignENName"]}
              </span>
            </li>
          );
          tempExtended["8C"].splice(2, 3);
        } else if (railObject["DesignENName"] && isRestoreHydrate && !tempExtended["8C"][1]) {
          tempExtended["8C"][1] = (
            <li key="1" className="step_title_extended_list_item">
              <span className="step_title_extended_list_item_title">{t("Design")}</span>
              <span className="step_title_extended_list_item_text">
                {pageLanguage === "fa"
                  ? convertToPersian(railObject["DesignName"])
                  : railObject["DesignENName"]}
              </span>
            </li>
          );
        }

        if (railObject["RailTypeId"] === 2208) {
          setTrackType8C(1);
          if (isRestoreHydrate) {
            applyStep9CElectricRestoreFromCart(
              restoredStep9CTrackRef.current || cartValues,
              tempExtended
            );
          }
        } else {
          const isSuperTrack = `${railObject["RailTypeId"]}` === "2207";
          setTrackType8C(isSuperTrack ? 2 : undefined);

          const colorId = step8C2 || cartValues["RailIdC"];
          let railObject2 = rails3.find((obj) => `${obj["RailId"]}` === `${colorId}`) || {};
          if (!Object.keys(railObject2).length && railObject["DesignCode"]) {
            const colorPool =
              (rods3 && rods3[railObject["DesignCode"]]) ||
              (tracks3 && tracks3[railObject["DesignCode"]]) ||
              [];
            railObject2 = colorPool.find((obj) => `${obj["RailId"]}` === `${colorId}`) || {};
          }

          if (
            railObject["DesignENName"] &&
            railObject2["ColorName"] &&
            railObject2["ColorEnName"]
          ) {
            tempExtended["8C"][2] = (
              <li key="2" className="step_title_extended_list_item">
                <span className="step_title_extended_list_item_title">{t("Finish")}</span>
                <span className="step_title_extended_list_item_text">
                  {pageLanguage === "fa"
                    ? convertToPersian(railObject2["ColorName"])
                    : railObject2["ColorEnName"]}
                </span>
              </li>
            );
          } else if (isRestoreHydrate && !tempExtended["8C"][2]) {
            const colorLabel =
              pageLanguage === "fa" ? cartValues["RailColorFaC"] : cartValues["RailColorEnC"];
            if (colorLabel) {
              tempExtended["8C"][2] = (
                <li key="2" className="step_title_extended_list_item">
                  <span className="step_title_extended_list_item_title">{t("Finish")}</span>
                  <span className="step_title_extended_list_item_text">{colorLabel}</span>
                </li>
              );
            }
          }

          if (isRestoreHydrate && colorId && `${step8C2}` !== `${colorId}`) {
            setStep8C2(`${colorId}`);
          }
          if (
            isRestoreHydrate &&
            !isSuperTrack &&
            cartValues["BatonOptionC"] &&
            !tempExtended["8C"][3]
          ) {
            const batonValue = Array.isArray(cartValues["BatonOptionC"])
              ? cartValues["BatonOptionC"][0]
              : cartValues["BatonOptionC"];
            if (batonValue) {
              if (`${step8C3}` !== `${batonValue}`) {
                setStep8C3(batonValue);
              }
              tempExtended["8C"][3] = (
                <li key="3" className="step_title_extended_list_item">
                  <span className="step_title_extended_list_item_title">{t("Baton")}</span>
                  <span className="step_title_extended_list_item_text">{t(batonValue)}</span>
                </li>
              );
            }
          }
          if (isRestoreHydrate && isSuperTrack) {
            const controlRaw = Array.isArray(cartValues["ControlPositionC"])
              ? cartValues["ControlPositionC"][0]
              : cartValues["ControlPositionC"];
            const controlSide = parseStep9AControlSide(controlRaw);
            if (controlSide) {
              if (step8C3 !== controlSide) {
                setStep8C3(controlSide);
              }
              tempExtended["8C"][3] = (
                <li key="3" className="step_title_extended_list_item">
                  <span className="step_title_extended_list_item_title">
                    {t("Control Position")}
                  </span>
                  <span className="step_title_extended_list_item_text">{t(controlSide)}</span>
                </li>
              );
            }
          }
          showRodsColor(railObject, "8C2");
        }
      }
      setExtendedTitle(tempExtended);
    }, 1000);
  }, [rails3]);

  useEffect(() => {
    if (
      accessoriesDesign["isPlus"] !== undefined ||
      accessoriesDesign["qty"] !== undefined ||
      accessoriesDesign["DesignCode"] !== undefined
    ) {
      // After refresh, skip until catalog + saved qty are hydrated (live clicks have isPlus/qty)
      if (
        pageLoad &&
        accessoriesDesign["isPlus"] === undefined &&
        accessoriesDesign["qty"] === undefined
      ) {
        return;
      }
      let temp = JSON.parse(JSON.stringify(customAcc));
      let temp2 = JSON.parse(JSON.stringify(customAccActive));

      if (
        accessoriesDesign["DesignCode"] !== "" &&
        temp2[accessoriesDesign["DesignCode"]] !== undefined
      ) {
        const found = temp.findIndex(
          (el) =>
            `${el["SewingAccessoryValue"]}` ===
            `${temp2[accessoriesDesign["DesignCode"]]["SewingAccessoryValue"]}`
        );

        if (accessoriesDesign["isPlus"] !== undefined) {
          if (accessoriesDesign["isPlus"]) {
            if (found === -1) {
              temp.push({
                SewingAccessoryId: temp2[accessoriesDesign["DesignCode"]]["SewingAccessoryId"],
                SewingModelAccessoryId:
                  temp2[accessoriesDesign["DesignCode"]]["SewingModelAccessoryId"],
                SewingAccessoryValue:
                  temp2[accessoriesDesign["DesignCode"]]["SewingAccessoryValue"],
                DesignNameEn: temp2[accessoriesDesign["DesignCode"]]["DesignNameEn"],
                DesignNameFa: temp2[accessoriesDesign["DesignCode"]]["DesignNameFa"],
                ColorNameEn: temp2[accessoriesDesign["DesignCode"]]["ColorNameEn"],
                ColorNameFa: temp2[accessoriesDesign["DesignCode"]]["ColorNameFa"],
                Qty: 1,
              });
            } else {
              let newQty = +temp[found]["Qty"] + +1;
              if (newQty > 10) {
                temp[found] = {
                  SewingAccessoryId: temp[found]["SewingAccessoryId"],
                  SewingModelAccessoryId: temp[found]["SewingModelAccessoryId"],
                  SewingAccessoryValue: temp[found]["SewingAccessoryValue"],
                  DesignNameEn: temp[found]["DesignNameEn"],
                  DesignNameFa: temp[found]["DesignNameFa"],
                  ColorNameEn: temp[found]["ColorNameEn"],
                  ColorNameFa: temp[found]["ColorNameFa"],
                  Qty: 10,
                };
              } else {
                temp[found] = {
                  SewingAccessoryId: temp[found]["SewingAccessoryId"],
                  SewingModelAccessoryId: temp[found]["SewingModelAccessoryId"],
                  SewingAccessoryValue: temp[found]["SewingAccessoryValue"],
                  DesignNameEn: temp[found]["DesignNameEn"],
                  DesignNameFa: temp[found]["DesignNameFa"],
                  ColorNameEn: temp[found]["ColorNameEn"],
                  ColorNameFa: temp[found]["ColorNameFa"],
                  Qty: newQty,
                };
              }
            }
          } else {
            if (found === -1) {
            } else {
              let newQty = +temp[found]["Qty"] - +1;
              if (newQty < 1) {
                temp.splice(found, 1);
              } else {
                temp[found] = {
                  SewingAccessoryId: temp[found]["SewingAccessoryId"],
                  SewingModelAccessoryId: temp[found]["SewingModelAccessoryId"],
                  SewingAccessoryValue: temp[found]["SewingAccessoryValue"],
                  DesignNameEn: temp[found]["DesignNameEn"],
                  DesignNameFa: temp[found]["DesignNameFa"],
                  ColorNameEn: temp[found]["ColorNameEn"],
                  ColorNameFa: temp[found]["ColorNameFa"],
                  Qty: newQty,
                };
              }
            }
          }
        } else if (accessoriesDesign["qty"] !== undefined) {
          if (found === -1) {
            let newQty = accessoriesDesign["qty"];
            if (newQty < 1) {
            } else if (newQty > 10) {
              temp.push({
                SewingAccessoryId: temp2[accessoriesDesign["DesignCode"]]["SewingAccessoryId"],
                SewingModelAccessoryId:
                  temp2[accessoriesDesign["DesignCode"]]["SewingModelAccessoryId"],
                SewingAccessoryValue:
                  temp2[accessoriesDesign["DesignCode"]]["SewingAccessoryValue"],
                DesignNameEn: temp2[accessoriesDesign["DesignCode"]]["DesignNameEn"],
                DesignNameFa: temp2[accessoriesDesign["DesignCode"]]["DesignNameFa"],
                ColorNameEn: temp2[accessoriesDesign["DesignCode"]]["ColorNameEn"],
                ColorNameFa: temp2[accessoriesDesign["DesignCode"]]["ColorNameFa"],
                Qty: 10,
              });
            } else {
              temp.push({
                SewingAccessoryId: temp2[accessoriesDesign["DesignCode"]]["SewingAccessoryId"],
                SewingModelAccessoryId:
                  temp2[accessoriesDesign["DesignCode"]]["SewingModelAccessoryId"],
                SewingAccessoryValue:
                  temp2[accessoriesDesign["DesignCode"]]["SewingAccessoryValue"],
                DesignNameEn: temp2[accessoriesDesign["DesignCode"]]["DesignNameEn"],
                DesignNameFa: temp2[accessoriesDesign["DesignCode"]]["DesignNameFa"],
                ColorNameEn: temp2[accessoriesDesign["DesignCode"]]["ColorNameEn"],
                ColorNameFa: temp2[accessoriesDesign["DesignCode"]]["ColorNameFa"],
                Qty: newQty,
              });
            }
          } else {
            let newQty = accessoriesDesign["qty"];
            if (newQty < 1) {
              temp.splice(found, 1);
            } else if (newQty > 10) {
              temp[found] = {
                SewingAccessoryId: temp[found]["SewingAccessoryId"],
                SewingModelAccessoryId: temp[found]["SewingModelAccessoryId"],
                SewingAccessoryValue: temp[found]["SewingAccessoryValue"],
                DesignNameEn: temp[found]["DesignNameEn"],
                DesignNameFa: temp[found]["DesignNameFa"],
                ColorNameEn: temp[found]["ColorNameEn"],
                ColorNameFa: temp[found]["ColorNameFa"],
                Qty: 10,
              };
            } else {
              temp[found] = {
                SewingAccessoryId: temp[found]["SewingAccessoryId"],
                SewingModelAccessoryId: temp[found]["SewingModelAccessoryId"],
                SewingAccessoryValue: temp[found]["SewingAccessoryValue"],
                DesignNameEn: temp[found]["DesignNameEn"],
                DesignNameFa: temp[found]["DesignNameFa"],
                ColorNameEn: temp[found]["ColorNameEn"],
                ColorNameFa: temp[found]["ColorNameFa"],
                Qty: newQty,
              };
            }
          }
        } else {
          if (found !== -1) {
            temp[found] = {
              SewingAccessoryId: accessoriesDesign["SewingAccessoryId"],
              SewingModelAccessoryId: accessoriesDesign["SewingModelAccessoryId"],
              SewingAccessoryValue: accessoriesDesign["SewingAccessoryValue"],
              DesignNameEn: accessoriesDesign["DesignNameEn"],
              DesignNameFa: accessoriesDesign["DesignNameFa"],
              ColorNameEn: accessoriesDesign["ColorNameEn"],
              ColorNameFa: accessoriesDesign["ColorNameFa"],
              Qty: temp[found]["Qty"],
            };
          }
          temp2[accessoriesDesign["DesignCode"]] = {
            SewingAccessoryId: accessoriesDesign["SewingAccessoryId"],
            SewingModelAccessoryId: accessoriesDesign["SewingModelAccessoryId"],
            SewingAccessoryValue: accessoriesDesign["SewingAccessoryValue"],
            DesignNameEn: accessoriesDesign["DesignNameEn"],
            DesignNameFa: accessoriesDesign["DesignNameFa"],
            ColorNameEn: accessoriesDesign["ColorNameEn"],
            ColorNameFa: accessoriesDesign["ColorNameFa"],
          };
          setCustomAccActive(temp2);
        }
      }
      setCart(undefined, undefined, undefined, undefined, undefined, temp);

      setCustomAcc(temp);
      setAccessoriesDesign({
        isPlus: undefined,
        SewingAccessoryValue: "",
        SewingAccessoryId: undefined,
        SewingModelAccessoryId: undefined,
        DesignCode: undefined,
        DesignNameEn: undefined,
        DesignNameFa: undefined,
        ColorNameEn: undefined,
        ColorNameFa: undefined,
        qty: undefined,
      });
    }
  }, [accessoriesDesign]);

  useEffect(() => {
    if (fabricSelected.selectedFabricId && tiebackDrapery["isPlus"] !== undefined) {
      if (tiebackDrapery["isPlus"]) {
        let newQty = +tiebackDraperyQty + +1;
        if (newQty > 10) {
          newQty = 10;
        }
        setTiebackDrapery({
          isPlus: undefined,
          HandCurtainId: tiebackDrapery["HandCurtainId"],
          HandCurtainNum: newQty,
        });
        setTiebackDraperyQty(newQty);
      } else {
        let newQty = +tiebackDraperyQty - +1;
        if (newQty < 0) {
          newQty = 0;
        }
        setTiebackDrapery({
          isPlus: undefined,
          HandCurtainId: tiebackDrapery["HandCurtainId"],
          HandCurtainNum: newQty,
        });
        setTiebackDraperyQty(newQty);
      }
    } else if (fabricSelected.selectedFabricId && tiebackDrapery["HandCurtainId"] !== undefined) {
      if (tiebackDrapery["HandCurtainNum"] > 0) {
        setCart(
          "HandCurtainId",
          tiebackDrapery["HandCurtainId"],
          "",
          "HandCurtainNum,HandCurtainEn,HandCurtainFa",
          [tiebackDraperyQty, "Matching Drapery Tieback", "کمرپرده پارچه ای"]
        );
      } else {
        setCart("", "", "HandCurtainId,HandCurtainNum");
      }
    }
  }, [tiebackDrapery]);

  useEffect(() => {
    if (fabricSelected2.selectedFabricId && tiebackSheer["isPlus"] !== undefined) {
      if (tiebackSheer["isPlus"]) {
        let newQty = +tiebackSheerQty + +1;
        if (newQty > 10) {
          newQty = 10;
        }
        setTiebackSheer({
          isPlus: undefined,
          HandCurtainId: tiebackSheer["HandCurtainId"],
          HandCurtainNum: newQty,
        });
        setTiebackSheerQty(newQty);
      } else {
        let newQty = +tiebackSheerQty - +1;
        if (newQty < 0) {
          newQty = 0;
        }
        setTiebackSheer({
          isPlus: undefined,
          HandCurtainId: tiebackSheer["HandCurtainId"],
          HandCurtainNum: newQty,
        });
        setTiebackSheerQty(newQty);
      }
    } else if (fabricSelected2.selectedFabricId && tiebackSheer["HandCurtainId"] !== undefined) {
      if (tiebackSheer["HandCurtainNum"] > 0) {
        setCart(
          "HandCurtainId2",
          tiebackSheer["HandCurtainId"],
          "",
          "HandCurtainNum2,HandCurtainEn2,HandCurtainFa2",
          [tiebackSheerQty, "Matching Sheer Tieback", "کمرپرده توری"]
        );
      } else {
        setCart("", "", "HandCurtainId2,HandCurtainNum2");
      }
    }
  }, [tiebackSheer]);

  useEffect(() => {
    if (Object.keys(customAccActive).length) {
      renderStepAccessories();
    }
  }, [customAcc, customAccActive, activeAccessoryColors]);

  useEffect(() => {
    if (pageLoad) return;
    setCartValues((prev) => {
      if (!prev || !Object.keys(prev).length) return prev;
      if (JSON.stringify(prev["Accessories"] || []) === JSON.stringify(customAcc || [])) {
        return prev;
      }
      return { ...prev, Accessories: customAcc };
    });
  }, [customAcc, pageLoad]);

  useEffect(() => {
    if (customAcc.length + tiebackDraperyQty + tiebackSheerQty) {
      let tempLabels = JSON.parse(JSON.stringify(stepSelectedLabel));
      let tempText = [];

      if (tiebackDraperyQty > 0) {
        tempText.push(
          `${pageLanguage === "en" ? "Matching Drapery Tieback" : "کمرپرده پارچه ای"} ${NumToFa(
            tiebackDraperyQty,
            pageLanguage
          )}`
        );
      }

      if (tiebackSheerQty > 0) {
        tempText.push(
          `${pageLanguage === "en" ? "Matching Sheer Tieback" : "کمرپرده توری"} ${NumToFa(
            tiebackSheerQty,
            pageLanguage
          )}`
        );
      }

      let promiseArr = [];
      customAcc.forEach((obj, index) => {
        promiseArr[index] = new Promise((resolve, reject) => {
          setTimeout(() => {
            let DesignENName;
            let DesignName;
            let ColorENName;
            let ColorName;
            const qty = obj["Qty"];
            const foundKey = Object.keys(stepAccessories || {}).find((e) =>
              findAccessoryColor(stepAccessories[e], obj)
            );
            if (foundKey !== undefined) {
              const colorObj = findAccessoryColor(stepAccessories[foundKey], obj);
              if (colorObj) {
                DesignENName = colorObj["DesignENName"];
                DesignName = colorObj["DesignName"];
                ColorENName = colorObj["ColorENName"];
                ColorName = colorObj["ColorName"];
              }
            }
            if (!DesignName && !DesignENName) {
              DesignENName = obj["DesignNameEn"];
              DesignName = obj["DesignNameFa"];
              ColorENName = obj["ColorNameEn"];
              ColorName = obj["ColorNameFa"];
            }
            if ((DesignName || DesignENName) && qty) {
              tempText.push(
                `${pageLanguage === "en" ? DesignENName : DesignName} / ${
                  pageLanguage === "en" ? capitalizeWordsText(ColorENName || "") : ColorName || ""
                } ${
                  pageLanguage === "en" ? `x${qty}` : NumberToPersianWord.convertEnToPe(`${qty}x`)
                }`
              );
            }
            resolve();
          }, 100);
        });
      });

      Promise.all(promiseArr).then(() => {
        tempLabels["9"] = tempText.join(", \n");

        let tempExtended = extendedTitle;
        tempExtended["9"] = tempText;
        setExtendedTitle(tempExtended);
        setStepSelectedLabel(tempLabels);
      });
    } else if (!pageLoad) {
      let tempLabels = JSON.parse(JSON.stringify(stepSelectedLabel));
      tempLabels["9"] = "";

      let tempExtended = extendedTitle;
      tempExtended["9"] = [];
      setExtendedTitle(tempExtended);
      setStepSelectedLabel(tempLabels);
    }
  }, [customAcc, tiebackDraperyQty, tiebackSheerQty, pageLanguage, stepAccessories, pageLoad]);

  useEffect(() => {
    if (stepSelectedLabel["3ARod"] === undefined || stepSelectedLabel["3ARod"] === "") {
      setStepSelectedLabel((prev) => ({
        ...prev,
        ["3ARod"]: pageLanguage === "en" ? "Floor" : "تا روی زمین",
      }));
      setStep3ARod("Floor");
      setStep3ATrack("Floor");
      // فراخوانی توابع در useEffect
      setCart(
        "FinishedLengthType",
        "Floor",
        "RodToBottom,Width3C,ExtensionLeft,ExtensionRight,Height3E,WindowToFloor,ShadeMount,CeilingToFloor,CeilingToWindow1,CeilingToWindow2,CeilingToWindow3,CeilingToFloor1,CeilingToFloor2,CeilingToFloor3"
      );
    }
  }, [step3ARod, stepSelectedLabel]);

  useEffect(() => {
    if (swatchLogin) {
      setSwatchLogin(false);
      modalHandleClose("side_login_modal");
      setTimeout(() => {
        fabricSwatch("0", swatchLoginSwatchId, swatchLoginSwatchDetailId);
      }, 500);
    } else if ((projectModalState === 2 && isLoggedIn) || (saveProjectCount !== 0 && isLoggedIn)) {
      if (roomLabelText !== "" && selectedRoomLabel.length) {
        if ((projectId && projectId !== "") || (editIndex && editIndex !== "")) {
          SaveUserProject(
            depSet,
            cartValues,
            [uploadedImagesFile, uploadedImagesURL, uploadedPDFFile, uploadedPDFURL],
            `${modelID}`,
            price,
            defaultModelName,
            defaultModelNameFa,
            projectData,
            customAcc
          )
            .then((temp) => {
              if (temp === 401) {
                setSaveProjectCount(saveProjectCount + 1);
              } else if (temp) {
                setProjectModalState(1);
                setSavingLoading(false);
              } else {
                setSavingLoading(false);
              }
            })
            .catch((err) => {
              console.log(err);
              setProjectModalState(2);
              setSavingLoading(false);
            });
        } else {
          SaveUserProject(
            depSet,
            cartValues,
            [uploadedImagesFile, uploadedImagesURL, uploadedPDFFile, uploadedPDFURL],
            `${modelID}`,
            price,
            defaultModelName,
            defaultModelNameFa,
            undefined,
            customAcc
          )
            .then((temp) => {
              if (temp === 401) {
                setSaveProjectCount(saveProjectCount + 1);
              } else if (temp) {
                setProjectModalState(1);
                setSavingLoading(false);
              } else {
                setSavingLoading(false);
              }
            })
            .catch((err) => {
              setProjectModalState(2);
              setSavingLoading(false);
            });
        }
      } else {
        setProjectModalState(0);
        modalHandleShow("add_to_project_modal");
      }
    }
  }, [isLoggedIn, saveProjectCount]);

  useEffect(() => {
    if (deleteUploadImageIndex !== -1) {
      if (deleteUploadImageUrl !== "") {
        deleteUploadedImg(
          uploadedImagesList,
          uploadedImagesNamesList,
          deleteUploadImageUrl,
          deleteUploadImageIndex
        );
      }
    }
  }, [deleteUploadImageUrl]);

  useEffect(() => {
    if (deleteUploadPdfIndex !== -1) {
      if (deleteUploadPdfUrl !== "") {
        deleteUploadedPdf(uploadedPDFNameList, deleteUploadPdfUrl, deleteUploadPdfIndex);
      }
    }
  }, [deleteUploadPdfUrl]);

  useEffect(() => {
    if (Object.keys(model).length !== 0 && widthCart !== undefined) {
      let tempObj = {};
      let promiseArr = [];
      model["Accessories"].forEach((obj, index) => {
        promiseArr[index] = new Promise((resolve, reject) => {
          let tempObj2 = {};
          let promiseArr2 = [];
          obj["SewingAccessoryDetails"].forEach((el, index2) => {
            promiseArr2[index2] = new Promise((resolve, reject) => {
              tempObj2[el["SewingAccessoryDetailId"]] = JSON.parse(JSON.stringify(el));
              tempObj2[el["SewingAccessoryDetailId"]]["Price"] =
                obj["CalcMethodId"] === 5602 ? (el["Price"] * widthCart) / 100 : el["Price"];
              resolve();
            });
          });
          Promise.all(promiseArr2).then(() => {
            tempObj[obj["SewingAccessoryId"]] = tempObj2;
            resolve();
          });
        });
      });

      Promise.all(promiseArr).then(() => {
        setModelAccessories(tempObj);
      });
    } else {
      setModelAccessories({});
    }
    if (Object.keys(model).length > 0) {
      let tempObj = {};
      let promiseArr = [];
      model["Accessories"].forEach((obj, index) => {
        promiseArr[index] = new Promise((resolve, reject) => {
          let promiseArr2 = [];
          if (obj["SewingAccessoryId"] === 26) {
            obj["SewingAccessoryDetails"].forEach((el, index2) => {
              promiseArr2[index2] = new Promise((resolve, reject) => {
                el["SewingModelAccessoryId"] = obj["SewingModelAccessoryId"];
                if (el["DesignCode"] && el["DesignCode"] !== "") {
                  if (
                    tempObj[el["DesignCode"]] === undefined ||
                    tempObj[el["DesignCode"]].length === 0
                  )
                    tempObj[el["DesignCode"]] = [];
                  tempObj[el["DesignCode"]].push(JSON.parse(JSON.stringify(el)));
                } else {
                  if (
                    tempObj[index2.toString()] === undefined ||
                    tempObj[index2.toString()].length === 0
                  )
                    tempObj[index2.toString()] = [];
                  tempObj[index2.toString()].push(JSON.parse(JSON.stringify(el)));
                }
                resolve();
              });
            });
          }
          Promise.all(promiseArr2).then(() => {
            resolve();
          });
        });
      });

      Promise.all(promiseArr).then(() => {
        setStepAccessories(tempObj);
      });
    } else {
      setStepAccessories({});
    }

    if (Object.keys(model).length > 0) {
      let tempArr = [];
      let promiseArr = [];
      model["Accessories"].forEach((obj, index) => {
        promiseArr[index] = new Promise((resolve, reject) => {
          let promiseArr2 = [];
          if (obj["SewingAccessoryId"] === 28) {
            obj["SewingAccessoryDetails"].forEach((el, index2) => {
              promiseArr2[index2] = new Promise((resolve, reject) => {
                el["SewingModelAccessoryId"] = obj["SewingModelAccessoryId"];
                tempArr.push(JSON.parse(JSON.stringify(el)));
                resolve();
              });
            });
          }
          Promise.all(promiseArr2).then(() => {
            resolve();
          });
        });
      });

      Promise.all(promiseArr).then(() => {
        let tempFabrics = {};
        let promiseArr2 = [];
        tempArr.forEach((obj, index) => {
          promiseArr2[index] = new Promise((resolve, reject) => {
            if (obj["ProductGroupId"] === "100703") {
              if (
                tempFabrics[obj["DesignCode"]] === "" ||
                tempFabrics[obj["DesignCode"]] === undefined ||
                tempFabrics[obj["DesignCode"]] === null ||
                tempFabrics[obj["DesignCode"]] === []
              )
                tempFabrics[obj["DesignCode"]] = [];
              tempFabrics[obj["DesignCode"]].push(obj);
            }
            resolve();
          });
        });
        Promise.all(promiseArr2).then(() => {
          setTrimAccessories(tempFabrics);
        });
      });
    } else {
      setTrimAccessories([]);
    }
  }, [model, widthCart]);

  useEffect(() => {
    if (!pageLoad && !rodsLoad && !rodsLoad2 && !motorLoad) {
      setCart(undefined, undefined);
    }
  }, [pageLoad, rodsLoad, rodsLoad2, motorLoad]);

  useEffect(() => {
    if (modelID !== "" && catID !== "") {
      getModel();
    }
  }, [modelID, catID]);

  useEffect(() => {
    if (pageItem) {
      setDefaultFabricPhoto(pageItem["MainImageUrl"]);
      if (pageType) {
        setCart("PhotoUrl", pageItem["MainImageUrl"], "", "PageType,PageId", [pageType, pageId]);
      } else {
        setCart("PhotoUrl", pageItem["MainImageUrl"], "", "PageId", [pageId]);
      }
      setDefaultModelName(pageItem["EnTitle"]);
      setDefaultModelNameFa(pageItem["Title"]);
      setDefaultModelDesc(pageItem["DescriptionEn"]);
      setDefaultModelDescFa(pageItem["Description"]);
    }
  }, [pageItem]);

  async function setLang() {
    if (
      pageLanguage !==
      location.pathname
        .split("")
        .slice(1, 3)
        .join("")
    ) {
      const tempLang = location.pathname.split("");
      setPageLanguage(tempLang.slice(1, 3).join(""));
    }
  }

  const getHasZipcode = createGetHasZipcode({
    isLoggedIn,
    setHasZipcode,
    setZipcode: (val) => {
      if (!val && restoredZipcodeRef.current) {
        setZipcode(restoredZipcodeRef.current);
        return;
      }
      setZipcode(val);
    },
    setZipcodeButton: (val) => {
      if (!val && restoredZipcodeRef.current) {
        setZipcodeButton(true);
        return;
      }
      setZipcodeButton(val);
    },
    setHasInstall: (val) => {
      if (!val && restoredZipcodeRef.current) {
        setHasInstall(true);
        return;
      }
      setHasInstall(val);
    },
  });

  const getCart = createGetCart({
    isLoggedIn,
    cartChanged,
    setBag,
    setCartChanged,
  });
  useEffect(() => {
    if (cartUpdated) {
      setBagUpdate(true);
      setBag(mainCart || {});
      if (mainCart && Object.keys(mainCart).length) {
        updateSideCartSummary(mainCart);
        setSideCartObjects(mainCart);
      } else if (!isLoggedIn && localStorage.getItem("cart")) {
        updateSideCartSummary(JSON.parse(localStorage.getItem("cart")));
      }
    }
  }, [cartUpdated]);

  useEffect(() => {
    if (!isLoggedIn && cartStateAgree && localStorage.getItem("cart")) {
      updateSideCartSummary(JSON.parse(localStorage.getItem("cart")));
    }
  }, [sideCartPrice, cartStateAgree, isLoggedIn]);

  useEffect(() => {
    setLang().then(() => {
      if (pageLanguage !== "") {
        if (Object.keys(fabrics).length || Object.keys(fabrics2).length) {
          if (!firstRender.current) {
            getCart()
              .then((temp) => {
                getHasZipcode();
                setTimeout(() => {
                  renderFabrics(temp);
                  renderFabrics2(temp);
                  renderFabrics22(temp);
                }, 100);
              })
              .catch(() => {
                // getHasZipcode();
                setTimeout(() => {
                  renderFabrics({});
                  renderFabrics2({});
                  renderFabrics2({});
                }, 100);
              });
          }
        }
      }
    });
  }, [fabrics, fabrics2, cartChanged, isLoggedIn, location.pathname]);

  useEffect(() => {
    setLang().then(() => {
      if (pageLanguage !== "") {
        if (Object.keys(sheers).length) {
          if (!firstRender.current) {
            renderSheers(bag);
            renderSheers2(bag);
          }
        } else {
          setSheersList([]);
          setSheersList2([]);
        }
      }
    });
  }, [sheers, sheers2, cartChanged, isLoggedIn, location.pathname]);

  useEffect(() => {
    setLang().then(() => {
      if (pageLanguage !== "") {
        if (Object.keys(rods).length || Object.keys(rods2).length || Object.keys(rods3).length) {
          renderRods();
        } else {
          setRodsList([]);
          setRodsList2([]);
          setRodsList3([]);
          setRodsList4([]);
        }
      }
      if (rodsLoad) {
        setRodsLoad(false);
      }
      if (rodsLoad2) {
        setRodsLoad2(false);
      }
    });
  }, [rods, rods2, rods3, isLoggedIn, location.pathname]);

  useEffect(() => {
    setLang().then(() => {
      if (pageLanguage !== "") {
        if (
          Object.keys(tracks).length ||
          Object.keys(tracks2).length ||
          Object.keys(tracks3).length
        ) {
          renderTracks();
        } else {
          setTracksList([]);
          setTracksList2([]);

          setStep6BHead("Rod");
          setStep6CHead("Rod");
          setStep6B("");
          setStep6C("");

          if (step6 === "Customize Style Per Curtain") {
            // setDeps("6B,6C", "");
            setCart("", "", "PanelTypeB,PanelTypeC");
          }
        }
      }
    });
  }, [tracks, tracks2, tracks3, isLoggedIn, location.pathname]);

  useEffect(() => {
    if (Object.keys(stepAccessories).length > 0) {
      let temp = JSON.parse(JSON.stringify(customAccActive));
      let promiseArr = [];
      Object.keys(stepAccessories).forEach((key, index) => {
        promiseArr[index] = new Promise((resolve, reject) => {
          const savedAcc = (customAcc || []).find((acc) =>
            findAccessoryColor(stepAccessories[key], acc)
          );
          if (savedAcc) {
            const colorObj = findAccessoryColor(stepAccessories[key], savedAcc);
            if (colorObj) {
              temp[key] = {
                SewingAccessoryId: colorObj["SewingAccessoryId"],
                SewingModelAccessoryId: colorObj["SewingModelAccessoryId"],
                SewingAccessoryValue: colorObj["DetailId"],
                DesignNameEn: colorObj["DesignENName"],
                DesignNameFa: colorObj["DesignName"],
                ColorNameEn: colorObj["ColorENName"],
                ColorNameFa: colorObj["ColorName"],
              };
            }
          } else if (temp[key] === undefined) {
            temp[key] = {
              SewingAccessoryId: stepAccessories[key][0]["SewingAccessoryId"],
              SewingModelAccessoryId: stepAccessories[key][0]["SewingModelAccessoryId"],
              SewingAccessoryValue: stepAccessories[key][0]["DetailId"],
              DesignNameEn: stepAccessories[key][0]["DesignENName"],
              DesignNameFa: stepAccessories[key][0]["DesignName"],
              ColorNameEn: stepAccessories[key][0]["ColorENName"],
              ColorNameFa: stepAccessories[key][0]["ColorName"],
            };
          }
          resolve();
        });
      });
      Promise.all(promiseArr).then(() => {
        setCustomAccActive(temp);
      });
    } else if (!(customAcc && customAcc.length)) {
      setStepAccessoriesList([]);
      setCustomAccActive({});
    }
  }, [stepAccessories, customAcc, location.pathname]);

  useEffect(() => {
    if (sheersModelId !== "") {
      if (widthCart && parseInt(widthCart) > 0) {
        getSheersRails(sheersModelId, parseInt(widthCart));
      } else {
        getSheersRails(sheersModelId);
      }
    } else {
      setRods2({});
      setTracks2({});
    }
  }, [sheersModelId, location.pathname]);

  useEffect(() => {
    if (sheersModelId2 !== "") {
      if (widthCart && parseInt(widthCart) > 0) {
        getSheersRails(sheersModelId2, parseInt(widthCart), true);
      } else {
        getSheersRails(sheersModelId2, undefined, true);
      }
    } else {
      setRods3({});
      setTracks3({});
    }
  }, [sheersModelId2, location.pathname]);

  useEffect(() => {
    if (firstRender.current) {
      firstRender.current = false;
    } else {
      if (bagUpdate) {
        setBagUpdate(false);
      } else {
        dispatch({
          type: CartUpdatedTrue,
          payload: { mainCart: bag },
        });
      }
      if (isLoggedIn) {
        setCartCount(bag["CartDetails"]?.length || 0);
      } else {
        setCartCount(bag["drapery"]?.length || 0);
      }
    }
  }, [bag]);

  useEffect(() => {
    if (filterChanged["filter"] !== 0) {
      filterSelected(
        filterChanged["filter"],
        filterChanged["filter_id"],
        filterChanged["isDelete"],
        filterChanged["step"] || (accordionActiveKey === "2" ? "2" : "1")
      );

      setFilterChanged({
        filter: 0,
        filter_id: undefined,
        isDelete: false,
        step: "1",
      });
    }
  }, [filterChanged, accordionActiveKey]);

  useEffect(() => {
    if (!isClearAll) {
      getFabricsWithFilter(false, "1");
    }
  }, [filterColors, filterPatterns, filterTypes, filterPrices, searchText, heightCart2]);

  useEffect(() => {
    if (!isClearAll) {
      getFabricsWithFilter(false, "2");
    }
  }, [filterColors2, filterPatterns2, filterTypes2, filterPrices2, searchText2, heightCart2]);

  useEffect(() => {
    if (pageLanguage !== "") {
      if (widthCart && parseInt(widthCart) > 0) {
        getRails(parseInt(widthCart));
      } else {
        getRails();
      }
      GetSewingFilters(1, `${modelID}`).then((temp) => {
        setInitFilterColors(temp);
      });
      GetSewingFilters(2, `${modelID}`).then((temp) => {
        setInitFilterPatterns(temp);
      });
      GetSewingFilters(3, `${modelID}`).then((temp) => {
        setInitFilterTypes(temp);
      });
      GetSewingFilters(4, `${modelID}`).then((temp) => {
        setInitFilterPrices(temp);
      });
    }
  }, [pageLanguage, location.pathname]);

  useEffect(() => {
    let tempLang = location.pathname
      .split("")
      .slice(1, 3)
      .join("");
    let pageLanguage = tempLang;
    if (
      Object.keys(initFilterColors).length &&
      Object.keys(initFilterPatterns).length &&
      Object.keys(initFilterTypes).length &&
      Object.keys(initFilterPrices).length
    ) {
      if (initFilterColors[tempLang]?.length) {
        let temp = JSON.parse(JSON.stringify(initFilterColors));

        setSewingColors(
          temp[tempLang]
            .sort((a, b) => a.label.localeCompare(b.label))
            .map((obj, index) => (
              <Dropdown.Item as={Button} key={index}>
                <label className="dropdown_label">
                  <input
                    type="checkbox"
                    filter-id={obj.value}
                    ref={(ref) =>
                      (filterCheckboxes.current["colors"] = [
                        ...filterCheckboxes.current["colors"],
                        ref,
                      ])
                    }
                    onChange={(e) => {
                      setFilterChanged({
                        filter: "colors",
                        filter_id: e.target.getAttribute("filter-id"),
                        isDelete: e.target.checked,
                        step: "1",
                      });
                    }}
                    id={"dropdown_color" + obj.value + index}
                  />
                  <label htmlFor={"dropdown_color" + obj.value + index} className="checkbox_label">
                    <img
                      className="checkbox_label_img checkmark1 img-fluid"
                      src={require("../Images/public/checkmark1_checkbox.png")}
                      alt=""
                    />
                  </label>
                  {convertToPersian(capitalizeWordsText(obj.label), pageLanguage)}
                </label>
              </Dropdown.Item>
            ))
        );
        filterCheckboxes.current["colorsSheer"] = [];
        setSewingColorsSheer(
          temp[tempLang]
            .sort((a, b) => a.label.localeCompare(b.label))
            .map((obj, index) => (
              <Dropdown.Item as={Button} key={"sheer-color-" + index}>
                <label className="dropdown_label">
                  <input
                    type="checkbox"
                    filter-id={obj.value}
                    checked={filterColors2.includes(obj.value.toString())}
                    ref={(ref) =>
                      (filterCheckboxes.current["colorsSheer"] = [
                        ...filterCheckboxes.current["colorsSheer"],
                        ref,
                      ])
                    }
                    onChange={(e) => {
                      setFilterChanged({
                        filter: "colors",
                        filter_id: e.target.getAttribute("filter-id"),
                        isDelete: e.target.checked,
                        step: "2",
                      });
                    }}
                    id={"dropdown_color_sheer" + obj.value + index}
                  />
                  <label
                    htmlFor={"dropdown_color_sheer" + obj.value + index}
                    className={
                      filterColors2.includes(obj.value.toString())
                        ? "checkbox_label checked_label"
                        : "checkbox_label"
                    }
                  >
                    <img
                      className="checkbox_label_img checkmark1 img-fluid"
                      src={require("../Images/public/checkmark1_checkbox.png")}
                      alt=""
                    />
                  </label>
                  {convertToPersian(capitalizeWordsText(obj.label), pageLanguage)}
                </label>
              </Dropdown.Item>
            ))
        );
        let promiseArr = [];
        let tempArr = [];
        temp[tempLang].forEach((obj, index) => {
          promiseArr[index] = new Promise((resolve, reject) => {
            if (index < 5 || showMoreFilter["colors"]) {
              tempArr.push(
                <button key={index} className="dropdown-item btn btn-primary">
                  <label className="dropdown_label">
                    <input
                      type="checkbox"
                      filter-id={obj.value}
                      checked={filterColors.includes(obj.value.toString())}
                      ref={(ref) =>
                        (filterCheckboxes.current["colors2"] = [
                          ...filterCheckboxes.current["colors2"],
                          ref,
                        ])
                      }
                      onChange={(e) => {
                        setFilterChanged({
                          filter: "colors",
                          filter_id: e.target.getAttribute("filter-id"),
                          isDelete: e.target.checked,
                        });
                      }}
                      id={"dropdown_color2" + obj.value + index}
                    />
                    <label
                      htmlFor={"dropdown_color2" + obj.value + index}
                      className={
                        filterColors.includes(obj.value.toString())
                          ? "checkbox_label checked"
                          : "checkbox_label"
                      }
                    >
                      <img
                        className="checkbox_label_img checkmark1 img-fluid"
                        src={require("../Images/public/checkmark1_checkbox.png")}
                        alt=""
                      />
                    </label>
                    {convertToPersian(obj.label, pageLanguage)}
                  </label>
                </button>
              );
              if (temp[tempLang]?.length > 5 && index === temp[tempLang]?.length - 1) {
                tempArr.push(
                  <button
                    key={index + "show_more"}
                    className="dropdown-item btn btn-primary show_more_filters"
                  >
                    <p
                      className="text_underline"
                      onClick={() => setShowMoreFilterTrigger("colors")}
                    >
                      {t("Show Less")}
                    </p>
                  </button>
                );
              }
              resolve();
            } else {
              tempArr.push(
                <button key={index} className="dropdown-item btn btn-primary hidden">
                  <label className="dropdown_label">
                    <input
                      type="checkbox"
                      filter-id={obj.value}
                      checked={filterColors.includes(obj.value.toString())}
                      ref={(ref) =>
                        (filterCheckboxes.current["colors2"] = [
                          ...filterCheckboxes.current["colors2"],
                          ref,
                        ])
                      }
                      onChange={(e) => {
                        setFilterChanged({
                          filter: "colors",
                          filter_id: e.target.getAttribute("filter-id"),
                          isDelete: e.target.checked,
                        });
                      }}
                      id={"dropdown_color2" + obj.value + index}
                    />
                    <label
                      htmlFor={"dropdown_color2" + obj.value + index}
                      className={
                        filterColors.includes(obj.value.toString())
                          ? "checkbox_label checked"
                          : "checkbox_label"
                      }
                    >
                      <img
                        className="checkbox_label_img checkmark1 img-fluid"
                        src={require("../Images/public/checkmark1_checkbox.png")}
                        alt=""
                      />
                    </label>
                    {convertToPersian(obj.label, pageLanguage)}
                  </label>
                </button>
              );
              if (index === temp[tempLang]?.length - 1) {
                tempArr.push(
                  <button
                    key={index + "show_more"}
                    className="dropdown-item btn btn-primary show_more_filters"
                  >
                    <p
                      className="text_underline"
                      onClick={() => setShowMoreFilterTrigger("colors")}
                    >
                      {t("Show More")}
                    </p>
                  </button>
                );
              }
              resolve();
            }
          });
        });
        Promise.all(promiseArr).then(() => {
          setSewingColors2(tempArr);
        });
      }
      if (initFilterPatterns[tempLang]?.length) {
        let temp = JSON.parse(JSON.stringify(initFilterPatterns));

        setSewingPatterns(
          temp[tempLang]
            .sort((a, b) => a.label.localeCompare(b.label))
            .map((obj, index) => (
              <Dropdown.Item as={Button} key={index}>
                <label className="dropdown_label">
                  <input
                    type="checkbox"
                    filter-id={obj.value}
                    ref={(ref) =>
                      (filterCheckboxes.current["patterns"] = [
                        ...filterCheckboxes.current["patterns"],
                        ref,
                      ])
                    }
                    onChange={(e) => {
                      setFilterChanged({
                        filter: "patterns",
                        filter_id: e.target.getAttribute("filter-id"),
                        isDelete: e.target.checked,
                        step: "1",
                      });
                    }}
                    id={"dropdown_pattern" + obj.value + index}
                  />
                  <label
                    htmlFor={"dropdown_pattern" + obj.value + index}
                    className="checkbox_label"
                  >
                    <img
                      className="checkbox_label_img checkmark1 img-fluid"
                      src={require("../Images/public/checkmark1_checkbox.png")}
                      alt=""
                    />
                  </label>
                  {convertToPersian(capitalizeWordsText(obj.label), pageLanguage)}
                </label>
              </Dropdown.Item>
            ))
        );

        filterCheckboxes.current["patternsSheer"] = [];
        setSewingPatternsSheer(
          temp[tempLang]
            .sort((a, b) => a.label.localeCompare(b.label))
            .map((obj, index) => (
              <Dropdown.Item as={Button} key={"sheer-pattern-" + index}>
                <label className="dropdown_label">
                  <input
                    type="checkbox"
                    filter-id={obj.value}
                    checked={filterPatterns2.includes(obj.value.toString())}
                    ref={(ref) =>
                      (filterCheckboxes.current["patternsSheer"] = [
                        ...filterCheckboxes.current["patternsSheer"],
                        ref,
                      ])
                    }
                    onChange={(e) => {
                      setFilterChanged({
                        filter: "patterns",
                        filter_id: e.target.getAttribute("filter-id"),
                        isDelete: e.target.checked,
                        step: "2",
                      });
                    }}
                    id={"dropdown_pattern_sheer" + obj.value + index}
                  />
                  <label
                    htmlFor={"dropdown_pattern_sheer" + obj.value + index}
                    className={
                      filterPatterns2.includes(obj.value.toString())
                        ? "checkbox_label checked_label"
                        : "checkbox_label"
                    }
                  >
                    <img
                      className="checkbox_label_img checkmark1 img-fluid"
                      src={require("../Images/public/checkmark1_checkbox.png")}
                      alt=""
                    />
                  </label>
                  {convertToPersian(capitalizeWordsText(obj.label), pageLanguage)}
                </label>
              </Dropdown.Item>
            ))
        );

        let promiseArr = [];
        let tempArr = [];
        temp[tempLang].forEach((obj, index) => {
          promiseArr[index] = new Promise((resolve, reject) => {
            if (index < 5 || showMoreFilter["patterns"]) {
              tempArr.push(
                <button key={index} className="dropdown-item btn btn-primary">
                  <label className="dropdown_label">
                    <input
                      type="checkbox"
                      filter-id={obj.value}
                      checked={filterPatterns.includes(obj.value.toString())}
                      ref={(ref) =>
                        (filterCheckboxes.current["patterns2"] = [
                          ...filterCheckboxes.current["patterns2"],
                          ref,
                        ])
                      }
                      onChange={(e) => {
                        setFilterChanged({
                          filter: "patterns",
                          filter_id: e.target.getAttribute("filter-id"),
                          isDelete: e.target.checked,
                        });
                      }}
                      id={"dropdown_pattern2" + obj.value + index}
                    />
                    <label
                      htmlFor={"dropdown_pattern2" + obj.value + index}
                      className={
                        filterPatterns.includes(obj.value.toString())
                          ? "checkbox_label checked"
                          : "checkbox_label"
                      }
                    >
                      <img
                        className="checkbox_label_img checkmark1 img-fluid"
                        src={require("../Images/public/checkmark1_checkbox.png")}
                        alt=""
                      />
                    </label>
                    {convertToPersian(obj.label, pageLanguage)}
                  </label>
                </button>
              );
              if (temp[tempLang]?.length > 5 && index === temp[tempLang]?.length - 1) {
                tempArr.push(
                  <button
                    key={index + "show_more"}
                    className="dropdown-item btn btn-primary show_more_filters"
                  >
                    <p
                      className="text_underline"
                      onClick={() => setShowMoreFilterTrigger("patterns")}
                    >
                      {t("Show Less")}
                    </p>
                  </button>
                );
              }
              resolve();
            } else {
              tempArr.push(
                <button key={index} className="dropdown-item btn btn-primary hidden">
                  <label className="dropdown_label">
                    <input
                      type="checkbox"
                      filter-id={obj.value}
                      checked={filterPatterns.includes(obj.value.toString())}
                      ref={(ref) =>
                        (filterCheckboxes.current["patterns2"] = [
                          ...filterCheckboxes.current["patterns2"],
                          ref,
                        ])
                      }
                      onChange={(e) => {
                        setFilterChanged({
                          filter: "patterns",
                          filter_id: e.target.getAttribute("filter-id"),
                          isDelete: e.target.checked,
                        });
                      }}
                      id={"dropdown_pattern2" + obj.value + index}
                    />
                    <label
                      htmlFor={"dropdown_pattern2" + obj.value + index}
                      className={
                        filterPatterns.includes(obj.value.toString())
                          ? "checkbox_label checked"
                          : "checkbox_label"
                      }
                    >
                      <img
                        className="checkbox_label_img checkmark1 img-fluid"
                        src={require("../Images/public/checkmark1_checkbox.png")}
                        alt=""
                      />
                    </label>
                    {convertToPersian(obj.label, pageLanguage)}
                  </label>
                </button>
              );
              if (index === temp[tempLang]?.length - 1) {
                tempArr.push(
                  <button
                    key={index + "show_more"}
                    className="dropdown-item btn btn-primary show_more_filters"
                  >
                    <p
                      className="text_underline"
                      onClick={() => setShowMoreFilterTrigger("patterns")}
                    >
                      {t("Show More")}
                    </p>
                  </button>
                );
              }
              resolve();
            }
          });
        });
        Promise.all(promiseArr).then(() => {
          setSewingPatterns2(tempArr);
        });
      }
      if (initFilterTypes[tempLang]?.length) {
        let temp = JSON.parse(JSON.stringify(initFilterTypes));
        setSewingTypes(
          temp[tempLang]
            .sort((a, b) => a.label.localeCompare(b.label))
            .map((obj, index) => (
              <Dropdown.Item as={Button} key={index}>
                <label className="dropdown_label">
                  <input
                    type="checkbox"
                    filter-id={obj.value}
                    ref={(ref) =>
                      (filterCheckboxes.current["types"] = [
                        ...filterCheckboxes.current["types"],
                        ref,
                      ])
                    }
                    onChange={(e) => {
                      setFilterChanged({
                        filter: "types",
                        filter_id: e.target.getAttribute("filter-id"),
                        isDelete: e.target.checked,
                        step: "1",
                      });
                    }}
                    id={"dropdown_type" + obj.value + index}
                  />
                  <label htmlFor={"dropdown_type" + obj.value + index} className="checkbox_label">
                    <img
                      className="checkbox_label_img checkmark1 img-fluid"
                      src={require("../Images/public/checkmark1_checkbox.png")}
                      alt=""
                    />
                  </label>
                  {convertToPersian(capitalizeWordsText(obj.label), pageLanguage)}
                </label>
              </Dropdown.Item>
            ))
        );

        filterCheckboxes.current["typesSheer"] = [];
        setSewingTypesSheer(
          temp[tempLang]
            .sort((a, b) => a.label.localeCompare(b.label))
            .map((obj, index) => (
              <Dropdown.Item as={Button} key={"sheer-type-" + index}>
                <label className="dropdown_label">
                  <input
                    type="checkbox"
                    filter-id={obj.value}
                    checked={filterTypes2.includes(obj.value.toString())}
                    ref={(ref) =>
                      (filterCheckboxes.current["typesSheer"] = [
                        ...filterCheckboxes.current["typesSheer"],
                        ref,
                      ])
                    }
                    onChange={(e) => {
                      setFilterChanged({
                        filter: "types",
                        filter_id: e.target.getAttribute("filter-id"),
                        isDelete: e.target.checked,
                        step: "2",
                      });
                    }}
                    id={"dropdown_type_sheer" + obj.value + index}
                  />
                  <label
                    htmlFor={"dropdown_type_sheer" + obj.value + index}
                    className={
                      filterTypes2.includes(obj.value.toString())
                        ? "checkbox_label checked_label"
                        : "checkbox_label"
                    }
                  >
                    <img
                      className="checkbox_label_img checkmark1 img-fluid"
                      src={require("../Images/public/checkmark1_checkbox.png")}
                      alt=""
                    />
                  </label>
                  {convertToPersian(capitalizeWordsText(obj.label), pageLanguage)}
                </label>
              </Dropdown.Item>
            ))
        );

        let promiseArr = [];
        let tempArr = [];
        temp[tempLang].forEach((obj, index) => {
          promiseArr[index] = new Promise((resolve, reject) => {
            if (index < 5 || showMoreFilter["types"]) {
              tempArr.push(
                <button key={index} className="dropdown-item btn btn-primary">
                  <label className="dropdown_label">
                    <input
                      type="checkbox"
                      filter-id={obj.value}
                      checked={filterTypes.includes(obj.value.toString())}
                      ref={(ref) =>
                        (filterCheckboxes.current["types2"] = [
                          ...filterCheckboxes.current["types2"],
                          ref,
                        ])
                      }
                      onChange={(e) => {
                        setFilterChanged({
                          filter: "types",
                          filter_id: e.target.getAttribute("filter-id"),
                          isDelete: e.target.checked,
                        });
                      }}
                      id={"dropdown_type2" + obj.value + index}
                    />
                    <label
                      htmlFor={"dropdown_type2" + obj.value + index}
                      className={
                        filterTypes.includes(obj.value.toString())
                          ? "checkbox_label checked"
                          : "checkbox_label"
                      }
                    >
                      <img
                        className="checkbox_label_img checkmark1 img-fluid"
                        src={require("../Images/public/checkmark1_checkbox.png")}
                        alt=""
                      />
                    </label>
                    {convertToPersian(obj.label, pageLanguage)}
                  </label>
                </button>
              );
              if (temp[tempLang]?.length > 5 && index === temp[tempLang]?.length - 1) {
                tempArr.push(
                  <button
                    key={index + "show_more"}
                    className="dropdown-item btn btn-primary show_more_filters"
                  >
                    <p className="text_underline" onClick={() => setShowMoreFilterTrigger("types")}>
                      {t("Show Less")}
                    </p>
                  </button>
                );
              }
              resolve();
            } else {
              tempArr.push(
                <button key={index} className="dropdown-item btn btn-primary hidden">
                  <label className="dropdown_label">
                    <input
                      type="checkbox"
                      filter-id={obj.value}
                      checked={filterTypes.includes(obj.value.toString())}
                      ref={(ref) =>
                        (filterCheckboxes.current["types2"] = [
                          ...filterCheckboxes.current["types2"],
                          ref,
                        ])
                      }
                      onChange={(e) => {
                        setFilterChanged({
                          filter: "types",
                          filter_id: e.target.getAttribute("filter-id"),
                          isDelete: e.target.checked,
                        });
                      }}
                      id={"dropdown_type2" + obj.value + index}
                    />
                    <label
                      htmlFor={"dropdown_type2" + obj.value + index}
                      className={
                        filterTypes.includes(obj.value.toString())
                          ? "checkbox_label checked"
                          : "checkbox_label"
                      }
                    >
                      <img
                        className="checkbox_label_img checkmark1 img-fluid"
                        src={require("../Images/public/checkmark1_checkbox.png")}
                        alt=""
                      />
                    </label>
                    {convertToPersian(obj.label, pageLanguage)}
                  </label>
                </button>
              );
              if (index === temp[tempLang]?.length - 1) {
                tempArr.push(
                  <button
                    key={index + "show_more"}
                    className="dropdown-item btn btn-primary show_more_filters"
                  >
                    <p className="text_underline" onClick={() => setShowMoreFilterTrigger("types")}>
                      {t("Show More")}
                    </p>
                  </button>
                );
              }
              resolve();
            }
          });
        });
        Promise.all(promiseArr).then(() => {
          setSewingTypes2(tempArr);
        });
      }
      if (initFilterPrices[tempLang]?.length) {
        let temp = JSON.parse(JSON.stringify(initFilterPrices));

        setSewingPrices(
          temp[tempLang]
            .filter((obj) => !/\d/.test(obj.label))
            .map((obj, index) => (
              <Dropdown.Item as={Button} key={index}>
                <label className="dropdown_label">
                  <input
                    type="checkbox"
                    filter-id={obj.value}
                    ref={(ref) =>
                      (filterCheckboxes.current["prices"] = [
                        ...filterCheckboxes.current["prices"],
                        ref,
                      ])
                    }
                    onChange={(e) => {
                      setFilterChanged({
                        filter: "prices",
                        filter_id: e.target.getAttribute("filter-id"),
                        isDelete: e.target.checked,
                        step: "1",
                      });
                    }}
                    id={"dropdown_price" + obj.value + index}
                  />
                  <label htmlFor={"dropdown_price" + obj.value + index} className="checkbox_label">
                    <img
                      className="checkbox_label_img checkmark1 img-fluid"
                      src={require("../Images/public/checkmark1_checkbox.png")}
                      alt=""
                    />
                  </label>
                  {convertToPersian(capitalizeWordsText(obj.label), pageLanguage)}
                </label>
              </Dropdown.Item>
            ))
        );

        filterCheckboxes.current["pricesSheer"] = [];
        setSewingPricesSheer(
          temp[tempLang]
            .filter((obj) => !/\d/.test(obj.label))
            .map((obj, index) => (
              <Dropdown.Item as={Button} key={"sheer-price-" + index}>
                <label className="dropdown_label">
                  <input
                    type="checkbox"
                    filter-id={obj.value}
                    checked={filterPrices2.includes(obj.value.toString())}
                    ref={(ref) =>
                      (filterCheckboxes.current["pricesSheer"] = [
                        ...filterCheckboxes.current["pricesSheer"],
                        ref,
                      ])
                    }
                    onChange={(e) => {
                      setFilterChanged({
                        filter: "prices",
                        filter_id: e.target.getAttribute("filter-id"),
                        isDelete: e.target.checked,
                        step: "2",
                      });
                    }}
                    id={"dropdown_price_sheer" + obj.value + index}
                  />
                  <label
                    htmlFor={"dropdown_price_sheer" + obj.value + index}
                    className={
                      filterPrices2.includes(obj.value.toString())
                        ? "checkbox_label checked_label"
                        : "checkbox_label"
                    }
                  >
                    <img
                      className="checkbox_label_img checkmark1 img-fluid"
                      src={require("../Images/public/checkmark1_checkbox.png")}
                      alt=""
                    />
                  </label>
                  {convertToPersian(capitalizeWordsText(obj.label), pageLanguage)}
                </label>
              </Dropdown.Item>
            ))
        );

        let promiseArr = [];
        let tempArr = [];
        temp[tempLang].forEach((obj, index) => {
          promiseArr[index] = new Promise((resolve, reject) => {
            if (index < 5 || showMoreFilter["prices"]) {
              tempArr.push(
                <button key={index} className="dropdown-item btn btn-primary">
                  <label className="dropdown_label">
                    <input
                      type="checkbox"
                      filter-id={obj.value}
                      checked={filterPrices.includes(obj.value.toString())}
                      ref={(ref) =>
                        (filterCheckboxes.current["prices2"] = [
                          ...filterCheckboxes.current["prices2"],
                          ref,
                        ])
                      }
                      onChange={(e) => {
                        setFilterChanged({
                          filter: "prices",
                          filter_id: e.target.getAttribute("filter-id"),
                          isDelete: e.target.checked,
                        });
                      }}
                      id={"dropdown_price2" + obj.value + index}
                    />
                    <label
                      htmlFor={"dropdown_price2" + obj.value + index}
                      className={
                        filterPrices.includes(obj.value.toString())
                          ? "checkbox_label checked"
                          : "checkbox_label"
                      }
                    >
                      <img
                        className="checkbox_label_img checkmark1 img-fluid"
                        src={require("../Images/public/checkmark1_checkbox.png")}
                        alt=""
                      />
                    </label>
                    {convertToPersian(obj.label, pageLanguage)}
                  </label>
                </button>
              );
              if (temp[tempLang]?.length > 5 && index === temp[tempLang]?.length - 1) {
                tempArr.push(
                  <button
                    key={index + "show_more"}
                    className="dropdown-item btn btn-primary show_more_filters"
                  >
                    <p
                      className="text_underline"
                      onClick={() => setShowMoreFilterTrigger("prices")}
                    >
                      {t("Show Less")}
                    </p>
                  </button>
                );
              }
              resolve();
            } else {
              tempArr.push(
                <button key={index} className="dropdown-item btn btn-primary hidden">
                  <label className="dropdown_label">
                    <input
                      type="checkbox"
                      filter-id={obj.value}
                      checked={filterPrices.includes(obj.value.toString())}
                      ref={(ref) =>
                        (filterCheckboxes.current["prices2"] = [
                          ...filterCheckboxes.current["prices2"],
                          ref,
                        ])
                      }
                      onChange={(e) => {
                        setFilterChanged({
                          filter: "prices",
                          filter_id: e.target.getAttribute("filter-id"),
                          isDelete: e.target.checked,
                        });
                      }}
                      id={"dropdown_price2" + obj.value + index}
                    />
                    <label
                      htmlFor={"dropdown_price2" + obj.value + index}
                      className={
                        filterPrices.includes(obj.value.toString())
                          ? "checkbox_label checked"
                          : "checkbox_label"
                      }
                    >
                      <img
                        className="checkbox_label_img checkmark1 img-fluid"
                        src={require("../Images/public/checkmark1_checkbox.png")}
                        alt=""
                      />
                    </label>
                    {convertToPersian(obj.label, pageLanguage)}
                  </label>
                </button>
              );
              if (index === temp[tempLang]?.length - 1) {
                tempArr.push(
                  <button
                    key={index + "show_more"}
                    className="dropdown-item btn btn-primary show_more_filters"
                  >
                    <p
                      className="text_underline"
                      onClick={() => setShowMoreFilterTrigger("prices")}
                    >
                      {t("Show More")}
                    </p>
                  </button>
                );
              }
              resolve();
            }
          });
        });
        Promise.all(promiseArr).then(() => {
          setSewingPrices2(tempArr);
        });
      }
    }
  }, [
    initFilterColors,
    initFilterPatterns,
    initFilterTypes,
    initFilterPrices,
    showMoreFilter,
    filterColors,
    filterPatterns,
    filterTypes,
    filterPrices,
    filterColors2,
    filterPatterns2,
    filterTypes2,
    filterPrices2,
  ]);
  useEffect(() => {
    if (showMoreFilterTrigger !== undefined) {
      let temp = JSON.parse(JSON.stringify(showMoreFilter));
      temp[showMoreFilterTrigger] = !temp[showMoreFilterTrigger];
      setShowMoreFilter(temp);
      setShowMoreFilterTrigger(undefined);
    }
  }, [showMoreFilterTrigger]);

  useEffect(() => {
    if (Object.keys(cartValues).length !== 0) {
      const updatedCartValues = {
        ...cartValues,
        SewingModelId: `${modelID}`,
        step6CHead,
        step6BHead,
        step6DHead,
      };
      if (step8 === "I Want To Customize Hardware Per Curtain" && step9ADrapery === "Track") {
        if (stepTrackCollectionsName9A)
          updatedCartValues.RailDesignEnA = stepTrackCollectionsName9A;
        if (stepHardwareName9A) updatedCartValues.RailColorEnA = stepHardwareName9A;
        if (stepTrackCollections9A) updatedCartValues.RailDesignB = stepTrackCollections9A;
        if (stepHardware9A) updatedCartValues.RailIdA = stepHardware9A;
        if (stepTCollections9A === "2201" && stepControl9A) {
          updatedCartValues.BatonOptionA = stepControl9A;
        }
        if (stepTCollections9A === "2207" && step9APosition) {
          updatedCartValues.ControlPositionB = `${step9APosition} Control`;
          delete updatedCartValues.BatonOptionA;
        }
        if (stepTCollections9A === "2208") {
          if (step8B6 === "true") updatedCartValues.hasPowerB = true;
          if (selectedMotorPositionA[0]?.value) {
            updatedCartValues.MotorPositionB = selectedMotorPositionA[0].value;
          }
          if (remoteNameA) updatedCartValues.RemoteNameA = remoteNameA;
          if (selectedMotorChannelsA?.length) {
            updatedCartValues.MotorChannelsB = selectedMotorChannelsA.map((obj) => obj.value);
          }
        }
      }
      cartValues["SewingModelId"] = `${modelID}`;
      const zipForStorage = parseSavedZipCode(zipcode) || parseSavedZipCode(cartValues["ZipCode"]);
      if (zipForStorage) {
        updatedCartValues.ZipCode = zipForStorage;
      }
      sessionStorage.setItem("cartValues", JSON.stringify(updatedCartValues));
      if (editIndex) {
        sessionStorage.setItem("editIndex", JSON.stringify(editIndex));
      }
      if (projectId) {
        sessionStorage.setItem("projectId", JSON.stringify(projectId));
      }
    }
  }, [JSON.stringify(cartValues), zipcode]);

  useEffect(() => {
    let pendingZip = "";
    try {
      const stored = sessionStorage.getItem("cartValues");
      if (stored) {
        pendingZip = parseSavedZipCode(JSON.parse(stored)?.ZipCode);
      }
    } catch (e) {
      pendingZip = "";
    }
    if (pendingZip) {
      restoredZipcodeRef.current = pendingZip;
      setZipcode(pendingZip);
      setZipcodeButton(true);
      setHasInstall(true);
    } else {
      getHasZipcode();
    }

    if (
      sessionStorage.getItem("cartValues") !== null &&
      editIndex === undefined &&
      projectId === undefined
    ) {
      let tempCartValues = {};
      let tempEditIndex;
      let tempProjectId;
      if (sessionStorage.getItem("cartValues") !== null) {
        tempCartValues = JSON.parse(sessionStorage.getItem("cartValues"));
        if (Object.keys(tempCartValues).length !== 0) {
          if (tempCartValues["SewingModelId"] && tempCartValues["SewingModelId"] === `${modelID}`) {
            setStepSelectedLabel({});
            setWindowSize("");

            setProjectDetails(tempCartValues, undefined, true);
          }
        }
      }
      if (sessionStorage.getItem("editIndex") !== null) {
        tempEditIndex = JSON.parse(
          sessionStorage.getItem("editIndex") &&
            sessionStorage.getItem("editIndex").toUpperCase() !== "UNDEFINED"
        );
        setEditIndex(tempEditIndex);
      }
      if (
        sessionStorage.getItem("projectId") !== null &&
        sessionStorage.getItem("projectId").toUpperCase() !== "UNDEFINED"
      ) {
        tempProjectId = JSON.parse(sessionStorage.getItem("projectId"));
        setProjectId(tempProjectId);
      }
      sessionStorage.removeItem("cartValues");
    }
  }, []);

  useEffect(() => {
    if (editIndex && editIndex !== "") {
      if (isLoggedIn) {
        getProjectDetail(editIndex);
      } else {
        if (localStorage.getItem("cart") !== null) {
          if (JSON.parse(localStorage.getItem("cart"))["drapery"] !== undefined) {
            setProjectDetails(
              JSON.parse(localStorage.getItem("cart"))["drapery"][editIndex],
              editIndex
            );
          } else {
            navigate("/" + pageLanguage + "/Curtain/" + catID + "/" + modelID);
          }
        } else {
          navigate("/" + pageLanguage + "/Curtain/" + catID + "/" + modelID);
        }
      }
    } else if (projectId && projectId !== "") {
      getProjectDetail();
    } else if (sessionStorage.getItem("cartCopy") !== null) {
      let tempCartValues = JSON.parse(sessionStorage.getItem("cartCopy"));
      if (Object.keys(tempCartValues).length !== 0) {
        if (tempCartValues["SewingModelId"] && tempCartValues["SewingModelId"] === `${modelID}`) {
          setStepSelectedLabel({});
          setWindowSize("");

          setProjectDetails(tempCartValues);
        }
      }
      sessionStorage.removeItem("cartCopy");
    } else if (Object.keys(cartValues).length !== 0) {
      setStepSelectedLabel({});
      setWindowSize("");
      setTimeout(() => {
        setProjectDetails(cartValues, undefined, true);
      }, 700);
    }
  }, [location.pathname]);

  const fixedDiv = useRef(null);
  const [offset, setOffset] = useState(false);

  useEffect(() => {
    const onScroll = () => {
      if (fixedDiv.current.offsetTop < window.pageYOffset + 92) {
        setOffset(true);
      } else {
        setOffset(false);
      }
    };

    // clean up code
    window.removeEventListener("scroll", onScroll);
    window.addEventListener("scroll", onScroll, { passive: true });
    return () => window.removeEventListener("scroll", onScroll);
  }, []);

  useEffect(() => {
    if (fabricsList.length === 0) {
      timeoutRef.current = setTimeout(() => {
        setShowEmptyMessage(true);
      }, 12000);
    } else {
      setShowEmptyMessage(false);
      if (timeoutRef.current) {
        clearTimeout(timeoutRef.current);
      }
    }

    return () => {
      if (timeoutRef.current) {
        clearTimeout(timeoutRef.current);
      }
    };
  }, [fabricsList]);

  let step5EStandardCeilingFloorTitle;
  let step5EStandardCeilingTitle;
  let step5ETitle;
  let RoomHeightTitle;

  if (step3A0 === "Ceiling" && step3A === "Standard" && step3B === "Apron") {
    step5EStandardCeilingFloorTitle = t("5E");
  } else if (step3A0 === "Ceiling" && step3A === "Standard" && step3B !== "Apron") {
    step5EStandardCeilingFloorTitle = t("5E");
  } else if (step3A0 === "Ceiling" && step3A === "Wall to Wall") {
    step5EStandardCeilingFloorTitle = t("5D");
  } else if (
    step3A0 === "Ceiling" &&
    (step3A === "Left Corner Window" || step3A === "Right Corner Window")
  ) {
    step5EStandardCeilingFloorTitle = t("5E");
  } else if (
    step3A === "Wall to Wall" &&
    step3A0 === "Moulding" &&
    (step3B === "Slight Puddle" || step3B === "Floor")
  ) {
    step5EStandardCeilingFloorTitle = t("5D");
  } else if (step3A === "Wall to Wall") {
    step5EStandardCeilingFloorTitle = t("5E");
  } else if (step3A === "Standard" && step3A0 === "Moulding") {
    step5EStandardCeilingFloorTitle = t("5E");
  } else if (step3A === "Standard") {
    step5EStandardCeilingFloorTitle = t("5F");
  } else if (
    step3A0 === "Moulding" &&
    (step3A === "Left Corner Window" || step3A === "Right Corner Window") &&
    (step3B === "Floor" || step3B === "Slight Puddle")
  ) {
    step5EStandardCeilingFloorTitle = t("5E");
  } else {
    step5EStandardCeilingFloorTitle = t("5D");
  }

  if (step3A0 !== "Wall") {
    if (
      step3A0 === "Ceiling" &&
      step3A === "Wall to Wall" &&
      (step3B === "Sill" || step3B === "Apron")
    ) {
      RoomHeightTitle = t("5E");
    } else if (
      step3A0 === "Ceiling" &&
      step3A === "Standard" &&
      (step3B === "Sill" || step3B === "Apron")
    ) {
      RoomHeightTitle = t("5F");
    } else if (
      step3A0 === "Ceiling" &&
      (step3A === "Left Corner Window" || step3A === "Right Corner Window") &&
      (step3B === "Sill" || step3B === "Apron")
    ) {
      RoomHeightTitle = t("5F");
    } else if (
      step3A === "Standard" &&
      step3A0 === "Moulding" &&
      (step3B === "Sill" || step3B === "Apron")
    ) {
      RoomHeightTitle = t("5F");
    } else if (
      step3A === "Wall to Wall" &&
      step3A0 === "Moulding" &&
      (step3B === "Sill" || step3B === "Apron")
    ) {
      RoomHeightTitle = t("5E");
    } else if (
      step3A0 === "Moulding" &&
      (step3A === "Left Corner Window" || step3A === "Right Corner Window") &&
      (step3B === "Sill" || step3B === "Apron")
    ) {
      RoomHeightTitle = t("5F");
    } else if (step3A === "Wall to Wall") {
      RoomHeightTitle = t("5F");
    } else {
      RoomHeightTitle = t("5G");
    }
  } else {
    if (step3A === "Wall to Wall") {
      RoomHeightTitle = t("5F");
    } else {
      RoomHeightTitle = t("5G");
    }
  }

  if (step3A === "Wall to Wall" && (step3B === "Apron" || step3B === "Sill")) {
    step5EStandardCeilingTitle = t("5D");
  } else if (
    step3A0 === "Ceiling" &&
    step3A === "Standard" &&
    (step3B === "Apron" || step3B === "Sill")
  ) {
    step5EStandardCeilingTitle = t("5E");
  } else if (
    step3A0 === "Ceiling" &&
    (step3A === "Left Corner Window" || step3A === "Right Corner Window") &&
    (step3B === "Sill" || step3B === "Apron")
  ) {
    step5EStandardCeilingTitle = t("5E");
  } else if (
    step3A === "Standard" &&
    step3A0 === "Moulding" &&
    (step3B === "Sill" || step3B === "Apron")
  ) {
    step5EStandardCeilingTitle = t("5E");
  } else if (
    step3A0 === "Moulding" &&
    (step3A === "Left Corner Window" || step3A === "Right Corner Window") &&
    (step3B === "Sill" || step3B === "Apron")
  ) {
    step5EStandardCeilingTitle = t("5E");
  } else {
    step5EStandardCeilingTitle = t("5F");
  }

  if (step3A === "Wall to Wall" && (step3B === "Apron" || step3B === "Sill")) {
    step5ETitle = t("5D");
  } else if (
    step3A0 === "Ceiling" &&
    step3A === "Standard" &&
    (step3B === "Apron" || step3B === "Sill")
  ) {
    step5ETitle = t("5E");
  } else if (
    step3A0 === "Wall" &&
    step3A === "Standard" &&
    (step3B === "Apron" || step3B === "Sill")
  ) {
    step5ETitle = t("5E");
  } else if (
    step3A0 === "Wall" &&
    (step3A === "Right Corner Window" || step3A === "Left Corner Window") &&
    (step3B === "Apron" || step3B === "Sill")
  ) {
    step5ETitle = t("5E");
  } else {
    step5ETitle = t("5F");
  }

  const addFailedFileToParent = (fileItem, errorMessage, errorType = "server") => {
    const failedFileObj = {
      id: fileItem.id,
      name: fileItem.name,
      size: fileItem.size,
      type: fileItem.file.type,
      status: "error",
      errorMessage: errorMessage,
      errorType: errorType,
      url: null,
      uploadedAt: new Date(),
    };

    if (fileItem.file.type === "application/pdf") {
      setUploadedPDFs((prev) => [...prev, failedFileObj]);
    } else {
      setUploadedImages((prev) => [...prev, failedFileObj]);
    }
  };

  const allFilesSorted = [...uploadingFiles, ...uploadedImages, ...uploadedPDFs].sort(
    (a, b) => new Date(a.uploadedAt) - new Date(b.uploadedAt)
  );

  return (
    <div className={`Custom_model_container ${pageLanguage === "fa" ? "font_farsi" : "font_en"}`}>
      <div
        className="noDisplay"
        dep-type="Specify"
        text={t("dep_grommet_1")}
        dep-group=""
        ref={(ref) => ["11", "111"].forEach((dep) => (depDetails.current["1"][dep] = ref))}
      />
      <div
        className="noDisplay"
        dep-type="Specify"
        text={t("dep_grommet_11")}
        dep-group=""
        ref={(ref) => ["11"].forEach((dep) => (depDetails.current["1"][dep] = ref))}
      />
      <div
        className="noDisplay"
        dep-type="Specify"
        text={t("dep_grommet_3")}
        dep-group=""
        ref={(ref) => ["21"].forEach((dep) => (depDetails.current["2"][dep] = ref))}
      />
      <div
        className="noDisplay"
        dep-type="Specify"
        text={t("dep_grommet_2")}
        dep-group=""
        ref={(ref) => ["211"].forEach((dep) => (depDetails.current["2"][dep] = ref))}
      />
      <div
        className="noDisplay"
        dep-type="Check"
        text={t("dep_grommet_2B1")}
        dep-group=""
        ref={(ref) => ["2B1"].forEach((dep) => (depDetails.current["2B"][dep] = ref))}
      />
      <div
        className="noDisplay"
        dep-type="Specify"
        text={"dep_grommet_3A0"}
        dep-group=""
        ref={(ref) => ["3A11", "3A12"].forEach((dep) => (depDetails.current["3A0"][dep] = ref))}
      />
      <div
        className="noDisplay"
        dep-type="Specify"
        text={""}
        dep-group="3"
        ref={(ref) => ["31", "311", "312"].forEach((dep) => (depDetails.current["3"][dep] = ref))}
      />
      <div
        className="noDisplay"
        dep-type="Specify"
        text={"dep_grommet_3A"}
        dep-group=""
        ref={(ref) => ["3A1"].forEach((dep) => (depDetails.current["3"][dep] = ref))}
      />
      <div
        className="noDisplay"
        dep-type="Specify"
        text={"dep_grommet_3ARod"}
        dep-group=""
        ref={(ref) => ["3ARod1"].forEach((dep) => (depDetails.current["3"][dep] = ref))}
      />
      <div
        className="noDisplay"
        dep-type="Specify"
        text={"dep_grommet_3B"}
        dep-group=""
        ref={(ref) => ["3B1"].forEach((dep) => (depDetails.current["3"][dep] = ref))}
      />
      <div
        className="noDisplay"
        dep-type="Specify"
        text={""}
        dep-group="3D"
        ref={(ref) => ["3D1", "3D2"].forEach((dep) => (depDetails.current["3"][dep] = ref))}
      />
      <div
        className="noDisplay"
        dep-type="Specify"
        text={""}
        dep-group="3EStandardCeiling"
        ref={(ref) =>
          ["3EStandardCeiling1", "3EStandardCeiling2", "3EStandardCeiling3"].forEach(
            (dep) => (depDetails.current["3"][dep] = ref)
          )
        }
      />
      <div
        className="noDisplay"
        dep-type="Specify"
        text={""}
        dep-group="3EStandardCeilingFloor"
        ref={(ref) =>
          ["3EStandardCeilingFloor1", "3EStandardCeilingFloor2", "3EStandardCeilingFloor3"].forEach(
            (dep) => (depDetails.current["3"][dep] = ref)
          )
        }
      />
      <div
        className="noDisplay"
        dep-type="Check"
        text={t("")}
        dep-group="6"
        ref={(ref) => ["61"].forEach((dep) => (depDetails.current["6"][dep] = ref))}
      />

      <div
        className="noDisplay"
        dep-type="Check"
        text={t("step6Aerror")}
        dep-group=""
        ref={(ref) => ["6A"].forEach((dep) => (depDetails.current["6"][dep] = ref))}
      />
      <div
        className="noDisplay"
        dep-type="Check"
        text={t("step6Berror")}
        dep-group=""
        ref={(ref) => ["6B"].forEach((dep) => (depDetails.current["6"][dep] = ref))}
      />
      <div
        className="noDisplay"
        dep-type="Check"
        text={t("step6Cerror")}
        dep-group=""
        ref={(ref) => ["6C"].forEach((dep) => (depDetails.current["6"][dep] = ref))}
      />
      <div
        className="noDisplay"
        dep-type="Select"
        text={t("dep_grommet_81")}
        dep-group=""
        ref={(ref) => ["81"].forEach((dep) => (depDetails.current["8"][dep] = ref))}
      />
      <div
        className="noDisplay"
        dep-type="Select"
        text={t("dep_grommet_82")}
        dep-group=""
        ref={(ref) => ["82"].forEach((dep) => (depDetails.current["8"][dep] = ref))}
      />
      <div
        className="noDisplay"
        dep-type="Select"
        text={t("dep_grommet_83")}
        dep-group=""
        ref={(ref) => ["83"].forEach((dep) => (depDetails.current["8"][dep] = ref))}
      />
      <div
        className="noDisplay"
        dep-type="Check"
        text={step9ADrapery === "Rod" ? t("dep_drapery_809") : t("dep_drapery_810")}
        dep-group=""
        ref={(ref) => ["84"].forEach((dep) => (depDetails.current["8"][dep] = ref))}
      />
      <div
        className="noDisplay"
        dep-type="Check"
        text={step8B === "Rod" ? t("dep_sheerRod_849") : t("dep_sheerTrack_849")}
        dep-group=""
        ref={(ref) => ["849"].forEach((dep) => (depDetails.current["8"][dep] = ref))}
      />
      <div
        className="noDisplay"
        dep-type="Select"
        text={t("dep_grommet_85")}
        dep-group=""
        ref={(ref) => ["85"].forEach((dep) => (depDetails.current["8"][dep] = ref))}
      />

      <div
        className="noDisplay"
        dep-type="Select"
        text={t("dep_grommet_86")}
        dep-group=""
        ref={(ref) => ["86"].forEach((dep) => (depDetails.current["8"][dep] = ref))}
      />
      <div
        className="noDisplay"
        dep-type="Select"
        text={t("dep_grommet_87")}
        dep-group=""
        ref={(ref) => ["87"].forEach((dep) => (depDetails.current["8"][dep] = ref))}
      />
      <div
        className="noDisplay"
        dep-type="Select"
        text={t("dep_grommet_809")}
        dep-group=""
        ref={(ref) => ["809"].forEach((dep) => (depDetails.current["8"][dep] = ref))}
      />
      <div
        className="noDisplay"
        dep-type="Select"
        text={t("dep_grommet_810")}
        dep-group=""
        ref={(ref) => ["810"].forEach((dep) => (depDetails.current["8"][dep] = ref))}
      />
      <div
        className="noDisplay"
        dep-type="Select"
        text={t("dep_grommet_8A1_new")}
        dep-group=""
        ref={(ref) => ["811"].forEach((dep) => (depDetails.current["8"][dep] = ref))}
      />
      <div
        className="noDisplay"
        dep-type="Select"
        text={t("dep_grommet_8A1_new")}
        dep-group=""
        ref={(ref) => ["8A1"].forEach((dep) => (depDetails.current["8"][dep] = ref))}
      />
      <div
        className="noDisplay"
        dep-type="Select"
        text={t("dep_grommet_8A1_new")}
        dep-group=""
        ref={(ref) => ["801"].forEach((dep) => (depDetails.current["8"][dep] = ref))}
      />
      <div
        className="noDisplay"
        dep-type="Select"
        text={t("dep_grommet_8A2_new")}
        dep-group=""
        ref={(ref) => ["8A2"].forEach((dep) => (depDetails.current["8"][dep] = ref))}
      />
      <div
        className="noDisplay"
        dep-type="Select"
        text={t("dep_grommet_8A2_new")}
        dep-group=""
        ref={(ref) => ["812"].forEach((dep) => (depDetails.current["8"][dep] = ref))}
      />
      <div
        className="noDisplay"
        dep-type="Select"
        text={t("dep_grommet_8A2_new2")}
        dep-group=""
        ref={(ref) => ["842"].forEach((dep) => (depDetails.current["8"][dep] = ref))}
      />
      <div
        className="noDisplay"
        dep-type="Select"
        text={t("dep_grommet_8A2_new4")}
        dep-group=""
        ref={(ref) => ["844"].forEach((dep) => (depDetails.current["8"][dep] = ref))}
      />
      <div
        className="noDisplay"
        dep-type="Select"
        text={t("dep_grommet_8A3_new")}
        dep-group=""
        ref={(ref) => ["8A3"].forEach((dep) => (depDetails.current["8"][dep] = ref))}
      />
      <div
        className="noDisplay"
        dep-type="Select"
        text={t("dep_grommet_8A3_new")}
        dep-group=""
        ref={(ref) => ["813"].forEach((dep) => (depDetails.current["8"][dep] = ref))}
      />
      <div
        className="noDisplay"
        dep-type="Select"
        text={t("dep_grommet_8A3")}
        dep-group=""
        ref={(ref) => ["843"].forEach((dep) => (depDetails.current["8"][dep] = ref))}
      />
      <div
        className="noDisplay"
        dep-type="Select"
        text={t("dep_grommet_8A5")}
        dep-group=""
        ref={(ref) => ["8A5"].forEach((dep) => (depDetails.current["8"][dep] = ref))}
      />
      <div
        className="noDisplay"
        dep-type="Select"
        text={t("dep_grommet_850")}
        dep-group=""
        ref={(ref) => ["850"].forEach((dep) => (depDetails.current["8"][dep] = ref))}
      />
      <div
        className="noDisplay"
        dep-type="Select"
        text={t("dep_grommet_852")}
        dep-group=""
        ref={(ref) => ["852"].forEach((dep) => (depDetails.current["8"][dep] = ref))}
      />
      <div
        className="noDisplay"
        dep-type="Select"
        text={t("dep_grommet_853")}
        dep-group=""
        ref={(ref) => ["853"].forEach((dep) => (depDetails.current["8"][dep] = ref))}
      />
      <div
        className="noDisplay"
        dep-type="Select"
        text={t("dep_grommet_854")}
        dep-group=""
        ref={(ref) => ["854"].forEach((dep) => (depDetails.current["8"][dep] = ref))}
      />
      <div
        className="noDisplay"
        dep-type="Select"
        text={t("dep_grommet_855")}
        dep-group=""
        ref={(ref) => ["855"].forEach((dep) => (depDetails.current["8"][dep] = ref))}
      />
      <div
        className="noDisplay"
        dep-type="Complete"
        text={t("dep_grommet_856")}
        dep-group=""
        ref={(ref) => ["856"].forEach((dep) => (depDetails.current["8"][dep] = ref))}
      />
      <div
        className="noDisplay"
        dep-type="Select"
        text={t("dep_grommet_857")}
        dep-group=""
        ref={(ref) => ["857"].forEach((dep) => (depDetails.current["8"][dep] = ref))}
      />
      <div
        className="noDisplay"
        dep-type="Select"
        text={step8C === "Rod" ? t("dep_layerRod_858") : t("dep_layerTrack_858")}
        dep-group=""
        ref={(ref) => ["858"].forEach((dep) => (depDetails.current["8"][dep] = ref))}
      />
      <div
        className="noDisplay"
        dep-type="Select"
        text={t("dep_grommet_859")}
        dep-group=""
        ref={(ref) => ["859"].forEach((dep) => (depDetails.current["8"][dep] = ref))}
      />
      <div
        className="noDisplay"
        dep-type="Select"
        text={t("dep_grommet_860")}
        dep-group=""
        ref={(ref) => ["860"].forEach((dep) => (depDetails.current["8"][dep] = ref))}
      />
      <div
        className="noDisplay"
        dep-type="Select"
        text={t("dep_grommet_861")}
        dep-group=""
        ref={(ref) => ["861"].forEach((dep) => (depDetails.current["8"][dep] = ref))}
      />
      <div
        className="noDisplay"
        dep-type="Select"
        text={t("dep_grommet_862")}
        dep-group=""
        ref={(ref) => ["862"].forEach((dep) => (depDetails.current["8"][dep] = ref))}
      />
      <div
        className="noDisplay"
        dep-type="Select"
        text={t("dep_grommet_863")}
        dep-group=""
        ref={(ref) => ["863"].forEach((dep) => (depDetails.current["8"][dep] = ref))}
      />
      <div
        className="noDisplay"
        dep-type="Complete"
        text={t("dep_grommet_864")}
        dep-group=""
        ref={(ref) => ["864"].forEach((dep) => (depDetails.current["8"][dep] = ref))}
      />
      <div
        className="noDisplay"
        dep-type="Select"
        text={t("dep_grommet_865")}
        dep-group=""
        ref={(ref) => ["865"].forEach((dep) => (depDetails.current["8"][dep] = ref))}
      />
      <div
        className="noDisplay"
        dep-type="Select"
        text={t("dep_grommet_8B1")}
        dep-group=""
        ref={(ref) => ["8B1"].forEach((dep) => (depDetails.current["8"][dep] = ref))}
      />
      <div
        className="noDisplay"
        dep-type="Select"
        text={t("dep_grommet_8B2")}
        dep-group=""
        ref={(ref) => ["8B2"].forEach((dep) => (depDetails.current["8"][dep] = ref))}
      />
      <div
        className="noDisplay"
        dep-type="Select"
        text={t("dep_grommet_8B3")}
        dep-group=""
        ref={(ref) => ["8B3"].forEach((dep) => (depDetails.current["8"][dep] = ref))}
      />
      <div
        className="noDisplay"
        dep-type="Select"
        text={t("dep_grommet_8B5")}
        dep-group=""
        ref={(ref) => ["8B5"].forEach((dep) => (depDetails.current["8"][dep] = ref))}
      />
      <div
        className="noDisplay"
        dep-type="Select"
        text={t("dep_grommet_8B51")}
        dep-group=""
        ref={(ref) => ["8B51"].forEach((dep) => (depDetails.current["8"][dep] = ref))}
      />
      <div
        className="noDisplay"
        dep-type="Select"
        text={t("dep_grommet_8B6")}
        dep-group=""
        ref={(ref) => ["8B6"].forEach((dep) => (depDetails.current["8"][dep] = ref))}
      />
      <div
        className="noDisplay"
        dep-type="Select"
        text={t("dep_grommet_8C1")}
        dep-group=""
        ref={(ref) => ["8C1"].forEach((dep) => (depDetails.current["8"][dep] = ref))}
      />
      <div
        className="noDisplay"
        dep-type="Select"
        text={t("dep_grommet_8C2")}
        dep-group=""
        ref={(ref) => ["8C2"].forEach((dep) => (depDetails.current["8"][dep] = ref))}
      />
      <div
        className="noDisplay"
        dep-type="Select"
        text={t("dep_grommet_8C3_new")}
        dep-group=""
        ref={(ref) => ["8C3"].forEach((dep) => (depDetails.current["8"][dep] = ref))}
      />
      <div
        className="noDisplay"
        dep-type="Select"
        text={t("dep_grommet_8C5_new")}
        dep-group=""
        ref={(ref) => ["8C5"].forEach((dep) => (depDetails.current["8"][dep] = ref))}
      />
      <div
        className="noDisplay"
        dep-type="Complete"
        text={t("dep_grommet_8P5")}
        dep-group=""
        ref={(ref) => ["8P5"].forEach((dep) => (depDetails.current["8"][dep] = ref))}
      />
      <div
        className="noDisplay"
        dep-type="Select"
        text={t("dep_grommet_8P6")}
        dep-group=""
        ref={(ref) => ["8P6"].forEach((dep) => (depDetails.current["8"][dep] = ref))}
      />
      <div
        className="noDisplay"
        dep-type="Select"
        text={t("dep_grommet_8C5_9A")}
        dep-group=""
        ref={(ref) => ["845"].forEach((dep) => (depDetails.current["8"][dep] = ref))}
      />
      <div
        className="noDisplay"
        dep-type="Complete"
        text={t("dep_grommet_8P5-9A")}
        dep-group=""
        ref={(ref) => ["846"].forEach((dep) => (depDetails.current["8"][dep] = ref))}
      />
      <div
        className="noDisplay"
        dep-type="Select"
        text={t("dep_grommet_8P6-9A")}
        dep-group=""
        ref={(ref) => ["847"].forEach((dep) => (depDetails.current["8"][dep] = ref))}
      />
      <div
        className="noDisplay"
        dep-type="Select"
        text={t("dep_grommet_CORD_9A")}
        dep-group=""
        ref={(ref) => ["848"].forEach((dep) => (depDetails.current["8"][dep] = ref))}
      />
      <div
        className="noDisplay"
        dep-type="Select"
        text={t("dep_grommet_8C51")}
        dep-group=""
        ref={(ref) => ["8C51"].forEach((dep) => (depDetails.current["8"][dep] = ref))}
      />
      <div
        className="noDisplay"
        dep-type="Select"
        text={t("dep_grommet_8C52")}
        dep-group=""
        ref={(ref) => ["8C52"].forEach((dep) => (depDetails.current["8"][dep] = ref))}
      />
      <div
        className="noDisplay"
        dep-type="Select"
        text={t("dep_grommet_8C6")}
        dep-group=""
        ref={(ref) => ["8C6"].forEach((dep) => (depDetails.current["8"][dep] = ref))}
      />
      <div
        className="noDisplay"
        dep-type="Complete"
        text={""}
        dep-group="10"
        ref={(ref) => ["1001", "1002"].forEach((dep) => (depDetails.current["6"][dep] = ref))}
      />

      <div className="models_title_div">
        <h1>
          {defaultModelName === undefined || defaultModelName === ""
            ? " "
            : pageLanguage === "fa"
            ? convertToPersian(defaultModelNameFa) + " سفارشی "
            : "Custom " + defaultModelName}
        </h1>
        {defaultModelDesc && defaultModelDesc !== "" && (
          <h2>{pageLanguage === "fa" ? convertToPersian(defaultModelDescFa) : defaultModelDesc}</h2>
        )}
      </div>
      <div
        className="model_customize_container"
        style={{ justifyContent: "space-between", minHeight: "100%", backgroundColor: "#ece9e580" }}
      >
        <div
          className={
            offset ? "model_customize_image model_customize_image_fixed" : "model_customize_image"
          }
          ref={fixedDiv}
        >
          <div className="fixed-div">
            {defaultFabricPhoto && (
              <img src={imgUrl(defaultFabricPhoto)} className="img-fluid_allShade" alt="" />
            )}
          </div>
        </div>
        <div
          className={`model_customize_section ${pageLanguage === "fa" ? "font_farsi" : "font_en"}`}
          style={{ marginInlineStart: "0", background: "#fff" }}
        >
          <Accordion ref={accordion} flush activeKey={accordionActiveKey}>
            {/* step 1 */}
            <Card>
              <Card.Header>
                <ContextAwareToggle
                  eventKey="1"
                  stepNum={t("1")}
                  stepTitle={t("grommet_step1")}
                  stepRef="1"
                  type="1"
                  required={requiredStep["1"]}
                  stepSelected={stepSelectedLabel["1"] === undefined ? "" : stepSelectedLabel["1"]}
                />
              </Card.Header>
              <Accordion.Collapse eventKey="1">
                <Card.Body>
                  <div className="card_body card-body-fabric card-body-fabric-sheer 1">
                    <div className="search_filter_container">
                      <div className="search_container">
                        <div className="search_box">
                          <input
                            type="text"
                            placeholder={t("Search for product Name/Code")}
                            className="form-control search_input"
                            name="search_input"
                            value={searchText}
                            ref={search_input}
                            onChange={(e) => {
                              if (e.target.value !== "") setSearchShow(true);
                              else setSearchShow(false);
                              setSearchText(e.target.value);
                            }}
                          />
                          {searchShow && (
                            <div
                              className="clear-icon-container"
                              onClick={() => {
                                search_input.current.value = "";
                                setSearchText("");
                                setSearchShow(false);
                              }}
                            >
                              <i className="fa fa-times-circle clear-icon" />
                            </div>
                          )}
                          <div className="search-icon-container">
                            <i className="fa fa-search " />
                          </div>
                        </div>
                        <div
                          className="filters_show_hide_container"
                          onClick={() => {
                            if (filtersShow) {
                              setFiltersShow(false);
                            } else {
                              setFiltersShow(true);
                            }
                          }}
                        >
                          <span className="filters_toggle">{t("Filters")}</span>
                          <span className="filters_indicator">
                            {filtersShow && (
                              <img
                                className="arrow_down img-fluid"
                                src={require("../Images/public/arrow_up.svg").default}
                                alt=""
                              />
                            )}
                            {!filtersShow && (
                              <img
                                className="arrow_down img-fluid"
                                src={require("../Images/public/arrow_down.svg").default}
                                alt=""
                              />
                            )}
                          </span>
                        </div>
                      </div>
                      <div
                        className={
                          filtersShow
                            ? "filters_container desktop_only"
                            : "filters_container desktop_only filters_container_hidden"
                        }
                      >
                        <div className="filter_container">
                          <Dropdown autoClose="outside" title="">
                            <Dropdown.Toggle className="dropdown_btn">
                              <p>{t("filter_Color")}</p>
                              {/*<img className="select_control_handle_close img-fluid" src={require('../Images/public/arrow_down.svg').default} alt=""/>*/}
                              <div className="select_control_handle_close img-fluid" />
                            </Dropdown.Toggle>
                            <Dropdown.Menu className="filter_color_items">
                              <div className="filter_items_container">{sewingColors}</div>
                              <div className="filter_inside_button_section">
                                <div
                                  className="clear_inside_filter"
                                  text="colors"
                                  onClick={(e) => clearFilters(e)}
                                >
                                  {/* {t("filter_Clear Filters")} */}
                                  {i18n.language === "fa" ? "حذف فیلترها" : "Clear Filters"}
                                </div>
                                <Dropdown.Toggle as="div" className="done_inside_filter">
                                  {t("filter_Done")}
                                </Dropdown.Toggle>
                              </div>
                            </Dropdown.Menu>
                          </Dropdown>
                        </div>
                        <div className="filter_container">
                          <Dropdown autoClose="outside" title="">
                            <Dropdown.Toggle className="dropdown_btn">
                              <p>{t("filter_Pattern")}</p>
                              {/*<img className="select_control_handle_close img-fluid" src={require('../Images/public/arrow_down.svg').default} alt=""/>*/}
                              <div className="select_control_handle_close img-fluid" />
                            </Dropdown.Toggle>
                            <Dropdown.Menu>
                              <div className="filter_items_container">{sewingPatterns}</div>
                              <div className="filter_inside_button_section">
                                <div
                                  className="clear_inside_filter"
                                  text="patterns"
                                  onClick={(e) => clearFilters(e)}
                                >
                                  {/* {t("filter_Clear Filters")} */}
                                  {i18n.language === "fa" ? "حذف فیلترها" : "Clear Filters"}
                                </div>
                                <Dropdown.Toggle as="div" className="done_inside_filter">
                                  {t("filter_Done")}
                                </Dropdown.Toggle>
                              </div>
                            </Dropdown.Menu>
                          </Dropdown>
                        </div>
                        <div className="filter_container">
                          <Dropdown autoClose="outside" title="">
                            <Dropdown.Toggle className="dropdown_btn">
                              <p>{t("filter_Type")}</p>
                              <div className="select_control_handle_close img-fluid" />
                            </Dropdown.Toggle>
                            <Dropdown.Menu>
                              <div className="filter_items_container">{sewingTypes}</div>
                              <div className="filter_inside_button_section">
                                <div
                                  className="clear_inside_filter"
                                  text="types"
                                  onClick={(e) => clearFilters(e)}
                                >
                                  {i18n.language === "fa" ? "حذف فیلترها" : "Clear Filters"}
                                </div>
                                <Dropdown.Toggle as="div" className="done_inside_filter">
                                  {t("filter_Done")}
                                </Dropdown.Toggle>
                              </div>
                            </Dropdown.Menu>
                          </Dropdown>
                        </div>
                        <div className="filter_container">
                          <Dropdown autoClose="outside" title="">
                            <Dropdown.Toggle className="dropdown_btn">
                              <p>{t("filter_Price")}</p>
                              <div className="select_control_handle_close img-fluid" />
                            </Dropdown.Toggle>
                            <Dropdown.Menu>
                              <div className="filter_items_container">{sewingPrices}</div>
                              <div className="filter_inside_button_section">
                                <div
                                  className="clear_inside_filter"
                                  text="prices"
                                  onClick={(e) => clearFilters(e)}
                                >
                                  {i18n.language === "fa" ? "حذف فیلترها" : "Clear Filters"}
                                </div>
                                <Dropdown.Toggle as="div" className="done_inside_filter">
                                  {t("filter_Done")}
                                </Dropdown.Toggle>
                              </div>
                            </Dropdown.Menu>
                          </Dropdown>
                        </div>
                      </div>
                    </div>

                    <div ref={fabricsContainerRef} className="fabrics_list_container 1">
                      {fabricsList.length === 0 && showEmptyMessage ? (
                        <div
                          className={`material_detail ${
                            pageLanguage === "fa" ? "font_farsi" : "font_en"
                          }`}
                          key={"fabric" + "empty"}
                        >
                          <div
                            className={`material_traits ${
                              pageLanguage === "fa" ? "font_farsi" : "font_en"
                            }`}
                          >
                            <h5 className="empty_fabrics">
                              {pageLanguage === "en"
                                ? "Sorry, no matching fabrics.\nTo view more results, try clearing your filters."
                                : "متاسفانه این محصول را موجود نداریم.\nبرای دیدن نتایج بهتر، فیلترها را تغییر دهید."}
                            </h5>
                            <button
                              className="empty_fabrics_btn white_btn btn"
                              onClick={() => {
                                setFabricsList([
                                  <div
                                    className={`material_detail ${
                                      pageLanguage === "fa" ? "font_farsi" : "font_en"
                                    }`}
                                    key={"fabric" + "empty"}
                                  >
                                    <div
                                      className={`material_traits ${
                                        pageLanguage === "fa" ? "font_farsi" : "font_en"
                                      }`}
                                    >
                                      <h5 className="empty_fabrics">
                                        {pageLanguage === "en"
                                          ? "Sorry, no matching fabrics.\nTo view more results, try clearing your filters."
                                          : "متاسفانه این محصول را موجود نداریم.\nبرای دیدن نتایج بهتر، فیلترها را تغییر دهید."}
                                      </h5>
                                      <button className="empty_fabrics_btn white_btn btn">
                                        {pageLanguage === "fa" ? "در حال پاک کردن" : "CLEARING"}
                                      </button>
                                    </div>
                                  </div>,
                                ]);
                                setTimeout(() => {
                                  setIsClearAll(true);
                                }, 300);
                              }}
                            >
                              {pageLanguage === "fa"
                                ? "همه فیلترها را پاک کنید"
                                : "CLEAR ALL FILTERS"}
                            </button>
                          </div>
                        </div>
                      ) : (
                        fabricsList
                      )}
                    </div>
                    <NextStep currentStep="1" eventKey="2">
                      {t("NEXT STEP")}
                    </NextStep>
                  </div>
                </Card.Body>
              </Accordion.Collapse>
            </Card>
            {/* step 2 */}
            <Card>
              <Card.Header>
                <ContextAwareToggle
                  eventKey="2"
                  stepNum={t("2")}
                  stepTitle={t("grommet_step2")}
                  stepRef="2"
                  type="1"
                  required={requiredStep["2"]}
                  stepSelected={stepSelectedLabel["2"] === undefined ? "" : stepSelectedLabel["2"]}
                />
              </Card.Header>
              <Accordion.Collapse eventKey="2">
                <Card.Body>
                  <div className="card_body card-body-fabric card-body-fabric-sheer 2">
                    <div className="search_filter_container">
                      <div className="search_container">
                        <div className="search_box">
                          <input
                            type="text"
                            placeholder={t("Search for product Name/Code")}
                            className="form-control search_input"
                            name="search_input"
                            value={searchText2}
                            ref={search_input2}
                            onChange={(e) => {
                              if (e.target.value !== "") setSearchShow2(true);
                              else setSearchShow2(false);
                              setSearchText2(e.target.value);
                            }}
                          />
                          {searchShow2 && (
                            <div
                              className="clear-icon-container"
                              onClick={() => {
                                search_input2.current.value = "";
                                setSearchText2("");
                                setSearchShow2(false);
                              }}
                            >
                              <i className="fa fa-times-circle clear-icon" />
                            </div>
                          )}
                          <div className="search-icon-container">
                            <i className="fa fa-search" />
                          </div>
                        </div>
                        <div
                          className="filters_show_hide_container"
                          onClick={() => {
                            if (filtersShow2) {
                              setFiltersShow2(false);
                            } else {
                              setFiltersShow2(true);
                            }
                          }}
                        >
                          <span className="filters_toggle">{t("Filters")}</span>
                          <span className="filters_indicator">
                            {filtersShow2 && (
                              <img
                                className="arrow_down img-fluid"
                                src={require("../Images/public/arrow_up.svg").default}
                                alt=""
                              />
                            )}
                            {!filtersShow2 && (
                              <img
                                className="arrow_down img-fluid"
                                src={require("../Images/public/arrow_down.svg").default}
                                alt=""
                              />
                            )}
                          </span>
                        </div>
                      </div>
                      <div
                        className={
                          filtersShow2
                            ? "filters_container desktop_only"
                            : "filters_container desktop_only filters_container_hidden"
                        }
                      >
                        <div className="filter_container">
                          <Dropdown autoClose="outside" title="">
                            <Dropdown.Toggle className="dropdown_btn">
                              <p>{t("filter_Color")}</p>
                              <div className="select_control_handle_close img-fluid" />
                            </Dropdown.Toggle>
                            <Dropdown.Menu className="filter_color_items">
                              <div className="filter_items_container">{sewingColorsSheer}</div>
                              <div className="filter_inside_button_section">
                                <div
                                  className="clear_inside_filter"
                                  text="colors"
                                  data-step="2"
                                  onClick={(e) => clearFilters(e)}
                                >
                                  {i18n.language === "fa" ? "حذف فیلترها" : "Clear Filters"}
                                </div>
                                <Dropdown.Toggle as="div" className="done_inside_filter">
                                  {t("filter_Done")}
                                </Dropdown.Toggle>
                              </div>
                            </Dropdown.Menu>
                          </Dropdown>
                        </div>
                        <div className="filter_container">
                          <Dropdown autoClose="outside" title="">
                            <Dropdown.Toggle className="dropdown_btn">
                              <p>{t("filter_Pattern")}</p>
                              <div className="select_control_handle_close img-fluid" />
                            </Dropdown.Toggle>
                            <Dropdown.Menu>
                              <div className="filter_items_container">{sewingPatternsSheer}</div>
                              <div className="filter_inside_button_section">
                                <div
                                  className="clear_inside_filter"
                                  text="patterns"
                                  data-step="2"
                                  onClick={(e) => clearFilters(e)}
                                >
                                  {i18n.language === "fa" ? "حذف فیلترها" : "Clear Filters"}
                                </div>
                                <Dropdown.Toggle as="div" className="done_inside_filter">
                                  {t("filter_Done")}
                                </Dropdown.Toggle>
                              </div>
                            </Dropdown.Menu>
                          </Dropdown>
                        </div>
                        <div className="filter_container">
                          <Dropdown autoClose="outside" title="">
                            <Dropdown.Toggle className="dropdown_btn">
                              <p>{t("filter_Type")}</p>
                              <div className="select_control_handle_close img-fluid" />
                            </Dropdown.Toggle>
                            <Dropdown.Menu>
                              <div className="filter_items_container">{sewingTypesSheer}</div>
                              <div className="filter_inside_button_section">
                                <div
                                  className="clear_inside_filter"
                                  text="types"
                                  data-step="2"
                                  onClick={(e) => clearFilters(e)}
                                >
                                  {i18n.language === "fa" ? "حذف فیلترها" : "Clear Filters"}
                                </div>
                                <Dropdown.Toggle as="div" className="done_inside_filter">
                                  {t("filter_Done")}
                                </Dropdown.Toggle>
                              </div>
                            </Dropdown.Menu>
                          </Dropdown>
                        </div>
                        <div className="filter_container">
                          <Dropdown autoClose="outside" title="">
                            <Dropdown.Toggle className="dropdown_btn">
                              <p>{t("filter_Price")}</p>
                              <div className="select_control_handle_close img-fluid" />
                            </Dropdown.Toggle>
                            <Dropdown.Menu>
                              <div className="filter_items_container">
                                <div className="price_filter_description">
                                  {t("filter_price_title")}
                                </div>
                                {sewingPricesSheer}
                              </div>
                              <div className="filter_inside_button_section">
                                <div
                                  className="clear_inside_filter"
                                  text="prices"
                                  data-step="2"
                                  onClick={(e) => clearFilters(e)}
                                >
                                  {i18n.language === "fa" ? "حذف فیلترها" : "Clear Filters"}
                                </div>
                                <Dropdown.Toggle as="div" className="done_inside_filter">
                                  {t("filter_Done")}
                                </Dropdown.Toggle>
                              </div>
                            </Dropdown.Menu>
                          </Dropdown>
                        </div>
                      </div>
                    </div>

                    <div ref={fabricsContainerRef2} className="fabrics_list_container 2">
                      {loading2 ? (
                        ""
                      ) : showEmptyMessage2 ? (
                        <div
                          className={`material_detail ${
                            pageLanguage === "fa" ? "font_farsi" : "font_en"
                          }`}
                          key={"fabric2" + "empty"}
                        >
                          <div
                            className={`material_traits ${
                              pageLanguage === "fa" ? "font_farsi" : "font_en"
                            }`}
                          >
                            <h5 className="empty_fabrics">
                              {pageLanguage === "en"
                                ? "Sorry, no matching fabrics.\nTo view more results, try clearing your filters."
                                : "متاسفانه این محصول را موجود نداریم.\nبرای دیدن نتایج بهتر، فیلترها را تغییر دهید."}
                            </h5>
                            <button
                              className="empty_fabrics_btn white_btn btn"
                              onClick={() => {
                                setShowEmptyMessage2(false);
                                filterCheckboxes.current["colorsSheer"].forEach((obj) => {
                                  if (obj !== null) obj.checked = false;
                                });
                                filterCheckboxes.current["patternsSheer"].forEach((obj) => {
                                  if (obj !== null) obj.checked = false;
                                });
                                filterCheckboxes.current["typesSheer"].forEach((obj) => {
                                  if (obj !== null) obj.checked = false;
                                });
                                filterCheckboxes.current["pricesSheer"].forEach((obj) => {
                                  if (obj !== null) obj.checked = false;
                                });
                                if (search_input2.current) search_input2.current.value = "";
                                setSearchText2("");
                                setSearchShow2(false);
                                setFilterColors2([]);
                                setFilterPatterns2([]);
                                setFilterTypes2([]);
                                setFilterPrices2([]);
                              }}
                            >
                              {pageLanguage === "fa"
                                ? "همه فیلترها را پاک کنید"
                                : "CLEAR ALL FILTERS"}
                            </button>
                          </div>
                        </div>
                      ) : (
                        fabricsList2
                      )}
                    </div>
                    <NextStep currentStep="2" eventKey={step2 !== "" ? "2A" : "2B"}>
                      {t("NEXT STEP")}
                    </NextStep>
                  </div>
                </Card.Body>
              </Accordion.Collapse>
            </Card>
            {/* step 2A */}
            <Step2APleated
              ContextAwareToggle={ContextAwareToggle}
              t={t}
              step2={step2}
              step2A={step2A}
              accordionActiveKey={accordionActiveKey}
              requiredStep={requiredStep}
              stepSelectedLabel={stepSelectedLabel}
              step8={step8}
              modalHandleShow={modalHandleShow}
              setSheerHeaderStyleTemp={setSheerHeaderStyleTemp}
              setStep2A={setStep2A}
              setDeps={setDeps}
              setCart={setCart}
              selectChanged={selectChanged}
              setSheersModelId={setSheersModelId}
              inputs={inputs}
              NextStep={NextStep}
            />
            {/* step 3 */}
            <Card>
              <Card.Header>
                <ContextAwareToggle
                  eventKey="2B"
                  stepNum={t("3")}
                  stepTitle={t("grommet3_step2")}
                  stepRef="2B"
                  type="1"
                  required={requiredStep["2B"]}
                  stepSelected={
                    stepSelectedLabel["2B"] === undefined ? "" : stepSelectedLabel["2B"]
                  }
                />
              </Card.Header>
              <Accordion.Collapse eventKey="2B">
                <Card.Body>
                  <div className="card_body card_body_radio card-body-fabric_grommet">
                    <div className="box33 radio_style">
                      <input
                        className="radio"
                        type="radio"
                        text={t("pl_None")}
                        value="1"
                        name="step2B"
                        ref-num="2B"
                        id="2B1"
                        checked={step2B === "None"}
                        onChange={(e) => {
                          setStep2B("None");
                          setStep2B1("");
                          setStep2C("");
                          setStep6C("");
                          let tempExtended = extendedTitle;
                          tempExtended["6"].splice(3, 1);
                          if (step8 === "I Want To Customize Hardware Per Curtain") {
                            setStep8C("");
                            setStep8C1("");
                            setStep8CTrack("");
                            setStep8C2("");
                            setStep8C3("");
                            tempExtended["8C"] = [];
                            selectChanged(e, "8C");
                            setCart(
                              "PrivacyLayer",
                              "None",
                              "SheersId1,SheersId2,SheersDesignFa,SheersDesignEn,SheersColorEn,SheersColorFa,SheersPhotoUrl,PrivacyLayerHeaderStyle,PrivacyLayerHeaderStyleID,PrivacyLayerHardware,RailIdC,BatonOptionC,ControlPositionC,RailDesignC,RailDesignEnC,RailDesignFaC,RailColorEnC,RailColorFaC,RodColorC,hardwarePrivacyLayer,PanelTypeC"
                            );
                            setDeps("", "2B,2B1,2C,6C,8C,8C1,8C2,8C3,8C5,8C51,8C52,8C6");
                          } else if (step8 === "I Have My Own Hardware") {
                            selectChanged(e);
                            setCart(
                              "PrivacyLayer",
                              "None",
                              "SheersId1,SheersId2,SheersDesignFa,SheersDesignEn,SheersColorEn,SheersColorFa,SheersPhotoUrl,PrivacyLayerHeaderStyle,PrivacyLayerHeaderStyleID,PrivacyLayerHardware,RailIdC,BatonOptionC,ControlPositionC,RailDesignC,RailDesignEnC,RailDesignFaC,RailColorEnC,RailColorFaC,RodColorC,hardwarePrivacyLayer,PanelTypeC"
                            );
                            setDeps("", "2B,2B1,2C,6C,87");
                          } else {
                            selectChanged(e, "6");
                            setCart(
                              "PrivacyLayer",
                              "None",
                              "SheersId1,SheersId2,SheersDesignFa,SheersDesignEn,SheersColorEn,SheersColorFa,SheersPhotoUrl,PrivacyLayerHeaderStyle,PrivacyLayerHeaderStyleID,hardwarePrivacyLayer,PanelTypeC"
                            );
                            setDeps("", "2B,2B1,2C,6C");

                            setSheersModelId2("0036");
                          }
                          setExtendedTitle(tempExtended);
                        }}
                        ref={(ref) => (inputs.current["2B1"] = ref)}
                      />
                      <label htmlFor="2B1">{t("pl_None")}</label>
                    </div>
                    <div className="box33 radio_style">
                      <input
                        className="radio"
                        type="radio"
                        text={t("Semi Sheer")}
                        value="2"
                        name="step2B"
                        ref-num="2B"
                        id="2B2"
                        checked={step2B === "Semi Sheer"}
                        onChange={(e) => {
                          if (
                            step2B === "None" &&
                            step8 === "I Want To Customize Hardware Per Curtain"
                          ) {
                            selectChanged(e);
                            setCart(
                              "PrivacyLayer",
                              "Semi Sheer",
                              "SheersId1,SheersId2,SheersDesignFa,SheersDesignEn,SheersColorEn,SheersColorFa,SheersPhotoUrl,PrivacyLayerHeaderStyle,PrivacyLayerHeaderStyleID"
                            );
                            setDeps(
                              "2B1,2C,8C" + (step6 === "Customize Style Per Curtain" ? ",6C" : ""),
                              "2B"
                            );
                          } else if (step2B === "None" && step8 === "I Have My Own Hardware") {
                            selectChanged(e);
                            setCart(
                              "PrivacyLayer",
                              "Semi Sheer",
                              "SheersId1,SheersId2,SheersDesignFa,SheersDesignEn,SheersColorEn,SheersColorFa,SheersPhotoUrl,PrivacyLayerHeaderStyle,PrivacyLayerHeaderStyleID"
                            );
                            setDeps(
                              "2B1,2C,87" + (step6 === "Customize Style Per Curtain" ? ",6C" : ""),
                              "2B"
                            );
                          } else {
                            if (step2B === "None") {
                              selectChanged(e);
                              setCart(
                                "PrivacyLayer",
                                "Semi Sheer",
                                "SheersId1,SheersId2,SheersDesignFa,SheersDesignEn,SheersColorEn,SheersColorFa,SheersPhotoUrl,PrivacyLayerHeaderStyle,PrivacyLayerHeaderStyleID"
                              );
                              setDeps(
                                "2B1,2C" + (step6 === "Customize Style Per Curtain" ? ",6C" : ""),
                                "2B"
                              );
                            } else {
                              selectChanged(e);
                              setCart(
                                "PrivacyLayer",
                                "Semi Sheer",
                                "SheersId1,SheersId2,SheersDesignFa,SheersDesignEn,SheersColorEn,SheersColorFa,SheersPhotoUrl"
                              );
                              setDeps("2B1", "2B");
                            }
                          }
                          setStep2B("Semi Sheer");
                          setStep2B1("");
                        }}
                        ref={(ref) => (inputs.current["2B2"] = ref)}
                      />
                      <label htmlFor="2B2">
                        {i18n.language === "fa" ? "نازک (پر نورتر)" : "Semi Sheer"}
                      </label>
                    </div>
                    <div className="box33 radio_style">
                      <input
                        className="radio"
                        type="radio"
                        text={t("Opaque")}
                        value="3"
                        name="step2B"
                        ref-num="2B"
                        id="2B3"
                        checked={step2B === "Opaque"}
                        onChange={(e) => {
                          if (
                            step2B === "None" &&
                            step8 === "I Want To Customize Hardware Per Curtain"
                          ) {
                            selectChanged(e);
                            setCart(
                              "PrivacyLayer",
                              "Opaque",
                              "SheersId1,SheersId2,SheersDesignFa,SheersDesignEn,SheersColorEn,SheersColorFa,SheersPhotoUrl,PrivacyLayerHeaderStyle,PrivacyLayerHeaderStyleID"
                            );
                            setDeps(
                              "2B1,2C,8C" + (step6 === "Customize Style Per Curtain" ? ",6C" : ""),
                              "2B"
                            );
                          } else if (step2B === "None" && step8 === "I Have My Own Hardware") {
                            selectChanged(e);
                            setCart(
                              "PrivacyLayer",
                              "Opaque",
                              "SheersId1,SheersId2,SheersDesignFa,SheersDesignEn,SheersColorEn,SheersColorFa,SheersPhotoUrl,PrivacyLayerHeaderStyle,PrivacyLayerHeaderStyleID"
                            );
                            setDeps(
                              "2B1,2C,87" + (step6 === "Customize Style Per Curtain" ? ",6C" : ""),
                              "2B"
                            );
                          } else {
                            if (step2B === "None") {
                              selectChanged(e);
                              setCart(
                                "PrivacyLayer",
                                "Opaque",
                                "SheersId1,SheersId2,SheersDesignFa,SheersDesignEn,SheersColorEn,SheersColorFa,SheersPhotoUrl,PrivacyLayerHeaderStyle,PrivacyLayerHeaderStyleID"
                              );
                              setDeps(
                                "2B1,2C" + (step6 === "Customize Style Per Curtain" ? ",6C" : ""),
                                "2B"
                              );
                            } else {
                              selectChanged(e);
                              setCart(
                                "PrivacyLayer",
                                "Opaque",
                                "SheersId1,SheersId2,SheersDesignFa,SheersDesignEn,SheersColorEn,SheersColorFa,SheersPhotoUrl"
                              );
                              setDeps("2B1", "2B");
                            }
                          }
                          setStep2B("Opaque");
                          setStep2B1("");
                        }}
                        ref={(ref) => (inputs.current["2B3"] = ref)}
                      />
                      <label htmlFor="2B3">
                        {i18n.language === "fa" ? "ضخیم (کم نورتر)" : "Opaque"}
                      </label>
                    </div>

                    <div
                      className={
                        step2B === "Semi Sheer"
                          ? "fabrics_list_container grommet_fabrics_list_container 3"
                          : "noDisplay"
                      }
                    >
                      <div className="fabrics_list_container fabrics_list_container_sheer dddd">
                        {sheersList}
                      </div>
                    </div>
                    <div
                      className={
                        step2B === "Opaque"
                          ? "fabrics_list_container grommet_fabrics_list_container 4"
                          : "noDisplay"
                      }
                    >
                      <div className="fabrics_list_container cccc">{sheersList2}</div>
                    </div>
                    <NextStep
                      currentStep="2B"
                      eventKey={step2B !== "" && step2B !== "None" ? "2C" : "3A0"}
                    >
                      {t("NEXT STEP")}
                    </NextStep>
                  </div>
                </Card.Body>
              </Accordion.Collapse>
            </Card>

            {/* step 3A */}
            <Step3APleated
              ContextAwareToggle={ContextAwareToggle}
              t={t}
              step2B={step2B}
              step2C={step2C}
              accordionActiveKey={accordionActiveKey}
              requiredStep={requiredStep}
              stepSelectedLabel={stepSelectedLabel}
              modalHandleShow={modalHandleShow}
              setSheerHeaderStyleTemp2={setSheerHeaderStyleTemp2}
              setStep2C={setStep2C}
              setDeps={setDeps}
              setCart={setCart}
              selectChanged={selectChanged}
              setSheersModelId2={setSheersModelId2}
              inputs={inputs}
              step8={step8}
              NextStep={NextStep}
            />

            {/* step 4 */}
            <Step4Pleated
              ContextAwareToggle={ContextAwareToggle}
              t={t}
              pageLanguage={pageLanguage}
              stepSelectedLabel={stepSelectedLabel}
              requiredStep={requiredStep}
              step3A0={step3A0}
              step3={step3}
              modalHandleShow={modalHandleShow}
              setMountTypeTemp={setMountTypeTemp}
              setStep3A0={setStep3A0}
              setStep3={setStep3}
              setDepth={setDepth}
              setMouldingHeight={setMouldingHeight}
              setMountErr1={setMountErr1}
              setMountErr2={setMountErr2}
              setDeps={setDeps}
              setCart={setCart}
              setCartLoading={setCartLoading}
              setMeasurementsNextStep={setMeasurementsNextStep}
              setExtendedTitle={setExtendedTitle}
              clearInputs={clearInputs}
              extendedTitle={extendedTitle}
              inputs={inputs}
              depthHelp={depthHelp}
              setDepthHelp={setDepthHelp}
              selectChanged={selectChanged}
              depth={depth}
              mountErr1={mountErr1}
              mountErr2={mountErr2}
              mouldingHeight={mouldingHeight}
              ContextAwareToggleViewDetails={ContextAwareToggleViewDetails}
              NextStep={NextStep}
              setStep5={setStep5}
            />

            {/* step 5 */}
            <Card>
              <Card.Header>
                <ContextAwareToggle
                  eventKey="3"
                  stepNum={t("5")}
                  stepTitle={t("zebra_step3")}
                  stepRef="3"
                  type="2"
                  required={requiredStep["3"]}
                  stepSelected={
                    windowSizeBool
                      ? windowSize
                      : stepSelectedLabel["3"] === undefined
                      ? ""
                      : stepSelectedLabel["3"]
                  }
                  cartCustomText={t("zebra_step3_custom_cart_text")}
                />
              </Card.Header>
              <Accordion.Collapse eventKey="3">
                <Card.Body>
                  <div className="card_body card_body_radio">
                    <div className="box50 radio_style">
                      <input
                        className="radio"
                        type="radio"
                        text={t("I have my own measurements")}
                        value="1"
                        name="step3"
                        ref-num="3"
                        id="31"
                        checked={step3 === "false"}
                        onChange={(e) => {
                          setMeasurementsNextStep("4");
                          setStep5("Full");
                          setStep6CHead("Rod");
                          setStep6BHead("Rod");
                          setStep6DHead("Rod");
                          setStep6CHead9("Rod");
                          setStep8B6(false);
                          setStep8B5(false);
                          setStep8C5(false);
                          if (step3A0 === "") {
                            setStep3("");
                            selectUncheck(e);
                            modalHandleShow("noMount");
                            setDeps("3", "311,312");
                            setCart(
                              "",
                              "",
                              "Width,Height,WidthCart,HeightCart,WindowWidth,WindowHeight,calcMeasurements"
                            );
                          } else {
                            setStep3("false");
                            setStep31("");
                            setStep61("");
                            setDeps(
                              "311,312",
                              "3,31,3A,3A1,3B,3B1,3C,3D1,3D2,3E,3EFloor,3F,3G,3ARod,3ARod1,3BRod,3CRod,3CRodFloor,3DRod,3EStandardCeiling1,3EStandardCeiling2,3EStandardCeiling3,3EStandardCeilingFloor1,3EStandardCeilingFloor2,3EStandardCeilingFloor3"
                            );
                            clearInputs(e, undefined, "3ARod,3A,3B");
                            setCart(
                              "calcMeasurements",
                              false,
                              "WidthCart,HeightCart,hasRod,CurtainPosition,FinishedLengthType,Width3C,ExtensionLeft,ExtensionRight,ShadeMount,Height3E,WindowToFloor,CeilingToFloor,RodWidth,RodToBottom,RodToFloor,CeilingToWindow1,CeilingToWindow2,CeilingToWindow3,CeilingToFloor1,CeilingToFloor2,CeilingToFloor3"
                            );
                          }
                        }}
                        ref={(ref) => (inputs.current["31"] = ref)}
                      />
                      <label htmlFor="31">{t("I have my own measurements.")}</label>
                    </div>
                    <div className="box50 radio_style">
                      <input
                        className="radio"
                        type="radio"
                        text={t("Calculate my measurements")}
                        value="2"
                        name="step3"
                        checked={step3 === "true"}
                        ref-num="3"
                        id="32"
                        ref={(ref) => (inputs.current["32"] = ref)}
                        onChange={(e) => {
                          setMeasurementsNextStep("4");
                          setStep5("");
                          if (step3A0 === "") {
                            setStep3("");
                            setStep8B6(false);
                            setStep8B5(false);
                            setStep8C5(false);
                            selectUncheck(e);
                            modalHandleShow("noMount");
                            setDeps("3", "31,32");
                            setCart(
                              "",
                              "",
                              "Width,Height,WidthCart,HeightCart,WindowWidth,WindowHeight,calcMeasurements"
                            );
                          } else {
                            setStep3("true");
                            setStep31("");
                            setStep61("");
                            clearInputs(e);
                            setDeps("31", "3,311,312");
                            setCart(
                              "calcMeasurements",
                              true,
                              "Width,Height,WidthCart,HeightCart,WindowWidth,WindowHeight"
                            );
                          }
                        }}
                      />
                      <label htmlFor="32">{t("Calculate my measurements.")}</label>
                    </div>

                    <div className={step3 === "false" ? "own_measurements_container" : "noDisplay"}>
                      <div className="own_measurements_width">
                        <div className="measure_input_container">
                          <h1 className="measure_input_label">{t("Width")}</h1>
                          <div className="measure_input_field_container">
                            <DebounceInput
                              inputRef={(ref) => (inputs.current["Width"] = ref)}
                              debounceTimeout={1500}
                              autoComplete="off"
                              onKeyDown={(e) => {
                                if (e.keyCode === 13) {
                                  inputs.current["Height"].focus();
                                } else if (
                                  !/[0-9]/.test(NumberToPersianWord.convertPeToEn(e.key)) &&
                                  e.keyCode !== 8 &&
                                  e.keyCode !== 46 &&
                                  e.keyCode !== 37 &&
                                  e.keyCode !== 39 &&
                                  e.keyCode !== 13
                                ) {
                                  e.preventDefault();
                                }
                              }}
                              className={
                                "measure_input" +
                                (width !== undefined && (width < 1 || width > 1000)
                                  ? " measure_input_err"
                                  : "")
                              }
                              type="text"
                              name="width"
                              value={NumToFa(`${width || ""}`, pageLanguage)}
                              onChange={(e) => {
                                setTimeout(() => {
                                  let newValue = NumberToPersianWord.convertPeToEn(e.target.value);
                                  newValue = isNaN(newValue) ? "" : newValue;
                                  if (
                                    newValue &&
                                    newValue !== "" &&
                                    parseInt(newValue) >= 1 &&
                                    parseInt(newValue) <= 1000
                                  ) {
                                    setCartLoading(true);
                                    setCart("Width", parseInt(newValue));
                                    setDeps("", "311");
                                    setWidth(parseInt(newValue));
                                  } else {
                                    setCartLoading(true);
                                    setCart("", "", "Width");
                                    setDeps("311", "");
                                    if (newValue === "" || isNaN(parseInt(newValue))) {
                                      setWidth(undefined);
                                      selectChanged(undefined, "3");
                                    } else {
                                      setWidth(parseInt(newValue));
                                      selectChanged("3", undefined, t("Invalid Measurements"));
                                    }
                                    setWindowSize("");
                                  }
                                }, 300);
                              }}
                            />
                            <div className="measure_input_postfix">{t("cm_label")}</div>
                          </div>
                        </div>
                      </div>
                      <div className="own_measurements_Length">
                        <div className="measure_input_container">
                          <h1 className="measure_input_label">{t("Height")}</h1>
                          <div className="measure_input_field_container">
                            <DebounceInput
                              inputRef={(ref) => (inputs.current["Height"] = ref)}
                              debounceTimeout={1500}
                              autoComplete="off"
                              onKeyDown={(e) => {
                                if (e.keyCode === 13) {
                                  inputs.current["Width"].focus();
                                } else if (
                                  !/[0-9]/.test(NumberToPersianWord.convertPeToEn(e.key)) &&
                                  e.keyCode !== 8 &&
                                  e.keyCode !== 46 &&
                                  e.keyCode !== 37 &&
                                  e.keyCode !== 39 &&
                                  e.keyCode !== 13
                                ) {
                                  e.preventDefault();
                                }
                              }}
                              className={
                                "measure_input" +
                                (height !== undefined && (height < 1 || height > 1000)
                                  ? " measure_input_err"
                                  : "")
                              }
                              type="text"
                              name="height"
                              value={NumToFa(`${height || ""}`, pageLanguage)}
                              onChange={(e) => {
                                setTimeout(() => {
                                  let newValue = NumberToPersianWord.convertPeToEn(e.target.value);
                                  newValue = isNaN(newValue) ? "" : newValue;
                                  if (
                                    newValue &&
                                    newValue !== "" &&
                                    parseInt(newValue) >= 1 &&
                                    parseInt(newValue) <= 1000
                                  ) {
                                    setCartLoading(true);
                                    setCart("Height", parseInt(newValue));
                                    setDeps("", "312");
                                    setHeight(parseInt(newValue));
                                  } else {
                                    setCartLoading(true);
                                    setCart("", "", "Height");
                                    setDeps("312", "");
                                    if (newValue === "" || isNaN(parseInt(newValue))) {
                                      setHeight(undefined);
                                      selectChanged(undefined, "3");
                                    } else {
                                      setHeight(parseInt(newValue));
                                      selectChanged("3", undefined, t("Invalid Measurements"));
                                    }
                                    setWindowSize("");
                                  }
                                }, 300);
                              }}
                            />
                            <div className="measure_input_postfix">{t("cm_label")}</div>
                          </div>
                        </div>
                      </div>
                    </div>

                    <div
                      className={
                        step3 === "true"
                          ? "card_body card_body_radio card_body_grommet_measurements"
                          : "noDisplay"
                      }
                    >
                      <div className="box100">
                        <p className="step_selection_title">
                          {t("grommet_step31_title_Pleated_new")}
                        </p>
                      </div>
                      <div className="boxParintHardware">
                        <div className="boxHardwareType radio_style">
                          <img
                            src={
                              require("../Images/drapery/european/calculatemeasurmenttrack-new.svg")
                                .default
                            }
                            className="img-fluid height_auto"
                            alt=""
                          />
                          <input
                            className="radio"
                            type="radio"
                            value="1"
                            name="step31"
                            ref-num="31"
                            id="311"
                            checked={step31 === "true"}
                            onChange={(e) => {
                              setStep6CHead("Rod");
                              setStep6BHead("Rod");
                              setStep6DHead("Rod");
                              setStep6CHead9("Rod");
                              setStep31("true");
                              setStep3A("Standard");
                              setStep3B("Floor");
                              clearInputs(e, undefined, "3ARod");
                              setDeps(
                                "3BRodHaveRod,3CRodFloorHaveRod,3DRod",
                                "31,3B,3B1,3C,3D1,3D2,3E,3EFloor,3F,3G,3A0,3A,3A1,3ARod1,3BRod,3CRod,3CRodFloor,3EStandardCeiling1,3EStandardCeiling2,3EStandardCeiling3,3EStandardCeilingFloor1,3EStandardCeilingFloor2,3EStandardCeilingFloor3"
                              );
                              setCart(
                                "hasRod",
                                true,
                                "Width3C,ExtensionLeft,ExtensionRight,ShadeMount,Height3E,WindowToFloor,CeilingToFloor,RodWidth,RodToBottom,RodToFloor,CeilingToWindow1,CeilingToWindow2,CeilingToWindow3,CeilingToFloor1,CeilingToFloor2,CeilingToFloor3"
                              );
                              setMeasurementsNextStep("3A");
                            }}
                            ref={(ref) => (inputs.current["311"] = ref)}
                          />
                          <label htmlFor="311">{t("grommet_has_rod")}</label>
                        </div>
                        <div className="boxHardwareType radio_style">
                          <img
                            src={
                              require("../Images/drapery/european/calculatemeasurmentrod-new.svg")
                                .default
                            }
                            className="img-fluid height_auto"
                            alt=""
                          />
                          <input
                            className="radio"
                            type="radio"
                            value="1"
                            name="step31"
                            ref-num="31"
                            id="313"
                            checked={step31 === "Track"}
                            onChange={(e) => {
                              setStep31("Track");
                              setStep3A("Standard");
                              setStep6CHead("Track");
                              setStep6BHead("Track");
                              setStep6DHead("Track");
                              setStep6CHead9("Track");
                              setStep3B("Floor");
                              clearInputs(e, undefined, "3ARod");
                              setDeps(
                                "3BRod,3CRodFloor,3DRod",
                                "31,3B,3B1,3C,3D1,3D2,3E,3EFloor,3F,3G,3A0,3A,3A1,3ARod1,3CRod,3EStandardCeiling1,3EStandardCeiling2,3EStandardCeiling3,3EStandardCeilingFloor1,3EStandardCeilingFloor2,3EStandardCeilingFloor3,3BRodHaveRod,3CRodFloorHaveRod,3CRodIHave"
                              );
                              setCart(
                                "hasRod",
                                true,
                                "Width3C,ExtensionLeft,ExtensionRight,ShadeMount,Height3E,WindowToFloor,CeilingToFloor,RodWidth,RodToBottom,RodToFloor,CeilingToWindow1,CeilingToWindow2,CeilingToWindow3,CeilingToFloor1,CeilingToFloor2,CeilingToFloor3"
                              );
                              setMeasurementsNextStep("3A");
                            }}
                            ref={(ref) => (inputs.current["313"] = ref)}
                          />
                          <label htmlFor="313">{t("grommet_has_Pleated")}</label>
                        </div>
                        <div className="boxHardwareType radio_style">
                          <img
                            src={
                              require("../Images/drapery/european/calculatemeasurmentnotrackrod-new.svg")
                                .default
                            }
                            className="img-fluid height_auto"
                            alt=""
                          />
                          <input
                            className="radio"
                            type="radio"
                            value="2"
                            name="step31"
                            ref-num="31"
                            id="312"
                            checked={step31 === "false"}
                            onChange={(e) => {
                              // setIsShowStep5(false);
                              setStep6CHead("Rod");
                              setStep6BHead("Rod");
                              setStep6DHead("Rod");
                              setStep6CHead9("Rod");
                              setStep31("false");
                              setStep3A("Standard");
                              setStep3B("Floor");
                              setWidth3C(undefined);
                              setCeilingToFloor1(undefined);
                              setCeilingToFloor2(undefined);
                              setCeilingToFloor3(undefined);
                              setLeft(undefined);
                              setRight(undefined);

                              selectChanged(
                                "3A",
                                "3C,3D,3E,3EFloor,3F,3G,3ARod,3BRod,3CRod,3CRodFloor,3DRod,3EStandardCeiling,3EStandardCeilingFloor",
                                t("Standard"),
                                "3B",
                                [t("Floor")]
                              );
                              setCart(
                                "hasRod",
                                false,
                                "Width3C,ExtensionLeft,ExtensionRight,ShadeMount,Height3E,WindowToFloor,CeilingToFloor,RodWidth,RodToBottom,RodToFloor,CeilingToWindow1,CeilingToWindow2,CeilingToWindow3,CeilingToFloor1,CeilingToFloor2,CeilingToFloor3",
                                "CurtainPosition,FinishedLengthType",
                                ["Standard", "Floor"]
                              );
                              if (step3A0 === "Wall") {
                                setDeps(
                                  "3C,3D1,3D2,3EFloor,3F,3G",
                                  "31,3A,3B,3B1,3E,3ARod,3A1,3ARod1,3BRod,3CRod,3CRodFloor,3DRod,3EStandardCeiling1,3EStandardCeiling2,3EStandardCeiling3,3EStandardCeilingFloor1,3EStandardCeilingFloor2,3EStandardCeilingFloor3,3BRodHaveRod,3CRodFloorHaveRod,3DRod,3CRodIHave"
                                );
                              } else {
                                setDeps(
                                  "3C,3D1,3D2,3EStandardCeilingFloor1,3EStandardCeilingFloor2,3EStandardCeilingFloor3",
                                  "31,3A,3B,3B1,3E,3F,3G,3EFloor,3ARod,3A1,3ARod1,3BRod,3CRod,3CRodFloor,3DRod,3EStandardCeiling1,3EStandardCeiling2,3EStandardCeiling3,3BRodHaveRod,3CRodFloorHaveRod,3DRod,3CRodIHave"
                                );
                              }
                              setMeasurementsNextStep("3A");
                            }}
                            ref={(ref) => (inputs.current["312"] = ref)}
                          />
                          <label htmlFor="312">{t("grommet_no_Pleated")}</label>
                        </div>
                      </div>
                    </div>
                    {step3 === "false" && step2B !== "None" && (
                      <div className="secondary_options_step5">
                        <span className="checkbox_text">{t("title_step5")}</span>
                      </div>
                    )}
                    {step3 === "false" && step2B === "None" && (
                      <div className="secondary_options_step5">
                        <span className="checkbox_text">{t("title_darpery&sheer_step5")}</span>
                      </div>
                    )}
                    <NextStep currentStep="3" eventKey={measurementsNextStep}>
                      {t("NEXT STEP")}
                    </NextStep>
                  </div>

                  {stepSelectedValue["3"] === "1" && (
                    <div className="accordion_help">
                      <div className="help_container">
                        <div className="help_column help_left_column">
                          <p className="help_column_header" />
                          <ul className="help_column_list">
                            <li className="no_listStyle single_line_height">
                              <div className="measurementsHelp_link">
                                {t("step3_help_11")}
                                <span
                                  className="link_between_text"
                                  onClick={(e) => modalHandleShow("measurementsHelp")}
                                >
                                  {t("step3_help_12")}
                                </span>
                                {t("step3_help_13")}
                              </div>
                            </li>
                          </ul>
                        </div>
                      </div>
                    </div>
                  )}
                  {stepSelectedValue["3"] === "2" && (
                    <div className="accordion_help">
                      <div className="help_container">
                        <div className="help_column help_left_column">
                          <p className="help_column_header" />
                          <ul className="help_column_list">
                            <li className="no_listStyle single_line_height">
                              <b>{t("Note:&nbsp;")}</b>
                              {t("step3_help_2.5")}
                            </li>
                          </ul>
                        </div>
                      </div>
                    </div>
                  )}
                </Card.Body>
              </Accordion.Collapse>
            </Card>
            {/* start step No, I don't have hardware */}
            {/* step 5A */}
            <Card
              className={
                isShowStep5
                  ? "noDisplay"
                  : step3 === "true" && step31 === "false"
                  ? ""
                  : "noDisplay"
              }
            >
              <Card.Header
                className={
                  [...depSet].findIndex((el) => el.startsWith("3")) === -1 &&
                  !accordionActiveKey.startsWith("3")
                    ? "hidden"
                    : ""
                }
              >
                <ContextAwareToggle
                  eventKey="3A"
                  stepNum={t("5A")}
                  stepTitle={t("grommet_step3A")}
                  stepRef="3A"
                  type="1"
                  required={requiredStep["3A"]}
                  stepSelected={
                    stepSelectedLabel["3A"] === undefined ? "" : stepSelectedLabel["3A"]
                  }
                />
              </Card.Header>
              <Accordion.Collapse eventKey="3A">
                <Card.Body>
                  <div className="card_body card_body_radio card_body_4_grommet">
                    <div className="box50 radio_style">
                      <img
                        src={
                          step3A0 === "Wall"
                            ? require("../Images/drapery/grommet/CP_standard.svg").default
                            : step3A0 === "Ceiling"
                            ? require("../Images/drapery/grommet/CP_standard2.svg").default
                            : require("../Images/drapery/grommet/CP_standard3.svg").default
                        }
                        className="img-fluid half_margin"
                        alt=""
                      />
                      <input
                        className="radio"
                        type="radio"
                        text={t("Standard")}
                        value="1"
                        name="step3A"
                        ref-num="3A"
                        id="3A1"
                        checked={step3A === "Standard"}
                        onChange={(e) => {
                          if (step3A !== "" && anyMeasurements) {
                            modalHandleShow("CurtainPosWarning");
                            setCurtainPosTemp({
                              stepValue: "Standard",
                              id: "",
                              cartValue: "Standard",
                              event: e,
                            });
                          } else {
                            setStep3A("Standard");
                            clearInputs(e);
                            setCart(
                              "CurtainPosition",
                              "Standard",
                              "Width3C,ExtensionLeft,ExtensionRight,ShadeMount,Height3E,WindowToFloor,CeilingToFloor,RodWidth,RodToBottom,RodToFloor,CeilingToWindow1,CeilingToWindow2,CeilingToWindow3,CeilingToFloor1,CeilingToFloor2,CeilingToFloor3"
                            );
                            if (step3B === "Sill" || step3B === "Apron") {
                              if (step3A0 === "Ceiling" || step3A0 === "Moulding") {
                                setDeps(
                                  "3C,3D1,3D2,3EStandardCeiling1,3EStandardCeiling2,3EStandardCeiling3,3G",
                                  "3A,3B,3B1,3E,3F,3EFloor,3BRod,3CRod,3CRodFloor,3DRod,3EStandardCeilingFloor1,3EStandardCeilingFloor2,3EStandardCeilingFloor3"
                                );
                              } else {
                                setDeps(
                                  "3C,3D1,3D2,3E,3F,3G",
                                  "3A,3B,3B1,3EFloor,3BRod,3CRod,3CRodFloor,3DRod,3EStandardCeiling1,3EStandardCeiling2,3EStandardCeiling3,3EStandardCeilingFloor1,3EStandardCeilingFloor2,3EStandardCeilingFloor3"
                                );
                              }
                            } else {
                              if (step3A0 === "Ceiling" || step3A0 === "Moulding") {
                                setDeps(
                                  "3C,3D1,3D2,3EStandardCeilingFloor1,3EStandardCeilingFloor2,3EStandardCeilingFloor3",
                                  "3A,3B,3B1,3E,3F,3G,3EFloor,3BRod,3CRod,3CRodFloor,3DRod,3EStandardCeiling1,3EStandardCeiling2,3EStandardCeiling3"
                                );
                              } else {
                                setDeps(
                                  "3C,3D1,3D2,3EFloor,3F,3G",
                                  "3A,3B,3B1,3E,3BRod,3CRod,3CRodFloor,3DRod,3EStandardCeiling1,3EStandardCeiling2,3EStandardCeiling3,3EStandardCeilingFloor1,3EStandardCeilingFloor2,3EStandardCeilingFloor3"
                                );
                              }
                            }
                          }
                        }}
                        ref={(ref) => (inputs.current["3A1"] = ref)}
                      />
                      <label htmlFor="3A1">{t("Standard")}</label>
                    </div>
                    <div className="box50 radio_style">
                      <img
                        src={
                          step3A0 === "Wall"
                            ? require("../Images/drapery/grommet/CP_Wall.svg").default
                            : step3A0 === "Ceiling"
                            ? require("../Images/drapery/grommet/CP_Wall2.svg").default
                            : require("../Images/drapery/grommet/CP_Wall3.svg").default
                        }
                        className="img-fluid half_margin"
                        alt=""
                      />
                      <input
                        className="radio"
                        type="radio"
                        text={t("Wall to Wall")}
                        value="2"
                        name="step3A"
                        ref-num="3A"
                        id="3A2"
                        checked={step3A === "Wall to Wall"}
                        onChange={(e) => {
                          if (step3A !== "" && anyMeasurements) {
                            modalHandleShow("CurtainPosWarning");
                            setCurtainPosTemp({
                              stepValue: "Wall to Wall",
                              id: "",
                              cartValue: "Wall to Wall",
                              event: e,
                            });
                          } else {
                            setStep3A("Wall to Wall");
                            clearInputs(e);
                            setCart(
                              "CurtainPosition",
                              "Wall to Wall",
                              "Width3C,ExtensionLeft,ExtensionRight,ShadeMount,Height3E,WindowToFloor,CeilingToFloor,RodWidth,RodToBottom,RodToFloor,CeilingToWindow1,CeilingToWindow2,CeilingToWindow3,CeilingToFloor1,CeilingToFloor2,CeilingToFloor3"
                            );
                            if (step3B === "Sill" || step3B === "Apron") {
                              if (step3A0 === "Wall") {
                                setDeps(
                                  "3C,3E,3F,3G",
                                  "3A,3B,3B1,3D1,3D2,3EFloor,3BRod,3CRod,3CRodFloor,3DRod,3EStandardCeiling1,3EStandardCeiling2,3EStandardCeiling3,3EStandardCeilingFloor1,3EStandardCeilingFloor2,3EStandardCeilingFloor3"
                                );
                              } else {
                                setDeps(
                                  "3C,3EStandardCeiling1,3EStandardCeiling2,3EStandardCeiling3,3G",
                                  "3A,3B,3B1,3D1,3D2,3E,3F,3EFloor,3BRod,3CRod,3CRodFloor,3DRod,3EStandardCeilingFloor1,3EStandardCeilingFloor2,3EStandardCeilingFloor3"
                                );
                              }
                            } else {
                              if (step3A0 === "Wall") {
                                setDeps(
                                  "3C,3EFloor,3F,3G",
                                  "3A,3B,3B1,3D1,3D2,3E,3BRod,3CRod,3CRodFloor,3DRod,3EStandardCeiling1,3EStandardCeiling2,3EStandardCeiling3,3EStandardCeilingFloor1,3EStandardCeilingFloor2,3EStandardCeilingFloor3"
                                );
                              } else {
                                setDeps(
                                  "3C,3EStandardCeilingFloor1,3EStandardCeilingFloor2,3EStandardCeilingFloor3",
                                  "3A,3B,3B1,3D1,3D2,3E,3F,3G,3EFloor,3BRod,3CRod,3CRodFloor,3DRod,3EStandardCeiling1,3EStandardCeiling2,3EStandardCeiling3"
                                );
                              }
                            }
                          }
                        }}
                        ref={(ref) => (inputs.current["3A2"] = ref)}
                      />
                      <label htmlFor="3A2">{t("Wall to Wall")}</label>
                    </div>
                    <div className="box100 dir_ltr">
                      <div className="box50 radio_style">
                        <img
                          src={
                            step3A0 === "Wall"
                              ? require("../Images/drapery/grommet/CP_Left.svg").default
                              : step3A0 === "Ceiling"
                              ? require("../Images/drapery/grommet/CP_Left2.svg").default
                              : require("../Images/drapery/grommet/CP_Left3.svg").default
                          }
                          className="img-fluid half_margin"
                          alt=""
                        />
                        <input
                          className="radio"
                          type="radio"
                          text={t("Left Corner Window")}
                          value="3"
                          name="step3A"
                          ref-num="3A"
                          id="3A3"
                          checked={step3A === "Left Corner Window"}
                          onChange={(e) => {
                            if (step3A !== "" && anyMeasurements) {
                              modalHandleShow("CurtainPosWarning");
                              setCurtainPosTemp({
                                stepValue: "Left Corner Window",
                                id: "",
                                cartValue: "Left Corner Window",
                                event: e,
                              });
                            } else {
                              setStep3A("Left Corner Window");
                              clearInputs(e);
                              setCart(
                                "CurtainPosition",
                                "Left Corner Window",
                                "Width3C,ExtensionLeft,ExtensionRight,ShadeMount,Height3E,WindowToFloor,CeilingToFloor,RodWidth,RodToBottom,RodToFloor,CeilingToWindow1,CeilingToWindow2,CeilingToWindow3,CeilingToFloor1,CeilingToFloor2,CeilingToFloor3"
                              );
                              if (step3B === "Sill" || step3B === "Apron") {
                                if (step3A0 === "Ceiling" || step3A0 === "Moulding") {
                                  setDeps(
                                    "3C,3D1,3D2,3EStandardCeiling1,3EStandardCeiling2,3EStandardCeiling3,3G",
                                    "3A,3B,3B1,3E,3F,3EFloor,3BRod,3CRod,3CRodFloor,3DRod,3EStandardCeilingFloor1,3EStandardCeilingFloor2,3EStandardCeilingFloor3"
                                  );
                                } else {
                                  setDeps(
                                    "3C,3D1,3D2,3E,3F,3G",
                                    "3A,3B,3B1,3EFloor,3BRod,3CRod,3CRodFloor,3DRod,3EStandardCeiling1,3EStandardCeiling2,3EStandardCeiling3,3EStandardCeilingFloor1,3EStandardCeilingFloor2,3EStandardCeilingFloor3"
                                  );
                                }
                              } else {
                                if (step3A0 === "Ceiling" || step3A0 === "Moulding") {
                                  setDeps(
                                    "3C,3D1,3D2,3EStandardCeilingFloor1,3EStandardCeilingFloor2,3EStandardCeilingFloor3",
                                    "3A,3B,3B1,3E,3F,3G,3EFloor,3BRod,3CRod,3CRodFloor,3DRod,3EStandardCeiling1,3EStandardCeiling2,3EStandardCeiling3"
                                  );
                                } else {
                                  setDeps(
                                    "3C,3D1,3D2,3EFloor,3F,3G",
                                    "3A,3B,3B1,3E,3BRod,3CRod,3CRodFloor,3DRod,3EStandardCeiling1,3EStandardCeiling2,3EStandardCeiling3,3EStandardCeilingFloor1,3EStandardCeilingFloor2,3EStandardCeilingFloor3"
                                  );
                                }
                              }
                            }
                          }}
                          ref={(ref) => (inputs.current["3A3"] = ref)}
                        />
                        <label htmlFor="3A3">{t("Left Corner Window")}</label>
                      </div>
                      <div className="box50 radio_style">
                        <img
                          src={
                            step3A0 === "Wall"
                              ? require("../Images/drapery/grommet/CP_Right.svg").default
                              : step3A0 === "Ceiling"
                              ? require("../Images/drapery/grommet/CP_Right2.svg").default
                              : require("../Images/drapery/grommet/CP_Right3.svg").default
                          }
                          className="img-fluid half_margin"
                          alt=""
                        />
                        <input
                          className="radio"
                          type="radio"
                          text={t("Right Corner Window")}
                          value="4"
                          name="step3A"
                          ref-num="3A"
                          id="3A4"
                          checked={step3A === "Right Corner Window"}
                          onChange={(e) => {
                            if (step3A !== "" && anyMeasurements) {
                              modalHandleShow("CurtainPosWarning");
                              setCurtainPosTemp({
                                stepValue: "Right Corner Window",
                                id: "",
                                cartValue: "Right Corner Window",
                                event: e,
                              });
                            } else {
                              setStep3A("Right Corner Window");
                              clearInputs(e);
                              setCart(
                                "CurtainPosition",
                                "Right Corner Window",
                                "Width3C,ExtensionLeft,ExtensionRight,ShadeMount,Height3E,WindowToFloor,CeilingToFloor,RodWidth,RodToBottom,RodToFloor,CeilingToWindow1,CeilingToWindow2,CeilingToWindow3,CeilingToFloor1,CeilingToFloor2,CeilingToFloor3"
                              );
                              if (step3B === "Sill" || step3B === "Apron") {
                                if (step3A0 === "Ceiling" || step3A0 === "Moulding") {
                                  setDeps(
                                    "3C,3D1,3D2,3EStandardCeiling1,3EStandardCeiling2,3EStandardCeiling3,3G",
                                    "3A,3B,3B1,3E,3F,3EFloor,3BRod,3CRod,3CRodFloor,3DRod,3EStandardCeilingFloor1,3EStandardCeilingFloor2,3EStandardCeilingFloor3"
                                  );
                                } else {
                                  setDeps(
                                    "3C,3D1,3D2,3E,3F,3G",
                                    "3A,3B,3B1,3EFloor,3BRod,3CRod,3CRodFloor,3DRod,3EStandardCeiling1,3EStandardCeiling2,3EStandardCeiling3,3EStandardCeilingFloor1,3EStandardCeilingFloor2,3EStandardCeilingFloor3"
                                  );
                                }
                              } else {
                                if (step3A0 === "Ceiling" || step3A0 === "Moulding") {
                                  setDeps(
                                    "3C,3D1,3D2,3EStandardCeilingFloor1,3EStandardCeilingFloor2,3EStandardCeilingFloor3",
                                    "3A,3B,3B1,3E,3F,3G,3EFloor,3BRod,3CRod,3CRodFloor,3DRod,3EStandardCeiling1,3EStandardCeiling2,3EStandardCeiling3"
                                  );
                                } else {
                                  setDeps(
                                    "3C,3D1,3D2,3EFloor,3F,3G",
                                    "3A,3B,3B1,3E,3BRod,3CRod,3CRodFloor,3DRod,3EStandardCeiling1,3EStandardCeiling2,3EStandardCeiling3,3EStandardCeilingFloor1,3EStandardCeilingFloor2,3EStandardCeilingFloor3"
                                  );
                                }
                              }
                            }
                          }}
                          ref={(ref) => (inputs.current["3A4"] = ref)}
                        />
                        <label htmlFor="3A4">{t("Right Corner Window")}</label>
                      </div>
                    </div>

                    <NextStep currentStep="3A" eventKey="3B">
                      {t("NEXT STEP")}
                    </NextStep>
                  </div>
                </Card.Body>
              </Accordion.Collapse>
            </Card>

            {/* step 5B */}
            <Card
              className={
                isShowStep5
                  ? "noDisplay"
                  : step3 === "true" && step31 === "false" && step3A0 !== "" && step3A !== ""
                  ? ""
                  : "noDisplay"
              }
            >
              <Card.Header
                className={
                  [...depSet].findIndex((el) => el.startsWith("3")) === -1 &&
                  !accordionActiveKey.startsWith("3")
                    ? "hidden"
                    : ""
                }
              >
                <ContextAwareToggle
                  eventKey="3B"
                  stepNum={t("5B")}
                  stepTitle={t("dk_step2A")}
                  stepRef="3B"
                  type="1"
                  required={requiredStep["3B"]}
                  stepSelected={
                    stepSelectedLabel["3B"] === undefined ? "" : stepSelectedLabel["3B"]
                  }
                />
              </Card.Header>
              <Accordion.Collapse eventKey="3B">
                <Card.Body>
                  <div className="card_body card_body_radio card_body_finished_length card_body_finished_length_grommet">
                    <div className="box100">
                      <p className="step_selection_title">{t("dk_step2A_title")}</p>
                    </div>
                    <div className="box25 radio_style 1">
                      <img
                        src={
                          pageLanguage === "fa"
                            ? require("../Images/drapery/grommet/length type-05.svg").default
                            : require("../Images/drapery/grommet/length type-04.svg").default
                        }
                        className="img-fluid height_auto"
                        alt=""
                      />
                      <input
                        className="radio"
                        type="radio"
                        text={t("Sill")}
                        value="1"
                        name="step3B"
                        ref-num="3B"
                        id="3B1"
                        checked={step3B === "Sill"}
                        onChange={(e) => {
                          if (
                            (step3B === "Floor" ||
                              step3B === "Slight Puddle" ||
                              step3B === "Apron") &&
                            anyMeasurements
                          ) {
                            modalHandleShow("FinishedLengthWarning");
                            setFinishedLengthTemp({
                              stepValue: "Sill",
                              id: "",
                              cartValue: "Sill",
                              event: e,
                            });
                          } else {
                            setStep3B("Sill");
                            clearInputs(e);
                            setCart("FinishedLengthType", "Sill");
                            if (
                              (step3A0 === "Ceiling" || step3A0 === "Moulding") &&
                              (step3A === "Standard" ||
                                step3A === "Left Corner Window" ||
                                step3A === "Right Corner Window")
                            ) {
                              setDeps(
                                "3C,3D1,3D2,3EStandardCeiling1,3EStandardCeiling2,3EStandardCeiling3,3G",
                                "3B,3B1,3E,3F,3EFloor,3BRod,3CRod,3CRodFloor,3DRod,3EStandardCeilingFloor1,3EStandardCeilingFloor2,3EStandardCeilingFloor3"
                              );
                            } else if (step3A === "Wall to Wall" && step3A0 === "Wall") {
                              setDeps(
                                "3C,3E,3F,3G",
                                "3B,3B1,3D1,3D2,3EFloor,3BRod,3CRod,3CRodFloor,3DRod,3EStandardCeiling1,3EStandardCeiling2,3EStandardCeiling3,3EStandardCeilingFloor1,3EStandardCeilingFloor2,3EStandardCeilingFloor3"
                              );
                            } else if (
                              step3A === "Wall to Wall" &&
                              (step3A0 === "Ceiling" || step3A0 === "Moulding")
                            ) {
                              setDeps(
                                "3C,3EStandardCeiling1,3EStandardCeiling2,3EStandardCeiling3,3G",
                                "3B,3B1,3D1,3D2,3E,3F,3EFloor,3BRod,3CRod,3CRodFloor,3DRod,3EStandardCeilingFloor1,3EStandardCeilingFloor2,3EStandardCeilingFloor3"
                              );
                            } else {
                              setDeps(
                                "3C,3D1,3D2,3E,3F,3G",
                                "3B,3B1,3EFloor,3BRod,3CRod,3CRodFloor,3DRod,3EStandardCeiling1,3EStandardCeiling2,3EStandardCeiling3,3EStandardCeilingFloor1,3EStandardCeilingFloor2,3EStandardCeilingFloor3"
                              );
                            }
                          }
                        }}
                        ref={(ref) => (inputs.current["3B1"] = ref)}
                      />
                      <label htmlFor="3B1">{t("Sill")}</label>
                    </div>
                    <div className="box25 radio_style 2">
                      <img
                        src={
                          pageLanguage === "fa"
                            ? require("../Images/drapery/grommet/length type-06.svg").default
                            : require("../Images/drapery/grommet/length type-03.svg").default
                        }
                        className="img-fluid height_auto"
                        alt=""
                      />
                      <input
                        className="radio"
                        type="radio"
                        text={t("Apron")}
                        value="2"
                        name="step3B"
                        ref-num="3B"
                        id="3B2"
                        checked={step3B === "Apron"}
                        onChange={(e) => {
                          if (
                            (step3B === "Floor" ||
                              step3B === "Slight Puddle" ||
                              step3B === "Sill") &&
                            anyMeasurements
                          ) {
                            modalHandleShow("FinishedLengthWarning");
                            setFinishedLengthTemp({
                              stepValue: "Apron",
                              id: "",
                              cartValue: "Apron",
                              event: e,
                            });
                          } else {
                            setStep3B("Apron");
                            clearInputs(e);
                            setCart("FinishedLengthType", "Apron");
                            if (
                              (step3A0 === "Ceiling" || step3A0 === "Moulding") &&
                              (step3A === "Standard" ||
                                step3A === "Left Corner Window" ||
                                step3A === "Right Corner Window")
                            ) {
                              setDeps(
                                "3C,3D1,3D2,3EStandardCeiling1,3EStandardCeiling2,3EStandardCeiling3,3G",
                                "3B,3B1,3E,3F,3EFloor,3BRod,3CRod,3CRodFloor,3DRod,3EStandardCeilingFloor1,3EStandardCeilingFloor2,3EStandardCeilingFloor3"
                              );
                            } else if (step3A === "Wall to Wall" && step3A0 === "Wall") {
                              setDeps(
                                "3C,3E,3F,3G",
                                "3B,3B1,3D1,3D2,3EFloor,3BRod,3CRod,3CRodFloor,3DRod,3EStandardCeiling1,3EStandardCeiling2,3EStandardCeiling3,3EStandardCeilingFloor1,3EStandardCeilingFloor2,3EStandardCeilingFloor3"
                              );
                            } else if (
                              step3A === "Wall to Wall" &&
                              (step3A0 === "Ceiling" || step3A0 === "Moulding")
                            ) {
                              setDeps(
                                "3C,3EStandardCeiling1,3EStandardCeiling2,3EStandardCeiling3,3G",
                                "3B,3B1,3D1,3D2,3E,3F,3EFloor,3BRod,3CRod,3CRodFloor,3DRod,3EStandardCeilingFloor1,3EStandardCeilingFloor2,3EStandardCeilingFloor3"
                              );
                            } else {
                              setDeps(
                                "3C,3D1,3D2,3E,3F,3G",
                                "3B,3B1,3EFloor,3BRod,3CRod,3CRodFloor,3DRod,3EStandardCeiling1,3EStandardCeiling2,3EStandardCeiling3,3EStandardCeilingFloor1,3EStandardCeilingFloor2,3EStandardCeilingFloor3"
                              );
                            }
                          }
                        }}
                        ref={(ref) => (inputs.current["3B2"] = ref)}
                      />
                      <label htmlFor="3B2">{t("Apron")}</label>
                    </div>
                    <div className="box25 radio_style 3">
                      <img
                        src={
                          pageLanguage === "fa"
                            ? require("../Images/drapery/grommet/length type-07.svg").default
                            : require("../Images/drapery/grommet/length type-02.svg").default
                        }
                        className="img-fluid height_auto"
                        alt=""
                      />
                      <input
                        className="radio"
                        type="radio"
                        text={t("Floor")}
                        value="3"
                        name="step3B"
                        ref-num="3B"
                        id="3B3"
                        checked={step3B === "Floor"}
                        onChange={(e) => {
                          if (
                            (step3B === "Sill" ||
                              step3B === "Apron" ||
                              step3B === "Slight Puddle") &&
                            anyMeasurements
                          ) {
                            modalHandleShow("FinishedLengthWarning");
                            setFinishedLengthTemp({
                              stepValue: "Floor",
                              id: "",
                              cartValue: "Floor",
                              event: e,
                            });
                          } else {
                            setStep3B("Floor");
                            clearInputs(e);
                            setCart("FinishedLengthType", "Floor");
                            if (
                              (step3A0 === "Ceiling" || step3A0 === "Moulding") &&
                              (step3A === "Standard" ||
                                step3A === "Left Corner Window" ||
                                step3A === "Right Corner Window")
                            ) {
                              setDeps(
                                "3C,3D1,3D2,3EStandardCeilingFloor1,3EStandardCeilingFloor2,3EStandardCeilingFloor3",
                                "3B,3B1,3E,3F,3G,3EFloor,3BRod,3CRod,3CRodFloor,3DRod,3EStandardCeiling1,3EStandardCeiling2,3EStandardCeiling3"
                              );
                            } else if (step3A === "Wall to Wall" && step3A0 === "Wall") {
                              setDeps(
                                "3C,3EFloor,3F,3G",
                                "3B,3B1,3D1,3D2,3E,3BRod,3CRod,3CRodFloor,3DRod,3EStandardCeiling1,3EStandardCeiling2,3EStandardCeiling3,3EStandardCeilingFloor1,3EStandardCeilingFloor2,3EStandardCeilingFloor3"
                              );
                            } else if (
                              step3A === "Wall to Wall" &&
                              (step3A0 === "Ceiling" || step3A0 === "Moulding")
                            ) {
                              setDeps(
                                "3C,3EStandardCeilingFloor1,3EStandardCeilingFloor2,3EStandardCeilingFloor3",
                                "3B,3B1,3D1,3D2,3E,3F,3G,3EFloor,3BRod,3CRod,3CRodFloor,3DRod,3EStandardCeiling1,3EStandardCeiling2,3EStandardCeiling3"
                              );
                            } else {
                              setDeps(
                                "3C,3D1,3D2,3EFloor,3F,3G",
                                "3B,3B1,3E,3BRod,3CRod,3CRodFloor,3DRod,3EStandardCeiling1,3EStandardCeiling2,3EStandardCeiling3,3EStandardCeilingFloor1,3EStandardCeilingFloor2,3EStandardCeilingFloor3"
                              );
                            }
                          }
                        }}
                        ref={(ref) => (inputs.current["3B3"] = ref)}
                      />
                      <label htmlFor="3B3">{t("Floor")}</label>
                    </div>
                    <div className="box25 radio_style 4">
                      <img
                        src={
                          pageLanguage === "fa"
                            ? require("../Images/drapery/grommet/length type-08.svg").default
                            : require("../Images/drapery/grommet/length type-01.svg").default
                        }
                        className="img-fluid height_auto"
                        alt=""
                      />
                      <input
                        className="radio"
                        type="radio"
                        text={t("Slight Puddle")}
                        value="4"
                        name="step3B"
                        ref-num="3B"
                        id="3B4"
                        checked={step3B === "Slight Puddle"}
                        onChange={(e) => {
                          if (
                            (step3B === "Sill" || step3B === "Apron" || step3B === "Floor") &&
                            anyMeasurements
                          ) {
                            modalHandleShow("FinishedLengthWarning");
                            setFinishedLengthTemp({
                              stepValue: "Slight Puddle",
                              id: "",
                              cartValue: "Slight Puddle",
                              event: e,
                            });
                          } else {
                            setStep3B("Slight Puddle");
                            clearInputs(e);
                            setCart("FinishedLengthType", "Slight Puddle");
                            if (
                              (step3A0 === "Ceiling" || step3A0 === "Moulding") &&
                              (step3A === "Standard" ||
                                step3A === "Left Corner Window" ||
                                step3A === "Right Corner Window")
                            ) {
                              setDeps(
                                "3C,3D1,3D2,3EStandardCeilingFloor1,3EStandardCeilingFloor2,3EStandardCeilingFloor3",
                                "3B,3B1,3E,3F,3G,3EFloor,3BRod,3CRod,3CRodFloor,3DRod,3EStandardCeiling1,3EStandardCeiling2,3EStandardCeiling3"
                              );
                            } else if (step3A === "Wall to Wall" && step3A0 === "Wall") {
                              setDeps(
                                "3C,3EFloor,3F,3G",
                                "3B,3B1,3D1,3D2,3E,3BRod,3CRod,3CRodFloor,3DRod,3EStandardCeiling1,3EStandardCeiling2,3EStandardCeiling3,3EStandardCeilingFloor1,3EStandardCeilingFloor2,3EStandardCeilingFloor3"
                              );
                            } else if (
                              step3A === "Wall to Wall" &&
                              (step3A0 === "Ceiling" || step3A0 === "Moulding")
                            ) {
                              setDeps(
                                "3C,3EStandardCeilingFloor1,3EStandardCeilingFloor2,3EStandardCeilingFloor3",
                                "3B,3B1,3D1,3D2,3E,3F,3G,3EFloor,3BRod,3CRod,3CRodFloor,3DRod,3EStandardCeiling1,3EStandardCeiling2,3EStandardCeiling3"
                              );
                            } else {
                              setDeps(
                                "3C,3D1,3D2,3EFloor,3F,3G",
                                "3B,3B1,3E,3BRod,3CRod,3CRodFloor,3DRod,3EStandardCeiling1,3EStandardCeiling2,3EStandardCeiling3,3EStandardCeilingFloor1,3EStandardCeilingFloor2,3EStandardCeilingFloor3"
                              );
                            }
                          }
                        }}
                        ref={(ref) => (inputs.current["3B4"] = ref)}
                      />
                      <label htmlFor="3B4">{t("Slight Puddle")}</label>
                    </div>

                    <div
                      className={
                        step3B === "Apron"
                          ? step3BErr1
                            ? "secondary_options secondary_options_err secondary_options_text"
                            : "secondary_options secondary_options_text"
                          : "noDisplay"
                      }
                    >
                      <div className="card-body-display-flex">
                        <div className="checkbox_style checkbox_style_step2">
                          <span className="checkbox_text box100">
                            {t("grommet_apron_checkbox_title")}
                          </span>
                        </div>
                      </div>
                    </div>

                    <div
                      className={
                        step3B === "Slight Puddle"
                          ? "secondary_options secondary_options_text"
                          : "noDisplay"
                      }
                    >
                      <div className="card-body-display-flex">
                        <div className="checkbox_style checkbox_style_step2">
                          <span className="checkbox_text box100">{t("puddle_text")}</span>
                        </div>
                      </div>
                    </div>

                    {step3BErr1 && <div className="input_not_valid">{t("grommet_step3AErr1")}</div>}
                    <NextStep currentStep="3B" eventKey="3C">
                      {t("NEXT STEP")}
                    </NextStep>
                  </div>

                  <div className="accordion_help">
                    <div className="help_container">
                      <div className="help_column help_left_column">
                        <p className="help_column_header"></p>
                        <ul className="help_column_list">
                          <li className="no_listStyle">
                            <b>{t("dk_step2a_help1")}</b>
                            {t("dk_step2a_help2")}
                          </li>
                          <li className="no_listStyle">
                            <b>{t("grommet_step3a_help2")}</b>
                            {t("grommet_step3a_help3")}
                          </li>
                          <li className="no_listStyle">
                            <b>{t("grommet_step3a_help4")}</b>
                            {t("grommet_step3a_help5")}
                          </li>
                          <li className="no_listStyle">
                            <b>{t("grommet_step3a_help6")}</b>
                            {t("grommet_step3a_help7")}
                          </li>
                        </ul>
                      </div>
                    </div>
                  </div>
                </Card.Body>
              </Accordion.Collapse>
            </Card>

            {/* step 5C*/}
            <Card
              className={
                isShowStep5
                  ? "noDisplay"
                  : step3 === "true" &&
                    step31 === "false" &&
                    step3A !== "" &&
                    step3B !== "" &&
                    step3A0 !== ""
                  ? ""
                  : "noDisplay"
              }
            >
              <Card.Header
                className={
                  [...depSet].findIndex((el) => el.startsWith("3")) === -1 &&
                  !accordionActiveKey.startsWith("3")
                    ? "hidden"
                    : ""
                }
              >
                <ContextAwareToggle
                  eventKey="3C"
                  stepNum={t("5C")}
                  stepTitle={step3A === "Wall to Wall" ? t("grommet_width_wall") : t("dk_step2B")}
                  stepRef="3C"
                  type="2"
                  required={requiredStep["3C"]}
                  stepSelected={
                    stepSelectedLabel["3C"] === undefined ? "" : stepSelectedLabel["3C"]
                  }
                />
              </Card.Header>
              <Accordion.Collapse eventKey="3C">
                <Card.Body>
                  <div className="card_body">
                    <div className="box100">
                      <p className="step_selection_title">
                        {step3A === "Wall to Wall"
                          ? t("grommet_width_wall_title")
                          : t("dk_step2B_title")}
                      </p>
                      <img
                        src={
                          step3A === "Wall to Wall"
                            ? step3A0 === "Moulding"
                              ? require("../Images/drapery/grommet/FrameSize_wall_arc.svg").default
                              : pageLanguage === "en"
                              ? require("../Images/drapery/europeanNew2/WCE-IDONOT-WallToWall.svg")
                                  .default
                              : require("../Images/drapery/europeanNew2/FWCE-IDONOT-WallToWall-01.svg")
                                  .default
                            : require("../Images/drapery/europeanNew2/WCE-IDONOT-Window-Width-01.svg")
                                .default
                        }
                        className="img-fluid frame_with_top"
                        alt=""
                      />
                    </div>
                    <div className="box100 Three_selection_container">
                      <div className="box100">
                        <div className="measure_input_container">
                          <h1 className="measure_input_label">{t("Width")}</h1>
                          <div className="measure_input_field_container">
                            <DebounceInput
                              debounceTimeout={1500}
                              autoComplete="off"
                              onKeyDown={(e) => {
                                if (
                                  !/[0-9]/.test(NumberToPersianWord.convertPeToEn(e.key)) &&
                                  e.keyCode !== 8 &&
                                  e.keyCode !== 46 &&
                                  e.keyCode !== 37 &&
                                  e.keyCode !== 39 &&
                                  e.keyCode !== 13
                                ) {
                                  e.preventDefault();
                                }
                              }}
                              className={
                                "measure_input" +
                                (width3C !== undefined && (width3C < 1 || width3C > 1000)
                                  ? " measure_input_err"
                                  : "")
                              }
                              type="text"
                              name="width3C"
                              value={NumToFa(`${width3C || ""}`, pageLanguage)}
                              onChange={(e) => {
                                setTimeout(() => {
                                  let newValue = NumberToPersianWord.convertPeToEn(e.target.value);
                                  newValue = isNaN(newValue) ? "" : newValue;
                                  if (
                                    newValue &&
                                    newValue !== "" &&
                                    parseInt(newValue) >= 1 &&
                                    parseInt(newValue) <= 1000
                                  ) {
                                    setCartLoading(true);
                                    setCart("Width3C", parseInt(newValue));
                                    setDeps("", "3C");
                                    setWidth3C(parseInt(newValue));
                                    optionSelectChanged(
                                      "3C",
                                      parseInt(newValue),
                                      "cm",
                                      "س\u200Cم",
                                      pageLanguage
                                    );
                                  } else {
                                    setCartLoading(true);
                                    setCart("", "", "Width3C");
                                    setDeps("3C", "");
                                    if (newValue === "" || isNaN(parseInt(newValue))) {
                                      setWidth3C(undefined);
                                      selectChanged(undefined, "3C");
                                    } else {
                                      setWidth3C(parseInt(newValue));
                                      selectChanged("3C", undefined, t("Invalid Measurements"));
                                    }
                                  }
                                }, 300);
                              }}
                            />
                            <div className="measure_input_postfix">{t("cm_label")}</div>
                          </div>
                        </div>
                      </div>
                    </div>
                    <NextStep currentStep="3C" eventKey={step3A === "Wall to Wall" ? "3E" : "3D"}>
                      {t("NEXT STEP")}
                    </NextStep>
                  </div>
                </Card.Body>
              </Accordion.Collapse>
            </Card>

            {/* step 5D*/}
            <Card
              className={
                isShowStep5
                  ? "noDisplay"
                  : step3 === "true" &&
                    step31 === "false" &&
                    step3A !== "" &&
                    step3B !== "" &&
                    step3A0 !== "" &&
                    !(step3A === "Wall to Wall")
                  ? ""
                  : "noDisplay"
              }
            >
              <Card.Header
                className={
                  [...depSet].findIndex((el) => el.startsWith("3")) === -1 &&
                  !accordionActiveKey.startsWith("3")
                    ? "hidden"
                    : ""
                }
              >
                <ContextAwareToggle
                  eventKey="3D"
                  stepNum={t("5D")}
                  stepTitle={t("dk_step2CCeiling")}
                  stepRef="3D"
                  type="2"
                  required={requiredStep["3D"]}
                  stepSelected={
                    stepSelectedLabel["3D"] === undefined ? "" : stepSelectedLabel["3D"]
                  }
                />
              </Card.Header>
              <Accordion.Collapse eventKey="3D">
                <Card.Body>
                  <div className="card_body card_body_overflow_issue">
                    <div className="box100">
                      <p className="step_selection_title">{t("dk_step2c_out_title")}</p>
                      <img
                        src={
                          require("../Images/drapery/europeanNew2/WCE-IDONOT-Stack-Width -01.svg")
                            .default
                        }
                        className="img-fluid frame_with_top2 33"
                        alt=""
                      />
                    </div>
                    <div className="box100 Two_selection_container dir_ltr">
                      <div className="box50">
                        <div
                          className={
                            step3A === "Left Corner Window"
                              ? "measure_input_container disabled"
                              : "measure_input_container"
                          }
                        >
                          <h1 className="measure_input_label">{t("Left")}</h1>
                          <div className="measure_input_field_container">
                            <DebounceInput
                              inputRef={(ref) => (inputs.current["Left"] = ref)}
                              debounceTimeout={1500}
                              autoComplete="off"
                              onKeyDown={(e) => {
                                if (e.keyCode === 13) {
                                  inputs.current["Right"].focus();
                                } else if (
                                  !/[0-9]/.test(NumberToPersianWord.convertPeToEn(e.key)) &&
                                  e.keyCode !== 8 &&
                                  e.keyCode !== 46 &&
                                  e.keyCode !== 37 &&
                                  e.keyCode !== 39 &&
                                  e.keyCode !== 13
                                ) {
                                  e.preventDefault();
                                }
                              }}
                              className={
                                "measure_input" +
                                (left !== undefined && (left < 1 || left > 1000)
                                  ? " measure_input_err"
                                  : "")
                              }
                              type="text"
                              name="Left"
                              value={NumToFa(`${left || ""}`, pageLanguage)}
                              disabled={step3A === "Left Corner Window"}
                              onChange={(e) => {
                                setTimeout(() => {
                                  let newValue = NumberToPersianWord.convertPeToEn(e.target.value);
                                  newValue = isNaN(newValue) ? "" : newValue;
                                  if (
                                    newValue &&
                                    newValue !== "" &&
                                    parseInt(newValue) >= 1 &&
                                    parseInt(newValue) <= 1000
                                  ) {
                                    setCartLoading(true);
                                    if (step3A === "Right Corner Window") {
                                      optionSelectChanged_LeftRight(
                                        parseInt(newValue),
                                        "3D",
                                        true,
                                        "cm",
                                        "س\u200Cم",
                                        pageLanguage,
                                        0
                                      );
                                      setDeps("", "3D1,3D2");
                                      setCart(
                                        "ExtensionLeft",
                                        parseInt(newValue),
                                        "",
                                        "ExtensionRight",
                                        [0]
                                      );
                                    } else {
                                      setCart("ExtensionLeft", parseInt(newValue));
                                      setDeps("", "3D1");
                                      optionSelectChanged_LeftRight(
                                        parseInt(newValue),
                                        "3D",
                                        true,
                                        "cm",
                                        "س\u200Cم",
                                        pageLanguage
                                      );
                                    }
                                    setLeft(parseInt(newValue));
                                  } else {
                                    setCartLoading(true);
                                    if (step3A === "Right Corner Window") {
                                      setDeps("3D1,3D2", "");
                                      setCart("", "", "ExtensionLeft,ExtensionRight");
                                    } else {
                                      setCart("", "", "ExtensionLeft");
                                      setDeps("3D1", "");
                                    }
                                    if (newValue === "" || isNaN(parseInt(newValue))) {
                                      setLeft(undefined);
                                      selectChanged(undefined, "3D");
                                    } else {
                                      setLeft(parseInt(newValue));
                                      selectChanged("3D", undefined, t("Invalid Measurements"));
                                    }
                                  }
                                }, 300);
                              }}
                            />
                            <div className="measure_input_postfix">{t("cm_label")}</div>
                          </div>
                        </div>
                        {step3A === "Left Corner Window" && (
                          <OverlayContainer
                            classNames="extension_unavailable"
                            placement="bottom"
                            children={
                              <div className="extension_unavailable_title text_underline">
                                {t("Why is this unavailable?")}
                              </div>
                            }
                            component={
                              <div className="extension_unavailable_container">
                                <div className="extension_unavailable_text">
                                  {t("Left_unavailable_text")}
                                </div>
                              </div>
                            }
                          />
                        )}
                      </div>
                      <div className="box50">
                        <div
                          className={
                            step3A === "Right Corner Window"
                              ? "measure_input_container disabled"
                              : "measure_input_container"
                          }
                        >
                          <h1 className="measure_input_label">{t("Right")}</h1>
                          <div className="measure_input_field_container">
                            <DebounceInput
                              inputRef={(ref) => (inputs.current["Right"] = ref)}
                              debounceTimeout={1500}
                              autoComplete="off"
                              onKeyDown={(e) => {
                                if (e.keyCode === 13) {
                                  inputs.current["Left"].focus();
                                } else if (
                                  !/[0-9]/.test(NumberToPersianWord.convertPeToEn(e.key)) &&
                                  e.keyCode !== 8 &&
                                  e.keyCode !== 46 &&
                                  e.keyCode !== 37 &&
                                  e.keyCode !== 39 &&
                                  e.keyCode !== 13
                                ) {
                                  e.preventDefault();
                                }
                              }}
                              className={
                                "measure_input" +
                                (right !== undefined && (right < 1 || right > 1000)
                                  ? " measure_input_err"
                                  : "")
                              }
                              type="text"
                              name="right"
                              value={NumToFa(`${right || ""}`, pageLanguage)}
                              disabled={step3A === "Right Corner Window"}
                              onChange={(e) => {
                                setTimeout(() => {
                                  let newValue = NumberToPersianWord.convertPeToEn(e.target.value);
                                  newValue = isNaN(newValue) ? "" : newValue;
                                  if (
                                    newValue &&
                                    newValue !== "" &&
                                    parseInt(newValue) >= 1 &&
                                    parseInt(newValue) <= 1000
                                  ) {
                                    setCartLoading(true);
                                    if (step3A === "Left Corner Window") {
                                      optionSelectChanged_LeftRight(
                                        parseInt(newValue),
                                        "3D",
                                        false,
                                        "cm",
                                        "س\u200Cم",
                                        pageLanguage,
                                        0
                                      );
                                      setDeps("", "3D2,3D1");
                                      setCart(
                                        "ExtensionRight",
                                        parseInt(newValue),
                                        "",
                                        "ExtensionLeft",
                                        [0]
                                      );
                                    } else {
                                      setCart("ExtensionRight", parseInt(newValue));
                                      setDeps("", "3D2");
                                      optionSelectChanged_LeftRight(
                                        parseInt(newValue),
                                        "3D",
                                        false,
                                        "cm",
                                        "س\u200Cم",
                                        pageLanguage
                                      );
                                    }
                                    setRight(parseInt(newValue));
                                  } else {
                                    setCartLoading(true);
                                    if (step3A === "Left Corner Window") {
                                      setDeps("3D2,3D1", "");
                                      setCart("", "", "ExtensionRight,ExtensionLeft");
                                    } else {
                                      setCart("", "", "ExtensionRight");
                                      setDeps("3D2", "");
                                    }
                                    if (newValue === "" || isNaN(parseInt(newValue))) {
                                      setRight(undefined);
                                      selectChanged(undefined, "3D");
                                    } else {
                                      setRight(parseInt(newValue));
                                      selectChanged("3D", undefined, t("Invalid Measurements"));
                                    }
                                  }
                                }, 300);
                              }}
                            />
                            <div className="measure_input_postfix">{t("cm_label")}</div>
                          </div>
                        </div>
                        {step3A === "Right Corner Window" && (
                          <OverlayContainer
                            classNames="extension_unavailable"
                            placement="bottom"
                            children={
                              <div className="extension_unavailable_title text_underline">
                                {t("Why is this unavailable?")}
                              </div>
                            }
                            component={
                              <div className="extension_unavailable_container">
                                <div className="extension_unavailable_text">
                                  {t("Right_unavailable_text")}
                                </div>
                              </div>
                            }
                          />
                        )}
                      </div>
                    </div>

                    <NextStep currentStep="3D" eventKey="3E">
                      {t("NEXT STEP")}
                    </NextStep>
                  </div>

                  <div className="accordion_help">
                    <div className="help_container">
                      <div className="help_column help_left_column">
                        <p className="help_column_header" />
                        <ul className="help_column_list">
                          <li className="no_listStyle single_line_height">
                            {t("grommet_step3C_help_1")}
                          </li>
                        </ul>
                      </div>
                    </div>
                  </div>
                </Card.Body>
              </Accordion.Collapse>
            </Card>

            {/* step 5E*/}
            <Card
              className={
                isShowStep5
                  ? "noDisplay"
                  : step3 === "true" &&
                    step31 === "false" &&
                    step3A !== "" &&
                    step3B !== "" &&
                    step3A0 !== "" &&
                    !(
                      (step3A0 === "Ceiling" || step3A0 === "Moulding") &&
                      (step3A === "Standard" ||
                        step3A === "Left Corner Window" ||
                        step3A === "Right Corner Window")
                    ) &&
                    !(
                      step3A === "Wall to Wall" &&
                      (step3A0 === "Ceiling" || step3A0 === "Moulding")
                    ) &&
                    (step3B === "Sill" || step3B === "Apron")
                  ? ""
                  : "noDisplay"
              }
            >
              <Card.Header
                className={
                  [...depSet].findIndex((el) => el.startsWith("3")) === -1 &&
                  !accordionActiveKey.startsWith("3")
                    ? "hidden"
                    : ""
                }
              >
                <ContextAwareToggle
                  eventKey="3E"
                  stepNum={step5ETitle}
                  stepTitle={t("dk_step2EWall")}
                  stepRef="3E"
                  type="2"
                  required={requiredStep["3E"]}
                  stepSelected={
                    stepSelectedLabel["3E"] === undefined ? "" : stepSelectedLabel["3E"]
                  }
                />
              </Card.Header>
              <Accordion.Collapse eventKey="3E">
                <Card.Body>
                  <div className="card_body">
                    <div className="box100">
                      <p className="step_selection_title">{t("dk_step2EWall_title")}</p>
                      <img
                        src={
                          require("../Images/drapery/europeanNew2/WCE-IDONOT-Window-Height-01.svg")
                            .default
                        }
                        className="img-fluid just_frame 1"
                        alt=""
                      />
                    </div>
                    <div className="box100 Three_selection_container">
                      <div className="box100">
                        <div className="measure_input_container">
                          <h1 className="measure_input_label">{t("Height")}</h1>
                          <div className="measure_input_field_container">
                            <DebounceInput
                              debounceTimeout={1500}
                              autoComplete="off"
                              onKeyDown={(e) => {
                                if (
                                  !/[0-9]/.test(NumberToPersianWord.convertPeToEn(e.key)) &&
                                  e.keyCode !== 8 &&
                                  e.keyCode !== 46 &&
                                  e.keyCode !== 37 &&
                                  e.keyCode !== 39 &&
                                  e.keyCode !== 13
                                ) {
                                  e.preventDefault();
                                }
                              }}
                              className={
                                "measure_input" +
                                (height3E !== undefined && (height3E < 1 || height3E > 1000)
                                  ? " measure_input_err"
                                  : "")
                              }
                              type="text"
                              name="height3E"
                              value={NumToFa(`${height3E || ""}`, pageLanguage)}
                              onChange={(e) => {
                                setTimeout(() => {
                                  let newValue = NumberToPersianWord.convertPeToEn(e.target.value);
                                  newValue = isNaN(newValue) ? "" : newValue;
                                  if (
                                    newValue &&
                                    newValue !== "" &&
                                    parseInt(newValue) >= 1 &&
                                    parseInt(newValue) <= 1000
                                  ) {
                                    setCartLoading(true);
                                    setCart("Height3E", parseInt(newValue));
                                    setDeps("", "3E");
                                    setHeight3E(parseInt(newValue));
                                    optionSelectChanged(
                                      "3E",
                                      parseInt(newValue),
                                      "cm",
                                      "س\u200Cم",
                                      pageLanguage
                                    );
                                  } else {
                                    setCartLoading(true);
                                    setCart("", "", "Height3E");
                                    setDeps("3E", "");
                                    if (newValue === "" || isNaN(parseInt(newValue))) {
                                      setHeight3E(undefined);
                                      selectChanged(undefined, "3E");
                                    } else {
                                      setHeight3E(parseInt(newValue));
                                      selectChanged("3E", undefined, t("Invalid Measurements"));
                                    }
                                  }
                                }, 300);
                              }}
                            />
                            <div className="measure_input_postfix">{t("cm_label")}</div>
                          </div>
                        </div>
                      </div>
                    </div>
                    <NextStep currentStep="3E" eventKey={step3A === "Wall to Wall" ? "3F" : "3F"}>
                      {t("NEXT STEP")}
                    </NextStep>
                  </div>
                </Card.Body>
              </Accordion.Collapse>
            </Card>

            {/* step 5EFloor */}
            <Card
              className={
                isShowStep5
                  ? "noDisplay"
                  : step3 === "true" &&
                    step31 === "false" &&
                    step3A !== "" &&
                    step3B !== "" &&
                    step3A0 !== "" &&
                    !(
                      (step3A0 === "Ceiling" || step3A0 === "Moulding") &&
                      (step3A === "Standard" ||
                        step3A === "Left Corner Window" ||
                        step3A === "Right Corner Window")
                    ) &&
                    !(
                      step3A === "Wall to Wall" &&
                      (step3A0 === "Ceiling" || step3A0 === "Moulding")
                    ) &&
                    (step3B === "Floor" || step3B === "Slight Puddle")
                  ? ""
                  : "noDisplay"
              }
            >
              <Card.Header
                className={
                  [...depSet].findIndex((el) => el.startsWith("3")) === -1 &&
                  !accordionActiveKey.startsWith("3")
                    ? "hidden"
                    : ""
                }
              >
                <ContextAwareToggle
                  eventKey="3E"
                  stepNum={step3A === "Wall to Wall" ? t("5D") : t("5E")}
                  stepTitle={t("dk_step2DWall")}
                  stepRef="3EFloor"
                  type="2"
                  required={requiredStep["3EFloor"]}
                  stepSelected={
                    stepSelectedLabel["3EFloor"] === undefined ? "" : stepSelectedLabel["3EFloor"]
                  }
                />
              </Card.Header>
              <Accordion.Collapse eventKey="3E">
                <Card.Body>
                  <div className="card_body">
                    <div className="box100">
                      <p className="step_selection_title">{t("dk_step2DWall_title")}</p>
                      <img
                        src={
                          pageLanguage === "fa"
                            ? require("../Images/drapery/europeanNew2/FWCE-IDONOT-WindowToFloor-Height-01.svg")
                                .default
                            : require("../Images/drapery/europeanNew2/WCE-IDONOT-WindowToFloor-Height-01.svg")
                                .default
                        }
                        className="img-fluid tall_curtain_image"
                        alt=""
                      />
                    </div>

                    <div className="box100 Three_selection_container">
                      <div className="box100">
                        <div className="measure_input_container">
                          <div className="measure_input_field_container">
                            <DebounceInput
                              debounceTimeout={1500}
                              autoComplete="off"
                              onKeyDown={(e) => {
                                if (
                                  !/[0-9]/.test(NumberToPersianWord.convertPeToEn(e.key)) &&
                                  e.keyCode !== 8 &&
                                  e.keyCode !== 46 &&
                                  e.keyCode !== 37 &&
                                  e.keyCode !== 39 &&
                                  e.keyCode !== 13
                                ) {
                                  e.preventDefault();
                                }
                              }}
                              className={
                                "measure_input" +
                                (windowToFloor !== undefined &&
                                (windowToFloor < 1 || windowToFloor > 1000)
                                  ? " measure_input_err"
                                  : "")
                              }
                              type="text"
                              name="windowToFloor1"
                              value={NumToFa(`${windowToFloor || ""}`, pageLanguage)}
                              onChange={(e) => {
                                setTimeout(() => {
                                  let newValue = NumberToPersianWord.convertPeToEn(e.target.value);
                                  newValue = isNaN(newValue) ? "" : newValue;
                                  if (
                                    newValue &&
                                    newValue !== "" &&
                                    parseInt(newValue) >= 1 &&
                                    parseInt(newValue) <= 1000
                                  ) {
                                    setCartLoading(true);
                                    setCart("WindowToFloor", parseInt(newValue));
                                    setDeps("", "3EFloor");
                                    setWindowToFloor(parseInt(newValue));
                                    optionSelectChanged(
                                      "3EFloor",
                                      parseInt(newValue),
                                      "cm",
                                      "س\u200Cم",
                                      pageLanguage
                                    );
                                  } else {
                                    setCartLoading(true);
                                    setCart("", "", "WindowToFloor");
                                    setDeps("3EFloor", "");
                                    if (newValue === "" || isNaN(parseInt(newValue))) {
                                      setWindowToFloor(undefined);
                                      selectChanged(undefined, "3EFloor");
                                    } else {
                                      setWindowToFloor(parseInt(newValue));
                                      selectChanged(
                                        "3EFloor",
                                        undefined,
                                        t("Invalid Measurements")
                                      );
                                    }
                                  }
                                }, 300);
                              }}
                            />
                            <div className="measure_input_postfix">{t("cm_label")}</div>
                          </div>
                        </div>
                      </div>
                    </div>
                    <NextStep
                      currentStep="3EFloor"
                      eventKey={step3A === "Wall to Wall" ? "3F" : "3F"}
                    >
                      {t("NEXT STEP")}
                    </NextStep>
                  </div>
                </Card.Body>
              </Accordion.Collapse>
            </Card>

            {/* step 5EStandardCeiling */}
            <Card
              className={
                isShowStep5
                  ? "noDisplay"
                  : step3 === "true" &&
                    step31 === "false" &&
                    (((step3A0 === "Ceiling" || step3A0 === "Moulding") &&
                      (step3A === "Standard" ||
                        step3A === "Left Corner Window" ||
                        step3A === "Right Corner Window")) ||
                      (step3A === "Wall to Wall" &&
                        (step3A0 === "Ceiling" || step3A0 === "Moulding"))) &&
                    step3B !== "" &&
                    step3A0 !== "" &&
                    (step3B === "Sill" || step3B === "Apron")
                  ? ""
                  : "noDisplay"
              }
            >
              <Card.Header
                className={
                  [...depSet].findIndex((el) => el.startsWith("3")) === -1 &&
                  !accordionActiveKey.startsWith("3")
                    ? "hidden"
                    : ""
                }
              >
                <ContextAwareToggle
                  eventKey="3E"
                  stepNum={step5EStandardCeilingTitle}
                  stepTitle={t("dk_step2D_sill")}
                  stepRef="3EStandardCeiling"
                  type="2"
                  required={requiredStep["3EStandardCeiling"]}
                  stepSelected={
                    stepSelectedLabel["3EStandardCeiling"] === undefined
                      ? ""
                      : stepSelectedLabel["3EStandardCeiling"]
                  }
                />
              </Card.Header>
              <Accordion.Collapse eventKey="3E">
                <Card.Body>
                  <div className="card_body">
                    <div className="box100">
                      <p className="step_selection_title">
                        {step3A0 === "Moulding" ? t("arc_step2D_title") : t("dk_step2D_title")}
                      </p>
                      <img
                        src={
                          pageLanguage === "fa"
                            ? step3A0 === "Moulding"
                              ? require("../Images/drapery/dk/new_ceiling_to_window_3_arc_fa.svg")
                                  .default
                              : require("../Images/drapery/europeanNew2/FCeiling-IDONOT-CeIlingToWindowHeight-01.svg")
                                  .default
                            : step3A0 === "Moulding"
                            ? require("../Images/drapery/dk/new_ceiling_to_window_3_arc.svg")
                                .default
                            : require("../Images/drapery/europeanNew2/Ceiling-IDONOT-CeIlingToWindowHeight-01.svg")
                                .default
                        }
                        className="img-fluid tall_curtain_image"
                        alt=""
                      />
                    </div>

                    <div className="box100 Three_selection_container">
                      <div className="Three_select_container">
                        <div className="measure_input_container">
                          <h1 className="measure_input_label">{t("step3BIn_A")}</h1>
                          <div className="measure_input_field_container">
                            <DebounceInput
                              inputRef={(ref) => (inputs.current["ceilingToWindow1"] = ref)}
                              debounceTimeout={1500}
                              autoComplete="off"
                              onKeyDown={(e) => {
                                if (e.keyCode === 13) {
                                  inputs.current["ceilingToWindow2"].focus();
                                } else if (
                                  !/[0-9]/.test(NumberToPersianWord.convertPeToEn(e.key)) &&
                                  e.keyCode !== 8 &&
                                  e.keyCode !== 46 &&
                                  e.keyCode !== 37 &&
                                  e.keyCode !== 39 &&
                                  e.keyCode !== 13
                                ) {
                                  e.preventDefault();
                                }
                              }}
                              className={
                                "measure_input" +
                                (ceilingToWindow1 !== undefined &&
                                (ceilingToWindow1 < 1 || ceilingToWindow1 > 1000)
                                  ? " measure_input_err"
                                  : "")
                              }
                              type="text"
                              name="ceilingToWindow1"
                              value={NumToFa(`${ceilingToWindow1 || ""}`, pageLanguage)}
                              onChange={(e) => {
                                setTimeout(() => {
                                  let newValue = NumberToPersianWord.convertPeToEn(e.target.value);
                                  newValue = isNaN(newValue) ? "" : newValue;
                                  if (
                                    newValue &&
                                    newValue !== "" &&
                                    parseInt(newValue) >= 1 &&
                                    parseInt(newValue) <= 1000
                                  ) {
                                    setCartLoading(true);
                                    setCart("CeilingToWindow1", parseInt(newValue));
                                    setDeps("", "3EStandardCeiling1");
                                    setCeilingToWindow1(parseInt(newValue));
                                    optionSelectChanged_three(
                                      parseInt(newValue),
                                      "3EStandardCeiling",
                                      0,
                                      true,
                                      "heightDifferent",
                                      "cm",
                                      "س\u200Cم",
                                      pageLanguage,
                                      "3E"
                                    );
                                  } else {
                                    setCartLoading(true);
                                    setCart("", "", "CeilingToWindow1");
                                    setDeps("3EStandardCeiling1", "");
                                    if (newValue === "" || isNaN(parseInt(newValue))) {
                                      setCeilingToWindow1(undefined);
                                      selectChanged(undefined, "3EStandardCeiling");
                                    } else {
                                      setCeilingToWindow1(parseInt(newValue));
                                      selectChanged(
                                        "3EStandardCeiling",
                                        undefined,
                                        t("Invalid Measurements")
                                      );
                                    }
                                  }
                                }, 300);
                              }}
                            />
                            <div className="measure_input_postfix">{t("cm_label")}</div>
                          </div>
                        </div>
                      </div>
                      <div className="Three_select_container">
                        <div className="measure_input_container">
                          <h1 className="measure_input_label">{t("step3BIn_B")}</h1>
                          <div className="measure_input_field_container">
                            <DebounceInput
                              inputRef={(ref) => (inputs.current["ceilingToWindow2"] = ref)}
                              debounceTimeout={1500}
                              autoComplete="off"
                              onKeyDown={(e) => {
                                if (e.keyCode === 13) {
                                  if (pageLanguage === "fa") {
                                    inputs.current["ceilingToWindow1"].focus();
                                  } else {
                                    inputs.current["ceilingToWindow3"].focus();
                                  }
                                } else if (
                                  !/[0-9]/.test(NumberToPersianWord.convertPeToEn(e.key)) &&
                                  e.keyCode !== 8 &&
                                  e.keyCode !== 46 &&
                                  e.keyCode !== 37 &&
                                  e.keyCode !== 39 &&
                                  e.keyCode !== 13
                                ) {
                                  e.preventDefault();
                                }
                              }}
                              className={
                                "measure_input" +
                                (ceilingToWindow2 !== undefined &&
                                (ceilingToWindow2 < 1 || ceilingToWindow2 > 1000)
                                  ? " measure_input_err"
                                  : "")
                              }
                              type="text"
                              name="ceilingToWindow2"
                              value={NumToFa(`${ceilingToWindow2 || ""}`, pageLanguage)}
                              onChange={(e) => {
                                setTimeout(() => {
                                  let newValue = NumberToPersianWord.convertPeToEn(e.target.value);
                                  newValue = isNaN(newValue) ? "" : newValue;
                                  if (
                                    newValue &&
                                    newValue !== "" &&
                                    parseInt(newValue) >= 1 &&
                                    parseInt(newValue) <= 1000
                                  ) {
                                    setCartLoading(true);
                                    setCart("CeilingToWindow2", parseInt(newValue));
                                    setDeps("", "3EStandardCeiling2");
                                    setCeilingToWindow2(parseInt(newValue));
                                    optionSelectChanged_three(
                                      parseInt(newValue),
                                      "3EStandardCeiling",
                                      1,
                                      true,
                                      "heightDifferent",
                                      "cm",
                                      "س\u200Cم",
                                      pageLanguage,
                                      "3E"
                                    );
                                  } else {
                                    setCartLoading(true);
                                    setCart("", "", "CeilingToWindow2");
                                    setDeps("3EStandardCeiling2", "");
                                    if (newValue === "" || isNaN(parseInt(newValue))) {
                                      setCeilingToWindow2(undefined);
                                      selectChanged(undefined, "3EStandardCeiling");
                                    } else {
                                      setCeilingToWindow2(parseInt(newValue));
                                      selectChanged(
                                        "3EStandardCeiling",
                                        undefined,
                                        t("Invalid Measurements")
                                      );
                                    }
                                  }
                                }, 300);
                              }}
                            />
                            <div className="measure_input_postfix">{t("cm_label")}</div>
                          </div>
                        </div>
                      </div>
                      <div className="Three_select_container">
                        <div className="measure_input_container">
                          <h1 className="measure_input_label">{t("step3BIn_C")}</h1>
                          <div className="measure_input_field_container">
                            <DebounceInput
                              inputRef={(ref) => (inputs.current["ceilingToWindow3"] = ref)}
                              debounceTimeout={1500}
                              autoComplete="off"
                              onKeyDown={(e) => {
                                if (e.keyCode === 13) {
                                  inputs.current["ceilingToWindow2"].focus();
                                } else if (
                                  !/[0-9]/.test(NumberToPersianWord.convertPeToEn(e.key)) &&
                                  e.keyCode !== 8 &&
                                  e.keyCode !== 46 &&
                                  e.keyCode !== 37 &&
                                  e.keyCode !== 39 &&
                                  e.keyCode !== 13
                                ) {
                                  e.preventDefault();
                                }
                              }}
                              className={
                                "measure_input" +
                                (ceilingToWindow3 !== undefined &&
                                (ceilingToWindow3 < 1 || ceilingToWindow3 > 1000)
                                  ? " measure_input_err"
                                  : "")
                              }
                              type="text"
                              name="ceilingToWindow3"
                              value={NumToFa(`${ceilingToWindow3 || ""}`, pageLanguage)}
                              onChange={(e) => {
                                setTimeout(() => {
                                  let newValue = NumberToPersianWord.convertPeToEn(e.target.value);
                                  newValue = isNaN(newValue) ? "" : newValue;
                                  if (
                                    newValue &&
                                    newValue !== "" &&
                                    parseInt(newValue) >= 1 &&
                                    parseInt(newValue) <= 1000
                                  ) {
                                    setCartLoading(true);
                                    setCart("CeilingToWindow3", parseInt(newValue));
                                    setDeps("", "3EStandardCeiling3");
                                    setCeilingToWindow3(parseInt(newValue));
                                    optionSelectChanged_three(
                                      parseInt(newValue),
                                      "3EStandardCeiling",
                                      2,
                                      true,
                                      "heightDifferent",
                                      "cm",
                                      "س\u200Cم",
                                      pageLanguage,
                                      "3E"
                                    );
                                  } else {
                                    setCartLoading(true);
                                    setCart("", "", "CeilingToWindow3");
                                    setDeps("3EStandardCeiling3", "");
                                    if (newValue === "" || isNaN(parseInt(newValue))) {
                                      setCeilingToWindow3(undefined);
                                      selectChanged(undefined, "3EStandardCeiling");
                                    } else {
                                      setCeilingToWindow3(parseInt(newValue));
                                      selectChanged(
                                        "3EStandardCeiling",
                                        undefined,
                                        t("Invalid Measurements")
                                      );
                                    }
                                  }
                                }, 300);
                              }}
                            />
                            <div className="measure_input_postfix">{t("cm_label")}</div>
                          </div>
                        </div>
                      </div>
                    </div>
                    <NextStep
                      currentStep={
                        [...depSet].findIndex((el) => el.startsWith("3")) === -1
                          ? "3"
                          : "3EStandardCeiling"
                      }
                      eventKey="3G"
                    >
                      {t("NEXT STEP")}
                    </NextStep>
                  </div>
                </Card.Body>
              </Accordion.Collapse>
            </Card>

            {/* step 5EStandardCeilingFloor */}
            <Card
              className={
                isShowStep5
                  ? "noDisplay"
                  : step3 === "true" &&
                    step31 === "false" &&
                    (((step3A0 === "Ceiling" || step3A0 === "Moulding") &&
                      (step3A === "Standard" ||
                        step3A === "Left Corner Window" ||
                        step3A === "Right Corner Window")) ||
                      (step3A === "Wall to Wall" &&
                        (step3A0 === "Ceiling" || step3A0 === "Moulding"))) &&
                    step3B !== "" &&
                    step3A0 !== "" &&
                    (step3B === "Floor" || step3B === "Slight Puddle")
                  ? ""
                  : "noDisplay"
              }
            >
              <Card.Header
                className={
                  [...depSet].findIndex((el) => el.startsWith("3")) === -1 &&
                  !accordionActiveKey.startsWith("3")
                    ? "hidden"
                    : ""
                }
              >
                <ContextAwareToggle
                  eventKey="3E"
                  stepNum={step5EStandardCeilingFloorTitle}
                  stepTitle={t("dk_step2E")}
                  stepRef="3EStandardCeilingFloor"
                  type="2"
                  required={requiredStep["3EStandardCeilingFloor"]}
                  stepSelected={
                    stepSelectedLabel["3EStandardCeilingFloor"] === undefined
                      ? ""
                      : stepSelectedLabel["3EStandardCeilingFloor"]
                  }
                />
              </Card.Header>
              <Accordion.Collapse eventKey="3E">
                <Card.Body>
                  <div className="card_body">
                    <div className="box100">
                      <p className="step_selection_title">
                        {step3A0 === "Moulding" ? t("arc_step2E_title") : t("dk_step2E_title")}
                      </p>
                      <img
                        src={
                          pageLanguage === "fa"
                            ? step3A0 === "Moulding"
                              ? require("../Images/drapery/dk/new_ceiling_to_floor_3_arc_fa.svg")
                                  .default
                              : require("../Images/drapery/europeanNew2/FCeiling-IDONOT-Height-01.svg")
                                  .default
                            : step3A0 === "Moulding"
                            ? require("../Images/drapery/dk/new_ceiling_to_floor_3_arc.svg").default
                            : require("../Images/drapery/europeanNew2/Ceiling-IDONOT-Height-01.svg")
                                .default
                        }
                        className="img-fluid tall_curtain_image"
                        alt=""
                      />
                    </div>

                    <div className="box100 Three_selection_container">
                      <div className="Three_select_container">
                        <div className="measure_input_container">
                          <h1 className="measure_input_label">{t("step3AIn_A")}</h1>
                          <div className="measure_input_field_container">
                            <DebounceInput
                              inputRef={(ref) => (inputs.current["ceilingToFloor1"] = ref)}
                              debounceTimeout={1500}
                              autoComplete="off"
                              onKeyDown={(e) => {
                                if (e.keyCode === 13) {
                                  inputs.current["ceilingToFloor2"].focus();
                                } else if (
                                  !/[0-9]/.test(NumberToPersianWord.convertPeToEn(e.key)) &&
                                  e.keyCode !== 8 &&
                                  e.keyCode !== 46 &&
                                  e.keyCode !== 37 &&
                                  e.keyCode !== 39 &&
                                  e.keyCode !== 13
                                ) {
                                  e.preventDefault();
                                }
                              }}
                              className={
                                "measure_input" +
                                (ceilingToFloor1 !== undefined &&
                                (ceilingToFloor1 < 1 || ceilingToFloor1 > 1000)
                                  ? " measure_input_err"
                                  : "")
                              }
                              type="text"
                              name="ceilingToFloor1"
                              value={NumToFa(`${ceilingToFloor1 || ""}`, pageLanguage)}
                              onChange={(e) => {
                                setTimeout(() => {
                                  let newValue = NumberToPersianWord.convertPeToEn(e.target.value);
                                  newValue = isNaN(newValue) ? "" : newValue;
                                  if (
                                    newValue &&
                                    newValue !== "" &&
                                    parseInt(newValue) >= 1 &&
                                    parseInt(newValue) <= 1000
                                  ) {
                                    setCartLoading(true);
                                    setCart("CeilingToFloor1", parseInt(newValue));
                                    setDeps("", "3EStandardCeilingFloor1");
                                    setCeilingToFloor1(parseInt(newValue));
                                    optionSelectChanged_three(
                                      parseInt(newValue),
                                      "3EStandardCeilingFloor",
                                      0,
                                      true,
                                      "heightDifferent",
                                      "cm",
                                      "س\u200Cم",
                                      pageLanguage,
                                      "3E"
                                    );
                                  } else {
                                    setCartLoading(true);
                                    setCart("", "", "CeilingToFloor1");
                                    setDeps("3EStandardCeilingFloor1", "");
                                    if (newValue === "" || isNaN(parseInt(newValue))) {
                                      setCeilingToFloor1(undefined);
                                      selectChanged(undefined, "3EStandardCeilingFloor");
                                    } else {
                                      setCeilingToFloor1(parseInt(newValue));
                                      selectChanged(
                                        "3EStandardCeilingFloor",
                                        undefined,
                                        t("Invalid Measurements")
                                      );
                                    }
                                  }
                                }, 300);
                              }}
                            />
                            <div className="measure_input_postfix">{t("cm_label")}</div>
                          </div>
                        </div>
                      </div>
                      <div className="Three_select_container">
                        <div className="measure_input_container">
                          <h1 className="measure_input_label">{t("step3AIn_B")}</h1>
                          <div className="measure_input_field_container">
                            <DebounceInput
                              inputRef={(ref) => (inputs.current["ceilingToFloor2"] = ref)}
                              debounceTimeout={1500}
                              autoComplete="off"
                              onKeyDown={(e) => {
                                if (e.keyCode === 13) {
                                  if (pageLanguage === "fa") {
                                    inputs.current["ceilingToFloor1"].focus();
                                  } else {
                                    inputs.current["ceilingToFloor3"].focus();
                                  }
                                } else if (
                                  !/[0-9]/.test(NumberToPersianWord.convertPeToEn(e.key)) &&
                                  e.keyCode !== 8 &&
                                  e.keyCode !== 46 &&
                                  e.keyCode !== 37 &&
                                  e.keyCode !== 39 &&
                                  e.keyCode !== 13
                                ) {
                                  e.preventDefault();
                                }
                              }}
                              className={
                                "measure_input" +
                                (ceilingToFloor2 !== undefined &&
                                (ceilingToFloor2 < 1 || ceilingToFloor2 > 1000)
                                  ? " measure_input_err"
                                  : "")
                              }
                              type="text"
                              name="ceilingToFloor2"
                              value={NumToFa(`${ceilingToFloor2 || ""}`, pageLanguage)}
                              onChange={(e) => {
                                setTimeout(() => {
                                  let newValue = NumberToPersianWord.convertPeToEn(e.target.value);
                                  newValue = isNaN(newValue) ? "" : newValue;
                                  if (
                                    newValue &&
                                    newValue !== "" &&
                                    parseInt(newValue) >= 1 &&
                                    parseInt(newValue) <= 1000
                                  ) {
                                    setCartLoading(true);
                                    setCart("CeilingToFloor2", parseInt(newValue));
                                    setDeps("", "3EStandardCeilingFloor2");
                                    setCeilingToFloor2(parseInt(newValue));
                                    optionSelectChanged_three(
                                      parseInt(newValue),
                                      "3EStandardCeilingFloor",
                                      1,
                                      true,
                                      "heightDifferent",
                                      "cm",
                                      "س\u200Cم",
                                      pageLanguage,
                                      "3E"
                                    );
                                  } else {
                                    setCartLoading(true);
                                    setCart("", "", "CeilingToFloor2");
                                    setDeps("3EStandardCeilingFloor2", "");
                                    if (newValue === "" || isNaN(parseInt(newValue))) {
                                      setCeilingToFloor2(undefined);
                                      selectChanged(undefined, "3EStandardCeilingFloor");
                                    } else {
                                      setCeilingToFloor2(parseInt(newValue));
                                      selectChanged(
                                        "3EStandardCeilingFloor",
                                        undefined,
                                        t("Invalid Measurements")
                                      );
                                    }
                                  }
                                }, 300);
                              }}
                            />
                            <div className="measure_input_postfix">{t("cm_label")}</div>
                          </div>
                        </div>
                      </div>
                      <div className="Three_select_container">
                        <div className="measure_input_container">
                          <h1 className="measure_input_label">{t("step3AIn_C")}</h1>
                          <div className="measure_input_field_container">
                            <DebounceInput
                              inputRef={(ref) => (inputs.current["ceilingToFloor3"] = ref)}
                              debounceTimeout={1500}
                              autoComplete="off"
                              onKeyDown={(e) => {
                                if (e.keyCode === 13) {
                                  inputs.current["ceilingToFloor2"].focus();
                                } else if (
                                  !/[0-9]/.test(NumberToPersianWord.convertPeToEn(e.key)) &&
                                  e.keyCode !== 8 &&
                                  e.keyCode !== 46 &&
                                  e.keyCode !== 37 &&
                                  e.keyCode !== 39 &&
                                  e.keyCode !== 13
                                ) {
                                  e.preventDefault();
                                }
                              }}
                              className={
                                "measure_input" +
                                (ceilingToFloor3 !== undefined &&
                                (ceilingToFloor3 < 1 || ceilingToFloor3 > 1000)
                                  ? " measure_input_err"
                                  : "")
                              }
                              type="text"
                              name="ceilingToFloor3"
                              value={NumToFa(`${ceilingToFloor3 || ""}`, pageLanguage)}
                              onChange={(e) => {
                                setTimeout(() => {
                                  let newValue = NumberToPersianWord.convertPeToEn(e.target.value);
                                  newValue = isNaN(newValue) ? "" : newValue;
                                  if (
                                    newValue &&
                                    newValue !== "" &&
                                    parseInt(newValue) >= 1 &&
                                    parseInt(newValue) <= 1000
                                  ) {
                                    setCartLoading(true);
                                    setCart("CeilingToFloor3", parseInt(newValue));
                                    setDeps("", "3EStandardCeilingFloor3");
                                    setCeilingToFloor3(parseInt(newValue));
                                    optionSelectChanged_three(
                                      parseInt(newValue),
                                      "3EStandardCeilingFloor",
                                      2,
                                      true,
                                      "heightDifferent",
                                      "cm",
                                      "س\u200Cم",
                                      pageLanguage,
                                      "3E"
                                    );
                                  } else {
                                    setCartLoading(true);
                                    setCart("", "", "CeilingToFloor3");
                                    setDeps("3EStandardCeilingFloor3", "");
                                    if (newValue === "" || isNaN(parseInt(newValue))) {
                                      setCeilingToFloor3(undefined);
                                      selectChanged(undefined, "3EStandardCeilingFloor");
                                    } else {
                                      setCeilingToFloor3(parseInt(newValue));
                                      selectChanged(
                                        "3EStandardCeilingFloor",
                                        undefined,
                                        t("Invalid Measurements")
                                      );
                                    }
                                  }
                                }, 300);
                              }}
                            />
                            <div className="measure_input_postfix">{t("cm_label")}</div>
                          </div>
                        </div>
                      </div>
                    </div>
                    <NextStep
                      currentStep={
                        [...depSet].findIndex((el) => el.startsWith("3")) === -1
                          ? "3"
                          : "3EStandardCeilingFloor"
                      }
                      eventKey="4"
                    >
                      {t("NEXT STEP")}
                    </NextStep>
                  </div>
                </Card.Body>
              </Accordion.Collapse>
            </Card>

            {/* step 5F */}
            <Card
              className={
                isShowStep5
                  ? "noDisplay"
                  : step3 === "true" &&
                    step31 === "false" &&
                    step3A !== "" &&
                    step3B !== "" &&
                    step3A0 !== "" &&
                    !(
                      (step3A0 === "Ceiling" || step3A0 === "Moulding") &&
                      (step3A === "Standard" ||
                        step3A === "Left Corner Window" ||
                        step3A === "Right Corner Window")
                    ) &&
                    !(
                      step3A === "Wall to Wall" &&
                      (step3A0 === "Ceiling" || step3A0 === "Moulding")
                    )
                  ? ""
                  : "noDisplay"
              }
            >
              <Card.Header
                className={
                  [...depSet].findIndex((el) => el.startsWith("3")) === -1 &&
                  !accordionActiveKey.startsWith("3")
                    ? "hidden"
                    : ""
                }
              >
                <ContextAwareToggle
                  eventKey="3F"
                  stepNum={step3A === "Wall to Wall" ? t("5E") : t("5F")}
                  stepTitle={t("dk_step2FWall")}
                  stepRef="3F"
                  type="2"
                  required={requiredStep["3F"]}
                  stepSelected={
                    stepSelectedLabel["3F"] === undefined ? "" : stepSelectedLabel["3F"]
                  }
                />
              </Card.Header>
              <Accordion.Collapse eventKey="3F">
                <Card.Body>
                  <div className="card_body">
                    <div className="box100">
                      <p className="step_selection_title">{t("dk_step2FWall_title_Pleated")}</p>
                      <img
                        src={
                          pageLanguage === "fa"
                            ? require("../Images/drapery/europeanNew2/WCE-IDONOT-Mount-Height-01.svg")
                                .default
                            : require("../Images/drapery/europeanNew2/WCE-IDONOT-Mount-Height-01.svg")
                                .default
                        }
                        className="img-fluid frame_with_top2 34"
                        alt=""
                      />
                    </div>
                    <div className="box100 Three_selection_container">
                      <div className="box100">
                        <div className="measure_input_container">
                          <h1 className="measure_input_label">{t("Height")}</h1>
                          <div className="measure_input_field_container">
                            <DebounceInput
                              debounceTimeout={1500}
                              autoComplete="off"
                              onKeyDown={(e) => {
                                if (
                                  !/[0-9]/.test(NumberToPersianWord.convertPeToEn(e.key)) &&
                                  e.keyCode !== 8 &&
                                  e.keyCode !== 46 &&
                                  e.keyCode !== 37 &&
                                  e.keyCode !== 39 &&
                                  e.keyCode !== 13
                                ) {
                                  e.preventDefault();
                                }
                              }}
                              className={
                                "measure_input" +
                                (mount !== undefined && mount < 10 ? " measure_input_err" : "")
                              }
                              type="text"
                              name="mount"
                              value={NumToFa(`${mount || ""}`, pageLanguage)}
                              onChange={(e) => {
                                setTimeout(() => {
                                  let newValue = NumberToPersianWord.convertPeToEn(e.target.value);
                                  newValue = isNaN(newValue) ? "" : newValue;
                                  if (newValue && newValue !== "" && parseInt(newValue) >= 10) {
                                    setCartLoading(true);
                                    setCart("ShadeMount", parseInt(newValue));
                                    setDeps("", "3F");
                                    setMount(parseInt(newValue));
                                    optionSelectChanged(
                                      "3F",
                                      parseInt(newValue),
                                      "cm",
                                      "س\u200Cم",
                                      pageLanguage
                                    );
                                  } else {
                                    setCartLoading(true);
                                    setCart("", "", "ShadeMount");
                                    setDeps("3F", "");
                                    if (newValue === "" || isNaN(parseInt(newValue))) {
                                      setMount(undefined);
                                      selectChanged(undefined, "3F");
                                    } else {
                                      setMount(parseInt(newValue));
                                      selectChanged("3F", undefined, t("Invalid Measurements"));
                                    }
                                  }
                                }, 300);
                              }}
                            />
                            <div className="measure_input_postfix">{t("cm_label")}</div>
                          </div>
                          <h2
                            className={`${
                              pageLanguage === "fa" ? "measure_input_desc_fa" : "measure_input_desc"
                            }${mount !== undefined && mount < 10 ? " measure_input_desc_err" : ""}`}
                          >
                            {t("Min: ")} {NumToFa(`10`, pageLanguage)} {t("cm_label")}
                          </h2>
                        </div>
                      </div>
                    </div>
                    <NextStep currentStep="3F" eventKey="3G">
                      {t("NEXT STEP")}
                    </NextStep>
                  </div>
                  <div className="accordion_help">
                    <div className="help_container">
                      <div className="help_column help_left_column">
                        <p className="help_column_header" />
                        <ul className="help_column_list">
                          <li className="no_listStyle single_line_height">
                            {t("grommet_step3E_help_1")}
                          </li>
                        </ul>
                      </div>
                    </div>
                  </div>
                </Card.Body>
              </Accordion.Collapse>
            </Card>

            {/* step 5G*/}
            <Card
              className={
                isShowStep5
                  ? "noDisplay"
                  : step3 === "true" &&
                    step31 === "false" &&
                    step3A !== "" &&
                    step3B !== "" &&
                    step3A0 !== "" &&
                    !(
                      (step3A0 === "Ceiling" || step3A0 === "Moulding") &&
                      (step3B === "Floor" || step3B === "Slight Puddle")
                    )
                  ? ""
                  : "noDisplay"
              }
            >
              <Card.Header
                className={
                  [...depSet].findIndex((el) => el.startsWith("3")) === -1 &&
                  !accordionActiveKey.startsWith("3")
                    ? "hidden"
                    : ""
                }
              >
                <ContextAwareToggle
                  eventKey="3G"
                  stepNum={RoomHeightTitle}
                  stepTitle={t("dk_step2FWall2")}
                  stepRef="3G"
                  type="2"
                  required={requiredStep["3G"]}
                  stepSelected={
                    stepSelectedLabel["3G"] === undefined ? "" : stepSelectedLabel["3G"]
                  }
                />
              </Card.Header>
              <Accordion.Collapse eventKey="3G">
                <Card.Body>
                  <div className="card_body">
                    <div className="box100">
                      <p className="step_selection_title">{t("dk_step2GWall_title")}</p>
                      <img
                        src={
                          pageLanguage === "fa"
                            ? require("../Images/drapery/europeanNew2/FWall-IDONOT-Room-Height -01.svg")
                                .default
                            : require("../Images/drapery/europeanNew2/Wall-IDONOT-Room-Height-01.svg")
                                .default
                        }
                        className="img-fluid tall_curtain_image 33"
                        alt=""
                      />
                    </div>
                    <div className="box100 Three_selection_container">
                      <div className="box100">
                        <div className="measure_input_container">
                          <div className="measure_input_field_container">
                            <DebounceInput
                              debounceTimeout={1500}
                              autoComplete="off"
                              onKeyDown={(e) => {
                                if (
                                  !/[0-9]/.test(NumberToPersianWord.convertPeToEn(e.key)) &&
                                  e.keyCode !== 8 &&
                                  e.keyCode !== 46 &&
                                  e.keyCode !== 37 &&
                                  e.keyCode !== 39 &&
                                  e.keyCode !== 13
                                ) {
                                  e.preventDefault();
                                }
                              }}
                              className={
                                "measure_input" +
                                (ceilingToFloor !== undefined &&
                                (ceilingToFloor < 1 ||
                                  ceilingToFloor > 1000 ||
                                  (heightCart && ceilingToFloor < +heightCart))
                                  ? " measure_input_err"
                                  : "")
                              }
                              type="text"
                              name="ceilingToFloor"
                              value={NumToFa(`${ceilingToFloor || ""}`, pageLanguage)}
                              onChange={(e) => {
                                setTimeout(() => {
                                  let newValue = NumberToPersianWord.convertPeToEn(e.target.value);
                                  newValue = isNaN(newValue) ? "" : newValue;
                                  if (
                                    newValue &&
                                    newValue !== "" &&
                                    parseInt(newValue) >= 1 &&
                                    parseInt(newValue) <= 1000 &&
                                    !(heightCart && parseInt(newValue) < +heightCart)
                                  ) {
                                    setCartLoading(true);
                                    setCart("CeilingToFloor", parseInt(newValue));
                                    setDeps("", "3G");
                                    setCeilingToFloor(parseInt(newValue));
                                    optionSelectChanged(
                                      "3G",
                                      parseInt(newValue),
                                      "cm",
                                      "س\u200Cم",
                                      pageLanguage
                                    );
                                  } else {
                                    setCartLoading(true);
                                    setCart("", "", "CeilingToFloor");
                                    setDeps("3G", "");
                                    if (newValue === "" || isNaN(parseInt(newValue))) {
                                      setCeilingToFloor(undefined);
                                      selectChanged(undefined, "3G");
                                    } else {
                                      setCeilingToFloor(parseInt(newValue));
                                      selectChanged("3G", undefined, t("Invalid Measurements"));
                                    }
                                  }
                                }, 300);
                              }}
                            />
                            <div className="measure_input_postfix">{t("cm_label")}</div>
                          </div>
                          <h2
                            className={
                              "measure_input_desc" +
                              (ceilingToFloor !== undefined &&
                              (ceilingToFloor < 1 ||
                                ceilingToFloor > 1000 ||
                                (heightCart && ceilingToFloor < +heightCart))
                                ? " measure_input_desc_err"
                                : "")
                            }
                          >
                            {heightCart && ceilingToFloor < +heightCart
                              ? t("roomHeight_more_than_height")
                              : ""}
                          </h2>
                        </div>
                      </div>
                    </div>
                    <NextStep
                      currentStep={
                        [...depSet].findIndex((el) => el.startsWith("3")) === -1 ? "3" : "3G"
                      }
                      eventKey="4"
                    >
                      {t("NEXT STEP")}
                    </NextStep>
                  </div>
                </Card.Body>
              </Accordion.Collapse>
            </Card>
            {/* end step No, I don't have hardware */}

            {/* start step Yes, I have a rod */}

            {/* step 5ARod */}

            <Card className={step3 === "true" && step31 === "true" ? "" : "noDisplay"}>
              <Card.Header
                className={
                  [...depSet].findIndex((el) => el.startsWith("3")) === -1 &&
                  !accordionActiveKey.startsWith("3")
                    ? "hidden"
                    : ""
                }
              >
                <ContextAwareToggle
                  eventKey="3A"
                  stepNum={t(nameStep)}
                  stepTitle={t("dk_step2A")}
                  stepRef="3ARodDrapery"
                  type="1"
                  required={requiredStep["3ARod"]}
                  stepSelected={
                    stepSelectedLabel["3ARod"] === undefined ? "" : stepSelectedLabel["3ARod"]
                  }
                />
              </Card.Header>
              <Accordion.Collapse eventKey="3A">
                <Card.Body>
                  <div className="card_body card_body_radio card_body_finished_length card_body_finished_length_grommet">
                    <div className="box100">
                      <p className="step_selection_title">{t("dk_step2A_title")}</p>
                    </div>
                    <div className="box25 radio_style 5">
                      <img
                        src={require("../Images/drapery/european/finished-rod-sill.svg").default}
                        className="img-fluid height_auto"
                        alt=""
                      />
                      <input
                        className="radio"
                        type="radio"
                        text={t("Sill")}
                        value="1"
                        name="step3ARod"
                        ref-num="3ARod"
                        id="3ARod1"
                        checked={step3ARod === "Sill"}
                        onChange={(e) => {
                          setStep3ARod("Sill");
                          clearInputs(e);
                          setCart(
                            "FinishedLengthType",
                            "Sill",
                            "RodToFloor,Width3C,ExtensionLeft,ExtensionRight,Height3E,WindowToFloor,ShadeMount,CeilingToFloor,CeilingToWindow1,CeilingToWindow2,CeilingToWindow3,CeilingToFloor1,CeilingToFloor2,CeilingToFloor3"
                          );
                          setDeps(
                            "3BRodHaveRod,3DRod,3CRodIHave",
                            "3ARod,3ARod1,3CRodFloor,3B,3C,3D1,3D2,3E,3F,3G,3EStandardCeiling1,3EStandardCeiling2,3EStandardCeiling3,3EStandardCeilingFloor1,3EStandardCeilingFloor2,3EStandardCeilingFloor3,3BRod,3CRod,3CRodFloorHaveRod"
                          );
                        }}
                        ref={(ref) => (inputs.current["3ARod1"] = ref)}
                      />
                      <label htmlFor="3ARod1">{t("Sill")}</label>
                    </div>
                    <div className="box25 radio_style 6">
                      <img
                        src={require("../Images/drapery/european/finished-rod-apron.svg").default}
                        className="img-fluid height_auto"
                        alt=""
                      />
                      <input
                        className="radio"
                        type="radio"
                        text={t("Apron")}
                        value="2"
                        name="step3ARod"
                        ref-num="3ARod"
                        id="3ARod2"
                        checked={step3ARod === "Apron"}
                        onChange={(e) => {
                          setStep3ARod("Apron");
                          clearInputs(e);
                          setCart(
                            "FinishedLengthType",
                            "Apron",
                            "RodToFloor,Width3C,ExtensionLeft,ExtensionRight,Height3E,WindowToFloor,ShadeMount,CeilingToFloor,CeilingToWindow1,CeilingToWindow2,CeilingToWindow3,CeilingToFloor1,CeilingToFloor2,CeilingToFloor3"
                          );
                          setDeps(
                            "3BRodHaveRod,3CRodIHave,3DRod",
                            "3ARod,3ARod1,3CRodFloor,3B,3C,3D1,3D2,3E,3F,3G,3EStandardCeiling1,3EStandardCeiling2,3EStandardCeiling3,3EStandardCeilingFloor1,3EStandardCeilingFloor2,3EStandardCeilingFloor3,3BRod,3CRod,3CRodFloorHaveRod"
                          );
                        }}
                        ref={(ref) => (inputs.current["3ARod2"] = ref)}
                      />
                      <label htmlFor="3ARod2">{t("Apron")}</label>
                    </div>
                    <div className="box25 radio_style 7">
                      <img
                        src={require("../Images/drapery/european/finished-rod-floor.svg").default}
                        className="img-fluid height_auto"
                        alt=""
                      />
                      <input
                        className="radio"
                        type="radio"
                        text={t("Floor")}
                        value="3"
                        name="step3ARod"
                        ref-num="3ARod"
                        id="3ARod3"
                        checked={step3ARod === "Floor"}
                        onChange={(e) => {
                          setStep3ARod("Floor");
                          clearInputs(e);
                          setCart(
                            "FinishedLengthType",
                            "Floor",
                            "RodToBottom,Width3C,ExtensionLeft,ExtensionRight,Height3E,WindowToFloor,ShadeMount,CeilingToFloor,CeilingToWindow1,CeilingToWindow2,CeilingToWindow3,CeilingToFloor1,CeilingToFloor2,CeilingToFloor3"
                          );
                          setDeps(
                            "3BRodHaveRod,3CRodFloorHaveRod,3DRod",
                            "3ARod,3ARod1,3CRod,3B,3C,3D1,3D2,3E,3F,3G,3EStandardCeiling1,3EStandardCeiling2,3EStandardCeiling3,3EStandardCeilingFloor1,3EStandardCeilingFloor2,3EStandardCeilingFloor3,3BRod,3CRodFloor,3CRodIHave"
                          );
                        }}
                        ref={(ref) => (inputs.current["3ARod3"] = ref)}
                      />
                      <label htmlFor="3ARod3">{t("Floor")}</label>
                    </div>
                    <div className="box25 radio_style 8">
                      <img
                        src={require("../Images/drapery/european/finished-rod-puddle.svg").default}
                        className="img-fluid height_auto"
                        alt=""
                      />
                      <input
                        className="radio"
                        type="radio"
                        text={t("Slight Puddle")}
                        value="4"
                        name="step3ARod"
                        ref-num="3ARod"
                        id="3ARod4"
                        checked={step3ARod === "Slight Puddle"}
                        onChange={(e) => {
                          setStep3ARod("Slight Puddle");
                          clearInputs(e);
                          setCart(
                            "FinishedLengthType",
                            "Slight Puddle",
                            "RodToBottom,Width3C,ExtensionLeft,ExtensionRight,Height3E,WindowToFloor,ShadeMount,CeilingToFloor,CeilingToWindow1,CeilingToWindow2,CeilingToWindow3,CeilingToFloor1,CeilingToFloor2,CeilingToFloor3"
                          );
                          setDeps(
                            "3BRodHaveRod,3CRodFloorHaveRod,3DRod",
                            "3ARod,3ARod1,3CRod,3B,3C,3D1,3D2,3E,3F,3G,3EStandardCeiling1,3EStandardCeiling2,3EStandardCeiling3,3EStandardCeilingFloor1,3EStandardCeilingFloor2,3EStandardCeilingFloor3,3BRod,3CRodFloor,3CRodIHave"
                          );
                        }}
                        ref={(ref) => (inputs.current["3ARod4"] = ref)}
                      />
                      <label htmlFor="3ARod4">{t("Slight Puddle")}</label>
                    </div>

                    <div
                      className={
                        step3ARod === "Apron"
                          ? step3ARodErr1
                            ? "secondary_options secondary_options_err secondary_options_text"
                            : "secondary_options secondary_options_text"
                          : "noDisplay"
                      }
                    >
                      <div className="card-body-display-flex">
                        <div className="checkbox_style checkbox_style_step2">
                          <span className="checkbox_text box100">
                            {t("grommet_apron_checkbox_title")}
                          </span>
                        </div>
                      </div>
                    </div>

                    <div
                      className={
                        step3ARod === "Slight Puddle"
                          ? "secondary_options secondary_options_text"
                          : "noDisplay"
                      }
                    >
                      <div className="card-body-display-flex">
                        <div className="checkbox_style checkbox_style_step2">
                          <span className="checkbox_text box100">{t("puddle_text")}</span>
                        </div>
                      </div>
                    </div>
                    {step3ARodErr1 && (
                      <div className="input_not_valid">{t("grommet_step3AErr1")}</div>
                    )}
                    <NextStep currentStep="3ARodDrapery" eventKey="3B" clickBtn={step3ARod}>
                      {t("NEXT STEP")}
                    </NextStep>
                  </div>

                  <div className="accordion_help">
                    <div className="help_container">
                      <div className="help_column help_left_column">
                        <p className="help_column_header"></p>
                        <ul className="help_column_list">
                          <li className="no_listStyle">
                            <b>{t("dk_step2a_help1")}</b>
                            {t("dk_step2a_help2")}
                          </li>
                          <li className="no_listStyle">
                            <b>{t("grommet_step3a_help2")}</b>
                            {t("grommet_step3a_help3")}
                          </li>
                          <li className="no_listStyle">
                            <b>{t("grommet_step3a_help4")}</b>
                            {t("grommet_step3a_help5")}
                          </li>
                          <li className="no_listStyle">
                            <b>{t("grommet_step3a_help6")}</b>
                            {t("grommet_step3a_help7")}
                          </li>
                        </ul>
                      </div>
                    </div>
                  </div>
                </Card.Body>
              </Accordion.Collapse>
            </Card>

            {/* step 5BRod*/}
            <Card
              className={
                step3 === "true" &&
                step31 === "true" &&
                ((step3ARod !== "" && step3ARod !== "Apron") ||
                  (step3ARod === "Apron" && step3ARod1 === "true"))
                  ? ""
                  : "noDisplay"
              }
            >
              <Card.Header
                className={
                  [...depSet].findIndex((el) => el.startsWith("3")) === -1 &&
                  !accordionActiveKey.startsWith("3")
                    ? "hidden"
                    : ""
                }
              >
                <ContextAwareToggle
                  eventKey="3B"
                  stepNum={t("5B")}
                  stepTitle={t("grommet_step3BRod")}
                  stepRef="3BRodHaveRod"
                  type="2"
                  required={requiredStep["3BRodHaveRod"]}
                  stepSelected={
                    stepSelectedLabel["3BRodHaveRod"] === undefined
                      ? ""
                      : stepSelectedLabel["3BRodHaveRod"]
                  }
                />
              </Card.Header>
              <Accordion.Collapse eventKey="3B">
                <Card.Body>
                  <div className="card_body">
                    <div className="box100">
                      <p className="step_selection_title">{t("grommet_step3BRod_title")}</p>
                      <img
                        src={
                          step3A0 === "Moulding"
                            ? require("../Images/drapery/europeanNew2/MouldingRodWidth01.svg")
                                .default
                            : require("../Images/drapery/europeanNew2/rodlength.svg").default
                        }
                        className="img-fluid frame_with_top"
                        alt=""
                      />
                    </div>
                    <div className="box100 Three_selection_container">
                      <div className="box100">
                        <div className="measure_input_container">
                          <h1 className="measure_input_label">{t("Width-1")}</h1>
                          <div className="measure_input_field_container">
                            <DebounceInput
                              debounceTimeout={1500}
                              autoComplete="off"
                              onKeyDown={(e) => {
                                if (
                                  !/[0-9]/.test(NumberToPersianWord.convertPeToEn(e.key)) &&
                                  e.keyCode !== 8 &&
                                  e.keyCode !== 46 &&
                                  e.keyCode !== 37 &&
                                  e.keyCode !== 39 &&
                                  e.keyCode !== 13
                                ) {
                                  e.preventDefault();
                                }
                              }}
                              className={
                                "measure_input" +
                                (rodWidth !== undefined && (rodWidth < 1 || rodWidth > 1000)
                                  ? " measure_input_err"
                                  : "")
                              }
                              type="text"
                              name="rodWidth"
                              value={NumToFa(`${rodWidth || ""}`, pageLanguage)}
                              onChange={(e) => {
                                setTimeout(() => {
                                  let newValue = NumberToPersianWord.convertPeToEn(e.target.value);
                                  newValue = isNaN(newValue) ? "" : newValue;
                                  if (
                                    newValue &&
                                    newValue !== "" &&
                                    parseInt(newValue) >= 1 &&
                                    parseInt(newValue) <= 1000
                                  ) {
                                    setCartLoading(true);
                                    setCart("RodWidth", parseInt(newValue));
                                    setDeps("", "3BRodHaveRod");
                                    setRodWidth(parseInt(newValue));
                                    optionSelectChanged(
                                      "3BRodHaveRod",
                                      parseInt(newValue),
                                      "cm",
                                      "س\u200Cم",
                                      pageLanguage
                                    );
                                  } else {
                                    setCartLoading(true);
                                    setCart("", "", "RodWidth");
                                    setDeps("3BRodHaveRod", "");
                                    if (newValue === "" || isNaN(parseInt(newValue))) {
                                      setRodWidth(undefined);
                                      selectChanged(undefined, "3BRodHaveRod");
                                    } else {
                                      setRodWidth(parseInt(newValue));
                                      selectChanged(
                                        "3BRodHaveRod",
                                        undefined,
                                        t("Invalid Measurements")
                                      );
                                    }
                                  }
                                }, 300);
                              }}
                            />
                            <div className="measure_input_postfix">{t("cm_label")}</div>
                          </div>
                        </div>
                      </div>
                    </div>
                    <NextStep currentStep="3BRodHaveRod" eventKey="3C">
                      {t("NEXT STEP")}
                    </NextStep>
                  </div>
                </Card.Body>
              </Accordion.Collapse>
            </Card>

            {/* step 5CRod*/}
            <Card
              className={
                step3 === "true" &&
                step31 === "true" &&
                (step3ARod === "Sill" || (step3ARod === "Apron" && step3ARod1 === "true"))
                  ? ""
                  : "noDisplay"
              }
            >
              <Card.Header
                className={
                  [...depSet].findIndex((el) => el.startsWith("3")) === -1 &&
                  !accordionActiveKey.startsWith("3")
                    ? "hidden"
                    : ""
                }
              >
                <ContextAwareToggle
                  eventKey="3C"
                  stepNum={t("5C")}
                  stepTitle={t("grommet_step3DRod")}
                  stepRef="3CRodDrapery"
                  type="2"
                  required={requiredStep["3CRod"]}
                  stepSelected={
                    stepSelectedLabel["3CRod"] === undefined ? "" : stepSelectedLabel["3CRod"]
                  }
                />
              </Card.Header>
              <Accordion.Collapse eventKey="3C">
                <Card.Body>
                  <div className="card_body">
                    <div className="box100">
                      <p className="step_selection_title">{t("grommet_step3DRod_title")}</p>
                      <img
                        src={
                          pageLanguage === "fa"
                            ? step3A0 === "Moulding"
                              ? require("../Images/drapery/europeanNew2/FMouldingRod-Sill01.svg")
                                  .default
                              : require("../Images/drapery/europeanNew2/Frodsillheight.svg").default
                            : step3A0 === "Moulding"
                            ? require("../Images/drapery/europeanNew2/MouldingRod-Sill01.svg")
                                .default
                            : require("../Images/drapery/europeanNew2/rodsillheight.svg").default
                        }
                        className="img-fluid just_frame 2"
                        alt=""
                      />
                    </div>
                    <div className="box100 Three_selection_container">
                      <div className="box100">
                        <div className="measure_input_container">
                          <h1 className="measure_input_label">{t("Height")}</h1>
                          <div className="measure_input_field_container">
                            <DebounceInput
                              debounceTimeout={1500}
                              autoComplete="off"
                              onKeyDown={(e) => {
                                if (
                                  !/[0-9]/.test(NumberToPersianWord.convertPeToEn(e.key)) &&
                                  e.keyCode !== 8 &&
                                  e.keyCode !== 46 &&
                                  e.keyCode !== 37 &&
                                  e.keyCode !== 39 &&
                                  e.keyCode !== 13
                                ) {
                                  e.preventDefault();
                                }
                              }}
                              className={
                                "measure_input" +
                                (rodToBottom !== undefined &&
                                (rodToBottom < 1 || rodToBottom > 1000)
                                  ? " measure_input_err"
                                  : "")
                              }
                              type="text"
                              name="rodToBottom1"
                              value={NumToFa(`${rodToBottom || ""}`, pageLanguage)}
                              onChange={(e) => {
                                setTimeout(() => {
                                  let newValue = NumberToPersianWord.convertPeToEn(e.target.value);
                                  newValue = isNaN(newValue) ? "" : newValue;
                                  if (
                                    newValue &&
                                    newValue !== "" &&
                                    parseInt(newValue) >= 1 &&
                                    parseInt(newValue) <= 1000
                                  ) {
                                    setCartLoading(true);
                                    setCart("RodToBottom", parseInt(newValue));
                                    setDeps("", "3CRod");
                                    setRodToBottom(parseInt(newValue));
                                    optionSelectChanged(
                                      "3CRod",
                                      parseInt(newValue),
                                      "cm",
                                      "س\u200Cم",
                                      pageLanguage
                                    );
                                  } else {
                                    setCartLoading(true);
                                    setCart("", "", "RodToBottom");
                                    setDeps("3CRod", "");
                                    if (newValue === "" || isNaN(parseInt(newValue))) {
                                      setRodToBottom(undefined);
                                      selectChanged(undefined, "3CRod");
                                    } else {
                                      setRodToBottom(parseInt(newValue));
                                      selectChanged("3CRod", undefined, t("Invalid Measurements"));
                                    }
                                  }
                                }, 300);
                              }}
                            />
                            <div className="measure_input_postfix">{t("cm_label")}</div>
                          </div>
                        </div>
                      </div>
                    </div>
                    <NextStep currentStep="3CRodDrapery" eventKey="3D">
                      {t("NEXT STEP")}
                    </NextStep>
                  </div>
                </Card.Body>
              </Accordion.Collapse>
            </Card>

            {/* step 5CRodFloor*/}
            <Card
              className={
                step3 === "true" &&
                step31 === "true" &&
                (step3ARod === "Floor" || step3ARod === "Slight Puddle")
                  ? ""
                  : "noDisplay"
              }
            >
              <Card.Header
                className={
                  [...depSet].findIndex((el) => el.startsWith("3")) === -1 &&
                  !accordionActiveKey.startsWith("3")
                    ? "hidden"
                    : ""
                }
              >
                <ContextAwareToggle
                  eventKey="3C"
                  stepNum={t("5C")}
                  stepTitle={t("grommet_step3DRodFloor")}
                  stepRef="3CRodFloorHaveRod"
                  type="2"
                  required={requiredStep["3CRodFloorHaveRod"]}
                  stepSelected={
                    stepSelectedLabel["3CRodFloorHaveRod"] === undefined
                      ? ""
                      : stepSelectedLabel["3CRodFloorHaveRod"]
                  }
                />
              </Card.Header>
              <Accordion.Collapse eventKey="3C">
                <Card.Body>
                  <div className="card_body">
                    <div className="box100">
                      <p className="step_selection_title">{t("grommet_step3DRodFloor_title")}</p>
                      <img
                        src={
                          pageLanguage === "fa"
                            ? step3A0 === "Moulding"
                              ? require("../Images/drapery/europeanNew2/FMouldingRod-Floor01.svg")
                                  .default
                              : require("../Images/drapery/europeanNew2/Frodfloorheight.svg")
                                  .default
                            : step3A0 === "Moulding"
                            ? require("../Images/drapery/europeanNew2/MouldingRod-Floor01.svg")
                                .default
                            : require("../Images/drapery/europeanNew2/rodfloorheight.svg").default
                        }
                        className="img-fluid just_frame 3"
                        alt=""
                      />
                    </div>
                    <div className="box100 Three_selection_container">
                      <div className="box100">
                        <div className="measure_input_container">
                          <h1 className="measure_input_label">{t("Height")}</h1>
                          <div className="measure_input_field_container">
                            <DebounceInput
                              debounceTimeout={1500}
                              autoComplete="off"
                              onKeyDown={(e) => {
                                if (
                                  !/[0-9]/.test(NumberToPersianWord.convertPeToEn(e.key)) &&
                                  e.keyCode !== 8 &&
                                  e.keyCode !== 46 &&
                                  e.keyCode !== 37 &&
                                  e.keyCode !== 39 &&
                                  e.keyCode !== 13
                                ) {
                                  e.preventDefault();
                                }
                              }}
                              className={
                                "measure_input" +
                                (rodToFloor !== undefined && (rodToFloor < 1 || rodToFloor > 1000)
                                  ? " measure_input_err"
                                  : "")
                              }
                              type="text"
                              name="rodToFloor1"
                              value={NumToFa(`${rodToFloor || ""}`, pageLanguage)}
                              onChange={(e) => {
                                setTimeout(() => {
                                  let newValue = NumberToPersianWord.convertPeToEn(e.target.value);
                                  newValue = isNaN(newValue) ? "" : newValue;
                                  if (
                                    newValue &&
                                    newValue !== "" &&
                                    parseInt(newValue) >= 1 &&
                                    parseInt(newValue) <= 1000
                                  ) {
                                    setCartLoading(true);
                                    setCart("RodToFloor", parseInt(newValue));
                                    setDeps("", "3CRodFloorHaveRod");
                                    setRodToFloor(parseInt(newValue));
                                    optionSelectChanged(
                                      "3CRodFloorHaveRod",
                                      parseInt(newValue),
                                      "cm",
                                      "س\u200Cم",
                                      pageLanguage
                                    );
                                  } else {
                                    setCartLoading(true);
                                    setCart("", "", "RodToFloor");
                                    setDeps("3CRodFloorHaveRod", "");
                                    if (newValue === "" || isNaN(parseInt(newValue))) {
                                      setRodToFloor(undefined);
                                      selectChanged(undefined, "3CRodFloorHaveRod");
                                    } else {
                                      setRodToFloor(parseInt(newValue));
                                      selectChanged(
                                        "3CRodFloorHaveRod",
                                        undefined,
                                        t("Invalid Measurements")
                                      );
                                    }
                                  }
                                }, 300);
                              }}
                            />
                            <div className="measure_input_postfix">{t("cm_label")}</div>
                          </div>
                        </div>
                      </div>
                    </div>
                    <NextStep currentStep="3CRodFloorHaveRod" eventKey="3D">
                      {t("NEXT STEP")}
                    </NextStep>
                  </div>
                </Card.Body>
              </Accordion.Collapse>
            </Card>

            {/* step 5DRod */}
            <Card
              className={
                step3 === "true" &&
                step31 === "true" &&
                ((step3ARod !== "" && step3ARod !== "Apron") ||
                  (step3ARod === "Apron" && step3ARod1 === "true"))
                  ? ""
                  : "noDisplay"
              }
            >
              <Card.Header
                className={
                  [...depSet].findIndex((el) => el.startsWith("3")) === -1 &&
                  !accordionActiveKey.startsWith("3")
                    ? "hidden"
                    : ""
                }
              >
                <ContextAwareToggle
                  eventKey="3D"
                  stepNum={t("5D")}
                  stepTitle={t("dk_step2FWall2")}
                  stepRef="3DRodDrapery"
                  type="2"
                  required={requiredStep["3DRod"]}
                  stepSelected={
                    stepSelectedLabel["3DRod"] === undefined ? "" : stepSelectedLabel["3DRod"]
                  }
                />
              </Card.Header>
              <Accordion.Collapse eventKey="3D">
                <Card.Body>
                  <div className="card_body">
                    <div className="box100">
                      <p className="step_selection_title">{t("dk_step2GWall_title")}</p>
                      <img
                        src={
                          pageLanguage === "fa"
                            ? step3A0 === "Moulding"
                              ? require("../Images/drapery/europeanNew2/FMouldingRod-Home01.svg")
                                  .default
                              : require("../Images/drapery/europeanNew2/Frodroomheight.svg").default
                            : step3A0 === "Moulding"
                            ? require("../Images/drapery/europeanNew2/MouldingRod-Home01.svg")
                                .default
                            : require("../Images/drapery/europeanNew2/rodroomheight.svg").default
                        }
                        className="img-fluid frame_with_top2 22"
                        alt="test"
                      />
                    </div>
                    <div className="box100 Three_selection_container">
                      <div className="box100">
                        <div className="measure_input_container">
                          <div className="measure_input_field_container">
                            <DebounceInput
                              debounceTimeout={1500}
                              autoComplete="off"
                              onKeyDown={(e) => {
                                if (
                                  !/[0-9]/.test(NumberToPersianWord.convertPeToEn(e.key)) &&
                                  e.keyCode !== 8 &&
                                  e.keyCode !== 46 &&
                                  e.keyCode !== 37 &&
                                  e.keyCode !== 39 &&
                                  e.keyCode !== 13
                                ) {
                                  e.preventDefault();
                                }
                              }}
                              className={
                                "measure_input" +
                                (ceilingToFloor !== undefined &&
                                (ceilingToFloor < 1 ||
                                  ceilingToFloor > 1000 ||
                                  (heightCart && ceilingToFloor < +heightCart))
                                  ? " measure_input_err"
                                  : "")
                              }
                              type="text"
                              name="ceilingToFloor"
                              value={NumToFa(`${ceilingToFloor || ""}`, pageLanguage)}
                              onChange={(e) => {
                                setTimeout(() => {
                                  let newValue = NumberToPersianWord.convertPeToEn(e.target.value);
                                  newValue = isNaN(newValue) ? "" : newValue;
                                  if (
                                    newValue &&
                                    newValue !== "" &&
                                    parseInt(newValue) >= 1 &&
                                    parseInt(newValue) <= 1000 &&
                                    !(heightCart && parseInt(newValue) < +heightCart)
                                  ) {
                                    setCartLoading(true);
                                    setCart("CeilingToFloor", parseInt(newValue));
                                    setDeps("", "3DRod");
                                    setCeilingToFloor(parseInt(newValue));
                                    optionSelectChanged(
                                      "3DRod",
                                      parseInt(newValue),
                                      "cm",
                                      "س\u200Cم",
                                      pageLanguage
                                    );
                                  } else {
                                    setCartLoading(true);
                                    setCart("", "", "CeilingToFloor");
                                    setDeps("3DRod", "");
                                    if (newValue === "" || isNaN(parseInt(newValue))) {
                                      setCeilingToFloor(undefined);
                                      selectChanged(undefined, "3DRod");
                                    } else {
                                      setCeilingToFloor(parseInt(newValue));
                                      selectChanged("3DRod", undefined, t("Invalid Measurements"));
                                    }
                                  }
                                }, 300);
                              }}
                            />
                            <div className="measure_input_postfix">{t("cm_label")}</div>
                          </div>
                          <h2
                            className={
                              "measure_input_desc" +
                              (ceilingToFloor !== undefined &&
                              (ceilingToFloor < 1 ||
                                ceilingToFloor > 1000 ||
                                (heightCart && ceilingToFloor < +heightCart))
                                ? " measure_input_desc_err"
                                : "")
                            }
                          >
                            {heightCart && ceilingToFloor < +heightCart
                              ? t("roomHeight_more_than_height")
                              : ""}
                          </h2>
                        </div>
                      </div>
                    </div>
                    <NextStep
                      currentStep={
                        [...depSet].findIndex((el) => el.startsWith("3")) === -1
                          ? "3"
                          : "3DRodDrapery"
                      }
                      eventKey="4"
                    >
                      {t("NEXT STEP")}
                    </NextStep>
                  </div>
                </Card.Body>
              </Accordion.Collapse>
            </Card>

            {/* end step Yes, I have a rod */}
            {/* start step Yes, I have a Track */}

            {/* step 5ATrack */}
            <Step5ATrackPleated
              t={t}
              step3={step3}
              step31={step31}
              depSet={depSet}
              accordionActiveKey={accordionActiveKey}
              requiredStep={requiredStep}
              stepSelectedLabel={stepSelectedLabel}
              pageLanguage={pageLanguage}
              clearInputs={clearInputs}
              setCart={setCart}
              setDeps={setDeps}
              step3ARodErr1={step3ARodErr1}
              ContextAwareToggle={ContextAwareToggle}
              nameStep={nameStep}
              step3ATrack={step3ATrack}
              setStep3ATrack={setStep3ATrack}
              inputs={inputs}
              step3ARod1={step3ARod1}
              setStep3ARod1={setStep3ARod1}
              NextStep={NextStep}
              modals={modals}
              modalHandleClose={modalHandleClose}
              setStep3B={setStep3B}
              finishedLengthTemp={finishedLengthTemp}
              step3A0={step3A0}
              step3A={step3A}
              modalHandleShow={modalHandleShow}
              rodWidth={rodWidth}
            />

            {/* step 5BTrack*/}
            <Step5BTrackPleated
              ContextAwareToggle={ContextAwareToggle}
              requiredStep={requiredStep}
              stepSelectedLabel={stepSelectedLabel}
              setDeps={setDeps}
              setCart={setCart}
              t={t}
              step3={step3}
              step31={step31}
              step3ARod={step3ARod}
              step3ARod1={step3ARod1}
              depSet={depSet}
              accordionActiveKey={accordionActiveKey}
              step3A0={step3A0}
              rodWidth={rodWidth}
              setRodWidth={setRodWidth}
              setCartLoading={setCartLoading}
              optionSelectChanged={optionSelectChanged}
              selectChanged={selectChanged}
              pageLanguage={pageLanguage}
              NextStep={NextStep}
              step3ATrack={step3ATrack}
            />
            {/* step 5CTrack*/}
            <Step5CTrackPleated
              ContextAwareToggle={ContextAwareToggle}
              requiredStep={requiredStep}
              stepSelectedLabel={stepSelectedLabel}
              setDeps={setDeps}
              setCart={setCart}
              t={t}
              step3={step3}
              step31={step31}
              step3ATrack={step3ATrack}
              step3ARod1={step3ARod1}
              depSet={depSet}
              accordionActiveKey={accordionActiveKey}
              step3A0={step3A0}
              rodToBottom={rodToBottom}
              setRodToBottom={setRodToBottom}
              setCartLoading={setCartLoading}
              optionSelectChanged={optionSelectChanged}
              selectChanged={selectChanged}
              pageLanguage={pageLanguage}
              NextStep={NextStep}
            />

            {/* step 5CTrackFloor*/}
            <Step5CTrackFloorPleated
              step3={step3}
              step31={step31}
              step3ATrack={step3ATrack}
              depSet={depSet}
              accordionActiveKey={accordionActiveKey}
              t={t}
              stepSelectedLabel={stepSelectedLabel}
              requiredStep={requiredStep}
              setCart={setCart}
              setCartLoading={setCartLoading}
              setDeps={setDeps}
              optionSelectChanged={optionSelectChanged}
              selectChanged={selectChanged}
              pageLanguage={pageLanguage}
              rodToFloor={rodToFloor}
              setRodToFloor={setRodToFloor}
              step3A0={step3A0}
              NextStep={NextStep}
              ContextAwareToggle={ContextAwareToggle}
            />

            {/* step 5DTrack */}
            <Step5DTrackPleated
              step3={step3}
              step31={step31}
              step3ATrack={step3ATrack}
              step3ARod1={step3ARod1}
              depSet={depSet}
              accordionActiveKey={accordionActiveKey}
              t={t}
              stepSelectedLabel={stepSelectedLabel}
              requiredStep={requiredStep}
              setCart={setCart}
              setCartLoading={setCartLoading}
              setDeps={setDeps}
              optionSelectChanged={optionSelectChanged}
              selectChanged={selectChanged}
              pageLanguage={pageLanguage}
              NextStep={NextStep}
              ContextAwareToggle={ContextAwareToggle}
              step3A0={step3A0}
              rodToFloor={rodToFloor}
              ceilingToFloor={ceilingToFloor}
              setCeilingToFloor={setCeilingToFloor}
              heightCart={heightCart}
            />

            {/* step 6 */}
            <Step6Pleated
              ContextAwareToggle={ContextAwareToggle}
              requiredStep={requiredStep}
              stepSelectedLabel={stepSelectedLabel}
              setDeps={setDeps}
              setCart={setCart}
              t={t}
              isTabletOrMobile={isTabletOrMobile}
              step4={step4}
              setStep4={setStep4}
              selectChanged={selectChanged}
              inputs={inputs}
              liningPrice={liningPrice}
              popoverImages={popoverImages}
              popoverThumbnailHover={popoverThumbnailHover}
              NextStep={NextStep}
              GetPrice={GetPrice}
              PopoverStickOnHover={PopoverStickOnHover}
              pageLanguage={pageLanguage}
              step5={step5}
            />

            {/* step 7 */}
            {(step5 !== "Full" || step3 === "true") && (
              <Step7Pleated
                ContextAwareToggle={ContextAwareToggle}
                requiredStep={requiredStep}
                stepSelectedLabel={stepSelectedLabel}
                setDeps={setDeps}
                setCart={setCart}
                t={t}
                step5={step5}
                setStep5={setStep5}
                selectChanged={selectChanged}
                inputs={inputs}
                NextStep={NextStep}
                pageLanguage={pageLanguage}
                step2B={step2B}
              />
            )}

            {/* step 8 */}
            <Step8PleatedComponent
              windowWidthPanelType={windowWidthPanelType}
              ContextAwareToggle={ContextAwareToggle}
              t={t}
              requiredStep={requiredStep}
              stepSelectedLabel={stepSelectedLabel}
              step6={step6}
              widthCart={widthCart}
              step5={step5}
              step3A0={step3A0}
              step6A={step6A}
              setStep6A={setStep6A}
              setStep6={setStep6}
              selectChanged={selectChanged}
              setExtendedTitle={setExtendedTitle}
              extendedTitle={extendedTitle}
              setDeps={setDeps}
              setCart={setCart}
              setStep5={setStep5}
              inputs={inputs}
              pageLanguage={pageLanguage}
              NextStep={NextStep}
              modalHandleShow={modalHandleShow}
              setPanelSheerWarningTemp={setPanelSheerWarningTemp}
              setStep6BHead={setStep6BHead}
              step8B={step8B}
              setStep8={setStep8}
              setHardwareNextStep={setHardwareNextStep}
              step6BHead={step6BHead}
              tracksList={tracksList}
              step2A={step2A}
              step8={step8}
              setStep6B={setStep6B}
              step6B={step6B}
              step6CHead={step6CHead}
              setStep6CHead={setStep6CHead}
              step6C={step6C}
              setStep6C={setStep6C}
              step8C={step8C}
              PopoverStickOnHover={PopoverStickOnHover}
              popoverThumbnailHover={popoverThumbnailHover}
              popoverImages={popoverImages}
              step2B={step2B}
              tracksList2={tracksList2}
              step2C={step2C}
              setPanelPLWarningTemp={setPanelPLWarningTemp}
              step31={step31}
              setStep6DHead={setStep6DHead}
              step6DHead={step6DHead}
              setStep6CHead9={setStep6CHead9}
              step3={step3}
            />

            {/* step 9 */}
            <Step9PleatedOne
              ContextAwareToggle={ContextAwareToggle}
              t={t}
              requiredStep={requiredStep}
              stepSelectedLabel={stepSelectedLabel}
              step6A={step6A}
              step5={step5}
              step3A0={step3A0}
              step2B={step2B}
              step2A={step2A}
              widthCart={widthCart}
              modalHandleShow={modalHandleShow}
              NextStep={NextStep}
              step8={step8}
              setStep81={setStep81}
              setStep82={setStep82}
              setStep83={setStep83}
              setStep9ADrapery={setStep9ADrapery}
              setStep8B={setStep8B}
              setStep8C={setStep8C}
              setSelectedDrapery={setSelectedDrapery}
              setSelectedSheer={setSelectedSheer}
              setSelectedPrivacyLayer={setSelectedPrivacyLayer}
              extendedTitle={extendedTitle}
              step6={step6}
              setHardwareNextStep={setHardwareNextStep}
              setStep8={setStep8}
              selectUncheck={selectUncheck}
              setDeps={setDeps}
              setCart={setCart}
              setExtendedTitle={setExtendedTitle}
              selectChanged={selectChanged}
              inputs={inputs}
              step6BHead={step6BHead}
              step3={step3}
              step31={step31}
              step2B1={step2B1}
              step2C={step2C}
              pageLanguage={pageLanguage}
              privacyLayerSelect={privacyLayerSelect}
              step6CHead={step6CHead}
              OverlayContainer={OverlayContainer}
              rodsList={rodsList}
              rodsColorList={rodsColorList}
              rodsLoad={rodsLoad}
              rodsLoad2={rodsLoad2}
              modelAccessories={modelAccessories}
              step81={step81}
              step83={step83}
              GetPrice={GetPrice}
              isTabletOrMobile={isTabletOrMobile}
              selectedDrapery={selectedDrapery}
              pageLoad={pageLoad}
              skipHardwareTypeCartWipeRef={skipHardwareTypeCartWipeRef}
              draperiesSelect={draperiesSelect}
              draperiesSelect2={draperiesSelect2}
              sheersSelect={sheersSelect}
              sheersSelect2={sheersSelect2}
              sheersSelect3={sheersSelect3}
              selectedSheer={selectedSheer}
              selectedPrivacyLayer={selectedPrivacyLayer}
              privacyLayerSelect3={privacyLayerSelect3}
              privacyLayerSelect2={privacyLayerSelect2}
              hardwareNextStep={hardwareNextStep}
              step6DHead={step6DHead}
              tracksList4={tracksList4}
              rodsColorList5={rodsColorList5}
              step8D1={step8D1}
              trackType8B={trackType8B}
              motorErr1={motorErr1}
              step8B6={step8B6}
              setStep8B6={setStep8B6}
              setMotorErr1={setMotorErr1}
              setSelectedMotorPositionB={setSelectedMotorPositionB}
              setSelectedRemoteName={setSelectedRemoteName}
              setSelectedMotorChannelsB={setSelectedMotorChannelsB}
              motorChannels={motorChannels}
              setRemoteNameB={setRemoteNameB}
              selectedMotorPositionB={selectedMotorPositionB}
              selectedRemoteName={selectedRemoteName}
              selectedMotorChannelsB={selectedMotorChannelsB}
              remoteNames={remoteNames}
              showRemoteName={showRemoteName}
              Capitalize={Capitalize}
              remoteNameB={remoteNameB}
              MotorPosition={MotorPosition}
              setShowRemoteName={setShowRemoteName}
              setCartLoading={setCartLoading}
              step8B={step8B}
              step8B4={step8B4}
              setStep8B4={setStep8B4}
              step8A4={step8A4}
              setStep8A4={setStep8A4}
              setStep8D1={setStep8D1}
              setStep8DTrack={setStep8DTrack}
              setStep8B1={setStep8B1}
              setStep8C1={setStep8C1}
              setStepTrackCollections9A={setStepTrackCollections9A}
              setStepControl9A={setStepControl9A}
              setStepHardware9A={setStepHardware9A}
              setStep9APosition={setStep9APosition}
              step6B={step6B}
              step6C={step6C}
              draperiesSelect3={draperiesSelect3}
              setStep6CHead={setStep6CHead}
              step6CHead9={step6CHead9}
              setStep6CHead9={setStep6CHead9}
              hardwareDraperyStep9={hardwareDraperyStep9}
              hardwareSheerStep9={hardwareSheerStep9}
              hardwareLayerStep9={hardwareLayerStep9}
              step8RodCheck={step8RodCheck}
              step8DTrack={step8DTrack}
              setStep8RodCheck={setStep8RodCheck}
              setStep8BRilType={setStep8BRilType}
              setStep8CTrack={setStep8CTrack}
              setStepTCollections9A={setStepTCollections9A}
              setStep8D2={setStep8D2}
              windowWidthPanelType={windowWidthPanelType}
            />

            {/* step 9A */}
            <Step9AcomponentPleated
              step8={step8}
              depSet={depSet}
              accordionActiveKey={accordionActiveKey}
              ContextAwareToggle={ContextAwareToggle}
              t={t}
              requiredStep={requiredStep}
              stepSelectedLabel={stepSelectedLabel}
              step9ADrapery={step9ADrapery}
              setStep8A1={setStep8A1}
              setStep8A2={setStep8A2}
              setStep8A3={setStep8A3}
              setSelectedDrapery={setSelectedDrapery}
              setStep9ADrapery={setStep9ADrapery}
              extendedTitle={extendedTitle}
              setExtendedTitle={setExtendedTitle}
              setDeps={setDeps}
              setCart={setCart}
              selectChanged={selectChanged}
              inputs={inputs}
              step3={step3}
              step31={step31}
              selectUncheck={selectUncheck}
              modalHandleShow={modalHandleShow}
              rodsList2={rodsList2}
              rodsColorList2={rodsColorList2}
              rodsLoad={rodsLoad}
              step8A1={step8A1}
              step8A3={step8A3}
              GetPrice={GetPrice}
              isTabletOrMobile={isTabletOrMobile}
              modelAccessories={modelAccessories}
              pageLanguage={pageLanguage}
              pageLoad={pageLoad}
              draperiesSelect={draperiesSelect}
              selectedDrapery={selectedDrapery}
              rodsLoad2={rodsLoad2}
              NextStep={NextStep}
              step6CHead={step6CHead}
              tracksList3={tracksList3}
              rodsColorList6={rodsColorList6}
              stepTrackCollections9A={stepTrackCollections9A}
              trackType8B={trackType8B}
              motorErr1={motorErr1}
              step8B6={step8B6}
              setStep8B6={setStep8B6}
              setMotorErr1={setMotorErr1}
              setSelectedMotorPositionA={setSelectedMotorPositionA}
              setSelectedRemoteNameA={setSelectedRemoteNameA}
              setSelectedMotorChannelsA={setSelectedMotorChannelsA}
              motorChannels={motorChannels}
              setRemoteNameA={setRemoteNameA}
              selectedMotorPositionA={selectedMotorPositionA}
              selectedRemoteNameA={selectedRemoteNameA}
              selectedMotorChannelsA={selectedMotorChannelsA}
              remoteNames={remoteNames}
              showRemoteName={showRemoteName}
              Capitalize={Capitalize}
              remoteNameA={remoteNameA}
              MotorPosition={MotorPosition}
              setShowRemoteName={setShowRemoteName}
              setCartLoading={setCartLoading}
              stepControl9A={stepControl9A}
              setStepControl9A={setStepControl9A}
              step9APosition={step9APosition}
              setStep9APosition={setStep9APosition}
              step5={step5}
              setNameBattonEnDraperyTrack={setNameBattonEnDraperyTrack}
              setNameBattonEnDraperyTrack9a={setNameBattonEnDraperyTrack9a}
              widthCart={widthCart}
              sheersSelect3={sheersSelect3}
              sheersSelect2={sheersSelect2}
              sheersSelect={sheersSelect}
              setStep6CHead={setStep6CHead}
              setStep6BHead={setStep6BHead}
              setStep6DHead={setStep6DHead}
              setStep6CHead9={setStep6CHead9}
              setSelectedSheer={setSelectedSheer}
              step8RodCheck={step8RodCheck}
              step8DTrack={step8DTrack}
              setStepTCollections9A={setStepTCollections9A}
              stepTCollections9A={stepTCollections9A}
              setStepTrackCollections9A={setStepTrackCollections9A}
              windowWidthPanelType={windowWidthPanelType}
            />

            {/* step 9B */}
            <Step9BcomponentPleated
              step8={step8}
              depSet={depSet}
              accordionActiveKey={accordionActiveKey}
              ContextAwareToggle={ContextAwareToggle}
              t={t}
              requiredStep={requiredStep}
              stepSelectedLabel={stepSelectedLabel}
              tracksList={tracksList}
              rodsList3={rodsList3}
              step8B={step8B}
              setStep8B1={setStep8B1}
              setStep8B2={setStep8B2}
              setStep8B3={setStep8B3}
              setSelectedSheer={setSelectedSheer}
              setStep8B={setStep8B}
              extendedTitle={extendedTitle}
              setExtendedTitle={setExtendedTitle}
              setDeps={setDeps}
              setCart={setCart}
              selectChanged={selectChanged}
              inputs={inputs}
              rodsColorList3={rodsColorList3}
              rodsLoad2={rodsLoad2}
              widthCart={widthCart}
              step6BHead={step6BHead}
              step6B={step6B}
              modalHandleShow={modalHandleShow}
              setHardwareSheerWarningTemp={setHardwareSheerWarningTemp}
              step6={step6}
              setStep6BHead={setStep6BHead}
              trackType8B={trackType8B}
              step8B3={step8B3}
              modelAccessories={modelAccessories}
              pageLanguage={pageLanguage}
              GetPrice={GetPrice}
              isTabletOrMobile={isTabletOrMobile}
              step8B5={step8B5}
              setStep8B5={setStep8B5}
              motorErr1={motorErr1}
              setMotorErr1={setMotorErr1}
              setSelectedMotorPositionB={setSelectedMotorPositionB}
              selectedMotorPositionB={selectedMotorPositionB}
              setSelectedRemoteName={setSelectedRemoteName}
              setSelectedMotorChannelsB={setSelectedMotorChannelsB}
              selectedMotorChannelsB={selectedMotorChannelsB}
              selectedSheer={selectedSheer}
              selectedRemoteName={selectedRemoteName}
              remoteNames={remoteNames}
              MotorPosition={MotorPosition}
              motorChannels={motorChannels}
              sheersSelect={sheersSelect}
              sheersSelect2={sheersSelect2}
              sheersSelect3={sheersSelect3}
              pageLoad={pageLoad}
              rodsLoad={rodsLoad}
              setRemoteNameB={setRemoteNameB}
              selectUncheck={selectUncheck}
              setShowRemoteName={setShowRemoteName}
              setCartLoading={setCartLoading}
              remoteNameB={remoteNameB}
              showRemoteName={showRemoteName}
              Capitalize={Capitalize}
              NextStep={NextStep}
              step31={step31}
              step3={step3}
              step9ADrapery={step9ADrapery}
              selectedDrapery={selectedDrapery}
              setStep8BRilType={setStep8BRilType}
              step8BRilType={step8BRilType}
              setRemove9A={setRemove9A}
              step5={step5}
              windowWidthPanelType={windowWidthPanelType}
            />

            {/* step 9C */}
            <Step9CcomponentPleated
              step8={step8}
              step2B={step2B}
              depSet={depSet}
              accordionActiveKey={accordionActiveKey}
              ContextAwareToggle={ContextAwareToggle}
              t={t}
              requiredStep={requiredStep}
              stepSelectedLabel={stepSelectedLabel}
              step2C={step2C}
              tracksList2={tracksList2}
              rodsList4={rodsList4}
              step8C={step8C}
              setStep8C1={setStep8C1}
              setStep8C2={setStep8C2}
              setStep8C3={setStep8C3}
              setSelectedPrivacyLayer={setSelectedPrivacyLayer}
              setStep8C={setStep8C}
              extendedTitle={extendedTitle}
              setExtendedTitle={setExtendedTitle}
              setDeps={setDeps}
              setCart={setCart}
              selectChanged={selectChanged}
              inputs={inputs}
              modalHandleShow={modalHandleShow}
              setHardwarePLWarningTemp={setHardwarePLWarningTemp}
              widthCart={widthCart}
              step6CHead={step6CHead}
              step6C={step6C}
              step6={step6}
              setStep6CHead={setStep6CHead}
              trackType8C={trackType8C}
              rodsColorList4={rodsColorList4}
              step8C3={step8C3}
              modelAccessories={modelAccessories}
              GetPrice={GetPrice}
              pageLanguage={pageLanguage}
              isTabletOrMobile={isTabletOrMobile}
              motorErr1={motorErr1}
              step8C5={step8C5}
              setStep8C5={setStep8C5}
              setMotorErr1={setMotorErr1}
              selectedMotorPositionC={selectedMotorPositionC}
              setSelectedMotorPositionC={setSelectedMotorPositionC}
              selectedRemoteName={selectedRemoteName}
              setSelectedRemoteName={setSelectedRemoteName}
              showRemoteName={showRemoteName}
              setSelectedMotorChannelsC={setSelectedMotorChannelsC}
              motorChannels={motorChannels}
              selectUncheck={selectUncheck}
              setRemoteNameC={setRemoteNameC}
              selectedMotorChannelsC={selectedMotorChannelsC}
              pageLoad={pageLoad}
              rodsLoad={rodsLoad}
              rodsLoad2={rodsLoad2}
              MotorPosition={MotorPosition}
              remoteNames={remoteNames}
              setShowRemoteName={setShowRemoteName}
              setCartLoading={setCartLoading}
              remoteNameC={remoteNameC}
              Capitalize={Capitalize}
              selectedPrivacyLayer={selectedPrivacyLayer}
              privacyLayerSelect3={privacyLayerSelect3}
              privacyLayerSelect={privacyLayerSelect}
              privacyLayerSelect2={privacyLayerSelect2}
              NextStep={NextStep}
              step6DHead={step6DHead}
              step31={step31}
              step3={step3}
              step6BHead={step6BHead}
              step9ADrapery={step9ADrapery}
              selectedSheer={selectedSheer}
              step8B={step8B}
              setStep8CTrack={setStep8CTrack}
              step8CTrack={step8CTrack}
              step5={step5}
              windowWidthPanelType={windowWidthPanelType}
            />

            {/* step 10 */}
            <Step11AccessoriesPleatedDraperyAndSheer
              ContextAwareToggle={ContextAwareToggle}
              t={t}
              pageLanguage={pageLanguage}
              isTabletOrMobile={isTabletOrMobile}
              requiredStep={requiredStep}
              stepSelectedLabel={stepSelectedLabel}
              liningPrice={liningPrice}
              stepAccessoriesList={stepAccessoriesList}
              GetPrice={GetPrice}
              NumberToPersianWord={NumberToPersianWord}
              tiebackDraperyQty={tiebackDraperyQty}
              setTiebackDrapery={setTiebackDrapery}
              tiebackSheerQty={tiebackSheerQty}
              setTiebackSheer={setTiebackSheer}
              NextStep={NextStep}
              handCurtainPricDrapery={handCurtainPricDrapery}
              handCurtainPricSheer={handCurtainPricSheer}
              step5={step5}
              step3={step3}
            />
            {/* step 11 */}
            <StepRoomLablePleated
              ContextAwareToggle={ContextAwareToggle}
              t={t}
              stepSelectedLabel={stepSelectedLabel}
              pageLanguage={pageLanguage}
              requiredStep={requiredStep}
              selectedRoomLabel={selectedRoomLabel}
              setSelectedRoomLabel={setSelectedRoomLabel}
              roomLabelChanged={roomLabelChanged}
              setDeps={setDeps}
              setCart={setCart}
              pageLoad={pageLoad}
              rodsLoad={rodsLoad}
              rodsLoad2={rodsLoad2}
              rooms={rooms}
              setCartLoading={setCartLoading}
              roomLabelText={roomLabelText}
              setRoomLabelText={setRoomLabelText}
              detailsShow={detailsShow}
              setDetailsShow={setDetailsShow}
              moreInfoInput={moreInfoInput}
              setMoreInfoInput={setMoreInfoInput}
              NextStep={NextStep}
              multipleFileUploadRef={multipleFileUploadRef}
              baseURLUploadPdf={baseURLUploadPdf}
              baseURLUploadImg={baseURLUploadImg}
              addUploadFileUrl={addUploadFileUrl}
              setUploadedImages={setUploadedImages}
              setUploadedPDFs={setUploadedPDFs}
              addFailedFileToParent={addFailedFileToParent}
              setUploadingFiles={setUploadingFiles}
              allFilesSorted={allFilesSorted}
              handleDeleteFile2={handleDeleteFile2}
              formatFileSize={formatFileSize}
              UploadedFilesList={UploadedFilesList}
              MultipleFileUpload={MultipleFileUpload}
              step5={step5}
              step3={step3}
            />

            {/* step 12 */}
            <Step12componentPleated
              accordionActiveKey={accordionActiveKey}
              ContextAwareToggle={ContextAwareToggle}
              t={t}
              stepSelectedLabel={stepSelectedLabel}
              pageLanguage={pageLanguage}
              hasZipcode={hasZipcode}
              zipcode={zipcode}
              setZipcode={setZipcode}
              measureWindowSize={measureWindowSize}
              zipcodeButton={zipcodeButton}
              hasInstall={hasInstall}
              installPrice={installPrice}
              transportPrice={transportPrice}
              zipcodeChecked={zipcodeChecked}
              setZipcodeChecked={setZipcodeChecked}
              setCart={setCart}
              addingLoading={addingLoading}
              inputs={inputs}
              modalHandleShow={modalHandleShow}
              isTabletOrMobile={isTabletOrMobile}
              GetPrice={GetPrice}
              step5={step5}
              step3={step3}
            />
          </Accordion>
          <div className="CustomModelFooter_visible_part">
            <div className="bag_buttons_section_container">
              <button
                className="btn add_to_cart"
                disabled={addingLoading || cartLoading}
                onClick={() => {
                  if (priceBtn === 0) {
                    modalHandleShow("addToCartPriceNull");
                    return;
                  }
                  setAddingLoading(true);
                  addToCart();
                }}
              >
                {addingLoading ? t("ADDING...") : t("footer_Add To Cart")}
              </button>
              <button className="btn add_to_cart no_pointer">
                {GetPrice(price, pageLanguage, t("TOMANS"), isTabletOrMobile)}
              </button>
              <button
                className="save_to_acc white_btn btn 1"
                onClick={() => {
                  if (step8 === "Same Hardware For All Curtains") {
                    const excludedValues = new Set([
                      "81",
                      "82",
                      "8B2",
                      "8B3",
                      "83",
                      "3BRod",
                      "3CRodFloor",
                      "3DRod",
                      "8B61",
                    ]);
                    for (let val of excludedValues) {
                      depSet.delete(val);
                    }
                  } else if (
                    step8 === "I Want To Customize Hardware Per Curtain" ||
                    step3 === "false"
                  ) {
                    const excludedValues = new Set([
                      "8A1",
                      "8A2",
                      "8B2",
                      "8B3",
                      "3BRod",
                      "3CRodFloor",
                      "3DRod",
                      "8A3",
                      "8B61",
                    ]);
                    for (let val of excludedValues) {
                      depSet.delete(val);
                    }
                  } else if (step8 === "I Have My Own Hardware") {
                    const excludedValues = new Set(["3BRod", "3CRodFloor", "3DRod"]);
                    for (let val of excludedValues) {
                      depSet.delete(val);
                    }
                  }
                  if (roomLabelText !== "" && selectedRoomLabel.length) {
                    setSavingLoading(true);
                    if ((projectId && projectId !== "") || (editIndex && editIndex !== "")) {
                      if (cartValues["PanelTypeA"]) {
                        cartValues["step6CHead"] = step6CHead;
                      }
                      if (cartValues["PanelTypeB"]) {
                        cartValues["step6BHead"] = step6BHead;
                      }
                      if (cartValues["PanelTypeC"]) {
                        cartValues["step6DHead"] = step6DHead;
                      }

                      SaveUserProject(
                        depSet,
                        cartValues,
                        [uploadedImagesFile, uploadedImagesURL, uploadedPDFFile, uploadedPDFURL],
                        `${modelID}`,
                        price,
                        defaultModelName,
                        defaultModelNameFa,
                        projectData
                      )
                        .then((temp) => {
                          if (temp === 401) {
                            setSaveProjectCount(saveProjectCount + 1);
                          } else if (temp) {
                            modalHandleShow("add_to_project_modal");
                            setProjectModalState(1);
                            setSavingLoading(false);
                          } else {
                            setSavingLoading(false);
                          }
                        })
                        .catch((err) => {
                          console.log(err);
                          setProjectModalState(2);
                          modalHandleShow("add_to_project_modal");
                          setSavingLoading(false);
                        });
                    } else {
                      if (cartValues["PanelTypeA"]) {
                        cartValues["step6CHead"] = step6CHead;
                      }
                      if (cartValues["PanelTypeB"]) {
                        cartValues["step6BHead"] = step6BHead;
                      }
                      if (cartValues["PanelTypeC"]) {
                        cartValues["step6DHead"] = step6DHead;
                      }

                      SaveUserProject(
                        depSet,
                        cartValues,
                        [uploadedImagesFile, uploadedImagesURL, uploadedPDFFile, uploadedPDFURL],
                        `${modelID}`,
                        price,
                        defaultModelName,
                        defaultModelNameFa
                      )
                        .then((temp) => {
                          if (temp === 401) {
                            setSaveProjectCount(saveProjectCount + 1);
                          } else if (temp) {
                            modalHandleShow("add_to_project_modal");
                            setProjectModalState(1);
                            setSavingLoading(false);
                          } else {
                            setSavingLoading(false);
                          }
                        })
                        .catch((err) => {
                          console.log(err);
                          setProjectModalState(2);
                          modalHandleShow("add_to_project_modal");
                          setSavingLoading(false);
                        });
                    }
                  } else {
                    setProjectModalState(0);
                    modalHandleShow("add_to_project_modal");
                  }
                }}
                disabled={savingLoading || cartLoading}
              >
                {savingLoading ? t("SAVING...") : t("footer_Save To")}
              </button>
            </div>
          </div>
        </div>
      </div>

      {/* Modals */}

      <div
        className={
          filtersShow
            ? "filters_container filters_container_mob_show mobile_only"
            : "filters_container mobile_only"
        }
      >
        <div className="nav_header">
          <div className="nav_header_bottom nav_header_bottom_single">
            <div className="close_menu_icon" onClick={() => setFiltersShow(false)}>
              <img
                src={require("../Images/public/close-button.png")}
                className="img-fluid"
                alt=""
              />
            </div>
          </div>
        </div>
        {filtersShow && (
          <div className="product_filters_container">
            <Accordion>
              <Accordion.Item eventKey="0">
                <ContextAwareToggleFilters
                  eventKey="0"
                  textOnHide={t("Color")}
                  textOnShow={t("Color")}
                />
                <Accordion.Body className="product_filter_dropdown">
                  <div className="product_filter_dropdown">{sewingColors2}</div>
                </Accordion.Body>
              </Accordion.Item>
            </Accordion>
            <Accordion>
              <Accordion.Item eventKey="0">
                <ContextAwareToggleFilters
                  eventKey="0"
                  textOnHide={t("Price")}
                  textOnShow={t("Price")}
                />
                <Accordion.Body className="product_filter_dropdown">
                  <div className="product_filter_dropdown">{sewingPrices2}</div>
                </Accordion.Body>
              </Accordion.Item>
            </Accordion>
            <Accordion>
              <Accordion.Item eventKey="0">
                <ContextAwareToggleFilters
                  eventKey="0"
                  textOnHide={t("Type")}
                  textOnShow={t("Type")}
                />
                <Accordion.Body className="product_filter_dropdown">
                  <div className="product_filter_dropdown">{sewingTypes2}</div>
                </Accordion.Body>
              </Accordion.Item>
            </Accordion>
            <Accordion>
              <Accordion.Item eventKey="0">
                <ContextAwareToggleFilters
                  eventKey="0"
                  textOnHide={t("Pattern")}
                  textOnShow={t("Pattern")}
                />
                <Accordion.Body className="product_filter_dropdown">
                  <div className="product_filter_dropdown">{sewingPatterns2}</div>
                </Accordion.Body>
              </Accordion.Item>
            </Accordion>
          </div>
        )}
        <div className="filter_modal_btn_section">
          <button
            className="btn btn-new-dark"
            onClick={() => {
              setIsClearAll(true);
              // setFiltersShow(false);
            }}
          >
            {t("CLEAR")}
          </button>
          <button
            className="btn white_btn"
            onClick={() => {
              setFiltersShow(false);
            }}
          >
            {t("DONE")}
          </button>
        </div>
      </div>
      <ElectricHandModalGrommet
        pageLanguage={pageLanguage}
        modals={modals}
        modalHandleClose={modalHandleClose}
        t={t}
      />

      <CompleteStep4Grommet
        pageLanguage={pageLanguage}
        modals={modals}
        modalHandleClose={modalHandleClose}
        t={t}
      />

      <FabricSelectionModalGrommet
        pageLanguage={pageLanguage}
        modals={modals}
        modalHandleClose={modalHandleClose}
        t={t}
      />
      <Modal
        dialogClassName={`warning_modal2 bigSizeModal ${
          pageLanguage === "fa" ? "font_farsi" : "font_en"
        }`}
        show={modals["panelTypeWarning"] === undefined ? false : modals["panelTypeWarning"]}
        onHide={() => modalHandleClose("panelTypeWarning")}
      >
        <Modal.Header closeButton>{/*<Modal.Title>Modal heading</Modal.Title>*/}</Modal.Header>
        <Modal.Body>
          <p>{t("panelTypeWarning")}</p>

          <br />
          <div className="buttons_section">
            <button
              className="btn btn-new-dark"
              onClick={() => {
                modalHandleClose("panelTypeWarning");
                selectChanged(undefined, "6");
              }}
            >
              {t("CHANGE MEASUREMENTS")}
            </button>
            <button
              className="btn white_btn"
              onClick={() => {
                modalHandleClose("panelTypeWarning");
              }}
            >
              {t("I AGREE, CONTINUE ANYWAY")}
            </button>
          </div>
        </Modal.Body>
      </Modal>

      <Modal
        dialogClassName={`warning_modal2 bigSizeModal ${
          pageLanguage === "fa" ? "font_farsi" : "font_en"
        }`}
        show={
          modals["SheerHeaderStyleWarning"] === undefined
            ? false
            : modals["SheerHeaderStyleWarning"]
        }
        onHide={() => modalHandleClose("SheerHeaderStyleWarning")}
      >
        <Modal.Header>{/*<Modal.Title>Modal heading</Modal.Title>*/}</Modal.Header>
        <Modal.Body>
          <p>{t("SheerHeaderStyleWarning")}</p>

          <br />
          <div className="buttons_section">
            <button
              className="btn btn-new-dark"
              onClick={() => {
                modalHandleClose("SheerHeaderStyleWarning");
              }}
            >
              {t("CANCEL")}
            </button>
            <button
              className="btn white_btn"
              onClick={() => {
                setStep2A(sheerHeaderStyleTemp.stepValue);
                setDeps(
                  "",
                  "2A,8,81,82,83,84,8A,8A1,8A2,8A3,8A4,8B,8B1,8B2,8B3,8B5,8B51,8B6,8C,8C1,8C2,8C3,8C5,8C51,8C52,8C6"
                );
                setCart(
                  "SheerHeaderStyle",
                  sheerHeaderStyleTemp.cartValue,
                  "RailId,BatonOption,RailDesign,RailDesignEn,RailDesignFa,RailColorEn,RailColorFa,RodColor,Mount8,BatonOptionA,RailDesignA,RailDesignEnA,RailDesignFaA,RailColorEnA,RailColorFaA,RodColorA,MountA,RailIdB,BatonOptionB,ControlPositionB,RailDesignB,RailDesignEnB,RailDesignFaB,RailColorEnB,RailColorFaB,RodColorB,hasPowerB,MotorPositionB,RemoteNameB,MotorChannelsB,RailIdC,BatonOptionC,ControlPositionC,RailDesignC,RailDesignEnC,RailDesignFaC,RailColorEnC,RailColorFaC,RodColorC,hasPowerC,MotorPositionC,RemoteNameC,MotorChannelsC",
                  "SheerHeaderStyleID",
                  [sheerHeaderStyleTemp.id]
                );
                selectChanged(sheerHeaderStyleTemp.event, "8");
                setSheersModelId(sheerHeaderStyleTemp.id);
                setStep8("");
                modalHandleClose("SheerHeaderStyleWarning");
              }}
            >
              {t("I AGREE, CONTINUE ANYWAY")}
            </button>
          </div>
        </Modal.Body>
      </Modal>
      <Modal
        backdrop="static"
        keyboard={false}
        dialogClassName={`addToCartErr bigSizeModal ${
          pageLanguage === "fa" ? "font_farsi" : "font_en"
        }`}
        show={modals["addToCartPriceNull"] === undefined ? false : modals["addToCartPriceNull"]}
        onHide={() => {
          modalHandleClose("addToCartPriceNull");
        }}
      >
        <Modal.Header closeButton></Modal.Header>
        <Modal.Body>
          <div className="modal-header-grommet">
            {pageLanguage === "fa" ? "امکان افزودن به سبد خرید وجود ندارد" : "UNABLE TO ADD TO BAG"}
          </div>

          <span>{t("notAddToBag")}</span>

          <br />
          <span>{t("addToCartErr1")}</span>
          <span>{t("addToCartErr3")}</span>
          <br />
          <div className="text_center">
            <button
              className="btn btn-new-dark"
              onClick={() => modalHandleClose("addToCartPriceNull")}
            >
              {t("OK")}
            </button>
          </div>
        </Modal.Body>
      </Modal>
      <Modal
        dialogClassName={`warning_modal2 bigSizeModal ${
          pageLanguage === "fa" ? "font_farsi" : "font_en"
        }`}
        show={
          modals["SheerHeaderStyleWarning2"] === undefined
            ? false
            : modals["SheerHeaderStyleWarning2"]
        }
        onHide={() => modalHandleClose("SheerHeaderStyleWarning2")}
      >
        <Modal.Header>{/*<Modal.Title>Modal heading</Modal.Title>*/}</Modal.Header>
        <Modal.Body>
          <p>{t("SheerHeaderStyleWarning")}</p>

          <br />
          <div className="buttons_section">
            <button
              className="btn btn-new-dark"
              onClick={() => {
                modalHandleClose("SheerHeaderStyleWarning2");
              }}
            >
              {t("CANCEL")}
            </button>
            <button
              className="btn white_btn"
              onClick={() => {
                setStep2C(sheerHeaderStyleTemp2.stepValue);
                setDeps(
                  "",
                  "2C,8,81,82,83,84,8A,8A1,8A2,8A3,8A4,8B,8B1,8B2,8B3,8B5,8B51,8B6,8C,8C1,8C2,8C3,8C5,8C51,8C52,8C6"
                );
                setCart(
                  "PrivacyLayerHeaderStyle",
                  sheerHeaderStyleTemp2.cartValue,
                  "RailId,BatonOption,RailDesign,RailDesignEn,RailDesignFa,RailColorEn,RailColorFa,RodColor,Mount8,BatonOptionA,RailDesignA,RailDesignEnA,RailDesignFaA,RailColorEnA,RailColorFaA,RodColorA,MountA,RailIdB,BatonOptionB,ControlPositionB,RailDesignB,RailDesignEnB,RailDesignFaB,RailColorEnB,RailColorFaB,RodColorB,hasPowerB,MotorPositionB,RemoteNameB,MotorChannelsB,RailIdC,BatonOptionC,ControlPositionC,RailDesignC,RailDesignEnC,RailDesignFaC,RailColorEnC,RailColorFaC,RodColorC,hasPowerC,MotorPositionC,RemoteNameC,MotorChannelsC",
                  "PrivacyLayerHeaderStyleID",
                  [sheerHeaderStyleTemp2.id]
                );
                selectChanged(sheerHeaderStyleTemp2.event, "8");
                setSheersModelId2(sheerHeaderStyleTemp2.id);
                setStep8("");
                modalHandleClose("SheerHeaderStyleWarning2");
              }}
            >
              {t("I AGREE, CONTINUE ANYWAY")}
            </button>
          </div>
        </Modal.Body>
      </Modal>

      <Modal
        dialogClassName={`warning_modal2 bigSizeModal ${
          pageLanguage === "fa" ? "font_farsi" : "font_en"
        }`}
        show={modals["MountTypeWarning"] === undefined ? false : modals["MountTypeWarning"]}
        onHide={() => modalHandleClose("MountTypeWarning")}
      >
        <Modal.Header>{/*<Modal.Title>Modal heading</Modal.Title>*/}</Modal.Header>
        <Modal.Body>
          <p>{t("MountTypeWarning")}</p>

          <br />
          <div className="buttons_section">
            <button
              className="btn btn-new-dark"
              onClick={() => {
                modalHandleClose("MountTypeWarning");
              }}
            >
              {pageLanguage === "en" ? "CANCEL" : "ادامه سفارش"}
            </button>
            <button
              className="btn white_btn"
              onClick={() => {
                setStep3A0(mountTypeTemp.stepValue);
                setStep3("");
                setStep5("");
                setWidth("");
                setHeight("");
                setLeft("");
                setRight("");
                setWidthCart("");
                setWindowWidthPanelType("");
                setHeightCart("");
                setHeightCart2(undefined);
                setWindowSize("");
                setWindowSizeBool(false);
                setMount("");
                setCeilingToWindow1("");
                setCeilingToWindow2("");
                setCeilingToWindow3("");
                setDepth(undefined);
                setMouldingHeight(undefined);
                setMountErr1(false);
                setMountErr2(false);
                if (mountTypeTemp.stepValue === "Moulding") {
                  setDeps(
                    "3,3A11,3A12",
                    "3A0,31,311,312,3A,3A1,3B,3B1,3C,3D1,3D2,3E,3EFloor,3F,3G,3ARod,3ARod1,3BRod,3CRod,3CRodFloor,3DRod,3EStandardCeiling1,3EStandardCeiling2,3EStandardCeiling3,3EStandardCeilingFloor1,3EStandardCeilingFloor2,3EStandardCeilingFloor3"
                  );
                } else {
                  setDeps(
                    "3",
                    "3A0,3A11,3A12,31,311,312,3A,3A1,3B,3B1,3C,3D1,3D2,3E,3EFloor,3F,3G,3ARod,3ARod1,3BRod,3CRod,3CRodFloor,3DRod,3EStandardCeiling1,3EStandardCeiling2,3EStandardCeiling3,3EStandardCeilingFloor1,3EStandardCeilingFloor2,3EStandardCeilingFloor3"
                  );
                }
                setCart(
                  "Mount",
                  mountTypeTemp.cartValue,
                  "Depth,MouldingHeight,calcMeasurements,Width,Height,WidthCart,HeightCart,WindowWidth,WindowHeight,hasRod,CurtainPosition,FinishedLengthType,Width3C,ExtensionLeft,ExtensionRight,ShadeMount,Height3E,WindowToFloor,CeilingToFloor,RodWidth,RodToBottom,RodToFloor,CeilingToWindow1,CeilingToWindow2,CeilingToWindow3,CeilingToFloor1,CeilingToFloor2,CeilingToFloor3"
                );
                // clearInputs(mountTypeTemp.event, undefined, "3,3A,3B");
                clearInputs(mountTypeTemp.event, undefined, "3");
                // setMeasurementsNextStep("4");
                modalHandleClose("MountTypeWarning");
              }}
            >
              {pageLanguage === "en" ? "I AGREE, CONTINUE ANYWAY" : "تغییر نحوه نصب"}
            </button>
          </div>
        </Modal.Body>
      </Modal>

      <Modal
        dialogClassName={`warning_modal2 bigSizeModal ${
          pageLanguage === "fa" ? "font_farsi" : "font_en"
        }`}
        show={modals["CurtainPosWarning"] === undefined ? false : modals["CurtainPosWarning"]}
        onHide={() => modalHandleClose("CurtainPosWarning")}
      >
        <Modal.Header>{/*<Modal.Title>Modal heading</Modal.Title>*/}</Modal.Header>
        <Modal.Body>
          <p>{t("CurtainPosWarning")}</p>

          <br />
          <div className="buttons_section">
            <button
              className="btn btn-new-dark"
              onClick={() => {
                modalHandleClose("CurtainPosWarning");
              }}
            >
              {t("CANCEL")}
            </button>
            <button
              className="btn white_btn"
              onClick={() => {
                setStep3A(curtainPosTemp.stepValue);
                clearInputs(curtainPosTemp.event);
                setCart(
                  "CurtainPosition",
                  curtainPosTemp.cartValue,
                  "Width3C,ExtensionLeft,ExtensionRight,ShadeMount,Height3E,WindowToFloor,CeilingToFloor,RodWidth,RodToBottom,RodToFloor,CeilingToWindow1,CeilingToWindow2,CeilingToWindow3,CeilingToFloor1,CeilingToFloor2,CeilingToFloor3"
                );
                if (step3B === "Sill" || step3B === "Apron") {
                  if (
                    (step3A0 === "Ceiling" || step3A0 === "Moulding") &&
                    (curtainPosTemp.stepValue === "Standard" ||
                      curtainPosTemp.stepValue === "Left Corner Window" ||
                      curtainPosTemp.stepValue === "Right Corner Window")
                  ) {
                    setDeps(
                      "3C,3D1,3D2,3EStandardCeiling1,3EStandardCeiling2,3EStandardCeiling3,3G",
                      "3A,3B,3B1,3E,3F,3EFloor,3BRod,3CRod,3CRodFloor,3DRod,3EStandardCeilingFloor1,3EStandardCeilingFloor2,3EStandardCeilingFloor3"
                    );
                  } else if (curtainPosTemp.stepValue === "Wall to Wall" && step3A0 === "Wall") {
                    setDeps(
                      "3C,3E,3F,3G",
                      "3A,3B,3B1,3D1,3D2,3EFloor,3BRod,3CRod,3CRodFloor,3DRod,3EStandardCeiling1,3EStandardCeiling2,3EStandardCeiling3,3EStandardCeilingFloor1,3EStandardCeilingFloor2,3EStandardCeilingFloor3"
                    );
                  } else if (
                    curtainPosTemp.stepValue === "Wall to Wall" &&
                    (step3A0 === "Ceiling" || step3A0 === "Moulding")
                  ) {
                    setDeps(
                      "3C,3EStandardCeiling1,3EStandardCeiling2,3EStandardCeiling3,3G",
                      "3A,3B,3B1,3D1,3D2,3E,3F,3EFloor,3BRod,3CRod,3CRodFloor,3DRod,3EStandardCeilingFloor1,3EStandardCeilingFloor2,3EStandardCeilingFloor3"
                    );
                  } else {
                    setDeps(
                      "3C,3D1,3D2,3E,3F,3G",
                      "3A,3B,3B1,3EFloor,3BRod,3CRod,3CRodFloor,3DRod,3EStandardCeiling1,3EStandardCeiling2,3EStandardCeiling3,3EStandardCeilingFloor1,3EStandardCeilingFloor2,3EStandardCeilingFloor3"
                    );
                  }
                } else {
                  if (
                    (step3A0 === "Ceiling" || step3A0 === "Moulding") &&
                    (curtainPosTemp.stepValue === "Standard" ||
                      curtainPosTemp.stepValue === "Left Corner Window" ||
                      curtainPosTemp.stepValue === "Right Corner Window")
                  ) {
                    setDeps(
                      "3C,3D1,3D2,3EStandardCeilingFloor1,3EStandardCeilingFloor2,3EStandardCeilingFloor3",
                      "3A,3B,3B1,3E,3F,3G,3EFloor,3BRod,3CRod,3CRodFloor,3DRod,3EStandardCeiling1,3EStandardCeiling2,3EStandardCeiling3"
                    );
                  } else if (curtainPosTemp.stepValue === "Wall to Wall" && step3A0 === "Wall") {
                    setDeps(
                      "3C,3EFloor,3F,3G",
                      "3A,3B,3B1,3D1,3D2,3E,3BRod,3CRod,3CRodFloor,3DRod,3EStandardCeiling1,3EStandardCeiling2,3EStandardCeiling3,3EStandardCeilingFloor1,3EStandardCeilingFloor2,3EStandardCeilingFloor3"
                    );
                  } else if (
                    curtainPosTemp.stepValue === "Wall to Wall" &&
                    (step3A0 === "Ceiling" || step3A0 === "Moulding")
                  ) {
                    setDeps(
                      "3C,3EStandardCeilingFloor1,3EStandardCeilingFloor2,3EStandardCeilingFloor3",
                      "3A,3B,3B1,3D1,3D2,3E,3F,3G,3EFloor,3BRod,3CRod,3CRodFloor,3DRod,3EStandardCeiling1,3EStandardCeiling2,3EStandardCeiling3"
                    );
                  } else {
                    setDeps(
                      "3C,3D1,3D2,3EFloor,3F,3G",
                      "3A,3B,3B1,3E,3BRod,3CRod,3CRodFloor,3DRod,3EStandardCeiling1,3EStandardCeiling2,3EStandardCeiling3,3EStandardCeilingFloor1,3EStandardCeilingFloor2,3EStandardCeilingFloor3"
                    );
                  }
                }
                modalHandleClose("CurtainPosWarning");
              }}
            >
              {t("I AGREE, CONTINUE ANYWAY")}
            </button>
          </div>
        </Modal.Body>
      </Modal>

      <Modal
        dialogClassName={`warning_modal2 bigSizeModal ${
          pageLanguage === "fa" ? "font_farsi" : "font_en"
        }`}
        show={
          modals["FinishedLengthWarning"] === undefined ? false : modals["FinishedLengthWarning"]
        }
        onHide={() => modalHandleClose("FinishedLengthWarning")}
      >
        <Modal.Header>{/*<Modal.Title>Modal heading</Modal.Title>*/}</Modal.Header>
        <Modal.Body>
          <p>{t("FinishedLengthWarning")}</p>

          <br />
          <div className="buttons_section">
            <button
              className="btn btn-new-dark"
              onClick={() => {
                modalHandleClose("FinishedLengthWarning");
              }}
            >
              {t("CANCEL")}
            </button>
            <button
              className="btn white_btn"
              onClick={() => {
                setStep3B(finishedLengthTemp.stepValue);
                clearInputs(finishedLengthTemp.event);
                setCart(
                  "FinishedLengthType",
                  finishedLengthTemp.cartValue,
                  "WindowToFloor,RodWidth,Width3C,Height3E,RodToBottom,RodToFloor,CeilingToFloor,CeilingToWindow1,CeilingToWindow2,CeilingToWindow3,CeilingToFloor1,CeilingToFloor2,CeilingToFloor3"
                );

                if (
                  finishedLengthTemp.stepValue === "Sill" ||
                  finishedLengthTemp.stepValue === "Apron"
                ) {
                  if (
                    (step3A0 === "Ceiling" || step3A0 === "Moulding") &&
                    (step3A === "Standard" ||
                      step3A === "Left Corner Window" ||
                      step3A === "Right Corner Window")
                  ) {
                    setDeps(
                      "3C,3D1,3D2,3EStandardCeiling1,3EStandardCeiling2,3EStandardCeiling3,3G",
                      "3B,3B1,3E,3F,3EFloor,3BRod,3CRod,3CRodFloor,3DRod,3EStandardCeilingFloor1,3EStandardCeilingFloor2,3EStandardCeilingFloor3"
                    );
                  } else if (step3A === "Wall to Wall" && step3A0 === "Wall") {
                    setDeps(
                      "3C,3E,3F,3G",
                      "3B,3B1,3D1,3D2,3EFloor,3BRod,3CRod,3CRodFloor,3DRod,3EStandardCeiling1,3EStandardCeiling2,3EStandardCeiling3,3EStandardCeilingFloor1,3EStandardCeilingFloor2,3EStandardCeilingFloor3"
                    );
                  } else if (
                    step3A === "Wall to Wall" &&
                    (step3A0 === "Ceiling" || step3A0 === "Moulding")
                  ) {
                    setDeps(
                      "3C,3EStandardCeiling1,3EStandardCeiling2,3EStandardCeiling3,3G",
                      "3B,3B1,3D1,3D2,3E,3F,3EFloor,3BRod,3CRod,3CRodFloor,3DRod,3EStandardCeilingFloor1,3EStandardCeilingFloor2,3EStandardCeilingFloor3"
                    );
                  } else {
                    setDeps(
                      "3C,3D1,3D2,3E,3F,3G",
                      "3B,3B1,3EFloor,3BRod,3CRod,3CRodFloor,3DRod,3EStandardCeiling1,3EStandardCeiling2,3EStandardCeiling3,3EStandardCeilingFloor1,3EStandardCeilingFloor2,3EStandardCeilingFloor3"
                    );
                  }
                } else {
                  if (
                    (step3A0 === "Ceiling" || step3A0 === "Moulding") &&
                    (step3A === "Standard" ||
                      step3A === "Left Corner Window" ||
                      step3A === "Right Corner Window")
                  ) {
                    setDeps(
                      "3C,3D1,3D2,3EStandardCeilingFloor1,3EStandardCeilingFloor2,3EStandardCeilingFloor3",
                      "3B,3B1,3E,3F,3G,3EFloor,3BRod,3CRod,3CRodFloor,3DRod,3EStandardCeiling1,3EStandardCeiling2,3EStandardCeiling3"
                    );
                  } else if (step3A === "Wall to Wall" && step3A0 === "Wall") {
                    setDeps(
                      "3C,3EFloor,3F,3G",
                      "3B,3B1,3D1,3D2,3E,3BRod,3CRod,3CRodFloor,3DRod,3EStandardCeiling1,3EStandardCeiling2,3EStandardCeiling3,3EStandardCeilingFloor1,3EStandardCeilingFloor2,3EStandardCeilingFloor3"
                    );
                  } else if (
                    step3A === "Wall to Wall" &&
                    (step3A0 === "Ceiling" || step3A0 === "Moulding")
                  ) {
                    setDeps(
                      "3C,3EStandardCeilingFloor1,3EStandardCeilingFloor2,3EStandardCeilingFloor3",
                      "3B,3B1,3D1,3D2,3E,3F,3G,3EFloor,3BRod,3CRod,3CRodFloor,3DRod,3EStandardCeiling1,3EStandardCeiling2,3EStandardCeiling3"
                    );
                  } else {
                    setDeps(
                      "3C,3D1,3D2,3EFloor,3F,3G",
                      "3B,3B1,3E,3BRod,3CRod,3CRodFloor,3DRod,3EStandardCeiling1,3EStandardCeiling2,3EStandardCeiling3,3EStandardCeilingFloor1,3EStandardCeilingFloor2,3EStandardCeilingFloor3"
                    );
                  }
                }
                modalHandleClose("FinishedLengthWarning");
              }}
            >
              {t("I AGREE, CONTINUE ANYWAY")}
            </button>
          </div>
        </Modal.Body>
      </Modal>

      <Modal
        dialogClassName={`warning_modal2 bigSizeModal ${
          pageLanguage === "fa" ? "font_farsi" : "font_en"
        }`}
        show={
          modals["FinishedLengthWarning4"] === undefined ? false : modals["FinishedLengthWarning4"]
        }
        onHide={() => modalHandleClose("FinishedLengthWarning4")}
      >
        <Modal.Header>{/*<Modal.Title>Modal heading</Modal.Title>*/}</Modal.Header>
        <Modal.Body>
          <p>{t("FinishedLengthWarning")}</p>

          <br />
          <div className="buttons_section">
            <button
              className="btn btn-new-dark"
              onClick={() => {
                modalHandleClose("FinishedLengthWarning4");
              }}
            >
              {t("CANCEL")}
            </button>
            <button
              className="btn white_btn"
              onClick={() => {
                setStep3ARod(finishedLengthTemp.stepValue);
                clearInputs(finishedLengthTemp.event);
                setCart(
                  "FinishedLengthType",
                  finishedLengthTemp.cartValue,
                  "WindowToFloor,RodWidth,Width3C,Height3E,RodToBottom,RodToFloor,CeilingToFloor,CeilingToWindow1,CeilingToWindow2,CeilingToWindow3,CeilingToFloor1,CeilingToFloor2,CeilingToFloor3"
                );

                modalHandleClose("FinishedLengthWarning4");
              }}
            >
              {t("I AGREE, CONTINUE ANYWAY")}
            </button>
          </div>
        </Modal.Body>
      </Modal>

      <Modal
        dialogClassName={`warning_modal2 bigSizeModal ${
          pageLanguage === "fa" ? "font_farsi" : "font_en"
        }`}
        show={modals["hardwareSheerWarning"] === undefined ? false : modals["hardwareSheerWarning"]}
        onHide={() => modalHandleClose("hardwareSheerWarning")}
      >
        <Modal.Header>{/*<Modal.Title>Modal heading</Modal.Title>*/}</Modal.Header>
        <Modal.Body>
          <p>{t("hardwareSheerWarning")}</p>

          <br />
          <div className="buttons_section">
            <button
              className="btn btn-new-dark"
              onClick={() => {
                modalHandleClose("hardwareSheerWarning");
              }}
            >
              {t("CANCEL")}
            </button>
            <button
              className="btn white_btn"
              onClick={() => {
                setStep6B("");
                setStep8B1("");
                setStep8BRilType("");
                setStep8B2("");
                setStep8B3("");
                // setStep8B4("");
                setTimeout(() => {
                  setStep8B(hardwareSheerWarningTemp.stepValue);
                }, 300);
                let tempExtended = extendedTitle;
                tempExtended["6"].splice(2, 1);
                tempExtended["8B"] = [t(hardwareSheerWarningTemp.id)];
                setExtendedTitle(tempExtended);

                setCart(
                  "SheerHardware",
                  hardwareSheerWarningTemp.cartValue,
                  "PanelTypeB,RailIdB,BatonOptionB,ControlPositionB,RailDesignB,RailDesignEnB,RailDesignFaB,RailColorEnB,RailColorFaB,RodColorB,hardwareSheer"
                );
                selectChanged(hardwareSheerWarningTemp.event);
                setDeps("6B,8B1,8B2,8B3", "8B,8B5,8B51,8B6");
                modalHandleClose("hardwareSheerWarning");
              }}
            >
              {t("I AGREE, CONTINUE ANYWAY")}
            </button>
          </div>
        </Modal.Body>
      </Modal>

      <Modal
        dialogClassName={`warning_modal2 bigSizeModal ${
          pageLanguage === "fa" ? "font_farsi" : "font_en"
        }`}
        show={modals["hardwarePLWarning"] === undefined ? false : modals["hardwarePLWarning"]}
        onHide={() => modalHandleClose("hardwarePLWarning")}
      >
        <Modal.Header>{/*<Modal.Title>Modal heading</Modal.Title>*/}</Modal.Header>
        <Modal.Body>
          <p>{t("hardwarePLWarning")}</p>

          <br />
          <div className="buttons_section">
            <button
              className="btn btn-new-dark"
              onClick={() => {
                modalHandleClose("hardwarePLWarning");
              }}
            >
              {t("CANCEL")}
            </button>
            <button
              className="btn white_btn"
              onClick={() => {
                setStep6C("");
                setStep8C1("");
                setStep8CTrack("");
                setStep8C2("");
                setStep8C3("");
                // setStep8C4("");
                setTimeout(() => {
                  setStep8C(hardwarePLWarningTemp.stepValue);
                }, 300);
                let tempExtended = extendedTitle;
                tempExtended["6"].splice(3, 1);
                tempExtended["8C"] = [t(hardwarePLWarningTemp.id)];
                setExtendedTitle(tempExtended);
                // setDeps("8C1,8C2,8C3", "8C");
                setCart(
                  "PrivacyLayerHardware",
                  hardwarePLWarningTemp.cartValue,
                  "PanelTypeC,RailIdC,BatonOptionC,ControlPositionC,RailDesignC,RailDesignEnC,RailDesignFaC,RailColorEnC,RailColorFaC,RodColorC,hardwarePrivacyLayer"
                );
                selectChanged(hardwarePLWarningTemp.event);
                setDeps("6C,8C1,8C2,8C3", "8C,8C5,8C51,8C52,8C6");
                modalHandleClose("hardwarePLWarning");
              }}
            >
              {t("I AGREE, CONTINUE ANYWAY")}
            </button>
          </div>
        </Modal.Body>
      </Modal>

      <Modal
        dialogClassName={`warning_modal2 bigSizeModal ${
          pageLanguage === "fa" ? "font_farsi" : "font_en"
        }`}
        show={modals["panelSheerWarning"] === undefined ? false : modals["panelSheerWarning"]}
        onHide={() => modalHandleClose("panelSheerWarning")}
      >
        <Modal.Header>{/*<Modal.Title>Modal heading</Modal.Title>*/}</Modal.Header>
        <Modal.Body>
          <p>
            {panelSheerWarningTemp.id === "1" ? t("hardwarePLWarning") : t("panelSheerWarning")}
          </p>

          <br />
          <div className="buttons_section">
            <button
              className="btn btn-new-dark"
              onClick={() => {
                modalHandleClose("panelSheerWarning");
              }}
            >
              {t("CANCEL")}
            </button>
            <button
              className="btn white_btn"
              onClick={() => {
                if (step6CHead === "Rod" && step6BHead === "Rod" && step6DHead === "Track") {
                  setStep6BHead(panelSheerWarningTemp.stepValue);
                  setStep6B("");
                  setStep8C("");
                  setStep8("");
                  let tempExtended = extendedTitle;
                  tempExtended["6"][1] = [];
                  tempExtended["8"] = [];
                  tempExtended["8A"] = [];
                  tempExtended["8B"] = [];
                  tempExtended["8C"] = [];
                  setExtendedTitle(tempExtended);
                } else if (
                  step6CHead === "Rod" &&
                  step6BHead === "Track" &&
                  step6DHead === "Track"
                ) {
                  setStep6BHead(panelSheerWarningTemp.stepValue);
                  setStep6B("");
                  setStep8C("");
                  setStep8("");
                  let tempExtended = extendedTitle;
                  tempExtended["6"][1] = [];
                  tempExtended["8"] = [];
                  tempExtended["8A"] = [];
                  tempExtended["8B"] = [];
                  tempExtended["8C"] = [];
                  setExtendedTitle(tempExtended);
                } else if (panelSheerWarningTemp.id === "1") {
                  setStep6DHead(panelSheerWarningTemp.stepValue);
                  setStep8D1("");
                  setStep8DTrack("");
                  setStep6C("");
                  setStep8B("");
                  setStep8("");
                  setStep81("");
                  setStep8RodCheck("");
                  setStep8A4("");
                  let tempExtended = extendedTitle;
                  tempExtended["8"] = [];
                  tempExtended["8A"] = [];
                  tempExtended["8B"] = [];
                  tempExtended["8C"] = [];
                  tempExtended["6"].splice(2);

                  setExtendedTitle(tempExtended);
                  setDeps("6B,8B", "8B1,8B2,8B3,8B5,8B51,8B6");
                  setCart(
                    "",
                    "",
                    "PanelTypeB,PrivacyLayerHardware,RailIdB,BatonOptionB,ControlPositionB,RailDesignB,RailDesignEnB,RailDesignFaB,RailColorEnB,RailColorFaB,RodColorB,hasPowerB,MotorPositionB,RemoteNameB,MotorChannelsB"
                  );
                } else {
                  setStep6BHead(panelSheerWarningTemp.stepValue);
                  if (panelSheerWarningTemp.stepValue === "Track") {
                    setStep6DHead("Track");
                  }
                  setStep81("");
                  setStep8RodCheck("");
                  setStep8D1("");
                  setStep8DTrack("");
                  setStep6C("");
                  setStep6B("");
                  setStep8B("");
                  setStep8A4("");
                  let tempExtended = extendedTitle;
                  tempExtended["8"] = [];
                  tempExtended["8A"] = [];
                  tempExtended["8B"] = [];
                  tempExtended["8C"] = [];
                  tempExtended["6"].splice(1);
                  setExtendedTitle(tempExtended);
                  setDeps("6B,8B", "8B1,8B2,8B3,8B5,8B51,8B6");
                  setCart(
                    "",
                    "",
                    "PanelTypeB,PrivacyLayerHardware,RailIdB,BatonOptionB,ControlPositionB,RailDesignB,RailDesignEnB,RailDesignFaB,RailColorEnB,RailColorFaB,RodColorB,hasPowerB,MotorPositionB,RemoteNameB,MotorChannelsB"
                  );
                }

                modalHandleClose("panelSheerWarning");
              }}
            >
              {t("I AGREE, CONTINUE ANYWAY")}
            </button>
          </div>
        </Modal.Body>
      </Modal>

      <Modal
        dialogClassName={`warning_modal2 bigSizeModal ${
          pageLanguage === "fa" ? "font_farsi" : "font_en"
        }`}
        show={modals["panelPLWarning"] === undefined ? false : modals["panelPLWarning"]}
        onHide={() => modalHandleClose("panelPLWarning")}
      >
        <Modal.Header>{/*<Modal.Title>Modal heading</Modal.Title>*/}</Modal.Header>
        <Modal.Body>
          <p>{t("panelPLWarning")}</p>

          <br />
          <div className="buttons_section">
            <button
              className="btn btn-new-dark"
              onClick={() => {
                modalHandleClose("panelPLWarning");
              }}
            >
              {t("CANCEL")}
            </button>
            <button
              className="btn white_btn"
              onClick={() => {
                setStep6CHead(panelPLWarningTemp.stepValue);
                if (panelPLWarningTemp.stepValue === "Track") {
                  setStep6BHead("Track");
                  setStep6DHead("Track");
                }

                if (step6CHead === "Track" && step6BHead === "Track" && step6DHead === "Track") {
                  setStep6A("");
                  setStep8C("");
                  let tempExtended = extendedTitle;
                  tempExtended["6"][0] = [];
                  tempExtended["8C"] = [];
                  setExtendedTitle(tempExtended);
                } else if (
                  step6CHead === "Rod" &&
                  step6BHead === "Track" &&
                  step6DHead === "Track"
                ) {
                  setStep6A("");
                  setStep8C("");
                  let tempExtended = extendedTitle;
                  tempExtended["6"][0] = [];
                  tempExtended["8C"] = [];
                  setExtendedTitle(tempExtended);
                } else {
                  setStep6C("");
                  setStep6B("");
                  setStep6A("");
                  setStep8C("");
                  let tempExtended = extendedTitle;
                  tempExtended["6"] = [];
                  tempExtended["8C"] = [];
                  setExtendedTitle(tempExtended);
                }

                setDeps("6C,8C", "8C1,8C2,8C3,8C5,8C51,8C52,8C6");
                setCart(
                  "",
                  "",
                  "PanelTypeC,PrivacyLayerHardware,RailIdC,BatonOptionC,ControlPositionC,RailDesignC,RailDesignEnC,RailDesignFaC,RailColorEnC,RailColorFaC,RodColorC,hasPowerC,MotorPositionC,RemoteNameC,MotorChannelsC"
                );
                modalHandleClose("panelPLWarning");
              }}
            >
              {t("I AGREE, CONTINUE ANYWAY")}
            </button>
          </div>
        </Modal.Body>
      </Modal>

      <SelectMountGrommetStep4
        pageLanguage={pageLanguage}
        modals={modals}
        modalHandleClose={modalHandleClose}
        t={t}
      />

      <Modal dialogClassName="zoomModal" show={show} onHide={() => handleClose()}>
        <Modal.Header closeButton>{zoomModalHeader}</Modal.Header>
        <Modal.Body>{zoomModalBody}</Modal.Body>
        <Modal.Footer>
          <button
            className={`swatchButton ${hasSwatchId ? "activeSwatch" : ""} ${
              pageLanguage === "fa" ? "font_farsi" : "font_en"
            }`}
            current-state={hasSwatchId ? "1" : "0"}
            onClick={(e) => {
              fabricSwatch(e, swatchId, swatchDetailId, swatchPhotoPath);
            }}
            disabled={swatchId === -1}
          >
            {hasSwatchId ? t("SWATCH IN BAG") : t("ORDER SWATCH")}
          </button>
        </Modal.Footer>
      </Modal>

      <Modal
        dialogClassName={`noMount_modal mediumSizeModal ${
          pageLanguage === "fa" ? "font_farsi" : "font_en"
        }`}
        show={modals["noPrivacyLayer"] === undefined ? false : modals["noPrivacyLayer"]}
        onHide={() => modalHandleClose("noPrivacyLayer")}
      >
        <Modal.Header closeButton>{/*<Modal.Title>Modal heading</Modal.Title>*/}</Modal.Header>
        <Modal.Body>
          {(() => {
            if (step2A === "" && (step2B === "" || (step2B !== "None" && step2B1 === ""))) {
              return <p>{t("modal_select_PrivacyLayer1")}</p>;
            } else if (step2A === "" && step2C === "") {
              return <p>{t("modal_select_PrivacyLayer2")}</p>;
            } else if (step2A === "") {
              return <p>{t("modal_select_PrivacyLayer3")}</p>;
            } else if (step2B === "" || (step2B !== "None" && step2B1 === "")) {
              return <p>{t("modal_select_PrivacyLayer4")}</p>;
            } else if (step2B !== "None" && step2C === "") {
              return <p>{t("modal_select_PrivacyLayer5")}</p>;
            }
          })()}
          <br />
          <div className=" text_center">
            <button
              className=" btn btn-new-dark"
              onClick={() => modalHandleClose("noPrivacyLayer")}
            >
              {t("CONTINUE")}
            </button>
          </div>
        </Modal.Body>
      </Modal>

      <Modal
        dialogClassName={`noMount_modal mediumSizeModal ${
          pageLanguage === "fa" ? "font_farsi" : "font_en"
        }`}
        show={modals["noMeasurements"] === undefined ? false : modals["noMeasurements"]}
        onHide={() => modalHandleClose("noMeasurements")}
      >
        <Modal.Header closeButton>{/*<Modal.Title>Modal heading</Modal.Title>*/}</Modal.Header>
        <Modal.Body>
          <p>{t("modal_select_noMeasurements")}</p>

          <br />
          <div className=" text_center">
            <button
              className=" btn btn-new-dark"
              onClick={() => modalHandleClose("noMeasurements")}
            >
              {t("CONTINUE")}
            </button>
          </div>
        </Modal.Body>
      </Modal>

      <Modal
        dialogClassName={`noMount_modal mediumSizeModal ${
          pageLanguage === "fa" ? "font_farsi" : "font_en"
        }`}
        show={modals["noPanelType"] === undefined ? false : modals["noPanelType"]}
        onHide={() => modalHandleClose("noPanelType")}
      >
        <Modal.Header closeButton>{/*<Modal.Title>Modal heading</Modal.Title>*/}</Modal.Header>
        <Modal.Body>
          <p>{t("modal_select_noPanelType")}</p>

          <br />
          <div className=" text_center">
            <button className=" btn btn-new-dark" onClick={() => modalHandleClose("noPanelType")}>
              {t("CONTINUE")}
            </button>
          </div>
        </Modal.Body>
      </Modal>

      <Modal
        dialogClassName={`noMount_modal mediumSizeModal ${
          pageLanguage === "fa" ? "font_farsi" : "font_en"
        }`}
        show={modals["width600cm"] === undefined ? false : modals["width600cm"]}
        onHide={() => modalHandleClose("width600cm")}
      >
        <Modal.Header closeButton>{/*<Modal.Title>Modal heading</Modal.Title>*/}</Modal.Header>
        <Modal.Body>
          <p>{t("width600cm")}</p>

          <br />
          <div className=" text_center">
            <button className=" btn btn-new-dark" onClick={() => modalHandleClose("width600cm")}>
              {t("CONTINUE")}
            </button>
          </div>
        </Modal.Body>
      </Modal>

      <Modal
        dialogClassName={`noMount_modal mediumSizeModal ${
          pageLanguage === "fa" ? "font_farsi" : "font_en"
        }`}
        show={modals["mountAllChange"] === undefined ? false : modals["mountAllChange"]}
        onHide={() => modalHandleClose("mountAllChange")}
      >
        <Modal.Header closeButton>{/*<Modal.Title>Modal heading</Modal.Title>*/}</Modal.Header>
        <Modal.Body>
          <p>{t("modal_select_mountAllChange")}</p>

          <br />
          <div className=" text_center">
            <button
              className=" btn btn-new-dark"
              onClick={() => modalHandleClose("mountAllChange")}
            >
              {t("CONTINUE")}
            </button>
          </div>
        </Modal.Body>
      </Modal>

      <Modal
        backdrop="static"
        keyboard={false}
        dialogClassName={`noMount_modal mediumSizeModal ${
          pageLanguage === "fa" ? "font_farsi" : "font_en"
        }`}
        show={modals["fabricHasLine"] === undefined ? false : modals["fabricHasLine"]}
        onHide={() => modalHandleClose("fabricHasLine")}
      >
        <Modal.Header closeButton>{/*<Modal.Title>Modal heading</Modal.Title>*/}</Modal.Header>
        <Modal.Body>
          <p>{t("fabricHasLine")}</p>
          <br />
          <div className=" text_center">
            <button className=" btn btn-new-dark" onClick={() => modalHandleClose("fabricHasLine")}>
              {t("CONTINUE")}
            </button>
          </div>
        </Modal.Body>
      </Modal>

      <Modal
        backdrop="static"
        keyboard={false}
        dialogClassName={`noMount_modal mediumSizeModal ${
          pageLanguage === "fa" ? "font_farsi" : "font_en"
        }`}
        show={modals["fabricHasLine2"] === undefined ? false : modals["fabricHasLine2"]}
        onHide={() => modalHandleClose("fabricHasLine2")}
      >
        <Modal.Header closeButton>{/*<Modal.Title>Modal heading</Modal.Title>*/}</Modal.Header>
        <Modal.Body>
          <p>{t("fabricHasLine2")}</p>
          <br />
          <div className=" text_center">
            <button
              className=" btn btn-new-dark"
              onClick={() => modalHandleClose("fabricHasLine2")}
            >
              {t("CONTINUE")}
            </button>
          </div>
        </Modal.Body>
      </Modal>

      <Modal
        backdrop="static"
        keyboard={false}
        dialogClassName={`noMount_modal mediumSizeModal ${
          pageLanguage === "fa" ? "font_farsi" : "font_en"
        }`}
        show={modals["fabricHasLine3"] === undefined ? false : modals["fabricHasLine3"]}
        onHide={() => modalHandleClose("fabricHasLine3")}
      >
        <Modal.Header closeButton>{/*<Modal.Title>Modal heading</Modal.Title>*/}</Modal.Header>
        <Modal.Body>
          <p>{t("fabricHasLine3")}</p>
          <br />
          <div className=" text_center">
            <button
              className=" btn btn-new-dark"
              onClick={() => modalHandleClose("fabricHasLine3")}
            >
              {t("CONTINUE")}
            </button>
          </div>
        </Modal.Body>
      </Modal>

      <Modal
        backdrop="static"
        keyboard={false}
        dialogClassName={`noMount_modal mediumSizeModal ${
          pageLanguage === "fa" ? "font_farsi" : "font_en"
        }`}
        show={modals["fabricUnAvailable"] === undefined ? false : modals["fabricUnAvailable"]}
        onHide={() => {
          setFabricSelected({
            selectedFabricId: 0,
            selectedTextEn: "",
            selectedTextFa: "",
            selectedDesignCode: "",
            selectedColorEn: "",
            selectedColorFa: "",
            selectedHasTrim: false,
            selectedPhoto: "",
            selectedPhoto2: "",
            FabricWidth: 0,
            SewingDirection: undefined,
          });
          let tempExtended = extendedTitle;
          setStep1Check("");
          setStep1Border("");
          setStep1BorderRadio("");
          setStep1Trim("");
          tempExtended["1"] = [];
          setDeps("1", "11,111");
          setCart(
            "",
            "",
            "FabricId,FabricDesignFa,FabricDesignEn,FabricColorEn,FabricColorFa,PhotoUrl,BorderOrTrimId,BorderOrTrimDesignFa,BorderOrTrimDesignEn,BorderOrTrimColorEn,BorderOrTrimColorFa,BorderOrTrimPhotoUrl,borderPosition"
          );
          selectChanged(undefined, "1");
          setExtendedTitle(tempExtended);
          setStep1("");
          modalHandleClose("fabricUnAvailable");
        }}
      >
        <Modal.Header closeButton>{/*<Modal.Title>Modal heading</Modal.Title>*/}</Modal.Header>
        <Modal.Body>
          <p>{t("fabricUnAvailable")}</p>

          <br />
          <div className=" text_center">
            <button
              className=" btn btn-new-dark"
              onClick={() => {
                setFabricSelected({
                  selectedFabricId: 0,
                  selectedTextEn: "",
                  selectedTextFa: "",
                  selectedDesignCode: "",
                  selectedColorEn: "",
                  selectedColorFa: "",
                  selectedHasTrim: false,
                  selectedPhoto: "",
                  selectedPhoto2: "",
                  FabricWidth: 0,
                  SewingDirection: undefined,
                });
                let tempExtended = extendedTitle;
                setStep1Check("");
                setStep1Border("");
                setStep1BorderRadio("");
                setStep1Trim("");
                tempExtended["1"] = [];
                setDeps("1", "11,111");
                setCart(
                  "",
                  "",
                  "FabricId,FabricDesignFa,FabricDesignEn,FabricColorEn,FabricColorFa,PhotoUrl,BorderOrTrimId,BorderOrTrimDesignFa,BorderOrTrimDesignEn,BorderOrTrimColorEn,BorderOrTrimColorFa,BorderOrTrimPhotoUrl,borderPosition"
                );
                selectChanged(undefined, "1");
                setExtendedTitle(tempExtended);
                setStep1("");
                modalHandleClose("fabricUnAvailable");
              }}
            >
              {t("CONTINUE")}
            </button>
          </div>
        </Modal.Body>
      </Modal>

      <Modal
        backdrop="static"
        keyboard={false}
        dialogClassName={`noMount_modal mediumSizeModal ${
          pageLanguage === "fa" ? "font_farsi" : "font_en"
        }`}
        show={modals["fabricUnAvailable2"] === undefined ? false : modals["fabricUnAvailable2"]}
        onHide={() => {
          setFabricSelected2({
            selectedFabricId: 0,
            selectedTextEn: "",
            selectedTextFa: "",
            selectedDesignCode: "",
            selectedColorEn: "",
            selectedColorFa: "",
            selectedHasTrim: false,
            selectedPhoto: "",
            selectedPhoto2: "",
            FabricWidth: 0,
            SewingDirection: undefined,
          });
          let tempExtended = extendedTitle;
          setStep2Check("");
          setStep2Check2("");
          setStep2Border("");
          setStep2BorderRadio("");
          setStep2Trim("");
          tempExtended["2"] = [];
          setDeps("2", "21,211", 1);
          setCart(
            "",
            "",
            "FabricId2,leadId,hasLead,FabricDesignFa2,FabricDesignEn2,FabricColorEn2,FabricColorFa2,PhotoUrl2,BorderOrTrimId2,BorderOrTrimDesignFa2,BorderOrTrimDesignEn2,BorderOrTrimColorEn2,BorderOrTrimColorFa2,BorderOrTrimPhotoUrl2,borderPosition2"
          );
          selectChanged(undefined, "2");
          setExtendedTitle(tempExtended);
          setStep2("");
          modalHandleClose("fabricUnAvailable2");
        }}
      >
        <Modal.Header closeButton>{/*<Modal.Title>Modal heading</Modal.Title>*/}</Modal.Header>
        <Modal.Body>
          <p>{t("fabricUnAvailable2")}</p>

          <br />
          <div className=" text_center">
            <button
              className=" btn btn-new-dark"
              onClick={() => {
                setFabricSelected2({
                  selectedFabricId: 0,
                  selectedTextEn: "",
                  selectedTextFa: "",
                  selectedDesignCode: "",
                  selectedColorEn: "",
                  selectedColorFa: "",
                  selectedHasTrim: false,
                  selectedPhoto: "",
                  selectedPhoto2: "",
                  FabricWidth: 0,
                  SewingDirection: undefined,
                });
                let tempExtended = extendedTitle;
                setStep2Check("");
                setStep2Check2("");
                setStep2Border("");
                setStep2BorderRadio("");
                setStep2Trim("");
                tempExtended["2"] = [];
                setDeps("2", "21,211", 1);
                setCart(
                  "",
                  "",
                  "FabricId2,leadId,hasLead,FabricDesignFa2,FabricDesignEn2,FabricColorEn2,FabricColorFa2,PhotoUrl2,BorderOrTrimId2,BorderOrTrimDesignFa2,BorderOrTrimDesignEn2,BorderOrTrimColorEn2,BorderOrTrimColorFa2,BorderOrTrimPhotoUrl2,borderPosition2"
                );
                selectChanged(undefined, "2");
                setExtendedTitle(tempExtended);
                setStep2("");
                modalHandleClose("fabricUnAvailable2");
              }}
            >
              {t("CONTINUE")}
            </button>
          </div>
        </Modal.Body>
      </Modal>

      <Modal
        backdrop="static"
        keyboard={false}
        className={`changeFabrics cart_modal_container cart_agree_container ${
          pageLanguage === "fa" ? "font_farsi" : "font_en"
        }`}
        dialogClassName={`cart_modal ${pageLanguage === "fa" ? "font_farsi" : "font_en"}`}
        show={modals["changeFabrics"] === undefined ? false : modals["changeFabrics"]}
        onHide={() => {
          modalHandleClose("changeFabrics");

          // Only clear steps that actually required replacement (=== 1),
          // matching the open logic — do not wipe a valid fabric/sheer selection.
          if (fabricBoard === 1 && sheerBoard === 1) {
            setAccordionActiveKey2("");
            setFabricSelected({
              selectedFabricId: 0,
              selectedTextEn: "",
              selectedTextFa: "",
              selectedDesignCode: "",
              selectedColorEn: "",
              selectedColorFa: "",
              selectedHasTrim: false,
              selectedPhoto: "",
              selectedPhoto2: "",
              FabricWidth: 0,
              SewingDirection: undefined,
            });
            setFabricSelected2({
              selectedFabricId: 0,
              selectedTextEn: "",
              selectedTextFa: "",
              selectedDesignCode: "",
              selectedColorEn: "",
              selectedColorFa: "",
              selectedHasTrim: false,
              selectedPhoto: "",
              selectedPhoto2: "",
              FabricWidth: 0,
              SewingDirection: undefined,
            });

            let tempExtended = extendedTitle;
            setStep1Check("");
            setStep1Border("");
            setStep1BorderRadio("");
            setStep1Trim("");
            tempExtended["1"] = [];
            setDeps("1,2", "11,111,21,211");
            setCart(
              "",
              "",
              "FabricId,FabricDesignFa,FabricDesignEn,FabricColorEn,FabricColorFa,PhotoUrl,BorderOrTrimId,BorderOrTrimDesignFa,BorderOrTrimDesignEn,BorderOrTrimColorEn,BorderOrTrimColorFa,BorderOrTrimPhotoUrl,borderPosition,FabricId2,leadId,hasLead,FabricDesignFa2,FabricDesignEn2,FabricColorEn2,FabricColorFa2,PhotoUrl2,BorderOrTrimId2,BorderOrTrimDesignFa2,BorderOrTrimDesignEn2,BorderOrTrimColorEn2,BorderOrTrimColorFa2,BorderOrTrimPhotoUrl2,borderPosition2"
            );
            selectChanged(undefined, "1,2");
            setStep1("");
            setStep2Check("");
            setStep2Check2("");
            setStep2Border("");
            setStep2BorderRadio("");
            setStep2Trim("");
            tempExtended["2"] = [];
            setExtendedTitle(tempExtended);
            setStep2("");
          } else if (fabricBoard === 1) {
            setAccordionActiveKey2("1");
            setFabricSelected({
              selectedFabricId: 0,
              selectedTextEn: "",
              selectedTextFa: "",
              selectedDesignCode: "",
              selectedColorEn: "",
              selectedColorFa: "",
              selectedHasTrim: false,
              selectedPhoto: "",
              selectedPhoto2: "",
              FabricWidth: 0,
              SewingDirection: undefined,
            });
            let tempExtended = extendedTitle;
            setStep1Check("");
            setStep1Border("");
            setStep1BorderRadio("");
            setStep1Trim("");
            tempExtended["1"] = [];
            setDeps("1", "11,111");
            setCart(
              "",
              "",
              "FabricId,FabricDesignFa,FabricDesignEn,FabricColorEn,FabricColorFa,PhotoUrl,BorderOrTrimId,BorderOrTrimDesignFa,BorderOrTrimDesignEn,BorderOrTrimColorEn,BorderOrTrimColorFa,BorderOrTrimPhotoUrl,borderPosition"
            );
            selectChanged(undefined, "1");
            setExtendedTitle(tempExtended);
            setStep1("");
          } else if (sheerBoard === 1) {
            setAccordionActiveKey2("2");
            setFabricSelected2({
              selectedFabricId: 0,
              selectedTextEn: "",
              selectedTextFa: "",
              selectedDesignCode: "",
              selectedColorEn: "",
              selectedColorFa: "",
              selectedHasTrim: false,
              selectedPhoto: "",
              selectedPhoto2: "",
              FabricWidth: 0,
              SewingDirection: undefined,
            });
            let tempExtended = extendedTitle;
            setStep2Check("");
            setStep2Check2("");
            setStep2Border("");
            setStep2BorderRadio("");
            setStep2Trim("");
            tempExtended["2"] = [];
            setDeps("2", "21,211", 1);
            setCart(
              "",
              "",
              "FabricId2,leadId,hasLead,FabricDesignFa2,FabricDesignEn2,FabricColorEn2,FabricColorFa2,PhotoUrl2,BorderOrTrimId2,BorderOrTrimDesignFa2,BorderOrTrimDesignEn2,BorderOrTrimColorEn2,BorderOrTrimColorFa2,BorderOrTrimPhotoUrl2,borderPosition2"
            );
            selectChanged(undefined, "2");
            setExtendedTitle(tempExtended);
            setStep2("");
          }

          setFabricBoard(undefined);
          setSheerBoard(undefined);
        }}
      >
        {/* {(()=> {
          console.log(`fabricBoard`, fabricBoard);
          console.log(`sheerBoard`, sheerBoard);
        })()} */}
        <Modal.Header closeButton>
          <div className="selection_assistant">
            <h1 className="selection_assistant_title">{t("Selection Assistant")}</h1>
            {!!(fabricBoard === 0) && (
              <div className="selection_assistant_fabric_container">
                <div className="selection_assistant_fabric_img">
                  <img
                    className="img-fluid"
                    src={imgUrl(fabricSelected["selectedPhoto2"])}
                    alt=""
                  />
                </div>
                <div className="selection_assistant_fabric_desc">{t("fabricHasLine")}</div>
              </div>
            )}
            {!!(sheerBoard === 0) && (
              <div className="selection_assistant_fabric_container">
                <div className="selection_assistant_fabric_img">
                  <img
                    className="img-fluid"
                    src={imgUrl(fabricSelected2["selectedPhoto2"])}
                    alt=""
                  />
                </div>
                <div className="selection_assistant_fabric_desc" style={{ whiteSpace: "pre-line" }}>
                  {t("fabricHasLine2")}
                </div>
              </div>
            )}
            <div
              className="selection_assistant_desc"
              style={{ whiteSpace: "pre-line", fontSize: "1.2rem" }}
            >
              {fabricBoard === 1 && sheerBoard === undefined
                ? t("selection_assistant_desc")
                : fabricBoard === 1 && sheerBoard === 1
                ? t("selection_assistant_desc3")
                : fabricBoard === undefined && sheerBoard === 1
                ? t("selection_assistant_desc2")
                : fabricBoard === 1 && sheerBoard === 0
                ? t("selection_assistant_desc")
                : t("selection_assistant_desc2")}
            </div>
            {fabricBoard === 1 && sheerBoard === 1 && (
              <h2 className="selection_assistant_title2" style={{ fontSize: "1.25rem" }}>
                {t("Select Options 1 & 2")}
              </h2>
            )}
          </div>
        </Modal.Header>
        <Modal.Body>
          <div
            className={
              !!(fabricBoard === 1 && sheerBoard === 1)
                ? "modal_step_container"
                : "modal_step_container modal_step_container_max"
            }
          >
            <Accordion ref={accordion2} flush activeKey={accordionActiveKey2}>
              {fabricBoard === 1 && (
                <Card>
                  <Card.Header>
                    {sheerBoard === 1 && (
                      <ContextAwareToggle2
                        eventKey="1"
                        stepNum={t("1")}
                        stepTitle={t("grommet_step1M")}
                        stepRef="1"
                        type="1"
                        required={requiredStep["1"]}
                        stepSelected={
                          stepSelectedLabel["1"] === undefined ? "" : stepSelectedLabel["1"]
                        }
                      />
                    )}
                    {sheerBoard !== 1 && (
                      <ContextAwareToggle3
                        eventKey="1"
                        stepNum={t("1")}
                        stepTitle={t("grommet_step1_2")}
                        stepRef="1"
                        type="1"
                        required={requiredStep["1"]}
                        stepSelected={
                          stepSelectedLabel["1"] === undefined ? "" : stepSelectedLabel["1"]
                        }
                      />
                    )}
                  </Card.Header>
                  <Accordion.Collapse eventKey="1">
                    <Card.Body>
                      <div className="card_body card-body-fabric 1">
                        <div className="search_filter_container">
                          <div className="search_container">
                            <div className="search_box">
                              <input
                                type="text"
                                placeholder={t("Search for product Name/Code")}
                                className="form-control search_input"
                                name="search_input"
                                value={searchText}
                                ref={search_input}
                                onChange={(e) => {
                                  if (e.target.value !== "") setSearchShow(true);
                                  else setSearchShow(false);
                                  setSearchText(e.target.value);
                                }}
                              />
                              {searchShow && (
                                <div
                                  className="clear-icon-container"
                                  onClick={() => {
                                    search_input.current.value = "";
                                    setSearchText("");
                                    setSearchShow(false);
                                  }}
                                >
                                  <i className="fa fa-times-circle clear-icon" />
                                </div>
                              )}
                              <div className="search-icon-container">
                                <i className="fa fa-search" />
                              </div>
                            </div>
                            <div
                              className="filters_show_hide_container"
                              onClick={() => {
                                if (filtersShow) {
                                  setFiltersShow(false);
                                } else {
                                  setFiltersShow(true);
                                }
                              }}
                            >
                              <span className="filters_toggle">{t("Filters")}</span>
                              <span className="filters_indicator">
                                {filtersShow && (
                                  <img
                                    className="arrow_down img-fluid"
                                    src={require("../Images/public/arrow_up.svg").default}
                                    alt=""
                                  />
                                )}
                                {!filtersShow && (
                                  <img
                                    className="arrow_down img-fluid"
                                    src={require("../Images/public/arrow_down.svg").default}
                                    alt=""
                                  />
                                )}
                              </span>
                            </div>
                          </div>
                          <div
                            className={
                              filtersShow
                                ? "filters_container desktop_only"
                                : "filters_container desktop_only filters_container_hidden"
                            }
                          >
                            <div className="filter_container">
                              <Dropdown autoClose="outside" title="">
                                <Dropdown.Toggle className="dropdown_btn">
                                  <p>{t("filter_Color")}</p>

                                  <div className="select_control_handle_close img-fluid" />
                                </Dropdown.Toggle>
                                <Dropdown.Menu className="filter_color_items">
                                  <div className="filter_items_container">{sewingColors}</div>
                                  <div className="filter_inside_button_section">
                                    <div
                                      className="clear_inside_filter"
                                      text="colors"
                                      onClick={(e) => clearFilters(e)}
                                    >
                                      {/* {t("filter_Clear Filters")} */}
                                      {i18n.language === "fa" ? "حذف فیلترها" : "Clear Filters"}
                                    </div>
                                    <Dropdown.Toggle as="div" className="done_inside_filter">
                                      {t("filter_Done")}
                                    </Dropdown.Toggle>
                                  </div>
                                </Dropdown.Menu>
                              </Dropdown>
                            </div>
                            <div className="filter_container">
                              <Dropdown autoClose="outside" title="">
                                <Dropdown.Toggle className="dropdown_btn">
                                  <p>{t("filter_Pattern")}</p>
                                  {/*<img className="select_control_handle_close img-fluid" src={require('../Images/public/arrow_down.svg').default} alt=""/>*/}
                                  <div className="select_control_handle_close img-fluid" />
                                </Dropdown.Toggle>
                                <Dropdown.Menu>
                                  <div className="filter_items_container">{sewingPatterns}</div>
                                  <div className="filter_inside_button_section">
                                    <div
                                      className="clear_inside_filter"
                                      text="patterns"
                                      onClick={(e) => clearFilters(e)}
                                    >
                                      {/* {t("filter_Clear Filters")} */}
                                      {i18n.language === "fa" ? "حذف فیلترها" : "Clear Filters"}
                                    </div>
                                    <Dropdown.Toggle as="div" className="done_inside_filter">
                                      {t("filter_Done")}
                                    </Dropdown.Toggle>
                                  </div>
                                </Dropdown.Menu>
                              </Dropdown>
                            </div>
                            <div className="filter_container">
                              <Dropdown autoClose="outside" title="">
                                <Dropdown.Toggle className="dropdown_btn">
                                  <p>{t("filter_Type")}</p>
                                  {/*<img className="select_control_handle_close img-fluid" src={require('../Images/public/arrow_down.svg').default} alt=""/>*/}
                                  <div className="select_control_handle_close img-fluid" />
                                </Dropdown.Toggle>
                                <Dropdown.Menu>
                                  <div className="filter_items_container">{sewingTypes}</div>
                                  <div className="filter_inside_button_section">
                                    <div
                                      className="clear_inside_filter"
                                      text="types"
                                      onClick={(e) => clearFilters(e)}
                                    >
                                      {/* {t("filter_Clear Filters")} */}
                                      {i18n.language === "fa" ? "حذف فیلترها" : "Clear Filters"}
                                    </div>
                                    <Dropdown.Toggle as="div" className="done_inside_filter">
                                      {t("filter_Done")}
                                    </Dropdown.Toggle>
                                  </div>
                                </Dropdown.Menu>
                              </Dropdown>
                            </div>
                            <div className="filter_container">
                              <Dropdown autoClose="outside" title="">
                                <Dropdown.Toggle className="dropdown_btn">
                                  <p>{t("filter_Price")}</p>
                                  {/*<img className="select_control_handle_close img-fluid" src={require('../Images/public/arrow_down.svg').default} alt=""/>*/}
                                  <div className="select_control_handle_close img-fluid" />
                                </Dropdown.Toggle>
                                <Dropdown.Menu>
                                  <div className="filter_items_container">
                                    {/*<div className="price_filter_description">{t("filter_price_title")}</div>*/}
                                    {sewingPrices}
                                  </div>
                                  <div className="filter_inside_button_section">
                                    <div
                                      className="clear_inside_filter"
                                      text="prices"
                                      onClick={(e) => clearFilters(e)}
                                    >
                                      {/* {t("filter_Clear Filters")} */}
                                      {i18n.language === "fa" ? "حذف فیلترها" : "Clear Filters"}
                                    </div>
                                    <Dropdown.Toggle as="div" className="done_inside_filter">
                                      {t("filter_Done")}
                                    </Dropdown.Toggle>
                                  </div>
                                </Dropdown.Menu>
                              </Dropdown>
                            </div>
                          </div>
                        </div>
                        <div ref={fabricsContainerRef3} className="fabrics_list_container aaa">
                          {loading ? "" : fabricsList}
                        </div>
                      </div>
                    </Card.Body>
                  </Accordion.Collapse>
                </Card>
              )}
              {/* step 2 */}
              {sheerBoard === 1 && (
                <Card>
                  <Card.Header>
                    {fabricBoard === 1 && (
                      <ContextAwareToggle2
                        eventKey="2"
                        stepNum={t("2")}
                        stepTitle={t("grommet_step2M")}
                        stepRef="2"
                        type="1"
                        required={requiredStep["2"]}
                        stepSelected={
                          stepSelectedLabel["2"] === undefined ? "" : stepSelectedLabel["2"]
                        }
                      />
                    )}
                    {fabricBoard !== 1 && (
                      <ContextAwareToggle3
                        eventKey="2"
                        stepNum={t("2")}
                        stepTitle={t("grommet_step2_2")}
                        stepRef="2"
                        type="1"
                        required={requiredStep["2"]}
                        stepSelected={
                          stepSelectedLabel["2"] === undefined ? "" : stepSelectedLabel["2"]
                        }
                      />
                    )}
                  </Card.Header>
                  <Accordion.Collapse eventKey="2">
                    <Card.Body>
                      <div className="card_body card-body-fabric card-body-fabric-sheer 3">
                        <div className="search_filter_container">
                          <div className="search_container">
                            <div className="search_box">
                              <input
                                type="text"
                                placeholder={t("Search for product Name/Code")}
                                className="form-control search_input"
                                name="search_input"
                                value={searchText2}
                                ref={search_input2}
                                onChange={(e) => {
                                  if (e.target.value !== "") setSearchShow2(true);
                                  else setSearchShow2(false);
                                  setSearchText2(e.target.value);
                                }}
                              />
                              {searchShow2 && (
                                <div
                                  className="clear-icon-container"
                                  onClick={() => {
                                    search_input2.current.value = "";
                                    setSearchText2("");
                                    setSearchShow2(false);
                                  }}
                                >
                                  <i className="fa fa-times-circle clear-icon" />
                                </div>
                              )}
                              <div className="search-icon-container">
                                <i className="fa fa-search" />
                              </div>
                            </div>
                            <div
                              className="filters_show_hide_container"
                              onClick={() => {
                                if (filtersShow2) {
                                  setFiltersShow2(false);
                                } else {
                                  setFiltersShow2(true);
                                }
                              }}
                            >
                              <span className="filters_toggle">{t("Filters")}</span>
                              <span className="filters_indicator">
                                {filtersShow2 && (
                                  <img
                                    className="arrow_down img-fluid"
                                    src={require("../Images/public/arrow_up.svg").default}
                                    alt=""
                                  />
                                )}
                                {!filtersShow2 && (
                                  <img
                                    className="arrow_down img-fluid"
                                    src={require("../Images/public/arrow_down.svg").default}
                                    alt=""
                                  />
                                )}
                              </span>
                            </div>
                          </div>
                          <div
                            className={
                              filtersShow2
                                ? "filters_container desktop_only"
                                : "filters_container desktop_only filters_container_hidden"
                            }
                          >
                            <div className="filter_container">
                              <Dropdown autoClose="outside" title="">
                                <Dropdown.Toggle className="dropdown_btn">
                                  <p>{t("filter_Color")}</p>
                                  <div className="select_control_handle_close img-fluid" />
                                </Dropdown.Toggle>
                                <Dropdown.Menu className="filter_color_items">
                                  <div className="filter_items_container">{sewingColorsSheer}</div>
                                  <div className="filter_inside_button_section">
                                    <div
                                      className="clear_inside_filter"
                                      text="colors"
                                      data-step="2"
                                      onClick={(e) => clearFilters(e)}
                                    >
                                      {i18n.language === "fa" ? "حذف فیلترها" : "Clear Filters"}
                                    </div>
                                    <Dropdown.Toggle as="div" className="done_inside_filter">
                                      {t("filter_Done")}
                                    </Dropdown.Toggle>
                                  </div>
                                </Dropdown.Menu>
                              </Dropdown>
                            </div>
                            <div className="filter_container">
                              <Dropdown autoClose="outside" title="">
                                <Dropdown.Toggle className="dropdown_btn">
                                  <p>{t("filter_Pattern")}</p>

                                  <div className="select_control_handle_close img-fluid" />
                                </Dropdown.Toggle>
                                <Dropdown.Menu>
                                  <div className="filter_items_container">{sewingPatternsSheer}</div>
                                  <div className="filter_inside_button_section">
                                    <div
                                      className="clear_inside_filter"
                                      text="patterns"
                                      data-step="2"
                                      onClick={(e) => clearFilters(e)}
                                    >
                                      {i18n.language === "fa" ? "حذف فیلترها" : "Clear Filters"}
                                    </div>
                                    <Dropdown.Toggle as="div" className="done_inside_filter">
                                      {t("filter_Done")}
                                    </Dropdown.Toggle>
                                  </div>
                                </Dropdown.Menu>
                              </Dropdown>
                            </div>
                            <div className="filter_container">
                              <Dropdown autoClose="outside" title="">
                                <Dropdown.Toggle className="dropdown_btn">
                                  <p>{t("filter_Type")}</p>

                                  <div className="select_control_handle_close img-fluid" />
                                </Dropdown.Toggle>
                                <Dropdown.Menu>
                                  <div className="filter_items_container">{sewingTypesSheer}</div>
                                  <div className="filter_inside_button_section">
                                    <div
                                      className="clear_inside_filter"
                                      text="types"
                                      data-step="2"
                                      onClick={(e) => clearFilters(e)}
                                    >
                                      {i18n.language === "fa" ? "حذف فیلترها" : "Clear Filters"}
                                    </div>
                                    <Dropdown.Toggle as="div" className="done_inside_filter">
                                      {t("filter_Done")}
                                    </Dropdown.Toggle>
                                  </div>
                                </Dropdown.Menu>
                              </Dropdown>
                            </div>
                            <div className="filter_container">
                              <Dropdown autoClose="outside" title="">
                                <Dropdown.Toggle className="dropdown_btn">
                                  <p>{t("filter_Price")}</p>
                                  {/*<img className="select_control_handle_close img-fluid" src={require('../Images/public/arrow_down.svg').default} alt=""/>*/}
                                  <div className="select_control_handle_close img-fluid" />
                                </Dropdown.Toggle>
                                <Dropdown.Menu>
                                  <div className="filter_items_container">
                                    <div className="price_filter_description">
                                      {t("filter_price_title")}
                                    </div>
                                    {sewingPricesSheer}
                                  </div>
                                  <div className="filter_inside_button_section">
                                    <div
                                      className="clear_inside_filter"
                                      text="prices"
                                      data-step="2"
                                      onClick={(e) => clearFilters(e)}
                                    >
                                      {/* {t("filter_Clear Filters")} */}
                                      {i18n.language === "fa" ? "حذف فیلترها" : "Clear Filters"}
                                    </div>
                                    <Dropdown.Toggle as="div" className="done_inside_filter">
                                      {t("filter_Done")}
                                    </Dropdown.Toggle>
                                  </div>
                                </Dropdown.Menu>
                              </Dropdown>
                            </div>
                          </div>
                        </div>
                        <div ref={fabricsContainerRef4} className="fabrics_list_container bbbb">
                          {loading2 ? (
                            ""
                          ) : showEmptyMessage2 ? (
                            <div
                              className={`material_detail ${
                                pageLanguage === "fa" ? "font_farsi" : "font_en"
                              }`}
                              key={"fabric2-board-empty"}
                            >
                              <div
                                className={`material_traits ${
                                  pageLanguage === "fa" ? "font_farsi" : "font_en"
                                }`}
                              >
                                <h5 className="empty_fabrics">
                                  {pageLanguage === "en"
                                    ? "Sorry, no matching fabrics.\nTo view more results, try clearing your filters."
                                    : "متاسفانه این محصول را موجود نداریم.\nبرای دیدن نتایج بهتر، فیلترها را تغییر دهید."}
                                </h5>
                              </div>
                            </div>
                          ) : (
                            fabricsList22
                          )}
                        </div>
                      </div>
                    </Card.Body>
                  </Accordion.Collapse>
                </Card>
              )}
            </Accordion>
          </div>
        </Modal.Body>
        <Modal.Footer>
          <div className="go_to_checkout">
            <div className="checkout_button_section small_checkout_button_section">
              <button
                className="basket_checkout btn"
                onClick={() => {
                  if (
                    fabricBoard === 1 &&
                    sheerBoard === 1 &&
                    (!fabricSelected.selectedFabricId || !fabricSelected2.selectedFabricId)
                  ) {
                    if (!fabricSelected.selectedFabricId) {
                      setAccordionActiveKey2("1");
                    } else if (!fabricSelected2.selectedFabricId) {
                      setAccordionActiveKey2("2");
                    }
                  } else {
                    modalHandleClose("changeFabrics");
                    setFabricBoard(undefined);
                    setSheerBoard(undefined);
                  }
                }}
                disabled={
                  (fabricBoard === 1 && !fabricSelected.selectedFabricId) ||
                  (sheerBoard === 1 && !fabricSelected2.selectedFabricId) ||
                  fabricLoading
                }
              >
                {t("CONFIRM SELECTION")}
              </button>
            </div>
          </div>
        </Modal.Footer>
      </Modal>

      <Modal
        dialogClassName={`learnMore_modal mediumSizeModal ${
          pageLanguage === "fa" ? "font_farsi" : "font_en"
        }`}
        show={modals["learnMore1"] === undefined ? false : modals["learnMore1"]}
        onHide={() => modalHandleClose("learnMore1")}
      >
        <Modal.Header closeButton>{/*<Modal.Title>Modal heading</Modal.Title>*/}</Modal.Header>
        <Modal.Body>
          <br />
          <div className="text_center">
            <button className="btn btn-new-dark" onClick={() => modalHandleClose("learnMore1")}>
              {t("CONTINUE")}
            </button>
          </div>
        </Modal.Body>
      </Modal>

      <Modal
        dialogClassName={`learnMore_modal mediumSizeModal ${
          pageLanguage === "fa" ? "font_farsi" : "font_en"
        }`}
        show={modals["learnMore2"] === undefined ? false : modals["learnMore2"]}
        onHide={() => modalHandleClose("learnMore2")}
      >
        <Modal.Header closeButton>{/*<Modal.Title>Modal heading</Modal.Title>*/}</Modal.Header>
        <Modal.Body>
          <p>{t("modal_learn_more3")}</p>

          <br />
          <div className="text_center">
            <button className="btn btn-new-dark" onClick={() => modalHandleClose("learnMore2")}>
              {t("CONTINUE")}
            </button>
          </div>
        </Modal.Body>
      </Modal>

      <Modal
        dialogClassName={`learnMore_modal mediumSizeModal ${
          pageLanguage === "fa" ? "font_farsi" : "font_en"
        }`}
        show={modals["learnMore3"] === undefined ? false : modals["learnMore3"]}
        onHide={() => modalHandleClose("learnMore3")}
      >
        <Modal.Header closeButton>{/*<Modal.Title>Modal heading</Modal.Title>*/}</Modal.Header>
        <Modal.Body>
          <ul className="help_column_list">
            <li>{t("learnMore3_help1")}</li>
            <li>{t("learnMore3_help2")}</li>
            <li>{t("learnMore3_help3")}</li>
          </ul>

          <br />
          <div className="text_center">
            <button className="btn btn-new-dark" onClick={() => modalHandleClose("learnMore3")}>
              {t("CONTINUE")}
            </button>
          </div>
        </Modal.Body>
      </Modal>

      <Modal
        dialogClassName={`learnMore_modal mediumSizeModal ${
          pageLanguage === "fa" ? "font_farsi" : "font_en"
        }`}
        show={modals["learnMore4"] === undefined ? false : modals["learnMore4"]}
        onHide={() => modalHandleClose("learnMore4")}
      >
        <Modal.Header closeButton>{/*<Modal.Title>Modal heading</Modal.Title>*/}</Modal.Header>
        <Modal.Body>
          <ul className="help_column_list">
            <li>{t("learnMore4_help1")}</li>
            <li>{t("learnMore4_help2")}</li>
            <li>{t("learnMore4_help3")}</li>
            <li>{t("learnMore4_help4")}</li>
          </ul>

          <br />
          <div className="text_center">
            <button className="btn btn-new-dark" onClick={() => modalHandleClose("learnMore4")}>
              {t("CONTINUE")}
            </button>
          </div>
        </Modal.Body>
      </Modal>

      <HelpMeasureModalPleated
        pageLanguage={pageLanguage}
        modals={modals}
        modalHandleClose={modalHandleClose}
        setHelpMeasure={setHelpMeasure}
        setHelpMeasureLengthType={setHelpMeasureLengthType}
        helpMeasure={helpMeasure}
        helpMeasureLengthType={helpMeasureLengthType}
        step3A0={step3A0}
        t={t}
      />

      <Modal
        dialogClassName={`upload_modal uploadImg_modal mediumSizeModal ${
          pageLanguage === "fa" ? "font_farsi" : "font_en"
        }`}
        show={modals["uploadImg"] === undefined ? false : modals["uploadImg"]}
        onHide={() => {
          setSelectedFile(undefined);
          setSelectedFileName("");
          setEditedFileName("");
          modalHandleClose("uploadImg");
          setDetailsShow(false);
        }}
      >
        <Modal.Header closeButton>{/*<Modal.Title>Modal heading</Modal.Title>*/}</Modal.Header>
        <Modal.Body>
          <div
            onDragOver={(e) => {
              e.preventDefault();
              e.stopPropagation();
            }}
            onDrop={(e) => {
              e.preventDefault();
              e.stopPropagation();
              const { files } = e.dataTransfer;
              if (
                files &&
                files.length &&
                (files[0].type === "image/jpg" ||
                  files[0].type === "image/jpeg" ||
                  files[0].type === "image/png")
              ) {
                uploadImg(files[0]);
              } else {
                setSelectedFile(undefined);
                setSelectedFileName("");
              }
            }}
          >
            <h2>{t("upload_img1")}</h2>
            <p className="file_size_description">{t("upload_img2")}</p>
            <div className="controls">
              <div className="modal_upload_section">
                <div className="modal_upload_item">
                  <label htmlFor="image-upload-btn" className="btn btn-new-gray file-upload-btn">
                    {t("upload_img3")}
                    <input
                      type="file"
                      className="custom-file file-upload"
                      id="image-upload-btn"
                      name="file"
                      accept="image/png,image/jpeg,image/jpg"
                      onChange={(e) => {
                        if (e.target.files && e.target.files.length) {
                          uploadImg(e.target.files[0]);
                        } else {
                          setSelectedFile(undefined);
                          setSelectedFileName("");
                        }
                      }}
                      onDragOver={(e) => {
                        e.preventDefault();
                        e.stopPropagation();
                      }}
                      onDrop={(e) => {
                        e.preventDefault();
                        e.stopPropagation();
                        const { files } = e.dataTransfer;
                        if (
                          files &&
                          files.length &&
                          (files[0].type === "image/jpg" ||
                            files[0].type === "image/jpeg" ||
                            files[0].type === "image/png")
                        ) {
                          uploadImg(files[0]);
                        } else {
                          setSelectedFile(undefined);
                          setSelectedFileName("");
                        }
                      }}
                    />
                  </label>
                  <div className="file-name file-upload-btn">
                    {selectedFileName === "" ? t("upload_img5") : selectedFileName}
                  </div>
                </div>
                <div className="modal_upload_item">
                  <input
                    className="file_name_text"
                    type="text"
                    value={editedFileName}
                    onChange={(e) => setEditedFileName(e.target.value)}
                    placeholder={t("upload_img4")}
                  />
                </div>
              </div>
            </div>
            <div className="controls">
              <div className="modal_button_section">
                <button
                  className="btn btn-new-gray"
                  onClick={() => {
                    setSelectedFile(undefined);
                    setSelectedFileName("");
                    setEditedFileName("");
                    modalHandleClose("uploadImg");
                    setDetailsShow(false);
                  }}
                >
                  {t("Cancel")}
                </button>
                <div
                  className="btn btn-new-dark image_submit file-upload-btn btn-disabled"
                  onClick={() => {
                    submitUploadedFile(2);
                  }}
                  disabled={selectedFileName === "" || isUploading}
                >
                  {isUploading ? t("UPLOADING...") : t("Upload Image")}
                </div>
              </div>
            </div>
          </div>
        </Modal.Body>
      </Modal>
      <Modal
        dialogClassName={`upload_modal uploadPdf_modal mediumSizeModal ${
          pageLanguage === "fa" ? "font_farsi" : "font_en"
        }`}
        show={modals["uploadPdf"] === undefined ? false : modals["uploadPdf"]}
        onHide={() => {
          modalHandleClose("uploadPdf");
          setDetailsShow(false);
        }}
      >
        <Modal.Header closeButton>{/*<Modal.Title>Modal heading</Modal.Title>*/}</Modal.Header>
        <Modal.Body>
          <div
            onDragOver={(e) => {
              e.preventDefault();
              e.stopPropagation();
            }}
            onDrop={(e) => {
              e.preventDefault();
              e.stopPropagation();
              const { files } = e.dataTransfer;
              if (files && files.length && files[0].type === "application/pdf") {
                uploadImg(files[0]);
              } else {
                setSelectedFile(undefined);
                setSelectedFileName("");
              }
            }}
          >
            <h2>{t("upload_pdf1")}</h2>
            <p className="file_size_description">{t("upload_pdf2")}</p>
            <div className="controls">
              <div className="modal_upload_section">
                <div className="modal_upload_item">
                  <label htmlFor="file-upload-btn" className="btn btn-new-gray file-upload-btn">
                    {t("upload_pdf3")}
                    <input
                      type="file"
                      className="custom-file file-upload"
                      name="file"
                      id="file-upload-btn"
                      accept="application/pdf"
                      onChange={(e) => {
                        if (e.target.files && e.target.files.length) {
                          uploadImg(e.target.files[0]);
                        } else {
                          setSelectedFile(undefined);
                          setSelectedFileName("");
                        }
                      }}
                      onDragOver={(e) => {
                        e.preventDefault();
                        e.stopPropagation();
                      }}
                      onDrop={(e) => {
                        e.preventDefault();
                        e.stopPropagation();
                        const { files } = e.dataTransfer;
                        if (files && files.length && files[0].type === "application/pdf") {
                          uploadImg(files[0]);
                        } else {
                          setSelectedFile(undefined);
                          setSelectedFileName("");
                        }
                      }}
                    />
                  </label>
                  <div className="file-name file-upload-btn">
                    {selectedFileName === "" ? t("upload_pdf5") : selectedFileName}
                  </div>
                </div>
                <div className="modal_upload_item">
                  <input
                    className="file_name_text"
                    type="text"
                    value={editedFileName}
                    onChange={(e) => setEditedFileName(e.target.value)}
                    placeholder={t("upload_pdf4")}
                  />
                </div>
              </div>
            </div>
            <div className="controls">
              <div className="modal_button_section">
                <button
                  className="btn btn-new-gray"
                  onClick={() => {
                    setSelectedFile(undefined);
                    setSelectedFileName("");
                    setEditedFileName("");
                    modalHandleClose("uploadPdf");
                    setDetailsShow(false);
                  }}
                >
                  {t("Cancel")}
                </button>
                <div
                  className="btn btn-new-dark image_submit file-upload-btn btn-disabled"
                  onClick={() => {
                    submitUploadedFile(1);
                  }}
                  disabled={selectedFileName === "" || isUploading}
                >
                  {isUploading ? t("UPLOADING...") : t("Upload PDF")}
                </div>
              </div>
            </div>
          </div>
        </Modal.Body>
      </Modal>
      <Modal
        backdrop="static"
        keyboard={false}
        dialogClassName={`warning_modal bigSizeModal ${
          pageLanguage === "fa" ? "font_farsi" : "font_en"
        }`}
        show={modals["widthDifferent"] === undefined ? false : modals["widthDifferent"]}
        onHide={() => {
          modalHandleClose("widthDifferent");
        }}
      >
        <Modal.Header>
          <p>{t("WIDTH DISCREPANCIES")}</p>
        </Modal.Header>
        <Modal.Body>
          <p>{t("WIDTH DISCREPANCIES_1")}</p>
          <br />
          <p>
            {t("WIDTH DISCREPANCIES_2.1")}
            <Link className="link_between_text" to={"/" + pageLanguage}>
              {t("WIDTH DISCREPANCIES_2.2")}
            </Link>
            {t("WIDTH DISCREPANCIES_2.3")}
          </p>
          <p>{t("WIDTH DISCREPANCIES4")}</p>
          <br />
          <div className="buttons_section">
            <button
              className="btn btn-new-dark"
              onClick={() => {
                clearInputs(undefined, inputDifRef, undefined, "WidthDif");
                setDeps(inputDifdep, "");
                let temp = JSON.parse(JSON.stringify(stepSelectedOptions));
                temp.labels[inputDifRef] = [];
                temp.values[inputDifRef] = [];
                setStepSelectedOptions(temp);
                modalHandleClose("widthDifferent");
              }}
            >
              {t("CHANGE MEASUREMENTS")}
            </button>
            <button
              className="btn white_btn"
              onClick={() => {
                modalHandleClose("widthDifferent");
                setAccordionActiveKey("3B");
              }}
            >
              {t("I AGREE, CONTINUE ANYWAY")}
            </button>
          </div>
        </Modal.Body>
      </Modal>
      <Modal
        backdrop="static"
        keyboard={false}
        dialogClassName={`addToCartErr bigSizeModal ${
          pageLanguage === "fa" ? "font_farsi" : "font_en"
        }`}
        show={modals["addToCartErr"] === undefined ? false : modals["addToCartErr"]}
        onHide={() => {
          modalHandleClose("addToCartErr");
        }}
      >
        <Modal.Header closeButton></Modal.Header>
        <Modal.Body>
          <div className="modal-header-grommet">
            {pageLanguage === "fa"
              ? "برای ادامه نیاز است مراحل زیر را تکمیل کنید:"
              : "PLEASE COMPLETE THE FOLLOWING:"}
          </div>
          <ul
            className={`addToCartErr_list_new ${
              pageLanguage === "fa" ? "addToCartErr_list_font_farsi" : ""
            }`}
          >
            {addCartErr}
          </ul>
          <br />
          <span>{t("addToCartErr1")}</span>
          <span>{t("addToCartErr3")}</span>
          <br />
          <div className="text_center">
            <button className="btn btn-new-dark" onClick={() => modalHandleClose("addToCartErr")}>
              {t("OK")}
            </button>
          </div>
        </Modal.Body>
      </Modal>
      <Modal
        keyboard={false}
        dialogClassName={`Zipcode_how_it_works customSizeModal ${
          pageLanguage === "fa" ? "font_farsi" : "font_en"
        }`}
        show={modals["Zipcode_how_it_works"] === undefined ? false : modals["Zipcode_how_it_works"]}
        onHide={() => {
          modalHandleClose("Zipcode_how_it_works");
        }}
      >
        <Modal.Header closeButton></Modal.Header>
        <Modal.Body>
          <div className="zipcode_modal_title_container">
            <h1 className="zipcode_modal_title">{t("zipcode_modal_text1")}</h1>
          </div>
          <div className="zipcode_modal_body">
            <div className="zipcode_modal_item">
              <div className="zipcode_modal_item_img_container">
                <img
                  src={require("../Images/public/zipcode_bag.png")}
                  className="img-fluid"
                  alt=""
                />
              </div>
              <div className="zipcode_modal_item_title_container">{t("zipcode_modal_text2")}</div>
              <div
                className={`zipcode_modal_item_text_container ${
                  pageLanguage === "fa" ? "font_farsi" : ""
                }`}
              >
                {t("zipcode_modal_text3")}
              </div>
            </div>
            <div className="zipcode_modal_item">
              <div className="zipcode_modal_item_img_container">
                <img
                  src={require("../Images/public/zipcode_mark.png")}
                  className="img-fluid"
                  alt=""
                />
              </div>
              <div className="zipcode_modal_item_title_container">{t("zipcode_modal_text4")}</div>
              <div className="zipcode_modal_item_text_container">{t("zipcode_modal_text5")}</div>
            </div>
            <div className="zipcode_modal_item">
              <div className="zipcode_modal_item_img_container">
                <img
                  src={require("../Images/public/zipcode_truck.png")}
                  className="img-fluid"
                  alt=""
                />
              </div>
              <div className="zipcode_modal_item_title_container">{t("zipcode_modal_text6")}</div>
              <div className="zipcode_modal_item_text_container">{t("zipcode_modal_text7")}</div>
            </div>
            <div className="zipcode_modal_item">
              <div className="zipcode_modal_item_img_container">
                <img
                  src={require("../Images/public/zipcode_tools.png")}
                  className="img-fluid"
                  alt=""
                />
              </div>
              <div className="zipcode_modal_item_title_container">{t("zipcode_modal_text8")}</div>
              <div className="zipcode_modal_item_text_container">{t("zipcode_modal_text9")}</div>
            </div>
          </div>
          <div className="zipcode_modal_footer">
            <div className="zipcode_modal_item_text_container">{t("zipcode_modal_text10")}</div>
          </div>
        </Modal.Body>
      </Modal>
      <Modal
        backdrop="static"
        keyboard={false}
        dialogClassName={`warning_modal bigSizeModal ${
          pageLanguage === "fa" ? "font_farsi" : "font_en"
        }`}
        show={modals["heightDifferent"] === undefined ? false : modals["heightDifferent"]}
        onHide={() => {
          modalHandleClose("heightDifferent");
        }}
      >
        <Modal.Header>
          <p>{t("HEIGHT DISCREPANCIES")}</p>
        </Modal.Header>
        <Modal.Body>
          <p>{t("HEIGHT DISCREPANCIES_1")}</p>
          <br />
          <p>
            {t("HEIGHT DISCREPANCIES_2.1")}
            <Link className="link_between_text" to={"/" + pageLanguage}>
              {t("HEIGHT DISCREPANCIES_2.2")}
            </Link>
            {t("HEIGHT DISCREPANCIES_2.3")}
          </p>
          <p>{t("HEIGHT DISCREPANCIES4")}</p>
          <br />

          <div className="buttons_section">
            <button
              className="btn btn-new-dark"
              onClick={() => {
                clearInputs(undefined, inputDifRef, undefined, "HeightDif");
                setDeps(inputDifdep, "");
                let temp = JSON.parse(JSON.stringify(stepSelectedOptions));
                temp.labels[inputDifRef] = [];
                temp.values[inputDifRef] = [];
                setStepSelectedOptions(temp);
                modalHandleClose("heightDifferent");
              }}
            >
              {t("CHANGE MEASUREMENTS")}
            </button>
            <button
              className="btn white_btn"
              onClick={() => {
                modalHandleClose("heightDifferent");
              }}
            >
              {t("I AGREE, CONTINUE ANYWAY")}
            </button>
          </div>
        </Modal.Body>
      </Modal>
      <Modal
        backdrop="static"
        keyboard={false}
        className={`cart_modal_container cart_agree_container ${
          pageLanguage === "fa" ? "font_farsi" : "font_en"
        }`}
        dialogClassName={`cart_modal ${pageLanguage === "fa" ? "font_farsi" : "font_en"}`}
        show={modals["cart_modal"] === undefined ? false : modals["cart_modal"]}
        onHide={() => {
          modalHandleClose("cart_modal");
          setCartStateAgree(false);
        }}
        id="cart_modal"
      >
        {cartStateAgree && (
          <div className="custom_cart_header_desc">{`${
            freeShipPrice - sideCartPrice > 0
              ? `${t("cart_agree_free_ship1")}${
                  pageLanguage === "fa"
                    ? NumberToPersianWord.convertEnToPe(
                        `${GetPrice(
                          freeShipPrice - sideCartPrice,
                          pageLanguage,
                          t("TOMANS"),
                          isTabletOrMobile
                        )}`
                      )
                    : GetPrice(
                        freeShipPrice - sideCartPrice,
                        pageLanguage,
                        t("TOMANS"),
                        isTabletOrMobile
                      )
                }${t("cart_agree_free_ship2")}`
              : `${t("cart_agree_free_ship")}`
          }`}</div>
        )}
        <Modal.Header>
          {cartStateAgree && (
            <span className="custom_cart_title">
              {t("My Bag")}{" "}
              <h3>
                (
                {pageLanguage === "fa"
                  ? NumberToPersianWord.convertEnToPe(`${cartCount}`)
                  : cartCount}
                )
              </h3>
            </span>
          )}
          {!cartStateAgree && <p className="custom_cart_title">&nbsp;</p>}
          <button
            className="custom_cart_close 1"
            onClick={() => {
              modalHandleClose("cart_modal");
              setCartStateAgree(false);
              setAddingLoading(false);
              sessionStorage.clear();
              if (backPage === true) {
                navigate(pageLanguage === "fa" ? "/fa" : "/en");
                setBackPage(false);
              }
            }}
          >
            {cartStateAgree ? t("CONTINUE SHOPPING") : t("EDIT ORDER")}
          </button>
        </Modal.Header>
        <Modal.Body>
          <div ref={modalTopRef}>
            <p></p>
          </div>

          {cartStateAgree && (
            <RenderSideCart cartObjects={sideCartObjects} setCartCount={setCartCount} />
          )}
          {!cartStateAgree && <h1 className="cart_agree_title1">{t("REVIEW ORDER")}</h1>}
          {!cartStateAgree && <h2 className="cart_agree_title2">{t("TERMS OF SALE")}</h2>}
          {!cartStateAgree && <div>{cartAgree}</div>}
          {!cartStateAgree && (
            <span className="cart_agree_desc">
              <label className="checkbox_style">
                <input
                  type="checkbox"
                  checked={cartAgreeDescription}
                  onChange={(e) => {
                    setCartAgreeDescription(e.target.checked);
                  }}
                  id="cartAgreeDescription"
                />
                <label htmlFor="cartAgreeDescription" className="checkbox_label">
                  <img
                    className="checkbox_label_img checkmark1 img-fluid"
                    src={require("../Images/public/checkmark1_checkbox.png")}
                    alt=""
                  />
                </label>
                <span className="checkbox_text">{t("cart_agree_desc")}</span>
              </label>
            </span>
          )}
          {!cartStateAgree && (
            <div className="go_to_checkout">
              <button
                className="basket_checkout"
                onClick={() => {
                  setAddingLoading(true);
                  setBackPage(true);
                  addToCart_agreed();
                  topScroll();
                }}
                disabled={addingLoading || !cartAgreeDescription}
              >
                {editIndex
                  ? addingLoading
                    ? t("UPDATING...")
                    : t("footer_update2")
                  : addingLoading
                  ? t("ADDING...")
                  : t("AGREE & ADD TO BAG")}
              </button>
            </div>
          )}
        </Modal.Body>
        <Modal.Footer>
          {cartStateAgree && (
            <div className="go_to_checkout" style={{ backgroundColor: "#faf9f7" }}>
              <div className="checkout_button_section small_checkout_button_section">
                <div className="small_cart_price_summary">
                  {sideCartProductTotal > 0 && (
                    <span
                      className="checkout_payment_price_detail payment_price_detail"
                      style={{ marginTop: "0.7rem" }}
                    >
                      <h3>{t("PRODUCT TOTAL")}</h3>
                      <h4>
                        {GetPrice(
                          sideCartProductTotal,
                          pageLanguage,
                          t("TOMANS"),
                          isTabletOrMobile
                        )}
                      </h4>
                    </span>
                  )}

                  {sideCartInstallPrice > 0 && (
                    <span className="checkout_payment_price_detail payment_price_detail">
                      <h3>{t("INSTALLATION SERVICES")}</h3>
                      <h4>
                        {GetPrice(
                          sideCartInstallPrice,
                          pageLanguage,
                          t("TOMANS"),
                          isTabletOrMobile
                        )}
                      </h4>
                    </span>
                  )}
                  {sideCartTransportPrice > 0 && (
                    <span className="checkout_payment_price_detail payment_price_detail">
                      <h3>{t("TRANSPORTATION FEE")}</h3>
                      <h4>
                        {GetPrice(
                          sideCartTransportPrice,
                          pageLanguage,
                          t("TOMANS"),
                          isTabletOrMobile
                        )}
                      </h4>
                    </span>
                  )}
                  {(sideCartHasSwatches ||
                    sideCartProductTotal > 0 ||
                    sideCartInstallPrice > 0 ||
                    sideCartTransportPrice > 0) && (
                    <span className="checkout_payment_price_detail payment_price_detail">
                      <h3>{t("SHIPPING")}</h3>
                      <h4>
                        {freeShipPrice > 0 &&
                        (isLoggedIn ? sideCartPrice : sideCartProductTotal) >= freeShipPrice
                          ? t("FREE")
                          : t("CALCULATED AT CHECKOUT")}
                      </h4>
                    </span>
                  )}
                </div>
                <span className="checkout_payment_price_detail payment_price_detail small_cart_subtotal">
                  <h3>
                    {freeShipPrice > 0 &&
                    (isLoggedIn ? sideCartPrice : sideCartProductTotal) >= freeShipPrice
                      ? t("TOTAL")
                      : t("SUBTOTAL")}
                  </h3>
                  <h4>
                    {GetPrice(
                      isLoggedIn
                        ? sideCartPrice
                        : sideCartProductTotal + sideCartInstallPrice + sideCartTransportPrice,
                      pageLanguage,
                      t("TOMANS"),
                      isTabletOrMobile
                    )}
                  </h4>
                </span>
                <Link
                  className="basket_checkout btn"
                  to={"/" + pageLanguage + "/Basket"}
                  onClick={() => {
                    setCartStateAgree(false);
                  }}
                >
                  {t("CHECKOUT")}
                </Link>
              </div>
            </div>
          )}
        </Modal.Footer>
      </Modal>
      <Modal
        backdrop="static"
        keyboard={false}
        className={`cart_modal_container cart_agree_container add_to_project_modal ${
          pageLanguage === "fa" ? "font_farsi" : "font_en"
        }`}
        dialogClassName={`cart_modal ${pageLanguage === "fa" ? "font_farsi" : "font_en"}`}
        show={modals["add_to_project_modal"] === undefined ? false : modals["add_to_project_modal"]}
        onHide={() => {
          modalHandleClose("add_to_project_modal");
        }}
        id="add_to_project_modal"
      >
        <Modal.Header closeButton></Modal.Header>
        <Modal.Body>
          {projectModalState === 0 && (
            <div className="add_to_project_container2">
              <h2 className="project_added_text">{t("Please select a room name")}</h2>
              <div className="box100 selectInput_section">
                <div className="room_select">
                  <label className="select_label">{t("Room")}</label>
                  <div className="select_container">
                    <Select
                      className="select"
                      placeholder={t("Please Select")}
                      dropdownPosition="bottom"
                      dropdownHandle={false}
                      dropdownGap={0}
                      values={selectedRoomLabel}
                      dropdownRenderer={({ props, state, methods }) => (
                        <CustomDropdownWithSearch props={props} state={state} methods={methods} />
                      )}
                      contentRenderer={({ props, state, methods }) => (
                        <CustomControl props={props} state={state} methods={methods} />
                      )}
                      onChange={(selected) => {
                        if (selected.length && !pageLoad && !rodsLoad && !rodsLoad2) {
                          setDeps("", "1001", 2);
                          roomLabelChanged(selected[0], "10", false);
                          setSelectedRoomLabel(selected);
                          setCart(
                            "RoomNameFa",
                            rooms["fa"].find((opt) => opt.value === selected[0].value).label,
                            "",
                            "RoomNameEn",
                            [selected[0].value]
                          );
                        }
                      }}
                      options={rooms[pageLanguage]}
                    />
                  </div>
                </div>
                <div className="room_select">
                  <label className="select_label">{t("Window Description")}</label>
                  <DebounceInput
                    debounceTimeout={1500}
                    onKeyDown={() => setCartLoading(true)}
                    type="text"
                    placeholder={t("E.g. Bedroom east wall")}
                    className="form-control window_name"
                    name="order_window_name"
                    value={roomLabelText}
                    onChange={(e) => {
                      setTimeout(() => {
                        if (e.target.value === "") {
                          setDeps("1002", "");
                        } else {
                          setDeps("", "1002", 2);
                        }
                        roomLabelChanged(e.target.value, "10", true);
                        setRoomLabelText(e.target.value);
                        setCart("WindowName", e.target.value);
                      }, 300);
                    }}
                  />
                </div>
              </div>
              {!!(roomLabelText !== "" && selectedRoomLabel.length) && (
                <button
                  className="save_item_btn btn-new-dark"
                  onClick={() => {
                    if (roomLabelText !== "" && selectedRoomLabel.length) {
                      setSavingLoading(true);
                      if ((projectId && projectId !== "") || (editIndex && editIndex !== "")) {
                        SaveUserProject(
                          depSet,
                          cartValues,
                          [uploadedImagesFile, uploadedImagesURL, uploadedPDFFile, uploadedPDFURL],
                          `${modelID}`,
                          price,
                          defaultModelName,
                          defaultModelNameFa,
                          projectData,
                          customAcc
                        )
                          .then((temp) => {
                            if (temp === 401) {
                              setSaveProjectCount(saveProjectCount + 1);
                            } else if (temp) {
                              modalHandleShow("add_to_project_modal");
                              setProjectModalState(1);
                              setSavingLoading(false);
                            } else {
                              setSavingLoading(false);
                            }
                          })
                          .catch((err) => {
                            console.log(err);
                            setProjectModalState(2);
                            setSavingLoading(false);
                          });
                      } else {
                        SaveUserProject(
                          depSet,
                          cartValues,
                          [uploadedImagesFile, uploadedImagesURL, uploadedPDFFile, uploadedPDFURL],
                          `${modelID}`,
                          price,
                          defaultModelName,
                          defaultModelNameFa,
                          undefined,
                          customAcc
                        )
                          .then((temp) => {
                            if (temp === 401) {
                              setSaveProjectCount(saveProjectCount + 1);
                            } else if (temp) {
                              setProjectModalState(1);
                              setSavingLoading(false);
                            } else {
                              setSavingLoading(false);
                            }
                          })
                          .catch((err) => {
                            setProjectModalState(2);
                            setSavingLoading(false);
                          });
                      }
                    } else {
                      setProjectModalState(0);
                    }
                  }}
                  disabled={savingLoading}
                >
                  {savingLoading ? t("SAVING...") : t("SAVE ITEM")}
                </button>
              )}
            </div>
          )}
          {projectModalState === 1 && (
            <div className="add_to_project_container">
              <h2 className="project_added_text">{t("1 ITEM ADDED TO YOUR PROJECTS")}</h2>
              <Link
                className="add_to_project_btn btn"
                to={"/" + pageLanguage + "/Account/Projects"}
              >
                {t("VIEW PROJECTS")}
              </Link>
              <button
                className="continue_shopping_btn"
                onClick={() => {
                  modalHandleClose("add_to_project_modal");
                }}
              >
                {cartStateAgree ? t("CONTINUE SHOPPING") : t("EDIT ORDER")}
              </button>
            </div>
          )}
          {projectModalState === 2 && <ModalLogin />}
        </Modal.Body>
      </Modal>

      <Modal
        backdrop="static"
        keyboard={false}
        className={`cart_modal_container cart_agree_container add_to_project_modal side_login_modal ${
          pageLanguage === "fa" ? "font_farsi" : "font_en"
        }`}
        dialogClassName={`cart_modal ${pageLanguage === "fa" ? "font_farsi" : "font_en"}`}
        show={modals["side_login_modal"] === undefined ? false : modals["side_login_modal"]}
        onHide={() => {
          modalHandleClose("side_login_modal");
          setSwatchLogin(false);
        }}
        id="side_login_modal"
      >
        <Modal.Header closeButton></Modal.Header>
        <Modal.Body>
          <ModalLogin text={t("fabric_login_text")} />
        </Modal.Body>
      </Modal>
      <div className={`CustomModelFooter ${pageLanguage === "fa" ? "font_farsi" : "font_en"}`}>
        <div className="CustomModelFooter_hidden_part" />
        <div className="CustomModelFooter_visible_part">
          <div className="bag_buttons_section_container">
            <button
              className="btn add_to_cart"
              disabled={addingLoading || cartLoading}
              onClick={() => {
                setAddingLoading(true);
                addToCart();
              }}
            >
              {editIndex
                ? addingLoading
                  ? t("UPDATING...")
                  : t("footer_update")
                : addingLoading
                ? t("ADDING...")
                : t("footer_Add To Cart")}
            </button>
            <button className="btn add_to_cart no_pointer">
              {GetPrice(price, pageLanguage, t("TOMANS"), isTabletOrMobile)}
            </button>
            <button
              className="save_to_acc white_btn btn 2"
              onClick={() => {
                if (roomLabelText !== "" && selectedRoomLabel.length) {
                  setSavingLoading(true);
                  if ((projectId && projectId !== "") || (editIndex && editIndex !== "")) {
                    SaveUserProject(
                      depSet,
                      cartValues,
                      [uploadedImagesFile, uploadedImagesURL, uploadedPDFFile, uploadedPDFURL],
                      `${modelID}`,
                      price,
                      defaultModelName,
                      defaultModelNameFa,
                      projectData,
                      customAcc
                    )
                      .then((temp) => {
                        if (temp === 401) {
                          setSaveProjectCount(saveProjectCount + 1);
                        } else if (temp) {
                          modalHandleShow("add_to_project_modal");
                          setProjectModalState(1);
                          setSavingLoading(false);
                        } else {
                          setSavingLoading(false);
                        }
                      })
                      .catch((err) => {
                        console.log(err);
                        setProjectModalState(2);
                        modalHandleShow("add_to_project_modal");
                        setSavingLoading(false);
                      });
                  } else {
                    SaveUserProject(
                      depSet,
                      cartValues,
                      [uploadedImagesFile, uploadedImagesURL, uploadedPDFFile, uploadedPDFURL],
                      `${modelID}`,
                      price,
                      defaultModelName,
                      defaultModelNameFa,
                      undefined,
                      customAcc
                    )
                      .then((temp) => {
                        if (temp === 401) {
                          setSaveProjectCount(saveProjectCount + 1);
                        } else if (temp) {
                          modalHandleShow("add_to_project_modal");
                          setProjectModalState(1);
                          setSavingLoading(false);
                        } else {
                          setSavingLoading(false);
                        }
                      })
                      .catch((err) => {
                        console.log(err);
                        setProjectModalState(2);
                        modalHandleShow("add_to_project_modal");
                        setSavingLoading(false);
                      });
                  }
                } else {
                  setProjectModalState(0);
                  modalHandleShow("add_to_project_modal");
                }
              }}
              disabled={savingLoading || cartLoading}
            >
              {savingLoading ? t("SAVING...") : t("footer_Save To")}
            </button>
          </div>
        </div>
      </div>
    </div>
  );
}
export default PleatedOne;
